const ItaramuluData = {
  "Telugurutuvulu": [
    {
      "CatID": [
        {
          "title": "1. చైత్రము"
        },
        {
          "title": "2. వైశాఖము"
        }
      ],
      "title": "వసంతఋతువు"
    },
    {
      "CatID": [
        {
          "title": "3. జ్యేష్ఠము"
        },
        {
          "title": "4. ఆషాఢము"
        }
      ],
      "title": "గ్రీష్మఋతువు"
    },
    {
      "CatID": [
        {
          "title": "5. శ్రావణము"
        },
        {
          "title": "6. బాధ్రపదము"
        }
      ],
      "title": "వర్షఋతువు"
    },
    {
      "CatID": [
        {
          "title": "7. ఆశ్వయుజము"
        },
        {
          "title": "8. కార్తీకము"
        }
      ],
      "title": "శరదృతువు"
    },
    {
      "CatID": [
        {
          "title": "9. మార్గశిరము"
        },
        {
          "title": "10. పుష్యము"
        }
      ],
      "title": "హేమంతఋతువు"
    },
    {
      "CatID": [
        {
          "title": "11. మాఘము"
        },
        {
          "title": "12. ఫాల్గుణము"
        }
      ],
      "title": "శిశిరఋతువు"
    }
  ],
  "Telugunumbers": [
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/1T.png'),
          // "img": require('../imgs/Numbers/1.png')
        }
      ],
      "title": "one"
    },
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/2T.png'),
          // "img": require('../imgs/Numbers/2.png')
        }
      ],
      "title": "two"
    },
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/3T.png'),
          // "img": require('../imgs/Numbers/3.png')
        }
      ],
      "title": "three"
    },
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/4T.png'),
          // "img": require('../imgs/Numbers/4.png')
        }
      ],
      "title": "four"
    },
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/5T.png'),
          // "img": require('../imgs/Numbers/5.png')
        }
      ],
      "title": "five"
    },
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/6T.png'),
          // "img": require('../imgs/Numbers/6.png')
        }
      ],
      "title": "six"
    },
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/7T.png'),
          // "img": require('../imgs/Numbers/7.png')
        }
      ],
      "title": "seven"
    },
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/8T.png'),
          // "img": require('../imgs/Numbers/8.png')
        }
      ],
      "title": "eight"
    },
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/9T.png'),
          // "img": require('../imgs/Numbers/9.png')
        }
      ],
      "title": "nine"
    },
    {
      "CatID": [
        {
          // "title": require('../imgs/Numbers/10T.png'),
          // "img": require('../imgs/Numbers/10.png')
        }
      ],
      "title": "ten"
    }
  ],
  "Telugunpakshamulu": {
    "CatID": [
      {
        "title": "పక్షము అనగా 15 రోజులకు లేదా కచ్చితంగా 14 రాత్రులకు సమానమైన ఒక కాలమానము."
      },
      {
        "title": "తెలుగు నెలలు పన్నెండు. నెలకు ముప్పై రోజులు. పదిహేను రోజులు ఒక పక్షం. ప్రతి నెల శుక్ల పక్ష పాడ్యమి (అమావాస్య తర్వాత వచ్చే తిథి) తో మొదలై అమావాస్య తో ముగుస్తుంది."
      },
      {
        "title": "ప్రతి నెలలో రెండు పక్షాలుంటాయి :"
      },
      {
        "title": <span class='highlight'> 1. శుక్ల పక్షం లేదా శుద్ధ పక్షం :</span>,
      },
      {
        "title": "(ప్రతి నెల మొదటి తిథి పాడ్యమి నుంచి పౌర్ణమి వరకు): రోజు రోజుకూ చంద్రుడి తో పాటు వెన్నెల పెరిగి రాత్రుళ్ళు తెల్లగా, కాంతివంతంగా అవుతాయి. (శుక్లం అంటే తెలుపు అని అర్థం)."
      },
      {
        "title": <span class='highlight'> 2. కృష్ణ పక్షం లేదా బహుళ పక్షం :</span>
      },
      {
        "title": "(ప్రతి నెల పున్నమి తరువాత వచ్చే పాడ్యమి తిథి నుంచి అమావాస్య వరకు): రోజు రోజుకూ చంద్రుడి తో పాటు వెన్నెల తరిగి రాత్రుళ్ళు నల్లగా చీకటితో నిండుతాయి. (కృష్ణ అంటే నల్లని అని అర్థం)."
      }
    ],
    "title": "పక్షములు"
  },
  "Teluguthidulu": {
    "CatID": [
      {
        "title": "1. పాడ్యమి"
      },
      {
        "title": "2. విదియ"
      },
      {
        "title": "3. తదియ"
      },
      {
        "title": "4. చవితి"
      },
      {
        "title": "5. పంచమి"
      },
      {
        "title": "6. షష్టి"
      },
      {
        "title": "7. సప్తమి"
      },
      {
        "title": "8. అష్టమి"
      },
      {
        "title": "9. నవమి"
      },
      {
        "title": "10. దశమి"
      },
      {
        "title": "11. ఏకాదశి"
      },
      {
        "title": "12. ద్వాదశి"
      },
      {
        "title": "13. త్రయోదశి"
      },
      {
        "title": "14. చతుర్దశి"
      },
      {
        "title": "15. పౌర్ణమి"
      },
      {
        "title": "16. అమావాస్య"
      }
    ],
    "title": "తెలుగు తిథులు"
  },
  "Telugupakshmaulonithidulu": {
    "CatID": [
      {
        "title": "#వేద సమయానుసారము ఒక చాంద్రమాన రోజును తిథి అంటారు లేదా శాస్త్రీయముగా సూర్యుడు, చంద్రున్ని కలుపుతూ ఉన్న ఆక్షాంశ కోణము 12 డిగ్రీలు పెరగడానికి పట్టే కాలాన్ని తిథి అనవచ్చు. తిధులు రోజులోని ఏ వేళలలో అయినా మొదలయ్యి, అంతమయ్యే అవకాశము ఉంది. ఒక్కొక్క తిథి దాదాపు 19 నుండి 26 గంటల సమయము ఉంటుంది. ప్రతి చాంద్రమాసములో 30 తిధులు ఉంటాయి."
      },
      {
        "title": <span class='highlight'> పక్షంలోని తిథులు</span>,
      },
      {
        "title": "1. పాడ్యమి (అధి దేవత - అగ్ని)"
      },
      {
        "title": "2. విదియ (అధి దేవత - బ్రహ్మ)"
      },
      {
        "title": "3. తదియ (అధి దేవత - గౌరి)"
      },
      {
        "title": "4. చవితి (అధి దేవత - వినాయకుడు)"
      },
      {
        "title": "5. పంచమి (అధి దేవత - సర్పము)"
      },
      {
        "title": "6. షష్ఠి (అధి దేవత - కుమార స్వామి)"
      },
      {
        "title": "7. సప్తమి (అధి దేవత - సూర్యుడు)"
      },
      {
        "title": "8. అష్టమి (అధి దేవత - శివుడు)"
      },
      {
        "title": "9. నవమి (అధి దేవత - దుర్గా దేవి)"
      },
      {
        "title": "10. దశమి (అధి దేవత - యముడు)"
      },
      {
        "title": "11. ఏకాదశి (అధి దేవత - శివుడు)"
      },
      {
        "title": "12. ద్వాదశి (అధి దేవత - విష్ణువు) "
      },
      {
        "title": "13. త్రయోదశి (అధి దేవత - మన్మధుడు)"
      },
      {
        "title": "14. చతుర్దశి (అధి దేవత - శివుడు)"
      },
      {
        "title": "15. పున్నమి/పూర్ణిమ/పౌర్ణమి (అధి దేవత - చంద్రుడు)"
      },
      {
        "title": "16. అమావాస్య (అధి దేవత - చంద్రుడు)"
      }
    ],
    "title": "తిథులు"
  },
  "DharmaSandehalu": [
    {
      "CatID": [
        {
          "title": <span class='highlight'> శుభ కార్యము (వివాహము లేదా గృహ ప్రవేశము) చేసిన ఆరు నెలల వరకు ఏ అశుభ కార్యము చేయ కూడదా? లేదా అశుభ కార్యక్రమము నకు హాజరు కాకూడదా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "శుభకార్యము తలపెట్టే ముందు పంచ పాలకులను, అష్ట దిక్పాలకులను ఆహ్వానించి ఆ శుభ కార్యము మొదలు పెడతాము. ఈవిధము గా మన గృహము లో ప్రవేశించిన దేవతలు ఒక అయనము (ఉత్తరాయణము లేదా దక్షిణాయనము) పూర్తి అయేంత వరకు ఉంటారు."
        },
        {
          "title": "ఉదా: జూన్ నెలలో గృహ ప్రవేశము చేస్తే జూలై మధ్య నుండి మొదలయే దక్షిణాయనం వరకు అంటే సుమారు ఒక నెల అంతే తప్ప ఆరు నెలలు అని కాదు. ఆరు నెలలు అని అనడం వెనుక ఉద్దేశం ఒక అయనం నుండి మరొక అయనం వరకు ఆరు నెలలు కనుక. ఈ సమయం లో దేవతలు గృహము లో ఉంటారు కనుక అశుభ కార్యం చేయకూడదు అంటారు."
        },
        {
          "title": "అయితే ఒక్కోసారి తప్పని సరి పరిస్థితులలో అశుభ కార్యం నకు హాజరు కావలసిన పరిస్థితి ఏర్పడవచ్చు. అటువంటప్పుడు స్నానాదికాలు బయట చేసి ఇంట్లో కి ప్రవేశించాలి తప్ప ఇంట్లోకి ప్రవేశించి చేయరాదు."
        }
      ],
      "title": "శుభ కార్యము (వివాహము లేదా గృహ ప్రవేశము) చేసిన ఆరు నెలల వరకు ఏ అశుభ కార్యము చేయ కూడదా? లేదా అశుభ కార్యక్రమము నకు హాజరు కాకూడదా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> పూజ చేసే సమయం లో జేగంట ఎందుకు మ్రోగించాలి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "దేవుని ముందు పూజ చేసేటప్పుడు శ్రావ్యమైన జేగంట మ్రోగిస్తారు. దేవతలకు ఆహ్వానం పలకడానికి, రాక్షసులను సాగనంపడానికి ఘంటా రావం చేస్తారు. ఘంటారావం విన్న రాక్షస శక్తులు, దేవతలు వస్తున్నారని లేదా దైవ శక్తులు వస్తున్నాయని గ్రహించి ప్రక్కకు తొలగి పోతాయి. దేవతలు తో పాటు మనకు మంచి ఆలోచనలు రావాలని అలాగే రాక్షసులతో పాటు చెడు ఆలోచనలు పోవాలని పూజ చేసే సమయం లో మాత్రమే ఘంటారావం చేస్తాము. స్త్రీ / పురుషులు ఎవరైనా పూజ సమయం లో జేగంట మ్రోగించవచ్చు."
        }
      ],
      "title": "పూజ చేసే సమయం లో జేగంట ఎందుకు మ్రోగించాలి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> విత్తు ముందా చెట్టు ముందా? పక్షి ముందా గుడ్డు ముందా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "అనాదిగా మనం ఈ విషయం పై వివిధ వాదనలు వింటున్నాము. చెట్టు ముందు అని చెబితే, విత్తనం లేకుండా ఆ చెట్టు ఎలా వచ్చిందని ప్రశ్నిస్తారు. విత్తనం ముందు అని చెబితే చెట్టు లేకుండా విత్తనం ఎలా వచ్చిందని ప్రశ్నిస్తారు. అలాగే పక్షి ముందు అని చెబితే గుడ్డు లేకుండా పక్షి ఎలా పుట్టిందని ప్రశ్నిస్తారు. గుడ్డు ముందు అని చెబితే, పక్షి లేకుండా గుడ్డు ఎలా వచ్చిందని ప్రశ్నిస్తారు. చివరికి ఈ వాదన ఎటూ తేలకుండా ముగుస్తుంది. ఈ ప్రశ్న ప్రశ్న లాగే మిగిలిపోతుంది."
        },
        {
          "title": "మనిషైనా, పశు పక్ష్యాదులైనా, చెట్లైనా ఈ చరాచర సృష్టి ని సృష్టించింది 'బ్రహ్మ' అని మన విశ్వాసం. అటువంటి 'బ్రహ్మ' ఒక జీవిని సృష్టించినప్పుడు ఆ జీవికి సంపూర్ణ ఆకృతి కల్పించి ఆపైన ఆ జీవిలో ప్రాణం ప్రవేశ పెట్టినట్లుగా బ్రహ్మ సృష్టిని పరిశీలించితే మనకు తెలుస్తుంది. ఈ విధం గా లక్షలాది చరాచర సృష్టి ని సృజించిన బ్రహ్మ ఆయా జీవుల పునరుత్పాదన క్షీరదాలలో 'పిండం' ద్వారా పక్షులలో, పాములలో 'గ్రుడ్డు' ద్వారా వృక్షాది అచర సృష్టి వాటి 'విత్తనాల' ద్వారా అయ్యే లా వాటికి వరం అనుగ్రహించాడు. కాబట్టి కొంతమంది ఉద్దేశ్యం ప్రకారం 'విత్తనం' కంటే చెట్టే ముందు గుడ్డు కంటే పక్షే ముందు. క్షీర సాగర మధన సమయం లో లక్ష్మి దేవి, ధన్వంతరి, కామ ధేనువు, కల్ప వృక్షం, ఐరావతం, పారిజాతం మొదలైనవి పూర్తి ఆకారం తో పుట్టినవే అని మనకు తెలుసు కదా!"
        }
      ],
      "title": "విత్తు ముందా చెట్టు ముందా? పక్షి ముందా గుడ్డు ముందా?"
    },
    {
      "CatID": [
        {
          "title":<span class='highlight'>  భారతీయ సంస్కృతి లో సంస్కారాలకు ఉండే ప్రాధాన్యత ఏమిటి</span>,
        },
        {
          "title": ""
        },
        {
          "title": "భారతీయ సంస్కతిలో చెప్పబడినవన్నీ సమాజహితం కోసమే ఉద్దేశించబడినవి. సమాజం అంటే మనుష్యులు తప్ప వేరెవరో కాదు. అందుకే మన సంప్రదాయయలు మానవ వికాసానికై ఋషులచే నిర్దేశించబడ్డాయి. ఈ సంప్రదాయలనే సంస్కారాలు అని చెబుతారు. మన జీవితాలు ఏదో ఒక దశలో ఈ సంప్రదాయలను అనుసరించే ముందుకు సాగుతుంటాయి."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ సంస్కారాలను షోడశ (16) సంస్కారాలుగా పేర్కొన్నారు 1. వివాహం, 2. గర్భాధానం, 3. పుంసవనం, 4. సీమంతం, 5. జాతకర్మ, 6. నామకరణం, 7. అన్నప్రాశనం, 8. చూడాకర్మ, 9. నిష్క్రమణం, 10. ఉపనయనం, 11. కేశాంతం, 12. సమావర్తనం.13 కర్ణభేధం 14. విద్యారంభం 15. వేదారంభం 16. అంత్యేష్టి"
        },
        {
          "title": ""
        },
        {
          "title": "మనిషి పుట్టుకనుంచి చనిపోయేవరకు సంస్కారమయమే. ఇందులో అంత్యేష్టి తప్ప మిగిలిన 15 కర్మల ద్వారా జీవుడు సంస్కరింపబడుతూ మరణం తర్వాత ఉత్తమలోక ప్రాప్తిని పొందడం జరుగుతుంది. సంస్కారాల వలన జన్మాంతర దోషాలు కూడ తొలగి మానవ జీవిత లక్ష్యమైన మోక్షప్రాప్తి సిధ్దిస్తుంది. సంస్కారాల ఆచరణ మనిషి జీవితంలో వివాహాంతో మొదలవుతుంది. అంటే తల్లి గర్భంలో ఏర్పడే పిండం పవిత్రంగా ఏర్పడాలన్నదే. స్త్రీ పురుష సంయోగం మంత్రం చేత పునీతమవుతుంది. అంటే తల్లి గర్భంలో ఏర్పడే పిండం పవిత్రంగా ఏర్పడాలన్నదే. తద్వారా మన సంస్కారములు ప్రధానోద్దేశ్యం జీవుల క్షేమమేనని తేటతెల్లమవుతోంది. వేదోపనిషత్తుల ప్రకారం మన శరీరం ఐదు అంశాలమయంగా విభజింపబడింది."
        },
        {
          "title": "1. అన్నమయ కోశం – భౌతిక శరీరం"
        },
        {
          "title": "2. ప్రాణమయ కోశం – శక్తి కేంద్రం"
        },
        {
          "title": "3. మనోమయ కోశం – చింతనా కేంద్రం"
        },
        {
          "title": "4. బుద్ధిమయ కోశం – వివేకం"
        },
        {
          "title": "5. అనందమయ కోశం – పరమశాంతి"
        },
        {
          "title": ""
        },
        {
          "title": "మన శరీరంలో ఈ ఐదు అంశాలు షోడశ సంస్కారాల ద్వారా సక్రమమైన రీతిలో చలిస్తాయనేది శాస్త్రవచనం. ఈ సంస్కారాల వెనుకనున్న వైజ్ణానిక రహస్యాలు నేటి వైజ్ణానికుల ను సైతం అశ్చర్యపరుస్తాయి."
        },
        {
          "title": ""
        },
        {
          "title": "1. వివాహం : వివాహం సమయంలో వధూవరులచే పలుమంత్రాలు చెప్పించబడుతుంటాయి. ఆ సమయంలో వరుడు, “భగ, ఆర్యమ, సవిత, పురంధి అనే దేవతలు గార్హపత్యం కోసం నిన్ను నాకు అనుగ్రహించగా, నా జీవితం సుఖ మయం అయ్యేందుకు నీ చేయిని నేను పట్టుకున్నాను” అని భార్య తో చెబుతాడు."
        },
        {
          "title": ""
        },
        {
          "title": "2. గర్భాదానం : స్త్రీ పురష సంయోగం ద్వారా పుట్టబోయే సంతానం యోగ్యులుగా ఉండేందుకై ఈ సంస్కారం నిర్దేశించబడింది."
        },
        {
          "title": ""
        },
        {
          "title": "3. పుంసవనం : తల్లి గర్భంలోని పిండం పవిత్రంగా ఏర్పడేందుకు ఉద్దేశించబడిన సంస్కారమే పుంసవనం."
        },
        {
          "title": ""
        },
        {
          "title": "4. సీమతం : గర్భవతికి ఈ సంస్కారాన్ని నిర్వహించడం వల్ల దుష్టశక్తుల నుంచి రక్షింపబడుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "5. జాతక కర్మ : బిడ్డకు నెయ్యిని రుచి చూపి, పది నెలలు తల్లి గర్భంలో ఉండి ఈ ప్రపంచానికి వచ్చిన జీవికి జరిపే తొలి సంస్కారం ఇది."
        },
        {
          "title": ""
        },
        {
          "title": "6. నామకరణం : బిడ్డ ఈ సమజంలో తనకంటూ ఓ వ్యక్తిత్వంతో వృద్ది లోకి రావాలన్న కోరికతో తల్లి దండ్రులు జరిపే సంస్కారం."
        },
        {
          "title": ""
        },
        {
          "title": "7. నిష్ర్కమణం : బిడ్దను తొలిసారిగా బయటకు తీసుకెళ్ళడం, చంటిబిడ్డను విభిన్న వాతావరణాలకు పరిచయం చేయడ మే ఈ సంస్కారంలోని అంతరార్ధం."
        },
        {
          "title": ""
        },
        {
          "title": "8. అన్నప్రాశనం : బిడ్డకు బలవర్ధకమైన, ఆహారాన్ని పరిచయం చేయడం."
        },
        {
          "title": ""
        },
        {
          "title": "9. చూడాకర్మ : పుట్టువెంట్రుకలను తీయించడం ఈ సంస్కారంలోని ప్రత్యేకత."
        },
        {
          "title": ""
        },
        {
          "title": "10. కర్ణబేధ : చెవులు కుట్టించడం."
        },
        {
          "title": ""
        },
        {
          "title": "11. ఉపనయనం : బాల బ్రహ్మచారికి జరిపే సంస్కారం."
        },
        {
          "title": ""
        },
        {
          "title": "12. వేదారంభం : సమవర్తన సంస్కారాన్ని చక్కగా ముగించేందుకే వేదారంభం."
        },
        {
          "title": ""
        },
        {
          "title": "13. సమావర్తనం : పిల్లలు విద్య ముగించుకుని ఇంటికి తిరిగి వచ్చినప్పుడు ఈ సంస్కారం జరుపబడుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "14. వానప్రస్ధం : బాధ్యతలను వారసులకు అప్పగించి వచ్చే జన్మకై జరిపే కర్మ."
        },
        {
          "title": ""
        },
        {
          "title": "15. సన్యాసం : ఐహిక బంధాల నుంచి విముక్తి పొందడం."
        },
        {
          "title": ""
        },
        {
          "title": "16. అంత్యేష్టి : పితృ ఋణం తీర్చుకునేందుకు పుత్రులు చేసే సంస్కారం."
        }
      ],
      "title": "భారతీయ సంస్కృతి లో సంస్కారాలకు ఉండే ప్రాధాన్యత ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> ఒకే ఇంట్లో గర్భవతులైన ఇద్దరు అక్కాచెల్లెళ్లు ఉండవచ్ఛునా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "ఒకే ఇంట్లో ఒకేసారి ముగ్గురు గర్భవతులు ఉండకూడదు కానీ, ఇద్దరు గర్భవతులు ఉండ వచ్ఛు. అయితే ఒకరు వండిన భోజనం వేరొకరు తినకూడదు. అలాగే ఒకరి చేతి ద్వారా పండు గానీ పండులో సగం గానీ వేరొకరు పుచ్చుకోకూడదు."
        },
        {
          "title": ""
        },
        {
          "title": "కారణమేమంటే, గర్భవతి అయిన సమయంలో వంట చేసిన వారి శారీరక మార్పులు లేదా మానసిక భావనలు ఆ వంట భుజించిన వారికి కలుగుతాయి అని ఒక విశ్వాసం. ఆడపిల్లని కాంక్షించే ఇల్లాలు వండిన వంట తిన్న వేరొక ఇల్లాలు (గర్భవతిగా ఉన్న) కి ఆడపిల్ల పుట్టవచ్ఛు లేదా మగ పిల్లవాడే పుట్టినప్పటికీ ఆ పుట్టిన శిశువుకి ఆడపిల్ల భావనలు కలుగ వచ్ఛు. అలాగే ఒకరినొకరు తాకకూడదు. ఒకే ఇంట ఇన్ని నియమాలు పాటించి ఉండడం కష్ట సాధ్యం కాబట్టి ఒకే ఇంట ఇద్దరు గర్భవతులైన అక్కాచెల్లెళ్లు ఉండకూడదు అని చెబుతారు."
        }
      ],
      "title": "ఒకే ఇంట్లో గర్భవతులైన ఇద్దరు అక్కాచెల్లెళ్లు ఉండవచ్ఛునా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> మాంసాహారం తిన్న తరువాత దైవ దర్శనం చేయ వచ్చా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "మన ప్రవర్తన మనం తినే ఆహారం పై ఆధార పడి ఉంటుంది అని పరిశోధనలు చెబుతున్నాయి. మాంసాహారం తమో గుణాన్ని పెంచుతుంది. అలాగే శాకాహారం అయిన ఉల్లిపాయలు కూడా తమోగుణాన్ని పెంచుతాయి. మాంసాహారం తిన్న తరువాత దైవ దర్శనం చేసుకో కూడదు అని ఎక్కడా చెప్పలేదు."
        },
        {
          "title": ""
        },
        {
          "title": "కానీ ఒక పవిత్ర భావనతో దైవ దర్శనం చేసుకుందాము. అని అనుకున్న వారు మాంసాహారం తీసుకోకుండా దైవ దర్శనం చేసుకోవడం మంచిది. అసలు ఏ ఆహారం స్వీకరించకుండా (మాంసాహారం / శాకాహారం) దైవ దర్శనం చేసుకోవడం చాల మంచిది."
        }
      ],
      "title": "మాంసాహారం తిన్న తరువాత దైవ దర్శనం చేయ వచ్చా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> వారాల పేర్లు ఎలా వచ్చాయి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "వారాల పేర్లు ఎలా వచ్చాయో గురువారం నుండి పరిశీలన చేసి చూద్దాం. గురు వారం అన్న పేరులోనే దీని ప్రాధాన్యం ఉంది. గురువు అంటే మార్గమును ప్రబోధించువాడు అని అర్థం. గురువు లేని విద్య ను వ్యర్థం అని చెబుతారు. అందుకే ఏ విద్య అయినా గురు ముఖంగా నేర్చుకోవాల‌ని సూచిస్తారు. ఇక గురువారానికి ఆ పేరు ఎలా వ‌చ్చిందో తెలుసుకోవాలంటే ఒక విశ్లేషణ ఉంది. ఈ విశ్లేషణ అన్ని వారాల పేర్లకు కూడా వ‌ర్తిస్తుంది"
        },
        {
          "title": ""
        },
        {
          "title": "భార‌తీయ ధ‌ర్మం ప్రకారం ఒక రోజు అనేది సూర్యోద‌యం తో ప్రారంభం అవుతుంది. మ‌ర్నాడు ఉద‌యం సూర్యోద‌యం అయ్యే దాకా దాన్ని రోజుగా భావిస్తారు. అంతేకాని ఇంగ్లీషు లెక్క మాదిరి అర్థ రాత్రి పన్నెండు గంట‌ల‌కు రోజు మార‌టం కాద‌న్న మాట. అయితే సూర్యోదయ స‌మ‌యంలో ఏ హోర న‌డుస్తోందో ఆ హోర కు ప్రాధాన్యం ఉంటుంది. అంటే గురు వారం రోజు ఉద‌యం సూర్యోదయ స‌మ‌యంలో గురు హోర న‌డుస్తూ ఉంటుంది. అందుచేత ఆ రోజుకి గురు వారం అని పేరు వ‌చ్చింది. త‌ర్వాత రోజు ఉద‌యం సూర్యోదయ స‌మ‌యంలో శుక్ర హోర న‌డుస్తూ ఉంటుంది. అందుచేత ఆ రోజుకి శుక్ర వారం అని పేరు వ‌చ్చింది.త‌ర్వాత రోజు ఉద‌యం సూర్యోదయ స‌మ‌యంలో శ‌ని హోర న‌డుస్తూ ఉంటుంది. అందుచేత ఆ రోజుకి శ‌ని వారం అని పేరు వ‌చ్చింది.త‌ర్వాత రోజు ఉద‌యం సూర్యోదయ స‌మ‌యంలో ర‌వి హోర న‌డుస్తూ ఉంటుంది."
        },
        {
          "title": ""
        },
        {
          "title": "అందుచేత ఆ రోజుకి ర‌వి వారం లేక ఆది వారం అని పేరు వ‌చ్చింది. త‌ర్వాత రోజు ఉద‌యం సూర్యోదయ స‌మ‌యంలో చంద్ర హోర న‌డుస్తూ ఉంటుంది. అందుచేత ఆ రోజుకి చంద్ర వారం లేక సోమ వారం అని పేరు వ‌చ్చింది. త‌ర్వాత రోజు ఉద‌యం సూర్యోదయ స‌మ‌యంలో కుజ హోర న‌డుస్తూ ఉంటుంది. అందుచేత ఆ రోజుకి కుజ వారం లేక మంగళ వారం అని పేరు వ‌చ్చింది. త‌ర్వాత రోజు ఉద‌యం సూర్యోదయ స‌మ‌యంలో బుధ హోర న‌డుస్తూ ఉంటుంది. అందుచేత ఆ రోజుకి బుధ వారం అని పేరు వ‌చ్చింది. ఈ విధంగా ఆయా రోజుల‌కు గ్రహాల పేరు మీదుగా పేర్లు ఏర్పడ్డాయి. దీన్నే వెనుక భావం నుంచి కూడా చెప్పవ‌చ్చు. అంటే ఆయా రోజుల పేర్లను బ‌ట్టి హోరా స‌మ‌యాల‌కు పేర్లను నిర్దేశించవ‌చ్చు. ఇదీ మన స‌నాతన భార‌తీయ జ్యోతిష శాస్త్ర విశ్లేషణ."
        }
      ],
      "title": "వారాల పేర్లు ఎలా వచ్చాయి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> దేవుని నిత్యం ఎందుకు పూజించాలి ?. ఆహార పదార్ధాలు ఎందుకు నివేదించాలి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "ఒక యజమాని వంట వాడిని పిలిపించి వంట పదార్ధాలను సమకూర్చి ఇఛ్చి వంట చేసి తమకు వడ్డించి తనను కూడా భుజించి పైకము తీసుకొని వెళ్ళమని చెప్పాడు అనుకుందాం. కానీ ఆ వంట చేసినతను పైకము తీసుకొని వంటచేసి తాను తినేసి యజమానికి ఉంచకుండా, మిగిలిన ఆహార పదార్ధాలను తీసుకొని వెళితే అతనిని కృతఘ్నుడు అని అంటాము కదా!"
        },
        {
          "title": ""
        },
        {
          "title": "అలాగే ఈ సమస్త చరాచర జీవ లోకానికి యజమాని అయిన భగవంతుడు మనకు కాంతి ప్రసాదించే సూర్య, చంద్రులను, సమస్త ఆహార ధాన్యాలను, నీటిని, రోగమొస్తే ఔషధిని ఇలా మనకు ప్రకృతి పరంగా ఏది కావాలంటే అది ఇస్తున్నాడు కదా!. అటువంటి భగవంతుని యెడల కృతజ్ఞత కలిగి నిత్యం శ్లోకములతో , స్తోత్రములతో స్తుతించి ఆహార పదార్ధాలను భక్తి తో, శుచి శుభ్రతలతో వండి నివేదించాలి. అని మనకు శాస్త్రం నిర్దేశిస్తోంది. అందులో భాగం గానే మనం నిత్యం దేవుని పూజించాలి. దేవునికి ఆహార పదార్ధాలను నివేదించడం లో అంతరార్ధం ఆయన ఆరగిస్తాడని కాదు. అతని చల్లని చూపు ప్రసరించిన నైవేద్యం మనం భుజిస్తే మనకు శక్తి రెట్టింపు అవుతుందని. అలాగే సమస్త మానవాళి కి ప్రత్యక్ష నారాయణుడైన ఆ సూర్య దేవుని ప్రతి రోజు నమస్కరించి. ఆయనకు అర్ఘ్య ప్రదానం చేయాలి."
        }
      ],
      "title": "దేవుని నిత్యం ఎందుకు పూజించాలి ?. ఆహార పదార్ధాలు ఎందుకు నివేదించాలి?"
    },
    {
      "CatID": [
        {
          "title":<span class='highlight'> ఇంటి పెద్ద మరణించినప్పుడు చూడడానికి వెళ్లిన వారు ఆ ఇంటి సంధ్యా దీపం చూడకూడదా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "జాతస్య మరణం ధృవం. పుట్టిన వారికి మరణం తప్పదు మరణించిన వారికి జన్మం తప్పదు. తమ ఆత్మ బంధువు, స్నేహితుడు మరణించినప్పుడు ఆఖరి చూపు కోసం ఎందరో ఆ ఇంటికి వెళతారు. ఆ కుటుంబీకులను ఓదారుస్తారు. ఆ రాత్రి వారికి సాయం గా ఉండాలని వారికి అనిపిస్తుంది, కానీ మృతుని ఇంటి దీపాన్ని (చీకటి పడిన తరువాత వెలిగించిన దీపం) చూడ రాదు. అనే నియమాన్ని అనుసరించి చీకటి పడకుండానే తిరిగి ప్రయాణం అవుతారు. ఈ విధమైన నియమం పెద్దలు ఏర్పరచడానికి కారణం?"
        },
        {
          "title": ""
        },
        {
          "title": "మరణించిన ఇంటి పెద్ద ను చూడ డానికి ఎక్కడెక్కడినుండో బంధు మిత్రులు వస్తారు. ఇంటి పెద్ద పోయిన దుఃఖం లో ఉన్న వారు. వఛ్చిన వారికి కనీస మర్యాదలు చేసే స్థితిలో ఉండరు. ఆ రాత్రి ఉందామనుకొనే వారికి సౌకర్యాలు సమకూర్చలేరు. పైగా వారికి ఆర్ధిక భారం. కొందరు చుట్టాలు వఛ్చి తిష్ట వేస్తే ఓ పట్టాన పోరు. వారికి ఇతరుల సాధక బాధలు పట్టవు. ఇంత అర్ధమయ్యేలా చెబితే ఎవరు వింటారు?. అందుకే ఆ ఇంటి దీపం చూడకుండా చీకటి పడకుండా వెనుతిరగాలి. అనే నియమం ఏర్పరిచారు. మరణించినప్పుడు రాలేని వారు చిన్న కర్మ రోజున గాని, పెద్ద కర్మ రోజున గాని వస్తారు. అప్పుడు కూడా ఇదే నియమం. వఛ్చిన బంధు మిత్రులు భోజనాలు చేసి సూర్యాస్తమయం లోపు తిరుగు ప్రయాణమౌతారు."
        },
        {
          "title": ""
        },
        {
          "title": "అలాగే మరణించిన ఇంటి వారి గడప తొక్కినవారు వేరే ఇంటికి వెళ్ళకూడదు అనే నియమం కూడా ఇలాంటిదే. మృత శరీరాన్ని తాకడం లేదా దగ్గరి బంధువులను తాకడం వల్ల ముట్టుకున్న వారికి ఆసౌచం వస్తుంది..వెంట తీసుకెళ్లిన బట్టలు అన్నీ తడపాలి. ఇంటికి వెళ్లి స్నానం తప్పనిసరిగా చేయాలి. వూరు కాని వూరిలో ఇవన్నీ ఎలా కుదురుతాయి?. వేరే స్నేహితులు ఉన్నా. వారికి ఇబ్బంది కలిగించిన వాళ్ళం అవుతాము. అందుకే ముందు తెలిసిన వారి ఇంటికి వెళ్లి మన బట్టల సంచి, సామాను వారి ఇంటి లో పెట్టి మృతుని ఇంటికి వెళ్లి పరామర్శించి తిరిగి తెలిసిన వారి ఇంటికి వఛ్చి స్నానం చేసిన తరువాత పసుపు నీళ్లు జల్లుకొని మన బట్టల సంచి తాకితే దోషం ఉండదు."
        }
      ],
      "title": "ఇంటి పెద్ద మరణించినప్పుడు చూడడానికి వెళ్లిన వారు ఆ ఇంటి సంధ్యా దీపం చూడకూడదా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> కుటుంబ సభ్యులలో ఎవరైనా కాలం చేసినప్పుడు ఆ సంవత్సరం పండుగలు జరుపుకోకూడదా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "పండుగను సాధారణం గా కుటుంబ సభ్యులతో, బంధు మిత్రులతో కలసి ఆనందం గా జరుపుకుంటారు. కుటుంబ సభ్యులలో ఎవరైనా మరణించినప్పుడు ఆ ఆనందం ఉంటుందా?. ఉండదు కదా? అందుకే ఒక సంవత్సరం పాటు పోయిన వారిపై గౌరవ భావం తో మాత్రమే పండుగలు జరుపుకో కూడదు అని ఒక కట్టుబాటు ఏర్పరిచారు మన పెద్దలు."
        },
        {
          "title": ""
        },
        {
          "title": "అయితే ఈ రోజుల్లో అటువంటి ఆటంకం తో పండుగ జరుపుకోని ఆ కుటుంబీకులను వారి బంధువులలో కొందరు పండుగ సందర్భాలలో తీసుకొని వెళ్తున్నారు. వీరు అక్కడ వారితో పండుగ జరుపుకొంటున్నారు. ఈ విధం గా పండుగ జరుపుకోవడం అనేది మంచి పధ్దతి కాదు అని కొందరి అభిప్రాయం. ఆచారాలను, సాంప్రదాయాలను గౌరవించాలే గాని. మనకు అవసరమైన సవరణలు చేసుకొని ఆచరించడానికి కాదు."
        }
      ],
      "title": "కుటుంబ సభ్యులలో ఎవరైనా కాలం చేసినప్పుడు ఆ సంవత్సరం పండుగలు జరుపుకోకూడదా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> స్త్రీలు రుద్రాక్షలు ధరించ కూడదా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "రుద్రాక్షలు ఎంతో పవిత్రమైనవి. వీటిని స్త్రీలు ధరించరాదని కొందరు పండితులు పేర్కొంటారు."
        },
        {
          "title": ""
        },
        {
          "title": "ప్రకృతి ధర్మం ప్రకారం యవ్వన వంతులైన స్త్రీలకు రజస్వల దోషం ఉంటుంది. కాబట్టి ఏ కారణం చేతనైనా (శస్త్ర చికిత్స మూలంగా) లేదా కొంత వయస్సు తరువాత (సాధారణం గా 50 తరువాత) బహిష్టులు ఆగిపోయిన స్త్రీలు, బహిష్టు దోష నివారణ వ్రతం అయిన రుషిపంచమి వ్రతం ఆచరించిన తరువాత రుద్రాక్షలు ధరించ వచ్చును అని కొందరు పండితులు చెబుతారు."
        }
      ],
      "title": "స్త్రీలు రుద్రాక్షలు ధరించ కూడదా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>శుభ కార్య క్రమాలకు వెళ్లేప్పుడు ముగ్గురు కలసి ప్రయాణం చేయరాదా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "ముగ్గురు కలసి శుభ కార్యక్రమాలకు కలసి వెళ్ళ కూడదు అని అన్నారు కాబట్టి నలుగురు వెళితే సరిపోతుంది. లేదా ముందు ఇద్దరు వెళతారు కాస్త వెనుకగా మరొకరు వెళతారు. ఇలా సర్ది చెబుతామే తప్ప పెద్దలు ఎందుకు అలా అన్నారో ఆలోచించము. శుభ కార్యక్రమాలకు ముగ్గురు కలసి ప్రయాణం చేయరాదు అని చెప్పలేదు కాని ముగ్గురు కలసి ప్రయాణం చేయరాదు అని మన పెద్దలు చెప్పారు. ఇలా చెప్పడం వెనుక కారణం."
        },
        {
          "title": ""
        },
        {
          "title": "పూర్వం ఇప్పటిలోలా ప్రయాణ సదుపాయాలు ఉండేవి కావు. ఒక ఊరి నుండి మరొక ఊరికి ఒంటరిగా గాని జంట గా గాని ఆహార పదార్ధాలు మూటగట్టుకొని కబుర్లు చెప్పుకుంటూ కాలి నడకన కొండలు కోనలు దాటుకుంటూ వెళ్ళే వారు. దారిలో నిధి నిక్షేపాలు లేదా ఏమైనా దొరికితే కలసి పంచుకునేవారు. స్నేహం గా మాట్లాడుకొని వెళ్ళే వారు. ఏ రహస్యమైన ఇద్దరి మధ్యే ఉండేది."
        },
        {
          "title": ""
        },
        {
          "title": "అలా కాక ముగ్గురు కలసి ప్రయాణం చేయవలసిన సందర్భం లో మాట పట్టింపులు ఎక్కువగా వఛ్చి ఒకరితో ఒకరు కలహించుకొనే అవకాశాలు ఎక్కువగా ఉండేవి. నిధి నిక్షేపాలు దొరికినప్పుడు, ముగ్గురైతే పంపకాల మధ్య తేడాలు వఛ్చి గొడవలు పడ డానికి అవకాశం ఉండేది. పంపకాలు ఇష్టం లేని వ్యక్తి ఆ సొమ్ము ప్రభుత్వానికే చెందాలి అని భావించి ఈ ఇద్దరికీ తెలియకుండా రక్షక భటులకు సమాచారం ఇవ్వ వచ్ఛు. అలాగే ఏదైనా విషయం రహస్యం గా ఉంచుదామంటే ఆ విషయం రహస్యం గా ఉండేది కాదు. మనం వింటూ / అంటూ ఉంటాము. 'ఈ రహస్యం మన ఇద్దరి మధ్యే ఉండాలి. మూడో వ్యక్తి కి తెలియ కూడదు' అని కారణం ఆ మూడో వ్యక్తి ఉంటే ఆ అతి రహస్యం కాస్తా బట్టబయలవుతుంది. ఈ విధమైన అసౌకర్యాలు ఉన్నాయి కాబట్టే. మన పెద్దలు ముగ్గురు కలసి ప్రయాణం చేయరాదు అని అన్నారు."
        }
      ],
      "title": "శుభ కార్య క్రమాలకు వెళ్లేప్పుడు ముగ్గురు కలసి ప్రయాణం చేయరాదా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> పెళ్లి చూపుల్లో పెళ్లి కూతుర్ని, పెళ్లి కుమారుని తండ్రి 'సంగీతం' వచ్చునా! అని ప్రశ్నిస్థా రెందుకు?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "ఈ రోజుల్లో పెళ్లి చూపుల్లో ఈ విధం గా పెళ్లి కూతుర్ని ' అమ్మాయీ నీకు పాటలు పాడడం వచ్చునా?' అని ఎక్కడో గాని అడగడం లేదు కాని పూర్వం రోజుల్లో పెళ్లి చూపుల్లో సాంప్రదాయ కుటుంబాలలోని ఆడపిల్లలను కాబోయే మామ గారు తప్పని సరిగా అడిగే వారు. సంగీతం తెలిసి పాటలు పాడే అమ్మాయిలకు ప్రాధాన్యత ఇచ్చే వారు. పెళ్లి కూతుర్ని ఈ విధం గా అడగడం వెనుక ఉద్దేశ్యం. పెళ్లి కుమారుని తల్లి దండ్రులు కోడలి పాటలు విని ఆనందించాలని కాదు. మన నిత్య పూజ విధానం లో పూజ అనంతరం ఆత్మ ప్రదక్షిణ అనంతరం"
        },
        {
          "title": ""
        },
        {
          "title": "ఛత్రం ధారయామి! చామరం వీజయామి!దర్పణం దర్సయామి ! నృత్యం దర్సయామి ! గీతం శ్రావయామి ! ఆందోళికనారోహయామి ! అశ్వానారోహయామి ! గజానారొహయామి ! సమస్త రాజోపచార శక్త్యుపచార, భక్త్యుపచార మంత్రోపచార సర్వోపచార పూజాం సమర్పయామి ! అని మంత్రాలు చదువుతూ పూజ ముగించే వారు. ఈ సందర్భం లో చామరం వీజయామి!' అని ఇంటి పెద్ద అన్నప్పుడు ఆయన కుమారుడు వింజామర తో దేవునికి ఉపచారం చేసే వాడు అలాగే గీతం శ్రావయామి!"
        },
        {
          "title": ""
        },
        {
          "title": "అన్నప్పుడు కోడలు దేవుని పై శ్రావ్యం గా మంచి కీర్తన ఆలపించేది. అలాగే మంగళ హారతుల సమయం లో మంగళ హారతి పాట పాడేది. ఈ విధం గా పూజ ముగిసేది. కాబట్టి పెళ్లి కూతుర్ని అత్త మామలు సంగీతం వచ్చునా అని అడగడం లో అంతరార్ధం ఇదీ!."
        }
      ],
      "title": "పెళ్లి చూపుల్లో పెళ్లి కూతుర్ని, పెళ్లి కుమారుని తండ్రి 'సంగీతం' వచ్చునా! అని ప్రశ్నిస్థా రెందుకు?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> స్త్రీలకు బహిష్టు రావడం ఎలా మొదలయ్యింది? నెలసరి నియమాలు పాటించక పోతే దోషమా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "పూర్వం ఒకానొక కారణం వలన ఇంద్రునికి బ్రహ్మ హత్యా పాతకం చుట్టుకుంది. ఆ కారణం గా ఇంద్రుడు ఒక్కసారిగా బలహీనుడు అయిపోయాడు. ఎవరిని చూసినా వణికి పోయే పరిస్థితి. స్వర్గ లోకం పాలన అస్తవ్యస్తం గా తయారయింది. దేవతలు వెళ్లి బ్రహ్మ తో మొర పెట్టుకున్నారు. ఇంద్రుని బ్రహ్మ హత్యా దోషం తొలగడానికి బ్రహ్మ ఒక మార్గం కనుగొన్నాడు. ఇంద్రునికి సంక్రమించిన బ్రహ్మ హత్యా దోషాన్ని 4 భాగాలుగా చేసి ఒక భాగాన్ని భూమికి, రెండవ భాగాన్ని వృక్షాలకు, మూడవ భాగాన్ని సముద్రానికి, నాల్గవ భాగాన్ని రజస్సు (బహిస్టు) రూపం లో స్త్రీలకు అందజేశాడు. ఈ విధంగా స్వీకరించినందుకు ఈ నలుగురికీ వరాలు అనుగ్రహించాడు. ఫలితం గా భూమిని ఎన్నిసార్లు తవ్వినా మళ్ళీ కప్పబడిపోతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "బ్రహ్మ హత్యా దోషం లో భాగం పొందినందుకు వృక్షముల కాండాలనుండి బంక కారుతుంది. దోషాన్ని భరించినందుకు గాను చెట్ల శాఖలను నరికినా మరల మరల చిగురించే వరం ఇవి పొందాయి. దోషం లో భాగం పొందినందుకు సముద్రం ఒడ్దు దగ్గర నురుగు ఏర్పడుతుంది. దోషాన్ని భరించినందుకు సముద్రం లో స్నానం చేసిన వారి పాపాలు హరించే శక్తి. ముఖ్యంగా గ్రహణ సమయం లో స్నానం ఆచరించిన వారి పాపాలు తొలగించే శక్తి సముద్రం పొందింది. దోషం లో భాగం పొందినందుకు స్త్రీలకు నెలలో మూడు రోజుల పాటు బహిష్టు స్రావం వస్తుంది. దోషాన్ని భరించినందుకు స్త్రీలకు మరో ప్రాణిని పుట్టించే హక్కుని ప్రసాదించాడు బ్రహ్మ."
        },
        {
          "title": ""
        },
        {
          "title": "బహిష్టు సమయం లో స్త్రీ శారీరక అశాంతికి లోనవుతుంది. బహిష్టు లో ఉన్న స్త్రీ తులసి చెట్టు ను తాక రాదు. తాకినా యెడల తులసి మాడిపోతుంది అని చెబుతారు. అలాగే బహిష్టు లో ఉన్న స్త్రీ దగ్గర పెట్టిన పచ్చని అరటి కాయ పసుపు రంగులో కి తొందరగా మారుతుందట. బహిష్టు స్త్రీ శరీరం నుండి నకారాత్మక శక్తి (నెగటివ్ ఎనర్జీ) వెలువడుతుందని చెబుతారు. ఆ కారణం గానే ఆమెకు ఆ మూడు రోజులు దేవుని గది లోకి వెళ్ళే అర్హత ఉండదు అని చెబుతారు."
        },
        {
          "title": ""
        },
        {
          "title": "సైన్స్ ప్రకారం చూసినా ఆ మూడు రోజులలో స్త్రీ నుండి వెలువడే స్రావం లో ప్రమాదకరమైన విష పదార్ధాలు, తీవ్రమైన ఉష్ణోగ్రత ఉంటాయి. కాబట్టే ఆ పరిస్థితి లో ఉన్న స్త్రీ తీవ్రమైన శారీరక బలహీనత తో ఉంటుంది. కాబట్టే స్త్రీలకు ఆ మూడు రోజులు విశ్రాంతి అవసరమని వైద్యులు చెబుతారు. ఎవరినీ ఆమె తాకరాదనీ, ఎవరూ ఆమెను తాకరాదనీ, వంట గది లోకి వెళ్ళకూడదనీ పెద్దలు నియమాలు విధించారు. అయితే తెలిసో తెలియకో ఈ నియమాలు పాటించని స్త్రీ దోష పరిహారానికి ఒక వ్రతం ఆచరించాలి అన్నారు. ఆ వ్రతం పేరే రుషి పంచమి వ్రతం. భాద్ర పద మాసం శుక్ల పక్షం లో వచ్చే వినాయక చవితి తరువాత వచ్చే పంచమి నాడు ఈ వ్రతం పాటించి దోషం నుండి నివృత్తి పొందవచ్చు అని మన సప్తర్షులు ఈ రుషిపంచమి వ్రత విధానం లో తెలియజేసారు."
        }
      ],
      "title": "స్త్రీలకు బహిష్టు రావడం ఎలా మొదలయ్యింది? నెలసరి నియమాలు పాటించక పోతే దోషమా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>పెళ్ళికి ముందు కన్యాదాత గృహం లో భోజనం చేస్తే ఆ సంబంధం కుదరదా?. 'కతికితే అతకదు' అంటారు నిజమేనా?"</span>,
        },
        {
          "title": ""
        },
        {
          "title": "మన తెలుగు లో ఇటువంటి ప్రాస పైన ఆధార పడే సామెతలు ఎలా పుట్టాయో గాని, మన నర నరానా నాటుకు పోయాయి. మూల నక్షత్రం వాళ్లకి ముక్కుమీద కోపం ఉంటుంది. మఖ నక్షత్రం అయితే మామ గారి గండం ఆశ్లేష నక్షత్రం అయితే అత్త గారికి గండం. ఇలాంటి సామెతలు కోవలోకే ఈ 'కతికితే అతకదు' కూడా వచ్చి చేరుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ సామెత బహుశా కన్యాదాత శ్రేయస్సుని దృష్టిలో పెట్టుకొని కనిపెట్టి ఉంటారు. ఈ రోజు మనకు లభ్యమవుతున్న అంతర్జాలం వల్ల, కమ్యూనికేషన్ వ్యవస్థ వల్ల వివాహ సంబంధములు తొందరగా కుదురుతున్నాయి గాని పూర్వం ఇందుకు భిన్నమైన పరిస్థితి ఉండేది. ఒక ఆడపిల్లకి పెళ్లి చేయడానికి అనేక సంబంధాలు చూసే వారు ఎక్కువ మంది వరులతో పెళ్లి చూపులు చూడవలసిన పరిస్థితి ఉండేది. పెళ్లి చూపులు అనేసరికి పెళ్లి కొడుకు బంధువులు అంతా వచ్చే వారు."
        },
        {
          "title": ""
        },
        {
          "title": "అంత మందికి భోజన సదుపాయాలు కల్పించడం కన్యాదాత కి వ్యయ ప్రయాసలతో కూడి ఉండేది. ఆడ పిల్లలకు, మగ పిల్లలలకు చిన్నతనం లోనే అంటే 12 సంవత్సరాల లోపే పెళ్ళిళ్ళు జరిగేవి. ఆ వయసులో చిన్న పిల్లలు (పెళ్లి కొడుకు, పెళ్లి కూతురు) భోజనాది సమయాలలో ప్రవర్తించే తీరు ఒక్కోసారి పెద్ద వాళ్లకు నచ్చేది కాదు. ఫలితం గా సంబంధాలు కుదిరేవి కావు. చూసిన ప్రతి సంబంధం కుదరదు కదా! వివిధ కారణాల వల్ల సంబంధాలు కుదరనప్పుడు ఇరువైపుల బంధువులు పెళ్లి చూపులకి వెళ్లి భోజనం చేస్తే ఆ సంబంధం కుదరదు. 'కతికితే అతకదు' అని అనుకొనేవారు. కాల క్రమేణా అదే సామెత అయింది. ఇదీ ఒకందుకు మంచిదే అయ్యింది. కన్యాదాత కి అనవసర ఖర్చు తప్పింది."
        }
      ],
      "title": "పెళ్ళికి ముందు కన్యాదాత గృహం లో భోజనం చేస్తే ఆ సంబంధం కుదరదా?. 'కతికితే అతకదు' అంటారు నిజమేనా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> సాయంత్రం వేళలో నవ గ్రహాలకు ప్రదక్షిణాలు చేయవచ్చా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "సాయంత్రం వేళలో నవగ్రహాలకు ప్రదక్షిణాలు చేయకూడదు అని ఎవరూ చెప్పలేదు. చేయవవచ్చు. అయితే ఉదయం వేళలో మనం స్నానం చేసి శుచిగా శుభ్రం గా ఉండడం వలన మన మనస్సు కూడా ప్రశాంతం గా ఉంటుంది. కాబట్టి ఉదయం వేళలో దేవాలయం సందర్శించడం మంచిది అన్నారు. అలాగే నవ గ్రహాలకు నవ గ్రహ స్తోత్రం చదువుతూ 9 సార్లు ప్రదక్షిణాలు చేయాలి. ప్రదక్షిణ అనంతరం మన కాళ్ళపై నీళ్ళు జల్లుకొని ఆ నీళ్ళు కనులకు అద్దుకోవాలి. ఎందుకంటే. నవ గ్రహ ప్రదక్షిణ సమయం లో మన కాళ్ళపై శని దృష్టి సారిస్తాడు. కాబట్టి కాళ్ళు పూర్తిగా కడక్కుండా నీళ్ళు మాత్రం జల్లుకోవాలి."
        }
      ],
      "title": "సాయంత్రం వేళలో నవ గ్రహాలకు ప్రదక్షిణాలు చేయవచ్చా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> మూడు నెలల లోపు గర్భిణి శుభ కార్య క్రమాలలో పాల్గొనవచ్చా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "గర్భస్థ పిండం ఏర్పడిన తొలి 3 నెలలు గర్భిణి చాల జాగ్రత్తగా ఉండాలి. బరువు పనులు చేయకూడదు. వంగోకూడదు, నేలపైన మఠం వేసుకొని కూర్చో కూడదు. అలాగే ఎటువంటి ఫల దానాలు ఇవ్వ రాదు. 5 వ నెల నుండి భర్త కి కూడా పూజాదికాలు పనికి రావు. శిశువు పుట్టెంత వరకు ఇద్దరికీ జాతా శౌచం. ఎటువంటి శుభ కార్య క్రమాలలో కూర్చొని చేసే అవకాసం ఉండదు. ఈ విషయం పై పండితుల మధ్య భిన్న అభిప్రాయాలు కలవు."
        },
        {
          "title": ""
        },
        {
          "title": "గృహప్రవేశం, సత్యన్నారాయణ వ్రతం వంటి శుభ కార్యక్రమాలు లో తప్పని సరిగా పీటలపై కూర్చోన వలసి వస్తుంది. అలా కూర్చోవటం గర్భిణి కి చాలా ఇబ్బందిగా ఉంటుంది కదా! కాబట్టి అటువంటి శుభకార్యక్రమాలు పనికి రావు అన్నారు. అయితే తప్పని సరి పరిస్థుతులలో గర్భిణి భర్త ప్రక్కనే కుర్చీలో కూర్చొని నిరభ్యంతరం గా పూజలు చేయవచ్చు అని కొంతమంది పండితులు చెబుతారు."
        }
      ],
      "title": "మూడు నెలల లోపు గర్భిణి శుభ కార్య క్రమాలలో పాల్గొనవచ్చా?"
    },
    {
      "CatID": [
        {
          "title":  <span class='highlight'> జాతక పొంతనలు కుదరకపోతే ఆ దంపతుల జీవితం సాఫీగా సాగదా?. కష్టాలు కన్నీళ్ళేనా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "సాధారణం గా ప్రేమ వివాహాలలో జాతకాలకు ప్రాధాన్యత ఉండదు. పెళ్లి అయ్యాక కొంత కాలం గడిచాక, దంపతుల మధ్య అభిప్రాయ భేదాలు రావడం. అప్పుడు జాతకాలు గురించి ఆలోచించి, ఇద్దరికీ పొంతనలు చూపించుకొని. పొంతనలు కుదరలేదు కాబట్టే కాపురం లో కలహాలు వస్తున్నాయని. ఇక ఈ జీవితం అంతా ఇంతే అని నిస్పృహకు లోనవుతారు."
        },
        {
          "title": ""
        },
        {
          "title": "అదే పెద్దలు కుదిర్చిన పెళ్ళిళ్ళలో జాతకాలకు ప్రాధాన్యత ఇచ్చి, జాతక పొంతనలు కుదిరిన తరువాతే వివాహం చేస్తారు. అయితే, ఈ విధంగా ఒక్కటయిన దంపతుల మధ్య కూడా కొంత కాలం గడిచాక అభిప్రాయ భేదాలు రావడం సహజమే అయితే ఇటువంటి సందర్భాలలో ఇరువైపుల బంధువులు వాళ్ళిద్దరికీ సర్ది చెప్పి కాపురం సజావుగా జరగడానికి సహకరిస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "దీనిని బట్టి మనకు అర్ధం అయ్యేది ఏమిటంటే, దంపతుల మధ్య అభిప్రాయ భేదాలనేవి జాతక పొంతనల మీద ఆధార పడి ఉండవు. జాతక పొంతనలు బాగున్నా వస్తాయి. జాతక పొంతనలు బాగు లేకపోయినా వస్తాయి. అయితే జాతక పొంతనలు కుదరనప్పుడు భార్యా భర్తలు ఇరువురూ తమ బుద్ధిని ఉపయోగించి ఎక్కడ తగ్గాలో అక్కడ తగ్గి, ఎక్కడ సర్దుకు పోవాలో అక్కడ సర్దుకు పోతే ఎటువంటి సమస్యలు ఉత్పన్నం కావు."
        },
        {
          "title": ""
        },
        {
          "title": "ఆరోగ్య పరీక్షలలో మన ఆరోగ్యం బాగా లేనప్పుడు మందులు వాడి ఆ సమస్య నుండి ఎలా బయట పడతామో, జాతక పొంతనలలో లోపాలు ఉన్నప్పుడు మన బుద్ది ని ఉపయోగించి, వివేకం తో ఆలోచించి ఆ లోపాలను జయించవచ్చు. ఇరువురి మధ్య ఉన్న మనస్పర్ధలు తొలగించుకోవచ్చు. హాయిగా సంసారం చేసుకోవచ్చు."
        }
      ],
      "title": "జాతక పొంతనలు కుదరకపోతే ఆ దంపతుల జీవితం సాఫీగా సాగదా?. కష్టాలు కన్నీళ్ళేనా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'> రధసప్తమి విశిష్టత ఏమిటి? ఎలా జరుపుకోవాలి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "ప్రాచీన కాలం నుండి మానవుడు సూర్యుని ఆరాదిస్తున్నాడు. సూర్యుడు జ్యోతిషామ్పతి. సూర్య గమనం వలన మనకు దశ- దిశ లు తెలుస్తున్నాయి. ఉదయించే సూర్యునికి ఎదురుగా మనం నుంచున్నప్పుడు, మన కుడి చేతి వైపు దక్షిణం, ఎడమ చేతి వైపు ఉత్తరం, వీపు వెనుక వైపు పడమర దిక్కులు వుంటాయి. సూర్యుని ప్రత్యక్ష నారాయణుడు అంటారు. కశ్యప ప్రజాపతి, అదితి ల కుమారుడే సూర్య భగవానుడు. అదితి కుమారుడు కాబట్టి సూర్యుని ఆదిత్యుడు అని కూడా అన్నారు. మాఘ మాసం శుక్ల పక్షం లో వచ్చే సప్తమి ని సూర్యుని జయంతి గా చెబుతారు. కశ్యప ప్రజాపతి సూర్యునకు రధము, సారధి, గుర్రములను ఇచ్చి లోకాదిపత్యం ఈరోజు కలిగించాడు కాబట్టే ఈరోజు రధసప్తమి అంటారు అని ఒక భావన. సూర్యుని తీక్షణత ఈరోజు నుండి క్రమేణా పెరుగుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "ఆయుర్వేదం ప్రకారం కఫరోగ, పిత్త, బుద్ధిమాంద్యము లను తొలగించే శక్తి జిల్లేడు ఆకులకు, రేగు పళ్లకు ఉంది అని చెబుతారు కాబట్టి ఈరోజు తలపై జిల్లేడు ఆకు దానిపై రేగు పండుని ఉంచి స్నానం చేయాలని చెబుతారు. ఆవు పిడకలను దాలిగా చేసి మండించి దానిపై ఇత్తడి పాత్ర ఉంచి ఆవుపాలు, బెల్లం, బియ్యం తో చేసిన పరమాన్నం అంటే సూర్యునికి ఎంతో ప్రీతి పంటలు చేతికొచ్చే కాలం లో వచ్చిన సప్తమి కాబట్టి ఈరోజు వండే పరమాన్నం లో కొత్త బియ్యం వాడుతారు. ఈ కాలం లో విరివిగా పాకే తీగ జాతికి చెందిన చిక్కుడు పాదు ఆకులపై పరమాన్నం వేసి సూర్యునికి నివేదిస్తారు. ఆయుర్వేద రీత్యా చిక్కుడు ఆకులు, కాయలు మన జీర్ణ వ్యవస్థపై చక్కగా పనిచేసి మంచి శక్తి ఇస్తాయి. చిక్కుడు ఆకులలో పీచు పదార్ధం ఉండడం వలన మంచి విరేచనకారిగా పనిచేస్తుంది. ఈ కాలం లో దొరికే చిక్కుడు తరచు తినడం వలన మలబద్ధకం సమస్యలు తొలగుతాయి. ఈరోజు తరిగిన కూరగాయలు తినకూడదు. చిక్కుడు కాయలతో చేసిన కూర మాత్రమే తినాలని (చిక్కుడు కాయలను తరగవలసిన పనిలేదు. చిక్కితే సరిపోతుంది ) పెద్దలు చెప్పడం లో ఉద్దేశ్యం కనీసం ఈరోజైనా చిక్కుడు కాయలు తినాలి అని చెప్పడమే, చిక్కుడు కాయలతో రధం చేయాలని చెప్పడం కూడా అందుకే."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ రోజు చేసిన పరమాన్నం సూర్యునికి నివేదించిన తరువాత అందరికీ పెట్టి మూషికములకు కూడా నివేదిస్తారు రైతులు ఇలా నివేదించడం వలన తమ ధాన్యపు గాదెల సమీపమునకు రావు అని వారి విశ్వాసం."
        },
        {
          "title": ""
        },
        {
          "title": "ఈరోజు స్వామి వారిని ఎర్రటి పుష్పములతో (ఎర్ర మందారం వంటివి) పూజించాలి. సూర్య నమస్కారములు చేయాలి. అగస్త్యుడు శ్రీరామునికి ఉపదేశించిన ఆదిత్య హృదయం ప్రతి రోజు పారాయణ చేసేవారు ఈ రోజు 12 సార్లు పారాయణం చేయాలి. ఏ విధం గా సూర్యుడు లోకానికి ఉపయోగపడి లోక బాంధవుడు అయ్యాడో అదే విధం గా లోకానికి ఉపయోగపడే మంచి పుత్రుని ఇమ్మనమని రధసప్తమి రోజు వ్రతం ఆచరిస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "రధసప్తమి రోజు ఛత్రము, పాదుకలు, ఎరుపు వస్త్రము, ఆవుపాలు, ఆవు నెయ్యి దానము చేసిన మంచిది."
        }
      ],
      "title": "రధసప్తమి విశిష్టత ఏమిటి? ఎలా జరుపుకోవాలి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>కనుమ రోజు మాంసం తినాలా?"</span>,
        },
        {
          "title": ""
        },
        {
          "title": "కనుమ రోజు మినుము తినాలి అని మన పెద్దలు అన్నారు కాని మాంసం తినమని చెప్పలేదు. ఎందుకంటే ఈ రోజు, పశువులు, పక్షులకి పండుగ అంటే వాటిని ఈ పండుగ రోజులలో ప్రేమతో అభిమానం తో చూడాలి. వాటికి ఇష్టమైన వాటిని తినిపించాలి. ప్రకృతి లో ఉండే అన్ని జీవరాసులనూ సమాన దృష్టి తో చూడాలని ఈ పండుగ చెబుతోంది. కనుమ నాడు మినుము తినాలి అనే సామెత వెనుక ఉద్దేశ్యం. మినప్పప్పు తో చేసిన గారెలు, నూలు పప్పు తో చేసిన పాకుండలు, అరిసెలు, చక్కిలాలు, జంతికలు మొదలైన నూనె పదార్ధాలు మనకు వేడి చేస్తాయి. ఈ చలికాలం లో తట్టు కొనేందుకు మనకు ఆమాత్రం వేడి అవసరమని అందుకే తినమని మన పెద్దలు అలా చెప్పారు."
        }
      ],
      "title": "కనుమ రోజు మాంసం తినాలా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>దుకాణం లో కొన్న తీపి పదార్ధాలు దేవునికి నివేదించ వచ్చునా?"</span>,
        },
        {
          "title": ""
        },
        {
          "title": "వినాయక చవితి, దసరా, దీపావళి. ఇలాంటి పండుగ లలో సాధారణం గా బయట కొనుగోలు చేసిన తీపి పదార్ధాలు దేవునికి నివేదన చేస్తుంటాము. ఇలా బయట కోనేవి నివేదన చేసే బదులు కొబ్బరి కాయ, అరటి పళ్ళు. మొదలగు ఫలాలు నివేదించడం మంచిది. ఎందుకంటే దేవునికి నివేదించే పదార్ధాలు శుచి, శుభ్రంగా మడి బట్టలు కట్టుకొని వండి నివేదించాలి. నిలువ వున్న తీపి పదార్ధాలు నివేదించ కూడదు. పర్వ దినాలలో దేవునికి పటిక బెల్లం నివేదించి ఆ పొడి ని తీపి పదార్ధాలపై జల్లి తీపి పదార్ధాలు పంచడం మంచిది."
        }
      ],
      "title": "దుకాణం లో కొన్న తీపి పదార్ధాలు దేవునికి నివేదించ వచ్చునా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>సంక్రాంతి పండుగ ప్రాధాన్యత ఏమిటి?"</span>,
        },
        {
          "title": ""
        },
        {
          "title": "సంక్రాంతి అనగా సూర్యుడు రాశిలో ప్రవేశించడం. సూర్యుడు రాశిలో ప్రవేశించడాన్ని సంక్రమణము అంటారు.అయితే ఈ సంక్రమణాన్నే సంక్రాంతి అంటారు. అయితే మనకు పన్నెండు రాశులు ఉన్నాయి.ఆ పన్నెండు రాశులలోకి సూర్యుడు ప్రవేశించే క్రమంలో మనకు పన్నెండు సంక్రాంతులు వస్తాయి. సూర్య సంక్రమణం జరిగేటపుడు సూర్యుడు ఏ రాశిలో ఉంటే ఆ సంక్రాంతి అంటారు. ఇలా ప్రతి మాసం ఒక సంక్రాంతి ఉంటుంది. సౌరమాన కాలెండరులో ప్రతినెల ఒక సంక్రాంతి తో ప్రారంభమవుతుంది. దీనిని భారతదేశంలో ఆంధ్ర ప్రదేశ్ , తెలంగాణ, కర్ణాటక, మహారాష్ట్ర, తమిళనాడు, కేరళ, ఒడిషా, పంజాబ్, గుజరాత్ మొదలగు రాష్ట్రాలలో పాటిస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "దీనిని భారతదేశంలో ఆంధ్ర ప్రదేశ్, తెలంగాణ, కర్ణాటక, మహారాష్ట్ర, తమిళనాడు, కేరళ, ఒడిషా, పంజాబ్, గుజరాత్ మొదలగు రాష్ట్రాలలో పాటిస్తారు. సూర్యుడు మకర రాశిలోకి ప్రవేశించే కాలమే మకర సంక్రమణము. మకర సంక్రమణము నుండి ఉత్తరాయణ పుణ్యకాలము ప్రారంభము అవుతుంది. ఆ తరువాత కుంభ, మీన, మేష,వృషభ, మిథున రాశులలో కొనసాగినంత కాలము ఉత్తరాయణము. శారీరక పరిశ్రమకు, పూజలకు, సాధనలకు, కృషికి అనువైన, ఆవశ్యకత ఉన్న కాలము ఉత్తరాయనము.కర్కాటక రాశిలోకి సూర్యుడు ప్రవేశించిన దగ్గరినుండీ మొదలై, ఆ తరువాతసింహ, కన్య, తుల, వృశ్చికం, ధనూ రాశులలో కొనసాగినంత కాలము దక్షిణాయణము. మానసికమైన అర్చనకు,ధ్యానానికీ, యోగానికీ, దీక్షలకు,బ్రహ్మచర్యానికి, నియమ నిష్టలకు అనువైన, ఆవశ్యకత ఉన్న కాలము దక్షిణాయణము. పన్నెండు నెలల సంవత్సర కాలములో ఆరు నెలల దక్షిణాయణము దేవతలకు ఒక రాత్రి, ఆరు నెలల ఉత్తరాయణము దేవతలకు ఒక పగలు. కనుక దేవతలు మేలుకునే కాలము ఉత్తరాయణ పుణ్య కాలము. కనుకనే ఉత్తరాయణము వరకూ ఎదురు చూసి ఉత్తరాయణము ప్రవేశించిన తర్వాత తనువును చాలించాడు మహానుభావుడైన భీష్ముడు."
        },
        {
          "title": ""
        },
        {
          "title": "సంక్రాంతి లేదా సంక్రమణం అంటే చేరుట అని అర్ధం. జయసింహ కల్పద్రుమం అనే గ్రంధంలో సంక్రాంతి ని ఇలా విర్వచించారు - తత్ర మేషాదిషు ద్వాదశ రాశి క్రమణేషు సంచరతః సూర్యస్య పూర్వస్మాద్రాశే ఉత్తరః రాశౌ సంక్రమణ ప్రవేశః సంక్రాంతిః - మేషం మొదలైన 12 రాశులలో సంచరించే సూర్యుడు ముందున్న రాశి నుండి తరువాతి రాశిలోనికి ప్రవేశించడమే సంక్రాంతి సూర్యుని చలనంలో (రధయాత్రలో) ఘట్టాలు నాలుగు. అవి మేష, తుల, కటక, మకర సంక్రమణాలు. వీటిలో మకర సంక్రమణాన్ని సంక్రాంతి పండుగ గా వ్యవహరిస్తారు.మార్గశిరం పూర్తి కాగానే ఉత్తరాయణం మొదలవుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "ఆంధ్రులకు పెద్ద పండుగ సంక్రాంతి.ఇది కొన్ని ప్రాంతాలలో మూడు రోజులు( భోగి, మకర సంక్రమణం, కనుమ) ఇతర ప్రాంతాలలో నాలుగు రోజులు (నాలుగోరోజు ముక్కనుమ ) జరుపతారు కావున దీన్ని పెద్ద పండుగ అంటారు. ముఖ్యంగా పంట చేతికొచ్చిన ఆనందంలో రైతులు ఈ పండుగ జరుపుకుంటారు కాబట్టి రైతుల పండుగగా కూడా దీన్ని అభివర్ణిస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "నిజానికి ధనుర్మాసారంభంతో నెల రోజులు మూమూలుగానే సంక్రాంతి వాతావరణం చలిచలిగా తెలుగునాట ప్రారంభమవుతుంది. ఆ నెల రోజులు తెలుగు పల్లెలు ఎంతో అందంగా, ఆహ్లాదకరంగా అలరారుతాయి. బుడబుక్కలవాళ్లు, పగటివేషధారులు, రకరకాల జానపద వినోద కళాకారులు వూళ్ళో తిరుగుతూ సందడి చేస్తారు . ఈ పండుగకు దాదాపు నెలరోజుల ముందునుంచే - ప్రతీ రోజు తమ ఇళ్ళ ముంగిళ్ళను రంగవల్లులు, గొబ్బెమ్మ లతో అలంకరిస్తారు. ముగ్గులు వేయటానికి ప్రత్యేకంగా బియ్యపు పిండిని వాడతారు. కళ్లం నుంచి బళ్ల మీద ధాన్యం బస్తాలు వస్తూ ఉంటాయి. కోడి పందాలు, ఎడ్ల బళ్ళ పందాలు జరుగుతాయి. ఇవన్నీ సంక్రాంతి పండుగకు శోభ చేకూర్చే సర్వసామాన్య విషయాలు."
        },
      ],
      "title": "సంక్రాంతి పండుగ ప్రాధాన్యత ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>భోగి పండుగ కు ఆ పేరు ఎలా వచ్చింది?. భోగి మంటలు ఎందుకు వేస్తారు?"</span>,
        },
        {
          "title": ""
        },
        {
          "title": "భోగి లేదా భోగి పండుగ అనునది ఆంధ్రులు జరుపుకునే ఒక ముఖ్యమైన పండుగ. ఆంధ్రులు పెద్ద పండుగగా జరుపుకునే మూడు రోజుల సంక్రాంతి పండుగలో మొదటిరోజును భోగి అంటారు. భోగి పండుగ సాధారణంగా జనవరి 13 లేదా జనవరి 14 తేదిలలో వస్తుంది. దక్షిణాయనంలో సూర్యుడు రోజు రోజుకి భూమికి దక్షిణం వైపుగా కొద్ది కొద్దిగా దూరమవుతూ దక్షిణ అర్ధగోళంలో భూమికి దూరం అవుట వలన భూమిపై బాగా చలి పెరుగుతుంది. ఈ చలి వాతావరణాన్ని తట్టుకునేందుకు ప్రజలు సెగ కోసం భగ భగ మండే చలి మంటలు వేసుకునేవారు, ఉత్తరాయణం ముందురోజుకి చలి విపరీతంగా పెరగడం ఈ చలిని తట్టుకునేందుకు భగ భగ మండే మంటలు అందరు వేయటం వలన ఈ రోజుకు భోగి అనే పేరు వచ్చింది."
        },
        {
          "title": ""
        },
        {
          "title": "భోగి పండగ వెనుక వుండే మరొక విశేషము చూద్దాం."
        },
        {
          "title": ""
        },
        {
          "title": "సంక్రమణ మహాపర్వానికి ముందు రోజుకి ఒక ప్రాధాన్యం ఉన్నది. దీనికి భోగిపర్వం అని పేరు. అయితే భోగము అనే మాటకు అర్థం ఏమిటంటే అనుభవము అని. ఆనందంగా దేనిని అనుభవిస్తామో లేదా దేనిని అనుభవించడం వల్ల ఆనందం పొండుతామో దానిని భోగము అనాలి. అలాంటి భోగములు అనుభవించవలసిన రోజుని భోగి అంటారు. నిజమైన ఆనందాన్ని అనుభవించడమే నిజమైన భోగం. ఒక్కొక్కరికి ఒక్కొక్కటి ఆనందం. సామాన్యుల ఆనందాలు వేరు. వాళ్ళకి లౌకిక విషయాలు దొరికితే అది భోగం. ఆ విషయంతో విసుగు కలిగితే మరో విషయం లభించాలని. కానీ ఏది లభిస్తే మరి ఇంకేదీ కావాలని అనిపించదో, ఏది పరిపూర్ణమైన ఆనందమో అదే నిజమైన భోగం. అలాంటి భోగం యోగం వల్లనే లభ్యం అవుతుంది. అందుకే యోగులే భోగులు కాగలరు. అలాంటి దివ్య భోగం ఈరోజున అమ్మ గోదాదేవి ఆండాళ్ళమ్మ పొందినది. అదేమిటంటే పరమాత్మ ప్రాప్తి. రంగనాథుని చేపట్టినది. రంగనాథుని అనుగ్రహాన్ని పొందినది. రంగనాథుని సాంగత్యం అనబడేటటువంటి ఆ కైవల్యానందం అనే భోగాన్ని అమ్మ పొందినది కనుక ఈరోజు భోగి అనే పేరు భక్తి సాంప్రదాయం పరంగా నిర్వచించేవారు చెబుతారు. సరిగ్గా ఈ రోజుతో ధనుర్మాసం పూర్తి అవుతున్నది. తరువాత మకర మాసం వస్తున్నది సౌరమానం ప్రకారంగా. ఈ ధనుర్మాస వ్రతమంతా ఈరోజు పూర్తి అవుతుంది. దాని ఫలితంగా అమ్మవారు స్వామియొక్క అనుగ్రహాన్ని పొందినది."
        }
      ],
      "title": "భోగి పండుగ కు ఆ పేరు ఎలా వచ్చింది?. భోగి మంటలు ఎందుకు వేస్తారు?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>ఎన్నేళ్ళకి ఒకసారి ఆడ పడచుకి ఒడిబియ్యం పొయ్యాలి?"</span>,
        },
        {
          "title": ""
        },
        {
          "title": "ఎన్నేళ్ళకి అనే లెక్కలేదు. ఆడ పడచు పుట్టింటికి వచ్చిన ప్రతి సారి వడిబియ్యం తో పాటు చనిమిడి, చీర, జాకెట్టు, పూలు, ఫలాలు, పసుపు, కుంకుమ ఇచ్చి సాగనంపడం సాంప్రదాయం. అలా చేసిన ఇంట శాంతి సౌభాగ్యాలు వెల్లివిరుస్తాయి అని పెద్దల నానుడి. వడిబియ్యం పోయడం వెనుక ఒక శాస్త్రీయమైన కారణం ఉంది. ప్రసవం అయిన స్త్రీ నడుం నెప్పి తో బాధపడడం సర్వ సాధారణం. ఇప్పుడంటే నడుముకు కట్టుకోవడానికి బెల్టులు వచ్చాయి కాని పూర్వం ఇవేవి ఉండేవి కావు. ఒక మాదిరి వైశాల్యం తో నడుము చుట్టుకొలతకు సరి పోయేలా గుడ్డ సంచి తయారు చేసి దాన్ని బియ్యం తో నింపి నడుముకి కట్టేవారు. దాని ద్వారా స్త్రీలు ఉపసమనం పొందే వారు. స్త్రీ సాధారణం గా పుట్టింటికి ప్రసవం గురించి వచ్చి ప్రసవం అయ్యాక 3 నెలలు ఉండి అత్త వారింటికి వెళుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "ఆ సందర్భం లో ఆమెకు ఈ విధం గా ఉపయోగపడాలని వడిబియ్యం పోసేవారు. ప్రసవానికి - ప్రసవానికి మధ్య కొంత విరామం వుండడం సహజం!. ఈ విరామం 1 లేదా 2 లేదా 3.ఇలా వుంటుంది కదా!. కాబట్టి ఆడపడచుకి ప్రతి సంవత్సరం వడిబియ్యం (ఒడిబియ్యం) పోయ్యాలా 2 లేదా 3 సంవత్సరాలకు పొయ్యాలా అనే సందేహం ప్రస్తుత కాలం లో ఆడపడచు తల్లిదండ్రులకు కలుగుతోంది. అలాగే బియ్యం పిండి, బెల్లం, ఆవునెయ్యి, ఎండుకొబ్బరి ముక్కలతో చేసిన చనిమిడి మంచి అంటి-బయోటెక్ గా పనిచేస్తుంది. ప్రసవం అయిన స్తీకి చలువ చేస్తుంది. తమ పుత్రిక ఎప్పుడూ ఇలా సంతానవతిగా వుండాలని ఆమె తల్లిదండ్రులు ఆశిస్తూ ఆమెకు వడిబియ్యం, చనిమిడి, చీర, రవికల గుడ్డ, పసుపు, కుంకుమ మొదలైనవి పెట్టడం సాంప్రదాయం గా మారింది."
        }
      ],
      "title": "ఎన్నేళ్ళకి ఒకసారి ఆడ పడచుకి ఒడిబియ్యం పొయ్యాలి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>జ్యోతిష్య శాస్త్రం లో చూపించే పరిష్కారాలు పనిచేస్తాయా?"</span>,
        },
        {
          "title": ""
        },
        {
          "title": "మన ప్రాచీన మహర్షులు, ఋషులు ఎన్నో విషయాలు పరిశీలించి. గ్రహాల కదలిక వల్ల మన నిత్య జీవితం లో కనబడే సమస్యలకు వివిధ పద్ధతులలో పరిష్కార మార్గాలు సూచించారు. అయితే వీటిని మనం నమ్మకం తో ఆచరించవలసి ఉంటుంది. అనుమానం తో ఆచరిస్తే ఫలితాలు కూడా అదే విధం గా ఉంటాయి. సంఖ్యా శాస్త్రం లో నిష్ణాతులైన పండితులు సూచించిన ప్రకారం పేరు మార్చుకొని ఉన్నత స్థితి కి వచ్చిన వారిని మనం చూస్తూనే ఉన్నాము కారణం వారికి ఆ శాస్త్రం పైన, పరిష్కారము పైన గల నమ్మకమే వారిని విజయ పధం వైపు నడిపించింది. నిజానికి సంఖ్యా శాస్త్రం కన్నా జ్యోతిష్య శాస్త్రం చాలా నమ్మదగినది."
        },
        {
          "title": ""
        },
        {
          "title": "జ్యోతిష్య శాస్త్ర ప్రకారం పరిష్కార మార్గాలు ఐదు పద్ధతులలో సూచించ బడతాయి. 1. రత్న ధారణ, 2. మంత్ర జపం / దానం 3. యంత్ర స్థాపన. 4. తంత్ర పద్ధతి 5. ఔషధ సేవనము"
        },
        {
          "title": ""
        },
        {
          "title": "1. రత్న ధారణ : మన గ్రహ స్థితి ని బట్టి ఆ సమయలో ఉండే గ్రహాన్ని సంతృప్తి పరచడానికి నవ రత్నాలలో అందుకు తగ్గ రత్నాన్ని సూచించడం జరుగుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "2. మంత్ర జపం / దానం: మాటే మంత్రము అవుతుంది. ఒక మంచి మాట ఒకరి మనసు మెప్పిస్తే ఒక చెడ్డ మాట అదే మనసుని నొప్పిస్తుంది. కాబట్టి మన గ్రహస్థితి ని బట్టి ఆ గ్రహాన్ని ఆనంద పరచడానికి ఆ గ్రహానికి సంబంధించిన స్తోత్రము పారాయణ చేయడం వలన ఆ గ్రహం యొక్క అనుగ్రహం పొందవచ్చు. అలాగే ఆ గ్రహానికి ఇష్టమైన తృణ ధాన్యాలను దానం చెయ్యడం వలన ఆ గ్రహాన్ని తృప్తి పరచవచ్చు."
        },
        {
          "title": ""
        },
        {
          "title": "3. యంత్ర స్తాపన: ఒక రాగి రేకుపై బీజాక్షరాలు, కోణాలు మొదలైన వాటితో సిద్ధం చేసినవి. శ్రీ చక్రం, అష్ట లక్ష్మి యంత్రం, కుబేర యంత్రం మొదలైనవి. నడుస్తున్న గ్రహస్థితిని బట్టి ఏ యంత్రం స్థాపించాలో సూచించడం జరుగుతుంది. ఆ యంత్రాన్ని భక్తి శ్రద్ధలతో పూజించి మంచి ఫలితములు పొందవచ్చు."
        },
        {
          "title": ""
        },
        {
          "title": "4. తంత్ర పద్ధతి: నిమ్మ కాయలు, గుమ్మడి కాయలు మొదలైన వాటిని ఉపయోగించి గ్రహముల దృష్టి మరల్చడం."
        },
        {
          "title": ""
        },
        {
          "title": "5. ఔషధ సేవనం: నిజానికి మనం భుజించే ఆహారమే మనకు ఔషధం గా పనిచేస్తుంది. మన ఆహారం లో ఉండే షడ్రుచుల సమ్మేళనం మనలను ఆరోగ్యవంతులుగా చేస్తుంది. మన గ్రహ స్థితిని బట్టి ఆ గ్రహానికి ఇష్టమైన కాయగూరలు, ధాన్యాలు సేవించడం వలన ఆ గ్రహాన్ని ఆనంద పరచడం వలన మంచి ఫలితములు పొంద వచ్చు."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ విధం గా మన గ్రహ స్థితిని బట్టి మనకు తగిన పరిష్కారములు మన ఋషులు, మహర్షులు సూచించడం జరిగింది."
        }
      ],
      "title": "జ్యోతిష్య శాస్త్రం లో చూపించే పరిష్కారాలు పనిచేస్తాయా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>క్షీరాబ్ది ద్వాదశి?"</span>,
        },
        {
          "title": ""
        },
        {
          "title": "కార్తీక శుద్ధ ద్వాదశిని క్షీరాబ్ది ద్వాదశి అని అంటారు. పూర్వం దేవతలు - దానవులు అమృతం కోసం క్షీరసాగరాన్ని మథించడం ఈ రోజునే ఆరంభించారు. ఈ కారణంగానే దీనికి క్షీరాబ్ధి ద్వాదశి అనే పేరు వచ్చింది. ఇక ఈ రోజున క్షీరసాగరం చిలకబడింది కనుక దీనిని చిలుకు ద్వాదశి గా మథన ద్వాదశి గా పిలుస్తుంటారు. ఇంతటి విశేషాన్ని సంతరించుకున్న ఈ రోజున తులసి పూజ చేసే ఆచారం వుంది కనుక ఈ రోజుని తులసి ద్వాదశి అని కూడా అంటూ వుంటారు."
        },
        {
          "title": ""
        },
        {
          "title": "శ్రీ మహావిష్ణువు లక్ష్మీదేవితో కలిసి ఈ రోజున తులసి కోటలోకి ప్రవేశిస్తాడు. అందువల్లనే ఈ రోజున తులసిని పూజించడం వలన సకల శుభాలు కలుగుతాయని చెప్పబడింది. ఇక ఈ రోజు తెల్లవారు జామునే పుణ్యస్త్రీలు తలంటు స్నానం చేయాలి. తులసికోట దగ్గర దీపం పెట్టి దాని చుట్టూ ప్రదక్షిణలు చేయాలి. ఆ తరువాత పూజా మందిరం చెంత యధావిధిగా నిత్య పూజను జరపాలి. మరలా సాయంత్రం తులసి పూజ అయ్యేంత వరకూ ఉపవాసం వుండాలి."
        },
        {
          "title": ""
        },
        {
          "title": "తులసి కోట లక్ష్మీ నారాయణుల నివాసంగా వుంటుంది కనుక, దానిని వివిధ రకాల పుష్పాలతో అందంగా అలంకరించాలి. తులసికోట చుట్టూ దీపాలను వెలిగించాలి. తులసిని లక్ష్మీనారాయణుల స్వరూపంగా భావించి పూజించాలి. భక్తి శ్రద్ధలతో తులసిని పూజించి, దీపదానాలు చేయడం వలన సమస్త దోషాలు నశిస్తాయనీ, అపమృత్యు భయాలు తొలగిపోతాయని చెప్పబడుతోంది."
        }
      ],
      "title": "క్షీరాబ్ది ద్వాదశి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>ఆకాశ దీపం అంటే ఏమిటి? దేవాలయాలలో వెలిగించడం వెనుక అంతరార్ధం ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "శివ కేశవులకి ఎంతో ప్రియమైనది కార్తీకమాసం. ఈ మాసం ప్రారంభం కాగానే దేవాలయాల్లో ధ్వజ స్తంభానికి 'ఆకాశ దీపం' వెళ్లాడ దీస్తుంటారు. చిన్న చిన్న రంధ్రాలు చేయబడిన ఓ గుండ్రని ఇత్తడి పాత్రలో నూనెపోసి ఈ దీపాన్ని వెలిగిస్తారు. తాడు సాయంతో ఈ పాత్రను పైకి పంపించి, ధ్వజ స్తంభం పైభాగాన వేలాడదీస్తారు. ఈ దీపంలో నూనె పోయడానికి, ఈ దీపాన్ని దర్శించుకోవడానికి భక్తులు పెద్ద సంఖ్యలో ఆలయాలకి వెళుతూ వుంటారు."
        },
        {
          "title": ""
        },
        {
          "title": "అయితే దీనిని ఆకాశ దీపం అని పిలవడానికి ధ్వజ స్తంభానికి వేలాడదీయడానికి కారణం వుంది. ఆకాశ దీపం దూరంగా ఉన్న మానవులు దర్శించడానికి కాదు, ఆకాశ మార్గాన ప్రయాణించే పితృదేవతల కోసమని శాస్త్రం చెబుతోంది. 'దీపావళి' రోజున రాత్రి లక్ష్మీ పూజ చేస్తారనే విషయం అందరికీ తెలిసిందే. అయితే ఆ రోజు మధ్యాహ్నం చాలామంది తమ పితృ దేవతలకు తర్పణం వదులుతుంటారు. కార్తీక శుద్ధ పాడ్యమి నుంచి పితృ దేవతలంతా ఆకాశమార్గాన తమ తమ లోకాలకు ప్రయాణం చేస్తుంటారు. ఈ సమయంలో వారికి త్రోవ సరిగ్గా కనిపించడం కోసం ఆలయాలలో ఆకాశ దీపాన్ని వెలిగిస్తుంటారు."
        }
      ],
      "title": "ఆకాశ దీపం అంటే ఏమిటి? దేవాలయాలలో వెలిగించడం వెనుక అంతరార్ధం ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>నాగుల చవితి పండుగ వెనుక వుండే అంతరార్ధం ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "దీపావళి అమావాస్య తరువాత వచ్చే కార్తీక శుద్ధ చతుర్థిని నాగుల చవితి పండుగ అంటారు. కొందరు శ్రావణ శుద్ధ చతుర్థినాడు జరుపుకుంటారు.ప్రకృతి మానవ మనుగడకు జీవనాధరమైనది కనుక దానిని దైవస్వరూపంగా భావించి మన పూర్వీకులు చెట్టును, పుట్టను, రాయిని, రప్పను, కొండను, కోనను, నదిని, పర్వతాన్ని - ఇలా సమస్త ప్రాణికోటిని దైవస్వరూపంగా చూసుకొంటూ! పూజిస్తూవస్తున్నారు. ఇదే మనభారతీయ సంస్కృతిలోని విశిష్టత. నిశితంగా పరిశీలిస్తే అందులో భాగంగానే నాగుపాము ను కూడా నాగరాజుగా, నాగదేవతగా పూజిస్తూ వస్తున్నారు."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ పాములు భూమి అంతర్భాగమందు నివసిస్తూ భూసారాన్ని కాపాడే ప్రాణులుగా సమస్త జీవకోటికి నీటిని ప్రసాదించే దేవతలుగా తలచేవారు. ఇవి పంటలను నాశనంచేసే క్రిమికీటకాదులను తింటూ, పరోక్షంగా రైతు కు పంటనష్టం కలగకుండా చేస్తాయట!. అలా ప్రకృతి పరంగా అవి మనకు ఎంతో సహాయపడుతూ ఉంటాయి. మన పురాణాలలో నాగుల చవితి గురుంచి ఎన్నో గాథలు ఉన్నాయి. దేశమంతట పలు దేవాలయల్లో మెలికలతో ఉన్న నాగేంద్రుని విగ్రహాలు కనిపిస్తూ ఉంటాయి. ఈ నాగుల చవితి నాడు నాగేంద్రుని శివభావముతో అర్పిస్తే సర్వరోగాలు పోయి సౌభాగ్యవంతులవుతారని భారతీయుల నమ్మకం."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ మానవ శరీరమనే పుట్టకు తొమ్మిది రంధ్రాలు ఉంటాయి. వాటినే నవరంధ్రాలు అంటూ ఉంటారు. మానవ శరీరంలో నాడులతో నిండివున్న వెన్నెముకను 'వెన్నుబాము' అని అంటారు. అందు కుండలినీశక్తి మూలాధారచ పాము ఆకారమువలెనే వుంటుందని యోగశాస్త్రం చెబుతోంది. ఇది మానవ శరీరంలో నిదురిస్తున్నట్లు నటిస్తూ! కామ, క్రోధ, లోభ, మోహ, మద, మాత్సర్యాలనే విషాల్ని గ్రక్కుతూ, మానవునిలో ' సత్వగుణ' సంపత్తిని హరించి వేస్తూ ఉంటుందని అందుకు ' నాగుల చవితి రోజున ప్రత్యక్షంగా విషసర్పపుట్టలను ఆరాధించి పుట్టలో పాలు పోస్తే మానవునిలో ఉన్న విషసర్పం కూడా శ్వేతత్వం పొంది, అందరి హృదయాలలో నివశించే ' శ్రీమహావిష్ణువు నకు తెల్లని ఆదిశేషువుగా మారి శేషపాన్పుగా మారాలని కోరికతో చేసేదే! ఈ నాగుపాము పుట్టలో పాలు పోయుటలోగల అంతర్యమని చెప్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "నాగుల చవితి రోజు ఆవు పాలు పుట్టలో పోసి నాగపూజచేసి చలిమిడి, చిమ్మిలి (నువ్వులతో చేస్తారు) అరటిపళ్ళు, తాటి బుర్రగుంజు, తేగలు మున్నగున్నవి నివేదన చేస్తారు. ఆ సందర్భంగా పుట్టవద్ద దీపావళి నాడు మిగిలిన మతాబులు, కాకరపువ్వొత్తులు, టపాసులు మొదలైనవి చిన్నపిల్లలు ఎంతో సంతోషంగా కూడా కాలుస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "మన భారతీయుల చాల ఇళ్ళల్లో ఇలవేల్పు సుబ్రహ్మణేశ్వరుడే ఆరాధ్య దైవంగా పూజిస్తారు కాబట్టి వారి పేరును చాల మంది నాగరాజు, ఫణి, సుబ్రహ్మణ్యం, సుబ్బారావు వగైరా పేర్లు పెట్తుకుంటూ ఉంటారు."
        },
      ],
      "title": "నాగుల చవితి పండుగ వెనుక వుండే అంతరార్ధం ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>కార్తీక మాసం లో వన భోజనం ఎందుకు చేయాలి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "కార్తీకమాసములో బంధువులు, స్నేహితులతో కలసి చెట్ల నీడ లో (ప్రత్యేకించి ఉసిరి చెట్టు నీడన) కలసి భోజనం చేయటాన్ని వన భోజనం అంటారు. ప్రకృతి తో మన బంధాన్ని గుర్తుచేసుకునే రోజు గా చెప్పవచ్చు. జపాను లో కూడ హనామి (హన - పువ్వు, మిమస్ - చూడటం) పేరుతో మార్చి చివరి వారం లో బంధువులు స్నేహితులతో కలసి ఇదే విధమైన వేడుక చేసుకుంటారు. ఇది జపాను లో విశేషమైన ఆదరణ పొందిన వేడుకలలో ఇది ఒకటి."
        },
        {
          "title": ""
        },
        {
          "title": "కార్తీక మాసంలో వనభోజనం తప్పని సరి. ‘వనం’ అనే పదానికి అరణ్యాన్ని ప్రేమించడమని అర్థమని అమరకోశం చెబు తుంది. కార్తీక మాసంలో వన భోజనానికి ఎందుకు వెళ్లాలి? దీని వెనక ఒక పరమార్థం ఉంది. అరణ్యానికి ఎవడు వెళ్ళాడో వాడు పండడానికి సిద్ధపడ్డాడని గుర్తు. వాన ప్రస్థంలో అందరూ అరణ్యంలోనే గడుపు తారు. అరణ్యంలో ఎవరితోనూ సంబంధం లేకుండా ఒక ఆశ్రమం కట్టుకొని, రాగద్వేషాలు లేకుండా, భగవంతుడిని ధ్యానం చేస్తూ గడుపుతారు. దానికి సాధనే వనభోజనం. అందుకే వనభోజనానికి పవిత్రమైన హృదయంతో వెళ్లాలి. ఏ ప్రకృతిలో ఉపద్రవం ఉందో ఆ ప్రకృతినే ఆశ్రయించి ఆరోగ్యాన్ని సిద్ధింపజేసుకోవాలి. ఆరోగ్యాన్నిచ్చే ఉసిరి చెట్లు, తులసి చెట్లు, మామిడి చెట్లు ఉన్న ప్రాంతాలకు వెళ్లాలి."
        },
        {
          "title": ""
        },
        {
          "title": "ఉసిరి, తులసిల గురించి మనకు తెలుసు. మరి మామిడి విశిష్టత ఏమిటి?. మామిడి చెట్టుకి సంస్కృతంలో రసాలం అని పేరు. పరమేశ్వరుని పేరు ఉన్న ఏకైక చెట్టు మామిడి చెట్టు. పరమేశ్వరుడే ఈ భూమి మీద చెట్టుగా వస్తే అది మామిడి చెట్టు. అటువంటి మామిడి చెట్టు, ఉసిరి చెట్టు, తులసి బృందావనం ఇటువంటివన్నీ ఎక్కడున్నాయో అక్కడికి వెళ్లాలి. సత్యనారాయణ స్వామి వ్రతం కానీ, మరే ఏ ఇతర వ్రతం గానీ చేయాలి. విష్ణు సహస్రం, శివ సహస్రం, లక్ష్మీ సహస్రం, లలితా సహస్రం- ఇవన్నీ సాయంత్రం దాకా చదవాలి. పొద్దు పొడిచిన తరువాత మహా నైవేద్యం పెట్టి భోజనం చేయాలి. కృష్ణుడి వన భోజనం!"
        },
        {
          "title": ""
        },
        {
          "title": "ఎవరూ మరచిపోలేనంత గొప్ప వనభోజనం చేసినవాడు శ్రీకృష్ణ పరమాత్ముడు. బలరాముడు, ఇతర స్నేహితులతో- “ఓరేయ్, రేపు మనమందరం వనభోజనానికి వెళుతున్నాం రా!” అన్నాడు. వాళ్ళు రోజూ వెళ్ళేది ఆ వనానికే. ప్రతి రోజూ మధ్యాహ్నం ఆహారం తినేది కూడా అక్కడే. అలాంటి వాళ్లకు కొత్తగా వన భోజనం ఎందుకు? ఎందుకంటే- వన భోజనం ఎలా ఉంటుందో రుచి చూపించాలనేది ఆయన ఉద్దేశం. అందరూ పొద్దున్నే లేచారు. గోపాల బాలురకి ఉండే లక్షణం ఏమిటంటే, వాళ్ళు ఉదయం స్నానం చేయరు. సాయంకాలం వచ్చి స్నానం చేస్తుంటారు. అందుకే వారు ఎప్పుడూ చద్ది అన్నమే తింటారు. ప్రతి రోజు మాదిరిగానే అన్నం మూటకట్టుకొని వన భోజనానికి వెళ్దాం పదండి అని బయలుదేరారు."
        },
        {
          "title": ""
        },
        {
          "title": "అక్కడ కృష్ణుడు చూపించిన లీలలు ఒకటా రెండా! అందుకే వనం అంటే బ్రహ్మం కాబట్టి బ్రహ్మాన్ని అరిగించడం. అంటే కృష్ణభగవానుడి లీలల్ని ఆస్వాదించటమే వన భోజనం. ఆ వన భోజనంలోు ఏ అరమరికలూ లేవు. గోపాలురు కృష్ణుడితో తాదామ్యత పొందారు. మనం కూడా వనంలోకి వెళ్ళీ ఆ ఉసిరి చెట్టు కింద, తులసి బృందావనంలో చక్కగా వంట చేసుకుని, పరమేశ్వరుడికి మహానైవేద్యం పెట్టి, అందరూ ఒక్కటిగా నిలబడి అన్నం తిని, ఆ ప్రకృతి అన్రుగహాన్ని, పరమాత్మ అన్రుగహాన్ని పొంది ఇంటికి తిరిగి రావడానికి వన భోజనమని పేరు. వనభోజనం ఎందుకు నిర్దేశించారో అందుకే చేయాలి. చేయకూడని పనుల కోసం వన భోజనాలకు వెళ్లకూడదు."
        },
      ],
      "title": "కార్తీక మాసం లో వన భోజనం ఎందుకు చేయాలి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>కార్తీక సోమవారం ప్రాధాన్యత ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "హిందూ మతంలో కార్తీక మాసం ప్రత్యేకమైనది. సాక్షాత్తు భగవంతుడు శివునికి పరమపవిత్రమైన మాసం ఇది. ఈ నెలలో సోమవారంనాడు ఉపవాసం ఉండి భగవంతుని పూజించి దానధర్మలు చేసినవారికి పాపాల నుంచి విముక్తి లభించడమే కాకుండా మోక్షం లభిస్తుందని అంటారు. కార్తీక మాసం సోమవారం నాడు ప్రారంభం అయితే అది ఒక విశేషం. సోమవారం పూట కార్తీక మాస ప్రారంభం శుభఫలితాలకు సంకేతమని పురోహితులు చెబుతున్నారు. అందుచేత కార్తీక సోమవారం శివాలయాలను దర్శించడం చాలా మంచిది."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ వారంలో ముత్తైదువులు భక్తిశ్రద్ధలతో శివునిని కొలిస్తే మాంగళ్య భాగ్యం చేకూరుతుందని విశ్వాసం. ఇంకా చెప్పాలంటే ఈ సోమవారాల్లో శైవభక్తులు నిష్టనియమాలతో శివునిని ఆరాధిస్తారు. సోమవారం సూర్యోదయానికి పూర్వమే బ్రహ్మీముహూర్తమున స్నానమాచరించి హరహరశంభో అంటూ శివుణ్ణి స్తుతిస్తే పాపాల నుంచి విముక్తి లభించడంతో పాటు అష్టైశ్వర్యాలు కలుగుతాయి. ఈ మాసమంతా ఉపవాసముండి శివునిని కొలిస్తే కైలాసవాసం సిద్ధిస్తుందని శాస్త్రోక్తం.దీనినే కార్తీక నత్తాలు అంటారు."
        },
        {
          "title": ""
        },
        {
          "title": "సోమవారం ఉదయం స్నానాదికార్యక్రమాలను పూర్తి చేసుకుని, పొడిబట్టలు ధరించి మొదటగా దీపారాధన చేయాలి. అనంతరం శివునికి రుద్రాభిషేకం చేయించి శివవ్రత నియమాలను పాటించాలి. ఈ విధంగా చేయడం ద్వారా నిత్య సిరిసంపదలతో, సుఖసౌఖ్యాలతో వర్ధిల్లుతారని విశ్వాసం."
        }
      ],
      "title": "కార్తీక సోమవారం ప్రాధాన్యత ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>కార్తీక మాసం విశిష్టత ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "కార్తీక మాసము తెలుగు సంవత్సరం లో ఎనిమిదవ నెల. చంద్రుడు పూర్ణుడై ఏ నక్షత్రంలో ఉంటాడో, ఆ నక్షత్రం పేరు ఆ మాసానికి వస్తుంది. కృత్తికా నక్షత్రంలో చంద్రుడు పూర్ణుడై సంచరించుట వలన ఈ మాసానికి కార్తీక మాసమని పేరు. హిందువులకు ఈ నెల శివుడు మరియు విష్ణువు లిద్దరి పూజ కొరకు చాలా పవిత్రమైనది. ఈ కార్తీకమాసము స్నానములకు మరియు వివిధ వ్రతములకు శుభప్రథమైనది."
        },
        {
          "title": ""
        },
        {
          "title": "కార్తీక మాసంలో ఉభయ పక్షములందు అనేక వ్రతములు కలవు. అయ్యప్ప దీక్ష ఈ నెలలో ప్రారంభమై మకర సంక్రాంతి వరకు కొనసాగుతుంది."
        },
        {
          "title": "స్కంద పురాణంలో ఈ విధంగా పేర్కొనబడినది:"
        },
        {
          "title": ""
        },
        {
          "title": "న కార్తికసమో మాసో న కృతేన సమం యుగమ్,"
        },
        {
          "title": ""
        },
        {
          "title": "అర్ధం: కార్తీకమాసానికి సమానమైన మాసమేదీ లేదు. సత్యయుగంతో సమానమైన యుగమేదీ లేదు. వేదములతో సమానమైన శాస్త్రమేదీ లేదు. గంగానది వంటి ఇతర నదేదీ లేదు."
        },
        {
          "title": ""
        },
        {
          "title": "ధార్మిక యోచనలు కలిగిన ప్రజలు ఏకభుక్తము, లేక నిరాహారాది వ్రతాలు చేస్తారు. రాత్రులలో దేవాలయాలందు లేదా తులసి దగ్గర దీపాలు వెలిగిస్తారు. స్వయంగా దీపదానాలు చేయనివారు ఆరిన దీపాలను వెలిగించుట వలన, గాలి మొదలైన వాటి వలన దీపాలు ఆరిపోకుండా చేసి, దీపదాన ఫలితాన్ని పొందవచ్చును. కార్తీక మాసము అత్యంత పవిత్రమైంది. మహిమాన్వితమైంది. శివ కేశవులకి ప్రీతికరమైన మాసం. ఈ మాసంలో దేశం నలుమూలలా ఉన్న ఆలయాలలో రుద్రాభిషేకాలు, లక్ష బిల్వార్చనలు, రుద్ర పూజలు విశేషంగా జరుపుతారు. విశేషార్చనలు జరిపే భక్తులకు సదాశివుడు ప్రసన్నుడై వారి అభీష్టాలను తీరుస్తాడు. అందుకే ఆ స్వామికి ‘అశుతోషుడు’ అన్న పేరు వచ్చింది. ‘అభిషేక ప్రియః శివః’ శివునికి అలంకారాలతో రాజోపచారములతో, నైవేద్యములతో పనిలేదు. మనస్సులో భక్తినుంచుకుని శివుడ్ని ధ్యానిస్తూ చేసే అభిషేకంతో శివుడు ప్రీతి చెందుతాడు. శివాభిషేకం అన్ని దోషాలను పోగొట్టి సకల శుభాలను కలగ చేస్తుంది."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ మాసంలో శివార్చన చేసినవారికి గ్రహదోషాలు, ఈతిబాధలు ఉండవు. శివునిని శ్రీవృక్ష పత్రములతో (బిల్వదళములు) పూజించిన స్వర్గమున లక్ష సంవత్సరములు జీవించును. ప్రదోషకాలంలో పరమేశ్వరుడు, ఏకకాలంలో రెండురూపాలని ప్రదర్శిస్తూ ఎడమభాగాన పార్వతి, కుడి భాగాన పరమేశ్వర రూపంగా అర్ధ నారీశ్వరునిగా దర్శనమిచ్చే సమయం ఈ ప్రదోషకాలంగా చెప్పబడింది. ప్రదోషకాలంలో శివారాధన, శివదర్శనంచేసుకుంటే శివుని అనుగ్రహానికి పాత్రులగుదురు. శివాలయములో ప్రార్థన, లింగార్చన, బిల్వార్చన వంటి పుణ్య కార్యములు ఆచరించుట ఈ మాసంలో విశేష ఫలాన్ని ప్రసాదిస్తాయి. అష్టోత్తర లింగార్చన, మహా లింగార్చన, సహస్ర లింగార్చన ఉత్తమోత్తమమైన అర్చన. ఈ మాసంలో ఈ అర్చనలు చేస్తే సంవత్సర మొత్తం చేసిన ఫలాన్నిస్తాయి. తులసి దళాలతో శ్రీ మహావిష్ణుని కార్తీకమాసంలో పూజిస్తే ముక్తిదాయకం అని శాస్త్ర వచనం. ఈ మాసంలో విష్ణువు దామోదర నామంతో పిలవబడతాడు. ‘కార్తీక దామోదర ప్రీత్యర్ధం’ అని ఈ మాసాన వ్రత దీక్ష ఆచరించాలి. తులసి చెంత హరిపూజ పుణ్యప్రదం. సత్యనారాయణ వ్రతం, విష్ణు సహస్రనామ పారాయణ, రుద్రాభిషేకాలు చేయడం శ్రేష్టం. శివానుగ్రహానికి, విష్ణువు అనుగ్రహానికి ఈ మాసం ఉతృష్టమైంది. "
        },
        {
          "title": ""
        },
        {
          "title": "కార్తిక మాసంలో ఏమంత్ర దీక్ష తీసుకున్నా మంచి ఫలితాలను ఇస్తుందని శాస్త్ర వచనం. ‘కార్త్తిక పురాణం’ రోజుకో అధ్యాయం పారాయణ చేయడం శుభకరం. ఈ మాసం మొదటినుండి సూర్యోదయానికి పూర్వమే నదీస్నానం అత్యంత ఫలప్రదం. కార్తీక నదీ స్నాన విషయంలో ఆరోగ్య సూత్రం కూడా ఇమిడి ఉంది. నదీ జలాలు కొండలలోను, కోనలలోను, చెట్టు పుట్టలను తాకుతూ ప్రవహిస్తాయి. అలా ప్రవహించడం ద్వారా ఎన్నో వనమూలికల రసం నదీ జలాల్లో కలుస్తుంది. ఈ మాసంలో గృహిణులు, యువతులు వేకువనే స్నానం చేసి తులసి కోట ముందు దీపారాధన చేసి గౌరీదేవిని పూజిస్తే ఈశ్వరాను గ్రహంతో సౌభాగ్యాన్ని, సకల శుభాలను పొందుతారు. మాసమంతా స్నాన విధిని పాటించలేని వారు పుణ్య తిథులలోనైనా స్నానం ఆచరించాలి. కార్తీక మాసం మొదలునుండే ‘ఆకాశదీపం’ ప్రారంభమవుతుంది. ఉభయ సంధ్యలలో గృహమందు, పూజామందిరంలోను, తులసి సన్నిధిలోను, ఆలయమలలో దీపారాధన, ఇహ, పర సౌఖ్యాలను కలగచేస్తుంది. ఈ మాసం దీపారాధనకి ప్రశస్త్యం. దీపదానమందు ఆవునెయ్యి ఉత్తమం. మంచి నూనె మధ్యమము. ఏకాదశి అత్యంత విశేషమైనది. ‘ఉత్థానైకాదశి’ కార్తీక శుద్ధ ద్వాదశి కార్తీక పౌర్ణమి లాంటి దినాలుప్రశస్తమైనవి."
        }
      ],
      "title": "కార్తీక మాసం విశిష్టత ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>ధన త్రయోదశి విశేషాలు ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "ఆశ్వయుజ బహుళ త్రయోదశి'ని ధన త్రయోదశి అని అంటారు. ఈ రోజుతోనే దీపావళి పండుగ సందడి మొదలవుతుంది. ఉత్తరాది వారి ఆచారంగా కనిపించే ధన్ తే రాస్ ధన త్రయోదశిగా నేడు భారతీయులందరినీ ప్రభావితం చేస్తోంది. ఈ రోజున బంగారం కొనుగోలు చేస్తే ఏడాది పొడవునా బంగారం కొంటూనే వుంటామనే బలమైన విశ్వాసం అందరిలోనూ కనిపిస్తూ వుంటుంది. ఈ రోజున ఇంటికి వచ్చిన లక్ష్మీదేవి స్థిరంగా ఉంటుందని భావిస్తుంటారు."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ సందర్భంగా లక్ష్మీదేవిని విష్ణుమూర్తిని కుబేరుడిని యమధర్మరాజుని ధన్వంతరిని పూజిస్తుంటారు. ఈ ఆచారం వెనుక పురాణ సంబంధమైన కథ లేకపోలేదు. నరకాసురుడి ధనాగారంలో బందీగా వున్న అమ్మవారిని శ్రీ మహావిష్ణువు విడిపించి, లక్ష్మీదేవిగా అమ్మవారిని పట్టాభిషిక్తురాలిని చేసింది ఈ రోజే. సమస్త లోకాల సంపదలకు కారకురాలైన లక్ష్మీదేవినీ, ఆ తల్లి అనుగ్రహాన్ని అందుబాటులోకి తెచ్చిన కారణంగా శ్రీ మహావిష్ణువును కూడా పూజిస్తుంటారు."
        },
        {
          "title": ""
        },
        {
          "title": "సంపదలకు కుబేరుడు అధిపతి కనుక ఈ రోజున ఆయనను ఆరాధిస్తూ వుంటారు. ఈ రోజున బంగారం రూపంలో లక్ష్మీదేవిని ఇంటికి తీసుకురావడం వలన మృత్యుభయం తొలగిపోతుందని అంటారు. బంగారుకాంతులు దీపాల వెలుగులు కలిసి యమధర్మరాజు దృష్టిని మళ్లించి ఆయన మనసును మార్చేస్తాయట. దాంతో ఉత్తచేతులతో వెనుదిరిగిన ఆయనకి అంతా కృతజ్ఞతలు తెలియజేస్తుంటారు. యమధర్మరాజుని శాంతింపజేసే రోజు కనుక దీనిని 'యమత్రయోదశి' అని కూడా పిలుస్తుంటారు. లక్ష్మీదేవి అనుగ్రహం వలన సంపదలు యముడి దయవలన ఆయుష్షు పొందిన వాళ్లు, ఆరోగ్యం కోసం ధన్వంతరిని ఆరాధిస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "ఇక సంపదలు ఆయుష్షు ఆరోగ్యం గురించి దేవతలను ఆరాధించిన వారు, అవి స్థిరంగా ఉండేలా పితృదేవతల ఆశీస్సులను కోరుకుంటారు. అందువల్లనే ఈ రోజు సాయంత్రం ప్రధాన ద్వారం చెంత అన్నాన్ని రాశిగా పోసి దానిపై దీపపు ప్రమిదను ఉంచుతారు. ఆ వెలుగు పితృదేవతలకు దారి చూపుతుందనీ, వాళ్లు వచ్చి ఆశీర్వదించి వెళతారని విశ్వసిస్తూ వుంటారు. అలా ధన త్రయోదశి పెద్దల ఆశీస్సులతో పాటు, ఆయురారోగ్య ఐశ్వర్యాలను అందిస్తూ తన విశిష్టతను చాటుకుంటోంది."
        }
      ],
      "title": "ధన త్రయోదశి విశేషాలు ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>తల్లి దండ్రుల పాప పుణ్యాలు పిల్లలకు వస్తాయా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "మనం ఒకోసారి వింటూ ఉంటాము. ఏ జన్మలో ఏ పాపం చేసానో. ఈ జన్మలో ఈ రోగం తో బాధ పడుతున్నాను. ఏ జన్మలో ఏ పాపం చేసానో ఈ జన్మలో ఇలాంటి భర్త / భార్య దొరికాడు / దొరికింది. తెలిసి నేను ఏ పాపమూ చెయ్య లేదు అయినా నా కెందుకీ శిక్ష వేసాడు దేవుడు."
        },
        {
          "title": ""
        },
        {
          "title": "ఇలాంటి మాటలు వింటూ ఉంటాము. మరి చెయ్యని పాపాలకు వాళ్ళు శిక్షలు ఎందుకు అనుభవిస్తున్నారు అంటే కారణం మూడు తరములనుండి వారికి ఆనువంశికంగా వస్తున్న పాప పుణ్యాలు అని చెప్పుకోవచ్చు. తాను గత జన్మ లో చేసిన పాప పుణ్యాలు మాత్రమే కాదు. ఈ జన్మలో తన తల్లిదండ్రులు, తాత ముత్తాతలు చేసిన పాప పుణ్యాలు కూడా జీవికి ఆనువంశికంగా వస్తాయి అనే చెబుతోంది ధర్మ శాస్త్రం. కనిపించే ఆస్తి పాస్తులు ధన - ధాన్యాలు వస్తు - వాహనాలు ఎలాగో కనబడనివి పాప పుణ్యాలు. కనిపించే ఆస్తి పాస్తులు తర తరాలనుండి ఎలా సంక్రమిస్తున్నాయో కనబడని పాప పుణ్యాలు కూడా అలాగే సంక్రమిస్తాయి అని చెబుతోంది ధర్మ శాస్త్రం. వారి ఆస్తి మాకు వద్దు, వారి పాప పుణ్యాలు మాకు వద్దు అన్నంత మాత్రాన ఇవి పోవు."
        },
        {
          "title": ""
        },
        {
          "title": "ఎందుకంటే ఈ శరీరమే తల్లిదండ్రులు, తాత ముత్తాతల ప్రసాదమైనప్పుదు ఈ శరీరానికి అంటిన ఆ పాపాలు అంత సులభంగా పోవు. అలా పోవాలంటే ప్రస్తుత జన్మలో నిత్యం భగవన్నామ స్మరణ చేయాలి. ఉన్నంతలో ఇతరులకు సహాయ సహకారాలు చేయాలి. పుణ్య నదులలో స్నానాదులు చెయ్యాలి, తీర్ధ యాత్రలు చెయ్యాలి. చేసిన పాపాలకుపశ్చాత్తాపం చెందాలి. ప్రస్తుత తరం పాపాలు భవిష్యత్ తరాలకు సోకకుండా చూసుకోవాలి."
        }
      ],
      "title": "తల్లి దండ్రుల పాప పుణ్యాలు పిల్లలకు వస్తాయా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>హిందూ పద్ధతిలో వివాహ పద్ధతులు ఎన్ని? కులాంతర మతాంతర వివాహాలలో ఏది మంచిది?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "కులాంతర మతాంతర వివాహాలలో ఏదీ మంచిది కాదు. ఈ విషయం చెప్పుకొనే ముందు మన సంప్రదాయం లో వివాహ పద్ధతులు ఎన్ని విధాలు గా వున్నాయో పరిశీలిద్దాము. బ్రాహ్మీ, దైవ,ప్రజాపత్య, రాక్షస, అసుర, కన్యాశుల్కం, గాంధర్వ, పైశాచిక మని ఎనిమిది అయినా ఆర్యధర్మం ప్రకారం వివాహాల్లో నాలుగు రకాలు ప్రాచుర్యం లో వున్నాయి."
        },
        {
          "title": ""
        },
        {
          "title": "1. బ్రాహ్మీ వివాహం, 2. గాంధర్వ వివాహం 3. క్షాత్ర వివాహం 4. రాక్షస వివాహం. ఈ నాలుగు వివాహాల్లో 'బ్రాహ్మీ వివాహం' విశిష్టమైనది."
        },
        {
          "title": ""
        },
        {
          "title": "1. బ్రాహ్మీ వివాహం:- ఋషి సంప్రదాయ బద్ధమైన బ్రాహ్మీ వివాహం ఆర్య సమ్మతమైన వివాహం. వధూవరుల కుల పెద్దలు, తల్లిదండ్రులు అనుమతించి అంగీకరించి ఆశీర్వదించి వైదిక విధి తో ఆచార యుక్తం గా జరిపించేది బ్రాహ్మీ వివాహం. ఇది సనాతన జన సమ్మతం ! సత్సంప్రదాయం."
        },
        {
          "title": ""
        },
        {
          "title": "2. గాంధర్వ వివాహం:- యువతీ యువకులు ఇద్దరూ యుక్త వయస్సు గలవారైయుండి, ఒకరినొకరు ఇష్టపడి, పెద్దల అంగీకారం లేకుండా, తమంత తాము గా పారిపోయి రహస్యం గా వేరొకచోట వివాహం చేసుకొనడాన్ని గాంధర్వ వివాహం అంటాము. ఈ వివాహం బ్రాహ్మీ వివాహమంత గొప్పది, పవిత్రమైనది కాదు. శకుంతల దుష్యంతుని ఈ విధం గానే పెళ్ళాడి కష్టాల పాలైంది."
        },
        {
          "title": ""
        },
        {
          "title": "3. క్షాత్ర వివాహం:- కన్యామణి అంగీకారం లేకుండా కన్య తరపు వారి పెద్దల అనుమతి లేకుండా వరుడు తన శౌర్య సాహసాలను ప్రదర్శించి కన్యను బలాత్కారంగా ఎత్తుకెళ్ళి తన స్వజనుల సమక్షం లోవివాహం చేసుకోవడాన్నేక్షాత్ర వివాహం అంటారు. ఇది కేవలం క్షత్రియ కులం వారు క్షత్రియ కులం కన్యను మాత్రమే ఈ పద్ధతిలో చేసుకొనుటకు అవకాసం వుంది. ఇతర వర్ణాల వారికి ఈ అవకాశం లేదు."
        },
        {
          "title": ""
        },
        {
          "title": "4. రాక్షస వివాహం: - చతుర్విధ వివాహాల్లో ఇది నీచమైన వివాహం. ఈ వివాహానికి బ్రాహ్మణ, వైశ్య కులాల వారికి అనుమతి లేదు. ఎవరికీ తెలియకుండా, దొంగతనం గా మోసం తో, ఇష్టం లేని కన్యను అపహరించి తీసుకొనిపోయి బలవంతం గా వివాహం చేసుకోవటం రాక్షస వివాహం. శూద్ర, క్షత్రియ కులాల వారు మాత్రమే ఈ విధం గా వివాహం చేసుకోవటానికి అర్హులు.వారికి మాత్రమే ఈ రకమైన వివాహం చెల్లుబాటు అవుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "ఈ నాలుగు రకాల వివాహాలు ధర్మ సమ్మతమే అయినా పెద్దల అనుమతి తో జరిగే బ్రాహ్మీ వివాహం మాత్రమే పవిత్రమైనది."
        },
        {
          "title": ""
        },
        {
          "title": "ఇక కులాంతర, మతాంతర వివాహ విషయం పరిశీలిస్తే"
        },
        {
          "title": ""
        },
        {
          "title": "ఎవరి కులం లోని వారు వారి కులం లోని వారినే పెళ్లి చేసుకోవడం మంచిది. వారి వారి ఆచార వ్యవహారాలు ఇరువురికీ ఒకటే కాబట్టి ఇబ్బంది వుండదు. తప్పనిసరి పరిస్థుతులలో. భగవద్గీత లో చెప్పినట్లు. స్వధర్మేని దానం శ్రేయః పరధర్మో భయావః, ధర్మ భ్రష్టత కన్నా కుల భ్రష్టతే మంచిది. కులాంతర వివాహం చేసుకోవచ్చు.మతాంతర వివాహం చేసుకొన్న వారికి మోక్షం లేక పిశాచాల్లా తిరుగుతూ ఉంటారని పెద్దల ఉవాచ."
        },
        {
          "title": ""
        },
        {
          "title": "అంతే కాక ఒక మతం వారి ఆచార వ్యవహారాలూ, కట్టుబాట్లు వేరొక మతం వారికి మింగుడు పడవు. విచ్చిన్న మవుతున్న వివాహాల్లో అనేకం. మతాంతర మరియు కులాంతర వివాహాలే."
        }
      ],
      "title": "హిందూ పద్ధతిలో వివాహ పద్ధతులు ఎన్ని? కులాంతర మతాంతర వివాహాలలో ఏది మంచిది?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>మన తెలుగు సంవత్సరాలు 60 మాత్రమే ఉండడం లోని అంతరార్ధం ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "మన తెలుగు సంవత్సరాలు ప్రభవ తో మొదలు అయి అక్షయ తో అంతమయి మరల ప్రభవ తో మొదలవుతుంది (1. ప్రభవ, 2. విభవ, 3. శుక్ల, 4. ప్రమోదూత, 5. ప్రజోత్పత్తి, 6. ఆంగీరస, 7. శ్రీముఖ, 8. భవ, 9. యువ, 10. ధాత, 11. ఈశ్వర, 12. బహుధాన్య, 13. ప్రమాథి, 14. విక్రయ, 15. వృక్ష, 16. చిత్రభాను, 17. స్వభాను, 18. తారణ, 19. పార్థివ, 20. వ్యయ, 21. సర్వజిత్, 22. సర్వధారి, 23. విరోధి, 24. వికృతి, 25. ఖర, 26. నందన, 27. విజయ, 28. జయ, 29. మన్మథ, 30. దుర్ముఖి, 31. హేవలంభి, 32. విలంబి, 33. వికారి, 34. శార్వరి, 35. ప్లవ, 36. శుభకృత్, 37. శోభకృత్, 38. క్రోధి, 39. విశ్వావసు, 40. పరాభవ, 41. ప్లవంగ, 42. కీలక, 43. సౌమ్య, 44. సాధారణ, 45. విరోధికృత్, 46. పరీధావి, 47. ప్రమాదీచ, 48. ఆనంద, 49. రాక్షస, 50. నల, 51. పింగళ, 52. కాళయుక్త, 53. సిద్ధార్థి, 54. రౌద్రి, 55. దుర్మతి, 56. దుందుబి, 57. రుధిరోద్గారి, 58. రక్తాక్షి, 59. క్రోధన, 60. అక్షయ.) ఈ విధంగా మొదలు అవడం వెనుక రక రకాల కధలు ప్రచారం లో వున్నాయి. అయితే హేతు బద్ధం గా ఆలోచిస్తే"
        },
        {
          "title": ""
        },
        {
          "title": "అరవై సంవత్సరాలకొకసారి మనో ధర్మాలతో పాటుగా మానవ ధర్మాలు మార్పు చెందుతూ వుంటాయి. బుద్ది శక్తి కూడా మనకు అరవై సంవత్సరాల వరకు మాత్రమే చురుగ్గా వుంటుంది. అరవై తరువాత క్రమం గా జ్ఞాపక శక్తి క్షీణించి పోతుంది. శరీరం లోని అవయవాలు అలసట చెంది శరీరం పని మందగిస్తుంది. అరవై సంవత్సరాల లోపల మృత్యువు ఒకసారి తన ప్రభావం చూపిస్తుందట. అంటే ఏదో రకం గా ప్రాణ గండం దగ్గరగా వచ్చి పోతుందన్నమాట!. అరవై తరువాత ప్రతి 10 సంవత్సరాలకు ఒక సారి మృత్యువు ఒకసారి పలకరించి పోతూ వుంటుంది అని చెబుతారు."
        },
        {
          "title": ""
        },
        {
          "title": "అందుకే అరవై సంవత్సరాలకు షష్టి పూర్తి చేస్తారు.ప్రభవ 'నామ' సంవత్సరం తో ప్రారంభమై 'అక్షయ నామ' సంవత్సరం తో అరవై సంవత్సరాలు ముగిసి మరల 'ప్రభవ' ప్రారంభమై నట్లుగానే మనిషి కి 60 పూర్తి అయిన తరువాత 'బాల్యావస్థ' మొదలవుతుంది. అంటే చిన్న పిల్లల్లా ప్రవర్తిస్తూ వుంటారు. అకారణం గా అలగడం, అవీ ఇవీ తినాలని అడగడం. చిరుతిళ్ళ కోసం చిరు దొంగతనాలు చేయడం చిన్న పిల్లల లాగ, ఎక్కువ సేపు నిదుర పోవడం, చిన్న విషయాలకే ఆనంద పడడం, కోపం తెచ్చు కోవడం. ఈ విధం గా పిల్లలు ఎలా చేస్తారో అలాగే పెద్దలు కూడా చేస్తారు అని చెబుతుంటారు. అరవై తరువాత తన బిడ్డకు తనే బిడ్డ అయి పోతారు తల్లి దండ్రులు. అందుకే అరవై సంవత్సరాలు నిండిన తల్లి దండ్రులను తన బిడ్డల తో సమానం గా చూసుకోవాలని చెబుతుంది ధర్మ శాస్త్రం."
        },
        {
          "title": ""
        },
        {
          "title": "ఆరు పదుల జీవితాన్ని ఎవరైతే ఆనందం గా గడుపుతారో వారి జీవితం ధన్యమనే చెప్పా వచ్చు. ఆ ధన్య జీవితపు జ్ఞాపకార్ధమే. బిడ్డలు, మనవళ్ళు, బంధు మిత్రులు కలసి షష్టి పూర్తి ఉత్సవం గా పండగ లా చేయడం. మన తెలుగు సంవత్సారాలు అరవై వరకు మాత్రమే వుండడం లో అంతరార్ధ మిదే. వార్ధక్యం లో స్త్రీ వ్యామోహం, అధికార దాహం వదలి వేయాలి. కుటుంబ భాద్యతను కొడుక్కి అప్పగించాలి. మంత్రి గా మాత్రమె సలహాలు ఇవ్వాలి. మనస్సు ను దైవ కార్యాల వైపు మళ్ళించాలి. తీర్ధ యాత్రలు చేయాలి. చాతనయినంతలో దాన ధర్మాలు చేయాలి."
        }
      ],
      "title": "మన తెలుగు సంవత్సరాలు 60 మాత్రమే ఉండడం లోని అంతరార్ధం ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>రుద్రాక్షల మహిమ ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "రుద్రాక్షలను తెలిసి ధరించినా తెలియక ధరించినా రుద్రాక్షల మహత్యం అనుభవం లోనికి వస్తుంది. తప్పుడు మార్గాన నడిచేవారు, సత్ప్రవర్తన లేనివారు, దురాచార మనస్కులు రుద్రాక్షలు ధరిస్తే పరివర్తన చెంది సన్మార్గులు అవుతారని భారతీయుల విశ్వాసం. స్కంద పురాణం కూడా ఇదే చెబుతుంది. రుద్రాక్షలు ధరించడానికి ముహూర్తాలు చూడనవసరం లేదు. మంచి మనస్సు తో ధరించాలనుకున్నప్పుడు దరించ వచ్చు."
        },
        {
          "title": ""
        },
        {
          "title": "పవిత్ర రుద్రాక్షలు స్త్రీ పురుషులు ఎవరైనా ధరించవచ్చు. రుద్రాక్షకు ఐదు ముఖాలు, మూడు ముఖాలు ఆరు, ఏడు ముఖాలు ఇలా రక రకాలుగా వుంటాయి. ఏ రుద్రాక్ష మహిమ అయినా ఒకటే ముఖాన్ని బట్టి దాని మహిమలో అంతరాలు వుండవు.మనకు లభించే రక రకాల రుద్రాక్షలు హస్త నైపుణ్యం తో చెక్కినవే. రుద్రాక్షలను వుంగరాలలొ ధరించకూడదు. రుద్రాక్ష మాల ధరించి సంగమించ కూడదు. బహిస్టులు ఆగిన స్త్రీలు మాత్రమె రుద్రాక్షలు ధరించాలి. ఒకరి రుద్రాక్షలు వేరొకరు ధరించరాదు."
        }
      ],
      "title": "రుద్రాక్షల మహిమ ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>దుర్గా దేవి ని శాకంబరి దేవి గా పూజించడం లో అంతరార్ధం ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "వేద కాలం లో దుర్గముడు అనే రాక్షసుడు బ్రహ్మ గురించి తపస్సు చేసి ' అందరూ వేదాలను మర్చి పోవాలి, వేద గానం చేయకూడదు'.అని వరం పొందాడు. ఫలితం గా దేవ, బ్రాహ్మణ గణాల వారికి వేదాలు గుర్తు రాక యజ్ఞ యాగాదులు అన్ని నిలిచి పోయాయి. దేవతలకు హవిస్సు అందక శక్తి హీనులైపోయారు. నదీ నదాలు ఎండి పోయాయి. వర్షాలు లేక వృక్ష జాతి నశించింది. ఋషులు, దేవతలు సర్వ శక్తి స్వరూపిణి అయిన పార్వతి మాతను ప్రార్ధించారు. అప్పుడు ఆ మహా మాత ప్రత్యక్షమై ఆకలితో అలమటిస్తున్న రుషులచేత శక్తి మంతమైన శాకాలను (ఆకు కూరలను) తినిపించింది. ఆ శాకాలను తిన్న ఋషులకు మంచి శక్తి లభించింది. అందరూ పార్వతి శక్తి ని ' శాకంబరి దేవి' గా స్తుతించారు. ఆనాటి నుండి సాత్వికాహారానికి శాకాహారమని పేరు వచ్చింది. ( గోంగూర, తోటకూర, పాలకూర, బచ్చలి కూర, మెంతి కూర మొదలైనవన్నీ శాకంబరి దేవి ప్రసాదమే)."
        },
        {
          "title": ""
        },
        {
          "title": "తరువాత దుర్గ, తన నుండి ఉద్భవించిన కాళిక, భైరవి, శాంభవి, త్రిపుర మొదలైన 32 శక్తులతో దుర్గమునితో, రాక్షస సైన్యాలతో తొమ్మిది రోజుల పాటు యుద్ధం చేసి చివరకు దుర్గముని సంహరించింది. దేవతలు, బ్రాహ్మణులు తిరిగి వేదములను మననం చేసుకున్నారు. నవరాత్రులలో దుర్గను వివిధ రూపాలతో పాటు శాకంబరి దేవిగా కూడా అలంకరిస్తారు."
        }
      ],
      "title": "దుర్గా దేవి ని శాకంబరి దేవి గా పూజించడం లో అంతరార్ధం ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>నవ రాత్రుల విశిష్టత ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "మహర్షులు, మునులు, యతులు, వాస్తు నిపుణులు, ఖగోళ శాస్త్రజ్ఞులు, ఆగమ శాస్త్ర పండితులు, వైదికాచార్యులు 'తొమ్మిది' ని దైవ సంఖ్య గాను, బ్రహ్మ సంఖ్యగాను గుర్తించారు."
        },
        {
          "title": ""
        },
        {
          "title": "చైత్రమాసం లో వసంత నవరాత్రులు, భాద్రపదమాసం లో గణపతి నవరాత్రులు, ఆశ్వయుజ మాసం లో దేవి నవరాత్రులు, తిరుమల వేంకటేశ్వరుని బ్రహ్మోత్సవాలు. తొమ్మిది రోజుల పాటు ఘనంగా నిర్వహిస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "భాద్రపద, ఆశ్వయుజ మాసాలలో ఆచరించే నవరాత్రులు శ్రేయోదాయకమైనవి. ఎందుకంటే క్రొత్త నీటితో నదీనదాలు ఎంతో కొంత కల్మష పూరితం గా ఉంటాయి. అనారోగ్యాన్ని, ఉదార సంబంధ సమస్యలను కలిగిస్తాయి.ఈ మాసం లో దేహ శ్రమ తక్కువగాను, ఆకలి ఎక్కువగాను వుంటుంది. కాయ గూరలు ద్వార కంటికి కనబడని క్రిములు కడుపు లోనికి వెళ్లి అనారోగ్య సమస్యలు కల్గిస్తాయి. గణపతి నవరాత్రులు, దేవి నవరాత్రులు దగ్గర దగ్గర గా వస్తాయి. ఈ రోజుల్లో రాత్రి సమయాలలో పూజ తరువాత ఉపవాసం వుండడం మంచిది అని చెబుతారు. మరునాటికి శరీరం కొత్త శక్తిని పుంజుకుంటుంది. దేహ దండన వల్ల తమో శక్తి హరించి దివ్య తేజస్సు నరనరాలకు ప్రాకి ఆయుర్వృద్ధి కలుగుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "శ్రావణ, భాద్రపద, ఆశ్వయుజ, కార్తీక మాసాలలో ఎక్కువగా వ్రతాలు , పూజలు, ఉపవాసాలు ఏర్పరచడం లోని ఉద్దేశ్యం ఇదే. సంతానవతులు కాగోరు మగువలు ఈ నాలుగు మాసాలలో నియమం పాటించడం మంచిది అని చెబుతున్నారు మన మహర్షులు తద్వారా ఎండలు మెండుగా వుండే వైశాఖ మాసం లో కాన్పులు నివారించ వచ్చునని వారి ఆలోచన."
        },
        {
          "title": ""
        },
        {
          "title": "మార్గశిర మాసానికి మనిషి బలంగా స్థిరం గా ఉంటాడు. మార్గ శిర మాసాన్ని విష్ణువు కి ఇష్టమైన మాసం గా చెబుతారు."
        }
      ],
      "title": "నవ రాత్రుల విశిష్టత ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>ఇంటికి సున్నం ఎందుకు వేస్తారు?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "మనిషికి చర్మం, ఇంటికి సున్నం వుండకపోతే కుదరవు. చర్మం రక్త మాంసాలకు కవచం గా వుంది ఎలా రక్షిస్తుందో, సున్నం కూడా గృహానికి రక్షణా కవచం లాగ వుంది రక్షిస్తుంది. గృహ నిర్మాణ రంగంలోకి సిమెంట్ రాక పూర్వం మహారాజుల మందిరాలు, దేవాలయాలు రుబ్బుడు సున్నం తో నిర్మించే వారు. తాజ్ మహల్,కుతుబ్ మీనార్, చార్మినార్, శ్రీరంగ నాధ దేవాలయం, కాశి విశ్వేశ్వరాలయం, స్వర్ణ మందిరం మొదలైన చారిత్రిక కట్టడాలన్నీ సున్నం తోనే నిర్మించారు. పూర్వ కాలం నాటి ఆన కట్టలు, వంతెనలు సున్నం తోనే కట్టినవి ఇప్పటికీ మూగ సాక్ష్యాలుగా నిలిచి ఉన్నాయి. సున్నానికి వున్న ఆయుర్దాయం లో ఐదవ వంతు మాత్రమే సిమెంట్ కి వుంది."
        },
        {
          "title": ""
        },
        {
          "title": "ఇండ్లకి పండుగ, పర్వదినాలలో సున్నం ఎందుకు వేయాలి అంటే :"
        },
        {
          "title": ""
        },
        {
          "title": "ఇటుకల ఇంటికైనా, మట్టి ఇంటి కైనా, రాతి కట్టడానికైనా బట్టీ సున్నం వేయడం ఎంతో మంచిది. శుభ ప్రదం మరియు ఆరోగ్య ప్రదం.ఇంటి లోపల బయట క్రమం తప్పకుండా ప్రతి సంవత్సరం సున్నం వేసుకుంటే. వేసవి వీడిమి నుండి రక్షణ లభిస్తుంది. అలాగే శీతా కాలపు అతి చల్లదనాన్ని కూడా లోనికి రానీయదు. సున్నం వేయడం వలన గదుల లోని వెలుతురు రెట్టింపు అవుతుంది. తెల్ల సున్నం మనసుకి ఎంతో ప్రశాంతతని ఇస్తుంది. అలాగే హానికారక సుక్ష్మ క్రిములు ఇంట్లోకి రావు.సున్నం వేసిన ఇంట్లో లక్ష్మి, సరస్వతులు ఇద్దరూ వుంటారు.ఇంట్లోని వారు ప్రశాంత జీవితం గడుపుతారు. అభివృద్ది కలుగుతుంది. సున్నం వేయని ఇంట్లో గృహ ప్రవేశం చేయరాదు. ఇంట్లో పెళ్లి, ఉపనయనం వంటి శుభ కార్యక్రమాలు తలపెట్టినప్పుడు సున్నం తప్పని సరిగా వేయాలి. అలాగే ఆ ఇంట్లో మన ఆప్తుల మరణం సంభవించి సంవత్సరం పూర్తి అయినప్పుడు సున్నం తప్పనిసరిగా వేయాలి. ప్రస్తుతం మనకు మన పూర్వీకులు వాడే సున్నం లభించుట లేదు. రక రకాల రంగులు ఎవరికి ఇష్టం వచ్చినవి వారు వేసుకుంటున్నారు. సున్నం వేయడం లోని శాస్త్రీయతను గుర్తించడం లేదు."
        }
      ],
      "title": "ఇంటికి సున్నం ఎందుకు వేస్తారు?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>భోజనం మౌనం గా చేయాలా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "ఆహారం తినే సమయంలో మాటల్లో పడితే ఎంత తింటున్నామో తెలియదు. మాటల వల్ల పోలమారడం జరిగి మనకు అసౌకర్యం కలగవచ్చు. ఎక్కువగా తిన్న ఆహారం శక్తిని కల్గించదు. టీవీ చూస్తూనో, న్యూస్ పేపర్ చదువుతూనో, కబుర్లు చెబుతూ తింటే ఆహారం రుచి తెలియదు. భోజనం చేసే సమయం లో ఏమైనా వాదులాటలు జరిగి ఇతరులతో గొడవలు పడితే భోజనానికి అర్ధాంతర ముగింపు జరగవచ్చు. ఇంటిలోని వారందరూ ఒక్కోసారి ఈ గొడవతో అర్ధాకలితో పడుకోవాల్సి రావచ్చు."
        },
        {
          "title": ""
        },
        {
          "title": "భోజనం మౌనం గా ఎందుకు చేయాలంటే, ప్రశాంతం గా భుజించే ఆహారమే శక్తి ని కల్గించి అమృతం గా మారుతుంది. నర నరాలకూ పుష్టి నిస్తుంది. మనం రోజుకి లక్ష రూపాయలు సంపాదించినా నాలుగు ముద్దల అన్నం కోసమే కదా!. ఇంతటి ముఖ్య అవసరాన్ని ఆదుర్దాగా ముగించడం మంచిది కాదు."
        }
      ],
      "title": "భోజనం మౌనం గా చేయాలా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>తల్లిదండ్రులది వేరు వేరు కులాలైతే బిడ్డలకు ఏ కులం వస్తుంది?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "హిందూ మతం లో పితృ స్వామ్యం కు ఉన్న ప్రాధాన్యత మాతృ స్వామ్యానికి లేదు. ఒకప్పుడు ఉన్నా ఇప్పుడు లేదు. భార్య భర్తలు వేరు వేరు కులాలకు చెందిన వారు అయినప్పుడు వారికి జన్మించిన సంతానానికి తండ్రి కులం మాత్రమే వస్తుంది. తన వీర్యం ద్వారా కాక వేరే వ్యక్తుల వీర్యం ద్వార (కృత్రిమ గర్భ ధారణ పద్ధతుల ద్వారా) తన భార్య గర్భం ధరించి సంతానం కన్నప్పుడు కూడా ఆ బిడ్డకు భర్త కులమే వస్తుంది అని ధర్మ శాస్త్రం చెబుతూంది."
        },
        {
          "title": ""
        },
        {
          "title": "అయితే ఒప్పందం ప్రకారం సంతానం కన్నప్పుడు తల్లి కులం మాత్రమే సంతానానికి వస్తుంది. ఇందుకు ఉదాహరణగా ధృత రాష్ట్రుడు, పాండు రాజులను చెప్పుకోవచ్చు. వీరు ఇద్దరూ నియోగ ధర్మం ప్రకారం వ్యాసుని వల్ల అంబిక, అంబాలికలకు జన్మించారు. వీరిరువిరినీ 'క్షేత్రజ్ఞులు' అంటారు. కన్య గా కుంతి కన్న కర్ణుని 'సహోఢుడు' అని అంటారు. పాండవులు నియోగ ధర్మం తో కుంతీ దేవికీ, మాద్రి దేవి కీ పుట్టారు. పాండు రాజు వల్ల జన్మించ కున్నా పాండవులే అయ్యారు."
        },
        {
          "title": ""
        },
        {
          "title": "నైష్టిక బ్రహ్మర్షి అయిన వశిష్ఠ మహర్షి దేవ వేశ్య ఊర్వశి కి పుట్టాడు. అంత మాత్రాన తల్లి కులం వశిష్టునికి సంక్రమించలేదు. ద్రౌపదీ దేవి ద్రుపద దంపతులకు పుట్టలేదు. యజ్ఞ గుండం నుండి జన్మించింది, అయినా ద్రుపదుని కూతురే అయ్యింది. సీత కూడా జనక రాజు కి భూమి లో దొరికింది.అయినా జనక పుత్రి గానే కీర్తి పొందింది. ప్రధానం గా తండ్రి కులమే బిడ్డలకు సంక్రమింప చేయడానికి ప్రధాన కారణం వంశం నిలపాలనే ఆరాటమే."
        }
      ],
      "title": "తల్లిదండ్రులది వేరు వేరు కులాలైతే బిడ్డలకు ఏ కులం వస్తుంది?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>దేవునికి కొబ్బరి కాయనే ఎందుకు కొట్టాలి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "బుద్ది వికాసానికి కొబ్బరి దివ్యామృతం గా పని చేస్తుంది. ఏదో విధం గా ప్రతి రోజు కొబ్బరిని తినే వారికి తెలివితేటలు, చాకచక్యము వస్తాయి. జ్ఞాపక శక్తి వేగవంతం గా ఉంటుంది. ఈ కారణం చేతనే దీని నూనె ను తలకు రాసుకుంటాము. ఈ కొబ్బరి నూనెకు నేతిలో ఉన్నంత శక్తి పదార్ధాలు వుండటం వల్లనే చలికాలం లో నేతి మాదిరి గానే పేరుకొని పోతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "గుడినిండా నీళ్ళు గుడికి తాళం' అనే పొడుపు కధకు మనకు వెంటనే స్ఫురించే సమాధానం కొబ్బరి కాయ. కొబ్బరి ఎలాంటి నేలలోనైనా పెరుగుతుంది. ఏ ఋతువు లోనైనా ఫల సాయం అందిస్తుంది. ఆహారానికీ ఔషధానికీ పనికి వచ్చే కాయ ఇది. ఆకు నుండి పీచు వరకు అన్ని భాగాలు ఉపయోగిస్తాయి."
        },
        {
          "title": ""
        },
        {
          "title": "అయితే కొబ్బరి కాయనే కొట్టాలని వేదం లో ఎక్కడా చెప్పలేదు. తదనంతర కాలం లో కొబ్బరి కాయ ఉపయోగం తెలిసిన మన ఋషులు అన్ని కాలాలలోనూ లభించే కొబ్బరి కాయ విశిష్టత గుర్తించి కొబ్బరి కాయను పూర్ణ ఫలం అని అన్నారు. దేవాలయాలలో దేవునికి సమర్పించాలి అనే నియమం ఏర్పరిచారు. కొబ్బరి కాయ సగ భాగం భక్తులకు ప్రసాదంగా పంచేవారు. ఈ రోజుల్లో కొబ్బరి కాయ సగ భాగాన్ని వేలం పాటదారు పట్టుకొని పోతున్నాడు. ఇది సరి అయిన పద్ధతి కాదు. వివాహాది శుభ కార్యక్రమాలు, శ్రీరామనవమి, వినాయకచవితి పందిళ్ళు. ఇలా అన్ని శుభ కార్య క్రమాలలోని కొబ్బరి మట్ట, ఆకు లతో వేసే పందిళ్ళు ఎంతో శోభాయమానం గా ఉండి ఎంతో చల్లదనాన్ని ఇస్తాయి."
        }
      ],
      "title": "దేవునికి కొబ్బరి కాయనే ఎందుకు కొట్టాలి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>కుమారుని తండ్రి ఏవిదం గా పెంచాలి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "పుత్రోత్సాహము తండ్రికి"
        },
        {
          "title": "పుత్రుడు జన్మించినపుడు పుట్టదు, జనులా"
        },
        {
          "title": "పుత్రుని కనుగొని పొగడగ"
        },
        {
          "title": "పుత్రోత్సాహంబు నాడు పొందును సుమతీ!"
        },
        {
          "title": ""
        },
        {
          "title": "అందరికీ తెలిసిన ఈ పద్యం తాత్పర్యం ప్రత్యేకించి చెప్పనక్కర్లేదు. తన సంతానం ని ఏ రోజైతే లోకమంతా మెచ్చు కుంటుందో ఆనాడే తండ్రికి నిజమైన పుత్రోత్సాహము. అంతే తప్ప ఫలానా వారి అబ్బాయి చేసిన వేధింపుల వల్ల ఒక అమ్మాయి అశువులు బాసింది. ఫలానా వారి అబ్బాయి దుర్మార్గుడు. అనే మాటల వల్ల పుత్రోత్సాహము కలుగదు."
        },
        {
          "title": ""
        },
        {
          "title": "అయితే కొడుకుల పట్ల తండ్రి ఎలా మసలుకోవాలి అని తెలుసుకోనేముందు ఎలా మసలుకో కూడదో మన పురాణాలలోని తండ్రి పాత్రలను ఒకసారి అవలోకించాలి. మహా భారతం లోని కొన్ని తండ్రి పాత్రలను (ధృత రాష్ట్రుడు, ద్రోణుడు, శంతనుడు మొదలైన వారు) పరిశీలిస్తే చిత్ర విచిత్రం గా అనిపిస్తాయి. తన పుత్రుడైన దుర్యోధనుణ్ణి నిజంగా త్రోవలో పెట్టుకున్నట్లైతే ధృత రాష్ట్రునికి వంశ నాశనం అయిందనే దు:ఖం, పుత్రశోకం కలిగిందనే చింతా, అపకీర్తి ఉండేవే కావు. పుత్ర వ్యామోహం పొరలు కమ్మి ధృత రాష్ట్రుడు వివిధ సందర్భాలలో దుర్యోధనుడు చేసిన చెడ్డ పనులును తెలిసి తెలిసీ సమర్ధించాడే తప్ప దుర్యోధనుణ్ణి అదుపు ఆజ్ఞ లలో పెట్టలేదు."
        },
        {
          "title": ""
        },
        {
          "title": "(కొడుకులు తెలిసి తెలిసీ తప్పులు చేస్తున్నప్పుడు తండ్రులు గమనించి నయానో భయానో అదుపు ఆజ్ఞ ల లో పెట్టాలి) తాను, తన ఉద్యోగం తప్ప కొడుకు అశ్వద్ధామ బాగోగులు ఏనాడు పట్టించుకోలేదు ద్రోణాచార్యుడు. పైగా అర్జునుణ్ణి మంచి విలుకాడిగా తయారుచేస్తాను. అని అన్నాడే తప్ప కొడుకు విద్య గురించి పట్టించు కోలేదు. దీనితో దుర్యోధనుడితో స్నేహం చేసి చరిత్ర భ్రష్టుడు అయ్యాడు. పండిత పుత్రః పరమ శుంఠ: - అనే నానుడి అశ్వథ్థామ ను ఉద్దేశించి పుట్టింది. (నిరంతరం ఉద్యోగం అభివృద్ది జీత భత్యాలు అనే కాకుండా కొడుకు ఎలా చదువుతున్నాడు. అతని ప్రవర్తన ఎలా ఉంది అనే విషయాలు గమనిస్తూ ఉండాలి.)"
        },
        {
          "title": ""
        },
        {
          "title": "భీష్ముని తండ్రి శంతనుడు. ఎదిగిన కొడుకు పెళ్ళికి ఉండగా అతని పెళ్లి గురించి ఆలోచించటం మాని. మళ్ళీ పెళ్ళికి తయారయ్యాడు దాశరాజు కూతురు సత్యవతితో దాశరాజు కోరిక మేరకు 'జీవితం లో పెళ్లి చేసుకోనని' భీషణ ప్రతిజ్ఞ చేసి 'భీష్ముడు' అయ్యాడు దేవవ్రతుడు. ( ఎదిగిన కొడుకు ఇంట్లో ఉన్నప్పుడు అతని విద్య, ఉద్యోగం, ఉపాధి, వివాహం గురించి ఆలోచన చెయ్యాలే తప్ప తన గురించి ఆలోచించకూడదు.)"
        },
        {
          "title": ""
        },
        {
          "title": "కర్ణుని తండ్రి సూర్యుడు కుంతి కి పుత్రుని అయితే ఇచ్చాడు కాని కన్న ప్రేమ అందించ లేక పోయాడు. ఫలితం గా పెంపుడు తండ్రి పంచన చేరి ఆ పై దుర్యోధనుని చేరి దుష్ట సహవాసం చేసాడు కర్ణుడు. ( సాధ్యమైనంత వరకు పిల్లలకు తండ్రి ప్రేమ పంచాలి. పరాయి వారి పంచన చేర్చి చదివించ రాదు. ఒక వేల చదివించ వలసి వచ్చినప్పుడు తరచు వెళ్లి పిల్లల బాగోగులు చూస్తూ ఉండాలి.)"
        },
        {
          "title": ""
        },
        {
          "title": "విడాకులు తీసుకొన్న దంపతులు అయితే పట్టుదలకు పోకుండా ఇరువురి ప్రేమాను రాగాలను పిల్లలకు సమానం గా పంచాలి. మధ్యలో అభం శుభం తెలియని పిల్లలను మానసికంగా ఇబ్బంది పెట్టకూడదు."
        }
      ],
      "title": "కుమారుని తండ్రి ఏవిదం గా పెంచాలి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>బ్రహ్మ ముహూర్తం (బ్రాహ్మీ ముహూర్తం) అంటే ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "బ్రహ్మ ముహూర్తం లో ఏ పని అయినా ప్రారంభించ వచ్చు. ఆ సమయం లో తిధి, వార, నక్షత్ర, దుర్ముహూర్త ములను పట్టించు కోవలసిన పని లేదు. ఇంటిలోకి ఒక క్రొత్త వస్తువు (టీవీ, ఫ్రిజ్, వాషింగ్ మెషిన్ ఇలాంటివి) కొన్న తరువాత వాటిని బ్రహ్మ ముహూర్తం లో వాడడం మొదలు పెట్టవచ్చు."
        },
        {
          "title": ""
        },
        {
          "title": "ఒక పనిని ప్రారంభించడానికి నిర్ణయించుకున్న సమయాన్ని ముహుర్తం అంటారు. ఒక పని ఎటువంటి ఆటంకాలు లేకుండా సజావుగా జరగడానికి నిర్ణయించుకున్న మూహుర్తాన్ని మంచి ముహుర్తం అంటారు. ప్రతిరోజు సూర్యోదయానికి ముందు కాలాన్ని అనగా తెల్లవారుజామును మంచి ముహుర్తం అంటారు. అందువలనే తెల్లవారుజామున ప్రారంభించిన పని ఏటువంటి ఆటంకాలు లేకుండా సజావుగా సాగుతాయంటారు. తెల్లవారుజామును రెండు భాగాలుగా విభజించారు. సూర్యోదయమునకు రెండు ఘడియల ముందు కాలాన్ని అనగా 48 నిమిషముల ముందు కాలాన్ని ఆసురీ ముహూర్తం అని ఆసురీ ముహుర్తానికి ముందు 48 నిమిషముల ముందు కాలాన్ని బ్రహ్మ ముహూర్తం అని అంటారు. ప్రతిరోజు బ్రహ్మముహుర్తమున లేచి భగవంతుని ధ్యానించి పనులు ప్రారంభించవలెనని అంటారు. బ్రహ్మ మూహూర్తానికి ఉన్న అత్యధిక ప్రాధాన్యత దృష్ట్యా అనేకమంది నూతన గృహప్రవేశంనకు ఈ సమయాన్ని ఎన్నుకుంటారు. ఈ సమయంనందే మానవుని మేథాశక్తికి భగవంతుని శక్తి తోడవుతుంది. మనం ఉన్న వూరు ను బట్టి సూర్యోదయం, సూర్యాస్తమయం మారుతూ ఉంటాయి. ఒక ఉదాహరణ చూద్దాం"
        },
        {
          "title": ""
        },
        {
          "title": "ఆగష్టు 22న సూర్యోదయం 5.28 ఉదయం. అనుకొంటే"
        },
        {
          "title": "సూర్యోదయానికి 48 నిమిషాల ముందు వరకు అసుర ముహూర్తం అంటే ఉదయం 4.40 నుండి 5.28 ఉదయం వరకు ఉంటుంది. అదే రోజు బ్రహ్మ ముహూర్తం ఉదయం 3.52 నుండి ఉదయం 4.40 వరకు ఉంటుంది."
        }
      ],
      "title": "బ్రహ్మ ముహూర్తం (బ్రాహ్మీ ముహూర్తం) అంటే ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>పాలను తొక్కితే పాపమా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "ఏకారణం చేతైనా గచ్చు మీద ఒలికిన పాలను పిల్లలు తెలిసో తెలియకో తొక్కితే పెద్దవాళ్ళు పిల్లలలను పాలను త్రొక్క కూడదు పాపం అని మందలిస్తారు. మహాలక్ష్మి క్షీర సముద్రం లో పుట్టింది. పాలు లక్ష్మీ దేవి స్థానం అని పెద్దలు చెబుతారు. పాలు తాగిన వెంటనే శక్తి వస్తుంది. పాలను సంపూర్ణ ఆహరం అన్నారు. పాలు అమృతం తో సమానం. ఏ కారణం చేతనైనా పాలు, పాల పదార్ధాలైన పెరుగు,వెన్న,నెయ్యి వృధా చేయటం పాపం అని మన పెద్దలు అన్నారు."
        },
        {
          "title": ""
        },
        {
          "title": "మన జీవన వున్నతి కి కారణమైన క్షీరదాలైన ఆవు, గేదె, మేక, గుర్రం, ఒంటె తదితర పాలను ఇచ్చే జంతువులను చేతితో అదలించాలె తప్ప కొట్టరాదు. గ్లాసు నిండా పాలు ఇచ్చే ఏ మాతృ మూర్తి అయినా స్వంత తల్లితో సమానమన్నారు. పాలు సమృద్ధిగా వున్న ఇంటి పరిసరాల్లోకి శనీశ్వరుడు రాడు అని చెబుతారు. దేవతా విగ్రహాలకు క్షీరాభిషేకం చేసిన తరువాత ఆ పాలను ఉపయోగించుకోవాలే తప్ప వృధాగా పోనీయరాదు."
        }
      ],
      "title": "పాలను తొక్కితే పాపమా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>గర్భవతులు పుష్కర స్నానం చేయవచ్చా?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "మూడు నెలలు దాటిన తరువాత గర్భిణి స్త్రీలు జాగ్రత్త గా వుండాలని చెబుతారు. గర్భస్థ పిండానికి అసౌకర్యం కలిగేల కదలికలు వుండకూడదు. ఎక్కువగా విశ్రాంతి తీసుకోవాలి. కాబట్టి గర్భిణీ స్త్రీలు, చన్నీటి స్నానం, నదీ స్నానం, పుష్కర స్నానం చేయకూడదు అని చెబుతారు. పుష్కరాలలో జన సంచారం అధికంగా వుంటుంది. సాధారణ ప్రజానీకమే చాల ఇబ్బందులు పడవలసి వస్తుంది. మెట్లు ఎక్కడం దిగడం శ్రమ తో కూడుకొన్నది. అలాంటిది. గర్భిణీ స్త్రీలు మరింత శ్రమ పడవలసి వస్తుంది. ఎక్కువమంది దృష్టి గర్భిణీ స్త్రీలపై పడి దిష్టి తగల వచ్చు. నదీ స్నానం, పుష్కర స్నానం చేయడం లో కదలికల వల్ల గర్భస్థ శిశువు కు అసౌకర్యంగా వుండి ఏదైనా జరగకూడనిది జరుగుతుందేమో. అనే ముందు జాగ్రత్త గా పెద్దలు అలా చెబుతారు."
        },
        {
          "title": ""
        },
        {
          "title": "అలాగే ఎటువంటి ఫల దానాలు చేయరాదు, భర్త కొబ్బరి కాయ కొట్టరాదు అని కూడా చెబుతారు. ఫలం దానం చేయడం అంటే 'గర్భస్థ ఫలం' దానం చేయడం తో సమానమని అలా అంటారు. అలాగే భర్త కొబ్బరి కాయ కొట్టరాదు. అని అనడం వెనుక. కొబ్బరి కాయ ను కొట్టడం బలి ఇవ్వడం తో సమానమని అలా అన్నారు. అలాగే భార్య పక్కన లేకుండా భర్త స్నానం చేయరాదు అని చెప్పారు కాబట్టి గర్భవతి భర్త పుష్కర స్నానం చేయరాదు అని చెబుతారు. కాబట్టి పుష్కర స్నానం చేయడానికి వీలు లేని వారు (వృద్ధులు, పిల్లలు, గర్భిణీ స్త్రీలు, ఇతరులు ) గోదావరి నీరు తెప్పించుకొని చక్కగా ఇంటిలో సంకల్పం చెప్పుకొని స్నానం చేయండి. పుష్కర ఫలాన్ని పొందండి. బహిష్టు స్త్రీలు, (ఆ అనుమానం వున్నవారు) నదీ స్నానం, పుష్కర స్నానం చేయరాదు."
        }
      ],
      "title": "గర్భవతులు పుష్కర స్నానం చేయవచ్చా?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>అష్టదరిద్రాలు అంటే ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "లింగాష్టకం లో"
        },
        {
          "title": "బ్రహ్మమురారిసురార్చితలింగం నిర్మలభాసితశోభితలింగం |"
        },
        {
          "title": "జన్మజదుఃఖవినాశకలింగం తత్ప్రణమామి సదాశివలింగం ||"
        },
        {
          "title": ""
        },
        {
          "title": "అష్టదళోపరివేష్టితలింగం సర్వసముద్భవకారణలింగం |"
        },
        {
          "title": "అష్టదరిద్రవినాశకలింగం తత్ప్రణమామి సదాశివ లింగం ||"
        },
        {
          "title": ""
        },
        {
          "title": "ధనం లేకపోవటమే దరిద్రం అనుకుంటాము మనం ధనం ఒక్కటే కాదు ఈ క్రింది వాటిలో ఏది లేకపోయినా దరిద్రం గానే పరిగణించాలి అని ఆనాటి పండితులు చెబుతున్నారు."
        },
        {
          "title": "ఆనాటి పరిష్తితులబట్టి దరిద్రాలు, ఎనిమిదిగా చెప్పియున్నారు."
        },
        {
          "title": ""
        },
        {
          "title": "1. అవసరములో సహాయము చేసేవారు ఒకరైనా లేకపోవడము"
        },
        {
          "title": "2. కనీస అవసరాలకు (కూడు, గూడు, గుడ్డ ) ధనము లేకపోవడము"
        },
        {
          "title": "3. ఒంటి పూట బోజనమునకు కూడా విపరీతమైన శ్రమచేయాల్సి రావడము"
        },
        {
          "title": "4. మన కష్టం చెప్పుకోవటానికి ఎవరూ దొరక్క పోవటం"
        },
        {
          "title": "5. చినిగిన బట్టలతో ఉండడము"
        },
        {
          "title": "6. వెళ్ళడానికి ఏ వాహనము లేక పోవడము"
        },
        {
          "title": "7. ధనము ఉన్నా సంతానము లేకపోవడము"
        },
        {
          "title": "8. పుత్రుడు ఉన్నా వదలివేయడము"
        },
        {
          "title": ""
        },
        {
          "title": "ఇటువంటి దరిద్రాలు ఎన్ని వున్నా శివలింగాన్ని ప్రతి రోజు అభిషేకిస్తే శివుడు ప్రీతినొంది ఎటువంటి దరిద్రాన్ని అయినా పోగొడతాడు. అని భక్తుల విశ్వాసం."
        }
      ],
      "title": "అష్టదరిద్రాలు అంటే ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>పంచ భక్ష్య పరమాన్నము అంటే ఏమిటి?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "సాధారణముగా మనం ప్రతి రోజు తినే ఆహారము వేరు పండుగలు, శుభ కార్యక్రములలో తీసుకునే ఆహారం వేరు గా ఉంటుంది. పంచ భక్ష్య పరమాన్నములతో విందు ఏర్పాటు చేసారు అంటూ ఉంటాము."
        },
        {
          "title": "విందులు వినోదాలు లో మనము తినే ఆహారము ఐదు విధాలుగా వుంటుంది."
        },
        {
          "title": ""
        },
        {
          "title": "1. భక్ష్య - కొరికి తినవలసినది ( గారెలు, బూరెలు, చక్కిలాలు వంటివి)"
        },
        {
          "title": "2. భోజ్య - నమిలి తినగలిగినవి ( చిత్రాన్నము, పులిహోర, ఫ్రైడ్ రైస్ మొదలైనవి )"
        },
        {
          "title": "3. ఖాద్య - చప్పరించి మింగేవి - మైసూరు పాకు లాంటివి"
        },
        {
          "title": "4 చోష్య - ద్రవ పదార్దాలు ( సాంబార్ , సూప్స్ లాంటివి )"
        },
        {
          "title": "5 లేహ్య - నాలుకతో నాకి తినేవి సగ్గుబియ్యం పరమాన్నం,తేనె, లాంటివి"
        },
        {
          "title": ""
        },
        {
          "title": "వీటితో ఎవరైనా భోజనం పెడితే పంచ భక్ష్య పరమాన్నములతో భోజనం పెట్టారు అంటారు."
        }
      ],
      "title": "పంచ భక్ష్య పరమాన్నము అంటే ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>దేవాలయాల్లో రావి చెట్టు, వేప చెట్టులను కలిపి పెంచుతారు ఎందువల్ల?</span>,
        },
        {
          "title": ""
        },
        {
          "title": "రావి చెట్టునే బోధి వృక్షమనీ, వట పత్ర వృక్షమనీ, అశ్వత్థ వృక్షమనీ కూడా అంటారు. రావి చెట్టును విష్ణు స్వరూపం గానూ, వేపచేట్టును లక్ష్మీ స్వరూపంగానూ భావిస్తారు. ఈ రెండు చెట్లను కలిపి పూజించడం లక్ష్మీ, నారాయణులను కలిపి పూజించడం తో సమానమని పండితులు చెబుతారు. ఈ రెండు చెట్లను కలిపి పూజిస్తే సంసారం లో కలతలు రావు అని, రావి చెట్టు చుట్టూ ప్రదక్షిణ చేస్తే సంతానం కలుగుతుంది అని అసంఖ్యాక హిందువుల విశ్వాసం. శ్రీ కృష్ణుని వట పత్ర శాయి అనడం వెనుక ఉద్దేశ్యం. కృష్ణుని నారాయణ స్వరూపంగా భావించడం వల్లనే."
        },
        {
          "title": ""
        },
        {
          "title": "జ్యోతిష శాస్త్ర ప్రకారం రావిచెట్టు చుట్టూ ప్రదక్షిణాలు చేస్తే శని దోషం పోతుంది. రావి చెట్టు కొమ్మలతో యజ్ఞ యాగాలు చేస్తారు. సన్యాసులు రావి చెట్టు కర్రను దండం గా చేసుకుంటారు. రావి చెట్టు నీడన రోజూ కాసేపు కూర్చుంటే రక్త పోటు అదుపులోకి వస్తుందని ఆయుర్వేదం చెబుతోంది. రావి చెట్టు గాలి మంచి ఆలోచనలు కలిగిస్తుంది. గౌతమ బుద్ధునికి జ్ఞానోదయం కలిగింది ఈ చెట్టు కిందనే కాబట్టే రావి చెట్టు బోధి వృక్షం అయ్యింది. బౌద్ధులకు పవిత్రమైనది ఈ బోధి వృక్షం. అంత్య కాలం లో శ్రీ కృష్ణుడు ఈ చెట్టు కిందనే విశ్రమించి ప్రాణాలు విడిచి పెట్టాడు."
        },
        {
          "title": ""
        },
        {
          "title": "వేప చెట్టు గురించి, వేప వృక్షం కూడా ఎన్నో ఔషధ గుణాలు కల్గిన దివ్య వృక్షం. వేప ఆకులను ఎన్నో రోగాలకు మందుగా వాడతారు. మధు మేహ రోగులు రోజు వేప చివుళ్ళు నమిలితే వ్యాధి అదుపులో వుంటుంది అని ఆయుర్వేదం చెబుతోంది. వేప ఆకులను నీటిలో వేసి కాచి త్రాగినా, వేపాకు ముద్దను శరీరం పై లేపనం గా పోసినా చర్మ సంబంధ వ్యాధులు తగ్గుతాయి. దుష్ట శక్తులను తరిమి కొట్టడానికి వేప మండలను ఉపయోగిస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "రావి చెట్లను ఇంటి వద్ద పెంచకూడదు. ఎందుకంటే కాలం గడిచిన కొద్దీ రావి చెట్టు మహా వృక్షమౌతుంది. ఇంటి పునాదులకు నష్టం కలిగించవచ్చు. అందుకే దేవాలయాల్లో మాత్రమే ఈ రెండు చెట్లను కలిపి పెంచుతారు."
        }
      ],
      "title": "దేవాలయాల్లో రావి చెట్టు, వేప చెట్టులను కలిపి పెంచుతారు ఎందువల్ల?"
    },
  ],
  "Teluguletters": {
    "CatID": [
      {
        "title": <span class='highlight'>అచ్చులు - 16</span>,
      },
      {
        "title": "అ ఆ ఇ ఈ ఉ ఊ ఋ ౠ ఎ ఏ ఐ ఒ ఓ ఔ అం అః"
      },
      {
        "title": <span class='highlight'>హల్లులు - 36</span>,
      },
      {
        "title": "క ఖ గ ఘ ఙ చ ఛ జ ఝ ఞ ట ఠ డ ఢ ణ త థ ద ధ న ప ఫ బ భ మ య ర ల వ శ ష స హ ళ క్ష ఱ"
      },
      {
        "title": <span class='highlight'>ఉభయాక్షరములు - 3</span>,
      }
    ],
    "title": "తెలుగు అక్షరాలు"
  },
  "Telugumonths": {
    "CatID": [
      {
        "title": "1. చైత్రము"
      },
      {
        "title": "2. వైశాఖము"
      },
      {
        "title": "3. జ్యేష్ఠము"
      },
      {
        "title": "4. ఆషాఢము"
      },
      {
        "title": "5. శ్రావణము"
      },
      {
        "title": "6. బాధ్రపదము"
      },
      {
        "title": "7. ఆశ్వయుజము"
      },
      {
        "title": "8. కార్తీకము"
      },
      {
        "title": "9. మార్గశిరము"
      },
      {
        "title": "10. పుష్యము"
      },
      {
        "title": "11. మాఘము"
      },
      {
        "title": "12. ఫాల్గుణము"
      }
    ],
    "title": "తెలుగు నెలలు"
  },
  "Telugunakshatramulu": {
    "CatID": [
      {
        "title": "1. అశ్విని"
      },
      {
        "title": "2. భరణి"
      },
      {
        "title": "3. కృత్తిక"
      },
      {
        "title": "4. రోహిణి"
      },
      {
        "title": "5. మృగశిర"
      },
      {
        "title": "6. ఆరుద్ర"
      },
      {
        "title": "7. పునర్వసు"
      },
      {
        "title": "8. పుష్యమి"
      },
      {
        "title": "9. ఆశ్లేష"
      },
      {
        "title": "10. మఖ"
      },
      {
        "title": "11. పుబ్బ"
      },
      {
        "title": "12. ఉత్తర"
      },
      {
        "title": "13. హస్త"
      },
      {
        "title": "14. చిత్తా"
      },
      {
        "title": "15. స్వాతి"
      },
      {
        "title": "16. విశాఖ"
      },
      {
        "title": "17. అనూరాధ"
      },
      {
        "title": "18. జ్యేష్ఠ"
      },
      {
        "title": "19. మూల"
      },
      {
        "title": "20. పూర్వాషాఢ"
      },
      {
        "title": "21. ఉత్తరాషాఢ"
      },
      {
        "title": "22. శ్రవణం"
      },
      {
        "title": "23. ధనిష్ఠ"
      },
      {
        "title": "24. శతభిషం"
      },
      {
        "title": "25. పూర్వాభాద్ర"
      },
      {
        "title": "26. ఉత్తరాభాద్ర"
      },
      {
        "title": "27. రేవతి"
      }
    ],
    "title": "తెలుగు నక్షత్రములు"
  },
  "Telugurasulu": {
    "CatID": [
      {
        "title": "1. మేషం",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/MeshaRasi.png?alt=media&token=88094b10-7221-4929-8115-6f1f175a46f4"
        // "imgPath":require('../imgs/mesha.png'),
      },
      {
        "title": "2. వృషభం",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/vrishabhaRashi.png?alt=media&token=493e066c-8154-4476-8872-364afd6f5c6b"
        // "imgPath":require('../imgs/vrishabha.png'),
      },
      {
        "title": "3. మిధునం",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/MithunaRasi.png?alt=media&token=260b1016-e24c-44f5-98ed-3940bdf31e3a"
        // "imgPath":require('../imgs/mithuna.png'),
      },
      {
        "title": "4. కర్కాటకం",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/karkatakaRasi.png?alt=media&token=91e20f67-0a0e-4a8e-84c5-74f8f0022095"
        // "imgPath":require('../imgs/karkataka.png'),
      },
      {
        "title": "5. సింహం",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/SimhaRasi.png?alt=media&token=949c20fb-cc10-438e-a90b-fb9824e9ca22"
        // "imgPath":require('../imgs/simaha.png'),
      },
      {
        "title": "6. కన్య",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/KanyaRasi.png?alt=media&token=7ad9aad0-d039-405c-8a1c-2557abf8b63f"
        // "imgPath":require('../imgs/kanya.png'),
      },
      {
        "title": "7. తుల",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/TulaRasi.png?alt=media&token=57af1a28-f235-49f8-be94-d81d159f8597"
        // "imgPath":require('../imgs/tula.png'),
      },
      {
        "title": "8. వృశ్చికము",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/vrischikaRashi.png?alt=media&token=ad19ae78-46c1-406a-aa9b-21d7b32ed0ac"
        // "imgPath":require('../imgs/vrischika.png'),
      },
      {
        "title": "9. ధనస్సు",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/DhanasuRasi.png?alt=media&token=f93a559d-6477-4cca-be5f-450d17fa556b"
        // "imgPath":require('../imgs/dhanasu.png'),
      },
      {
        "title": "10. మకరము",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/MakaraRasi.png?alt=media&token=78ccb72f-2490-41c1-b9a5-b8c018852006"
        // "imgPath":require('../imgs/makara.png'),
      },
      {
        "title": "11. కుంభము",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/KumbhaRasi.png?alt=media&token=9a80f428-8a03-4924-98b5-a2ce6ee91b0c"
        // "imgPath":require('../imgs/kumbha.png'),
      },
      {
        "title": "12. మీనం",
        // "imgPath": "https://firebasestorage.googleapis.com/v0/b/telugu-calendar-e8d37.appspot.com/o/MeenaRasi.png?alt=media&token=dde67a5e-7434-44fd-8719-661f5ecdf4f1"
        // "imgPath":require('../imgs/meena.png'),
      }
    ],
    "title": "రాశులు 12"
  },
  "SankhyalaPramukyatalu": {
    "CatID": [
      {
        "telugu": [
          {
            "title": "లింగాలు",
            "subtitle": [
              {
                "title": "లింగాలు 3 అవి :"
              },
              {
                "title": "1. పుం"
              },
              {
                "title": "2. స్త్రీ"
              },
              {
                "title": "3. నపుంసక"
              }
            ]
          },
          {
            "title": "వాచకాలు",
            "subtitle": [
              {
                "title": "వాచకాలు 3 అవి :"
              },
              {
                "title": "1. మహద్వా"
              },
              {
                "title": "2. మహతీ"
              },
              {
                "title": "3. అమహత్తు"
              }
            ]
          },
          {
            "title": "పురుషులు",
            "subtitle": [
              {
                "title": "పురుషులు 3 అవి :"
              },
              {
                "title": "1. ప్రథమ"
              },
              {
                "title": "2. మధ్యమ"
              },
              {
                "title": "3. ఉత్తమ"
              }
            ]
          },
          {
            "title": "శరీరంలు",
            "subtitle": [
              {
                "title": "శరీరంలు 3 అవి :"
              },
              {
                "title": "1. స్థూల శరీరం"
              },
              {
                "title": "2. సూక్ష్మ శరీరం"
              },
              {
                "title": "3. కారణ శరీరం"
              }
            ]
          },
          {
            "title": "అవస్తలు",
            "subtitle": [
              {
                "title": "అవస్తలు 3 అవి :"
              },
              {
                "title": "1. జాగ్రదావస్త"
              },
              {
                "title": "2. స్వప్నావస్త"
              },
              {
                "title": "3. సుషుప్తి అవస్త"
              }
            ]
          },
          {
            "title": "జీవి త్రయంలు",
            "subtitle": [
              {
                "title": "జీవి త్రయంలు 3 అవి :"
              },
              {
                "title": "1. విశ్వుడు"
              },
              {
                "title": "2. తైజుడు"
              },
              {
                "title": "3. ప్రఙ్ఞుడు"
              }
            ]
          },
          {
            "title": "కర్మత్రయంలు",
            "subtitle": [
              {
                "title": "కర్మత్రయంలు 3 అవి :"
              },
              {
                "title": "1. ప్రారబ్దం కర్మలు"
              },
              {
                "title": "2. అగామి కర్మలు"
              },
              {
                "title": "3. సంచిత కర్మలు"
              }
            ]
          },
          {
            "title": "గుణంలు",
            "subtitle": [
              {
                "title": "గుణంలు 3 అవి :"
              },
              {
                "title": "1. సత్వ గుణం"
              },
              {
                "title": "2. రజో గుణం"
              },
              {
                "title": "3. తమో గుణం"
              }
            ]
          },
          {
            "title": "త్రిగుణములు",
            "subtitle": [
              {
                "title": "త్రిగుణములు 3 అవి :"
              },
              {
                "title": "సృష్ఠి యావత్తు త్రిగుణములతోనే ఉంటుంది. దేవతలు జీవులు చెట్లలో అన్ని వర్గంలలో మూడే గుణములు ఉంటాయి."
              },
              {
                "title": "1. సత్వ గుణం"
              },
              {
                "title": "2. రజో గుణం"
              },
              {
                "title": "3. తమో గుణం"
              }
            ]
          }
        ],
        "title": "మూడు యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "దిక్కులు",
            "subtitle": [
              {
                "title": "దిక్కులు 4 అవి :"
              },
              {
                "title": "1. తూర్పు"
              },
              {
                "title": "2. దక్షిణం"
              },
              {
                "title": "3. పడమర"
              },
              {
                "title": "4. ఉత్తరం"
              }
            ]
          },
          {
            "title": "మూలలు",
            "subtitle": [
              {
                "title": "మూలలు 4 అవి :"
              },
              {
                "title": "1. ఆగ్నేయం"
              },
              {
                "title": "2. నైరుతి"
              },
              {
                "title": "3. వాయువ్యం"
              },
              {
                "title": "4. ఈశాన్యం"
              }
            ]
          },
          {
            "title": "వేదాలు",
            "subtitle": [
              {
                "title": "వేదాలు 4 అవి :"
              },
              {
                "title": "1. ఋగ్వేదం"
              },
              {
                "title": "2. యజుర్వేదం"
              },
              {
                "title": "3. సామవేదం"
              },
              {
                "title": "4. అదర్వణ వేదం"
              }
            ]
          },
          {
            "title": "ఉపవేదాలు",
            "subtitle": [
              {
                "title": "ఉపవేదాలు 4 అవి :"
              },
              {
                "title": "1. ధనుర్వేద"
              },
              {
                "title": "2. ఆయుర్వేద"
              },
              {
                "title": "3. గంధర్వ"
              },
              {
                "title": "4. శిల్ప"
              }
            ]
          },
          {
            "title": "వేదభాగాలు",
            "subtitle": [
              {
                "title": "వేదభాగాలు 4 అవి :"
              },
              {
                "title": "1. సంహిత"
              },
              {
                "title": "2. బ్రాహ్మణము"
              },
              {
                "title": "3. అరణ్యకము"
              },
              {
                "title": "4. ఉపనిషత్తులు"
              }
            ]
          },
          {
            "title": "పురుషార్ధాలు",
            "subtitle": [
              {
                "title": "పురుషార్ధాలు 4 అవి :"
              },
              {
                "title": "1. ధర్మ"
              },
              {
                "title": "2. అర్థ"
              },
              {
                "title": "3. కామ"
              },
              {
                "title": "4. మోక్షా"
              }
            ]
          },
          {
            "title": "చతురాశ్రమాలు",
            "subtitle": [
              {
                "title": "చతురాశ్రమాలు 4 అవి :"
              },
              {
                "title": "1. బ్రహ్మ చర్యం"
              },
              {
                "title": "2. గార్హస్య్ద"
              },
              {
                "title": "3. వానప్రస్ధం"
              },
              {
                "title": "4. సన్యాసం"
              }
            ]
          }
        ],
        "title": "నాలుగు యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "పంచభూతాలు",
            "subtitle": [
              {
                "title": "పంచభూతాలు 5 అవి :"
              },
              {
                "title": "1. గాలి"
              },
              {
                "title": "2. నీరు"
              },
              {
                "title": "3. భూమి"
              },
              {
                "title": "4. అగ్ని"
              },
              {
                "title": "5. ఆకాశం"
              }
            ]
          },
          {
            "title": "పంచాంగంలో",
            "subtitle": [
              {
                "title": "పంచాంగంలో 5 అవి :"
              },
              {
                "title": "1. తిధి"
              },
              {
                "title": "2. వార"
              },
              {
                "title": "3. నక్షత్రం"
              },
              {
                "title": "4. కరణం"
              },
              {
                "title": "5. యోగం"
              }
            ]
          },
          {
            "title": "పంచేంద్రియాలు",
            "subtitle": [
              {
                "title": "పంచేంద్రియాలు 5 అవి :"
              },
              {
                "title": "1. కన్ను"
              },
              {
                "title": "2. ముక్కు"
              },
              {
                "title": "3. చెవి"
              },
              {
                "title": "4. నాలుక"
              },
              {
                "title": "5. చర్మం"
              }
            ]
          },
          {
            "title": "భాషా భాగాలు",
            "subtitle": [
              {
                "title": "భాషా భాగాలు 5 అవి :"
              },
              {
                "title": "1. నామవాచకం"
              },
              {
                "title": "2. సర్వనామం"
              },
              {
                "title": "3. విశేషణం"
              },
              {
                "title": "4. క్రియ"
              },
              {
                "title": "5. అవ్యయం"
              }
            ]
          },
          {
            "title": "లలిత కళలు",
            "subtitle": [
              {
                "title": "లలిత కళలు 5 అవి :"
              },
              {
                "title": "1. కవిత్వం"
              },
              {
                "title": "2. చిత్రలేఖనం"
              },
              {
                "title": "3. నాట్యం"
              },
              {
                "title": "4. సంగీతం"
              },
              {
                "title": "5. శిల్పం"
              }
            ]
          },
          {
            "title": "పంచకావ్యాలు",
            "subtitle": [
              {
                "title": "పంచకావ్యాలు 5 అవి :"
              },
              {
                "title": "1. ఆముక్తమాల్యద"
              },
              {
                "title": "2. వసుచరిత్ర"
              },
              {
                "title": "3. మనుచరిత్ర"
              },
              {
                "title": "4. పారిజాతాపహరణం"
              },
              {
                "title": "5. శృంగార నైషధం"
              }
            ]
          },
          {
            "title": "పంచగంగలు",
            "subtitle": [
              {
                "title": "పంచగంగలు 5 అవి :"
              },
              {
                "title": "1. గంగ"
              },
              {
                "title": "2. కృష్ణ"
              },
              {
                "title": "3. గోదావరి"
              },
              {
                "title": "4. కావేరి"
              },
              {
                "title": "5. తుంగభద్ర"
              }
            ]
          },
          {
            "title": "దేవతావృక్షాలు",
            "subtitle": [
              {
                "title": "దేవతావృక్షాలు 5 అవి :"
              },
              {
                "title": "1. మందారం"
              },
              {
                "title": "2. పారిజాతం"
              },
              {
                "title": "3. కల్పవృక్షం"
              },
              {
                "title": "4. సంతానం"
              },
              {
                "title": "5. హరిచందనం"
              }
            ]
          },
          {
            "title": "పంచోపచారాలు",
            "subtitle": [
              {
                "title": "పంచోపచారాలు 5 అవి :"
              },
              {
                "title": "1. స్నానం"
              },
              {
                "title": "2. పూజ"
              },
              {
                "title": "3. నైవేద్యం"
              },
              {
                "title": "4. ప్రదక్షిణం"
              },
              {
                "title": "5. నమస్కారం"
              }
            ]
          },
          {
            "title": "పంచాగ్నులు",
            "subtitle": [
              {
                "title": "పంచాగ్నులు 5 అవి :"
              },
              {
                "title": "1. బడబాగ్ని"
              },
              {
                "title": "2. జఠరాగ్ని"
              },
              {
                "title": "3. కష్టాగ్ని"
              },
              {
                "title": "4. వజ్రాగ్ని"
              },
              {
                "title": "5. సూర్యాగ్ని"
              }
            ]
          },
          {
            "title": "పంచామృతాలు",
            "subtitle": [
              {
                "title": "పంచామృతాలు 5 అవి :"
              },
              {
                "title": "1. ఆవుపాలు"
              },
              {
                "title": "2. పెరుగు"
              },
              {
                "title": "3. నెయ్యి"
              },
              {
                "title": "4. చక్కెర"
              },
              {
                "title": "5. తేనె"
              }
            ]
          },
          {
            "title": "పంచలోహాలు",
            "subtitle": [
              {
                "title": "పంచలోహాలు 5 అవి :"
              },
              {
                "title": "1. బంగారం"
              },
              {
                "title": "2. వెండి"
              },
              {
                "title": "3. రాగి"
              },
              {
                "title": "4. సీసం"
              },
              {
                "title": "5. తగరం"
              }
            ]
          },
          {
            "title": "పంచారామాలు",
            "subtitle": [
              {
                "title": "పంచారామాలు 5 అవి :"
              },
              {
                "title": "1. అమరావతి"
              },
              {
                "title": "2. భీమవరం"
              },
              {
                "title": "3. పాలకొల్లు"
              },
              {
                "title": "4. సామర్లకోట"
              },
              {
                "title": "5. ద్రాక్షారామం"
              }
            ]
          },
          {
            "title": "పంచ కోశాలు",
            "subtitle": [
              {
                "title": "పంచ కోశాలు 5 అవి :"
              },
              {
                "title": "1. అన్నమయ కోశం"
              },
              {
                "title": "2. ప్రాణమయ కోశం"
              },
              {
                "title": "3. మనోమయ కోశం"
              },
              {
                "title": "4. విజ్ఞానమయ కోశం"
              },
              {
                "title": "5. ఆనందమయ కోశం"
              }
            ]
          },
          {
            "title": "ధర్మరాజు అడిగిన ఊళ్ళు",
            "subtitle": [
              {
                "title": "ధర్మరాజు అడిగిన ఊళ్ళు 5 అవి :"
              },
              {
                "title": "1. ఇంద్రప్రస్థం"
              },
              {
                "title": "2. కుశస్థం"
              },
              {
                "title": "3. వృకస్థలం"
              },
              {
                "title": "4. వాసంతి"
              },
              {
                "title": "5. వారణావతం"
              }
            ]
          },
          {
            "title": "ఙ్ఞానేంద్రియంలు",
            "subtitle": [
              {
                "title": "ఙ్ఞానేంద్రియంలు 5 అవి :"
              },
              {
                "title": "1. శబ్ద"
              },
              {
                "title": "2. స్పర్ష"
              },
              {
                "title": "3. రూప"
              },
              {
                "title": "4. రస"
              },
              {
                "title": "5. గంధంలు"
              }
            ]
          },
          {
            "title": "పంచ తన్మాత్రలు",
            "subtitle": [
              {
                "title": "పంచ తన్మాత్రలు 5 అవి :"
              },
              {
                "title": "1. చెవులు"
              },
              {
                "title": "2. చర్మం"
              },
              {
                "title": "3. కండ్లు"
              },
              {
                "title": "4. నాలుక"
              },
              {
                "title": "5. ముక్కు"
              }
            ]
          },
          {
            "title": "పంచ ప్రాణంలు",
            "subtitle": [
              {
                "title": "పంచ ప్రాణంలు 5 అవి :"
              },
              {
                "title": "1. అపాన"
              },
              {
                "title": "2. సామనా"
              },
              {
                "title": "3. ప్రాణ"
              },
              {
                "title": "4. ఉదాన"
              },
              {
                "title": "5. వ్యాన"
              }
            ]
          },
          {
            "title": "అంతఃర ఇంద్రియంలు",
            "subtitle": [
              {
                "title": "అంతఃర ఇంద్రియంలు 5 అవి :"
              },
              {
                "title": "1. మనస్సు"
              },
              {
                "title": "2. బుద్ది"
              },
              {
                "title": "3. చిత్తం"
              },
              {
                "title": "4. జ్ఞానం"
              },
              {
                "title": "5. ఆహంకారం"
              }
            ]
          },
          {
            "title": "కర్మేంద్రియంలు",
            "subtitle": [
              {
                "title": "కర్మేంద్రియంలు 5 అవి :"
              },
              {
                "title": "1. వాక్కు"
              },
              {
                "title": "2. పాని"
              },
              {
                "title": "3. పాదం"
              },
              {
                "title": "4. గుహ్యం"
              },
              {
                "title": "5. గుదం"
              }
            ]
          }
        ],
        "title": "ఐదు యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "షడ్రుచులు",
            "subtitle": [
              {
                "title": "షడ్రుచులు 6 అవి :"
              },
              {
                "title": "1. తీపి"
              },
              {
                "title": "2. పులుపు"
              },
              {
                "title": "3. చేదు"
              },
              {
                "title": "4. వగరు"
              },
              {
                "title": "5. కారం"
              },
              {
                "title": "6. ఉప్పు"
              }
            ]
          },
          {
            "title": "వేదాంగాలు(స్మ్రతులు)",
            "subtitle": [
              {
                "title": "వేదాంగాలు(స్మ్రతులు) 6 అవి :"
              },
              {
                "title": "1. శిక్ష"
              },
              {
                "title": "2. వ్యాకరణం"
              },
              {
                "title": "3. ఛందస్సు"
              },
              {
                "title": "4. నిరుక్తం"
              },
              {
                "title": "5. జ్యోతిష్యం"
              },
              {
                "title": "6. కల్పం"
              }
            ]
          },
          {
            "title": "అరిషడ్వర్గాలు షడ్గుణాలు",
            "subtitle": [
              {
                "title": "అరిషడ్వర్గాలు షడ్గుణాలు 6 అవి :"
              },
              {
                "title": "1. కామం"
              },
              {
                "title": "2. క్రోధం"
              },
              {
                "title": "3. లోభం"
              },
              {
                "title": "4. మోహం"
              },
              {
                "title": "5. మదం"
              },
              {
                "title": "6. మత్సరం"
              }
            ]
          },
          {
            "title": "ఋతువులు",
            "subtitle": [
              {
                "title": "ఋతువులు 6 అవి :"
              },
              {
                "title": "1. వసంత"
              },
              {
                "title": "2. గ్రీష్మ"
              },
              {
                "title": "3. వర్ష"
              },
              {
                "title": "4. శరద్ఋతువు"
              },
              {
                "title": "5. హేమంత"
              },
              {
                "title": "6. శిశిర"
              }
            ]
          },
          {
            "title": "షట్చక్రవర్తులు",
            "subtitle": [
              {
                "title": "షట్చక్రవర్తులు 6 అవి :"
              },
              {
                "title": "1. హరిశ్చంద్రుడు"
              },
              {
                "title": "2. నలుడు"
              },
              {
                "title": "3. సగరుడు"
              },
              {
                "title": "4. పురుకుత్సుడు"
              },
              {
                "title": "5. పురూరవుడు"
              },
              {
                "title": "6. కార్తవీర్యార్జునుడు"
              }
            ]
          },
          {
            "title": "రామాయణంలోకాండలు",
            "subtitle": [
              {
                "title": "రామాయణంలోకాండలు 6 అవి :"
              },
              {
                "title": "1. బాల"
              },
              {
                "title": "2. అయోధ్య"
              },
              {
                "title": "3. అరణ్య"
              },
              {
                "title": "4. కిష్కింద"
              },
              {
                "title": "5. సుందర"
              },
              {
                "title": "6. యుద్ధ"
              },
              {
                "title": "7. (తెలుగులో7వకాండ ఉత్తర (లవకుశ కథ))"
              }
            ]
          },
          {
            "title": "షడ్బావ వికారంలు",
            "subtitle": [
              {
                "title": "షడ్బావ వికారంలు 6 అవి :"
              },
              {
                "title": "1. ఉండుట"
              },
              {
                "title": "2. పుట్టుట"
              },
              {
                "title": "3. పెరుగుట"
              },
              {
                "title": "4. పరినమించుట"
              },
              {
                "title": "5. క్షిణించుట"
              },
              {
                "title": "6. నశించుట"
              }
            ]
          },
          {
            "title": "షడ్ముర్ములు",
            "subtitle": [
              {
                "title": "షడ్ముర్ములు 6 అవి :"
              },
              {
                "title": "1. ఆకలి"
              },
              {
                "title": "2. దప్పిక"
              },
              {
                "title": "3. శోకం"
              },
              {
                "title": "4. మోహం"
              },
              {
                "title": "5. జర"
              },
              {
                "title": "6. మరణం"
              }
            ]
          }
        ],
        "title": "ఆరు యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "సప్త ఋషులు",
            "subtitle": [
              {
                "title": "సప్త ఋషులు 7 అవి :"
              },
              {
                "title": "1. కాశ్యపుడు"
              },
              {
                "title": "2. గౌతముడు"
              },
              {
                "title": "3. అత్రి"
              },
              {
                "title": "4. విశ్వామిత్రుడు"
              },
              {
                "title": "5. భరద్వాజ"
              },
              {
                "title": "6. జమదగ్ని"
              },
              {
                "title": "7. వశిష్ఠుడు"
              }
            ]
          },
          {
            "title": "సప్త ధాతువులు(కోశములు)",
            "subtitle": [
              {
                "title": "సప్త ధాతువులు 7 అవి :"
              },
              {
                "title": "1. చర్మం"
              },
              {
                "title": "2. రక్తం"
              },
              {
                "title": "3. మాంసం"
              },
              {
                "title": "4. మేదస్సు"
              },
              {
                "title": "5. మజ్జ"
              },
              {
                "title": "6. ఎముకలు"
              },
              {
                "title": "7. శుక్లం"
              }
            ]
          },
          {
            "title": "తిరుపతి సప్తగిరులు",
            "subtitle": [
              {
                "title": "తిరుపతి సప్తగిరులు 7 అవి :"
              },
              {
                "title": "1. శేషాద్రి"
              },
              {
                "title": "2. నీలాద్రి"
              },
              {
                "title": "3. గరుడాద్రి"
              },
              {
                "title": "4. అంజనాద్రి"
              },
              {
                "title": "5. వృషభాద్రి"
              },
              {
                "title": "6. నారాయణాద్రి"
              },
              {
                "title": "7. వేంకటాద్రి"
              }
            ]
          },
          {
            "title": "మానవ శరీరములోని 7 చక్రాలు",
            "subtitle": [
              {
                "title": "చక్రాలు 7 అవి :"
              },
              {
                "title": "1. మూలధార"
              },
              {
                "title": "2. స్వాధిష్టాన"
              },
              {
                "title": "3. మణిపూరక"
              },
              {
                "title": "4. అనాహత"
              },
              {
                "title": "5. విశుద్ధ"
              },
              {
                "title": "6. ఆజ్ఞాచక్రాలు"
              },
              {
                "title": "7. సహస్రార చక్రము"
              }
            ]
          },
          {
            "title": "కులపర్వతాలు",
            "subtitle": [
              {
                "title": "కులపర్వతాలు 7 అవి :"
              },
              {
                "title": "1. మహేంద్ర"
              },
              {
                "title": "2. మలయ"
              },
              {
                "title": "3. సహ్యం"
              },
              {
                "title": "4. శుక్తిమంతం"
              },
              {
                "title": "5. గంధమాధనం"
              },
              {
                "title": "6. వింధ్య"
              },
              {
                "title": "7. పారియాత్ర"
              }
            ]
          },
          {
            "title": "సప్త సముద్రాలు",
            "subtitle": [
              {
                "title": "సప్త సముద్రాలు 7 అవి :"
              },
              {
                "title": "1. ఇక్షు"
              },
              {
                "title": "2. జల"
              },
              {
                "title": "3. క్షీర"
              },
              {
                "title": "4. లవణ"
              },
              {
                "title": "5. దది"
              },
              {
                "title": "6. సూర"
              },
              {
                "title": "7. సర్పి"
              }
            ]
          },
          {
            "title": "సప్త వ్యసనాలు",
            "subtitle": [
              {
                "title": "సప్త వ్యసనాలు 7 అవి :"
              },
              {
                "title": "1. జూదం"
              },
              {
                "title": "2. మద్యం"
              },
              {
                "title": "3. దొంగతనం"
              },
              {
                "title": "4. వేట"
              },
              {
                "title": "5. వ్యభిచారం"
              },
              {
                "title": "6. దుబారఖర్చు"
              },
              {
                "title": "7. కఠినంగా మాట్లాడటం"
              }
            ]
          },
          {
            "title": "సప్త నదులు",
            "subtitle": [
              {
                "title": "సప్త నదులు 7 అవి :"
              },
              {
                "title": "1. గంగ"
              },
              {
                "title": "2. యమునా"
              },
              {
                "title": "3. సరస్వతి"
              },
              {
                "title": "4. గోదావరి"
              },
              {
                "title": "5. సింధు"
              },
              {
                "title": "6. నర్మద"
              },
              {
                "title": "7. కావేరి"
              }
            ]
          },
          {
            "title": "ఊర్ధ్వలోకాలు",
            "subtitle": [
              {
                "title": "ఊర్ధ్వలోకాలు 7 అవి :"
              },
              {
                "title": "1. భూ"
              },
              {
                "title": "2. భువర్ణో"
              },
              {
                "title": "3. సువర్ణో"
              },
              {
                "title": "4. తపో"
              },
              {
                "title": "5. జనో"
              },
              {
                "title": "6. మహా"
              },
              {
                "title": "7. సత్య"
              }
            ]
          },
          {
            "title": "అదో లోకాలు",
            "subtitle": [
              {
                "title": "అదో లోకాలు 7 అవి :"
              },
              {
                "title": "1. అతల"
              },
              {
                "title": "2. వితల"
              },
              {
                "title": "3. సుతల"
              },
              {
                "title": "4. తలాతల"
              },
              {
                "title": "5. రసాతల"
              },
              {
                "title": "6. మహాతల"
              },
              {
                "title": "7. పాతాళ"
              }
            ]
          }
        ],
        "title": "ఏడు యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "జన్మలు",
            "subtitle": [
              {
                "title": "జన్మలు 8 అవి :"
              },
              {
                "title": "1. దేవ"
              },
              {
                "title": "2. మనుష్య"
              },
              {
                "title": "3. రాక్షస"
              },
              {
                "title": "4. పిశాచి"
              },
              {
                "title": "5. పశు"
              },
              {
                "title": "6. పక్షి"
              },
              {
                "title": "7. జలజీవ"
              },
              {
                "title": "8. కీటక"
              }
            ]
          },
          {
            "title": "కర్మలు",
            "subtitle": [
              {
                "title": "కర్మలు 8 అవి :"
              },
              {
                "title": "1. స్నానం"
              },
              {
                "title": "2. సంధ్య"
              },
              {
                "title": "3. జపం"
              },
              {
                "title": "4. హోమం"
              },
              {
                "title": "5. స్వాధ్యాయం"
              },
              {
                "title": "6. దేవపూజ"
              },
              {
                "title": "7. ఆతిథ్యం"
              },
              {
                "title": "8. వైశ్యదేవం"
              }
            ]
          },
          {
            "title": "అష్టదిగ్గజాలు",
            "subtitle": [
              {
                "title": "అష్టదిగ్గజాలు 8 అవి :"
              },
              {
                "title": "1. ఐరావతం"
              },
              {
                "title": "2. పుండరీకం"
              },
              {
                "title": "3. కుముదం"
              },
              {
                "title": "4. సార్వభౌమం"
              },
              {
                "title": "5. అంజనం"
              },
              {
                "title": "6. సుప్రతీకం"
              },
              {
                "title": "7. వామనం"
              },
              {
                "title": "8. పుష్పదంతం"
              }
            ]
          },
          {
            "title": "అష్టదిగ్గజకవులు",
            "subtitle": [
              {
                "title": "అష్టదిగ్గజకవులు 8 అవి :"
              },
              {
                "title": "1. నందితిమ్మన"
              },
              {
                "title": "2. పెద్దన"
              },
              {
                "title": "3. ధూర్జటి"
              },
              {
                "title": "4. పింగళి సూరన"
              },
              {
                "title": "5. తెనాలిరామకృష్ణ"
              },
              {
                "title": "6. రామరాజభూషణుడు"
              },
              {
                "title": "7. అయ్యలరాజురామభద్రుడు"
              },
              {
                "title": "8. మాదయగారిమల్లన"
              }
            ]
          },
          {
            "title": "శ్రీ కృష్ణుని అష్ట భార్యలు",
            "subtitle": [
              {
                "title": "శ్రీ కృష్ణుని అష్ట భార్యలు 8 అవి :"
              },
              {
                "title": "1. రుక్మిణి"
              },
              {
                "title": "2. సత్యభామ"
              },
              {
                "title": "3. జాంబవతి"
              },
              {
                "title": "4. మిత్రవింద"
              },
              {
                "title": "5. భద్ర"
              },
              {
                "title": "6. సుదంత"
              },
              {
                "title": "7. కాళింది"
              },
              {
                "title": "8. లక్షణ"
              }
            ]
          },
          {
            "title": "అష్ట భాషలు",
            "subtitle": [
              {
                "title": "అష్ట భాషలు 8 అవి :"
              },
              {
                "title": "1. సంస్కృతం"
              },
              {
                "title": "2. ప్రాకృత"
              },
              {
                "title": "3. శౌరసేని"
              },
              {
                "title": "4. మాగధీ"
              },
              {
                "title": "5. పైశాచి = అపభ్రంశ భాషా"
              },
              {
                "title": "6. ప్రాచీ భాషా"
              },
              {
                "title": "7. అవంతీ భాషా"
              },
              {
                "title": "8. సార్వదేశీ భాష"
              }
            ]
          }
        ],
        "title": "ఎనిమిది యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "నవధాన్యాలు",
            "subtitle": [
              {
                "title": "నవధాన్యాలు 9 అవి :"
              },
              {
                "title": "1. గోధుమ"
              },
              {
                "title": "2. వడ్లు"
              },
              {
                "title": "3. పెసలు"
              },
              {
                "title": "4. శనగలు"
              },
              {
                "title": "5. కందులు"
              },
              {
                "title": "6. నువ్వులు"
              },
              {
                "title": "7. మినుములు"
              },
              {
                "title": "8. ఉలవలు"
              },
              {
                "title": "9. అలసందలు"
              }
            ]
          },
          {
            "title": "నవరత్నాలు",
            "subtitle": [
              {
                "title": "నవరత్నాలు 9 అవి :"
              },
              {
                "title": "1. ముత్యం"
              },
              {
                "title": "2. పగడం"
              },
              {
                "title": "3. గోమేధికం"
              },
              {
                "title": "4. వజ్రం"
              },
              {
                "title": "5. కెంపు"
              },
              {
                "title": "6. నీలం"
              },
              {
                "title": "7. కనకపుష్యరాగం"
              },
              {
                "title": "8. పచ్చ (మరకతం)"
              },
              {
                "title": "9. ఎరుపు (వైడూర్యం)"
              }
            ]
          },
          {
            "title": "నవధాతువులు",
            "subtitle": [
              {
                "title": "నవధాతువులు 9 అవి :"
              },
              {
                "title": "1. బంగారం"
              },
              {
                "title": "2. వెండి"
              },
              {
                "title": "3. ఇత్తడి"
              },
              {
                "title": "4. రాగి"
              },
              {
                "title": "5. ఇనుము"
              },
              {
                "title": "6. కంచు"
              },
              {
                "title": "7. సీసం"
              },
              {
                "title": "8. తగరం"
              },
              {
                "title": "9. కాంతలోహం"
              }
            ]
          },
          {
            "title": "నవరసాలు",
            "subtitle": [
              {
                "title": "నవరసాలు 9 అవి :"
              },
              {
                "title": "1. హాస్యం"
              },
              {
                "title": "2. శృంగార"
              },
              {
                "title": "3. కరుణ"
              },
              {
                "title": "4. శాంత"
              },
              {
                "title": "5. రౌద్ర"
              },
              {
                "title": "6. భయానక"
              },
              {
                "title": "7. బీభత్స"
              },
              {
                "title": "8. అద్భుత"
              },
              {
                "title": "9. వీర"
              }
            ]
          },
          {
            "title": "నవబ్రహ్మలు",
            "subtitle": [
              {
                "title": "నవబ్రహ్మలు 9 అవి :"
              },
              {
                "title": "1. మరీచ"
              },
              {
                "title": "2. భరద్వాజ"
              },
              {
                "title": "3. అంగీరసుడు"
              },
              {
                "title": "4. పులస్య్తుడు"
              },
              {
                "title": "5. పులహుడు"
              },
              {
                "title": "6. క్రతువు"
              },
              {
                "title": "7. దక్షుడు"
              },
              {
                "title": "8. వశిష్ఠుడు"
              },
              {
                "title": "9. వామదేవుడు"
              }
            ]
          },
          {
            "title": "నవ చక్రాలు",
            "subtitle": [
              {
                "title": "నవ చక్రాలు 9 అవి :"
              },
              {
                "title": "1. మూలాధార"
              },
              {
                "title": "2. స్వాధిష్టాన"
              },
              {
                "title": "3. నాభి"
              },
              {
                "title": "4. హృదయ"
              },
              {
                "title": "5. కంఠ"
              },
              {
                "title": "6. ఘంటికా"
              },
              {
                "title": "7. భ్రూవు"
              },
              {
                "title": "8. గగన"
              },
              {
                "title": "9. బ్రహ్మ రంధ్రం"
              }
            ]
          },
          {
            "title": "నవదుర్గలు",
            "subtitle": [
              {
                "title": "నవదుర్గలు 9 అవి :"
              },
              {
                "title": "1. శైలపుత్రి"
              },
              {
                "title": "2. బ్రహ్మ చారిణి"
              },
              {
                "title": "3. చంద్రఘంట"
              },
              {
                "title": "4. కూష్మాండ"
              },
              {
                "title": "5. స్కందమాత"
              },
              {
                "title": "6. కాత్యాయని"
              },
              {
                "title": "7. కాళరాత్రి"
              },
              {
                "title": "8. మహాగౌరి"
              },
              {
                "title": "9. సిద్ధిధాత్రి"
              }
            ]
          },
          {
            "title": "నవగ్రహాలు",
            "subtitle": [
              {
                "title": "నవగ్రహాలు 9 అవి :"
              },
              {
                "title": "1. సూర్యుడు"
              },
              {
                "title": "2. చంద్రుడు"
              },
              {
                "title": "3. అంగారకుడు"
              },
              {
                "title": "4. బుదుడు"
              },
              {
                "title": "5. బృహస్పతి"
              },
              {
                "title": "6. శుక్రుడు"
              },
              {
                "title": "7. శని"
              },
              {
                "title": "8. రాహువు"
              },
              {
                "title": "9. కేతువు"
              }
            ]
          },
          {
            "title": "నవగోప్యలు",
            "subtitle": [
              {
                "title": "నవగోప్యలు 9 అవి :"
              },
              {
                "title": "1. ఆయువు"
              },
              {
                "title": "2. విత్తము"
              },
              {
                "title": "3. ఇంటిగుట్టు"
              },
              {
                "title": "4. మంత్రం"
              },
              {
                "title": "5. ఔషధం"
              },
              {
                "title": "6. సంగమం"
              },
              {
                "title": "7. దానం"
              },
              {
                "title": "8. మానము"
              },
              {
                "title": "9. అవమానం"
              }
            ]
          },
          {
            "title": "చతుష్ఠయములు",
            "subtitle": [
              {
                "title": "చతుష్ఠయములు 9 అవి :"
              },
              {
                "title": "1. సంకల్ప"
              },
              {
                "title": "2. అధ్యాసాయం"
              },
              {
                "title": "3. ఆభిమానం"
              },
              {
                "title": "4. అవధరణ"
              },
              {
                "title": "5. ముదిత"
              },
              {
                "title": "6. కరుణ"
              },
              {
                "title": "7. మైత్రి"
              },
              {
                "title": "8. ఉపేక్ష"
              },
              {
                "title": "9. తితిక్ష"
              }
            ]
          }
        ],
        "title": "తొమ్మిది యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "దశ సంస్కారాలు",
            "subtitle": [
              {
                "title": "దశ సంస్కారాలు 10 అవి :"
              },
              {
                "title": "1. వివాహం"
              },
              {
                "title": "2. గర్భాదానం"
              },
              {
                "title": "3. పుంసవనం"
              },
              {
                "title": "4. సీమంతం"
              },
              {
                "title": "5. జాతకకర్మ"
              },
              {
                "title": "6. నామకరణం"
              },
              {
                "title": "7. అన్నప్రాశనం"
              },
              {
                "title": "8. చూడకర్మ"
              },
              {
                "title": "9. ఉపనయనం"
              },
              {
                "title": "10. సమవర్తనం"
              }
            ]
          },
          {
            "title": "దశ మహాదానాలు",
            "subtitle": [
              {
                "title": "దశ మహాదానాలు 10 అవి :"
              },
              {
                "title": "1. గో"
              },
              {
                "title": "2. సువర్ణ"
              },
              {
                "title": "3. రజతం"
              },
              {
                "title": "4. ధాన్యం"
              },
              {
                "title": "5. వస్త్ర"
              },
              {
                "title": "6. నెయ్యి"
              },
              {
                "title": "7. తిల"
              },
              {
                "title": "8. సాలగ్రామం"
              },
              {
                "title": "9. లవణం"
              },
              {
                "title": "10. బెల్లం"
              }
            ]
          },
          {
            "title": "అర్జునుడికి గల పేర్లు",
            "subtitle": [
              {
                "title": "అర్జునుడికి గల పేర్లు 10 అవి :"
              },
              {
                "title": "1. అర్జునుడు"
              },
              {
                "title": "2. పార్ధుడు"
              },
              {
                "title": "3. కిరీటి"
              },
              {
                "title": "4. శ్వేతవాహనుడు"
              },
              {
                "title": "5. బీభత్సుడు"
              },
              {
                "title": "6. జిష్ణుడు"
              },
              {
                "title": "7. విజయుడు"
              },
              {
                "title": "8. సవ్యసాచి"
              },
              {
                "title": "9. ధనుంజయుడు"
              },
              {
                "title": "10. పాల్గుణుడు"
              }
            ]
          },
          {
            "title": "దశ బలములు",
            "subtitle": [
              {
                "title": "దశ బలములు 10 అవి :"
              },
              {
                "title": "1. విద్య"
              },
              {
                "title": "2. స్నేహ"
              },
              {
                "title": "3. బుద్ధి"
              },
              {
                "title": "4. ధన"
              },
              {
                "title": "5. పరివార"
              },
              {
                "title": "6. సత్య"
              },
              {
                "title": "7. సామర్ధ్య"
              },
              {
                "title": "8. జ్ఞాన"
              },
              {
                "title": "9. దైవ"
              },
              {
                "title": "10. కులినిత"
              }
            ]
          },
          {
            "title": "దశావతారాలు",
            "subtitle": [
              {
                "title": "దశావతారాలు 10 అవి :"
              },
              {
                "title": "1. మత్స్య"
              },
              {
                "title": "2. కూర్మ"
              },
              {
                "title": "3. వరాహ"
              },
              {
                "title": "4. నరసింహ"
              },
              {
                "title": "5. వామన"
              },
              {
                "title": "6. పరశురామ"
              },
              {
                "title": "7. శ్రీరామ"
              },
              {
                "title": "8. శ్రీకృష్ణ"
              },
              {
                "title": "9. బుద్ధ"
              },
              {
                "title": "10. కల్కి"
              }
            ]
          },
          {
            "title": "వాయువులు",
            "subtitle": [
              {
                "title": "వాయువులు 10 అవి :"
              },
              {
                "title": "1. అపాన"
              },
              {
                "title": "2. సమాన"
              },
              {
                "title": "3. ప్రాణ"
              },
              {
                "title": "4. ఉదాన"
              },
              {
                "title": "5. వ్యాన"
              },
              {
                "title": "6. కూర్మ"
              },
              {
                "title": "7. కృకర"
              },
              {
                "title": "8. నాగ"
              },
              {
                "title": "9. దేవదత్త"
              },
              {
                "title": "10. ధనంజమ"
              }
            ]
          }
        ],
        "title": "పది యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "జ్యోతిర్లింగాలు",
            "subtitle": [
              {
                "title": "జ్యోతిర్లింగాలు 12 అవి :"
              },
              {
                "title": "1. కేదారేశ్వరలింగం, హిమలయపర్వతం"
              },
              {
                "title": "2. కాశీవిశ్వేశ్వరుడు, కాశీ"
              },
              {
                "title": "3. మహాకాలేశ్వరలింగం, మధ్యప్రదేశ్"
              },
              {
                "title": "4. ఓంకారేశ్వరలింగం, మధ్యప్రదేశ్"
              },
              {
                "title": "5. సోమనాధలింగం, గుజరాత్"
              },
              {
                "title": "6. నాగేశ్వరలింగం, గుజరాత్"
              },
              {
                "title": "7. భీమశంకరం, మహారాష్ట్ర"
              },
              {
                "title": "8. త్ర్యంబకేశ్వరం, మహారాష్ట్ర"
              },
              {
                "title": "9. ఘృష్ణేశ్వరం, మహారాష్ట్ర"
              },
              {
                "title": "10. వైద్యనాదేశ్వరం, మహారాష్ట్ర"
              },
              {
                "title": "11. మల్లిఖార్జునలింగం, ఆంధ్రప్రదేశ్"
              },
              {
                "title": "12. రామలింగేశ్వరం, తమిళనాడు"
              }
            ]
          }
        ],
        "title": "పన్నెండు యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "అవస్థ దేవతలు",
            "subtitle": [
              {
                "title": "అవస్థ దేవతలు 14 అవి :"
              },
              {
                "title": "1. దిక్కు"
              },
              {
                "title": "2. వాయువు"
              },
              {
                "title": "3. సూర్యుడు"
              },
              {
                "title": "4. వరుణుడు"
              },
              {
                "title": "5. అశ్వీని దేవతలు"
              },
              {
                "title": "6. ఆగ్ని"
              },
              {
                "title": "7. ఇంద్రుడు"
              },
              {
                "title": "8. ఉపేంద్రుడు"
              },
              {
                "title": "9. మృత్యువు"
              },
              {
                "title": "10. చంద్రుడు"
              },
              {
                "title": "11. చతర్వకుడు"
              },
              {
                "title": "12. రుద్రుడు"
              },
              {
                "title": "13. క్షేత్రజ్ఞుడు"
              },
              {
                "title": "14. ఈశానుడు"
              }
            ]
          }
        ],
        "title": "పద్నాలుగు యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "షోడశ మహాదానాలు",
            "subtitle": [
              {
                "title": "షోడశ మహాదానాలు 16 అవి :"
              },
              {
                "title": "1. గో"
              },
              {
                "title": "2. భూ"
              },
              {
                "title": "3. తిల"
              },
              {
                "title": "4. రత్న"
              },
              {
                "title": "5. హిరణ్య"
              },
              {
                "title": "6. విద్య"
              },
              {
                "title": "7. దాసి"
              },
              {
                "title": "8. కన్య"
              },
              {
                "title": "9. శయ్య"
              },
              {
                "title": "10. గృహ"
              },
              {
                "title": "11. అగ్రహార"
              },
              {
                "title": "12. రధ"
              },
              {
                "title": "13. గజ"
              },
              {
                "title": "14. అశ్వ"
              },
              {
                "title": "15. ఛాగ (మేక)"
              },
              {
                "title": "16. మహిషి (దున్నపోతు)"
              }
            ]
          }
        ],
        "title": "పదహారు యొక్క ప్రాధాన్యత"
      },
      {
        "telugu": [
          {
            "title": "అష్టాదశవర్ణనలు",
            "subtitle": [
              {
                "title": "అష్టాదశవర్ణనలు 18 అవి :"
              },
              {
                "title": "1. నగరం"
              },
              {
                "title": "2. సముద్రం"
              },
              {
                "title": "3. ఋతువు"
              },
              {
                "title": "4. చంద్రోదయం"
              },
              {
                "title": "5. అర్కోదయం"
              },
              {
                "title": "6. ఉద్యానము"
              },
              {
                "title": "7. సలిలక్రీడ"
              },
              {
                "title": "8. మధుపానం"
              },
              {
                "title": "9. రతోత్సవం"
              },
              {
                "title": "10. విప్రలంభం"
              },
              {
                "title": "11. వివాహం"
              },
              {
                "title": "12. పుత్రోత్పత్తి"
              },
              {
                "title": "13. మంత్రము"
              },
              {
                "title": "14. ద్యూతం"
              },
              {
                "title": "15. ప్రయాణం"
              },
              {
                "title": "16. నాయకాభ్యుదయం"
              },
              {
                "title": "17. శైలము"
              },
              {
                "title": "18. యుద్ధం"
              }
            ]
          },
          {
            "title": "అష్టాదశ పురాణాలు",
            "subtitle": [
              {
                "title": "అష్టాదశ పురాణాలు 18 అవి :"
              },
              {
                "title": "1. మార్కండేయ"
              },
              {
                "title": "2. మత్స్య"
              },
              {
                "title": "3. భవిష్య"
              },
              {
                "title": "4. భాగవత"
              },
              {
                "title": "5. బ్రహ్మ"
              },
              {
                "title": "6. బ్రహ్మవైవర్త"
              },
              {
                "title": "7. బ్రహ్మాండ"
              },
              {
                "title": "8. విష్ణు"
              },
              {
                "title": "9. వాయు"
              },
              {
                "title": "10. వరాహ"
              },
              {
                "title": "11. వామన"
              },
              {
                "title": "12. అగ్ని"
              },
              {
                "title": "13. నారద"
              },
              {
                "title": "14. పద్మ"
              },
              {
                "title": "15. లింగ"
              },
              {
                "title": "16. గరుడ"
              },
              {
                "title": "17. కూర్మ"
              },
              {
                "title": "18. స్కాంద"
              }
            ]
          },
          {
            "title": "భారతంలోపర్వాలు",
            "subtitle": [
              {
                "title": "భారతంలోపర్వాలు 18 అవి :"
              },
              {
                "title": "1. ఆది"
              },
              {
                "title": "2. సభా"
              },
              {
                "title": "3. అరణ్య"
              },
              {
                "title": "4. విరాట"
              },
              {
                "title": "5. ఉద్యోగ"
              },
              {
                "title": "6. భీష్మ"
              },
              {
                "title": "7. ద్రోణ"
              },
              {
                "title": "8. కర్ణ"
              },
              {
                "title": "9. శల్య"
              },
              {
                "title": "10. సౌప్తిక"
              },
              {
                "title": "11. స్ర్తి"
              },
              {
                "title": "12. శాంతి"
              },
              {
                "title": "13. అనుశాసన"
              },
              {
                "title": "14. అశ్వమేధ"
              },
              {
                "title": "15. ఆశ్రమవాస"
              },
              {
                "title": "16. మౌసల"
              },
              {
                "title": "17. మహాప్రస్థాన"
              },
              {
                "title": "18. స్వర్గారోహణ"
              }
            ]
          },
          {
            "title": "పురాణాల పేర్లు",
            "subtitle": [
              {
                "title": "పురాణాల పేర్లు 18 అవి :"
              },
              {
                "title": "1. మత్స్యపురాణం"
              },
              {
                "title": "2. కూర్మపురాణం"
              },
              {
                "title": "3. వామన పురాణం"
              },
              {
                "title": "4. వరాహ పురాణం"
              },
              {
                "title": "5. గరుడ పురాణం"
              },
              {
                "title": "6. వాయు పురాణం"
              },
              {
                "title": "7. నారద పురాణం"
              },
              {
                "title": "8. స్కాంద పురాణం"
              },
              {
                "title": "9. విష్ణుపురాణం"
              },
              {
                "title": "10. భాగవత పురాణం"
              },
              {
                "title": "11. అగ్నిపురాణం"
              },
              {
                "title": "12. బ్రహ్మపురాణం"
              },
              {
                "title": "13. పద్మపురాణం"
              },
              {
                "title": "14. మార్కండేయ పురాణం"
              },
              {
                "title": "15. బ్రహ్మవైవర్త పురాణం"
              },
              {
                "title": "16. లింగపురాణం"
              },
              {
                "title": "17. బ్రహ్మాండ పురాణం"
              },
              {
                "title": "18. భవిష్యపురాణం"
              }
            ]
          }
        ],
        "title": "పద్దెనిమిది యొక్క ప్రాధాన్యత"
      }
    ]
  },
  "kolethelu": {
    "CatID": [
      {
        "measure": "= 0.03937 అంగుళం",
        "title": "1 మిల్లీ మీటరు"
      },
      {
        "measure": "= 1 సెంటీ మీటరు",
        "title": "10 మిల్లీ మీటర్లు"
      },
      {
        "measure": "= 0.3937 అంగుళం",
        "title": "1 సెంటీ మీటరు"
      },
      {
        "measure": "= 0.083 అడుగు",
        "title": "1 అంగుళం"
      },
      {
        "measure": "= 0.9144 మీటరు",
        "title": "1 గజం"
      },
      {
        "measure": "= 1 డెస్సీ మీటరు",
        "title": "10 సెంటీ మీటర్లు"
      },
      {
        "measure": "= 1 మీటరు",
        "title": "10 డెస్సీ మీటర్లు"
      },
      {
        "measure": "= 1 మీటరు",
        "title": "100 సెంటీ మీటర్లు"
      },
      {
        "measure": "= 39.3701 అంగుళాలు",
        "title": "1 మీటరు"
      },
      {
        "measure": "= 1 డెకా మీటరు",
        "title": "10 మీటర్లు"
      },
      {
        "measure": "= 1 హెక్టా మీటరు",
        "title": "10 డెకా మీటర్లు"
      },
      {
        "measure": "= 1 కిలో మీటరు",
        "title": "10 హెక్టా మీటర్లు"
      },
      {
        "measure": "= 1 మైలు",
        "title": "1.609 కిలో మీటరు"
      },
      {
        "measure": "= 10.7639 చదరపు అడుగులు",
        "title": "1 చదరపు మీటరు"
      },
      {
        "measure": "= 0.386 చదరపు మైల్లు",
        "title": "1 చదరపు కిలోమీటరు"
      },
      {
        "measure": "= 2.59 చదరపు కిలోమీటరు",
        "title": "1 చదరపు మైలు"
      },
      {
        "measure": "= 0.451 చదరపు కిలోమీటర్లు",
        "title": "1 చదరపు అడుగు"
      },
      {
        "measure": "= 0.0929 చదరపు మీటరు",
        "title": "1 చదరపు అడుగు"
      },
      {
        "measure": "= 0.18361 చదరపు మీటరు",
        "title": "1 చదరపు గజం"
      }
    ],
    "title": "కొలతలు"
  },
  "Teluguyears": [
    {
      "CatID": [
        {
          "title": "1. ప్రభవ నామ సంవత్సరం"
        },
        {
          "title": "(యజ్ఞములు ఎక్కువగా జరుగుతాయని అర్థం)"
        }
      ],
      "title": "1927, 1987, 2047, 2107"
    },
    {
      "CatID": [
        {
          "title": "2. విభవ నామ సంవత్సరం"
        },
        {
          "title": "(ప్రజలు సుఖసంతోషాలతో జీవిస్తారు)"
        }
      ],
      "title": "1928, 1988, 2048, 2108"
    },
    {
      "CatID": [
        {
          "title": "3. శుక్ల నామ సంవత్సరం"
        },
        {
          "title": "(సమృద్ధిగా పంటలు పండుతాయనే సంకేతమిస్తుంది)"
        }
      ],
      "title": "1929, 1989, 2049, 2109"
    },
    {
      "CatID": [
        {
          "title": "4. ప్రమోదూత నామ సంవత్సరం"
        },
        {
          "title": "(అందరికీ ఆనందం పంచుతుందని అర్థం)"
        }
      ],
      "title": "1930, 1990, 2050, 2110"
    },
    {
      "CatID": [
        {
          "title": "5. ప్రజోత్పత్తి నామ సంవత్సరం"
        },
        {
          "title": "(అన్నింటా అభివృద్ధి చెందడాన్ని సూచిస్తుంది)"
        }
      ],
      "title": "1931, 1991, 2051, 2111"
    },
    {
      "CatID": [
        {
          "title": "6. అంగీరస నామ సంవత్సరం"
        },
        {
          "title": "(భోగభాగ్యములు కలగాలనే అర్థాన్నిస్తుంది)"
        }
      ],
      "title": "1932, 1992, 2052, 2112"
    },
    {
      "CatID": [
        {
          "title": "7. శ్రీముఖ నామ సంవత్సరం"
        },
        {
          "title": "(వనరులన్నీ సమృద్ధిగా అందుతాయని అర్థం)"
        }
      ],
      "title": "1933, 1993, 2053, 2113"
    },
    {
      "CatID": [
        {
          "title": "8. భావ నామ సంవత్సరం"
        },
        {
          "title": "(సద్భావనలు, ఉన్నత భావాలు కలిగి ఉండాలని తెలుపుతుంది)"
        }
      ],
      "title": "1934, 1994, 2054, 2114"
    },
    {
      "CatID": [
        {
          "title": "9. యువ నామ సంవత్సరం"
        },
        {
          "title": "(సమృద్ధిగా వర్షాలు కురిసి, పాడిపంటలతో ప్రజలు సుఖంగా ఉండాలి)"
        }
      ],
      "title": "1935, 1995, 2055, 2115"
    },
    {
      "CatID": [
        {
          "title": "10. ధాత నామ సంవత్సరం"
        },
        {
          "title": "(అనారోగ్య బాధలు తొలుగుతాయని, ఔషధాలు ఫలిస్తాయని చెబుతుంది)"
        }
      ],
      "title": "1936, 1996, 2056, 2116"
    },
    {
      "CatID": [
        {
          "title": "11. ఈశ్వర నామ సంవత్సరం"
        },
        {
          "title": "(అందరూ క్షేమంగా, సంపూర్ణ ఆరోగ్యంతో ఉండాలని అర్థం)"
        }
      ],
      "title": "1937, 1997, 2057, 2117"
    },
    {
      "CatID": [
        {
          "title": "12. బహుధాన్య నామ సంవత్సరం"
        },
        {
          "title": "(దేశమంతా సుభిక్షంగా, సంతోషంగా ఉండాలని సూచిస్తుంది)"
        }
      ],
      "title": "1938, 1998, 2058, 2118"
    },
    {
      "CatID": [
        {
          "title": "13. ప్రమాది నామ సంవత్సరం"
        },
        {
          "title": "(వర్షాలు మధ్యస్థంగా ఉంటాయి)"
        }
      ],
      "title": "1939, 1999, 2059, 2119"
    },
    {
      "CatID": [
        {
          "title": "14. విక్రమ నామ సంవత్సరం"
        },
        {
          "title": "(సమృద్ధిగా పంటలు పండిస్తూ, అన్నింటా విజయం సాధిస్తారని అర్థం)"
        }
      ],
      "title": "1940, 2000, 2060, 2120"
    },
    {
      "CatID": [
        {
          "title": "15. వృష నామ సంవత్సరం"
        },
        {
          "title": "(వర్షాలు సమృద్ధిగా కురుస్తాయని తెలుపుతుంది)"
        }
      ],
      "title": "1941, 2001, 2061, 2121"
    },
    {
      "CatID": [
        {
          "title": "16. చిత్రభాను నామ సంవత్సరం"
        },
        {
          "title": "(అంచనాలకు అందని ఫలితాలు పొందుతారు)"
        }
      ],
      "title": "1942, 2002, 2062, 2122"
    },
    {
      "CatID": [
        {
          "title": "17. స్వభాను నామ సంవత్సరం"
        },
        {
          "title": "(ప్రజలకు క్షేమం, ఆనందం, ఆరోగ్యం అందుతాయని అర్థం)"
        }
      ],
      "title": "1943, 2003, 2063, 2123"
    },
    {
      "CatID": [
        {
          "title": "18. తారణ నామ సంవత్సరం"
        },
        {
          "title": "(సరైన సమయంలో వర్షాలు కురుస్తాయి)"
        }
      ],
      "title": "1944, 2004, 2064, 2124"
    },
    {
      "CatID": [
        {
          "title": "19. పార్థివ నామ సంవత్సరం"
        },
        {
          "title": "(సంపద సిద్ధిస్తుంది)"
        }
      ],
      "title": "1945, 2005, 2065, 2125"
    },
    {
      "CatID": [
        {
          "title": "20. వ్యయ నామ సంవత్సరం"
        },
        {
          "title": "(అతివృష్టి, అధిక ఖర్చులని సూచిస్తుంది)"
        }
      ],
      "title": "1946, 2006, 2066, 2126"
    },
    {
      "CatID": [
        {
          "title": "21. సర్వజిత్తు నామ సంవత్సరం"
        },
        {
          "title": "(ప్రజలకు అనుకూలించే వర్షాలు కురుయును)"
        }
      ],
      "title": "1947, 2007, 2067, 2127"
    },
    {
      "CatID": [
        {
          "title": "22. సర్వధారి నామ సంవత్సరం"
        },
        {
          "title": "(అందరూ సుభిక్షంగా ఉండాలని అర్థం)"
        }
      ],
      "title": "1948, 2008, 2068, 2128"
    },
    {
      "CatID": [
        {
          "title": "23. విరోధి నామ సంవత్సరం"
        },
        {
          "title": "(వర్షాలు తక్కువగా కురుస్తాయి)"
        }
      ],
      "title": "1949, 2009, 2069, 2129"
    },
    {
      "CatID": [
        {
          "title": "24. వికృతి నామ సంవత్సరం"
        },
        {
          "title": "(అశుభ, ప్రతికూల ఫలితాలు సూచిస్తుంది)"
        }
      ],
      "title": "1950, 2010, 2070, 2130"
    },
    {
      "CatID": [
        {
          "title": "25. ఖర నామ సంవత్సరం"
        },
        {
          "title": "(సామాన్య పరిస్థితులు ఉంటాయి)"
        }
      ],
      "title": "1951, 2011, 2071, 2131"
    },
    {
      "CatID": [
        {
          "title": "26. నందన నామ సంవత్సరం"
        },
        {
          "title": "(ప్రజలు ఆనందంతో ఉంటారు)"
        }
      ],
      "title": "1952, 2012, 2072, 2132"
    },
    {
      "CatID": [
        {
          "title": "27. విజయ నామ సంవత్సరం"
        },
        {
          "title": "(శత్రువుపై విజయం సాధిస్తారు)"
        }
      ],
      "title": "1953, 2013, 2073, 2133"
    },
    {
      "CatID": [
        {
          "title": "28. జయ నామ సంవత్సరం"
        },
        {
          "title": "(కార్యసిద్ధి, రుగ్మతలను జయిస్తారు)"
        }
      ],
      "title": "1954, 2014, 2074, 2134"
    },
    {
      "CatID": [
        {
          "title": "29. మన్మథ నామ సంవత్సరం"
        },
        {
          "title": "(భోగభాగ్యాలు సిద్ధించి, ఆరోగ్యంగా ఉంటారు. బాధలు తొలిగిపోతాయి)"
        }
      ],
      "title": "1955, 2015, 2075 , 2135"
    },
    {
      "CatID": [
        {
          "title": "30. దుర్ముఖి నామ సంవత్సరం"
        },
        {
          "title": "(ఇబ్బందులున్నా క్షేమకర ఫలితాలు పొందుతారు)"
        }
      ],
      "title": "1956, 2016, 2076, 2136"
    },
    {
      "CatID": [
        {
          "title": "31. హేవిలంబి నామ సంవత్సరం"
        },
        {
          "title": "(ప్రజలంతా సంతోషంగా ఉంటారు)"
        }
      ],
      "title": "1957, 2017, 2077, 2137"
    },
    {
      "CatID": [
        {
          "title": "32. విలంబి నామ సంవత్సరం"
        },
        {
          "title": "(అంతా సుభిక్షంగా ఉంటారిని అర్థం)"
        }
      ],
      "title": "1958, 2018, 2078, 2138"
    },
    {
      "CatID": [
        {
          "title": "33. వికారి నామ సంవత్సరం"
        },
        {
          "title": "(శత్రువుల నుంచి ఇబ్బందులు ఎదురవుతాయి)"
        }
      ],
      "title": "1959, 2019, 2079, 2139"
    },
    {
      "CatID": [
        {
          "title": "34. శార్వరి నామ సంవత్సరం"
        },
        {
          "title": "(పంటల దిగుబడి సాఽధారణంగా ఉంటుంది)"
        }
      ],
      "title": "1960, 2020, 2080, 2140"
    },
    {
      "CatID": [
        {
          "title": "35. ప్లవ నామ సంవత్సరం"
        },
        {
          "title": "(నీటి వనరులు పుష్కలంగా ఉంటాయి)"
        }
      ],
      "title": "1961, 2021, 2081, 2141"
    },
    {
      "CatID": [
        {
          "title": "36. శుభకృతు నామ సంవత్సరం"
        },
        {
          "title": "(ప్రజలు సుఖంగా జీవిస్తారు)"
        }
      ],
      "title": "1962, 2022, 2082, 2142"
    },
    {
      "CatID": [
        {
          "title": "37. శోభకృతు నామ సంవత్సరం"
        },
        {
          "title": "(సుఖసంతోషాలు వెల్లువిరుస్తాయి)"
        }
      ],
      "title": "1963, 2023, 2083, 2143"
    },
    {
      "CatID": [
        {
          "title": "38. క్రోధి నామ సంవత్సరం"
        },
        {
          "title": "(కోప స్వభావంతో సామాన్య ఫలితాలు పొందుతారు)"
        }
      ],
      "title": "1964, 2024, 2084, 2144"
    },
    {
      "CatID": [
        {
          "title": "39. విశ్వావసు నామ సంవత్సరం"
        },
        {
          "title": "(ధనం సమృద్ధిగా లభిస్తుంది)"
        }
      ],
      "title": "1965, 2025, 2085, 2145"
    },
    {
      "CatID": [
        {
          "title": "40. పరాభవ నామ సంవత్సరం"
        },
        {
          "title": "(ఓటములు ఎదురవుతాయి)"
        }
      ],
      "title": "1966, 2026, 2086, 2146"
    },
    {
      "CatID": [
        {
          "title": "41. ప్లవంగ నామ సంవత్సరం"
        },
        {
          "title": "(నీరు సమృద్ధిగా లభించును)"
        }
      ],
      "title": "1967, 2027, 2087, 2147"
    },
    {
      "CatID": [
        {
          "title": "42. కీలక నామ సంవత్సరం"
        },
        {
          "title": "(పంటలు విశేషంగా పండుతాయి)"
        }
      ],
      "title": "1968, 2028, 2088, 2148"
    },
    {
      "CatID": [
        {
          "title": "43. సౌమ్య నామ సంవత్సరం"
        },
        {
          "title": "(అందరికీ శుభాలు కలుగుతాయి)"
        }
      ],
      "title": "1969, 2029, 2089, 2149"
    },
    {
      "CatID": [
        {
          "title": "44. సాధారణ నామ సంవత్సరం"
        },
        {
          "title": "(సామాన్య ఫలితాలు కలుగుతాయి)"
        }
      ],
      "title": "1970, 2030, 2090, 2150"
    },
    {
      "CatID": [
        {
          "title": "45. విరోధికృతు నామ సంవత్సరం"
        },
        {
          "title": "(ప్రజల్లో వైరుధ్య భావాలు ఏర్పడతాయి)"
        }
      ],
      "title": "1971, 2031, 2091, 2151"
    },
    {
      "CatID": [
        {
          "title": "46. పరీధావి నామ సంవత్సరం"
        },
        {
          "title": "(భయాలు కలుగుతాయి)"
        }
      ],
      "title": "1972, 2032, 2092, 2152"
    },
    {
      "CatID": [
        {
          "title": "47. ప్రమాదీచ నామ సంవత్సరం"
        },
        {
          "title": "(ప్రమాదాలు ఎక్కువగా సంభవించును)"
        }
      ],
      "title": "1973, 2033, 2093, 2153"
    },
    {
      "CatID": [
        {
          "title": "48. ఆనంద నామ సంవత్సరం"
        },
        {
          "title": "(అంతా ఆనందమయమేనని అర్థం)"
        }
      ],
      "title": "1974, 2034, 2094, 2154"
    },
    {
      "CatID": [
        {
          "title": "49. రాక్షస నామ సంవత్సరం"
        },
        {
          "title": "(కఠినత్వం పెరగుతుంది. దుస్సంఘటనలు సంభవిస్తాయి)"
        }
      ],
      "title": "1975, 2035, 2095, 2155"
    },
    {
      "CatID": [
        {
          "title": "50. నల నామ సంవత్సరం"
        },
        {
          "title": "(సస్య సమృద్ధి కలుగుతుంది)"
        }
      ],
      "title": "1976, 2036, 2096, 2156"
    },
    {
      "CatID": [
        {
          "title": "51. పింగళ నామ సంవత్సరం"
        },
        {
          "title": "(సామాన్య ఫలితాలు కలుగుతాయి)"
        }
      ],
      "title": "1977, 2037, 2097, 2157"
    },
    {
      "CatID": [
        {
          "title": "52. కాళయుక్తి నామ సంవత్సరం"
        },
        {
          "title": "(కాలానికి అనుగుణమైన ఫలితాలు వస్తాయి)"
        }
      ],
      "title": "1978, 2038, 2098, 2158"
    },
    {
      "CatID": [
        {
          "title": "53. సిధ్ధార్థి నామ సంవత్సరం"
        },
        {
          "title": "(అన్ని కార్యాలు సిద్ధిస్తాయి)"
        }
      ],
      "title": "1979, 2039, 2099, 2159"
    },
    {
      "CatID": [
        {
          "title": "54. రౌద్రి నామ సంవత్సరం"
        },
        {
          "title": "(బాధలు కలుగుతాయి)"
        }
      ],
      "title": "1980, 2040, 2100, 2160"
    },
    {
      "CatID": [
        {
          "title": "55. దుర్మతి నామ సంవత్సరం"
        },
        {
          "title": "(సామాన్య వర్షాలు కురుస్తాయి)"
        }
      ],
      "title": "1981, 2041, 2101, 2161"
    },
    {
      "CatID": [
        {
          "title": "56. దుందుభి నామ సంవత్సరం"
        },
        {
          "title": "(ధాన్య సమృద్ధితో పాటు అంతా క్షేమంగా ఉంటారు)"
        }
      ],
      "title": "1982, 2042, 2102, 2162"
    },
    {
      "CatID": [
        {
          "title": "57. రుధిరోద్గారి నామ సంవత్సరం"
        },
        {
          "title": "(ప్రమాదాలు అధికం)"
        }
      ],
      "title": "1983, 2043, 2103, 2163"
    },
    {
      "CatID": [
        {
          "title": "58. రక్తాక్షి నామ సంవత్సరం"
        },
        {
          "title": "(అశుభాలకు సంకేతం, సామాన్య ఫలితాలు వస్తాయి)"
        }
      ],
      "title": "1984, 2044, 2104, 2164"
    },
    {
      "CatID": [
        {
          "title": "59. క్రోధన నామ సంవత్సరం"
        },
        {
          "title": "(అన్నింటా విజయం సిద్ధిస్తుంది)"
        }
      ],
      "title": "1985, 2045, 2105, 2165"
    },
    {
      "CatID": [
        {
          "title": "60. అక్షయ నామ సంవత్సరం"
        },
        {
          "title": "(అధిక సంపదలను సూచిస్తుంది)"
        }
      ],
      "title": "1986, 2046, 2106, 2166"
    }
  ],
  "numericastrology": {
    "letter": [
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ],
    "luckycolor": [
      "Pink",
      "White",
      "Blue",
      "Black",
      "Mixed Color",
      "Blue",
      "Green",
      "Red",
      "Yellow",
      "White",
      "Pink",
      "Gray",
      "Purple",
      "Yellow",
      "Cream",
      "Cream",
      "Gray",
      "Gray",
      "Pink",
      "White",
      "Red",
      "Green",
      "Blue",
      "Mixed Color",
      "Cream",
      "Pink",
      "Blue",
      "Gray",
      "Blue",
      "White",
      "Yellow",
      "Green"
    ],
    "luckyday": [
      "Tue",
      "Fri",
      "Sat",
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Tue",
      "Fri",
      "Sat",
      "Mon",
      "Tue",
      "Fri",
      "Sat",
      "Fri",
      "Fri",
      "Mon",
      "Sun",
      "Sat",
      "Fri",
      "Tue",
      "Mon",
      "Sun",
      "Sat",
      "Fri",
      "Tue",
      "Thu",
      "Mon",
      "Sat",
      "Sun",
      "Fri",
      "Tue"
    ],
    "luckynumber": [
      2,
      5,
      6,
      3,
      6,
      8,
      9,
      1,
      2,
      3,
      3,
      4,
      5,
      6,
      8,
      8,
      7,
      6,
      5,
      1,
      2,
      3,
      4,
      7,
      1,
      6,
      9,
      6,
      8,
      7,
      1,
      5
    ],
    "negative": [
      "Selfishness, laziness, destruction",
      "Sarcasm, coldness, sensitiveness",
      "Timidity, vacillation, tactless",
      "Laginess, stagnation, pessimism",
      "Restriction, unconventional, sternness",
      "Inability, slowness, postponement",
      "Inferiority, anger, impatience",
      "Carelessness, changeability, restlessness",
      "Luxurious,false pride, high desire",
      "Sarcasm, coldness, sensitiveness",
      "Inability, slowness, postponement",
      "Inferiority, anger, impatience",
      "Selfishness, laziness, destruction",
      "Timidity, vacillation, tactless",
      "Restriction, unconventional, sternness",
      "Carelessness, changeability, restlessness",
      "Luxurious,false pride, high desire",
      "Laginess, stagnation, pessimism",
      "Sarcasm, coldness, sensitiveness",
      "Inability, slowness, postponement",
      "Inferiority, anger, impatience",
      "Selfishness, laziness, destruction",
      "Timidity, vacillation, tactless",
      "Restriction, unconventional, sternness",
      "Carelessness, changeability, restlessness",
      "Luxurious,false pride, high desire",
      "Laginess, stagnation, pessimism",
      "Sarcasm, coldness, sensitiveness",
      "Inability, slowness, postponement",
      "Inferiority, anger, impatience",
      "Selfishness, laziness, destruction",
      "Inferiority, anger, impatience"
    ],
    "positive": [
      "Occultism, mental analysis, Research, Spirituality, study",
      "Originality, leadership, ambition, progress, official",
      "Harmony, co-operation,diplomacy,affection, expression",
      "Sociablility,optimism, teaching, politics, leadership",
      "Practicality, economy, organisation, loyalty, discovery",
      "Dynamism, energy, courage, brotherhood, action",
      "Executive ability, judgement, union-leadership, patience",
      "Domesticity, artistic, fine tastes, teaching, responsibility",
      "Versatality, mental curiosity, travel, business, teaching,law",
      "Harmony, co-operation,diplomacy,affection, expression",
      "Originality, leadership, ambition, progress, official",
      "Dynamism, energy, courage, brotherhood, action",
      "Executive ability, judgement, union-leadership, patience",
      "Practicality, economy, organisation, loyalty, discovery",
      "Sociablility,optimism, teaching, politics, leadership",
      "Occultism, mental analysis, Research, Spirituality, study",
      "Domesticity, artistic, fine tastes, teaching, responsibility",
      "Versatality, mental curiosity, travel, business, teaching,law",
      "Harmony, co-operation,diplomacy,affection, expression",
      "Originality, leadership, ambition, progress, official",
      "Dynamism, energy, courage, brotherhood, action",
      "Executive ability, judgement, union-leadership, patience",
      "Practicality, economy, organisation, loyalty, discovery",
      "Sociablility,optimism, teaching, politics, leadership",
      "Occultism, mental analysis, Research, Spirituality, study",
      "Domesticity, artistic, fine tastes, teaching, responsibility",
      "Versatality, mental curiosity, travel, business, teaching,law",
      "Harmony, co-operation,diplomacy,affection, expression",
      "Originality, leadership, ambition, progress, official",
      "Dynamism, energy, courage, brotherhood, action",
      "Executive ability, judgement, union-leadership, patience",
      "Versatality, mental curiosity, travel, business, teaching,law"
    ],
    "text": [
      "Hello , Your Name number is 1.It indicates that you are ambitious and independent with a creative bent of mind. You will excel in professions where managerial qualities are required. You will see any work completed. You are worried about name and fame and do not yield to flattery. You want to lead others and do not want to follow. You will excuse others if they bend before you.",
      "Hello , Your Name number is 2.It indicates that you are romantic, emotional, imaginative and inventive. You love to change and this leads to frequent travels.  You change your decisions. You like good food and drinks. You will have two sources of income. You will earn name and fame elsewhere outside your native place.  You are family- oriented and respect old customs.",
      "Hello , Your Name number is 3.This number indicates that idealism, religion, expansion and optimism. You can easily spot any deception and dishonesty. You feel responsible in your work. You are a leader and good organizer. You do not want to be a subordinate to others. You will excel in a government sector where power and authority is important.",
      "Hello , Your Name number is 4.This number indicates that you view everything from an opposite angle. This mentality wil\tl make secrete enemies for you. You will concentrate more on future than on present. You are unconventional and become a revolutionist. You excel in mathematics and law. You are more prone to skin diseases.",
      "Hello , Your Name number is 5.It indicates versatility and communication. You will have skill in different subjects and very tactful in your speech. You are calculative in spending money. You love commerce, finance and banking related subjects. Since your analysis will be generally correct, you will excel in stock exchange and shares.",
      "Hello , Your Name number is 6.It indicates magnetism and love You like to dress neatly and attractive to others. You are soft with sweet voice. You involve into love affairs and spend money on luxurious articles. You are fit for professions where artistic nature involved. You should control jealousy.",
      "Hello , Your Name number is 7.This number indicates spirituality, mystery and sensitivity. You are sympathetic to the feelings of others. Your dreams often come true. You have interest in mysterious things like gods and devils. Your philosophical outlook will become an obstacle in earning money. You love reading books and enjoy indoor sports.",
      "Hello , Your Name number is 8.It indicates patience and duty. You are misunderstood most often by others. You have a warm heart but you appear cold and undemonstrative to others. You will see either great failures or great success in your life. You maintain limitations in every thing. Your spouse will have a dominating nature.",
      "Hello , Your Name number is 9.This number represents stubborn nature, courage and aggressiveness. You are action-oriented and do not want to waste time in thinking. You are straight forward and you do not care even your superiors. You feel life is a battle and hence you make enemies quickly. You should control your anger and be diplomatic.",
      "Hello , Your Name number is 10.This number is a symbol of warnings of hidden dangers, trial and treachery from others. You will face difficulty in uniting many separated things. There would be conflict in every sphere of life. There would be a third party involvement in your personal affairs which ruin your life.",
      "Hello , Your Name number is 11.The symbolism of this number is suffering and anxiety of mind. You should be alert in every situation and beware of false flattery from others. You will become victim of others misdeeds. You will suffer from emotional stress and mental anguish as a result of bitter lessons you will learn.",
      "Hello , Your Name number is 12.This number indicates change of plans, place and regeneration of new ideas. It is a symbol of power which if wrongly used will wreak destruction upon itself. Unknown and sudden misfortunes will fall on you. Financial loss and ill health are indicated.",
      "Hello , Your Name number is 13.It indicates danger from natural forces such as storms, water, air, fire etc. You will have success in communication, writing, publishing and all media related matters. You will lose in betting, speculation and stock market. ",
      "Hello , Your Name number is 14.It represents magic and mystery. You will talk convincingly. You love music, art and drama. You can obtain money, gifts and favors from others. Do not use your mystical powers for selfish purpose. With them, you can bring great happiness to others.",
      "Hello , Your Name number is 15.This number indicates danger of accidents and the defeat of one's plans. If you follow your inner voice, you can escape from dangers. You may reach top most position in your profession, but there would be sudden fall from that position. You should heed the warning signs and plan the things to avoid misfortunes.",
      "Hello , Your Name number is 16.It is a spiritual number that represents love and peace. Worldly difficulties will not touch you and finally your soul will rise to higher planes. Always try to help others. People will slowly realize your philanthropic nature. Your name will live after you for a long time.",
      "Hello , Your Name number is 17.It indicates tensions and quarrels. You will involve into bitter quarrels with others. There is a warning of dangers and treachery from others. There may be accidents from air, fire and storms. Do not try to make money through wars or revolutionary methods.",
      "Hello , Your Name number is 18.This number is regarded as fortunate and extremely favorable. You will be successful in all of your endeavors. Happiness and honor will be yours. There are chances of reaching to top position in your career. There may be benefits from Government people and projects.",
      "Hello , Your Name number is 19.It represents the awakening of new purpose, new plans and new ambitions. There would be delays and obstacles in your undertakings. You should take the help of your mind to achieve success. Gods will help you, so have faith. But there may be dissatisfaction in monetary gains.",
      "Hello , Your Name number is 20.It promises general success, advancement, honors and awards. Even though there is a struggle, you will gain victory at the end. You will have elevation in your career and life. You will have sweet speech, active thinking and a magnetic personality.",
      "Hello , Your Name number is 21.This number indicates a person who cannot resist the attacks from others. You will trust in people who are not trust-worthy. This leads to backstabbing and cheating. Even though, you are a good person, people will try to throw stones against you. So, be watchful.",
      "Hello , Your Name number is 22.This number represents success by the help of friends and superiors. There will be good communication. You will receive all kinds of prosperity and wealth. You can make your plans successful with the cooperation of people in high position.",
      "Hello , Your Name number is 23.It is a favorable number to enjoy success and luxuries in life. You will receive help from people in high position. There will be gains through love and the opposite sex. You will have original thoughts, good logic and eloquent speech. There may be fickle mindedness.",
      "Hello , Your Name number is 24.This number promises authority, power and command. You will receive great rewards in your work. Your creative ability and imagination will give you success. You should control short temper and try to keep your mind peaceful.",
      "Hello , Your Name number is 25.This number is full of contradiction. You can not take wise decisions and hence you will meet with failures. You may face losses through trust in others, powerful opposition from enemies and competitors in business. Court litigations are also indicated.",
      "Hello , Your Name number is 26.This number represents a lonely and isolated person. You may be a genius with high intelligence but you can not get material success. There may be some revolutionary ideas which will not materialize. You will have difficulties in profession and there may be loss of prestige"
    ]
  },
  "teluguguninthamulu": {
    "CatID": [
      {
        "title": <span class='highlight'>తెలుగు గుణింతములు</span>,
      },
      {
        "title": "క, కా, కి, కీ, కు, కూ, కృ, కౄ, కె, కే, కై, కొ, కో, కౌ, కం, కః"
      },
      {
        "title": ""
      },
      {
        "title": "ఖ, ఖా, ఖి, ఖీ, ఖు, ఖూ, ఖృ, ఖౄ, ఖె, ఖే, ఖై, ఖొ, ఖో, ఖౌ, ఖం, ఖః"
      },
      {
        "title": ""
      },
      {
        "title": "గ, గా, గి, గీ, గు, గూ, గృ, గౄ, గె, గే, గై, గొ, గో, గౌ, గం, గః"
      },
      {
        "title": ""
      },
      {
        "title": "ఘ, ఘా, ఘి, ఘీ, ఘు, ఘూ, ఘృ, ఘౄ, ఘె, ఘే, ఘై, ఘొ, ఘో, ఘౌ, ఘం, ఘః"
      },
      {
        "title": ""
      },
      {
        "title": "చ, చా, చి, చీ, చు, చూ, చృ, చౄ, చె, చే, చై, చొ, చో, చౌ, చం, చః"
      },
      {
        "title": ""
      },
      {
        "title": "ఛ, ఛా, ఛి, ఛీ, ఛు, ఛూ, ఛృ, ఛౄ, ఛె, ఛే, ఛై, ఛొ, ఛో, ఛౌ, ఛం, ఛః"
      },
      {
        "title": ""
      },
      {
        "title": "జ, జా, జి, జీ, జు, జూ, జృ, జౄ, జె, జే, జై, జొ, జో, జౌ, జం, జః"
      },
      {
        "title": ""
      },
      {
        "title": "ఝ, ఝా, ఝి, ఝీ, ఝు, ఝూ, ఝృ, ఝౄ, ఝె, ఝే, ఝై, ఝొ, ఝో, ఝౌ, ఝం, ఝః"
      },
      {
        "title": ""
      },
      {
        "title": "ట, టా, టి, టీ, టు, టూ, టృ, టౄ, టె, టే, టై, టొ, టో, టౌ, టం, టః"
      },
      {
        "title": ""
      },
      {
        "title": "ఠ, ఠా, ఠి, ఠీ, ఠు, ఠూ, ఠృ, ఠౄ, ఠె, ఠే, ఠై, ఠొ, ఠో, ఠౌ, ఠం, ఠః"
      },
      {
        "title": ""
      },
      {
        "title": "డ, డా, డి, డీ, డు, డూ, డృ, డౄ, డె, డే, డై, డొ, డో, డౌ, డం, డః"
      },
      {
        "title": ""
      },
      {
        "title": "ఢ, ఢా, ఢి, ఢీ, ఢు, ఢూ, ఢృ, ఢౄ, ఢె, ఢే, ఢై, ఢొ, ఢో, ఢౌ, ఢం, ఢః"
      },
      {
        "title": ""
      },
      {
        "title": "ణ, ణా, ణి, ణీ, ణు, ణూ, ణృ, ణౄ, ణె, ణే, ణై, ణొ, ణో, ణౌ, ణం, ణః"
      },
      {
        "title": ""
      },
      {
        "title": "త, తా, తి, తీ, తు, తూ, తృ, తౄ, తె, తే, తై, తొ తో, తౌ, తం, తః"
      },
      {
        "title": ""
      },
      {
        "title": "థ, థా, థి, థీ, థు, థూ, థృ, థౄ, థె, థే, థై, థొ, థో, ధౌ, థం, థః"
      },
      {
        "title": ""
      },
      {
        "title": "ద, దా, ది, దీ, దు, దూ, దృ, ధౄ, దె, దే, దై, దొ, దో, దౌ, దం, దః"
      },
      {
        "title": ""
      },
      {
        "title": "ధ, ధా, ధి, ధీ, ధు, ధూ, ధృ, ధౄ, ధె, ధే, ధై, ధొ, ధో, ధౌ, ధం, ధః"
      },
      {
        "title": ""
      },
      {
        "title": "న, నా, ని, నీ, ను, నూ, నృ, నౄ, నె, నే, నై, నొ, నో, నౌ, నం, నః"
      }, {
        "title": ""
      },
      {
        "title": "ప, పా, పి, పీ, పు, పూ, పృ, పౄ, పె, పే, పై, పొ, పో, పౌ, పం, పః"
      },
      {
        "title": ""
      },
      {
        "title": "ఫ, ఫా, ఫి, ఫీ, ఫు, ఫూ, ఫృ, ఫౄ, ఫె, ఫే, ఫై, ఫొ, ఫో, ఫౌ, ఫం, ఫః"
      },
      {
        "title": ""
      },
      {
        "title": "బ, బా, బి, బీ, బు, బూ, బృ, బౄ, బె, బే, బై, బొ, బో, బౌ, బం, బః"
      },
      {
        "title": ""
      },
      {
        "title": "భ, భా, భి, భీ, భు, భూ, భృ, భౄ, భె, భే, భై, భొ, భో, భౌ, భం, భః"
      },
      {
        "title": ""
      },
      {
        "title": "మ, మా, మి, మీ, ము, మూ, మృ, మౄ, మె, మే, మై, మొ, మో, మౌ, మం, మః"
      },
      {
        "title": ""
      },
      {
        "title": "య, యా, యి, యీ, యు, యూ, యృ, యౄ, యె, యే, యై, యొ, యో, యౌ, యం, యః"
      },
      {
        "title": ""
      },
      {
        "title": "ర, రా, రి, రీ, రు, రూ, రృ, రౄ, రె, రే, రై, రొ, రో, రౌ, రం, రః"
      },
      {
        "title": ""
      },
      {
        "title": "ల, లా, లి, లీ, లు, లూ, లృ, లౄ, లె, లే, లై, లొ, లో, లౌ, లం, లః"
      },
      {
        "title": ""
      },
      {
        "title": "వ, వా, వి, వీ, వు, వూ, వృ, వౄ, వె, వే, వై, వొ, వో, వౌ, వం, వః"
      },
      {
        "title": ""
      },
      {
        "title": "శ, శా, శి, శీ, శు, శూ, శృ, శౄ, శె, శే, శై, శొ, శో, శౌ, శం, శః"
      },
      {
        "title": ""
      },
      {
        "title": "ష, షా, షి, షీ, షు, షూ, షృ, షౄ, షె, షే, షై, షొ, షో, షౌ, షం, షః"
      },
      {
        "title": ""
      },
      {
        "title": "స, సా, సి, సీ, సు, సూ, సృ, సౄ, సె, సే, సై, సొ, సో, సౌ, సం, సః"
      },
      {
        "title": ""
      },
      {
        "title": "హ, హా, హి, హీ, హు, హూ, హృ, హౄ, హె, హే, హై, హొ, హో, హౌ, హం, హః"
      }
    ],
    "title": "తెలుగు_గుణింతములు"
  },
  "telugunavagrahalu": {
    "CatID": [
      {
        "title": "1. సూర్యుడు"
      },
      {
        "title": "2. చంద్రుడు"
      },
      {
        "title": "3. అంగారకుడు"
      },
      {
        "title": "4. బుధుడు"
      },
      {
        "title": "5. గురువు"
      },
      {
        "title": "6. శుక్రుడు"
      },
      {
        "title": "7. శని"
      },
      {
        "title": "8. రాహువు"
      },
      {
        "title": "9. కేతువు"
      }
    ],
    "title": "నవగ్రహాలు"
  },
  "telugulagnam": {
    "CatID": [
      {
        "title": "1. మేష లగ్నము"
      },
      {
        "title": "2. వృషభ లగ్నము"
      },
      {
        "title": "3. మిధున లగ్నము"
      },
      {
        "title": "4. కర్కాటక లగ్నము"
      },
      {
        "title": "5. సింహ లగ్నము"
      },
      {
        "title": "6. కన్యా లగ్నము"
      },
      {
        "title": "7. తులా లగ్నము"
      },
      {
        "title": "8. వృశ్చిక లగ్నము"
      },
      {
        "title": "9. ధనుర్ లగ్నము"
      },
      {
        "title": "10. మకర లగ్నము"
      },
      {
        "title": "11. కుంభ లగ్నము"
      },
      {
        "title": "12. మీన లగ్నము"
      }
    ],
    "title": "తెలుగు లగ్నములు"
  },
  "BalliSastram": [{
    "Gender": "Male",
    "Parts": [{
      "Description": "కలయము",
      "actionId": "తలమీద"
    }, {
      "Description": "మరణము",
      "actionId": "బ్రహ్మ రంధ్రమున"
    }, {
      "Description": "బంధు దర్శనం",
      "actionId": "ముఖము"
    }, {
      "Description": "బంధు సన్యాసము",
      "actionId": "నుదురు"
    }, {
      "Description": "శుభం",
      "actionId": "ఎడమ కన్ను"
    }, {
      "Description": "అపజయం",
      "actionId": "కుడి కన్ను"
    }, {
      "Description": "ఆదాయం",
      "actionId": "ఎడమ చెవి"
    }, {
      "Description": "దీర్ఘాయువు ",
      "actionId": "కుడి చెవి "
    }, {
      "Description": "కలహము",
      "actionId": "పై పెదవి"
    }, {
      "Description": "లాభము",
      "actionId": "క్రింది పెదవి"
    }, {
      "Description": "మృత్యువు",
      "actionId": "రెండు పెదవులపై"
    }, {
      "Description": "ఇస్టాన్న భోజనం",
      "actionId": "నోటియందు"
    }, {
      "Description": "రాజ దండనము",
      "actionId": "గడ్డం"
    }, {
      "Description": "వస్త్ర లాభం",
      "actionId": "దవడ"
    }, {
      "Description": "అలంకార ప్రాప్తి",
      "actionId": "మణికట్టు"
    }, {
      "Description": "కీర్తి",
      "actionId": "మోచేయి"
    }, {
      "Description": "ధన హాని",
      "actionId": "వ్రేళ్ళపై"
    }, {
      "Description": "ఆరోగ్యం",
      "actionId": "కుడిభుజము"
    }, {
      "Description": "అగౌరవము",
      "actionId": "ఎడమ భుజము"
    }, {
      "Description": "వస్త్ర నాశము",
      "actionId": "తొడలు"
    }, {
      "Description": "కష్టము",
      "actionId": "మీసములపై"
    }, {
      "Description": "కష్టము",
      "actionId": "పాదములు"
    }, {
      "Description": "ప్రయాణము",
      "actionId": "పాదముల వెనుక"
    }, {
      "Description": "నిర్లజ్జ",
      "actionId": "కాలి వేళ్ళు"
    }]
  }, {
    "Gender": "FeMale",
    "Parts": [{
      "Description": "ఎం ఉండదు",
      "actionId": "తలమీద"
    }, {
      "Description": "రోగ భయం",
      "actionId": "కొప్పుపై"
    }, {
      "Description": "బంధు దర్శనము",
      "actionId": "పిక్కలు"
    }, {
      "Description": "భర్త ప్రేమ",
      "actionId": "ఎడమ కన్ను"
    }, {
      "Description": "మనోవ్యధ",
      "actionId": "కుడి కన్ను"
    }, {
      "Description": "ధనలాభం",
      "actionId": "కుడిచెవి"
    }, {
      "Description": "వివాదాలు",
      "actionId": "పైపెదవి"
    }, {
      "Description": "కొత్త వస్తువులు సంక్రమిస్తాయి",
      "actionId": "క్రింది పెదవి"
    }, {
      "Description": "అధిక దుఃఖము",
      "actionId": "స్థనము"
    }, {
      "Description": "మరణ వార్త",
      "actionId": "వీపు"
    }, {
      "Description": "కలహాలు",
      "actionId": "గోళ్ళపై "
    }, {
      "Description": "మెంటల్ స్ట్రెస్",
      "actionId": "ఎడమ చేయి"
    }, {
      "Description": "నగల ప్రాప్తి",
      "actionId": "వేళ్ళపై"
    }, {
      "Description": "ధన నష్టము",
      "actionId": "చేతియందు"
    }, {
      "Description": "కామ రతి ప్రాప్తి",
      "actionId": "కుడి భుజము"
    }, {
      "Description": "వ్వభిచారము",
      "actionId": "తొడలు"
    }, {
      "Description": "బంధనము",
      "actionId": "మోకాళ్ళు"
    }, {
      "Description": "కష్టము",
      "actionId": "చీలమండలము"
    }, {
      "Description": "శత్రు నాశనము",
      "actionId": "కుడికాలు"
    }, {
      "Description": "పుత్ర లాభము",
      "actionId": "కాలి వేళ్ళు"
    }, {
      "Description": "మగ శిశువు జన్మిస్తాడు ",
      "actionId": "కుడి చెంప"
    }, {
      "Description": "మంచి జరుగుతుంది",
      "actionId": "రొమ్ము"
    }, {
      "Description": "డబ్బు నష్టం",
      "actionId": "మోచేయి"
    }, {
      "Description": "అత్యంత సుఖము",
      "actionId": "వక్షము"
    }]
  }],

  EclipseUpdated: [
    
    {
      Data: [
        {
          Desc: [
            {
              txt: "సూర్య గ్రహణాలు నాలుగు రకాలు.",
            },
            {
              txt: "సంపూర్ణ సూర్య గ్రహణం,\nఅంగుళీయక (యాన్యులర్) సూర్య గ్రహణం,\nసంకర గ్రహణం,\nపాక్షిక సూర్య గ్రహణం",
            },
          ],
          Sun: [
            {
              txt: "భూమికి సూర్యుడికి మధ్య చంద్రుడు వచ్చినప్పుడు, భూమి మీద కొంత భాగానికి సూర్యుడు పూర్తిగా గానీ, పాక్షికంగా గానీ కనబడకుండా పోవడం వలన సూర్య గ్రహణము ఏర్పడుతుంది. ఈ ప్రకియను ప్రాచీన హిందూ మతంకు సంబంధించిన సూర్య సిద్ధాంతంలో కూడా చెప్పబడింది. సూర్య గ్రహణము అమావాస్య నాడు మాత్రమే వస్తుంది. ప్రాచీన కాలంలో గ్రహణాలను అశుభ సూచకముగా భావించేవారు. ఇప్పటికీ ప్రపంచంలో కొన్ని ప్రాంతాల ప్రజలు వీటిని అశుభ సూచకంగానే భావిస్తారు. అకస్మాత్తుగా సూర్యుడు ఆకాశం నుండి మాయమై చీకటి కమ్ముకోవడం వలన ప్రజలు భయభ్రాంతులకు గురి అవుతారు. విజ్ఞాన శాస్త్రం గ్రహణాలను వివరించిన తరువాత ప్రజల్లో ఇటువంటి నమ్మకాలు తగ్గాయిి.",
            },
            {
              txt: "భూమిని చంద్రుడి పూర్ణ ఛాయ (అంబ్రా) కప్పినపుడు మాత్రమే సంపూర్ణ సూర్య గ్రహణం ఏర్పడుతుంది. అందుచేత సంపూర్ణ సూర్య గ్రహణాలు, భూమ్మీద ఎక్కడైనా సరే, చాలా అరుదు. సంపూర్ణ సూర్య గ్రహణం చూడదలచినవారు ఆ గ్రహణం పట్టే ప్రదేశాలు సుదూరంలో ఉన్నప్పటికీ అక్కడకు వెళ్ళి ఆ గ్రహణాన్ని చూస్తారు. 1999లో ఐరోపాలో కనిపించిన సూర్యగ్రహణమును ప్రపంచంలో అత్యధిక ప్రజలు వీక్షించారని చెబుతారు. దీనివలన గ్రహణాల పట్ల ప్రజలకు అవగాహన పెరిగింది.",
            },
          ],
          Suntakecare: [
            {
              txt: "@సూర్యగ్రహణం సమయంలో అనుసరించాల్సినవి :",
            },
            {
              txt: "1. సూర్యగ్రహణానికి ముందు మరియు తరువాత స్నానం చేయండి.",
            },
            {
              txt: "2. గ్రహణానికి కనీసం రెండు గంటల ముందు ఆహారం తీసుకోండి.",
            },
            {
              txt: "3. సూర్యగ్రహణం సమయంలో ధ్యానం చేయండి. సూర్యగ్రహణం సమయంలో శివుడు, గురువు, విష్ణువు స్తోత్రాలను పఠించండి.",
            },
            {
              txt: "4. చెడు ప్రభావాన్ని నివారించడానికి పవిత్ర తులసి ఆకులను నీటి పాత్రలలో ఉంచండి.",
            },
            {
              txt: "5. సూర్యగ్రహణం తర్వాత ఇంటిని శుభ్రం చేసి ఇంటి చుట్టూ గంగాజలం చల్లాలి. ఇది సానుకూలతను తెస్తుంది. గ్రహణం యొక్క చెడు ప్రభావాల నుండి రక్షిస్తుంది.",
            },
            {
              txt: "@సూర్యగ్రహణం సమయంలో చేయకూడనివి :",
            },
            {
              txt: "1. గ్రహణం సమయంలో సూర్యునికి నేరుగా శరీరం బహిర్గతం కాకుండా ఉండండి.",
            },
            {
              txt: "2. గ్రహణ సమయంలో వంట చేయడం, తినడం మానుకోండి.",
            },
            {
              txt: "3. సూర్యుడిని కంటితో చూడవద్దు.",
            },
            {
              txt: "4. గ్రహణ సమయంలో గర్భిణీ స్త్రీలు ఇంటి నుండి బయటకు రాకూడదు.",
            },
            {
              txt: " 5. గ్రహణానికి ముందు వండిన ఆహారం తినకూడదు. గ్రహణానికి ముందు నీరు, అన్నం, ఇతర ఆహార పదార్థాలపై తులసి ఆకుల్ని వేయండి.",
            },
            {
              txt: "6. గ్రహణం సమయంలో నిద్రించడం లేదా బయటికి వెళ్లడం మానుకోండి.",
            },
            {
              txt: "7. మీ ఇంటి నుండి సూర్యరశ్మిని దూరంగా ఉంచండి. మీ తలుపులను కర్టెన్లతో కప్పండి.",
            },
          ],
          Title: "సూర్య గ్రహణం",
          ex: [
            {
              Date: "మార్చి 29, 2025",
              Time: "14:20 నుండి 18:13 వరకు",
            },
            {
              Date: "సెప్టెంబర్ 21, 2025",
              Time: "22:59 నుండి 03:23 వరకు",
            },
          ],
        },
        {
          Moon: [
            {
              txt: "చంద్రునికి సూర్యునికి మధ్యగా భూమి వచ్చినపుడు, సూర్యుని కాంతి చంద్రునిపై పడకుండా భూమి అడ్డుపడటంతో భూమిపై నున్నవారికి చంద్రుడు కనిపించడు. దీన్ని చంద్ర గ్రహణం అంటారు. ఇది ఎప్పుడూ పౌర్ణమి నాడు జరుగుతుంది. చంద్ర గ్రహణం చాలాసేపు (కొన్ని గంటలు) మొత్తం అర్థగోళం అంతా కనిపిస్తుంది.చంద్రగ్రహణానికి క్రింది పరిస్థితులు కావలెను.చంద్రుడు, భూమి మరియు సూర్యుడు ఒకే సరళరేఖలో వుండాలి.చంద్రుడికీ సూర్యుడికీ మధ్య భూమి వుండాలిి.నిండు పౌర్ణమి రాత్రి వుండాలి.చంద్రగ్రహణ కాలము చంద్రుడి స్థాన కక్ష్యాబిందువులపై ఆధారపడి వుంటుంది.",
            },
          ],
          Title: "చంద్ర గ్రహణం",
          ex: [
            {
              Date: "మార్చి 14, 2025",
              Time: "09:27 నుండి 15:30 వరకు",
            },
            {
              Date: "సెప్టెంబర్ 07, 2025",
              Time: "20:58 నుండి 02:25 సెప్టెంబర్ 08 వరకు",
            },
          ],
        },
      ],
    },
    {
  Data: [
          {
            Desc: [
              {
                txt: "సూర్య గ్రహణాలు నాలుగు రకాలు.",
              },
              {
                txt: "సంపూర్ణ సూర్య గ్రహణం,\nఅంగుళీయక (యాన్యులర్) సూర్య గ్రహణం,\nసంకర గ్రహణం,\nపాక్షిక సూర్య గ్రహణం",
              },
            ],
            Sun: [
              {
                txt: "భూమికి సూర్యుడికి మధ్య చంద్రుడు వచ్చినప్పుడు, భూమి మీద కొంత భాగానికి సూర్యుడు పూర్తిగా గానీ, పాక్షికంగా గానీ కనబడకుండా పోవడం వలన సూర్య గ్రహణము ఏర్పడుతుంది. ఈ ప్రకియను ప్రాచీన హిందూ మతంకు సంబంధించిన సూర్య సిద్ధాంతంలో కూడా చెప్పబడింది. సూర్య గ్రహణము అమావాస్య నాడు మాత్రమే వస్తుంది. ప్రాచీన కాలంలో గ్రహణాలను అశుభ సూచకముగా భావించేవారు. ఇప్పటికీ ప్రపంచంలో కొన్ని ప్రాంతాల ప్రజలు వీటిని అశుభ సూచకంగానే భావిస్తారు. అకస్మాత్తుగా సూర్యుడు ఆకాశం నుండి మాయమై చీకటి కమ్ముకోవడం వలన ప్రజలు భయభ్రాంతులకు గురి అవుతారు. విజ్ఞాన శాస్త్రం గ్రహణాలను వివరించిన తరువాత ప్రజల్లో ఇటువంటి నమ్మకాలు తగ్గాయిి.",
              },
              {
                txt: "భూమిని చంద్రుడి పూర్ణ ఛాయ (అంబ్రా) కప్పినపుడు మాత్రమే సంపూర్ణ సూర్య గ్రహణం ఏర్పడుతుంది. అందుచేత సంపూర్ణ సూర్య గ్రహణాలు, భూమ్మీద ఎక్కడైనా సరే, చాలా అరుదు. సంపూర్ణ సూర్య గ్రహణం చూడదలచినవారు ఆ గ్రహణం పట్టే ప్రదేశాలు సుదూరంలో ఉన్నప్పటికీ అక్కడకు వెళ్ళి ఆ గ్రహణాన్ని చూస్తారు. 1999లో ఐరోపాలో కనిపించిన సూర్యగ్రహణమును ప్రపంచంలో అత్యధిక ప్రజలు వీక్షించారని చెబుతారు. దీనివలన గ్రహణాల పట్ల ప్రజలకు అవగాహన పెరిగింది.",
              },
            ],
            Suntakecare: [
              {
                txt: "@సూర్యగ్రహణం సమయంలో అనుసరించాల్సినవి :",
              },
              {
                txt: "1. సూర్యగ్రహణానికి ముందు మరియు తరువాత స్నానం చేయండి.",
              },
              {
                txt: "2. గ్రహణానికి కనీసం రెండు గంటల ముందు ఆహారం తీసుకోండి.",
              },
              {
                txt: "3. సూర్యగ్రహణం సమయంలో ధ్యానం చేయండి. సూర్యగ్రహణం సమయంలో శివుడు, గురువు, విష్ణువు స్తోత్రాలను పఠించండి.",
              },
              {
                txt: "4. చెడు ప్రభావాన్ని నివారించడానికి పవిత్ర తులసి ఆకులను నీటి పాత్రలలో ఉంచండి.",
              },
              {
                txt: "5. సూర్యగ్రహణం తర్వాత ఇంటిని శుభ్రం చేసి ఇంటి చుట్టూ గంగాజలం చల్లాలి. ఇది సానుకూలతను తెస్తుంది. గ్రహణం యొక్క చెడు ప్రభావాల నుండి రక్షిస్తుంది.",
              },
              {
                txt: "@సూర్యగ్రహణం సమయంలో చేయకూడనివి :",
              },
              {
                txt: "1. గ్రహణం సమయంలో సూర్యునికి నేరుగా శరీరం బహిర్గతం కాకుండా ఉండండి.",
              },
              {
                txt: "2. గ్రహణ సమయంలో వంట చేయడం, తినడం మానుకోండి.",
              },
              {
                txt: "3. సూర్యుడిని కంటితో చూడవద్దు.",
              },
              {
                txt: "4. గ్రహణ సమయంలో గర్భిణీ స్త్రీలు ఇంటి నుండి బయటకు రాకూడదు.",
              },
              {
                txt: " 5. గ్రహణానికి ముందు వండిన ఆహారం తినకూడదు. గ్రహణానికి ముందు నీరు, అన్నం, ఇతర ఆహార పదార్థాలపై తులసి ఆకుల్ని వేయండి.",
              },
              {
                txt: "6. గ్రహణం సమయంలో నిద్రించడం లేదా బయటికి వెళ్లడం మానుకోండి.",
              },
              {
                txt: "7. మీ ఇంటి నుండి సూర్యరశ్మిని దూరంగా ఉంచండి. మీ తలుపులను కర్టెన్లతో కప్పండి.",
              },
            ],
            Title: "సూర్య గ్రహణం",
            ex: [
              {
                Date: "ఫిబ్రవరి 17, 2026",
                Time: "15:26 నుండి 19:57 వరకు",
              },
              {
                Date: "ఆగష్టు 12, 2026",
                Time: "21:04 నుండి 01:27 వరకు",
              },
            ],
          },
          {
            Moon: [
              {
                txt: "చంద్రునికి సూర్యునికి మధ్యగా భూమి వచ్చినపుడు, సూర్యుని కాంతి చంద్రునిపై పడకుండా భూమి అడ్డుపడటంతో భూమిపై నున్నవారికి చంద్రుడు కనిపించడు. దీన్ని చంద్ర గ్రహణం అంటారు. ఇది ఎప్పుడూ పౌర్ణమి నాడు జరుగుతుంది. చంద్ర గ్రహణం చాలాసేపు (కొన్ని గంటలు) మొత్తం అర్థగోళం అంతా కనిపిస్తుంది.చంద్రగ్రహణానికి క్రింది పరిస్థితులు కావలెను.చంద్రుడు, భూమి మరియు సూర్యుడు ఒకే సరళరేఖలో వుండాలి.చంద్రుడికీ సూర్యుడికీ మధ్య భూమి వుండాలిి.నిండు పౌర్ణమి రాత్రి వుండాలి.చంద్రగ్రహణ కాలము చంద్రుడి స్థాన కక్ష్యాబిందువులపై ఆధారపడి వుంటుంది.",
              },
            ],
            Title: "చంద్ర గ్రహణం",
            ex: [
              {
                Date: "మార్చి 3, 2026",
                Time: "14:14 నుండి 19:53 వరకు",
              },
              {
                Date: "ఆగష్టు 28, 2026",
                Time: "06:53 నుండి 12:31 వరకు",
              },

            ],
          },
        ],
    },
  ],

  MuhurthamUpdated: [
    {
      Title: [
        {
          dates: [
            {
              date: "16/01/2025: 04:06 నుండి 06:50 జనవరి 17 వరకు",
            },
            {
              date: "17/01/2025: 06:50 నుండి 12:45",
            },
            {
              date: "18/01/2025: 14:51 నుండి 01:16 జనవరి 19 వరకు",
            },
            {
              date: "19/01/2025: 01:58 నుండి 06:50 జనవరి 20 వరకు",
            },
            {
              date: "20/01/2025: 06:50 నుండి 09:58 వరకు",
            },
            {
              date: "21/01/2025: 23:36 నుండి 03:50 జనవరి 22 వరకు",
            },
            {
              date: "23/01/2025: 05:08 నుండి 06:36 జనవరి 24 వరకు",
            },
            {
              date: "24/01/2025: 19:25 నుండి 06:49 జనవరి 25 వరకు",
            },
            {
              date: "25/01/2025: 06:49 నుండి 07:07 వరకు",
            },
            {
              date: "26/01/2025: 03:34 నుండి 06:49 జనవరి 27 వరకు",
            },
            {
              date: "27/01/2025: 06:49 నుండి 09:02 వరకు",
            },
            {
              date: "02/02/2025: 09:14 నుండి 06:48 ఫిబ్రవరి 03 వరకు",
            },
            {
              date: "03/02/2025: 06:48 నుండి 17:40 వరకు",
            },
            {
              date: "06/02/2025: 19:29 నుండి 06:46 ఫిబ్రవరి 07 వరకు",
            },
            {
              date: "07/02/2025: 06:46 నుండి 16:17 వరకు",
            },
            {
              date: "12/02/2025: 01:58 నుండి 06:44 ఫిబ్రవరి 13 వరకు",
            },
            {
              date: "13/02/2025: 06:44 నుండి 07:31 వరకు",
            },
            {
              date: "14/02/2025: 23:09 నుండి 06:43 ఫిబ్రవరి 15 వరకు",
            },
            {
              date: "15/02/2025: 06:43 నుండి 10:48 వరకు",
            },
            {
              date: "16/02/2025: 06:42 నుండి 08:06 వరకు",
            },
            {
              date: "18/02/2025: 09:52 నుండి 06:41 ఫిబ్రవరి 19 వరకు",
            },
            {
              date: "19/02/2025: 06:41 నుండి 07:32 వరకు",
            },
            {
              date: "21/02/2025: 11:59 నుండి 15:54 వరకు",
            },
            {
              date: "23/02/2025: 13:55 నుండి 18:43 వరకు",
            },
            {
              date: "25/02/2025: 08:15 నుండి 18:31 వరకు",
            },
            {
              date: "01/03/2025: 11:22 నుండి 06:34 మార్చి 02 వరకు",
            },
            {
              date: "02/03/2025: 06:34 నుండి 01:14 మార్చి 03 వరకు",
            },
            {
              date: "06/03/2025: 22:01 నుండి 06:30 మార్చి 07 వరకు",
            },
            {
              date: "07/03/2025: 06:30 నుండి 23:32 వరకు",
            },
            {
              date: "12/03/2025: 08:43 నుండి 04:05 మే 13 వరకు",
            },
            {
              date: "14/04/2025: 22:39 నుండి 00:13 ఏప్రిల్ 15 వరకు",
            },
            {
              date: "16/04/2025: 00:19 నుండి 05:55 ఏప్రిల్ 17 వరకు",
            },
            {
              date: "18/04/2025: 01:04 నుండి 05:58 ఏప్రిల్ 19 వరకు",
            },
            {
              date: "19/04/2025: 05:58 నుండి 10:21 వరకు",
            },
            {
              date: "20/04/2025: 11:48 నుండి 05:56 ఏప్రిల్ 21 వరకు",
            },
            {
              date: "21/04/2025: 05:56 నుండి 12:37 వరకు",
            },
            {
              date: "25/04/2025: 08:53 నుండి 12:31 వరకు",
            },
            {
              date: "29/04/2025: 18:47 నుండి 05:51 ఏప్రిల్ 30 వరకు",
            },
            {
              date: "30/04/2025: 05:51 నుండి 12:02 వరకు",
            },
            {
              date: "01/05/2025: 11:23 నుండి 14:21 వరకు",
            },
            {
              date: "05/05/2025: 20:29 నుండి 05:48 మే 06 వరకు",
            },
            {
              date: "06/05/2025: 05:48 నుండి 15:52 వరకు",
            },
            {
              date: "08/05/2025: 12:29 నుండి 01:57 మే 09 వరకు",
            },
            {
              date: "10/05/2025: 03:15 నుండి 04:01 మే 11 వరకు",
            },
            {
              date: "14/05/2025: 06:34 నుండి 11:47 వరకు",
            },
            {
              date: "15/05/2025: 04:02 నుండి 05:44 మే 16 వరకు",
            },
            {
              date: "16/05/2025: 05:44 నుండి 16:07 వరకు",
            },
            {
              date: "17/05/2025: 17:44 నుండి 05:43 మే 18 వరకు",
            },
            {
              date: "18/05/2025: 05:43 నుండి 18:52 వరకు",
            },
            {
              date: "22/05/2025: 01:12 నుండి 05:42 మే 23 వరకు",
            },
            {
              date: "23/05/2025: 05:42 నుండి 05:42 మే 24 వరకు",
            },
            {
              date: "24/05/2025: 05:42 నుండి 08:22 వరకు",
            },
            {
              date: "27/05/2025: 18:45 నుండి 05:41 మే 28 వరకు",
            },
            {
              date: "28/05/2025: 05:41 నుండి 19:09 వరకు",
            },
            {
              date: "02/06/2025: 08:21 నుండి 20:34 వరకు",
            },
            {
              date: "04/06/2025: 08:29 నుండి 05:41 జూన్ 05 వరకు",
            },
            {
              date: "05/06/2025: 05:41 నుండి 09:14 వరకు",
            },
            {
              date: "07/06/2025: 09:40 నుండి 11:18 వరకు",
            },
            {
              date: "08/06/2025: 12:18 నుండి 12:42 వరకు",
            },
            {
              date: "09/06/2025: 15:31 నుండి 05:41 జూన్ 10 వరకు",
            },
            {
              date: "02/11/2025: 23:11 నుండి 06:15 నవంబర్ 03 వరకు",
            },
            {
              date: "03/11/2025: 06:15 నుండి 19:40 వరకు",
            },
            {
              date: "08/11/2025: 07:32 నుండి 22:02 వరకు",
            },
            {
              date: "12/11/2025: 00:51 నుండి 06:20 నవంబర్ 13 వరకు",
            },
            {
              date: "13/11/2025: 06:20 నుండి 19:38 వరకు",
            },
            {
              date: "16/11/2025: 06:47 నుండి 02:11 నవంబర్ 17 వరకు",
            },
            {
              date: "17/11/2025: 05:01 నుండి 06:23 నవంబర్ 18 వరకు",
            },
            {
              date: "18/11/2025: 06:23 నుండి 07:12 వరకు",
            },
            {
              date: "21/11/2025: 10:44 నుండి 13:56 వరకు",
            },
            {
              date: "22/11/2025: 23:27 నుండి 06:25 నవంబర్ 23 వరకు",
            },
            {
              date: "23/11/2025: 06:25 నుండి 12:09 వరకు",
            },
            {
              date: "25/11/2025: 12:50 నుండి 23:57 వరకు",
            },
            {
              date: "30/11/2025: 07:12 నుండి 06:30 డిసెంబర్ 01 వరకు",
            },
            {
              date: "04/12/2025: 08:40 నుండి 06:33 డిసెంబర్ 05 వరకు",
            },
            {
              date: "05/12/2025: 06:33 నుండి 06:33 డిసెంబర్ 06 వరకు",
            },
            {
              date: "06/12/2025: 06:33 నుండి 08:48 వరకు",
            }
          ],
          txt: "పెళ్లి ముహూర్తాలు",
        },
        {
          dates: [
            {
              date: "06/02/2025: 22:53 నుండి 06:46, ఫిబ్రవరి 07 వరకు",
            },
            {
              date: "07/02/2025: 06:46 నుండి 06:46, ఫిబ్రవరి 08 వరకు",
            },
            {
              date: "08/02/2025: 06:46 నుండి 18:07 వరకు",
            },
            {
              date: "14/02/2025: 23:09 నుండి 06:43, ఫిబ్రవరి 15 వరకు",
            },
            {
              date: "15/02/2025: 06:43 నుండి 23:52 వరకు",
            },
            {
              date: "17/02/2025: 06:42 నుండి 04:53, ఫిబ్రవరి 18 వరకు",
            },
            {
              date: "01/03/2025: 11:22 నుండి 06:34, మార్చి 02 వరకు",
            },
            {
              date: "05/03/2025: 01:08 నుండి 06:31, మార్చి 06 వరకు",
            },
            {
              date: "06/03/2025: 06:31 నుండి 10:50 వరకు",
            },
            {
              date: "14/03/2025: 12:23 నుండి 06:24, మార్చి 15 వరకు",
            },
            {
              date: "30/04/2025: 05:51 నుండి 14:12 వరకు",
            },
            {
              date: "01/05/2025: 11:23 నుండి 14:21 వరకు",
            },
            {
              date: "07/05/2025: 18:17 నుండి 05:47, మే 08 వరకు",
            },
            {
              date: "08/05/2025: 05:47 నుండి 12:29 వరకు",
            },
            {
              date: "09/05/2025: 00:09 నుండి 05:46 మే 10 వరకు",
            },
            {
              date: "10/05/2025: 05:46 నుండి 17:29 వరకు",
            },
            {
              date: "14/05/2025: 05:45 నుండి 11:47 వరకు",
            },
            {
              date: "17/05/2025: 17:44 నుండి 05:43, మే 18 వరకు",
            },
            {
              date: "22/05/2025: 17:47 నుండి 05:42 మే 23 వరకు",
            },
            {
              date: "23/05/2025: 05:42 నుండి 22:29 వరకు",
            },
            {
              date: "28/05/2025: 05:41 నుండి 00:29, మే 29 వరకు",
            },
            {
              date: "04/06/2025: 23:54 నుండి 03:35 జూన్ 05 వరకు",
            },
            {
              date: "06/06/2025: 06:34 నుండి 04:47, జూన్ 07 వరకు",
            },
            {
              date: "23/10/2025: 04:51 నుండి 06:12 అక్టోబర్ 24 వరకు",
            },
            {
              date: "24/10/2025: 06:12 నుండి 01:19, అక్టోబర్ 25 వరకు",
            },
            {
              date: "29/10/2025: 06:13 నుండి 09:23 వరకు",
            },
            {
              date: "03/11/2025: 06:15 నుండి 02:05 నవంబర్ 04 వరకు",
            },
            {
              date: "07/11/2025: 06:17 నుండి 06:18, నవంబర్ 08 వరకు",
            },
            {
              date: "08/11/2025: 06:18 నుండి 07:32 వరకు",
            },
            {
              date: "14/11/2025: 21:20 నుండి 06:21, నవంబర్ 15 వరకు",
            },
            {
              date: "15/11/2025: 06:21 నుండి 23:34 వరకు",
            },
            {
              date: "24/11/2025: 21:53 నుండి 06:27, నవంబర్ 25 వరకు",
            },
            {
              date: "29/11/2025: 02:22 నుండి 06:30, నవంబర్ 30 వరకు",
            },
            {
              date: "5/12/2025: 06:33 నుండి 06:33, డిసెంబర్ 06 వరకు",
            },
            {
              date: "6/12/2025: 06:33 నుండి 08:48 వరకు",
            },
          ],
          txt: "గృహ ప్రవేశ ముహూర్తాలు",
        },
        {
          dates: [
            {
              date: "02/01/2025: 06:47 నుండి 01:08 జనవరి 3 వరకు",
            },
            {
              date: "06/01/2025: 19:06 నుండి 06:48, జనవరి 7 వరకు",
            },
            {
              date: "13/01/2025: 10:38 నుండి 06:49, జనవరి 14 వరకు",
            },
            {
              date: "19/01/2025: 17:30 నుండి 06:50, జనవరి 20 వరకు",
            },
            {
              date: "20/01/2025: 06:50 నుండి 09:58 వరకు",
            },
            {
              date: "24/01/2025: 06:50 నుండి 06:49 జనవరి 25 వరకు",
            },
            {
              date: "31/01/2025: 13:59 నుండి 04:14 ఫిబ్రవరి 01 వరకు",
            },
            {
              date: "03/02/2025: 06:48 నుండి 23:16 వరకు",
            },
            {
              date: "07/02/2025: 06:46 నుండి 06:46, ఫిబ్రవరి 08 వరకు",
            },
            {
              date: "09/02/2025: 19:25 నుండి 06:45, ఫిబ్రవరి 10 వరకు",
            },
            {
              date: "10/02/2025: 06:45 నుండి 18:57 వరకు",
            },
            {
              date: "17/02/2025: 06:42 నుండి 06:41 ఫిబ్రవరి 18 వరకు",
            },
            {
              date: "19/02/2025: 06:41 నుండి 07:32 వరకు",
            },
            {
              date: "20/02/2025: 13:30 నుండి 06:40 ఫిబ్రవరి 21 వరకు",
            },
            {
              date: "21/02/2025: 06:40 నుండి 11:57 వరకు",
            },
            {
              date: "26/02/2025: 06:36 నుండి 11:08 వరకు",
            },
            {
              date: "02/03/2025: 08:59 నుండి 21:01 వరకు",
            },
            {
              date: "06/03/2025: 10:50 నుండి 06:30, మార్చి 7 వరకు",
            },
            {
              date: "07/03/2025: 06:30 నుండి 09:18 వరకు",
            },
            {
              date: "09/03/2025: 06:29 నుండి 06:28, మార్చి 10 వరకు",
            },
            {
              date: "10/03/2025: 06:28 నుండి 07:44 వరకు",
            },
            {
              date: "16/03/2025: 16:58 నుండి 06:23, మార్చి 17 వరకు",
            },
            {
              date: "17/03/2025: 06:23 నుండి 19:33 వరకు",
            },
            {
              date: "19/03/2025: 20:50 నుండి 06:20, మార్చి 20 వరకు",
            },
            {
              date: "20/03/2025: 06:20 నుండి 23:31 వరకు",
            },
            {
              date: "27/03/2025: 06:15 నుండి 23:03 వరకు",
            },
            {
              date: "02/04/2025: 08:49 నుండి 06:09, ఏప్రిల్ 3 వరకు",
            },
            {
              date: "03/04/2025: 06:09 నుండి 21:41 వరకు",
            },
            {
              date: "06/04/2025: 19:22 నుండి 06:06, ఏప్రిల్ 7 వరకు",
            },
            {
              date: "07/04/2025: 06:06 నుండి 06:25 వరకు",
            },
            {
              date: "13/04/2025: 06:02 నుండి 06:01, ఏప్రిల్ 14 వరకు",
            },
            {
              date: "14/04/2025: 06:01 నుండి 08:25 వరకు",
            },
            {
              date: "16/04/2025: 06:00 నుండి 13:16 వరకు",
            },
            {
              date: "21/04/2025: 12:37 నుండి 18:58 వరకు",
            },
            {
              date: "23/04/2025: 05:55 నుండి 05:54 ఏప్రిల్ 24 వరకు",
            },
            {
              date: "24/04/2025: 05:54 నుండి 10:49 వరకు",
            },
            {
              date: "30/04/2025: 05:51 నుండి 14:12 వరకు",
            },
            {
              date: "01/05/2025: 11:23 నుండి 14:21 వరకు",
            },
            {
              date: "02/05/2025: 13:04 నుండి 05:49, మే 03 వరకు",
            },
            {
              date: "04/05/2025: 07:18 నుండి 12:53 వరకు",
            },
            {
              date: "09/05/2025: 14:56 నుండి 05:46, మే 10 వరకు",
            },
            {
              date: "11/05/2025: 20:01 నుండి 05:45, మే 12 వరకు",
            },
            {
              date: "18/05/2025: 18:52 నుండి 05:43, మే 19 వరకు",
            },
            {
              date: "19/05/2025: 05:43 నుండి 06:11 వరకు",
            },
            {
              date: "23/05/2025: 16:02 నుండి 22:29 వరకు",
            },
            {
              date: "05/06/2025: 05:41 నుండి 05:41 జూన్ 06 వరకు",
            },
            {
              date: "06/06/2025: 05:41 నుండి 04:47, జూన్ 07 వరకు",
            },
            {
              date: "08/06/2025: 07:17 నుండి 12:42 వరకు",
            },
            {
              date: "15/06/2025: 15:51 నుండి 05:42, జూన్ 16 వరకు",
            },
            {
              date: "16/06/2025: 05:42 నుండి 05:42 జూన్ 17 వరకు",
            },
            {
              date: "20/06/2025: 09:49 నుండి 21:45 వరకు",
            },
            {
              date: "23/06/2025: 15:16 నుండి 22:09 వరకు",
            },
            {
              date: "27/06/2025: 11:19 నుండి 05:45 జూన్ 28 వరకు",
            },
            {
              date: "02/07/2025: 11:58 నుండి 05:46, జూలై 3 వరకు"
            },
            {
              date: "03/07/2025: 05:46 నుండి 14:06 వరకు"
            },
            {
              date: "04/07/2025: 16:31 నుండి 05:47, జూలై 5 వరకు"
            },
            {
              date: "13/07/2025: 05:49 నుండి 01:02, జూలై 14 వరకు"
            },
            {
              date: "17/07/2025: 19:08 నుండి 03:39, జూలై 18 వరకు"
            },
            {
              date: "21/07/2025: 05:52 నుండి 09:38 వరకు"
            },
            {
              date: "30/07/2025: 05:55 నుండి 02:41, జూలై 31 వరకు"
            },
            {
              date: "01/08/2025: 05:55 నుండి 03:40, ఆగస్టు 2 వరకు"
            },
            {
              date: "03/08/2025: 09:42 నుండి 05:56, ఆగస్టు 4 వరకు"
            },
            {
              date: "04/08/2025: 05:56 నుండి 09:12 వరకు"
            },
            {
              date: "08/08/2025: 14:28 నుండి 05:58, ఆగస్టు 9 వరకు"
            },
            {
              date: "10/08/2025: 05:58 నుండి 12:09 వరకు"
            },
            {
              date: "11/08/2025: 10:33 నుండి 13:00 వరకు"
            },
            {
              date: "13/08/2025: 10:32 నుండి 04:23, ఆగస్టు 14 వరకు"
            },
            {
              date: "14/08/2025: 05:59 నుండి 09:06 వరకు"
            },
            {
              date: "17/08/2025: 19:24 నుండి 06:00, ఆగస్టు 18 వరకు"
            },
            {
              date: "18/08/2025: 06:00 నుండి 02:06, ఆగస్టు 19 వరకు"
            },
            {
              date: "20/08/2025: 13:58 నుండి 06:00, ఆగస్టు 21 వరకు"
            },
            {
              date: "21/08/2025: 06:00 నుండి 12:44 వరకు"
            },
            {
              date: "27/08/2025: 15:44 నుండి 06:02, ఆగస్టు 28 వరకు"
            },
            {
              date: "28/08/2025: 06:02 నుండి 06:02, ఆగస్టు 29 వరకు"
            },
            {
              date: "29/08/2025: 06:02 నుండి 11:38 వరకు"
            },
            {
              date: "31/08/2025: 06:02 నుండి 17:27 వరకు"
            },
            {
              date: "05/09/2025: 06:03 నుండి 03:12, సెప్టెంబర్ 6 వరకు"
            },
            {
              date: "07/09/2025: 06:03 నుండి 21:41 వరకు"
            },
            {
              date: "24/09/2025: 06:05 నుండి 06:05, సెప్టెంబర్ 25 వరకు"
            },
            {
              date: "25/09/2025: 06:05 నుండి 07:06 వరకు"
            },
            {
              date: "02/10/2025: 09:13 నుండి 06:07, అక్టోబర్ 3 వరకు"
            },
            {
              date: "03/10/2025: 06:07 నుండి 18:32 వరకు"
            },
            {
              date: "05/10/2025: 06:07 నుండి 08:01 వరకు"
            },
            {
              date: "10/10/2025: 19:38 నుండి 06:08, అక్టోబర్ 11 వరకు"
            },
            {
              date: "12/10/2025: 06:08 నుండి 13:36 వరకు"
            },
            {
              date: "13/10/2025: 12:26 నుండి 06:09, అక్టోబర్ 14 వరకు"
            },
            {
              date: "15/10/2025: 10:33 నుండి 12:00 వరకు"
            },
            {
              date: "24/10/2025: 06:12 నుండి 01:19, అక్టోబర్ 25 వరకు"
            },
            {
              date: "29/10/2025: 17:29 నుండి 06:14, అక్టోబర్ 30 వరకు"
            },
            {
              date: "30/10/2025: 06:14 నుండి 10:06 వరకు"
            },
            {
              date: "31/10/2025: 10:03 నుండి 06:15, నవంబర్ 1 వరకు"
            },
            {
              date: "03/11/2025: 15:05 నుండి 02:05, నవంబర్ 4 వరకు"
            },
            {
              date: "07/11/2025: 11:05 నుండి 06:18, నవంబర్ 8 వరకు"
            },
            {
              date: "09/11/2025: 20:04 నుండి 06:19, నవంబర్ 10 వరకు"
            },
            {
              date: "10/11/2025: 06:19 నుండి 00:07, నవంబర్ 11 వరకు"
            },
            {
              date: "17/11/2025: 06:22 నుండి 06:23, నవంబర్ 18 వరకు"
            },
            {
              date: "26/11/2025: 06:27 నుండి 00:01, నవంబర్ 27 వరకు"
            },
            {
              date: "28/11/2025: 06:28 నుండి 00:15, నవంబర్ 29 వరకు"
            },
            {
              date: "01/12/2025: 06:30 నుండి 19:01 వరకు"
            },
            {
              date: "04/12/2025: 14:54 నుండి 04:43, డిసెంబర్ 5 వరకు"
            },
            {
              date: "05/12/2025: 06:33 నుండి 00:55, డిసెంబర్ 6 వరకు"
            },
            {
              date: "07/12/2025: 06:34 నుండి 18:24 వరకు"
            },
            {
              date: "08/12/2025: 16:03 నుండి 02:52, డిసెంబర్ 9 వరకు"
            },
            {
              date: "14/12/2025: 06:38 నుండి 06:38, డిసెంబర్ 15 వరకు"
            },
            {
              date: "15/12/2025: 06:38 నుండి 21:19 వరకు"
            },
            {
              date: "17/12/2025: 17:11 నుండి 02:32, డిసెంబర్ 18 వరకు"
            },
            {
              date: "24/12/2025: 13:11 నుండి 06:44, డిసెంబర్ 25 వరకు"
            },
            {
              date: "25/12/2025: 06:44 నుండి 06:44, డిసెంబర్ 26 వరకు"
            },
            {
              date: "26/12/2025: 06:44 నుండి 09:00 వరకు"
            },
            {
              date: "28/12/2025: 08:43 నుండి 11:59 వరకు"
            }
          ],
          txt: "వాహన కొనుగోలు ముహూర్తాలు",
        },
        {
          dates: [
            {
              date: "05/01/2025: 06:48 నుండి 21:26 వరకు",
            },
            {
              date: "06/01/2025: 00:14 నుండి 06:48 జనవరి 07 వరకు",
            },
            {
              date: "12/01/2025: 06:49 నుండి 14:25 వరకు",
            },
            {
              date: "19/01/2025: 15:18 నుండి 06:50 జనవరి 20 వరకు",
            },
            {
              date: "20/01/2025: 06:50 నుండి 06:17 జనవరి 21 వరకు",
            },
            {
              date: "26/01/2025: 18:57 నుండి 06:49 జనవరి 27 వరకు",
            },
            {
              date: "27/01/2025: 06:49 నుండి 18:37 వరకు",
            },
            {
              date: "02/02/2025: 06:18 నుండి 06:48 ఫిబ్రవరి 03 వరకు",
            },
            {
              date: "03/02/2025: 06:48 నుండి 06:47 ఫిబ్రవరి 04 వరకు",
            },
            {
              date: "16/02/2025: 06:43 నుండి 06:42 ఫిబ్రవరి 17 వరకు",
            },
            {
              date: "17/02/2025: 06:42 నుండి 20:28 వరకు",
            },
            {
              date: "23/02/2025: 06:39 నుండి 03:44 ఫిబ్రవరి 24 వరకు",
            },
            {
              date: "02/03/2025: 12:43 నుండి 06:33 మార్చి 03 వరకు",
            },
            {
              date: "03/03/2025: 06:33 నుండి 15:43 వరకు",
            },
            {
              date: "16/03/2025: 06:24 నుండి 04:47 మార్చి 17 వరకు",
            },
            {
              date: "23/03/2025: 06:18 నుండి 14:08 వరకు",
            },
            {
              date: "30/03/2025: 06:13 నుండి 22:59 వరకు",
            },
            {
              date: "31/03/2025: 01:57 నుండి 06:11 ఏప్రిల్ 01 వరకు",
            },
            {
              date: "13/04/2025: 06:02 నుండి 10:43 వరకు",
            },
            {
              date: "27/04/2025: 05:53 నుండి 07:00 వరకు",
            },
            {
              date: "28/04/2025: 09:53 నుండి 05:52 ఏప్రిల్ 29 వరకు",
            },
            {
              date: "05/05/2025: 21:40 నుండి 05:48 మే 06 వరకు",
            },
            {
              date: "25/05/2025: 17:54 నుండి 05:42 మే 26 వరకు",
            },
            {
              date: "26/05/2025: 05:42 నుండి 05:42 మే 27 వరకు",
            },
            {
              date: "02/06/2025: 06:53 నుండి 05:41 జూన్ 3 వరకు",
            },
            {
              date: "22/06/2025: 05:43 నుండి 05:43 జూన్ 23 వరకు",
            },
            {
              date: "23/06/2025: 05:43 నుండి 05:44 జూన్ 24 వరకు",
            },
            {
              date: "29/06/2025: 16:30 నుండి 05:45 జూన్ 30 వరకు",
            },
            {
              date: "30/06/2025: 05:45 నుండి 05:45 జూలై 1 వరకు",
            },
            {
              date: "07/07/2025: 22:16 నుండి 05:48 జూలై 08 వరకు",
            },
            {
              date: "14/07/2025: 22:27 నుండి 05:50 జూలై 15 వరకు",
            },
            {
              date: "17/08/2025: 05:59 నుండి 06:00 ఆగస్టు 18 వరకు",
            },
            {
              date: "18/08/2025: 06:00 నుండి 22:57 వరకు",
            },
            {
              date: "24/08/2025: 06:01 నుండి 06:01 ఆగస్టు 25 వరకు",
            },
            {
              date: "25/08/2025: 06:01 నుండి 09:14 వరకు",
            },
            {
              date: "31/08/2025: 17:45 నుండి 03:18 సెప్టెంబర్ 01 వరకు",
            },
            {
              date: "01/09/2025: 06:02 నుండి 14:56 వరకు",
            },
            {
              date: "07/09/2025: 10:25 నుండి 06:03 సెప్టెంబర్ 08 వరకు",
            },
            {
              date: "08/09/2025: 06:03 నుండి 12:09 వరకు",
            },
            {
              date: "14/09/2025: 06:04 నుండి 04:54 సెప్టెంబర్ 15 వరకు",
            },
            {
              date: "21/09/2025: 06:05 నుండి 15:35 వరకు",
            },
            {
              date: "22/09/2025: 15:34 నుండి 06:05 సెప్టెంబర్ 23 వరకు",
            },
            {
              date: "28/09/2025: 06:06 నుండి 01:48 సెప్టెంబర్ 29 వరకు",
            },
            {
              date: "29/09/2025: 23:18 నుండి 06:06 సెప్టెంబర్ 30 వరకు",
            },
            {
              date: "05/10/2025: 06:07 నుండి 19:40 వరకు",
            },
            {
              date: "06/10/2025: 21:32 నుండి 06:07 అక్టోబర్ 07 వరకు",
            },
            {
              date: "12/10/2025: 06:08 నుండి 11:36 వరకు",
            },
            {
              date: "19/10/2025: 21:04 నుండి 06:10 అక్టోబర్ 20 వరకు",
            },
            {
              date: "20/10/2025: 06:10 నుండి 06:11 అక్టోబర్ 21 వరకు",
            },
            {
              date: "26/10/2025: 06:12 నుండి 11:27 వరకు",
            },
            {
              date: "27/10/2025: 09:25 నుండి 04:17 అక్టోబర్ 28 వరకు",
            },
            {
              date: "02/11/2025: 05:57 నుండి 06:15 నవంబర్ 03 వరకు",
            },
            {
              date: "03/11/2025: 06:15 నుండి 06:16 నవంబర్ 04 వరకు",
            },
            {
              date: "16/11/2025: 06:21 నుండి 06:22 నవంబర్ 17 వరకు",
            },
            {
              date: "17/11/2025: 06:22 నుండి 01:17 నవంబర్ 18 వరకు",
            },
            {
              date: "23/11/2025: 17:16 నుండి 06:26 నవంబర్ 24 వరకు",
            },
            {
              date: "24/11/2025: 06:26 నుండి 16:01 వరకు",
            },
            {
              date: "30/11/2025: 15:01 నుండి 06:30 డిసెంబర్ 01 వరకు",
            },
            {
              date: "01/12/2025: 06:30 నుండి 16:40 వరకు",
            },
            {
              date: "14/12/2025: 06:38 నుండి 06:38 డిసెంబర్ 15 వరకు",
            },
            {
              date: "15/12/2025: 06:38 నుండి 08:10 వరకు",
            },
            {
              date: "21/12/2025: 06:41 నుండి 22:09 వరకు",
            },
            {
              date: "28/12/2025: 06:45 నుండి 01:05 డిసెంబర్ 29 వరకు",
            },
            {
              date: "29/12/2025: 03:10 నుండి 06:45 డిసెంబర్ 30 వరకు",
            },
          ],
          txt: "భూమి పూజ ముహూర్తాలు",
        },
        {
          dates: [
            {
              date: "16/01/2025: 06:50 నుండి 06:50, జనవరి 17 వరకు"
            },
            {
              date: "17/01/2025: 06:50 నుండి 06:50, జనవరి 18 వరకు"
            },
            {
              date: "23/01/2025: 06:50 నుండి 06:50, జనవరి 24 వరకు"
            },
            {
              date: "24/01/2025: 06:50 నుండి 06:49, జనవరి 25 వరకు"
            },
            {
              date: "31/01/2025: 04:14 నుండి 06:48, ఫిబ్రవరి 1 వరకు"
            },
            {
              date: "07/02/2025: 18:40 నుండి 06:46, ఫిబ్రవరి 8 వరకు"
            },
            {
              date: "13/02/2025: 06:44 నుండి 06:43, ఫిబ్రవరి 14 వరకు"
            },
            {
              date: "14/02/2025: 06:43 నుండి 23:09 వరకు"
            },
            {
              date: "20/02/2025: 06:40 నుండి 06:40, ఫిబ్రవరి 21 వరకు"
            },
            {
              date: "21/02/2025: 06:40 నుండి 15:54 వరకు"
            },
            {
              date: "28/02/2025: 13:40 నుండి 06:34, మార్చి 1 వరకు"
            },

            {
              date: "06/03/2025: 00:05 నుండి 06:30, మార్చి 7 వరకు"
            },
            {
              date: "07/03/2025: 06:30 నుండి 23:32 వరకు"
            },
            {
              date: "13/03/2025: 06:26 నుండి 06:19, మార్చి 14 వరకు"
            },
            {
              date: "20/03/2025: 06:20 నుండి 23:31 వరకు"
            },
            {
              date: "21/03/2025: 01:46 నుండి 06:19, మార్చి 22 వరకు"
            },
            {
              date: "27/03/2025: 00:34 నుండి 06:14, మార్చి 28 వరకు"
            },
            {
              date: "28/03/2025: 06:14 నుండి 22:09 వరకు"
            },
            {
              date: "03/04/2025: 07:02 నుండి 05:51, ఏప్రిల్ 04 వరకు"
            },
            {
              date: "04/04/2025: 05:20 నుండి 06:08, ఏప్రిల్ 05 వరకు"
            },
            {
              date: "10/04/2025: 06:04 నుండి 12:24 వరకు"
            },
            {
              date: "18/04/2025: 08:21 నుండి 05:58, ఏప్రిల్ 19 వరకు"
            },
            {
              date: "24/04/2025: 10:49 నుండి 05:54, ఏప్రిల్ 25 వరకు"
            },
            {
              date: "25/04/2025: 05:54 నుండి 08:53 వరకు"
            },
            {
              date: "01/05/2025: 05:50 నుండి 14:21 వరకు"
            },
            {
              date: "02/05/2025: 13:04 నుండి 05:49, మే 03 వరకు"
            },
            {
              date: "15/05/2025: 14:07 నుండి 05:44, మే 16 వరకు"
            },
            {
              date: "16/05/2025: 05:44 నుండి 05:44, మే 17 వరకు"
            },
            {
              date: "22/05/2025: 05:42 నుండి 17:47 వరకు"
            },
            {
              date: "23/05/2025: 16:02 నుండి 05:42, మే 24 వరకు"
            },
            {
              date: "29/05/2025: 22:38 నుండి 05:41, మే 30 వరకు"
            },
            {
              date: "30/05/2025: 05:41 నుండి 21:29 వరకు"
            },
            {
              date: "12/06/2025: 05:41 నుండి 05:42, జూన్ 13 వరకు"
            },
            {
              date: "13/06/2025: 05:42 నుండి 23:21 వరకు"
            },
            {
              date: "19/06/2025: 23:17 నుండి 05:43, జూన్ 20 వరకు"
            },
            {
              date: "20/06/2025: 05:43 నుండి 21:45 వరకు"
            },
            {
              date: "26/06/2025: 08:46 నుండి 05:44, జూన్ 27 వరకు"
            },
            {
              date: "27/06/2025: 05:44 నుండి 07:22 వరకు"
            },
            {
              date: "10/07/2025: 05:48 నుండి 05:49, జూలై 11 వరకు"
            },
            {
              date: "11/07/2025: 05:49 నుండి 05:56 వరకు"
            },
            {
              date: "17/07/2025: 05:51 నుండి 03:39, జూలై 18 వరకు"
            },
            {
              date: "24/07/2025: 05:53 నుండి 16:43 వరకు"
            },
            {
              date: "25/07/2025: 16:00 నుండి 05:54, జూలై 26 వరకు"
            },
            {
              date: "01/08/2025: 03:40 నుండి 05:56, ఆగస్టు 02 వరకు"
            },
            {
              date: "07/08/2025: 05:57 నుండి 14:01 వరకు"
            },
            {
              date: "14/08/2025: 05:59 నుండి 09:06 వరకు"
            },
            {
              date: "21/08/2025: 00:08 నుండి 06:01, ఆగస్టు 22 వరకు"
            },
            {
              date: "22/08/2025: 06:01 నుండి 06:01, ఆగస్టు 23 వరకు"
            },
            {
              date: "29/08/2025: 11:38 నుండి 06:02, ఆగస్టు 30 వరకు"
            },
            {
              date: "18/09/2025: 06:32 నుండి 06:05, సెప్టెంబర్ 19 వరకు"
            },
            {
              date: "19/09/2025: 06:05 నుండి 06:05, సెప్టెంబర్ 20 వరకు"
            },
            {
              date: "25/09/2025: 19:09 నుండి 06:06, సెప్టెంబర్ 26 వరకు"
            },
            {
              date: "26/09/2025: 06:06 నుండి 06:06, సెప్టెంబర్ 27 వరకు"
            },
            {
              date: "16/10/2025: 06:09 నుండి 06:10, అక్టోబర్ 17 వరకు"
            },
            {
              date: "17/10/2025: 06:10 నుండి 06:10, అక్టోబర్ 18 వరకు"
            },
            {
              date: "23/10/2025: 06:11 నుండి 06:12, అక్టోబర్ 24 వరకు"
            },
            {
              date: "24/10/2025: 06:12 నుండి 06:12, అక్టోబర్ 25 వరకు"
            },
            {
              date: "07/11/2025: 00:33 నుండి 06:18, నవంబర్ 08 వరకు"
            },
            {
              date: "13/11/2025: 06:20 నుండి 06:21, నవంబర్ 14 వరకు"
            },
            {
              date: "14/11/2025: 06:21 నుండి 21:20 వరకు"
            },
            {
              date: "20/11/2025: 06:24 నుండి 06:24, నవంబర్ 21 వరకు"
            },
            {
              date: "21/11/2025: 06:24 నుండి 13:56 వరకు"
            },
            {
              date: "28/11/2025: 02:49 నుండి 06:29, నవంబర్ 29 వరకు"
            },
            {
              date: "05/12/2025: 11:46 నుండి 06:33, డిసెంబర్ 06 వరకు"
            },
            {
              date: "11/12/2025: 06:36 నుండి 03:55, డిసెంబర్ 12 వరకు"
            },
            {
              date: "18/12/2025: 06:40 నుండి 20:07 వరకు"
            },
            {
              date: "19/12/2025: 22:51 నుండి 06:41, డిసెంబర్ 20 వరకు"
            },
            {
              date: "26/12/2025: 09:00 నుండి 06:44, డిసెంబర్ 27 వరకు"
            }
          ],
          txt: "ఆస్తి కొనుగోలు ముహూర్తాలు",
        },
        {
          dates: [
            {
              date: "01/01/2025: 11:12 నుండి 12:48 వరకు",
            },
            {
              date: "02/01/2025: 11:08 నుండి 12:44 వరకు",
            },
            {
              date: "15/01/2025: 10:17 నుండి 10:28 వరకు",
            },
            {
              date: "31/01/2025: 09:14 నుండి 10:50 వరకు, 12:35 నుండి 12:56 వరకు",
            },
            {
              date: "07/02/2025: 08:47 నుండి 10:23 వరకు, 12:29 నుండి 13:39 వరకు",
            },
            {
              date: "10/02/2025: 08:35 నుండి 10:11 వరకు, 11:56 నుండి 13:40 వరకు",
            },
            {
              date: "17/02/2025: 08:08 నుండి 08:55 వరకు, 11:28 నుండి 13:29 వరకు",
            },
            {
              date: "06/03/2025: 07:01 నుండి 08:37 వరకు, 10:21 నుండి 10:50 వరకు",
            },
            {
              date: "10/03/2025: 11:49 నుండి 12:06 వరకు",
            },
            {
              date: "24/03/2025: 10:25 నుండి 11:11 వరకు",
            },
            {
              date: "26/03/2025: 09:07 నుండి 11:03 వరకు",
            },
            {
              date: "27/03/2025: 08:59 నుండి 09:29 వరకు, 10:35 నుండి 10:59 వరకు",
            },
            {
              date: "24/04/2025: 09:09 నుండి 10:49 వరకు",
            },
            {
              date: "25/04/2025: 09:05 నుండి 11:18 వరకు",
            },
            {
              date: "30/04/2025: 08:46 నుండి 09:29 వరకు, 10:33 నుండి 10:58 వరకు",
            },
            {
              date: "09/05/2025: 08:22 నుండి 10:23 వరకు",
            },
            {
              date: "14/05/2025: 07:51 నుండి 10:03 వరకు",
            },
            {
              date: "23/05/2025: 07:15 నుండి 09:28 వరకు",
            },
            {
              date: "28/05/2025: 06:56 నుండి 08:15 వరకు",
            },
            {
              date: "05/06/2025: 06:24 నుండి 08:37 వరకు",
            },
            {
              date: "22/10/2025: 08:04 నుండి 10:18 వరకు",
            },
            {
              date: "24/10/2025: 07:56 నుండి 09:48 వరకు",
            },
            {
              date: "15/12/2025: 10:42 నుండి 12:20 వరకు",
            },
            {
              date: "22/12/2025: 10:15 నుండి 11:53 వరకు",
            },
            {
              date: "25/12/2025: 10:03 నుండి 11:41 వరకు",
            },
            {
              date: "29/12/2025: 10:12 నుండి 11:25 వరకు",
            }
          ],
          txt: "నామకరణ ముహూర్తాలు",
        },
      ],
    },
    {
    Title: [
      {
        dates: [
          {
            date: "16/01/2026: 20:01 నుండి 06:50 జనవరి 17 వరకు",
          },
          {
            date: "17/01/2026: 06:50 నుండి 21:50 వరకు",
          },
          {
            date: "20/01/2026: 03:09 నుండి 06:50 జనవరి 21 వరకు",
          },
          {
            date: "21/01/2026: 06:50 నుండి 07:23 వరకు",
          },
          {
            date: "22/01/2026: 06:50 నుండి 04:58 జనవరి 23 వరకు",
          },
          {
            date: "27/01/2026: 19:44 నుండి 06:49 జనవరి 28 వరకు",
          },
          {
            date: "28/01/2026: 06:49 నుండి 15:53 వరకు",
          },
          {
            date: "30/01/2026: 10:43 నుండి 06:49 జనవరి 31 వరకు",
          },
          {
            date: "31/01/2026: 06:49 నుండి 01:08 ఫిబ్రవరి 01 వరకు",
          },
          {
            date: "04/02/2026: 07:21 నుండి 05:44 ఫిబ్రవరి 05 వరకు",
          },
          {
            date: "06/02/2026: 13:18 నుండి 06:27 ఫిబ్రవరి 07 వరకు",
          },
          {
            date: "07/02/2026: 04:37 నుండి 06:46 ఫిబ్రవరి 08 వరకు",
          },
          {
            date: "08/02/2026: 06:46 నుండి 11:17 వరకు",
          },
          {
            date: "12/02/2026: 14:56 నుండి 06:44 ఫిబ్రవరి 13 వరకు",
          },
          {
            date: "13/02/2026: 14:41 నుండి 05:11 ఫిబ్రవరి 14 వరకు",
          },
          {
            date: "17/02/2026: 08:46 నుండి 13:44 వరకు",
          },
          {
            date: "24/02/2026: 13:35 నుండి 22:20 వరకు",
          },
          {
            date: "25/02/2026: 01:24 నుండి 06:37 ఫిబ్రవరి 26 వరకు",
          },
          {
            date: "26/02/2026: 06:37 నుండి 15:27 వరకు",
          },
          {
            date: "29/02/2026: 10:22 నుండి 06:34 మార్చి 01 వరకు",
          },
          {
            date: "01/03/2026: 06:34 నుండి 12:48 వరకు",
          },
          {
            date: "02/03/2026: 20:24 నుండి 06:33 మార్చి 03 వరకు",
          },
          {
            date: "03/03/2026: 06:33 నుండి 15:15 వరకు",
          },
          {
            date: "04/03/2026: 22:16 నుండి 06:32 మార్చి 05 వరకు",
          },
          {
            date: "05/03/2026: 06:32 నుండి 14:09 వరకు",
          },
          {
            date: "06/03/2026: 14:52 నుండి 06:30 మార్చి 07 వరకు",
          },
          {
            date: "07/03/2026: 06:30 నుండి 08:24 వరకు",
          },
          {
            date: "10/03/2026: 01:55 నుండి 06:27 మార్చి 07 వరకు",
          },
          {
            date: "11/03/2026: 06:27 నుండి 06:26 మార్చి 12 వరకు",
          },
          {
            date: "12/03/2026: 06:26 నుండి 15:08 వరకు",
          },
          {
            date: "18/04/2026: 00:44 నుండి 05:57 ఏప్రిల్ 19 వరకు",
          },
          {
            date: "19/04/2026: 05:57 నుండి 06:46 వరకు",
          },
          {
            date: "20/04/2026: 14:04 నుండి 02:48 ఏప్రిల్ 21 వరకు",
          },
          {
            date: "21/04/2026: 03:45 నుండి 05:55 ఏప్రిల్ 22 వరకు",
          },
          {
            date: "22/04/2026: 05:55 నుండి 20:00 వరకు",
          },
          {
            date: "23/04/2026: 04:57 నుండి 05:54 ఏప్రిల్ 24 వరకు",
          },
          {
            date: "24/04/2026: 05:54 నుండి 00:41 ఏప్రిల్ 25 వరకు",
          },
          {
            date: "25/04/2026: 04:54 నుండి 05:53 ఏప్రిల్ 26 వరకు",
          },
          {
            date: "26/04/2026: 05:53 నుండి 20:05 వరకు",
          },
          {
            date: "28/04/2026: 10:33 నుండి 04:49 ఏప్రిల్ 29 వరకు",
          },
          {
            date: "29/04/2026: 04:42 నుండి 05:51 ఏప్రిల్ 30 వరకు",
          },
          {
            date: "30/04/2026: 05:51 నుండి 07:05 వరకు",
          },
          {
            date: "09/07/2026: 14:28 నుండి 18:56 వరకు",
          },
          {
            date: "11/07/2026: 13:04 నుండి 04:09 జూలై 12 వరకు",
          },
          {
            date: "12/07/2026: 05:15 నుండి 05:49 జూలై 13 వరకు",
          },
          {
            date: "13/07/2026: 05:49 నుండి 15:05 వరకు",
          },
          {
            date: "14/07/2026: 22:06 నుండి 05:50 జూలై 15 వరకు",
          },
          {
            date: "15/07/2026: 05:50 నుండి 00:30 జూలై 16 వరకు",
          },
          {
            date: "12/11/2026: 16:04 నుండి 19:10 వరకు",
          },
          {
            date: "13/11/2026: 15:26 నుండి 21:48 వరకు",
          },
          {
            date: "16/11/2026: 23:48 నుండి 06:22 నవంబర్ 17 వరకు",
          },
          {
            date: "17/11/2026: 06:22 నుండి 06:23 నవంబర్ 18 వరకు",
          },
          {
            date: "18/11/2026: 06:23 నుండి 07:56 వరకు",
          },
          {
            date: "22/11/2026: 23:44 నుండి 06:26 నవంబర్ 23 వరకు",
          },
          {
            date: "23/11/2026: 06:26 నుండి 11:42 వరకు",
          },
          {
            date: "25/11/2026: 01:01 నుండి 06:27 నవంబర్ 26 వరకు",
          },
          {
            date: "26/11/2026: 06:27 నుండి 04:35 నవంబర్ 27 వరకు",
          },
          {
            date: "28/11/2026: 07:36 నుండి 06:29 నవంబర్ 29 వరకు",
          },
          {
            date: "29/11/2026: 06:29 నుండి 08:39 వరకు",
          },
          {
            date: "04/12/2026: 17:15 నుండి 01:22 డిసెంబర్ 05 వరకు",
          },
          {
            date: "05/12/2026: 12:49 నుండి 17:26 వరకు",
          },
          {
            date: "09/12/2026: 14:56 నుండి 01:06 డిసెంబర్ 10 వరకు",
          },
          {
            date: "10/12/2026: 22:03 నుండి 06:13 డిసెంబర్ 11 వరకు",
          },
          {
            date: "14/12/2026: 06:38 నుండి 16:58 వరకు",
          },
        ],
        txt: "పెళ్లి ముహూర్తాలు",
      },
      {
        dates: [
          {
            date: "03/01/2026: 06:47 నుండి 14:46 వరకు",
          },
          {
            date: "12/02/2026: 14:56 నుండి 17:44 వరకు",
          },
          {
            date: "14/02/2026: 06:44 నుండి 10:43 వరకు",
          },
          {
            date: "19/02/2026: 06:41 నుండి 10:33 వరకు",
          },
          {
            date: "26/02/2026: 06:37 నుండి 04:31 ఫిబ్రవరి 27 వరకు",
          },
          {
            date: "28/02/2026: 04:18 నుండి 06:35 ఫిబ్రవరి 29 వరకు",
          },
          {
            date: "29/02/2026: 06:35 నుండి 10:22 వరకు",
          },
          {
            date: "02/03/2026: 14:42 నుండి 06:33 మార్చి 03 వరకు",
          },
          {
            date: "06/03/2026: 14:52 నుండి 04:13 మార్చి 07 వరకు",
          },
          {
            date: "15/03/2026: 22:09 నుండి 06:23 మార్చి 16 వరకు",
          },
          {
            date: "16/03/2026: 06:23 నుండి 21:38 వరకు",
          },
          {
            date: "27/03/2026: 06:15 నుండి 16:16 వరకు",
          },
          {
            date: "29/03/2026: 20:36 నుండి 06:12 మార్చి 30 వరకు",
          },
          {
            date: "30/03/2026: 06:12 నుండి 21:13 వరకు",
          },
          {
            date: "03/04/2026: 18:29 నుండి 21:47 వరకు",
          },
          {
            date: "02/11/2026: 05:58 నుండి 06:16 నవంబర్ 03 వరకు",
          },
          {
            date: "04/11/2026: 06:16 నుండి 08:04 వరకు",
          },
          {
            date: "07/11/2026: 00:34 నుండి 06:18 నవంబర్ 08 వరకు",
          },
          {
            date: "08/11/2026: 06:18 నుండి 12:03 వరకు",
          },
          {
            date: "13/11/2026: 13:01 నుండి 03:11 నవంబర్ 14 వరకు",
          },
          {
            date: "16/11/2026: 19:28 నుండి 06:22 నవంబర్ 17 వరకు",
          },
          {
            date: "18/11/2026: 06:23 నుండి 15:49 వరకు",
          },
          {
            date: "25/11/2026: 06:27 నుండి 01:24 నవంబర్ 26 వరకు",
          },
          {
            date: "05/12/2026: 12:49 నుండి 17:26 వరకు",
          },
          {
            date: "11/12/2026: 06:36 నుండి 11:48 వరకు",
          },
          {
            date: "21/12/2026: 06:14 నుండి 06:42 డిసెంబర్ 22 వరకు",
          },
          {
            date: "25/12/2026: 06:44 నుండి 15:22 వరకు",
          },
        ],
        txt: "గృహ ప్రవేశ ముహూర్తాలు",
      },
      {
        dates: [
          {
            date: "03/01/2026: 19:48 నుండి 06:47 జనవరి 04 వరకు",
          },
          {
            date: "04/01/2026: 06:47 నుండి 22:04 వరకు",
          },
          {
            date: "14/01/2026: 06:49 నుండి 07:59 వరకు",
          },
          {
            date: "15/01/2026: 06:50 నుండి 08:07 వరకు",
          },
          {
            date: "21/01/2026: 06:50 నుండి 19:26 వరకు",
          },
          {
            date: "22/01/2026: 19:51 నుండి 04:58 జనవరి 23 వరకు",
          },
          {
            date: "24/01/2026: 21:49 నుండి 06:50 జనవరి 25 వరకు",
          },
          {
            date: "25/01/2026: 06:50 నుండి 06:49 జనవరి 26 వరకు",
          },
          {
            date: "26/01/2026: 06:49 నుండి 10:28 వరకు",
          },
          {
            date: "31/01/2026: 06:49 నుండి 06:48 ఫిబ్రవరి 01 వరకు",
          },
          {
            date: "01/02/2026: 06:48 నుండి 14:03 వరకు",
          },
          {
            date: "03/02/2026: 16:02 నుండి 05:57 ఫిబ్రవరి 04 వరకు",
          },
          {
            date: "04/02/2026: 17:49 నుండి 06:47 ఫిబ్రవరి 05 వరకు",
          },
          {
            date: "05/02/2026: 06:47 నుండి 07:54 వరకు",
          },
          {
            date: "14/02/2026: 06:44 నుండి 10:43 వరకు",
          },
          {
            date: "14/02/2026: 06:44 నుండి 10:43 వరకు",
          },
          {
            date: "18/02/2026: 08:15 నుండి 06:41 ఫిబ్రవరి 19 వరకు",
          },
          {
            date: "19/02/2026: 06:41 నుండి 10:33 వరకు",
          },
          {
            date: "21/02/2026: 11:27 నుండి 06:39 ఫిబ్రవరి 22 వరకు",
          },
          {
            date: "22/02/2026: 06:39 నుండి 13:21 వరకు",
          },
          {
            date: "29/02/2026: 06:35 నుండి 06:34 మార్చి 01 వరకు",
          },
          {
            date: "01/03/2026: 06:34 నుండి 12:48 వరకు",
          },
          {
            date: "03/03/2026: 08:44 నుండి 15:55 వరకు",
          },
          {
            date: "08/03/2026: 06:29 నుండి 21:57 వరకు",
          },
          {
            date: "15/03/2026: 16:08 నుండి 22:09 వరకు",
          },
          {
            date: "17/03/2026: 06:22 నుండి 16:47 వరకు",
          },
          {
            date: "20/03/2026: 06:20 నుండి 22:38 వరకు",
          },
          {
            date: "25/03/2026: 10:38 నుండి 06:15 మార్చి 26 వరకు",
          },
          {
            date: "27/03/2026: 17:06 నుండి 06:14 మార్చి 28 వరకు",
          },
          {
            date: "28/03/2026: 06:14 నుండి 18:38 వరకు",
          },
          {
            date: "29/03/2026: 20:36 నుండి 06:12 వరకు మార్చి 30 వరకు",
          },
          {
            date: "04/04/2026: 06:08 నుండి 06:07 ఏప్రిల్ 05 వరకు",
          },
          {
            date: "05/04/2026: 06:07 నుండి 13:28 వరకు",
          },
          {
            date: "12/04/2026: 13:11 నుండి 06:02 ఏప్రిల్ 13 వరకు",
          },
          {
            date: "15/04/2026: 12:11 నుండి 05:59 ఏప్రిల్ 16 వరకు",
          },
          {
            date: "21/04/2026: 17:08 నుండి 01:11 ఏప్రిల్ 22 వరకు",
          },
          {
            date: "24/04/2026: 05:54 నుండి 00:41 ఏప్రిల్ 25 వరకు",
          },
          {
            date: "26/04/2026: 07:45 నుండి 03:40 ఏప్రిల్ 27 వరకు",
          },
          {
            date: "01/05/2026: 05:50 నుండి 04:01 మే 02 వరకు",
          },
          {
            date: "03/05/2026: 05:49 నుండి 00:06 మే 04 వరకు",
          },
          {
            date: "05/05/2026: 19:57 నుండి 05:48 మే 06 వరకు",
          },
          {
            date: "06/05/2026: 05:48 నుండి 14:40 వరకు",
          },
          {
            date: "10/05/2026: 05:46 నుండి 02:50 మే 11 వరకు",
          },
          {
            date: "12/05/2026: 10:27 నుండి 05:45 మే 13 వరకు",
          },
          {
            date: "13/05/2026: 05:45 నుండి 02:50 మే 14 వరకు",
          },
          {
            date: "19/05/2026: 05:43 నుండి 13:50 వరకు",
          },
          {
            date: "20/05/2026: 15:58 నుండి 05:43 మే 21 వరకు",
          },
          {
            date: "23/05/2026: 09:15 నుండి 05:42 మే 24 వరకు",
          },
          {
            date: "24/05/2026: 05:42 నుండి 10:10 వరకు",
          },
          {
            date: "29/05/2026: 05:41 నుండి 13:39 వరకు",
          },
          {
            date: "30/05/2026: 11:43 నుండి 05:41 మే 31 వరకు",
          },
          {
            date: "31/05/2026: 05:41 నుండి 06:14 వరకు",
          },
          {
            date: "02/06/2026: 05:41 నుండి 01:40 జూన్ 03 వరకు",
          },
          {
            date: "09/06/2026: 05:41 నుండి 15:44 వరకు",
          },
          {
            date: "10/06/2026: 16:14 నుండి 21:40 వరకు",
          },
          {
            date: "16/06/2026: 05:42 నుండి 05:42 జూన్ 17 వరకు",
          },
          {
            date: "17/06/2026: 05:42 నుండి 05:42 జూన్ 18 వరకు",
          },
          {
            date: "19/06/2026: 17:23 నుండి 05:43 జూన్ 20 వరకు",
          },
          {
            date: "20/06/2026: 05:43 నుండి 07:49 వరకు",
          },
          {
            date: "24/06/2026: 15:54 నుండి 01:23 జూన్ 25 వరకు",
          },
          {
            date: "26/06/2026: 05:44 నుండి 05:44 జూన్ 27 వరకు",
          },
          {
            date: "27/06/2026: 05:44 నుండి 11:36 వరకు",
          },
          {
            date: "03/07/2026: 07:10 నుండి 05:47 జూలై 04 వరకు",
          },
          {
            date: "04/07/2026: 05:47 నుండి 05:54 వరకు",
          },
          {
            date: "08/07/2026: 05:48 నుండి 06:03 వరకు",
          },
          {
            date: "14/07/2026: 05:50 నుండి 17:25 వరకు",
          },
          {
            date: "15/07/2026: 19:19 నుండి 00:30 జూలై 16 వరకు",
          },
          {
            date: "17/07/2026: 05:51 నుండి 21:02 వరకు",
          },
          {
            date: "22/07/2026: 05:52 నుండి 13:11 వరకు",
          },
          {
            date: "24/07/2026: 05:53 నుండి 07:30 వరకు",
          },
          {
            date: "26/07/2026: 14:30 నుండి 23:30 వరకు",
          },
          {
            date: "31/07/2026: 05:55 నుండి 15:55 వరకు",
          },
          {
            date: "02/08/2026: 10:59 నుండి 15:26 వరకు",
          },
          {
            date: "09/08/2026: 05:58 నుండి 05:58 ఆగస్టు 10 వరకు",
          },
          {
            date: "12/08/2026: 07:55 నుండి 08:33 వరకు",
          },
          {
            date: "14/08/2026: 10:23 నుండి 12:13 వరకు",
          },
          {
            date: "19/08/2026: 06:00 నుండి 05:45 ఆగస్టు 20 వరకు",
          },
          {
            date: "23/08/2026: 10:38 నుండి 19:54 వరకు",
          },
          {
            date: "26/08/2026: 15:55 నుండి 02:19 ఆగస్టు 27 వరకు",
          },
          {
            date: "28/08/2026: 06:02 నుండి 15:53 వరకు",
          },
          {
            date: "29/08/2026: 16:39 నుండి 01:37 ఆగస్టు 30 వరకు",
          },
          {
            date: "05/09/2026: 12:21 నుండి 06:03 సెప్టెంబర్ 06 వరకు",
          },
          {
            date: "06/09/2026: 06:03 నుండి 15:01 వరకు",
          },
          {
            date: "08/09/2026: 06:03 నుండి 15:31 వరకు",
          },
          {
            date: "09/09/2026: 18:04 నుండి 21:53 వరకు",
          },
          {
            date: "15/10/2026: 18:12 నుండి 06:04 సెప్టెంబర్ 16 వరకు",
          },
          {
            date: "16/09/2026: 06:04 నుండి 15:10 సవరకు",
          },
          {
            date: "07/10/2026: 09:47 నుండి 02:25 అక్టోబర్ 08 వరకు",
          },
          {
            date: "13/10/2026: 06:09 నుండి 06:09 అక్టోబర్ 14 వరకు",
          },
          {
            date: "14/09/2026: 06:09 నుండి 06:41 వరకు",
          },
          {
            date: "16/10/2026: 20:40 నుండి 06:10 అక్టోబర్ 17 వరకు",
          },
          {
            date: "17/10/2026: 06:10 నుండి 16:20 వరకు",
          },
          {
            date: "21/10/2026: 06:11 నుండి 05:51 అక్టోబర్ 22 వరకు",
          },
          {
            date: "24/10/2026: 06:12 నుండి 01:58 అక్టోబర్ 25 వరకు",
          },
          {
            date: "30/10/2026: 06:14 నుండి 13:15 వరకు",
          },
          {
            date: "04/11/2026: 06:16 నుండి 08:04 వరకు",
          },
          {
            date: "10/11/2026: 21:01 నుండి 06:19 నవంబర్ 11 వరకు",
          },
          {
            date: "11/11/2026: 06:19 నుండి 09:40 వరకు",
          },
          {
            date: "13/11/2026: 13:01 నుండి 03:11 నవంబర్ 14 వరకు",
          },
          {
            date: "17/11/2026: 21:06 నుండి 06:23 నవంబర్ 18 వరకు",
          },
          {
            date: "18/11/2026: 06:23 నుండి 15:49 వరకు",
          },
          {
            date: "20/11/2026: 06:24 నుండి 06:24 నవంబర్ 21 వరకు",
          },
          {
            date: "21/11/2026: 06:24 నుండి 15:35 వరకు",
          },
          {
            date: "28/11/2026: 06:29 నుండి 06:29 నవంబర్ 29 వరకు",
          },
          {
            date: "29/11/2026: 06:29 నుండి 08:39 వరకు",
          },
          {
            date: "05/12/2026: 17:26 నుండి 06:33 డిసెంబర్ 06 వరకు",
          },
          {
            date: "06/12/2026: 06:33 నుండి 06:34 డిసెంబర్ 07 వరకు",
          },
          {
            date: "08/12/2026: 09:44 నుండి 16:03 వరకు",
          },
          {
            date: "11/12/2026: 06:36 నుండి 11:48 వరకు",
          },
          {
            date: "15/12/2026: 06:39 నుండి 02:20 డిసెంబర్ 16 వరకు",
          },
          {
            date: "18/12/2026: 06:40 నుండి 10:06 వరకు",
          },
          {
            date: "23/12/2026: 09:09 నుండి 17:07 వరకు",
          },
          {
            date: "25/12/2026: 06:44 నుండి 06:44 డిసెంబర్ 26 వరకు",
          },
          {
            date: "26/12/2026: 06:44 నుండి 18:09 వరకు",
          },
        ],
        txt: "వాహన కొనుగోలు ముహూర్తాలు",
      },
      {
        dates: [
          {
            date: "25/01/2026: 09:15 నుండి 12:15 వరకు",
          },
          {
            date: "26/01/2026: 07:28 నుండి 12:24 వరకు",
          },
          {
            date: "01/02/2026: 07:24 నుండి 10:25 వరకు",
          },
          {
            date: "14/02/2026: 07:40 నుండి 12:16 వరకు",
          },
          {
            date: "15/02/2026: 06:42 నుండి 08:26 వరకు",
          },
          {
            date: "19/02/2026: 07:39 నుండి 10:38 వరకు",
          },
          {
            date: "22/02/2026: 07:21 నుండి 09:12 వరకు",
          },
          {
            date: "03/04/2026: 18:29 నుండి 21:47 వరకు",
          },
          {
            date: "17/07/2026: 07:33 నుండి 08:25 వరకు",
          },
          {
            date: "14/09/2026: 07:15 నుండి 09:07 వరకు",
          },
          {
            date: "14/10/2026: 07:11 నుండి 09:28 వరకు",
          },
          {
            date: "17/10/2026: 07:18 నుండి 11:35 వరకు",
          },
          {
            date: "02/11/2026: 05:58 నుండి 06:40 వరకు",
          },
          {
            date: "04/11/2026: 06:40 నుండి 08:04 వరకు",
          },
          {
            date: "07/10/2026: 12:34 నుండి 06:42 వరకు",
          },
          {
            date: "08/11/2026: 06:42 నుండి 12:03 వరకు",
          },
          {
            date: "13/11/2026: 01:01 నుండి 03:11 వరకు",
          },
          {
            date: "16/11/2026: 07:28 నుండి 06:47 నవంబర్ 17 వరకు",
          },
          {
            date: "18/11/2026: 06:48 నుండి 03:49 వరకు",
          },
          {
            date: "25/11/2026: 06:52 నుండి 01:24 నవంబర్ 26 వరకు",
          },
          {
            date: "05/12/2026: 12:49 నుండి 17:26 వరకు",
          },
          {
            date: "11/12/2026: 07:02 నుండి 11:48 వరకు",
          },
          {
            date: "21/12/2026: 06:14 నుండి 07:08 వరకు",
          },
          {
            date: "25/12/2026: 07:09 నుండి 03:22 వరకు",
          },
        ],
        txt: "భూమి పూజ ముహూర్తాలు",
      },
      {
        dates: [
          {
            date: "11/01/2026: 06:49 నుండి 17:39",
          },
          {
            date: "25/01/2026: 06:50 నుండి 08:16 వరకు",
          },
          {
            date: "26/01/2026: 10:28 నుండి 06:49 జనవరి 27 వరకు",
          },
          {
            date: "02/02/2026: 05:57 నుండి 06:48 ఫిబ్రవరి 03 వరకు",
          },
          {
            date: "22/02/2026: 16:43 నుండి 06:39 ఫిబ్రవరి 23 వరకు",
          },
          {
            date: "23/02/2026: 06:39 నుండి 06:38 ఫిబ్రవరి 24 వరకు",
          },
          {
            date: "01/03/2026: 12:48 నుండి 06:34 మార్చి 02 వరకు",
          },
          {
            date: "21/03/2026: 06:19 నుండి 06:19 మార్చి 22 వరకు",
          },
          {
            date: "22/03/2026: 06:19 నుండి 06:18 మార్చి 23 వరకు",
          },
          {
            date: "28/03/2026: 18:38 నుండి 06:13 మార్చి 29 వరకు",
          },
          {
            date: "29/03/2026: 06:13 నుండి 06:12 మార్చి 30 వరకు",
          },
          {
            date: "12/04/2026: 00:51 నుండి 06:02 ఏప్రిల్ 13 వరకు",
          },
          {
            date: "18/04/2026: 05:58 నుండి 05:57 ఏప్రిల్ 19 వరకు",
          },
          {
            date: "19/04/2026: 05:57 నుండి 05:57 ఏప్రిల్ 20 వరకు",
          },
          {
            date: "25/04/2026: 05:54 నుండి 05:53 ఏప్రిల్ 26 వరకు",
          },
          {
            date: "26/04/2026: 05:53 నుండి 03:40 ఏప్రిల్ 27 వరకు",
          },
          {
            date: "03/05/2026: 00:06 నుండి 05:49 మే 04 వరకు",
          },
          {
            date: "10/05/2026: 10:47 నుండి 05:46 మే 11 వరకు",
          },
          {
            date: "16/05/2026: 05:44 నుండి 05:44 మే 17 వరకు",
          },
          {
            date: "17/05/2026: 05:44 నుండి 21:18 వరకు",
          },
          {
            date: "23/05/2026: 05:42 నుండి 05:42 మే 24 వరకు",
          },
          {
            date: "24/05/2026: 05:42 నుండి 10:10 వరకు",
          },
          {
            date: "31/05/2026: 06:14 నుండి 04:48 జూన్ 01 వరకు",
          },
          {
            date: "06/06/2026: 20:16 నుండి 05:41 జూన్ 07 వరకు",
          },
          {
            date: "07/06/2026: 05:41 నుండి 19:43 వరకు",
          },
          {
            date: "13/06/2026: 05:42 నుండి 05:08 జూన్ 14 వరకు",
          },
          {
            date: "20/06/2026: 05:43 నుండి 18:10 వరకు",
          },
          {
            date: "21/06/2026: 18:19 నుండి 05:43 జూన్ 22 వరకు",
          },
          {
            date: "27/06/2026: 11:36 నుండి 05:45 జూన్ 28 వరకు",
          },
          {
            date: "28/06/2026: 05:45 నుండి 10:10 వరకు",
          },
          {
            date: "04/07/2026: 05:47 నుండి 03:54 జూలై 05 వరకు",
          },
          {
            date: "05/07/2026: 04:06 నుండి 05:47 జూలై 06 వరకు",
          },
          {
            date: "11/07/2026: 05:49 నుండి 13:04 వరకు",
          },
          {
            date: "18/07/2026: 03:25 నుండి 05:51 జూలై 19 వరకు",
          },
          {
            date: "19/07/2026: 05:51 నుండి 05:52 జూలై 20 వరకు",
          },
          {
            date: "25/07/2026: 05:53 నుండి 16:16 వరకు",
          },
          {
            date: "26/07/2026: 14:30 నుండి 05:54 జూలై 27 వరకు",
          },
          {
            date: "01/08/2026: 05:56 నుండి 10:24 వరకు",
          },
          {
            date: "02/08/2026: 10:59 నుండి 15:26 ఆగష్టు 03 వరకు",
          },
          {
            date: "15/08/2026: 12:53 నుండి 05:59 ఆగష్టు 16 వరకు",
          },
          {
            date: "16/08/2026: 05:59 నుండి 06:00 ఆగష్టు 17 వరకు",
          },
          {
            date: "22/08/2026: 22:05 నుండి 06:01 ఆగష్టు 23 వరకు",
          },
          {
            date: "23/08/2026: 06:01 నుండి 19:54 వరకు",
          },
          {
            date: "29/08/2026: 16:39 నుండి 06:02 ఆగష్టు 30 వరకు",
          },
          {
            date: "30/08/2026: 06:02 నుండి 17:56 వరకు",
          },
          {
            date: "12/09/2026: 06:04 నుండి 06:04 సెప్టెంబర్ 13 వరకు",
          },
          {
            date: "13/09/2026: 06:04 నుండి 21:35 వరకు",
          },
          {
            date: "19/09/2026: 08:04 నుండి 05:15 సెప్టెంబర్ 20 వరకు",
          },
          {
            date: "26/09/2026: 06:06 నుండి 23:34 వరకు",
          },
          {
            date: "27/09/2026: 01:20 నుండి 06:06 సెప్టెంబర్ 28 వరకు",
          },
          {
            date: "10/10/2026: 06:08 నుండి 05:41 అక్టోబర్ 11 వరకు",
          },
          {
            date: "17/10/2026: 06:10 నుండి 16:20 వరకు",
          },
          {
            date: "25/10/2026: 07:40 నుండి 06:12 అక్టోబర్ 26 వరకు",
          },
          {
            date: "01/11/2026: 03:31 నుండి 06:15 నవంబర్ 02 వరకు",
          },
          {
            date: "07/11/2026: 06:17 నుండి 11:47 వరకు",
          },
          {
            date: "21/11/2026: 15:35 నుండి 06:25 నవంబర్ 22 వరకు",
          },
          {
            date: "22/11/2026: 06:25 నుండి 06:26 నవంబర్ 23 వరకు",
          },
          {
            date: "29/11/2026: 10:18 నుండి 06:30 నవంబర్ 30 వరకు",
          },
          {
            date: "19/12/2026: 06:41 నుండి 06:41 డిసెంబర్ 20 వరకు",
          },
          {
            date: "20/12/2026: 06:41 నుండి 06:42 డిసెంబర్ 21 వరకు",
          },
          {
            date: "26/12/2026: 18:09 నుండి 06:45 డిసెంబర్ 27 వరకు",
          },
          {
            date: "27/12/2026: 06:45 నుండి 06:45 డిసెంబర్ 28 వరకు",
          },
        ],
        txt: "ఆస్తి కొనుగోలు ముహూర్తాలు",
      },
      {
        dates: [
          {
            date: "03/01/2026: 14:46 నుండి 17:33 జనవరి 04 వరకు",
          },
          {
            date: "07/01/2026: 22:08 నుండి 22:03 జనవరి 08 వరకు",
          },
          {
            date: "11/01/2026: 17:39 నుండి 06:52 జనవరి 13 వరకు",
          },
          {
            date: "14/01/2026: 06:53 నుండి 10:22 వరకు",
          },
          {
            date: "16/01/2026: 06:10 నుండి 06:53 వరకు",
          },
          {
            date: "17/01/2026: 06:53 నుండి 02:58 జనవరి 19 వరకు",
          },
          {
            date: "21/01/2026: 06:53 నుండి 04:58 జనవరి 23 వరకు",
          },
          {
            date: "26/01/2026: 00:00 నుండి 10:28 వరకు",
          },
          {
            date: "31/01/2026: 06:52 నుండి 01:08 ఫిబ్రవరి 01 వరకు",
          },
          {
            date: "04/02/2026: 07:20 నుండి 07:54 ఫిబ్రవరి 05 వరకు",
          },
          {
            date: "08/02/2026: 04:37 నుండి 06:49 ఫిబ్రవరి 10 వరకు",
          },
          {
            date: "12/02/2026: 14:56 నుండి 06:47 ఫిబ్రవరి 13 వరకు",
          },
          {
            date: "14/02/2026: 06:47 నుండి 09:26 ఫిబ్రవరి 15 వరకు",
          },
          {
            date: "18/02/2026: 06:45 నుండి 10:33 ఫిబ్రవరి 19 వరకు",
          },
          {
            date: "21/02/2026: 14:17 నుండి 14:17 ఫిబ్రవరి 22 వరకు",
          },
          {
            date: "27/02/2026: 04:30 నుండి 06:39 వరకు",
          },
          {
            date: "28/02/2026: 06:39 నుండి 07:33 వరకు",
          },
          {
            date: "03/03/2026: 06:36 నుండి 15:55 వరకు",
          },
          {
            date: "06/03/2026: 14:52 నుండి 06:32 మార్చి 09 వరకు",
          },
          {
            date: "11/03/2026: 01:55 నుండి 06:29 మార్చి 12 వరకు",
          },
          {
            date: "13/03/2026: 06:29 నుండి 18:24 వరకు",
          },
          {
            date: "15/03/2026: 16:08 నుండి 06:26 మార్చి 16 వరకు",
          },
          {
            date: "17/03/2026: 06:26 నుండి 16:47 వరకు",
          },
          {
            date: "20/03/2026: 06:23 నుండి 20:38 వరకు",
          },
          {
            date: "25/03/2026: 10:37 నుండి 06:18 మార్చి 26 వరకు",
          },
          {
            date: "29/03/2026: 20:36 నుండి 06:15 మార్చి 30 వరకు",
          },
          {
            date: "03/04/2026: 06:12 నుండి 18:06 ఏప్రిల్ 05 వరకు",
          },
          {
            date: "07/04/2026: 12:58 నుండి 06:08 ఏప్రిల్ 09 వరకు",
          },
          {
            date: "12/04/2026: 01:38 నుండి 06:05 ఏప్రిల్ 13 వరకు",
          },
          {
            date: "16/04/2026: 03:05 నుండి 06:03 వరకు",
          },
          {
            date: "21/04/2026: 17:08 నుండి 19:59 ఏప్రిల్ 22 వరకు",
          },
          {
            date: "26/04/2026: 02:24 నుండి 03:40 ఏప్రిల్ 27 వరకు",
          },
          {
            date: "30/04/2026: 04:42 నుండి 05:54 వరకు",
          },
          {
            date: "01/05/2026: 05:53 నుండి 01:49 మే 03 వరకు",
          },
          {
            date: "05/05/2026: 05:51 నుండి 05:50 మే 07 వరకు",
          },
          {
            date: "09/05/2026: 11:55 నుండి 05:49 మే 11 వరకు",
          },
          {
            date: "13/05/2026: 11:23 నుండి 05:48 మే 14 వరకు",
          },
          {
            date: "19/05/2026: 05:46 నుండి 03:16 మే 20 వరకు",
          },
          {
            date: "23/05/2026: 09:14 నుండి 10:10 మే 24 వరకు",
          },
          {
            date: "27/05/2026: 10:13 నుండి 05:45 మే 28 వరకు",
          },
          {
            date: "29/05/2026: 05:45 నుండి 07:31 మే 30 వరకు",
          },
          {
            date: "01/06/2026: 04:48 నుండి 05:44 వరకు",
          },
          {
            date: "02/06/2026: 05:44 నుండి 00:05 జూన్ 04 వరకు",
          },
          {
            date: "05/06/2026: 21:16 నుండి 19:43 జూన్ 07 వరకు",
          },
          {
            date: "09/06/2026: 20:20 నుండి 21:39 జూన్ 10 వరకు",
          },
          {
            date: "16/06/2026: 05:45 నుండి 11:12 వరకు",
          },
          {
            date: "19/06/2026: 17:23 నుండి 18:10 జూన్ 20 వరకు",
          },
          {
            date: "23/06/2026: 17:03 నుండి 05:47 జూన్ 25 వరకు",
          },
          {
            date: "26/06/2026: 05:48 నుండి 13:05 వరకు",
          },
          {
            date: "28/06/2026: 10:10 నుండి 05:48 జూన్ 29 వరకు",
          },
          {
            date: "30/06/2026: 05:49 నుండి 06:26 జూలై 01 వరకు",
          },
          {
            date: "03/07/2026: 05:50 నుండి 03:54 జూలై 05 వరకు",
          },
          {
            date: "07/07/2026: 05:51 నుండి 06:02 జూలై 08 వరకు",
          },
          {
            date: "12/07/2026: 16:08 నుండి 05:53 జూలై 13 వరకు",
          },
          {
            date: "17/07/2026: 05:54 నుండి 03:12 జూలై 18 వరకు",
          },
          {
            date: "21/07/2026: 05:55 నుండి 05:56 జూలై 23 వరకు",
          },
          {
            date: "25/07/2026: 16:16 నుండి 05:57 జూలై 27 వరకు",
          },
          {
            date: "28/07/2026: 05:58 నుండి 11:47 వరకు",
          },
          {
            date: "31/07/2026: 05:58 నుండి 10:24 ఆగస్టు 01 వరకు",
          },
          {
            date: "04/08/2026: 06:00 నుండి 13:26 వరకు",
          },
          {
            date: "08/08/2026: 11:34 నుండి 02:44 ఆగస్టు 10 వరకు",
          },
          {
            date: "14/08/2026: 06:02 నుండి 12:12 వరకు",
          },
          {
            date: "18/08/2026: 06:03 నుండి 05:45 ఆగస్టు 20 వరకు",
          },
          {
            date: "22/08/2026: 00:33 నుండి 06:04 ఆగస్టు 24 వరకు",
          },
          {
            date: "26/08/2026: 15:55 నుండి 06:05 ఆగస్టు 27 వరకు",
          },
          {
            date: "28/08/2026: 06:05 నుండి 15:53 వరకు",
          },
          {
            date: "30/08/2026: 17:55 నుండి 06:05 ఆగస్టు 31 వరకు",
          },
          {
            date: "05/09/2026: 06:14 నుండి 09:25 సెప్టెంబర్ 06 వరకు",
          },
          {
            date: "09/09/2026: 18:04 నుండి 06:07 సెప్టెంబర్ 10 వరకు",
          },
          {
            date: "13/09/2026: 21:35 నుండి 06:07 సెప్టెంబర్ 14 వరకు",
          },
          {
            date: "15/09/2026: 06:07 నుండి 18:33 సెప్టెంబర్ 16 వరకు",
          },
          {
            date: "18/09/2026: 11:00 నుండి 02:42 సెప్టెంబర్ 21 వరకు",
          },
          {
            date: "22/09/2026: 23:02 నుండి 06:08 సెప్టెంబర్ 24 వరకు",
          },
          {
            date: "28/09/2026: 00:00 నుండి 01:20 సెప్టెంబర్ 28 వరకు",
          },
          {
            date: "02/10/2026: 12:23 నుండి 03:32 అక్టోబర్ 03 వరకు",
          },
          {
            date: "07/10/2026: 00:11 నుండి 02:25 అక్టోబర్ 08 వరకు",
          },
          {
            date: "11/10/2026: 05:41 నుండి 06:12 అక్టోబర్ 12 వరకు",
          },
          {
            date: "13/10/2026: 06:12 నుండి 02:51 అక్టోబర్ 14 వరకు",
          },
          {
            date: "16/10/2026: 06:13 నుండి 13:26 అక్టోబర్ 18 వరకు",
          },
          {
            date: "20/10/2026: 08:31 నుండి 05:51 అక్టోబర్ 22 వరకు",
          },
          {
            date: "25/10/2026: 00:00 నుండి 07:40 వరకు",
          },
          {
            date: "30/10/2026: 06:17 నుండి 21:43 వరకు",
          },
          {
            date: "03/11/2026: 06:19 నుండి 08:04 నవంబర్ 04 వరకు",
          },
          {
            date: "07/11/2026: 11:47 నుండి 06:21 నవంబర్ 09 వరకు",
          },
          {
            date: "10/11/2026: 06:22 నుండి 10:59 వరకు",
          },
          {
            date: "13/11/2026: 06:23 నుండి 00:33 నవంబర్ 15 వరకు",
          },
          {
            date: "17/11/2026: 06:25 నుండి 15:49 నవంబర్ 18 వరకు",
          },
          {
            date: "20/11/2026: 14:50 నుండి 14:50 నవంబర్ 21 వరకు",
          },
          {
            date: "26/11/2026: 01:24 నుండి 06:31 వరకు",
          },
          {
            date: "01/12/2026: 06:34 నుండి 14:23 వరకు",
          },
          {
            date: "04/12/2026: 17:15 నుండి 06:37 డిసెంబర్ 07 వరకు",
          },
          {
            date: "09/12/2026: 14:56 నుండి 06:39 డిసెంబర్ 10 వరకు",
          },
          {
            date: "11/12/2026: 06:40 నుండి 09:52 డిసెంబర్ 12 వరకు",
          },
          {
            date: "14/12/2026: 05:47 నుండి 06:41 వరకు",
          },
          {
            date: "15/12/2026: 06:42 నుండి 02:20 డిసెంబర్ 16 వరకు",
          },
          {
            date: "18/12/2026: 06:43 నుండి 00:44 డిసెంబర్ 19 వరకు",
          },
          {
            date: "23/12/2026: 09:09 నుండి 06:46 డిసెంబర్ 24 వరకు",
          },
          {
            date: "27/12/2026: 20:28 నుండి 06:48 డిసెంబర్ 28 వరకు",
          },
        ],
        txt: "నామకరణ ముహూర్తాలు",
      },
    ],
  }],

  "Namakaranam": [[{
    "data": {
      "Eng": "chu,che,cho,la",
      "NakshatraEng": "Aswini",
      "NakshatraTel": "అశ్విని",
      "Telugu": "చు, చే, చో, లా"
    }
  }, {
    "data": {
      "Eng": "Lee, Lu, Le, Lo",
      "NakshatraEng": "Bharani",
      "NakshatraTel": "భరణి",
      "Telugu": "లీ, లు, లే, లో"
    }
  }, {
    "data": {
      "Eng": "aa, ee, vu, Ei",
      "NakshatraEng": "Krithika",
      "NakshatraTel": "కృతిక",
      "Telugu": "ఆ,ఈ,ఊ ,ఏ,"
    }
  }, {
    "data": {
      "Eng": "O, Va, Vi, Vu",
      "NakshatraEng": "Rohini",
      "NakshatraTel": "రోహిణి",
      "Telugu": "ఓ, వా, వి, వు"
    }
  }, {
    "data": {
      "Eng": "We Wo, Ka, Ki",
      "NakshatraEng": "Mrugasira",
      "NakshatraTel": "మృగశిర",
      "Telugu": "వి వో, కా, కి"
    }
  }, {
    "data": {
      "Eng": "Ku, kam, ja, cha",
      "NakshatraEng": "Arudra",
      "NakshatraTel": "ఆరుద్ర",
      "Telugu": "కూ,ఖం,జ, ఛా"
    }
  }, {
    "data": {
      "Eng": "ke,ko,ha,hi",
      "NakshatraEng": "Punarvasu",
      "NakshatraTel": "పునర్వసు",
      "Telugu": "కే, కో, హ, హీ"
    }
  }, {
    "data": {
      "Eng": "hu,he,ho,da",
      "NakshatraEng": "Pushyami",
      "NakshatraTel": "పుష్య",
      "Telugu": "హు, హీ, హో, డా"
    }
  }, {
    "data": {
      "Eng": "di,du,de,do",
      "NakshatraEng": "Ashlesha",
      "NakshatraTel": "ఆశ్లేష",
      "Telugu": "డీ, డు, డే,డో"
    }
  }, {
    "data": {
      "Eng": "ma,mi,mu,me",
      "NakshatraEng": "Makha",
      "NakshatraTel": "మఖ",
      "Telugu": "మా, మి,  మూ, మే"
    }
  }, {
    "data": {
      "Eng": "mo,ta,ti,tu",
      "NakshatraEng": "PoorvaPhalguni",
      "NakshatraTel": "పూర్వ ఫల్గుని",
      "Telugu": "మో, టా, టీ,  టూ"
    }
  }, {
    "data": {
      "Eng": "te,to,pa,pi",
      "NakshatraEng": "Uthraphalguni",
      "NakshatraTel": "ఉత్తర ఫల్గుని",
      "Telugu": "టే, టో,  పా, పీ"
    }
  }, {
    "data": {
      "Eng": "pu,sham,na,ta",
      "NakshatraEng": "Hastha",
      "NakshatraTel": "హస్త",
      "Telugu": "వూ, షం, ణా,  ఢా"
    }
  }, {
    "data": {
      "Eng": "pe,po,ra,ri",
      "NakshatraEng": "Chitra",
      "NakshatraTel": "చిత్ర",
      "Telugu": "పే, పో, రా, రి"
    }
  }, {
    "data": {
      "Eng": "ru,re,ro,tha",
      "NakshatraEng": "Swaathi",
      "NakshatraTel": "స్వాతి",
      "Telugu": "రూ, రే,  రో, లా"
    }
  }, {
    "data": {
      "Eng": "thi,thu,the,tho",
      "NakshatraEng": "Vishaakha",
      "NakshatraTel": "విశాక",
      "Telugu": "తీ, తూ, తే, తో"
    }
  }, {
    "data": {
      "Eng": "na,ni,nu,ne",
      "NakshatraEng": "Anuraadha",
      "NakshatraTel": "అనురాధ",
      "Telugu": "నా, నీ, నూ, నే"
    }
  }, {
    "data": {
      "Eng": "no,ya,yi,yu",
      "NakshatraEng": "Jyeshta",
      "NakshatraTel": "జ్యేష్ట",
      "Telugu": "నో, యా, యీ, యూ"
    }
  }, {
    "data": {
      "Eng": "ye,yu,ba,bi",
      "NakshatraEng": "Moola",
      "NakshatraTel": "మూలా",
      "Telugu": "యే, యో, బా,  బీ"
    }
  }, {
    "data": {
      "Eng": "bu,da,bha,da",
      "NakshatraEng": "Poorvashaada",
      "NakshatraTel": "పూర్వాషాఢ",
      "Telugu": "బూ,  ధా, భా, ఢా"
    }
  }, {
    "data": {
      "Eng": "be,bo,ja,ji",
      "NakshatraEng": "Uthrashaada",
      "NakshatraTel": "ఉత్తరాషాఢ",
      "Telugu": "బే, బో,  జా,  జీ"
    }
  }, {
    "data": {
      "Eng": "ju,je,jo,ka",
      "NakshatraEng": "Shraavan",
      "NakshatraTel": "శ్రవణ",
      "Telugu": "జూ, జే, జో, ఖా"
    }
  }, {
    "data": {
      "Eng": "ga,gi,gu,ge",
      "NakshatraEng": "Dhanishta",
      "NakshatraTel": "ధనిష్ఠ",
      "Telugu": "గా,  గీ ,గూ, గే"
    }
  }, {
    "data": {
      "Eng": "go,sa,si,su",
      "NakshatraEng": "Shathabhisha",
      "NakshatraTel": "శతభిష",
      "Telugu": "గో, సా,  సీ, సూ"
    }
  }, {
    "data": {
      "Eng": "se,so,dha,dhi",
      "NakshatraEng": "Poorvabhadra",
      "NakshatraTel": "పూర్వాభాద్ర",
      "Telugu": "సే, సో,  దా,దీ"
    }
  }, {
    "data": {
      "Eng": "du,syam,zu,dha",
      "NakshatraEng": "Uthrabhadra",
      "NakshatraTel": "ఉత్తరాభాద్ర",
      "Telugu": "ధు, శ్చం, చా, ధా"
    }
  }, {
    "data": {
      "Eng": "de,do,cha,chi",
      "NakshatraEng": "Revathi",
      "NakshatraTel": "రేవతి",
      "Telugu": "దే, దో, చా, చీ"
    }
  }]],
  "JanapadaKalalu": {
    "CatID": [
      {
        "title": "1. హరికథ"
      },
      {
        "title": "2. బుర్రకథ"
      },
      {
        "title": "3. ఒగ్గుకథ"
      },
      {
        "title": "4. తోలుబొమ్మలాట"
      },
      {
        "title": "5. బుడబుక్కలాట"
      },
      {
        "title": "6. కోలాటం"
      },
      {
        "title": "7. పులివేషం"
      },
      {
        "title": "8. యక్షగానం"
      },
      {
        "title": "9. వీధినాటకాలు"
      },
      {
        "title": "10. డప్పులనృత్యం"
      },
      {
        "title": "11. గంగిరెద్దులమేళం"
      },
      {
        "title": "12. కర్రసాము"
      }
    ],
    "title": "జానపద_కళలు"
  },
  "Kulavruthulu": {
    "CatID": [
      {
        "title": "1. బ్రాహ్మణ"
      },
      {
        "title": "2. క్షత్రియ"
      },
      {
        "title": "3. వైశ్య"
      },
      {
        "title": "4. రజక"
      },
      {
        "title": "5. మంగలి"
      },
      {
        "title": "6. వడ్రంగి"
      },
      {
        "title": "7. కుమ్మరి"
      },
      {
        "title": "8. కమ్మరి"
      },
      {
        "title": "9. కంసాలి"
      },
      {
        "title": "10. సాలెలు"
      },
      {
        "title": "11. జాలరి"
      },
      {
        "title": "12. మేదరి"
      },
      {
        "title": "13. కర్షకుడు"
      },
      {
        "title": "14. చెప్పులు కుట్టేవారు"
      }
    ],
    "title": "కులవృత్తులు"
  },
  "telugudays": {
    "CatID": [
      {
        "title": "1. ఆది"
      },
      {
        "title": "2. సోమ"
      },
      {
        "title": "3. మంగళ"
      },
      {
        "title": "4. బుధ"
      },
      {
        "title": "5. గురు"
      },
      {
        "title": "6. శుక్ర"
      },
      {
        "title": "7. శని"
      }
    ],
    "title": "తెలుగు_రోజులు"
  },
  "karanamulu": {
    "CatID": [
      {
        "title": "1. కింస్తుఘ్న"
      },
      {
        "title": "2. బవ"
      },
      {
        "title": "3. బాలవ"
      },
      {
        "title": "4. కౌలవ"
      },
      {
        "title": "5. తైతిల"
      },
      {
        "title": "6. గర"
      },
      {
        "title": "7. వణిజ"
      },
      {
        "title": "8. శకుని"
      },
      {
        "title": "9. చతుష్పాద"
      },
      {
        "title": "10. నాగవ"
      }
    ],
    "title": "తెలుగు కరణములు"
  },
  "yogalu": {
    "CatID": [
      {
        "title": "1. విష్కుమ్భ"
      },
      {
        "title": "2. ప్రీతి"
      },
      {
        "title": "3. ఆయుష్మాన్"
      },
      {
        "title": "4. సౌభాగ్య"
      },
      {
        "title": "5. శోభన"
      },
      {
        "title": "6. అతిగణ్డ"
      },
      {
        "title": "7. సుకర్మా"
      },
      {
        "title": "8. ధృతి"
      },
      {
        "title": "9. శూల"
      },
      {
        "title": "10. గణ్డ"
      },
      {
        "title": "11. వృద్ధి"
      },
      {
        "title": "12. ధ్రువ"
      },
      {
        "title": "13. వ్యాఘాత"
      },
      {
        "title": "14. హర్షణ"
      },
      {
        "title": "15. వజ్ర"
      },
      {
        "title": "16. సిద్ధి"
      },
      {
        "title": "17. వ్యతీపాత"
      },
      {
        "title": "18. వారీయన"
      },
      {
        "title": "19. పరిఘ"
      },
      {
        "title": "20. శివ"
      },
      {
        "title": "21. సిద్ధ"
      },
      {
        "title": "22. సాధ్య"
      },
      {
        "title": "23. శుభ"
      },
      {
        "title": "24. శుక్ల"
      },
      {
        "title": "25. బ్రహ్మ"
      },
      {
        "title": "26. ఐన్ద్ర"
      },
      {
        "title": "27. వైధృతి"
      }
    ],
    "title": "యోగాలు"
  },
  "officiallanguages": {
    "CatID": [
      {
        "state": "అసోం",
        "title": "అస్సామీస్, బోడో, కర్బీ"
      },
      {
        "state": "పశ్చిమ బెంగాల్",
        "title": "బెంగాలీ"
      },
      {
        "state": "జమ్మూ కాశ్మీరు లద్దాక్",
        "title": "డోగ్రి"
      },
      {
        "state": "గోండ్వానా పీఠభూమి లోని గోండుల",
        "title": "గోండి"
      },
      {
        "state": "దాద్రా నాగరు హవేలీ, డామన్ డయ్యు, గుజరాత్",
        "title": "గుజరాతీ"
      },
      {
        "state": "కర్ణాటక",
        "title": "కన్నడ"
      },
      {
        "state": "జమ్మూ కాశ్మీరు",
        "title": "కాశ్మీరీ"
      },
      {
        "state": "గోవా",
        "title": "కొంకణి"
      },
      {
        "state": "కేరళ, లక్షద్వీపాలు,మాహే (కేంద్రపాలిత ప్రాంతం, పాండిచ్చేరి)",
        "title": "మలయాళం"
      },
      {
        "state": "బీహార్",
        "title": "మైథిలి"
      },
      {
        "state": "మణిపూర్",
        "title": "మణిపురి లేక మైతై"
      },
      {
        "state": "మహారాష్ట్ర",
        "title": "మరాఠి"
      },
      {
        "state": "సిక్కిం",
        "title": "నేపాలీ"
      },
      {
        "state": "ఒడిషా",
        "title": "ఒరియా"
      },
      {
        "state": "పంజాబ్, చండీగఢ్",
        "title": "పంజాబీ"
      },
      {
        "state": "ఉత్తరాఖండ్లో",
        "title": "సంస్కృతం"
      },
      {
        "state": "జార్ఖండ్, బీహార్, ఒడిషా, చత్తీస్‌గఢ్",
        "title": "సంతాలీ"
      },
      {
        "state": "సింధీ",
        "title": "సింధీ"
      },
      {
        "state": "తమిళనాడు, పుదుచ్చేరి",
        "title": "తమిళం"
      },
      {
        "state": "ఆంధ్ర ప్రదేశ్,తెలంగాణ,అండమాన్ నికోబార్ దీవులు యానాం",
        "title": "తెలుగు"
      },
      {
        "state": "జమ్మూ కాశ్మీరు, ఆంధ్ర ప్రదేశ్, తెలంగాణ, ఢిల్లీ, ఉత్తర ప్రదేశ్",
        "title": "ఉర్దూ"
      }
    ],
    "title": "వివిధ_రాష్ట్రాల_అధికార_భాషలు"
  },
  "upanishadlu": {
    "data": [
      {
        "title": "ఉపనిషత్తులు అంటే బ్రహ్మవిద్య, జీవాత్మ, పరమాత్మ, జ్ఞానము, మోక్షము, పరబ్రహ్మ స్వరూపమును గురించి వివరించేవి. నాలుగు వేదాలకు కలిపి 1180 ఉపనిషత్తులు ఉన్నాయి. కాని వీటిలో 108 ఉపనిషత్తులు మాత్రమే చదవదగ్గవి అని చెబుతారు. ఉప అంటే సమీపంగా, ని అంటే కింద, షత అంటే కూర్చునుట."
      },
      {
        "title": "ఋగ్వేదానికి సంబంధించినవి - 10"
      },
      {
        "title": "కృష్ణ యజుర్వేదానికి సంబంధించినవి - 32"
      },
      {
        "title": "శుక్ల యజుర్వేదానికి సంబంధించినవి - 19"
      },
      {
        "title": "సామవేదానికి సంబంధించినవి - 16"
      },
      {
        "title": "అధర్వణ వేదానికి సంబంధించినవి - 31 (మొత్తం - 108)"
      },
    ],
    "CatID": [
      {
        "title": "1. ఈశావాస్య ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "2. కేన ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "3. కఠ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "4. ప్రశ్న ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "5. ముండక ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "6. మాండూక్య ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "7. తైత్తిరీయ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "8. ఐతరేయ ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "9. ఛాందోగ్య ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "10. బృహదారణ్యక ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "11. బ్రహ్మ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "12. కైవల్య ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "13. జాబాల ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "14. శ్వేతాశ్వతర ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "15. హంస ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "16. ఆరుణిక ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "17. గర్భ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "18. నారాయణ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "19. పరమహంస ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "20. అమృతబిందు ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "21. అమృతనాద ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "22. అధర్వశిర ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "23. అధర్వశిఖ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "24. మైత్రాయణి ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "25. కౌషీతకీబ్రాహ్మణ ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "26. బృహత్ జాబాల ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "27. నృసింహతాపిని ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "28. కాలాగ్నిరుద్ర ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "29. మైత్రేయ ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "30. సుబాల ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "31. క్షురిక ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "32. మంత్రిక ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "33. సర్వసార ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "34. నిరాలంబ ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "35. శుకరహస్య ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "36. వజ్రసూచిక ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "37. తెజోబిందు ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "38. నాదబిందు ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "39. ధ్యానబిందు ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "40. బ్రహ్మవిద్య ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "41. యోగతత్త్వ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "42. ఆత్మబోధ ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "43. నారదపరివ్రాజక ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "44. త్రిశిఖబ్రాహ్మణ ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "45. సీత ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "46. యోగచూడామణి ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "47. నిర్వాణ ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "48. మండలబ్రాహ్మణ ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "49. దక్షిణామూర్తి ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "50. శరభ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "51. స్కంద ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "52. త్రిపాద్విభూతిమహానారాయణ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "53. అద్వయతారక ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "54. రామరహస్య ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "55. రామతాపిని ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "56. వాసుదేవ ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "57. ముద్గల ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "58. శాండిల్య ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "59. పైంగల ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "60. భిక్షుక ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "61. మహా ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "62. శారీరక ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "63. యోగశిఖ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "64. తురీయాతీత ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "65. సన్యాస ఉపనిషత్తు  - సామవేదం"
      },
      {
        "title": "66. పరమహంస పరివ్రాజక ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "67. అక్షమాలిక ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "68. అవ్యక్త ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "69. అన్నపూర్ణ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "70. ఏకాక్షర ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "71. సూర్య ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "72. అక్షి ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "73. అధ్యాత్మ ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "74. కుండిక ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "75. సావిత్రి ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "76. ఆత్మ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "77. పాశుపతబ్రహ్మ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "78. పరబ్రహ్మ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "79. అవధూత ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "80. త్రిపురాతాపిని ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "81. దేవి ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "82. త్రిపుర ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "83. కఠరుద్ర ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "84. భావన ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "85. రుద్రహృదయ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "86. యోగకుండలి ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "87. బస్మజాబాల ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "88. రుద్రాక్షజాబాల ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "89. గణపతి ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "90. దర్శన ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "91. తారసార ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "92. మహావాక్య ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "93. పంచబ్రహ్మ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "94. ప్రాణాగ్నిహోత్ర ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "95. గోపాలతాపిని ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "96. కృష్ణ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "97. యాజ్ఞవల్క ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "98. వరాహ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "99. శాట్యాయనీయ ఉపనిషత్తు - శుక్లయజుర్వేదం"
      },
      {
        "title": "100. హయగ్రీవ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "101. దత్తాత్రేయ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "102. గారుడ ఉపనిషత్తు - అధర్వణవేదం"
      },
      {
        "title": "103. కలిసంతరణ ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "104. జాబాలి ఉపనిషత్తు - సామవేదం"
      },
      {
        "title": "105. సౌభాగ్యలక్ష్మి ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "106. సరస్వతీరహస్య ఉపనిషత్తు - కృష్ణయజుర్వేదం"
      },
      {
        "title": "107. బహ్వృచ ఉపనిషత్తు - ఋగ్వేదం"
      },
      {
        "title": "108. ముక్తిక ఉపనిషత్తు - శుక్లయజుర్వేదం"
      }
    ],
    "title": "108_ఉపనిషత్తులు"
  },
  "agamanalu": {
    "CatID": [
      {
        "title": "శైవ"
      },
      {
        "title": "వైఖానసము"
      },
      {
        "title": "పాంచరాత్రము"
      }
    ],
    "title": "ఆగమములు"
  },
  "vedabagamulu": {
    "CatID": [
      {
        "title": "సంహిత"
      },
      {
        "title": "బ్రాహ్మణము"
      },
      {
        "title": "అరణ్యకము"
      },
      {
        "title": "ఉపనిషత్తులు"
      }
    ],
    "title": "వేదభాగాలు"
  },
  "vedamulu": {
    "CatID": [
      {
        title: 'ఋగ్వేదం :',
      },
      {
        title: 'దేవతల గుణగణాలు ఇందిలో ప్రత్యేకం. అగ్నిదేవుడి ప్రార్ధనతో ఈ వేదం ప్రారంభమవుతుంది. ఇందులో 1017 సూక్లా, 10,580 మంత్రాలు, 1,53,826 శబ్దాలు, 43,200 అక్షరాలు ఉన్నాయి. ఋగ్వేదంలో ఉండే మంత్రాలను రుక్కులు అని కూడా అంటారు. ఇవి ఛందోబద్ధాలు.',
      },
      {
        title: 'యజుర్వేదం :',
      },
      {
        title: 'ఇది యజ్ఞయాగాదులు గురించి వివరిస్తుంది. ఇందులో రెండు శాఖలు ఉన్నాయి. అవి:                                               1. శుక్ల యజుర్వేదం (యాజ్ఞ వల్క్య మహర్షి). ఇందులో 1975 పద్యగద్యాలున్నాయి.                                                                2. యజుర్వేదం (త్తెత్తరీయ మహర్షి). ఇందులో 2198 మంత్రాలు, 19,200 పదాలు ఉన్నాయి.',
      },
      // {
      //   title: '1. శుక్ల యజుర్వేదం (యాజ్ఞ వల్క్య మహర్షి). ఇందులో 1975 పద్యగద్యాలున్నాయి.',
      // },
      // {
      //   title: '2. యజుర్వేదం (త్తెత్తరీయ మహర్షి). ఇందులో 2198 మంత్రాలు, 19,200 పదాలు ఉన్నాయి.',
      // },
      {
        title: 'సామవేదము :',
      },
      {
        title: 'ఇది అతి చిన్నది. సమం అంటే గ్రామం. ఇందులో మంత్రాలు 1875 ఉన్నాయి. వీటిలో 1504 ఋగ్వేద మంత్రాలే. 99 మాత్రమే కొత్తవి. 272 పునరుక్తాలు. భారతీయ సంగీత శాస్త్రానికి సామవేదమే మూలం. ఇది శాంతి వేదం.',
      },
      {
        title: 'అధర్వణవేదము :',
      },
      {
        title: 'లౌకిక విషయాలను ఇది వర్ణిస్తుంది. 5977 మంత్రాలు ఉన్నాయి. అనేక చికిత్సా విధానాలు ఉన్నాయి. మూలికా చికిత్స కూడా ఇందులో వర్ణించి ఉంది. రాజ్యం, రాజ్యాంగం, రాజకీయ వ్యవస్థల గురించి వివరంగా వర్ణనలు ఉన్నాయి. దీనినే బ్రహ్మ వేదమని కూడా అంటారు. రాజ్యం, రాజకీయాల గురించి వివరించినందుకు క్షత్ర వేదమని, చికిత్సల గురించి వివరిస్తుంది కాబట్టి భిషగ్వేదమని కూడా పిలుస్తారు. వేదాలను అర్థం చేసుకోవడం సామాన్యులకు కష్టమే. అందుకే వీటిని చదివి అర్థం చేసుకోవడానికి మహర్షులు ఒక నిర్దిష్ట పద్ధతిని ఏర్పరిచారు. దీని ప్రకారమే ఆరు వేదాంగాలు, నాలుగు ఉపవేదాలు ఉన్నాయి.                       ఉపవేదాలు: గాంధర్వ వేదం, ఆయుర్వేదం, ధనుర్వేదం, అర్థవేదం. అథర్వణ వేదమే ఈ నాలుగు ఉప వేదాలకు మూలమని భావిస్తారు.',
      },
      // {
      //   title: 'ఉపవేదాలు: గాంధర్వ వేదం, ఆయుర్వేదం, ధనుర్వేదం, అర్థవేదం. అథర్వణ వేదమే ఈ నాలుగు ఉప వేదాలకు మూలమని భావిస్తారు.',
      // },
    ],
    "title": "చతుర్వేదములు"
  },
  "vedaluupyogalu": {
    "CatID": [
      {
        title: 'ఈ లోకంలో ప్రతి ప్రాణి, ప్రతి జీవి యొక్క యదార్థ స్వరూపం పరమాత్మయే. అయితే తను పరమాత్మా స్వరూపాన్ని మరచి జీవుడుగా వ్యవహరిస్తున్నాడు మానవుడు. అది ఎలాగు అంటే తను తన స్వస్వరుపాన్ని మరచి అజ్ఞానంతో మరియు అవిద్యతో ఏర్పరచుకున్న కర్మలతో తనకు తాను వచ్చిన దారిని మరచి బద్దుడవుతున్నాడు.',
      },
      {
        title: 'అలా దారితప్పిన మనం ఇప్పుడు తిరిగి మాధవుడుగా (మానవుడే మాధవుడు), నరుడు నారాయనుడుగా, జీవుడు దేవుడుగా తన స్వస్తితిలో నిలిచి పోవాలంటే అందుకు మార్గం చుపేవే వేదాలు.',
      },
      {
        title:
          'వేద అంటే తెలుసుకొనుట అని అర్థం . ఏమి తెలుసుకోవాలి? దేనిని తెలుసుకున్న తరువాత ఇక తెలిసికోవాల్సింది ఏమి ఉండదో, దేనిని తెలుసుకుంటే సర్వము తెలిసినట్లో అట్టి జ్ఞానాన్ని ఆత్మ జ్ఞానాన్ని తెలుసుకోవాలి. కనుక మానవుడు తరించాలంటే, తన జన్మను సార్ధకం చేసుకోవాలంటే, జీవిత పరమార్ధమైన మోక్షాన్ని పొందాలంటే తప్పక తెలిసికోవలసింది వేదవిజ్ఞాన్నే.',
      },
      {
        title:
          'ఈ వేదవిజ్ఞానాన్ని మొదట బ్రహ్మ దేవుడు దివ్యవాణిగా విన్నాడు. అందుకే దీనిని శృతి అన్నారు. శృతి అంటే విన్నది అని అర్థం. బ్రహ్మదేవుడు మొదటగా విని ఇతరులకు బోదించటం వలన దీనిని "బ్రహ్మవిద్య" అన్నారు.',
      },
      {
        title:
          'మొదట వేదం అంతా ఒకటిగానే వుండేది. కానీ కలియుగంలో మనుషులు అల్పాయుష్కులు మరియు అల్పజ్ఞానులు అని గ్రహించి ఈ వేదమంత్రాలను కలియుగానికి ముందే ద్వాపరయుగంలో జన్మించిన వ్యాసమహర్షి ఒకటిగా ఉన్న ఈ వేదమంత్రాలను నాలుగుగా విభజించి వేదవ్యాసుడయ్యాడు.',
      },
      {
        title:
          'అవే: 1.ఋగ్వేదం, 2.యజుర్వేదం, 3.సామవేదం, 4.అధర్వణవేదం.',
      },
      {
        title:
          'ఇలా విభజించబడిన ప్రతివేదం తిరిగి ఒక్కొక్కటి నాలుగు భాగాలుగా విభజించబడినవి. అవే: 1.సంహిత (మంత్రం భాగము), 2.బ్రాహ్మణులూ (పూజలు, యజ్ఞయాగాదులు మొదలైనవి కర్మకాండ), 3.ఆరణ్యకాలు (ఉపాసనలు), 4.ఉపనిషత్తులు (పరమాత్మా తత్త్వం).',
      },
      {
        title:
          'మానవులకు మోక్ష మార్గాన్ని చూపేవే ఉపనిషత్తులు. ఇవి వేదాలకు అంతంలో వుండడం వలన వేదాంతం అంటారు. మన మానవ జీవితాన్ని తరింపజేసుకోనుటకు, మోక్షాన్ని అందుకొనుటకు కావలసిన అద్భుత జ్ఞానాన్ని ప్రసదించేవే ఉపనిషత్తులు. ఇవి నాలుగు వేదాలలోను మొత్తం 1180 వున్నవి. అయితే 108 ఉపనిషత్తులు మాత్రమే మంత్రాలతో సహా ఇప్పుడు మనకు లభిస్తున్నాయి.',
      },
      {
        title:
          'ఇందులో కూడా 10 ఉపనిషత్తులు అత్యంత ముఖ్యమైనవని మహాత్ములందరూ అంగీకరిస్తున్నారు. అవే: ',
      },
      {
        title: 'ఈసా, కేన, కఠో, ప్రశ్న, ముండక, మాండుక్య, తైత్తిరీయ, ఐతరేయ, ఛాందోగ్య, బృహదారణ్యక అనే దశోపనిషత్తులు.',
      },
      {
        title: 'ఉపనిషత్తులు అంటే ఆత్మవిద్య అదే బ్రహ్మవిద్య . ఈ విద్య మానవునిలోని అజ్ఞాన్ని పోగొట్టి, సమస్త దుఃఖాలను నివృత్తి చేసి, పరబ్రహ్మాన్ని ఎరుకపరిచి, ముక్తిని ప్రసాదిస్తుంది.',
      },
    ],
    "title": "వేదాలు - ఉపయోగాలు"
  },
  "manaacharalu": {
    "CatID": [
      {
        "title": "1. మనం సాధారణంగా ఆల‌యాల్లో గంట‌లు ఉండ‌డం చూస్తుంటాం. ఆల‌యాల్లో ఉండే గంట‌ను ఏడు సార్లు కొడితే మ‌న శ‌రీరంలో ఉన్న ఏడు చ‌క్రాలు ఉత్తేజం అవుతాయ‌ట‌. అంతేకాదు మెద‌డు కుడి, ఎడ‌మ భాగాలు రెండూ కొంత సేపు ఏక‌మ‌వుతాయ‌ట‌. దీంతోమ‌న మ‌న‌స్సుకు ప్ర‌శాంత‌త క‌లుగుతుంద‌ట‌. ఏకాగ్ర‌త పెరుగుతుంద‌ట‌. గంట‌ను మోగించ‌డం వ‌ల్ల ఆ ప్రాంతంలోని గాలిలో ఉండే క్రిములు నాశ‌న‌మ‌వుతాయ‌ట‌."
      },
      {
        "title": "2. ఇక ఆడ‌వారు గాజులు ధరించ‌డం వ‌ల్ల అనారోగ్య స‌మ‌స్య‌లు రాకుండా ఉంటాయ‌ట‌. గాజులు ఎల్ల‌ప్పుడూ చేతి న‌రాల‌కు తాకుతూ ఉండ‌డం వ‌ల్ల బీపీ కూడా కంట్రోల్‌లో ఉంటుంద‌ట‌."
      },
      {
        "title": "3. చిన్న పిల్లలకు చెవులు కుట్టించ‌డం స‌హ‌జ‌మే. ప్ర‌ధానంగా ఆడ‌పిల్ల‌ల‌కు, అలాగే కొంత మంది మ‌గ పిల్ల‌ల‌కు కూడా చెవులు కుట్టిస్తారు. అయితే ఇలా కుట్టించ‌డం వ‌ల్ల ఆక్యుప్రెష‌ర్ వైద్యం జ‌రిగి దాంతో వారికి వ‌చ్చే బాలారిష్ట అనారోగ్యాలు పోతాయ‌ట‌. ప్ర‌ధానంగా ఆస్త‌మా వంటి వ్యాధులు రావ‌ట‌."
      },
      {
        "title": "4. హిందువుల్లో అధిక శాతం మంది రావి చెట్టుకు పూజ‌లు చేస్తారు. ఈ చెట్ల‌ ఎక్కువ‌గా దేవాల‌యాల్లోనే ఉంటాయి. అయితే సాధార‌ణంగా చెట్ల‌న్నీ ప‌గ‌టి పూట ఆక్సిజ‌న్‌ను విడుద‌ల చేస్తే రావి చెట్టు మాత్రం రాత్రి పూట ఆక్సిజ‌న్‌ను విడుద‌ల చేస్తుంద‌ట‌. అందుకే రావి చెట్టును పూజిస్తారు."
      },
      {
        "title": "5. హిందూ సాంప్ర‌దాయంలో పెళ్ల‌యిన మ‌హిళ‌లు కాలికి మెట్టెల‌ను ధ‌రిస్తారు. ఇలా ధ‌రించ‌డం వ‌ల్ల ఆక్యుప్రెష‌ర్ వైద్యం జ‌రిగి వారి గుండె నుంచి గ‌ర్భాశ‌యానికి ర‌క్త ప్ర‌స‌ర‌ణ బాగా జ‌రుగుతుంద‌ట‌. అయితే బంగారం మెట్టెలు కంటే వెండి మెట్టెలు ధ‌రిస్తే ప్ర‌కృతిలో ఉన్న పాజిటివ్ ఎన‌ర్జీ వారి శ‌రీరంలోకి ప్ర‌వేశిస్తుంద‌ట‌."
      },
      {
        "title": "6. భూమికి అయ‌స్కాంత క్షేత్రం ఉన్న‌ట్టుగానే మ‌న శ‌రీరానికి కూడా అయ‌స్కాంత క్షేత్రం ఉంటుంద‌ట‌. ఒక వేళ మ‌నం ఉత్త‌రం దిశ‌గా త‌ల‌ను పెట్టి ప‌డుకుంటే మ‌న శ‌రీరంలో ఉన్న ఐర‌న్ మెద‌డుకు ప్ర‌వ‌హించి బీపీ, గుండె సంబంధ స‌మ‌స్య‌లు వ‌స్తాయ‌ట‌. త‌ల‌నొప్పి, అల్జీమ‌ర్స్‌, పార్కిన్‌స‌న్స్ డిసీజ్ వంటి వ్యాధులు కూడా వచ్చే ప్రమాదం ఉందట‌. కాబ‌ట్టి త‌ల‌ను ఉత్త‌రం దిశ‌కు పెట్టి నిద్రించ‌కూడ‌ద‌ట‌."
      },
      {
        "title": "7. ఆడవారు నుదుట‌న కుంకుమ బొట్టును ధ‌రిస్తే అక్క‌డి న‌రాలు ఉత్తేజిత‌మై పీయూష గ్రంథిని యాక్టివేట్ చేస్తాయ‌ట‌. దీంతో బీపీ, ఒత్తిడి, ఆందోళ‌న వంటి స‌మ‌స్య‌లు త‌గ్గుముఖం ప‌డ‌తాయ‌ట‌. మగవారు కూడా ఇలా కుంకుమ బొట్టును ధరించవచ్చట."
      },
      {
        "title": "8. ఇక మన ఎదురుగా ఉన్న వారికి రెండు చేతుల‌తో న‌మ‌స్క‌రిస్తే మ‌నం వారిని ఎప్ప‌టికీ గుర్తు పెట్టుకుంటామ‌ట‌. ఎందుకంటే మన రెండు చేతుల‌ను జోడించిన‌ప్పుడు చేతి వేళ్ల‌న్నీ క‌లిసిపోయి ఆక్యుప్రెష‌ర్ వైద్యం జ‌రిగి మ‌న జ్ఞాప‌క‌శ‌క్తిని పెంచుతాయ‌ట‌. దీంతోపాటు మెద‌డు ప‌నితీరు కూడా మెరుగు ప‌డుతుంద‌ట‌."
      },
      {
        "title": "9. నేల‌పై కూర్చుని భోజ‌నం చేయ‌డం వ‌ల్ల ప‌ద్మాస‌నం భంగిమ వ‌స్తుంది. దీంతో జీర్ణ‌క్రియ స‌క్ర‌మంగా జ‌రిగి జీర్ణాశ‌య సంబంధ స‌మ‌స్య‌లు దూర‌మ‌వుతాయ‌ట‌."
      },
      {
        "title": "10. భోజ‌నం చేసిన‌ప్పుడు ముందుగా కారంగా ఉండే ఆహారం తిన‌డం వ‌ల్ల జీర్ణాశ‌యంలో జీర్ణ‌క్రియ‌కు అవ‌స‌ర‌మైన ఆమ్లాలు బాగా ఉత్ప‌త్తి అవుతాయ‌ట‌. దీంతో జీర్ణ‌క్రియ స‌క్ర‌మంగా జ‌రుగుతుంద‌ట‌. భోజ‌నం మొదట్లోనే స్వీట్లు తింటే అది మ‌నం తిన్న ఆహారాన్ని స‌రిగ్గా జీర్ణంచేయ‌నీయ‌ద‌ట‌."
      },
      {
        "title": "11. ఒక‌ప్పుడు మ‌న ద‌గ్గ‌ర రాగితో చేసిన నాణేలు చ‌లామ‌ణీలో ఉండేవి. ఈ కార‌ణంగా ఆ నాణేల‌ను న‌దుల్లో వేస్తే ఆ రాగి అంతా ఆ నీటిని శుద్ధి చేసేద‌ట‌. దీంతో ఆ నీటిని తాగేవారికి ఎన్నో అనారోగ్యాలు దూర‌మ‌య్యేవ‌ట‌."
      },
      {
        "title": "12. హిందువుల్లో అధిక శాతం మంది వారంలో ఏదో ఒక రోజు దేవుడికి ఉప‌వాసం ఉంటారు క‌దా. ఆయుర్వేద ప్ర‌కారం అలా ఉప‌వాసం ఉండ‌డం చాలా మంచిది."
      },
      {
        "title": "13. ఎందుకంటే ఉప‌వాస స‌మ‌యంలో మ‌న జీర్ణ‌వ్య‌వ‌స్థకు పూర్తిగా విశ్రాంతి ల‌భించి శ‌రీరంలో ఉన్న ప‌లు విష ప‌దార్థాలు బ‌య‌ట‌కు వెళ్ల‌గొట్ట‌బ‌డ‌తాయ‌ట‌. దీంతోపాటు దేహం త‌న‌కు తాను మ‌ర‌మ్మ‌త్తులు చేసుకుంటుంద‌ట‌. ఉప‌వాసం ఉండ‌డం వ‌ల్ల డ‌యాబెటిస్‌, గుండె జ‌బ్బులు, క్యాన్స‌ర్‌, బాక్టీరియా ఇన్‌ఫెక్ష‌న్లు రావ‌ట‌."
      }
    ],
    "title": "పూర్వకాలం నుండి మన పెద్దలు పాటిస్తున్న, పాటించమని మనకి చెప్తున్న ఆచారాలు వెనుక అంతరార్ధం తప్పక ఉండేది. మరి అలాంటి కొన్ని ఆచారాలు, వాటి వెనుక ఉన్న అంతరార్ధాలు మనం ఇపుడు తెలుసుకుందాము."
  },

  "darsanamulu": {
    "CatID": [
      {
        "title": "సాంఖ్య"
      },
      {
        "title": "యోగ"
      },
      {
        "title": "వైశేషిక"
      },
      {
        "title": "న్యాయ"
      },
      {
        "title": "పూర్వమీమాంస"
      },
      {
        "title": "ఉత్తరమీమాంస"
      }
    ],
    "title": "దర్శనములు"
  },

  "vadangamulu": {
    "CatID": [
      {
        "title": "శిక్ష"
      },
      {
        "title": "ఛందస్సు"
      },
      {
        "title": "వ్యాకరణము"
      },
      {
        "title": "నిరుక్తము"
      },
      {
        "title": "జ్యోతిషము"
      },
      {
        "title": "కల్పము"
      }
    ],
    "title": "వేదాంగములు(సూత్రములు)"
  },
  "truewords": {
    "CatID": [
      {
        "title": "1. తల్లిదండ్రులను పూజించాలి. ఏ స్థితిలోనూ దూషించరాదు."
      },
      {
        "title": "2. మంత్రోపదేశం చేసినవారు మాత్రమే గురువు. (తక్కిన విద్యలు నేర్పినవారు అధ్యాపకులు మాత్రమే) అట్టి గురువును ఏ పరిస్థితిలోనూ నిందించరాదు. ఆయన ఎదురుగా కాళ్ళుచూపి కూర్చోరాదు."
      },
      {
        "title": "3. భోజనం తూర్పు, ఉత్తర దిక్కులవైపు కూర్చొని చేయాలి."
      },
      {
        "title": "4. చిన్న పిల్లల్ని చూడ్డానికి వెళ్ళేటప్పుడు, అనారోగ్యవంతుల దగ్గరికి వెళ్ళేటప్పుడు, గుడికి వెళ్ళేటప్పుడు, గురుదర్శనానికి వెళ్ళేటప్పుడు, పురాణం వినటానికి వెళ్ళేటప్పుడు ఒట్టి చేతులతో వెళ్ళరాదు. ఏదో ఒకటి సమర్పించుకోవాలి."
      },
      {
        "title": "5. భోజనానంతరం ఎంగిలి ఆకులు ఎత్తే వాడికి వచ్చే పుణ్యం అన్నదాతకు కూడా రాదు."
      },
      {
        "title": "6. తల్లిదండ్రులకు నిత్యపాద నమస్కారం చేయడానికి మించిన ధర్మం, నిత్యాన్నదానం చేయడం కంటే మించిన పుణ్యం ఈ సృష్టిలో లేవు."
      },
      {
        "title": "7. ఒకేసారి నీరు, నిప్పు రెండు చేతులతో గాని, ఒకే చేత్తోగాని పట్టుకెళ్ళరాదు."
      },
      {
        "title": "8. తూర్పు, దక్షిణ దిక్కుల తల పెట్టి నిద్రపోవాలి, ఉత్తర, పశ్చిమాల వైపు తల పెట్టి నిద్రిస్తే వారు ప్రమాదాల పాలౌతారని మార్కండేయ పురాణం చెబుతుంది."
      },
      {
        "title": "9. ఇంటికి గురువు వస్తే టక్కున లేచి నిలబడి ఎదురుగావెళ్ళి లోపలికి గౌరవంగా తీసుకొని వచ్చి ఆసనం వేసి కూర్చోబెట్టకుండా మాట్లాడరాదు. సాగనంపేటపుడు బయటకు వచ్చి గురువుని కొంచెం దూరం అనుసరించాలి."
      },
      {
        "title": "10. పైన అనగా భుజాలమీదుగా వస్త్రం లేకుండా దైవపూజ చేయరాదు, భోజనం చేయకూడదు."
      },
      {
        "title": "11. రెండు చేతులతో ఎప్పుడూ తల గోక్కోరాదు."
      },
      {
        "title": "12. ఇతరుల చెప్పులు, వస్త్రాలు ధరించకూడదు."
      },
      {
        "title": "13. తెలిసినవారి మరణ వార్త విన్న వెంటనే గాని, పురిటి వార్త విన్న వెంటనే గాని కట్టుబట్టలతో స్నానం చేయాలి."
      },
      {
        "title": "14. అన్నము తిన్నాక కంచంలో చేయి కడుక్కోరాదు. చేయి కడిగిన తరువాత ఆ చేతిని విదల్చరాదు."
      },
      {
        "title": "15. నవగ్రహ ప్రదక్షిణ, పూజానంతరం తీర్థ ప్రసాదాలు స్వీకరించవచ్చు."
      },
      {
        "title": "16. పిసినిగొట్టుతో, శత్రువుతో, అసత్యం పలికే వాడితో భర్తను తిట్టే స్త్రీతో కలిసి భోజనం చేయటం మహాపాపం."
      },
      {
        "title": "17. స్నానం చేయకుండా అన్నం వండరాదు. ఆ అన్నం తినరాదు."
      },
      {
        "title": "18. నోటితో అగ్నిని ఆర్పరాదు, ఊదరాదు."
      },
      {
        "title": "19. పురాణాలు చెప్పే వ్యక్తి సర్వోత్తముడు. అటువంటి వారిని నిందించరాదు."
      },
      {
        "title": "20. పుణ్య కార్యాల్లో చోళ్ళు, జొన్నలు, వెల్లుల్లి, ఉల్లి, చద్ది పదార్థాలు తినరాదు, ఉపయోగించరాదు."
      },
      {
        "title": "21. కాళ్ళు కడుక్కొన్నాక తుడుచుకోకుండా, తడి కాళ్ళతో భోజనం చేయరాదు."
      },
      {
        "title": "22. తడిసిన బట్టల నీళ్ళు ఇతరులపై పడేట్లు విదిలించరాదు."
      },
      {
        "title": "23. ఎట్టి పరిస్థితులలోను ఆత్మహత్య చేసుకోరాదు. అలా చేసుకున్నవారు కొన్ని వేల జన్మలు పిశాచ జన్మలెత్తి వికలాంగులై పుడతారు."
      },
      {
        "title": "24. నోట్లో వ్రేళ్ళు పెట్టుకొనుట, గోళ్ళుకొరుకుట చేయరాదు."
      },
      {
        "title": "25. పుష్కర స్నానాదులలో చొక్కాతో స్నానం చేయరాదు. కండువా మాత్రమే ఉండవలెను."
      },
      {
        "title": "26. ఆదివారం, శుక్రవారం, మంగళవారం తులసి ఆకులు కోయరాదు."
      },
      {
        "title": "27. కూర్చొని తొడలు, కాళ్ళు ఊపరాదు. అలా ఊపినవాడు వచ్చే జన్మలో కుంటివాడై పుడతాడు."
      },
      {
        "title": "28. చీకటి పడ్డాక పువ్వులు, ఆకులు చెట్లనుండి త్రుంచరాదు."
      },
      {
        "title": "29. నిద్రనుండి లేవగానే ముందుగా అరచేతులను దర్శించి వామన నామస్మరణ చేయాలి."
      },
      {
        "title": "30. నిజం తెలుసుకోకుండా ఎవరినీ నిందించరాదు, అభాండాలు వేయరాదు. అలా చేస్తే అవతలి వారి పాపాలన్నీ అభాండాలు వేసిన వారి తలకు చుట్టుకుంటాయి."
      },
      {
        "title": "31. శవాన్ని స్మశానం దాకా మోసినా, శవాన్ని ఇంటి దగ్గర ఉండటానికి అనుమతినిచ్చినా మనం స్వర్గానికి పోతాము."
      },
      {
        "title": "32. నిద్రపోతున్న వారిని అనవసరంగా లేపుట, పురాణ కథలు జరుగుతున్నపుడు విఘ్నం కలుగ చేయుట, భార్యాభర్తలను విడదీయుట, తల్లిని బిడ్డను విడదీయుట బ్రహ్మహత్యాపాతకాలతో సమానం. (వేళాపాళ లేకుండా నిద్రించేవారి విషయంలో వర్తించదు."
      },
      {
        "title": "33. పుట్టిన రోజునాడు దీపాలు కానీ, కొవ్వొత్తులు కానీ ఆర్పరాదు. నోటితో అగ్నిని ఊదుట ఘోరపాపం. అటువంటివారు గ్రహణపు మొర్రితో మళ్ళీ జన్మమెత్తి దుఃఖాలు పొందుతారు."
      },
      {
        "title": "34. ఎంగిలి నోటితో గురువుతో మాట్లాడరాదు. ఎంగిలి చేత్తో ఏ పదార్థాన్ని చూపించరాదు."
      },
      {
        "title": "35. పురాణాలు దానం చేస్తే గొప్ప విద్యావేత్తలు అవుతారు."
      },
      {
        "title": "36. క్రూరుడు, దుష్టుడు కాని మగనితో తాళికట్టించుకొన్న భార్య, కాపురం చేయక ఏడిపించటం, చెప్పిన మాట వినకపోవటం, తాళి తీసి భర్త చేతిలో పెట్టడం చేయరాదు. ఇలా చేసిన స్త్రీలకి వంద జన్మలలో వైధవ్యం కానీ, అసలు పెళ్లి కాకపోవడం జరుగుతుంది."
      },
      {
        "title": "37. దీపాలు పెట్టేవేళ తలదువ్వుకోరాదు. ఇలా చేసిన స్త్రీలకి వందల జన్మలలో వైధవ్యం కాని, అసలు పెళ్లి జరగకపోవడం వంటివి జరుగుతాయి."
      },
      {
        "title": "38. తలమీద రెండు చేతులు ఒకేసారి పెట్టుకొనరాదు."
      },
      {
        "title": "39. వికలాంగులను వేళాకోళం చేయరాదు."
      },
      {
        "title": "40. ఒకరి బట్టలు మరొకరు కట్టరాదు. ఒకరు తీసివేసిన జందెం మరొకరు ధరించరాదు."
      },
      {
        "title": "41. సంకల్పం చెప్పకుండా నదీస్నానం పనికిరాదు. ఒకవేళ చేస్తే ఇంటిలో స్నానం చేసినట్లే. నదీస్నాన ఫలితంరాదు."
      },
      {
        "title": "42. ఉమ్మితో వెళ్ళు తడిపి పుస్తకంలో పుటలు తిప్పరాదు."
      },
      {
        "title": "43. వ్యసనపరులతో, మూర్ఖులతో వాదోపవాదనలు చేయరాదు."
      },
      {
        "title": "44. ఏడవటం వలన దారిద్ర్యం, సంతోషం వలన ఐశ్వర్యం లభిస్తాయి."
      },
      {
        "title": "45. భోజన సమయంలో మాట్లాడుట, నవ్వుట పనికిరాదు."
      },
      {
        "title": "46. పెద్దన్న గారు, పిల్లనిచ్చిన మామ గారు, గురువు ఈ ముగ్గురు కన్నతండ్రితో సమానం కనుక వీరు ముగ్గురినీ తండ్రిలాగే పూజించాలి."
      },
      {
        "title": "47. ఒకసారి వెలిగించాక ఏ కారణం చేతనైనా కొండెక్కిన దీపంలోని వత్తిని తీసివేసి క్రొత్త వత్తిని వేసి మాత్రమే దీపారాధన చేయాలి. పాత వత్తిని మళ్ళీ వెలిగించరాదు."
      },
      {
        "title": "48. ఒక చెట్టును నరికేముందు మూడుచెట్లు నాటితే కాని ఆ దోషం పోదు."
      },
      {
        "title": "49. అన్నమును తింటున్నపుడు ఆ అన్నమును దూషించుట కాని, కోపముతో అన్నం పెట్టేవారిని తిట్టుటకాని చేయరాదు."
      },
      {
        "title": "50. చీటికి మాటికి ప్రతిజ్ఞలు చేయుట, ఒట్టు పెట్టుట దోషం."
      },
      {
        "title": "51. నిలబడికాని, అటూఇటూ తిరుగుతూ కాని అన్నం తినటం వల్ల క్రమంగా దరిద్రుడౌతాడు. రాబోయే జన్మలో బిచ్చగాడు అవుతాడు."
      },
      {
        "title": "52. నోట్లో వ్రేళ్ళు పెట్టుకొనుట, గోళ్ళుకొరుకుట చేయరాదు."
      },
      {
        "title": "53. నదిలో చీమిడి చీదుట, ఉమ్ముట, చిల్లర డబ్బులు వేయుట దోషం."
      },
      {
        "title": "54. ఒడిలో కంచం పళ్ళాలు పెట్టుకొని ఏ పదార్థాలు తినరాదు. అలా చేస్తే ఘోర నరకాలు కలగటమే కాక, వచ్చే జన్మలో దరిద్రులై పుడతారు."
      },
      {
        "title": "55. చీటికి మాటికి తనను తాను నిందించుకొనుట, అవమానించుకొనుట, తక్కువ వేసికొనుట చేయరాదు."
      },
      {
        "title": "56. గురువుద్వారా మంత్రోపదేశం పొందనివాడు ఎప్పటికీ తరించలేడు. కనుక ఉపదేశం పొందితీరాలి."
      },
      {
        "title": "57. చెట్లు, దేవతా విగ్రహాలు ఈశాన్యంలో ఉంటే వాటిని బరువులుగా భావించి తీసివేసేవారు, తీసివేయమని సలహా ఇచ్చేవారు ఏడు జన్మలు ఉబ్బసపు రోగులుగా పుడతారు. ఈ పనులు చేయుట దైవద్రోహం కనుక చేయరాదు."
      },
      {
        "title": "58. గురువులకు, అర్చకులకు, పౌరాణికులకు సరిగా పారితోషంఇవ్వక, వారికి ఋణపడేవారు నూరుజన్మలు కుక్కలుగా, చండాలురుగా పుట్టి కష్టనష్టాల పాలవుతారు."
      },
      {
        "title": "59. శివలింగార్చన ఆడువారు కూడా చేయవచ్చు."
      },
      {
        "title": "60. ఇంట్లో విగ్రహాలుంటే ఏమీ ప్రమాదం లేదు. పరులకు అపకారం కోరి పూజ చేసేవారికి మాత్రమే నియమాలు. తక్కిన వారికి పూజా విషయాలలో పెద్ద పెద్ద నియమాలు లేవు."
      },
      {
        "title": "61. ఎంతకోపం వచ్చినా తల్లిదండ్రులను, గురువును కొట్టరాదు. వారిపైకి చేయి ఎత్తరాదు. ఇంటి నుండి గెంటివేయరాదు. వారికి పెట్టకుండా పదార్థాలేవీ తాను తినరాదు."
      },
      {
        "title": "62. పాచి ముఖంతో అద్దం చూసుకొనరాదు."
      },
      {
        "title": "63. మేడి చెట్టుకు ప్రదక్షిణ, రావి చెట్టుకు పూజ, వేప చెట్టును నాటుట, మామిడి పళ్ళు దానం అశ్వమేథ యాగ ఫలితాన్ని ఇస్తాయి."
      },
      {
        "title": "64. తీర్థం తీసుకున్నాక, ఆ చేతిని కడుక్కోవాలి తప్ప, అరచేతిని తలపై రాసుకొనరాదు."
      },
      {
        "title": "65. పాడయిపోయిన లేక శిథిలమైపోయిన దేవతల పటాలు లేక విగ్రహాలు కాలువలో కాని, చెరువులో కాని, సముద్రంలో కాని కలుపవలెను. ఏమీ లేకపోతే గొయ్యి తీసి అందులో పాతిపెట్టవలెను."
      },
      {
        "title": "66. ఉపవాసం ఉన్నపుడు, జాగరణ చేసినపుడు పరులదోషాలు తలుచుకోరాదు."
      },
      {
        "title": "67. శివాలయంలో నందికి దగ్గరగా దీపారాధన చేయరాదు. కొంచెం దూరం ఉంచాలి."
      },
      {
        "title": "68. తల వెంట్రుకలతో కూడిన అన్నం పండితులకు, గురువులకు పెట్టరాదు. సాధ్యమైనంత జాగ్రత్త వహించాలి. పొరపాటున అన్నంలో వెంట్రుకలు వస్తే ఆ అన్నం తీసివేసి మళ్ళీ వడ్డించి నేయి వేయాలి."
      },
      {
        "title": "69. అన్నం తింటున్న వారెవరినీ తిట్టరాదు, దెప్పి పొడవరాదు."
      },
      {
        "title": "70. కొడుకు పుట్టిన వెంటనే తండ్రి కట్టుబట్టలతో స్నానం చేయాలి. ఆ కుమారుడు మరణించినట్లైతే తండ్రితో పాటు అందరూ కట్టు బట్టలతో స్నానం చేయాలి."
      },
      {
        "title": "71. ఇస్తానని వాగ్దానం చేసి దానమివ్వనివాడు వందజన్మలు దరిద్రుడై పుడతాడు, వాక్ భంగం చాలా దోషం."
      },
      {
        "title": "72. కొబ్బరికాయ కొట్టాక వెనుకవైపు పీచు తీయాలనే నియమం కూడా తప్పనిసరి కాదు. శుభ్రత కోసం పీచు తీయవచ్చు, తీయకపోతే దోషం లేదు."
      },
      {
        "title": "73. తరచుగా కాలినడకన పుణ్యక్షేత్రాలు దర్శిస్తే మంచి జన్మలు కలుగుతాయి. దీనిని కాయిక తపస్సు అంటారు."
      },
      {
        "title": "74. గురువునకు ఉపదేశ సమయాలలో కాని, పురాణాదులు వినేటప్పుడు కాని పాదాలు ఒత్తితే 7 జన్మల పాపాలు తొలుగుతాయి."
      },
      {
        "title": "75. కొబ్బరికాయను నీళ్ళతో కడిగి కొట్టడం చాలా తప్పు, కొబ్బరికాయను పీచు ఒలిచివేశాక నీళ్ళతో కడగరాదు."
      },
      {
        "title": "76. దీపారాధనకు ఒక కుంది మాత్రమే వాడినపుడు మూడు వత్తులు వేయాలి."
      },
      {
        "title": "77. అష్టమి, పూర్ణిమ, చతుర్థశి కాలలో స్వయంపాకం దానం చేస్తే అన్నపానాలకు ఏనాడు లోటుండదు."
      },
      {
        "title": "78. ఎక్కువ వేడిగా, ఎక్కువ చల్లగా ఉండే పదార్థాలు స్వీకరించరాదు."
      },
      {
        "title": "79. భోజనం చేసిన వస్త్రాలు ఉతికి ఆరవేయకుండా వాటితో దైవపూజ చేయరాదు."
      },
      {
        "title": "80. నిత్యం తామువాడే పాత్రలలో పండితులకు ఆహారం పెట్టుట దోషం, కనుక ఆకులలోకాని, క్రొత్త పాత్రలలోకాని వారికి ఆహారం పెట్టాలి."
      },
      {
        "title": "81. గృహప్రవేశ కాలంలో గాని, ఏడాదిలోపు గాని ఆ ఇంట మణిద్వీప పరాయణం చేయడం మంచిది. ఇది వాస్తుదోషాలను పరిహరిస్తుంది."
      },
      {
        "title": "82. భోజనానికి ముందు, అనంతరం కూడా కాళ్ళు కడుక్కోవాలి."
      },
      {
        "title": "83. సకల పురాణేతిహాస కోవిదుడు కాని వాని వద్ద మంత్రోపదేశం పొందరాదు."
      },
      {
        "title": "84. రేపు చేయవలసిన పనిని ఈ రోజు, ఈ రోజుపని ఈ క్షణమే చేయాలి. వాయిదాలు పనికిరావు."
      },
      {
        "title": "85. తలకి నూనె రాసుకొని ఆ చేతులతో పాదాలకు ఆ నూనెజిడ్డు పులమరాదు."
      },
      {
        "title": "86. శుక్ర, శనివారం వంటి వార నియమాలు పెట్టుకున్నవారు హోటలు టిఫిన్లు తినుటగానీ, ఆనాటి అల్పహారాదులలో ఉల్లి వాడుట కాని నిషేదము. ఇది ప్రయాణ మధ్యంలో ఉన్న వారికి వర్తించదు."
      },
      {
        "title": "87. చీటికి, మాటికి యజ్ఞోపవీతం తీసి పక్కనపెట్టడం, తాళి తీసేస్తుండటం రెండూ భయంకర దోషాలే."
      },
      {
        "title": "88. పుష్కర సమయాలలో స్నానం, శ్రాద్ధకర్మ ఎవరైనా చేసి తీరాల్సిందే."
      },
      {
        "title": "89. ప్రదక్షిణలు చేసేటపుడు, మంత్ర పుష్పం ఇచ్చేటపుడు ఆసనాలపై నిలబడరాదు. కింద నిలబడి చేయాలి. పూజా సమయాలలో కొందరు చాపలు పీకుట, దర్భాసనాలు తుంచటం చేస్తారు. ఇవి మహా పాపాలు."
      },
      {
        "title": "90. గణపతి గరికపూజ మహాప్రీతి ఏ పరిస్థితులలోనూ తులసితో పూజ చేయరాదు(వినాయక చతుర్థినాడు కుడా తులసిని సమర్పించరాదు."
      },
      {
        "title": "91. మనుష్యుని పాపం వాడి అన్నం లోనే ఉంటుంది. అందువలన పాపాత్ముల ఇంటి భోజనం చేయరాదు. మంత్రోపదేశం చేసిన గురువు భోజనానికి పిలిస్తే వెళ్ళని వానికి ఏనాటికీ మోక్షంరాదు."
      },
      {
        "title": "92. జపమాల మెడలో వేసుకొనరాదు. మెడలో వేసుకొన్న మాలతో జపం చేయరాదు."
      },
      {
        "title": "93. బంగారం దొరికితే దానిని ఇంట్లోకి తెచ్చుకోరాదు. దాని వల్ల చాలా అనర్థాలు జరుగుతాయి. దొరికిన బంగారం వెంటనే దానం చేయుట కాని, లేదా దేవాలయాలకు ఇచ్చివేయుట కాని చేయాలి."
      },
      {
        "title": "94. దీపారాధనకు అగ్గిపెట్టె వాడకూడదని ఏ శాస్త్రాలు చెప్పలేదు. కనుక అగ్గిపెట్టెతో దీపం వెలిగించుకోవచ్చు."
      },
      {
        "title": "95. భోజనసమయంలో వేదములు చదువుట, గిన్నె మొత్తం ఊడ్చుకొని తినుట పనికిరావు. ఏడుస్తూ అన్నం తినరాదు."
      },
      {
        "title": "96. దేవాలయం నీడను, దేవతల నీడను, యజ్ఞం చేసే వారి నీడను, గోబ్రాహ్మణుల నీడను దాటరాదు."
      },
      {
        "title": "97. శ్రాద్దములో భోక్తగా మిత్రుడు పనికిరాడు. అతిథులుగా భోజనం పెట్టుకొనవచ్చు."
      },
      {
        "title": "98. విశిష్ట వ్యక్తులను, మహాత్ములను అగౌరవపరచి, నిందించు దుర్మార్గుని పాపం చిత్రగుప్తుడు కూడా వర్ణించలేడు."
      },
      {
        "title": "99. దేవాలయం లేని ఊరిలో భోజనం చేయరాదు."
      },
      {
        "title": "100. ఒకేసారి నీరు, నిప్పు రెండు చేతులతో గాని, ఒకే చేత్తోగాని పట్టుకెళ్ళరాదు."
      }

    ],
    "title": "నిత్య సత్యాలు - ధర్మఆచారములు"
  },
  "sanskritDateNames": {
    "CatID": [
      {
        "title": "1. ఆదివారము = భానువారము"
      },
      {
        "title": "2. సోమవారము = ఇందువారము"
      },
      {
        "title": "3. మంగళవారము = భౌమవారము"
      },
      {
        "title": "4. బుధవారము = సౌమ్యవారము"
      },
      {
        "title": "5. గురువారము = బృహస్పతివారము/గురువారము"
      },
      {
        "title": "6. శుక్రవారము = భృగువారము"
      },
      {
        "title": "7. శనివారము = స్థిరవారము/మందవారము"
      }
    ],
    "title": "సంస్కృత వారాల పేర్లు"
  },
  "nividenela": {
    "CatID": [
      {
        "title": "1. చూతఫలం = మామిడిపండు"
      },
      {
        "title": "2. ఖర్జూర = ఖర్జూరం"
      },
      {
        "title": "3. నింబ = వేప"
      },
      {
        "title": "4. నారింగ = నారింజ"
      },
      {
        "title": "5. భల్లాతకీ = జీడిపప్పు"
      },
      {
        "title": "6. బదరీ = రేగు"
      },
      {
        "title": "7. అమలక = ఉసిరికాయ"
      },
      {
        "title": "8. శుష్కద్రాక్ష = కిస్మిస్"
      },
      {
        "title": "9. అమృత లేక బీజాపూరం = జామపండు"
      },
      {
        "title": "10. ఇక్షుఖండం = చెఱకుముక్క"
      },
      {
        "title": "11. కదళీఫలం, రంభా ఫలం = అరటిపండు"
      },
      {
        "title": "12. నారికేళం = కొబ్బరికాయ"
      },
      {
        "title": "13. జంభీర = నిమ్మ పండు"
      },
      {
        "title": "14. దాడిమీ = దానిమ్మపండు"
      },
      {
        "title": "15. సీతాఫలం / బహుబీజ ఫలం = సీతాఫలం"
      },
      {
        "title": "16. రామఫలం = రామఫలము"
      },
      {
        "title": "17. కపిత్త = వెలగ పండు"
      },
      {
        "title": "18. శ్రీ ఫలం, బిల్వఫలం = మారేడు"
      },
      {
        "title": "19. మాదీ ఫలం = దబ్బ పండు"
      },
      {
        "title": "20. జంభూఫలం = నేరేడు"
      },
      {
        "title": "21. వాతాదం = బాదము పప్పు"
      },
      {
        "title": "22. సేవం/ సీమ ఫలం/ కాశ్మీర ఫలం = ఆపిల్"
      }
    ],
    "title": "నివేదనల పేర్లు"
  },
  "prasademulu": {
    "CatID": [
      {
        "title": "1. కుశలాన్నం = పులగం"
      },
      {
        "title": "2. చిత్రాన్నం = పులిహోర"
      },
      {
        "title": "3. క్షీరాన్నం = పరమాన్నం"
      },
      {
        "title": "4. పాయసం = పాయసం"
      },
      {
        "title": "5. శర్కరాన్నం = చక్కెరపొంగలి"
      },
      {
        "title": "6. మరీచ్యన్నమ్ = కట్టు లేదా మిరియాలపొంగలి"
      },
      {
        "title": "7. దధ్యోదనం = పెరుగు అన్నము"
      },
      {
        "title": "8. తిలాన్నం = నువ్వులపొడితో చేసిన అన్నం"
      },
      {
        "title": "9. శాకమిశ్రితాన్నం = కిచిడీ"
      },
      {
        "title": "10. గుడాన్నం = బెల్లపు పరమాన్నం"
      },
      {
        "title": "11. సపాదభక్ష్యం = గోధుమనూకతో చేసిన ప్రసాదం"
      },
      {
        "title": "(గోధుమ నూక చీనీ నెయ్యి సమపాళ్ళలో వేసి చేసింది గాన ఆపేరు)"
      },
      {
        "title": "12. గుడమిశ్రిత ముద్గ సూపమ్ = వడపప్పు"
      },
      {
        "title": "13. గుడమిశ్రిత తండులపిష్టం = చలిమిడి"
      },
      {
        "title": "14. మధురపానీయ = పానకం"
      },
      {
        "title": "15. పృథక్ = అటుకులు"
      },
      {
        "title": "16. పృథకాపాయస = అటుకుల పాయసం"
      },
      {
        "title": "17. లాజ = పేలాలు"
      },
      {
        "title": "18. భక్ష్యం = పిండివంటలు"
      },
      {
        "title": "19. భోజ్యం = అన్నము మొదలగునవి"
      },
      {
        "title": "20. వ్యంజనం = పచ్చడి"
      },
      {
        "title": "21. అపూపం = అరిసెలు లేదా అప్పములు"
      },
      {
        "title": "22. మాషచక్రం = గారెలు"
      },
      {
        "title": "23. లడ్డుక = లాడూలు"
      },
      {
        "title": "24. మోదకం = ఉండ్రాళ్లు"
      }
    ],
    "title": "ప్రసాదములు పేర్లు"
  },
  "pushpalu": {
    "CatID": [

      {
        "title": "1. సేవంతికా = చామంతి"
      },
      {
        "title": "2. సూర్యకాంతి: = పొద్దుతిరుగుడు"
      },
      {
        "title": "3. మాలతీ = మాలతీ"
      },
      {
        "title": "4. వకులం = పొగడ"
      },
      {
        "title": "5. కమలం = తామర"
      },
      {
        "title": "6. జపా = మందార"
      },
      {
        "title": "7. జాతీ = జాజి"
      },
      {
        "title": "8. నవమల్లికా = విరజాజి"
      },
      {
        "title": "9. పాటలం = గులాబీ"
      },
      {
        "title": "10. నక్షత్ర సేవంతికా = నక్షత్ర చేమంతి"
      },
      {
        "title": "11. కురవకం = గోరింట"
      },
      {
        "title": "12. ప్రతాపన: = తెల్లమందారం"
      },
      {
        "title": "13. శిరీషం = దిరిశెన పువ్వు"
      },
      {
        "title": "14. ఉత్పలం = కలువపువ్వు"
      },
      {
        "title": "15. అంభోజం = తామర"
      },
      {
        "title": "16. సితాంభోజం = తెల్ల తామర"
      },
      {
        "title": "17. కుశేశయం = నూరు వరహాలు"
      },
      {
        "title": "18. కరవీరం = గన్నేరు"
      },
      {
        "title": "19. నలినం = లిల్లీ"
      },
      {
        "title": "20. శేఫాలికా = వావిలి"
      },
      {
        "title": "21. పున్నగం = పొన్న పువ్వు"
      },
      {
        "title": "22. అంబష్టం = అడివి మల్లె"
      },
      {
        "title": "23. జాతీ సుమం = సన్న జాజి"
      },
      {
        "title": "24. గుచ్చ పుష్పం = బంతి"
      },
      {
        "title": "25. కేతకీ = మొగలి"
      },
      {
        "title": "26. కర్ణికారం = కొండ గోగు"
      },
      {
        "title": "27. కోవిదారం = దేవకాంచనము"
      },
      {
        "title": "28. స్థలపద్మం = మెట్ట తామర"
      },
      {
        "title": "29. బంధూకం = మంకెన"
      },
      {
        "title": "30. కురంటకం = పచ్చ గోరింట"
      },
      {
        "title": "31. పీత కరవీరం = పచ్చ గన్నేరు"
      },
      {
        "title": "32. గుచ్చ మందారం = ముద్ద మందారం"
      },
      {
        "title": "33. చంపకం = సంపెంగ"
      },
      {
        "title": "34. కుందం = మల్లె"
      },
      {
        "title": "35. పుష్ప మంజరీ = పూలవెన్ను"
      }
    ],
    "title": "పుష్పాల పేర్లు"
  },
  "Pushpamuluvaatiphalithalu": {
    "CatID": [
      {
        title: 'ఏ పూలతో పూజ చేస్తే ఏ విధమైన ఫలితాలు లభిస్తాయి :',
      },
     
      {
        title: 'దేవుడికి మనం పూజ చేసేటప్పుడు ఈ పూలు వాడొచ్చా లేదా ఏ పూలు వాడితే మంచిదని చాలా ఆలోచిస్తాం. కానీ ఎక్కువగా అందుబాటులో ఉన్న పూలను మాత్రమే పూజకు ఉపయోగిస్తాం.',
      },
     
      {
        title: 'మనం చేసే పూజకు ప్రతిఫలం దక్కాలంటే ఖచ్చితంగా నియమాలను పాటించాలి. వాడాల్సిన పూలను మాత్రమే వాడిలి. అందుకే ఏయే దేవుడుకి ఏ పూలు వాడితే మంచిదో ఇప్పుడు తెలుసుకుందాం.అలాగే ఏ పూలు వాడకూడదో కూడా తెలుసుకుందాం.',
      },
     
      {
        title: 'మనం ఏ దేవుడినైతే పూజ చేస్తున్నామో ఆ దేవుడికి ఇష్టమైన పూలు వాడటం మరింత మంచిది.దేవుడిని ఎంత సంతృప్తి పరిస్తే మనకు అంత మంచి జరుగుతుంది.',
      },
     
      {
        title: 'దేవునికి విడి పూల కన్నా మాలగా కట్టిన పూలతో పూజ చేస్తేనే ప్రత్యక ఫలితం లభిస్తుంది. దేవునికి వేసే పుష్పాలు విచ్చుకున్నట్లు అయితే మీ జీవితం భవిష్యతు బాగుంటుంది.',
      },
     
      {
        title: '1. జాజి పూలు - మీలో ఉన్న దుష్టగుణాలు తొలగి, మంచి గుణం వస్తుంది. ఉద్యోగంలో ఉన్నవారి సమస్యలు తొలగిపోతాయి.',
      },
     
      {
        title: '2. సంపెంగ పూలు - శత్రువుల భాద నివారణ సాధ్యం అవుతుంది',
      },
     
      {
        title: '3. పారిజాత పూలు - కాల సర్ప దోషం నివారించబడి మనస్సుకు శాంతి లభిస్తుంది.',
      },
     
      {
        title: '4. రుద్రాక్ష పూలు - ఎన్ని కష్టాలు వచ్చిన అంతిమ విజయం మీదే అవుతుంది.',
      },
     
      {
        title: '5. మొగలి పూలు - అధికారంలో ఉన్నవారి మనస్తాపాలు పరిహరించబడుతాయి.',
      },
     
      {
        title: '6. లక్కీ పూలు - భార్య పిల్లలతో కలహాలు లేకుండా సంతోషంగా ఉంటారు.',
      },
     
      {
        title: '7. పద్మం లేదా కమలం - సమస్త దారిద్ర నివారణ. శ్రీమంతులు అవుతారు.',
      },
     
      {
        title: '8. మల్లె పూలు - అన్ని రోగాలు నయం అవుతాయి, ఆరోగ్యం ప్రాప్తిస్తుంది.',
      },
     
      {
        title: '9. గన్నేరు పూలు - కవులకు కల్పనా సాహిత్యం వృద్ది చెందుతుంది.',
      },
     
      {
        title: '10. కల్హార పూలు - మీకు గుర్తింపు వచ్చి ఆకర్షణ పెరుగుతుంది.',
      },
     
      {
        title: '11. పాటలీ పుష్పం - వ్యాపార వ్యవహారంలో అధిక లాభం వస్తుంది.',
      },
     
      {
        title: '12. కంద పుష్పం - ముఖంలో అధికమైన తేజస్సు వస్తుంది.',
      },
     
      {
        title: '13. తుమ్మ పూలు - ఈశ్వరునికి పూజ చేస్తే దేవునిఫై భక్తి అధికం అవుతుంది.',
      },
     
      {
        title: '14. నందివర్ధనం పూలు - శివునికి పూజ చేస్తే జీవితంలో సుఖం,శాంతి, ప్రశాంతత లభిస్తుంది.',
      },
     
      {
        title: '15. కణగాలే పుష్పం - మనస్సును పట్టి పీడిస్తున్న భయం,భీతి తొలగిపోతాయి.',
      },
     
      {
        title: '16. అశోక పుష్పం -  జీవితంలో, సంసారంలో ఉండే అన్ని దుఃఖాలు నాశనం అవుతాయి.',
      },
     
      {
        title: '17. నల్ల కలువ పుష్పం - అన్ని రకాల శని సమస్యలు తొలగిపోతాయి.',
      },
     
      {
        title: '18. పాదరి పుష్పం - అన్ని రకాల పితృ దోషాలు తొలగిపోతాయి.',
      },
     
      {
        title: '19. మాలతి పుష్పం - అన్ని పాపాలు తొలగిపోతాయి.',
      },
     
      {
        title: '20. పున్నాగ పుష్పం - మగ సంతానం కలుగుతుంది.',
      },
     
      {
        title: '21. వకుళ పుష్పం - భూమి మరియు సొంత ఇల్లు పొందే యోగం వస్తుంది.',
      },
     
      {
        title: '22. ఉత్ఫల పుష్పం - జీవితంలో అభివృద్ధి చెoదుతారు.',
      },
     
      {
        title: '23. తెల్లని జిల్లేడు పూలు - రోగాలు తొలగి, ఆరోగ్య్యం సిద్దిస్తుంది.',
      },
     
      {
        title: '24. ద్రోణ పుష్పం - శత్రువుల నాశన, మిత్రలాభం అవుతుంది. అధికారం ప్రాప్తిస్తుంది.',
      },
     
      {
        title: '25. భందూక పుష్పం - బంధువులు క్షేమంగా ఉంటారు.',
      },
     
      {
        title: '26. అగసి పుష్పం - పాపాలు తొలగిపోతాయి.',
      },
     
      {
        title: '27. సురభి పుష్పం - ఇష్టార్ధం సిద్ధిస్తుంది.',
      },
     
      {
        title: '28. పొద్దు తిరుగుడు పూలు - పువ్వును హోమం పూర్ణాహుతికి సమర్పిస్తే అష్ట ఐశ్వర్యాలు సిద్దిస్తాయి.',
      },
     
      {
        title: 'పరమేశ్వరుని పూజలకు జిల్లేడూ, గన్నేరూ, మారేడూ, తమ్మి, ఉత్తరేణు, జమ్మి ఆకులు, జమ్మి పూలు, నల్లకలువలు చాలా మంచివని జ్యోతిష్యశాస్త్ర నిపుణులు చెబుతున్నారు.',
      },
     
      {
        title: 'దాసాని, మంకెన, నదంత, మొగలి, మాలతి, కుంకుమ, మద్ది ఈ పూలు పూజకు పనికి రావు, తొడిమలేని పువ్వులు పూజకు అస్సలే పనికిరావట.',
      },
     
      {
        title: 'అలాగే ఏ పూలు వాడకూడదో కూడా తెలుసుకుందాం :',
      },
     
      {
        title: 'అలాగే మహాగణపతిని తులసితోనూ, తమాల వృక్ష పుష్పాలతో సరస్వతీ దేవిని, మల్లె పూలతో భైరవుడిని, మొగలి పువ్వులతో పరమేశ్వరుణ్ణి, మారేడు దళాలతో సూర్య భగవానుడిని ఎట్టి స్థితిలోనూ పూజింపరాదు.',
      },
     
    ],
    "title": "పుష్పములు - వాటి ఫలితాలు"
  },
  "samathalu": {
    "CatID": [
      {
        "title": "1. అంత్యనిష్ఠూరం కన్నా ఆది నిష్ఠూరం మేలు"
      },
      {
        "title": "2. అంబలి తాగే వారికి మీసాలు యెగబట్టేవారు కొందరా"
      },
      {
        "title": "3. అడిగేవాడికి చెప్పేవాడు లోకువ"
      },
      {
        "title": "4. అత్తలేని కోడలుత్తమురాలు కోడల్లేని అత్త గుణవంతురాలు"
      },
      {
        "title": "5. అనువు గాని చోట అధికులమనరాదు"
      },
      {
        "title": "6. అభ్యాసం కూసు విద్య"
      },
      {
        "title": "7. అమ్మబోతే అడివి కొనబోతే కొరివి"
      },
      {
        "title": "8. అయితే ఆదివారం కాకుంటే సోమవారం"
      },
      {
        "title": "9. ఆలూ లేదు చూలు లేదు కొడుకు పేరు సోమలింగం"
      },
      {
        "title": "10. ఇంట్లో ఈగల మోత బయట పల్లకీల మోత"
      },
      {
        "title": "11. ఇల్లు కట్టి చూడు పెళ్ళి చేసి చూడు"
      },
      {
        "title": "12. ఇంట గెలిచి రచ్చ గెలువు"
      },
      {
        "title": "13. ఇల్లు పీకి పందిరేసినట్టు"
      },
      {
        "title": "14. ఎనుబోతు మీద వాన కురిసినట్టు"
      },
      {
        "title": "15. చెవిటి వాని ముందు శంఖమూదినట్టు"
      },
      {
        "title": "16. కందకు లేని దురద కత్తిపీటకెందుకు"
      },
      {
        "title": "17. కత్తిపోటు తప్పినా కలంపోటు తప్పదు"
      },
      {
        "title": "18. కుక్క కాటుకు చెప్పుదెబ్బ"
      },
      {
        "title": "19. కోటి విద్యలూ కూటి కొరకే"
      },
      {
        "title": "20. నీరు పల్లమెరుగు నిజము దేవుడెరుగు"
      },
      {
        "title": "21. పిచ్చుకపై బ్రహ్మాస్త్రం"
      },
      {
        "title": "22. పిట్ట కొంచెం కూత ఘనం"
      },
      {
        "title": "23. రొట్టె విరిగి నేతిలో పడ్డట్టు"
      },
      {
        "title": "24. వాన రాకడ ప్రాణపోకడ ఎవరి కెరుక"
      },
      {
        "title": "25. కళ్యాణమొచ్చినా కక్కొచ్చినా ఆగదు"
      },
      {
        "title": "26. మింగమెతుకులేదు మీసాలకు సంపంగి నూనె"
      },
      {
        "title": "27. ఆడబోయిన తీర్థము యెదురైనట్లు"
      },
      {
        "title": "28. ఆడలేక మద్దెల వోడు అన్నట్లు"
      },
      {
        "title": "29. ఆది లొనే హంస పాదు"
      },
      {
        "title": "30. ఏమీ లేని యెడారిలో ఆముదము చెట్టే మహా వృక్షము"
      },
      {
        "title": "31. ఆకలి రుచి యెరుగదు నిద్ర సుఖమెరుగదు"
      },
      {
        "title": "32. ఆకాశానికి హద్దే లేదు"
      },
      {
        "title": "33. ఆలస్యం అమృతం విషం"
      },
      {
        "title": "34. ఆరే దీపానికి వెలుగు యెక్కువ"
      },
      {
        "title": "35. ఆరోగ్యమే మహాభాగ్యము"
      },
      {
        "title": "36. ఆవులింతకు అన్న ఉన్నాడు కాని తుమ్ముకు తమ్ముడు లేడంట"
      },
      {
        "title": "37. ఆవు చేనులో మేస్తే దూడ గట్టున మేస్తుందా?"
      },
      {
        "title": "38. అబద్ధము ఆడినా అతికినట్లు ఉండాలి"
      },
      {
        "title": "39. అడగందే అమ్మైనా అన్నము పెట్టదు"
      },
      {
        "title": "40. అడ్డాల నాడు బిడ్డలు కాని గడ్డాల నాడు కాదు"
      },
      {
        "title": "41. ఏ ఎండకు ఆ గొడుగు"
      },
      {
        "title": "42. అగ్నికి వాయువు తోడైనట్లు"
      },
      {
        "title": "43. ఐశ్వర్యమొస్తే అర్ధరాత్రి గొడుగు పట్టమంటాడు"
      },
      {
        "title": "44. అందని మామిడిపండ్లకు అర్రులు చాచుట"
      },
      {
        "title": "45. అందితే జుట్టు అందక పోతే కాళ్ళు"
      },
      {
        "title": "46. అంగట్లో అన్నీ ఉన్నా, అల్లుడి నోట్లో శని ఉన్నట్లు"
      },
      {
        "title": "47. అన్నపు చొరవే గాని అక్షరపు చొరవ లేదు"
      },
      {
        "title": "48. అప్పు చేసి పప్పు కూడు"
      },
      {
        "title": "49. అయ్య వారు వచ్చే వరకు అమావాస్య ఆగుతుందా"
      },
      {
        "title": "50. అయ్యవారిని చెయ్యబొతే కోతి బొమ్మ అయినట్లు"
      },
      {
        "title": "51. బతికుంటే బలుసాకు తినవచ్చు"
      },
      {
        "title": "52. భక్తి లేని పూజ పత్రి చేటు"
      },
      {
        "title": "53. బూడిదలో పోసిన పన్నీరు"
      },
      {
        "title": "54. చాదస్తపు మొగుడు చెబితే వినడు, గిల్లితే యేడుస్తాడు"
      },
      {
        "title": "55. చాప కింద నీరులా"
      },
      {
        "title": "56. చచ్చినవాని కండ్లు చారెడు"
      },
      {
        "title": "57. చదివేస్తే ఉన్నమతి పోయినట్లు"
      },
      {
        "title": "58. విద్య లేని వాడు వింత పశువు"
      },
      {
        "title": "59. చేతకానమ్మకే చేష్టలు ఎక్కువ"
      },
      {
        "title": "60. చేతులు కాలినాక ఆకులు పట్టుకున్నట్లు"
      },
      {
        "title": "61. చక్కనమ్మ చిక్కినా అందమే"
      },
      {
        "title": "62. చెడపకురా చెడేవు"
      },
      {
        "title": "63. చీకటి కొన్నాళ్ళువెలుగు కొన్నాళ్ళు"
      },
      {
        "title": "64. చెరువుకి నీటి ఆశ నీటికి చెరువు ఆశ"
      },
      {
        "title": "65. చింత చచ్చినా పులుపు చావ లేదు"
      },
      {
        "title": "66. చింతకాయలు అమ్మేదానికి సిరిమానం వస్తే, ఆ వంకర టింకరవి యేమి కాయలని అడిగిందట"
      },
      {
        "title": "67. చిలికి చిలికి గాలివాన అయినట్లు"
      },
      {
        "title": "68. డబ్బుకు లోకం దాసోహం"
      },
      {
        "title": "69. దేవుడు వరం ఇచ్చినా పూజారి వరం ఇవ్వడు"
      },
      {
        "title": "70. దరిద్రుడి పెళ్ళికి వడగళ్ళ వాన"
      },
      {
        "title": "71. దాసుని తప్పు దండంతో సరి"
      },
      {
        "title": "72. దెయ్యాలు వేదాలు పలికినట్లు"
      },
      {
        "title": "73. దిక్కు లేని వాడికి దేవుడే దిక్కు"
      },
      {
        "title": "74. దొంగకు దొంగ బుద్ధి, దొరకు దొర బుద్ధి"
      },
      {
        "title": "75. దొంగకు తేలు కుట్టినట్లు"
      },
      {
        "title": "76. దూరపు కొండలు నునుపు"
      },
      {
        "title": "77. దున్నపోతు మీద వర్షం కురిసినట్లు"
      },
      {
        "title": "78. దురాశ దుఃఖమునకు చెటు"
      },
      {
        "title": "79. ఈతకు మించిన లోతే లేదు"
      },
      {
        "title": "80. ఎవరికి వారే యమునా తీరే"
      },
      {
        "title": "81. ఎవరు తీసుకున్న గోతిలో వారే పడతారు"
      },
      {
        "title": "82. గాడిద సంగీతానికి ఒంటె ఆశ్చర్యపడితే, ఒంటె అందానికి గాడిద మూర్ఛ పోయిందంట"
      },
      {
        "title": "83. గాజుల బేరం భోజనానికి సరి"
      },
      {
        "title": "84. గంతకు తగ్గ బొంత"
      },
      {
        "title": "85. గతి లేనమ్మకు గంజే పానకం"
      },
      {
        "title": "86 గోరు చుట్టు మీద రోకలి పోటు"
      },
      {
        "title": "87. గొంతెమ్మ కోరికలు"
      },
      {
        "title": "88. గుడ్డి కన్నా మెల్ల మేలు"
      },
      {
        "title": "89. గుడ్డి యెద్దు చేలో పడినట్లు"
      },
      {
        "title": "90. గుడ్డు వచ్చి పిల్లను వెక్కిరించినట్లు"
      },
      {
        "title": "91. గుడినే మింగే వాడికి లింగమొక లెఖ్ఖా"
      },
      {
        "title": "92. గుడిని గుడిలో లింగాన్నీ మింగినట్లు"
      },
      {
        "title": "93. గుడ్ల మీద కోడిపెట్ట వలే"
      },
      {
        "title": "94. గుమ్మడి కాయల దొంగ అంటే భుజాలు తడుముకొన్నాడట"
      },
      {
        "title": "95. గుర్రము గుడ్డిదైనా దానాలో తక్కువ లేదు"
      },
      {
        "title": "96. గురువుకు పంగనామాలు పెట్టినట్లు"
      },
      {
        "title": "97. తిన్న ఇంటి వాసాలు లెక్కపెట్టినట్లు"
      },
      {
        "title": "98. ఇంటి దొంగను ఈశ్వరుడైనా పట్టలేడు"
      },
      {
        "title": "99. ఇంటి పేరు కస్తూరివారు వీధిలో గబ్బిలాల కంపు"
      },
      {
        "title": "100. ఇంటికన్న గుడి పదిలం"
      },
      {
        "title": "101. ఇసుక తక్కెడ పేడ తక్కెడ"
      },
      {
        "title": "102. జోగి జోగి రాసుకుంటే బూడిద రాలిందంట"
      },
      {
        "title": "103. కాచిన చెట్టుకే రాళ్ళ దెబ్బలు"
      },
      {
        "title": "104. కాగల కార్యము గంధర్వులే తీర్చినట్లు"
      },
      {
        "title": "105. కాకి ముక్కుకు దొండ పండు"
      },
      {
        "title": "106. కాకి పిల్ల కాకికి ముద్దు"
      },
      {
        "title": "107. కాలం కలిసి రాక పోతే కర్రే పామై కాటు వేస్తుంది"
      },
      {
        "title": "108. కాలు జారితే తీసుకోగలము కాని నోరు జారితే తీసుకోగలమా"
      },
      {
        "title": "109. కాసుంటే మార్గముంటుంది"
      },
      {
        "title": "110. కడుపు చించుకుంటే కాళ్ళపైన పడ్డట్లు"
      },
      {
        "title": "111. కలకాలపు దొంగ ఏదో ఒకనాడు దొరుకును"
      },
      {
        "title": "112. కలి మి లేములు కావడి కుండలు"
      },
      {
        "title": "113. కలిసి వచ్చే కాలం వస్తే, నడిచి వచ్చే కొడుకు పుడతాడు"
      },
      {
        "title": "114. కంచే చేను మేసినట్లు"
      },
      {
        "title": "115. కంచు మ్రోగునట్లు కనకంబు మ్రోగునా !"
      },
      {
        "title": "116. కందకు కత్తి పీట లోకువ"
      },
      {
        "title": "117. కరవమంటే కప్పకు కోపం విడవమంటే పాముకు కోపం"
      },
      {
        "title": "118. కీడెంచి మేలెంచమన్నారు"
      },
      {
        "title": "119. కొండ నాలికకి మందు వేస్తే ఉన్న నాలిక ఊడినట్లు"
      },
      {
        "title": "120. కొండల్లే వచ్చిన ఆపద కూడా మంచువలే కరిగినట్లు"
      },
      {
        "title": "121. కొండను తవ్వి ఎలుకను పట్టినట్లు"
      },
      {
        "title": "122. కొన్న దగ్గిర కొసరే గాని కోరిన దగ్గర కొసరా"
      },
      {
        "title": "123. కూసే గాడిద వచ్చి మేసే గాడిదను చెరిచిందిట"
      },
      {
        "title": "124. కూటికి పేదైతే కులానికి పేదా"
      },
      {
        "title": "125. కొరివితో తల గోక్కున్నట్లే"
      },
      {
        "title": "126. కోతికి కొబ్బరి చిప్ప ఇచ్చినట్లు"
      },
      {
        "title": "127. కొత్తొక వింత పాతొక రోత"
      },
      {
        "title": "128. కోటిి విద్యలు కూటి కొరకే"
      },
      {
        "title": "129. కొత్త అప్పుకు పొతే పాత అప్పు బయటపడ్డదట"
      },
      {
        "title": "130. కొత్త బిచ్చగాడు పొద్దు యెరగడు"
      },
      {
        "title": "131. కృషితో నాస్తి దుర్భిక్షం"
      },
      {
        "title": "132. క్షేత్ర మెరిగి విత్తనము పాత్ర మెరిగి దానము"
      },
      {
        "title": "133. కుడుము చేతికిస్తే పండగ అనేవాడు"
      },
      {
        "title": "134. కుక్క వస్తే రాయి దొరకదు రాయి దొరికితే కుక్క రాదు"
      },
      {
        "title": "135. ఉన్న లోభి కంటే లేని దాత నయం"
      },
      {
        "title": "136. లోగుట్టు పెరుమాళ్ళకెరుక"
      },
      {
        "title": "137. మెరిసేదంతా బంగారం కాదు"
      },
      {
        "title": "138. మంచమున్నంత వరకు కాళ్ళు చాచుకో"
      },
      {
        "title": "139. నోరు మంచిదయితే ఊరు మంచిదవుతుంది"
      },
      {
        "title": "140. మంది యెక్కువయితే మజ్జిగ పలచన అయినట్లు"
      },
      {
        "title": "141. మనిషి మర్మము మాను చేవ బయటకు తెలియవు"
      },
      {
        "title": "142. మనిషి పేద అయితే మాటకు పేదా"
      },
      {
        "title": "143. మనిషికి మాటే అలంకారం"
      },
      {
        "title": "144. మనిషికొక మాట పశువుకొక దెబ్బ"
      },
      {
        "title": "145. మనిషికొక తెగులు మహిలో వేమా అన్నారు"
      },
      {
        "title": "146. మంత్రాలకు చింతకాయలు రాల్తాయా"
      },
      {
        "title": "147. మీ బోడి సంపాదనకుఇద్దరు పెళ్ళాలా"
      },
      {
        "title": "148. మెత్తగా ఉంటే మొత్త బుద్ధి అయ్యిందట"
      },
      {
        "title": "149. మొక్కై వంగనిది మానై వంగునా"
      },
      {
        "title": "150. మొరిగే కుక్క కరవదు కరిసే కుక్క మొరగదు"
      },
      {
        "title": "151. మొసేవానికి తెలుసు కావడి బరువు"
      },
      {
        "title": "152. ముల్లును ముల్లుతోనే తీయాలి వజ్రాన్ని వజ్రంతొనే కొయ్యాలి"
      },
      {
        "title": "153. ముందర కాళ్ళకి బంధాలు వేసినట్లు"
      },
      {
        "title": "154. ముందుకు పోతే గొయ్యి వెనుకకు పోతే నుయ్యి"
      },
      {
        "title": "155. ముంజేతి కంకణముకు అద్దము యెందుకు"
      },
      {
        "title": "156. నడమంత్రపు సిరి నరాల మీద పుండు"
      },
      {
        "title": "157. నేతి బీరకాయలో నెయ్యి యెంత ఉందో నీ మాటలో అంతే నిజం ఉంది"
      },
      {
        "title": "158. నక్కకి నాగలోకానికి ఉన్నంత తేడా"
      },
      {
        "title": "159. నవ్వు నాలుగు విధాలా చేటు"
      },
      {
        "title": "160. నీ చెవులకు రాగి పొగులే అంటే అవీ నీకు లేవే అన్నట్లు"
      },
      {
        "title": "161. నిదానమే ప్రధానము"
      },
      {
        "title": "162. నిజం నిప్పు లాంటిది"
      },
      {
        "title": "163. నిమ్మకు నీరెత్తినట్లు"
      },
      {
        "title": "164. నిండు కుండ తొణకదు"
      },
      {
        "title": "165. నిప్పు ముట్టనిదే చేయి కాలదు"
      },
      {
        "title": "166. నూరు గొడ్లు తిన్న రాబందుకైనా ఒకటే గాలిపెట్టు"
      },
      {
        "title": "167. ఆరు నెళ్ళు సావాసం చేస్తే వారు వీరు అవుతారు"
      },
      {
        "title": "168. ఒక ఒరలో రెండు కత్తులు ఇమడవు"
      },
      {
        "title": "169. ఊపిరి ఉంటే ఉప్పు అమ్ముకొని బ్రతకవచ్చు"
      },
      {
        "title": "170. బతికి ఉంటే బలుసాకు తినవచ్చు"
      },
      {
        "title": "171. ఊరంతా చుట్టాలు ఉత్తికట్ట తావు లేదు"
      },
      {
        "title": "172. ఊరు మొహం గోడలు చెపుతాయి"
      },
      {
        "title": "173. పనమ్మాయితొ సరసమ్ కంటే అత్తరు సాయిబు తో కలహం మేలు"
      },
      {
        "title": "174. పాము కాళ్ళు పామునకెరుక"
      },
      {
        "title": "175. పానకంలో పుడక"
      },
      {
        "title": "176. పాపమని పాత చీర ఇస్తే గోడ చాటుకు వెళ్ళి మూర వేసిందట"
      },
      {
        "title": "177. పచ్చ కామెర్లు వచ్చిన వాడికి లోకమంతా పచ్చగా కనపడినట్లు"
      },
      {
        "title": "178. పండిత పుత్రః పరమశుంఠః"
      },
      {
        "title": "179. పనిలేని మంగలి పిల్లి తల గొరిగినట్లు"
      },
      {
        "title": "180. పరిగెత్తి పాలు తాగే కంటే నిలబడి నీళ్ళు తాగడం మేలు"
      },
      {
        "title": "181. పట్టి పట్టి పంగనామం పెడితే, గోడ చాటుకు వెళ్ళి చెరిపేసుకున్నాడట"
      },
      {
        "title": "182. పెదవి దాటితే పృథ్వి దాటుతుంది"
      },
      {
        "title": "183. పెళ్ళంటే నూరేళ్ళ పంట"
      },
      {
        "title": "184. పెళ్ళికి వెళుతూ పిల్లిని చంకన పెట్టుకు వెళ్ళినట్టు"
      },
      {
        "title": "185. పేనుకు పెత్తనమిస్తే తలంతా గొరికిందట"
      },
      {
        "title": "186. పెరుగు తోట కూరలో, పెరుగు యెంత ఉందో, నీ మాటలో అంతే నిజం ఉంది"
      },
      {
        "title": "187. పిచ్చి కోతికి తేలు కుట్టినట్లు"
      },
      {
        "title": "188. పిచ్చోడి చేతిలో రాయిలా"
      },
      {
        "title": "189. పిల్లి శాపాలకు ఉట్లు తెగుతాయా"
      },
      {
        "title": "190. పిల్లికి చెలగాటం ఎలుకకు ప్రాణ సంకటం"
      },
      {
        "title": "191. పిండి కొద్దీ రొట్టె"
      },
      {
        "title": "192. పిట్ట కొంచెము కూత ఘనము"
      },
      {
        "title": "193. పోరు నష్టము పొందు లాభము"
      },
      {
        "title": "194. పోరాని చోట్లకు పోతే , రారాని మాటలు రాకపోవు"
      },
      {
        "title": "195. పొర్లించి పొర్లించి కొట్టినా మీసాలకు మన్ను కాలేదన్నదడట"
      },
      {
        "title": "196. పుణ్యం కొద్దీ పురుషుడు, దానం కొద్దీ బిడ్డలు"
      },
      {
        "title": "197. పువ్వు పుట్టగానే పరిమళించినట్లు"
      },
      {
        "title": "198. రాజు గారి దివాణంలో చాకలోడి పెత్తనము"
      },
      {
        "title": "199. రామాయణంలో పిడకల వేట"
      },
      {
        "title": "200. రామాయణం అంతా విని రాముడికి సీత యేమౌతుంది అని అడిగినట్టు"
      },
      {
        "title": "201. రామేశ్వరం వెళ్ళినా శనేశ్వరం వదలనట్లు"
      },
      {
        "title": "202. రెడ్డి వచ్చే మొదలెట్టు అన్నట్టు"
      },
      {
        "title": "203. రొట్టె విరిగి నేతిలో పడ్డట్లు"
      },
      {
        "title": "204. రౌతు కొద్దీ గుర్రము"
      },
      {
        "title": "205. ఋణ శేషం శత్రు శేషం ఉంచరాదు"
      },
      {
        "title": "206. చంకలో పిల్లవాడిని ఉంచుకుని ఊరంతా వెతికినట్టు"
      },
      {
        "title": "207. సంతొషమే సగం బలం"
      },
      {
        "title": "208. సిగ్గు విడిస్తే శ్రీరంగమే"
      },
      {
        "title": "209. శివుని ఆజ్ఞ లేక చీమైనా కుట్టదు"
      },
      {
        "title": "210. శుభం పలకరా వెంకన్నా అంటే పెళ్ళి కూతురు ముండ ఎక్కడ అన్నాడంట!"
      }

    ],
    "title": "సామెతలు"
  },
  "beejaksharalu": {
    "CatID": [
      {
        "title": "వృక్షము యొక్క విత్తు లాగానే బీజాక్షరము అనేది మంత్రము యొక్క బీజము లాంటిది. అది పఠించటము వలన సాధకునకు సకారాత్మక శక్తి(Positive energy) కలుగును. పఠించిన కొలది ఆ సకారాత్మక శక్తి(Positive energy) క్రమముగా వృక్షము మాదిరి వృద్ధిచెందును. బీజ మంత్రములు అనేవి స్పందనలు. ఆత్మయొక్క పిలుపులు. సృష్టి ఆరంభములోని స్పందనలు బీజాక్షర మంత్రములే. తొమ్మిది శబ్దములవరకు ఉన్నది బీజమంత్రము, తొమ్మిదికి మించినయడల మంత్రము అని, ఇరువది శబ్దములను మించిన మహా మంత్రము అని అంటారు."
      },
      {
        "title": ""
      },
      {
        "title": "అసలు సృష్టి ఆరంభములోని ప్రథమ స్పందన 'ఓం'. అనగా ‘ఓం’ అనేది ప్రథమ బీజాక్షరము. ఆ ‘ఓం’ అనే ప్రథమ బీజాక్షరము క్రమముగా యోగ బీజము, తేజో బీజము, శాంతి బీజము, మరియు రక్షా బీజము లుగా ఉత్పత్తి చెందినది. అవియే ‘ఐం’, ‘హ్రీం’, ‘శ్రీం’, ‘క్రీం’, ‘క్లీం’, ‘దం’, ‘గం’, ‘గ్లౌం’, ‘లం’, ‘వం’, ‘రం’, ‘యం’, ‘హమ్’, ‘రాం’ అనే బీజాక్షరములు. సంగీతములో కూడా ప్రథమముగా ఉన్నది ‘ఓం’ మాత్రమే. అది క్రమముగా ‘స’, ‘రి’, ‘గ’, ‘మ’, ‘ప’, ‘ద’, ‘ని’, గా ఉత్పత్తి చెందినది. వేణువు ఊదినప్పుడు వచ్చు మొదటి శబ్దము ‘ఓం’ మాత్రమె. యోగ బీజము, తేజో బీజము, శాంతి బీజము, మరియు రక్షా బీజము లుగా ఉత్పత్తి చెందినది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>ఓం:</span>,
      },
      {
        "title": "‘ఓం’ మంత్రము త్రిమూర్తులు అనగా సృష్టి (బ్రహ్మ) లేదా ‘అ’ కారమునకు, స్థితి(విష్ణు) లేదా ‘ఉ’ కారమునకు, మరియు లయ (మహేశ్వర) లేదా ‘మ’ కారమునకు, లకు ప్రతీక. ‘అ’ కారము, ‘ఉ’ కారమునకు, మరియు ‘మ’ కారము మూడు కలిసినదే ఓంకారము. ‘అ’ కారము ఋగ్వేదమునకు, ‘ఉ’ కారము సామవేదమునకు, మరియు ‘మ’ కారము యజుర్వేదమునకు ప్రతీక. సృష్టి (బ్రహ్మ), స్థితి(విష్ణు) మరియు లయ (మహేశ్వర) మూడింటిని కలిపి మాయ అంటారు."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>క్రీం లేదా ధం లేదా క్షం లేదా లం :</span>,
      },
      {
        "title": "ఇది కాళీమాత మరియు కుబేర బీజాక్షరము. ఈ బీజాక్షర ఉచ్చారణ మూలాధార చక్రములో చేయవలయును. మూలాధార చక్రము పృథ్వీ తత్వమునకు ప్రతీక. తద్వారా ఇచ్ఛాశక్తి వృద్ధి చెందును. తద్వారా ఆరోగ్యము, బలము, అన్నివిధముల సఫలత, మరియు నకారాత్మక శక్తులనుండి రక్షణ లభించును."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>శ్రీం లేదా వం :</span>,
      },
      {
        "title": "ఇది మహాలక్ష్మి బీజమంత్రము. ఈ బీజాక్షర ఉచ్చారణ స్వాధిష్ఠాన చక్రములో చేయవలయును. స్వాధిష్ఠాన చక్రము వరుణ తత్వమునకు ప్రతీక. తద్వారా క్రియాశక్తి వృద్ధి చెందును. తద్వారా ఆరోగ్యము, అంగములలో బలము, మూత్రపిండములు, చర్మము వ్యాధుల నుండి రక్షణ, అన్నివిధముల భౌతిక సఫలత, వ్యాపార లేక వృత్తిలో వృద్ధి, రోగములను నిరోధించు శక్తి, విచార లేక శోక నిర్మూలన, సౌందర్యముగల భార్య లభించుట, సంతోషకరమయిన దాంపత్య జీవనము, అన్నివిధముల సఫలత, మరియు నకారాత్మక శక్తులనుండి రక్షణ లభించును."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>హ్రౌం లేదా దూం లేదా రం:</span>,
      },
      {
        "title": "ఇది శివ బీజమంత్రము. ఈ బీజాక్షర ఉచ్చారణ మణిపురచక్రములో చేయవలయును. మణిపురచక్రము అగ్ని తత్వమునకు ప్రతీక. తద్వారా జ్ఞానశక్తి వృద్ధి చెందును. తద్వారా ఆత్మనిగ్రహశక్తి వృద్ధి చెందును. అకాల మరణము, చక్కర (diabetes) వ్యాధినుండి రక్షణ, మోక్షమునకు మార్గము లభించుట ఆరోగ్యము, అంగములలో బలము, అన్నివిధముల భౌతిక సఫలత, వ్యాపార లేక వృత్తిలో వృద్ధి, రోగములను నిరోధించు శక్తి, విచార లేక శోక నిర్మూలన, సౌందర్యముగల బార లభించుట, సంతోషకరమయిన దాంపత్య జీవనము, అన్నివిధముల సఫలత, మరియు నకారాత్మక శక్తులనుండి రక్షణ లభించును."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>హ్రీం లేక ఐం లేక యం:</span>,
      },
      {
        "title": "ఇది మహామాయ లేక భువనేశ్వరీ బీజమంత్రము. ఈ బీజాక్షర ఉచ్చారణ అనాహతచక్రములో చేయవలయును. అనాహతచక్రము వాయు తత్వమునకు ప్రతీక. తద్వారా బీజశక్తి(root power) వృద్ధి చెందును. తద్వారా ప్రాణశక్తి నియంత్రణ వృద్ధి చెందును. వాయుప్రకోపనముల (gastric disturbances) వ్యాధులనుండి రక్షణ, నాయక లక్షణములు కలుగుట ఏర్పడును."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>గం లేక ఫ్రౌం లేక హమ్:</span>,
      },
      {
        "title": "ఇది గణపతి, కుండలినీ, మరియు హనుమాన్ బీజమంత్రము. ఈ బీజాక్షర ఉచ్చారణ విశుద్ధ చక్రములో చేయవలయును. విశుద్ధ చక్రము ఆకాశ తత్వమునకు ప్రతీక. తద్వారా జ్ఞానము, రక్షణ, ఐశ్వర్యము, సుఖము, సౌభాగ్యం, ఆరోగ్యము, సమస్త హృదయబాధల ఉపశమన, సమస్త నకారాత్మక శక్తుల నిర్మూలన నివారణ కలుగును."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>దం లేక ఓం:</span>,
      },
      {
        "title": "ఇది విష్ణు బీజమంత్రము. ఈ బీజాక్షర ఉచ్చారణ ఆజ్ఞా చక్రములో చేయవలయును. ఆజ్ఞా చక్రము కృష్ణ తత్వమునకు ప్రతీక. తద్వారా శుద్ధ జ్ఞానము, రక్షణ, ఐశ్వర్యము, సుఖము, సౌభాగ్యం, ఆరోగ్యము, సమస్త హృదయబాధల ఉపశమన, సమస్త నకారాత్మక శక్తుల నిర్మూలన నివారణ కలుగును. క్ష్రౌం లేక రాం : ఇది నరసింహ బీజమంత్రము. ఈ బీజాక్షర ఉచ్చారణ సహస్రార చక్రములో చేయవలయును. తద్వారా సమస్త నకారాత్మక శక్తుల నిర్మూలన నివారణ కలుగును మరియు సాధకుడు స్వయముగా సాక్షీభూతుడు అగుతాడు."
      }
    ],
    "title": "బీజాక్షర వివరణార్థములు"
  },
  "Beejaksharasankatamulu": {
    "CatID": [
      {
        "title": "ఓం - ప్రణవము సృష్టికి మూలం"
      },
      {
        "title": ""
      },
      {
        "title": "హ్రీం - శక్తి లేక మాయా బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ఈం - మహామాయ"
      },
      {
        "title": ""
      },
      {
        "title": "ఐం - వాగ్బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "క్లీం - మన్మధ బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "సౌః - సౌభాగ్య బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ఆం - పాశబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "క్రోం - అంకుశము"
      },
      {
        "title": ""
      },
      {
        "title": "హ్రాం - సూర్య బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "సోం, సః - చంద్ర బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "లం - ఇంద్ర బీజం, పృథివీ బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "వం - వరుణ బీజం, జల బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "రం - అగ్ని బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "హం - ఆకాశ బీజం, యమ బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "యం - వాయు బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "శం - ఈశాన్య బీజం, శాంతి బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "షం, క్షం - నిరృతి బీజము"
      },
      {
        "title": ""
      },
      {
        "title": "సం - సోమ (కుబేర) బీజము"
      },
      {
        "title": ""
      },
      {
        "title": "జూం - మృత్యుంజయ, కాలభైరవ బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "భం - భైరవబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "శ్రీం - లక్ష్మీబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "హ్సౌ - ప్రాసాద, హయగ్రీవబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ఖేం - మారణబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ఖట్ - సంహారబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ఫట్ - అస్త్రబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "హుం - కవచబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "వషట్ - వశీకరణముబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "వౌషట్ - ఆవేశబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ష్ట్రీo - యమబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ధూం - ధూమావతిబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "క్రీం - కాళీబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "గం - గణపతిబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "గ్లౌం - వారాహి, గణపతిబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ఘే - గణపతిబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "త్రీం - తారా బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "స్త్రీo - తారాబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "హూం - కూర్చము, క్రోధము, ధేనువు"
      },
      {
        "title": ""
      },
      {
        "title": "బ్లూం - సమ్మోహనము"
      },
      {
        "title": ""
      },
      {
        "title": "ద్రాం -ద్రావణ, దత్తాత్రేయబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ద్రీo - ఉద్దీపనం"
      },
      {
        "title": ""
      },
      {
        "title": "దం - దత్తాత్రేయబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "అం - బ్రహ్మ బీజం"
      },
      {
        "title": ""
      },
      {
        "title": "కం - బ్రహ్మబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ఇం - నేత్రబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ఉం - శ్రోత్రబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "హ్లీం - బగళాబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "గ్రీం - గణపతిబీజం"
      },
      {
        "title": ""
      },
      {
        "title": "ఠ - స్థంభనము"
      },
      {
        "title": ""
      },
      {
        "title": "హిలి - వశీకరణ, దేవతాభాషణం"
      },
      {
        "title": ""
      },
      {
        "title": "కిలి కిలి - దేవతాభాషణం"
      },
      {
        "title": ""
      },
      {
        "title": "చులు - బాధా నివారణ"
      },
      {
        "title": ""
      },
      {
        "title": "హులు - బాధా నివారణ"
      },
      {
        "title": ""
      },
      {
        "title": "మానవుడు ఈ లోకంలోని కర్మ వలన శరీరాన్ని పొందుతున్నాడు. ప్రారబ్ధ కర్మలను అనుభవిస్తూ మరల పాపపుణ్యాలు చేసి తిరిగి జన్మ పరంపరను పొందుతున్నాడు. ఇట్టి జన్మ పరంపరను విచ్చేదమొనర్చడానికి ఉపయోగపడు సాధనే ‘జపం’ అని శాస్తమ్రులు చెబుతున్నాయి."
      },
      {
        "title": ""
      },
      {
        "title": "‘జప’మనగా ‘జ’-జన్మ విచ్ఛేదనం చేయునది. ‘ప’ -పాపమును నశింపచేయునది అని అర్ధం. ఈ విధంగా జన్మను పాపమును రెండింటిని నశింపచేయడం చేతనే దీనికి జపమని పేరు వచ్చింది. జపంలో చందోబద్ధమైన ఒకే భగవన్నామం కానీ, ప్రత్యేకమైన కొన్ని మంత్రాలను కానీ ఉచ్చరించడం జరుగుతుంది. మనసు చంచలమై అల్లకల్లోలంగా వున్నప్పుడు ఆ మనసును ఏకాగ్రపరచడానికి జపం ఉపయోగపడుతుంది. నిశ్చల మనస్సుతో నిర్మలంగా దైవంపై మనసును కేంద్రీకరించి తత్ మంత్ర దేవతామూర్తి గుణరూపాలను మనసులో ముద్రించుకుని జపించాలి."
      },
      {
        "title": ""
      },
      {
        "title": "జపాన్ని మూడు విధాలుగా చేయవచ్చు. ఒకటి వాచకము: మంత్ర బీజ వర్ణములను తన దగ్గర ఉన్నవారికి వినబడునట్టు ఉచ్చరించుతూ జపించడం. రెండవది ఉపాంశువు: తన దగ్గరున్న వారికి మంత్రోచ్ఛారణ శబ్దాలు వినపడకుండా ఉచ్చరిస్తూ కేవలం పెదవులను మాత్రమే కదలిస్తూ జపం చేయడం. మూడు మానసికము: పెదవులను నాలుకను కదల్చకుండా మనస్సులోనే మంత్రం జపించుట."
      },
      {
        "title": ""
      },
      {
        "title": "వాచిక జపయజ్ఞముకన్నా ఉపాంశు జప యజ్ఞము వందరెట్లు అధిక ఫలాన్ని కలిగిస్తుంది. ఉపాంశు జప యజ్ఞం కంటె మానసిక జపయజ్ఞం వెయ్యిరెట్లు అధిక ఫలాన్ని కలిగిస్తుంది. ముఖ్యంగా మంత్ర మహిమార్ధములను క్షుణ్ణంగా తెలుసుకుని జపించడం, సగర్భ జపం అనీ, మిక్కిలి శ్రేష్ఠమైనదనీ చెబుతున్నారు."
      },
      {
        "title": ""
      },
      {
        "title": "జపాన్ని చేసి సిద్ధి పొంది ఉచ్ఛస్థితికి వచ్చిన మహాపురుషుల యొక్క ప్రతిరోమము మంత్రాన్ని ఉచ్చరించడాన్ని మనం గమనించవచ్చును. జపం వలన కలుగు స్పందనచే సాధకుని శరీరం అంతా ఒక విధమైన దివ్య తేజస్సుతో దీప్తి నొందుతుంది. ఇట్టి స్థితిలో సాధకుని శరీరం దైవభావంతో అంతర్లీనమై ఒకవిధమైన గగుర్పాటు కలిగి అనిర్వచనీయమైన అద్భుతానందాన్ని పొందును. అతనిలో దైవ ప్రేమ పూర్తిగా నిండి ఆధ్యాత్మిక శక్తిని పొందుతుంది. మరియు అనేక ఇతర సిద్ధులను కూడా పొందుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": "అలాగే జపవిధానంలో తీసుకోవాల్సిన జాగ్రత్తలు మరీ మెల్లగా అక్షరం విడిచి అక్షరంగా జపం చేయరాదు. అలాగని వర్ణోచ్ఛారణ మిక్కిలి వేగంగాను చేయరాదు. సమాన వేగంతో ఆటంకాలు లేకుండా స్పష్టంగా ఉచ్చరించాలి. జపం చేసేటప్పుడు మనసును ఇతర భావాలనుండి మరిల్చి దైవం మీద మంత్రార్ధం మీదే ధ్యాసవుంచి ప్రశాంతంగా, ఏకాంతంగా జపించాలి."
      },
      {
        "title": ""
      },
      {
        "title": "సాధ్యమైనంతవరకు వౌనంగా ఉండాలి. శాంత స్వభావంతో ఉంటు పెద్దలను, విజ్ఞులను గౌరవించాలి. పాప కర్మలను, పాప చింతనలను పూర్తిగా విడిచి ధర్మచింతనతో, ఆధ్యాత్మిక చింతనతో గడపవలెను. సాత్విక మితాహారాన్ని భుజించాలి. సదా ఇష్ట దేవతా స్తోత్రాల పఠనం, వినడం కీర్తనం చేయాలి. దైవంనందు జపం పట్ల పరిపూర్ణ విశ్వాసం వుండడం అత్యంత ఆవశ్యకం. మానసిక జపానికి కాలనియమం లేదు. సాధకుని యొక్క అనుకూలత బట్టి ఎపుడైనా ప్రశాంతంగా చేసుకోవచ్చు. మంత్రార్ధాన్ని, మంత్ర చైతన్యమును, యోని ముద్రను తెలసుకోకుండా ఎన్నిసార్లు జపించినా నిష్ఫలం అవుతుంది. జపోచ్ఛారణలో మంత్రం బీజాక్షరాలు లోపించకూడదు. అలాలోపిస్తే జప ఫలం ఉండదు."
      },
      {
        "title": ""
      },
      {
        "title": "బీజ లోపం లేకుండా చైతన్యం కలిగి ఉండు మంత్రాలను జపించడం వల్లనే ఫలితం. సంధ్యా సమయాల్లో అష్టోత్తరాలు, సహస్రనామాలు జపించడం ఉత్తమం. ఒక దైవనామాన్నికానీ ఒకే మంత్రాన్ని గానీ జపిచడం వల్ల ఏకాగ్రత కుదిరి జపసాధన నిర్విఘ్నంగా సాగుతుంది."
      }
    ],
    "title": "బీజాక్షర సంకేతములు"
  },
  "yagnalu": {
    "CatID": [
      {
        "title": "వేదంలో యజ్ఞో వై విష్ణుః అని చెప్పబడింది. అనగా యజ్ఞము విష్ణు స్వరూపము."
      },
      {
        "title": ""
      },
      {
        "title": "యజ్ఞం లేదా యాగం ఒక విశిష్టమైన హిందూ సంప్రదాయం. భారతదేశంలో పురాణకాలం నుండి వివిధ రకాలైన యజ్ఞాలు జరిగాయి. దేవతలకు తృప్తి కలిగించడం యజ్ఞం లక్ష్యం. సాధారణంగా యజ్ఞం అనేది అగ్ని (హోమం) వద్ద వేదమంత్రాల సహితంగా జరుగుతుంది. ఇందుకు అనుబంధంగా అనేక నియమాలు, సంప్రదాయాలు ఉన్నాయి. అగ్నిహోత్రం అనేది యజ్ఞంలో ముఖ్యమైన అంశం. యజ్ఞంలోని అగ్నిలో వ్రేల్చినవి అన్నీ దేవతలకు చేరుతాయి."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>యజ్ఞ విధానం</span>,
      },
      {
        "title": ""
      },
      {
        "title": "వైదిక యజ్ఞంలో అధ్వర్యుడు ప్రధాన అర్చకుడు. అతని అధ్వర్యంలో అన్ని కార్యక్రమాలూ జరుగుతాయి. అతనికి సహాయంగా అనేక అర్చకులు, పండితులు ఉంటారు. హోత ఈయన ఆహుతికి పూర్వం మంత్రాల్ని పఠించి దేవతల్ని యజ్ఞాభూమికి తీసుకొస్తాడు. ఉద్గాత వేద మంత్రాలు చదువుతాడు. ఇంకొకరు బ్రహ్మ హోతాద్వర్యుల కార్యక్రమాన్ని పర్యవేక్షించడమే ఈయనపని.పొరపాటు వస్తే సరిదిద్దుతాడు. ఇంకొకరు అగ్నీత్తు-బ్రహ్మకు సహకారి. యజ్ఞంలో ఒకటి గాని అంతకంటే ఎక్కువ గాని హోమాగ్నులు ఉంటాయి. ఆ అగ్నిలో నెయ్యి, పాలు, ధాన్యం వంటి అనేక సంభారాలు పోస్తుంటారు. యజ్ఞాలు కొద్ది నిముషాలనుండి అనేక సంవత్సరాలవరకూ జరుగవచ్చును."
      },
      {
        "title": ""
      },
      {
        "title": "ఈక్రింద ఇష్టియాగం అను యాగ క్రతువును అనుసరించి వివరించబడింది. ఈ యాగము పౌర్ణము నాడు గాని, అమావాస్యనాడు గాని ప్రతీ గృహస్తుడు చేయవచ్చును. పౌర్ణమినాడు చేయబడితే అది పూర్ణమాసయాగాం, అమావాస్యనాడు చేయబడితే దర్శయాగం."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>పురోడాశం</span>,
      },
      {
        "title": "ఇది ఒక ప్రధానఅహుతి. అనగా అగ్నికి వేయు ఆహుతి ఇయ్యబడే ద్రవ్యం. ఇది యవలతో (Barley) గాని, బియ్యంతోగాని చెయ్యబడే రొట్టెముక్క, రుబ్బి నిప్పులో కాలుస్తే ఇది తయారవుతుంది. దీన్ని అద్వర్యుడు చేయాలి. ఇది అర్ధవృత్తాకారంలో ఉంటుంది. దీనిని పలు భాగాలుగా ఆహుతి ఈయుటుక విభజిస్తారు. వాటినే చతుష్కోణ కపాలం, ఏకాదశ కపాల భాగాలు అంటారు."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>వ్రతగ్రహణం</span>,
      },
      {
        "title": "ఇది యాగానికి పూర్వదినం అపరాహ్న (సాయంసంధ్యవేళ) పూర్నాహ్న (తెల్లవారుజాము) సమయములలో చెయ్యాల్సిన క్రియలు. ఇవి యాగానికి సంబంధించిన అగ్నిని ముందుగానే సిద్ధముగా ఉంచుట. ఇవి రెండు విధాలు. వ్రతగ్రహణ, అంవాధానాలు. పూర్వాహ్నంలో యజమాని గార్హపత్యం (శ్రోతగ్ని), ఆహవనీయ, దక్షిణాగ్నుల్లో క్రమంగా ఒక్కొక్క సమిత్తు వేసి, అగ్నిని యజ్ఞానుకూలం చేస్తాడు. నేను రేపు యాగం చేస్తాను సిద్ధంగా ఉండుసుమా అని అప్పుడే అగ్నికి చెప్పి ఉంచటము. అపరాహ్నం క్షుర కర్మచేసుకొని, స్నానం చేసుకొని కొంచెం ఏమైనా తింటాడు. తరువాత అగ్నికి పక్కగా నిల్చి, నేను సత్యాన్నే పలుకుతాను మొదలుగాగల కొన్ని నియమాల్ని పాలించటానికి ప్రతిజ్ఞ తీసుకొంటాడు. పత్నీ సహితంగా రాత్రి యజ్ఞసాలలోనే గడపాలి."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>వరణం</span>,
      },
      {
        "title": "మరునాడు నిత్యాగ్నిహోత్రకర్మానంతరం ఇది ఋత్విక్కులు వారి వారి దిక్కులను అనుసరించి అగ్నికి అనుకూలంగా కూర్చెడెడి విధానము. ఇందులో ప్రథమం బ్రహ్మ వరణం. వరణానంతరం బ్రహ్మ ఆహవనీయానికి (శ్రోతగ్ని) దక్షిణంగా ఆసనాన్ని స్వీకరించి, కర్మనంతటినీ పర్యవేక్షిస్తాడు. బ్రహ్మకు వామభాగమున యజమాని కూర్చుండే చోటు. యజమాని భార్య గార్హపత్యానికి దక్షిణంగా అధివసిస్తుంది. వేదికకి ఉత్తరంగా హోతా అగ్నీత్తులు ఉంటారు. అధ్వర్యుడు యాగకాలంలో కూర్చోటానికి వీలుండదు. దీనికీ దానికీ కదుల్టు ఉండాలి."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>ప్రణీత</span>,
      },
      {
        "title": "వరణానంతరం ప్రణీత- ప్రణయకర్మ - కాసిని నీళ్ళను పూర్వముఖంగా తీసుకువెళ్ళి, ఆహవనీయానికి (యజ్ఞవేదికకు తూర్పున చతురస్రంగా ఉండే కుండంలోని అగ్ని శ్రౌతాగ్నులలో ఒకటి) పక్కగా ఉంచుట. ఈనీటిపేరు ప్రణీత. యాగం ముగిసే వరకు ఆనీరు అక్కడే ఉంచాలి. యజ్ఞ రక్షణార్ధం జలం అసురులకీ, రాక్షసులుకీ వజ్రం. దీన్ని చూస్తే వాళ్ళు యజ్ఞభూమికి రారు అని శతపధబ్రాహ్మణం చెబుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>ప్రధాన యజ్ఞవస్తువులు</span>,
      },
      {
        "title": "1. సమింధనము లేదా సమిత్తులు- అనగా యజ్ఞకట్టెలు. అధ్వర్యుడు ఒక్కో సమిత్తును ఆహవనీయంలో వేస్తాడు. హోత ఒక్కో ఋక్-మంత్రాన్ని చదువుతాడు. 2. దర్భకలు-వైదిక కర్మకాండలో ఉపయోగ పడే రెల్లుజాతి తృణాలు. ఇవి పది రకాలు: కుశం, కాశం, యవం, దూర్వం, విశ్వా మిత్రం, ఉసీరం, కుందురం, గోధూమం, వ్రీహి, ముంజం. దర్భలను కృష్ణపక్షమి పాడ్యమినాడు మంత్ర పఠనం చేస్తూ సేకరిస్తారు. దర్భలు మంత్రాలను శక్తిమంతం చేస్తాయనీ, హానికరమైన కిరణాలను, తరంగాలను అడ్డుకుంటాయని కొందరు వైజ్ఞానిక పరిశోధన చేసి ప్రకటించాడు. 3. పురోడాశం 4.ఆవునేయి."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>దేవతాహ్వానం</span>,
      },
      {
        "title": "హోత సామాన్య మానవుడు. అతడు పిలిస్తే మటుకు దేవతలు ఎందుకు పలుకాలి? అగ్ని స్వయంగా దేవతల హోత. అందువల్ల ఆయన్ని ఆపనికి వినియోగించాలి. మళ్ళా, అగ్ని నెవరు పిలవాలి? హోతాద్వర్యురులు ఇద్దరు అగ్నిని పిలుస్తారు. వీళ్ళ ఆహ్వానన్ని మటుకు అగ్ని ఎందుకు అంగీకరించాలి? ఎందుకు వినాలి? ప్రాచీన ఋషులు మంత్రద్రష్టులు. అలౌకికశక్తి వల్ల లభించిన మంత్రాల్తో వాళ్ళు అగ్నిని పిలిచేవాళ్ళు. అది అగ్నికి వినిపించీ వినపించటంతోనే అగ్ని కదిలివచ్చేవాడు. ఎవరిమట్టుకు వాళ్ళు వారివారి అగ్నినే పిలిచేవాళ్ళు. ఆయా ఋషుల అగ్నిపేరు ఆర్షేయాగ్ని, ప్రవరాగ్ని అని ఇంకోపేరు. దేవతాహ్వానముకోసం చేసిన హోతృవరణం పేరు ప్రవరణం. వరణానంతరం హోత వేదికకి ఉత్తరంగా కూర్చుంటాడు. హోత ఆసీనుడైన తరువాత యాగం ఆరంభం అవుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>ప్రయాజయాగం</span>,
      },
      {
        "title": "ప్రధానయాగానికి ముందుగా చెయ్యల్సింది ప్రయాజయాగం. ఆహుతి ద్రవ్యం ఆజ్యం. అద్వర్యుడు ఘృతంద్వారా మొదట్లో ఆఘారహోమం చేసి దీనిని చేస్తాడు. 5గురు దేవతల్ని ఉద్దేశించి 5 ఆహుతులు. ఈ దేవతల పేర్లు- సమిత్, తనూనపాత్, ఇడా, బర్హి, స్వాహాకార."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>ఆజ్యభాగం</span>,
      },
      {
        "title": "ఈ పంచప్రయజానంతరము అగ్నిని ఉద్దేశించి ఒకసారి, సోముణ్ణి మరోసారి ఉద్దేశించి ఆజ్యాహుతి ఇవ్వాలి. దీని పేరు ఆజ్యభాగదానం."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>ఉపాంశుయాగం</span>,
      },
      {
        "title": "ఆజ్యభాగదానం తరువాత ప్రధానయాగం. అగ్నిని ఉద్దేశించి ప్రథమపురోడాశం. అగ్నిని, సోముణ్ణి ఉద్దేశించి ద్వితీయపురోడాశదానం. ఈ రెంటికీ మధ్య అగ్నిసోములకి కొంచెం ఘృతాహుతి. ఈఘృతాహుతి సమయంలో మంత్రపానం అనుచ్చస్వరంలో జరుగుతుంది.కాబట్టి దీనిపేరు ఉపాంశుయాగం."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>స్విష్టకృత్తు</span>,
      },
      {
        "title": "రెండు కపాలాల్లో ఉంచిన పురోడాశాన్ని అంతటినీ ఆహుతి వేయకుండా అగ్ని-స్వష్టకృత్తు నుద్దేశించి ఆహుతి నీయాలి.వీరు రుద్ర దేవాతకము. ఈ రుద్రదేవత అంటె ఎంతో భయం. ఇతని బాణాలంటే చెప్పలేనంత భయం. స్పష్టంగా ఇతనిపేరు ఉచ్చరించటానికికూడా జడుపేనట. ఉగ్ర, భీమ, కపర్ది శబ్దాలు ఈ భయానికే సూచనలు. ఇతన్ని సంతోషింపజేయుటకే శంకరుడనే పిలుపు. వేదంలోని ఇతర దేవతలకీ, ఇతనికే ఎంతో తేడా ఉంది. ఒకప్పుడు దేవతలు ప్రార్ధిస్తే, ఈయన ప్రజాపతి అంతటివాడిమీద బాణాల్ని విసిరాడు. దానికి దేవతలెంతో సంతోషించి, పశుగణానికి ఈయన్ని అధిపతిగా చేశారు. పశుపతి అయినాడు. పూర్వం యజ్ఞభాగాల్లో పాలు ఉండేది కాదు. ఒకసారి ఈయన బలవంతంగా యజ్ఞ భాగాన్ని గ్రహించాడు. అప్పట్నుంచే ఈ స్విష్టకృత్ యాగం ఆరంభం అయింది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>అనుయాజ</span>,
      },
      {
        "title": "ప్రధానయాగానికి పూర్వం ప్రయాజయాగం ఉన్నట్టు, అనంతరం ఈ అనుయాజ.ప్రయాజకు పంచదేవతలు. కాని, అనుయాజకు దేవతలు ముగ్గురే. వీరి పేర్లు-బర్హి, నరాశంస, అగ్ని స్విష్టకృత్తులు."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>సమాన్యనియమక్రమం</span>,
      },
      {
        "title": "ఈ ప్రధాన యాగాల్ని చేసే కొన్ని నియమాలు. అధ్వర్యుడే యాగకర్త, హోత ఆహ్వానకారి.ఆహావనీయంలోనే ఆహుతిసమర్పణ. అద్వర్యుడి ఆసనం ఆహావనీయానికి ఉత్తరంగా. అక్కడ ఆయన నిలబడి ఉండాలి. ఏ యాగంలోనైనసరే, ఆయన దక్షిణహస్తంతో జుహువును (మోదుగు కర్రతో చేసిన పరికరం. ఆజ్యాన్ని హోమం చేయడానికి ఉపయోగపడే గరిట), వామహస్తంతో ఉపభృత్తు (యజ్ఞాంగ పాత్రము. రావికఱ్ఱతో చేసిన స్రుక్కు) పట్టుకొని వేదికకి ఉత్తరమ్నుండి దక్షిణంగా వస్తాడు.అక్కడ నిలబడి అగ్నీత్తును ఆదేశిస్తాడు : ఓం శ్వావయః. అంటే దేవతలని మంత్రాల్ని వినమని ప్రార్థించు.ఈ అగ్నీత్తు వేదికకి ఉత్తరంగా నిలబడతాడు, చేత్తో ఒక కర్రకాతిని పట్టుకొని. ఈ కర్రకత్తిపేరు స్ఫ్యః ఆయన జవాబిస్తాడు: అస్తు శ్రౌషట్. అంటె మంచిది దేవతలు వింటున్నారు అని. అప్పుడు అద్వర్యుడు హోతకాదేశిస్తాడు, దేవతల్ని ఆహ్వానించమని. హోత రెండు మంత్రాలు చదవాలి. ఒకటి అనువాక్యం-ఇది ఋక్ మంత్రం. ఈ మంత్రంవల్ల దేవతల్ని అనుకూలంగా చేసుకుంటారు.ద్వితీయ మంత్రం యాజ్యం. ఇది కొన్నిపట్ల ఋక్కును, కొన్ని పట్ల యజుస్సు. ఇదే యాగమంత్రం. కనుకనే యాజ్యం. హోత మంత్రపఠాన్ని యే యజామహే అగ్నిం దేవం అని ఆరంభిస్తాడు. దీని పేరు అగూః మంత్రం. తరువాత యాజ్యమంత్రాన్ని చదివి అగ్నే విహి ఔషట్ అగ్ని దీన్ని భక్షించి దేవతల దగ్గరకు వెళ్ళు అని అర్ధము. ఈ వషట్కారము ఉచ్చారితమవుతూ ఉన్నప్పుడే అధ్వర్యుడు ఆహుతి ద్రవ్యాన్ని అగ్నిలో వేస్తాడు. యజమాని ఆహుత్యనంతరము ఇదం అగ్నయే న మమ ఇది నాదికాదు అనే త్యాగ మంత్రాన్ని ఉచ్చరిస్తాడు."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>హవిర్భక్షణ</span>,
      },
      {
        "title": "ఇది కాకపోతే ఏ యజ్ఞమూ సంపూర్ణంకాదు. పురోడాశాన్ని అంతా ఆహుతి ఇయ్యకూడదు. కొంచెం మిగిలేట్టు చూడాలి. యజమానీ, ఋత్విక్కులు దీన్ని భజిస్తారు. మిగిలిన పురోడాశాన్ని దీని నిమిత్తం కొన్ని ముక్కలుగా భాగిస్తారు. ఒకదాని పేరు ప్రాశిత్రం, దీని బ్రహ్మ భక్షిస్తాడు. ఇంకోదాని పేరు షడవత్తం -అగ్నీత్తుది. ఇంకో ఖండాన్ని మళ్ళా నల్లుగు ముక్కలు చేసి, అధ్వర్యు, హోత, బ్రహ్మ, అగ్నీత్తులు భక్షిస్తారు. ఇంకో రెండు ముక్కలు బ్రహ్మ, యజమానీ దాని భక్షిస్తారు."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>ఇడాభక్షణ</span>,
      },
      {
        "title": "ఈపురోడాశఖండాల్లో కొన్నిటిని ఘృతాక్తం చేయాలి. వీటిపేరు ఇడ. యజమాని, 4 ఋత్విక్కులు దీనిని భక్షిస్తారు. అసలు హవిస్సేష భక్షణే చాలా ముఖ్యం. అందులో మళ్ళీ ఇడా భక్షణ మరీ ముఖ్యం. ఈ ఇడలో ఒక భాగాన్ని హోత తింటాడు- అది అవాంతర ఇడ. ఈహవిశ్శేషభక్షణానుష్ఠానం స్విష్టకృత్తు యాగానికి తర్వాత, అనుయాగ-యాగానికి ముందు. కేవలం బ్రహ్మ, యజమాని లిద్దరు యజ్ఞం పూర్తికాగానే తింటారు."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>సమాప్తిక్రమం</span>,
      },
      {
        "title": "ప్రస్తర మనబడే దర్భకట్టతో యజమానశరీరాన్ని ఏకంగా భావించాలి. అనుయాజ యాగానంతరం ఈ ప్రస్తరాన్ని ఆహవనీయాగ్నిలో పడేయ్యాలి. ఇది కాలిపోతున్నప్పుడు యజమాని స్వర్గానికి వెళుతున్నట్టు. సంపూర్ణంగా దగ్ధమైతే, యజమాని స్వర్గలోకంలో దేవతల్తో ఐక్యమైనట్టు. ప్రస్తరం కాలిపోతున్నప్పుడు, హోత అధ్వర్యుడి అనుజ్ఞతో కొన్ని మంత్రాల్ని చదువుతాడు. వీటి పేరు సూక్తవాక్కు.పూర్తిగా కలిపోయినాక మరికొన్ని మంత్రాలని చదువుతాడు వీటి పేరు శంయూవాక్కు. ఇవి ఆశీర్వాద సుచకాలు."
      },
      {
        "title": ""
      },
      {
        "title": "పరిధి అనబడే సంత్కాష్ఠఖండత్రయంలో, మానవహోత దేవహోతను పిలుచుకువచ్చిన దానిని లిపిన దర్భ పేరు పరిధి. వీటిని కూడా అగ్నిలో వేయాలి. అప్పుడు దేవహోత యజ్ఞస్థలం నుంచి వెళ్ళిపోతాడు."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>సంస్రవం</span>,
      },
      {
        "title": "ఈ సమయంలో అధ్వర్యుడు విశ్వదేవతల నుద్దేశించి, కొంచెంగా ఆజ్యాన్ని ఆహుతి ఇచ్చి హోమం చేస్తాడు. దీని పేరు సంస్రవహోమం. ఇది యాగం కాదు, హోమం. దీంతో యజమాని అనుష్ఠానం సమాప్తం."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>పత్నీకృత్యం</span>,
      },
      {
        "title": "ఇంతవరకూ ఒపికగా గార్హపత్యాగ్ని ప్రక్కగా కూర్చున్న యజమాని భార్య దగ్గరకు బ్రహ్మ కాక మిగిలిన ముగ్గురు ఋత్విక్కులు వచ్చి, గార్హపత్యాగ్నిలో కొన్ని ఆహుతులు వేస్తారు. ఆహుతి ద్రవ్యం ఆజ్యం. దేవతలు: సోముడు, త్వష్ట, దేవపత్నీగణం, అగ్ని-గృహపతి. ప్రధానయాగానంతరం హవిర్భక్షణ జరిగినట్టే ఇప్పుడు కూడా జరగాలి."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>సమష్టిహోమం</span>,
      },
      {
        "title": "దక్షిణాగ్నిలో ఇంతవరకూ ఒక్క ఆహుతి కూడా పడలేదు. కనుక, అధ్వర్యుడు దక్షిణాగ్నిలో ఆజ్యహోమాన్ని చేస్తాడు. పురోడాశం చేయ్యగా మిగిలిన కొంచెం రుబ్బుడు పిండిని, విశ్వదేవతల నుద్దేశించి అగ్నిలో వేస్తారు. దేవహోత ఆహ్వానాన్ని అనుసరించి యజ్ఞక్షేత్రానికి వచ్చిన దేవతలందరూ ఇంకా వెళ్ళిపోలేదు. అధ్వర్యుడు వీళ్ళందరి నిమిత్తమూ ఆజ్యాహుతుల్ని ఆహనీయంలో వేస్తాడు. అప్పుడు వాళ్ళు సంతుష్టులై వెళ్ళిపోతారు. దీనిపేరు సమష్టియజుర్హోమం."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>రాక్షసులకు</span>,
      },
      {
        "title": "వేదికమీద పరచబడిన దర్భలనన్నిటినీ ఆహవనీయంలో పడవేస్తారు. ప్రణీతా-జలాన్ని వేదిమీద పొయ్యాలి. పురోడాశం తయారుచెయ్యటంలో వచ్చిన ఊక, తవుడు చిట్టు మొదలైనవి రాక్షసులకు ప్రాప్యం. దీంతోనే వాళ్ళు సంతోషిస్తారు. రాక్షసుల్ని ఉద్దేశించి వాటిని విసర్జించాలి."
      },
      {
        "title": "దీంతో యజ్ఞం ముగుస్తుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>ప్రక్రమణ</span>,
      },
      {
        "title": "ఈ యజ్ఞ నిర్వహణఫలంగా యజమాని దైవత్వాన్ని పొందాడు. అంతేకాదు దేవతల్లో సర్వశ్రేష్ఠుడైన విష్ణువుపదాన్ని పొదటానికే అతడిప్పుడు అభ్యర్థి. విష్ణువు త్రిపదవిన్యాసంతో మూడులోకాల్ని ఆక్రమించాడు అని భావించి యజమాని యజ్ఞస్థలంలో మూడు అడుగులు వేసి, తూర్పుగా ఆహవనీయం వరకు ప్రక్రమిస్తాడు. దీనిపేరు విష్ణుక్రమ ప్రక్రరణ. పూర్వదిక్కు దేవతల స్థానం. యజమాని తూర్పుగా తిరిగి చూస్తూ నేను జ్యోతిలో గమనమొనరుస్తున్నాను, జ్యోతిలో కలిశాను అనే అర్ధం గల మంత్రాన్ని జపిస్తాడు."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>వ్రత విసర్జన</span>,
      },
      {
        "title": "యజమాన్ని గార్హపత్య ఉపస్థానమూ, సూర్యోపస్థానమూ జరిపి గృహపతి అయిన అగ్నీ! నేను స్వగృహపతిని అవుతాను అగుగాక అని అంటాడు. తర్వాత, పుత్రుడు పేరు చెప్పి, నా ఈ పుత్రుడు ఈ కర్మనీకు అనుక్రమంగా విస్తరిల్లాజేస్తాడుగాక. అని ప్రార్ధిస్తాడు."
      },
      {
        "title": "విసర్జనానంతరము యజమాని బ్రహ్మతో కలిపి యజ్ఞశాలకు బయటకు వచ్చి, తమకోసం అట్టేపెట్టిన పురోడాశాభాగాన్ని స్వీకరిస్తారు."
      },
      {
        "title": "సర్వశేషంగా బ్రహ్మ ఆహవనీయంలో సమిత్ఖండాల్ని వేసి, పూర్ణమాసేష్టిని సమాప్తం చేస్తాడు. యజ్ఞాంతంలో ఋత్విక్కులకు దక్షిణ ఇవ్వాలి."
      }
    ],
    "title": "యజ్ఞ విజ్ఞాన రహస్యాలు"
  },
  "homalu": {
    "CatID": [
      {
        "title": "కేవలం తాను బతకటం కోసం మాత్రమే కాక, కొంతవరకు నిస్వార్థంగా ఇతరుల కోసం ఆలోచించి, పని చేసేవారికే మంచి మనస్సు వుంటుంది. అలా మంచి మనసున్న వారినుంచే మంచి మాటలు వస్తాయి. మహర్షులు ఎన్నో సందర్భాలలో 'పరోపకారార్ధమిదం శరీరమ్' అని చెప్పారు. చెప్పటమే కాదు, ఆచరణలో చూపించారు. బహుశా అందుకే కావచ్చు మహర్షులకు వాక్ శుద్ధి వుండేది. వారు ఎలాంటి ప్రతిఫలం ఆశించకుండా ఇతరుల కోసం ఎంతో కొంత చేసేవారు."
      },
      {
        "title": ""
      },
      {
        "title": "మహర్షులు మాట్లాడేది తప్పకుండా జరిగేది. మహర్షులు వివిధ ప్రయోజనాల కోసం రకరకాల హోమాలు చేసేవారు. తమ ఆశయాలను నెరవేర్చుకునేవారు. ఇక్కడ గమనించవలసిందే ఏమంటే మహర్షుల కోరికలన్నీ నేరుగా కానీ, అంతర్గతంగా కానీ ప్రజల కోసమే ఉద్దేశించి వుండేవి - అంటే లోక కళ్యాణం కోసం అన్నమాట!"
      },
      {
        "title": ""
      },
      {
        "title": "ఈ మధ్య కూడా శ్రీశైలం దగ్గర జరిగిన హోమం సందర్భంగా ఆకాశంలోంచి పెను పరిమాణంలో పెద్ద శిల నదీ జలాల్లో పడటం, జలాలు తాటి చెట్టు ఎత్తున పైకి లేవటం పేపర్లలో కూడా వచ్చింది."
      },
      {
        "title": ""
      },
      {
        "title": "హోమాల్లో ఎన్నో రకాల సమిధలు వాడవలసి వుంది. ఒక్కో సమిధ ఒక్కో గ్రహానికి సంబంధించినదై వుంటుంది. అంటే అన్ని గ్రహాలూ సమతుల్య స్థితిలో వుంటేనే సృష్టి సక్రమంగా వుంటుంది. అంటే వ్యాధులు లేకపోవటం, వర్షాలు సక్రమంగా పడటం ఇలాంటివి జరుగుతాయి."
      },
      {
        "title": ""
      },
      {
        "title": "ఈ హోమ ఫలాలు వ్యక్తిగతంగా కూడా అందుకునే విధంగా జ్యోతిష్యవేత్తలు కొన్ని సూచనలు చేశారు. ఎవరైనా ఒక వ్యక్తిపై నవగ్రహాలలో ఏదో ఒక గ్రహ ప్రభావం తక్కువగా వుంటే దానికి సంబంధించిన రంగంలో లేదా విషయంలో ఆ వ్యక్తికి వ్యతిరేక ఫలితాలు వస్తాయి. ఏ వ్యక్తి అయితే వ్యతిరేక ఫలితాలను అనుభవిస్తున్నాడో ఆ వ్యక్తి ఇంట్లో హోమం చేయిస్తే చక్కటి ఫలితాలు వస్తాయి."
      },
      {
        "title": ""
      },
      {
        "title": "ఉదాహరణకు రవి(సూర్యుని) గ్రహ ప్రభావం బాగా తగ్గిపోయి, అదే సమయంలో ఇతర గ్రహాలూ కూడా అననుకూలంగా మారితే, ఆ వ్యక్తికి మృత్యువు రావచ్చు లేదా ఆయుష్షు పరంగా తీవ్ర నష్టం జరగవచ్చు. దీనిని నివారించేందుకు రవికి సంబంధించిన ఉపశాంతి చేయమని సూచిస్తారు. తరచుగా హోమాలను ప్రమాద నివారణకు కూడా సూచిస్తారు."
      },
      {
        "title": ""
      },
      {
        "title": "ఈ హోమాలలో రకరకాల మూలికలు వాడతారు. శని గ్రహం అనుకూలత కోసం శమీ వృక్ష సమిధను, రాహువు కోసం గరిక ఉపయోగిస్తే, సూర్యానుగ్రహం కోసం అర్క సమిధను ఉపయోగిస్తారు. కేతు గ్రహ ఉపశాంతికి దర్భను ఉపయోగిస్తారు."
      },
      {
        "title": ""
      },
      {
        "title": "ఆయుర్వేదం ప్రకారం అర్క-లో కుష్టు వ్యాధిని నయం చేసే శక్తి వుంది. శరీరంలో ఉత్పన్నమయ్యే వివిధ రకాల దోషాలను పోగొట్టగలిగే శక్తి ఈ మూలికకు వుంది. అలాగే చంద్ర గ్రహ శాంతి కోసం మోదుగను వాడతారు. అటు వైద్య పరంగా చూస్తే జీర్ణ వ్యవస్థను అద్భుతంగా పునరుజ్జీవింప చేసే శక్తి మోదుగకు వుంది. రక్తాన్ని శుభ్రపరుస్తుంది. రావి చెట్టును గురు గ్రహోపశాంతి కోసం ఉపయోగిస్తారు. ఇది వివిధ కప దోషాలను రూపుమాపుతుందని ఆయుర్వేదంలో వుంది."
      },
      {
        "title": ""
      },
      {
        "title": "ఈ విధంగా చూస్తే హోమం ప్రత్యక్షంగా మన ఆరోగ్యానికి, పరోక్షంగా నవగ్రహాలపై ప్రభావం చూపుతుందని అర్థం అవుతుంది. అయితే, హోమ క్రమం గురించి క్షుణ్ణంగా తెలిసినవారు హోమం చేస్తేనే హోమ ఫలం అందుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>ముఖ్య హోమాలు వాటి ప్రయోజనాలు ఏమిటో గమనిద్దాం :</span>,
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>గణపతి హోమం :-</span>,
      },
      {
        "title": "విఘ్నాలను తొలగించే విఘ్ననాయకుడు గణపతి. మానవులు ప్రారంభించే ప్రతి కార్యాల్లోనూ మొదటగా గణపతిని పూజించడం జరుగుతుంది. ప్రారంభించిన కార్యం ఎటువంటి ఆటంకాలు లేకుండా పూర్తి కావాలని కోరుతూ వినాయకుడిని పూజిస్తారు. జీవితంలో ఎదురయ్యే కష్టాలను, ప్రతికూల అంశాలను తొలగించడానికి వినాయకుడికి గణపతి హోమం నిర్వహిస్తాము. ఈ గణపతి హోమం చేయడం వలన విజయము, ఆరోగ్యము, సంపద కార్య సిద్ధి కలుగుతాయి. హిందూ ధర్మం ప్రకారం ఏ శుభకార్యం చేయాలన్నా మొదటగా గణపతి హోమంతోనే ప్రారంభించడం జరుగుతుంది. ఈ గణపతి హోమానికి అష్ట ద్రవ్యలు/ 8 రకాలు. దర్భ మొదలగునవి ఉపయోగించడం జరుగుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>రుద్ర హోమం :-</span>,
      },
      {
        "title": "పురాణ కథలను అనుసరించి రుద్ర అనునది శివునికి మరొక నామము. శివుడు లేదా రుద్రుని అనుగ్రహం కొరకు చేసే హోమాన్ని రుద్రహోమము అంటారు. ఈ హోమం చేయుట వలన శివుని అనుగ్రహం పొంది తద్వారా అపమృత్యు భయాలు తొలగింపబడి, దీర్ఘకాలిక అనారోగ్య సమస్యల నుండి విముక్తి పొంది శక్తి సంపన్నులు అవుతారు. దీర్ఘాయుష్షుని పొందడం జరుగుతుంది. మృత్యువు మీద విజయాన్ని సాధించడానికి కూడా ఈ రుద్ర హోమం చేస్తారు. ఏ వ్యక్తి అయితే రుద్ర హోమం చేస్తారో ఆ వ్యక్తి యొక్క జన్మ నక్షత్రం ఆధారంగా నిర్ణయించబడిన ముహూర్తానికి రుద్రహోమం జరపబడుతుంది. ఈ రుద్రహోమం అత్యంత శక్తివంతమైనది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>చండీ హోమం :-</span>,
      },
      {
        "title": "హిందూ పురాణాల ప్రకారం అత్యంత శక్తిస్వరూపిణి చండీ. జీవితంలో ఎదురయ్యే కష్టాలను తొలగించడానికి, ఆనందమైన జీవితాన్ని గడపడానికి, సిరిసంపదల కోసం చండి హోమం నిర్వహించడం జరుగుతుంది. చండి హోమం నిర్వహించడం వలన జీవితంలో ఉన్న ప్రతికూల అంశాలన్నీ తొలగిపోతాయి. చండీ హోమం చేసేప్పుడు నవగ్రహాలను ఆవాహన చేసుకొని చేయడం జరుగుతుంది.చండీ హోమాన్ని ఎక్కువగా శుక్రవారం రోజు లేదా అష్టమి, నవములలో చేయడం శ్రేష్టం. సప్తశతిలో ఉన్నటువంటి 13 అధ్యాయాల ప్రకారంగా చండీహోమం చేసేందుకు 13 రకాల విభిన్నమైన పదార్థాలను వాడడం జరుగుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>చండీహోమం విశిష్టత :</span>,
      },
      {
        "title": "చండీహోమం కేవలం ఒక వర్ణం కో ఒక వర్గం కో మాత్రమే కాదు. అన్ని వర్ణాల వారికి సంబంధించినది.చండీ ఆరాధన కలకత్తా దగ్గరలోని గిరిజన జాతులవారు ప్రారంభించారని పెద్దలు చెప్పియున్నారు, వారి వద్ధనుండే చండీహోమం ఆరాధన, హోమం బయల్పడినాయి. కాలక్రమేణా బ్రాహ్మణులు, పండితులు కూడా చండీహోమం చేయనారంభించారు."
      },
      {
        "title": ""
      },
      {
        "title": "లక్ష్మీ, సరస్వతీ, కాళికాదేవి, ఈ ముగ్గరు శక్తుల కలయికతో ఏర్పడినదే మహాచండీ. ఈమె హోమం చేయడంవల్ల సమస్త బాధలు నివారణమవుతాయి.వ్యాపారాలు వృద్ధి చెందుతాయి, శత్రువులు నశిస్తారు, పరప్రయోగాలతో బాధపడేవారు, తరచుగా కుటుంబంలో మరణాలు సంభవిస్తున్నవారు, అకారణంగా కోర్టు కేసులలో ఇరుక్కుంటున్నవారు, ఇంకేమైనా ఇతరత్రా సమస్యలతో బాధపడతున్నవారు చండీహోమాన్ని చేయించుకోవడం వల్ల చండీమాత అనుగ్రహంతో త్వరితగతిని, వాటి నుండి బయటపడతారు."
      },
      {
        "title": ""
      },
      {
        "title": "చండీమాత ఉగ్రరూపమే కాళికామాత, ఈమె శాంతరూపంలో మంగళచండి, సంకటచండీ, రణచండీ, ఓరైచండీ గా పూజలందుకుంటారు. చండీ హోమము ఎందుకు చేయాలి. అమ్మ ఆది పరాశక్తి అని తెలిసిన విషయమే, చండీ మాత ఓ ప్రచండ శక్తి. భూగ్రహంపై మాత్రమే కాకుండా విశ్వాంతరాళాలని అంటిపెట్టుకునే ఉంటుంది. సృష్టి జరగడానికి, అది వృద్ధి చెందడానికి, తిరిగి లయం కావడానికి, అవసరమైన శక్తి అంతా ఆమెలోనే ఉంది. ఆమె ఆదిశక్తి, పరాశక్తి, జ్ఞానశక్తి, ఇచ్చాశక్తి, క్రియాశక్తి, కుండలినీ శక్తి. అందుకే ఆమెకు అంత ప్రాధాన్యం."
      },
      {
        "title": ""
      },
      {
        "title": "లోక రక్షకులైన అమ్మవారి స్వరూపాల్లో చండీ ఒకటి. లోక కల్యాణం కోసం, విశేష కార్యసిద్ధి కోసం, సకల చరాచర జగత్తు సృష్టికి, స్థితికి, లయకు మూల కారణమైన జగన్మాతను ఆరాధించడం అనాదిగా వస్తోంది. ఆదితత్త్వాన్ని నేత్రమూర్తిగా భావించి చేసే ప్రకృతి ఉపాసనే శ్రీవిద్య. అది లలితా పారాయణం, చండీ పారాయణం అని రెండు రకాలు. బ్రహ్మాండ పురాణం, దేవీ భాగవతం, లలితాదేవి మహిమలను చెబితే, మార్కండేయ పురాణం చండీ మహత్మ్యాన్ని వివరిస్తుంది."
      },
      {
        "title": ""
      },
      {
        "title": "చండీ లేదా దుర్గాదేవి విజయాలను వివరించడంతో పాటు బ్రహ్మాది దేవతలు ఆమె వైభవాన్ని కీర్తించే శక్తిమంతమైన మంత్రాల కదంబమే చండీ లేదా దుర్గా సప్తశతి. చండీ హోమం లో ఉన్న మంత్రాలు, అధ్యాయాలు. చండీ సప్తశతిలో 700 మంత్రాలు ఉంటాయని ప్రతీతి. అయితే, ఇందులో ఉన్న మంత్రాలు 578 మాత్రమే. ఉవాచ మంత్రాలు, అర్థశ్లోక, త్రిపాద శ్లోక మంత్రాలతో కలిపి మొత్తం 700 మంత్రాలయ్యాయి."
      },
      {
        "title": ""
      },
      {
        "title": "బ్రాహ్మీ, నందజా, రక్తదంతికా, శాకంబరీ, దుర్గా, భీమా, భ్రామరీ అనే ఏడుగురు దేవతామూర్తులకు సప్తసతులు అని పేరు. వారి మహత్య్మ వర్ణనతో కూడిన మంత్రాలు కాబట్టి దీనికి చండీ సప్తసతి అనే పేరు వచ్చింది. ఇది శాక్తేయ హోమం కనక నిష్ఠగా చేయాల్సి ఉంటుంది."
      },
      {
        "title": ""
      },
      {
        "title": "దుర్గ లేదా చండీ సప్తశతి మూడు చరిత్రలుగా, 13 అధ్యాయాలుగా ఉంటుంది. తొలి భాగంలో ఒకే ఒక అధ్యాయం ఉంటుంది. రెండో భాగంలో మూడు అధ్యాయాలు, మూడో భాగంలో తొమ్మిది అధ్యాయాలు ఉన్నాయి. వీటిలో మధుకైటభ వర్ణన, మహిషాసుర సంహారం, శుంభనిశుంభుల వధతోపాటు బ్రహ్మాది దేవతలు చేసిన పవిత్ర దేవీ స్తోత్రాలు ఉంటాయి. సప్తశతిని మూడు పద్ధతుల్లో ఆచరిస్తారు"
      },
      {
        "title": ""
      },
      {
        "title": "పూజ, పారాయణ, హోమం."
      },
      {
        "title": "ఈ మూడు పద్ధతుల్లో జగన్మాతను ప్రసన్నం చేసుకుంటారు. పారాయణలో దశాంశం హోమం, దశాంశం తర్పణం ఇస్తారు."
      },
      {
        "title": "చండీ హోమానికి సంబంధించి"
      },
      {
        "title": "నవ చండీ యాగం, శత చండీ యాగం, సహస్ర చండీ యాగం, అయుత (పది వేలు) చండీ యాగం, నియుత (లక్ష) చండీ యాగం, ప్రయుత (పది లక్షలు) చండీ యాగం ఉంటాయి. కలియుగంలో చండీ పారాయణకు మించిన శక్తిమంతమైన ఫలసాధనం మరొకటి లేదని శాస్త్రవచనం. ఇహపర సాధనకు చండీ హోమం ఉత్తమం. ఏడు వందల మంత్రాలతో కూడిన చండీ సప్తశతిని పారాయణ చేసి, హోమం నిర్వహించడమే చండీ హోమం. దేశోపద్రవాలు శాంతించడానికి, గ్రహాల అనుకూలతకు, భయభీతులు పోవడానికి, శత్రు సంహారానికి, శత్రువులపై విజయం సాధించడానికి తదితర కారణాలతో చండీ యాగం చేస్తారు. వీటిలో నవ చండీ యాగం చేస్తే వాజపేయం చేసినంత ఫలం వస్తుందట."
      },
      {
        "title": ""
      },
      {
        "title": "ఏకాదశ చండి చేస్తే రాజు వశమవుతాడని, ద్వాదశ చండి చేస్తే శత్రు నాశనమని, మను చండి (చతుర్దశ చండి)తో శత్రువు వశమవుతాడని మార్కండేయ పురాణం చెప్పినట్లు శాంతి కమలాకరంలో ఉంది."
      },
      {
        "title": ""
      },
      {
        "title": "ఇక, శత చండి చేస్తే కష్టాలు, వైద్యానికి లొంగని అనారోగ్యం, ధన నష్టం తదితరాలు తొలగుతాయి. సహస్ర చండితో లక్ష్మీదేవి వరిస్తుంది. కోరికలు నెరవేరతాయి. లక్ష చండి చేస్తే చక్రవర్తి అవుతాడని మార్కండేయ పురాణంలో ఉంది. దీనినే నియుత చండి అంటారు."
      },
      {
        "title": "ప్రయుత చండి అంటే పది లక్షల చండీ సప్తశతి పారాయణాలు"
      },
      {
        "title": ""
      },
      {
        "title": "|| ఓం శ్రీ మాత్రే నమః ||"
      },
      {
        "title": "|| ఓం నమః శివాయ ||"
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>గరుడ హోమం :-</span>,
      },
      {
        "title": "మానవుని శరీరాకృతి, గరుడుని ముఖము కలిగి శ్రీమహావిష్ణువు వాహనంగా పిలువబడే దైవ స్వరూపమే గరుడుడు. గరుడుడు అనంతమైన శక్తికి, జ్ఞానానికి స్వరూపం. గరుడార్, గరుడ భగవాన్ అని పిలిచుకొనే గరుడుడికి చేసే హోమమే గరుడ హోమం. సరైన విధివిధానాలతో కనుక గరుడ హోమం చేసినట్లయితే ఆకర్షణ శక్తి పెరగడం అలాగే అనేక విషయాల పట్ల, వ్యక్తుల పట్ల ఆధిపత్యాన్ని సాధించడం, శత్రువుల మీద విజయం, ప్రమాదాల నుంచి రక్షించబడడం, అన్ని శారీరక, మానసిక వ్యాధుల నుంచి ఉపశమనం మొదలగునవి లభిస్తాయి. అంతేకాకుండా ఈ గరుడ హోమం చేయడం వలన జ్ఞానము అలాగే జ్ఞాపకశక్తి వృద్ధి జరుగుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>సుదర్శన హోమం :-</span>,
      },
      {
        "title": "శ్రీమహావిష్ణుకు చెందిన అత్యంత శక్తివంతమైన ఆయుధమే సుదర్శన చక్రం.హిందూ పురాణాల ప్రకారం ఈ ఆయుధం చాలా శక్తివంతమైన ఆయుధం అవ్వడమే కాకుండా దైవిక శక్తి కలిగి ఉండి దుష్టశక్తులను సంహరిస్తుంది. మానవుని జీవితంలో లేదా కుటుంబంలో జరుగుతున్న ప్రతికూల అంశాలకు కారణమైన దుష్టశక్తుల నుండి రక్షింపబడడానికి, నరదృష్టి తొలగించడానికి ఈ సుదర్శన హోమం చేయడం జరుగుతుంది. ముఖ్యంగా గృహ ప్రవేశ సమయంలో మరియు మిగిలిన శుభకార్యాల సమయంలో కూడా సుదర్శన హోమం నిర్వహించబడుతుంది. హోమాగ్నికి అష్ట ద్రవ్యాలను సమర్పిస్తూ అత్యంత పవిత్రమైన సుదర్శన మంత్రాన్ని జపిస్తూ ఈ హోమం చేయడం జరుగుతుంది. మానవుని జన్మ నక్షత్రం ఆధారంగా నిర్ణయింపబడిన ముహూర్తాన్ని అనుసరించి ఈ హోమం చేయడం జరుగుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>మన్యుసూక్త హోమం :-</span>,
      },
      {
        "title": "వేదాల ననుసరించి మాన్యు అనగా ఆగ్రహం అని, లేదా మరొక అర్థం లో తీవ్రమైన భావావేశము అని చెప్పబడుతుంది.మాన్యు దేవుడి ఆశీస్సుల కోసం చేసే హోమము మన్యుసూక్త పాశుపత హోమం. ఈ హోమాన్ని ప్రధానంగా శత్రు సంహారం కోసం చేయడం జరుగుతుంది. కోర్టు కేసుల లాంటి దీర్ఘకాలిక సమస్యల నుండి విముక్తి కోసం కూడా ఈ హోమాన్ని చేస్తారు. ఈ హోమాన్ని శనివారం చేయడం ద్వారా ఉత్తమమైన ఫలితాలు పొందడం జరుగుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>లక్ష్మీ కుబేర పాశుపతహోమం :-</span>,
      },
      {
        "title": "హిందూ ధర్మానుసారంగా సంపదకి దేవతలుగా లక్ష్మీ దేవిని, కుబేరున్ని పూజిస్తాము.జీవితంలో ఆర్థికంగా కష్టాలను ఎదుర్కొంటున్న వారికోసం సూచింపబడేదే లక్ష్మి కుబేర పాశుపతహోమం.జీవితంలో ఆర్థిక వృద్ధి, సిరి సంపదల కొరకు లక్ష్మీదేవిని అలాగే కుబేరుడిని కూడా ఈ హోమంలో పూజించడం జరుగుతుంది. ప్రధానంగా ఈ హోమాన్ని శుక్రవారం రోజున చేయడం శ్రేష్టం. ఎందుకనగా శుక్రవారాన్ని లక్ష్మీ వా పరిగణిస్తాము కనుక. హోమం చేసుకునే వ్యక్తి యొక్క జన్మ నక్షత్రాన్ని అనుసరించి నిర్ణయించబడిన ముహూర్తానికి ఈ హోమం చేయబడును. ఈ హోమం చేయడానికి కమలాలని వాడడం జరుగుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>మృత్యుంజయ పాశుపత హోమం :-</span>,
      },
      {
        "title": "మరణం నుంచి విజయాన్ని పొందడమే మృత్యుంజయం.పేరులో ఉన్నట్టుగానే మృత్యువుపైన విజయాన్ని సాధించడం కోసం మృత్యుంజయ పాశుపత హోమం నిర్వహిస్తారు. ప్రాణ హాని అలాగే తీవ్రమైన అనారోగ్య సమస్యల నుండి విముక్తి పొందడం కోసం ఈ హోమం చేయడం జరుగుతుంది. దుష్టశక్తులను అదుపుచేసి, సంహరించే భూత నాథుడిగా పిలవబడే ఆ శివుడిని ప్రసన్నం చేసుకోవడం కోసం చేసే హోమం చేస్తారు.ఈ హోమం చేసుకునేవారు హోమానికి సంబంధించిన మంత్రాన్ని 21సార్లు జపించవలసి ఉంటుంది. ఈ హోమం చేయడానికి కావాల్సిన ప్రధాన వస్తువులు. దర్భ, అమృత మూలిక. దీర్ఘాయుష్షును కోరుతూ హోమము చేసే వారి జన్మదినం రోజున ఈ హోమాన్ని నిర్వహిస్తారు."
      },
      {
        "title": ""
      },
      {
        "title": <span class='highlight'>నవదుర్గ పాశుపత హోమం :-</span>,
      },
      {
        "title": "భక్తుల చేత దుర్గామాత నవదుర్గగా పూజింప బడుతుంది. జట దుర్గ, శాంతి దుర్గ, శూలిని దుర్గ,శబరి దుర్గ,లవణ దుర్గ,అసురి దుర్గ, దీప దుర్గా, వన దుర్గ, మరియు జ్వాలా దుర్గ. దుర్గామాతయొక్క ఈ తొమ్మిది రూపాలను పూజించడానికి చేసే హోమమే ఈ నవదుర్గ పాశుపత హోమం.ఈ హోమం చేయడం వలన దుష్ట శక్తుల నుంచి విముక్తి, శాంతి,సంపద, ఆరోగ్యం, ఆయుష్యు, సంతానం, విద్య మొదలైనవి లభించి ప్రతికూలమైన ఆలోచనలు, ప్రతికూలమైన అంశాలను నుండి విముక్తి కలిగుతుంది."
      }
    ],
    "title": "హోమం విశిష్టత"
  },
  "matchingnakshatra":
    [
      {
        "Nakshatraname": "అశ్విని",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "ఆశ్లేష"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "ఉత్తరాషాఢ"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "భరణి",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "ఆశ్లేష"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "ఉత్తర"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "విశాఖ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "ఉత్తరాషాఢ"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "కృత్తిక",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "భరణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          }
        ]
      },
      {
        "Nakshatraname": "రోహిణి",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "ఉత్తర"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "మృగశిర",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "ఉత్తర"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "పూర్వాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "ఆరుద్ర",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          }
        ]
      },
      {
        "Nakshatraname": "పునర్వసు",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "పుష్యమి",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "ఆశ్లేష"
          },
          {
            "title": "ఉత్తర"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "విశాఖ"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "ఉత్తరాషాఢ 2,3,4 పా।। "
          },
          {
            "title": "పూర్వాభాద్ర 4 పా।।"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "ఆశ్లేష",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "భరణి"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          }
        ]
      },
      {
        "Nakshatraname": "మఖ",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "భరణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "ధనిష్ఠ 3,4 పా।।"
          },
          {
            "title": "శతభిషం"
          },
        ]
      },
      {
        "Nakshatraname": "పుబ్బ",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "ఉత్తర"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "విశాఖ"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "ఉత్తరాషాఢ"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "ఉత్తర",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          }
        ]
      },
      {
        "Nakshatraname": "హస్త",
        "MatchingNakshtra": [
          {
            "title": "రోహిణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "ఆశ్లేష"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "ఉత్తరాషాఢ"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "చిత్త",
        "MatchingNakshtra": [
          {
            "title": "కృత్తిక"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "ఆశ్లేష"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "విశాఖ"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "శతభిషం"
          }
        ]
      },
      {
        "Nakshatraname": "స్వాతి",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "పూర్వాభాద్ర"
          }
        ]
      },
      {
        "Nakshatraname": "విశాఖ",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "పూర్వాభాద్ర 1,2,3 పా।।"
          }
        ]
      },
      {
        "Nakshatraname": "అనూరాధ",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "ఆశ్లేష"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "ఉత్తర"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "ఉత్తరాషాఢ"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "పూర్వాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "జ్యేష్ఠ",
        "MatchingNakshtra": [
          {
            "title": "రోహిణి"
          },
          {
            "title": "మృగశిర 1,2 పా।।"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "ఆశ్లేష"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "చిత్త 3,4 పా।।"
          },
          {
            "title": "విశాఖ 1,2,3 పా।।"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          },
          {
            "title": "రేవతి"
          },
        ]
      },
      {
        "Nakshatraname": "మూల",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "పూర్వాషాఢ",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "ఉత్తర"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "విశాఖ"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "ఉత్తరాషాఢ"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "పూర్వాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "ఉత్తరాషాఢ",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "భరణి"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "పూర్వాభాద్ర"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          }
        ]
      },
      {
        "Nakshatraname": "శ్రవణం",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "మృగశిర 1,2 పా।।"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "ఉత్తర 2,3,4 పా।।"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "ధనిష్ఠ",
        "MatchingNakshtra": [
          {
            "title": "కృత్తిక"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "విశాఖ"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "పూర్వాభాద్ర"
          }
        ]
      },
      {
        "Nakshatraname": "శతభిషం",
        "MatchingNakshtra": [
          {
            "title": "భరణి"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "మఖ"
          },
          {
            "title": "చిత్త"
          },
          {
            "title": "విశాఖ"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "ధనిష్ఠ"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          }
        ]
      },
      {
        "Nakshatraname": "పూర్వాభాద్ర",
        "MatchingNakshtra": [
          {
            "title": "మృగశిర"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "పుబ్బ"
          },
          {
            "title": "స్వాతి"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "ఉత్తరాషాఢ"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          }
        ]
      },
      {
        "Nakshatraname": "ఉత్తరాభాద్ర",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "కృత్తిక"
          },
          {
            "title": "రోహిణి"
          },
          {
            "title": "ఆరుద్ర"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "ఆశ్లేష"
          },
          {
            "title": "ఉత్తర"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "ఉత్తరాషాఢ"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "శతభిషం"
          },
          {
            "title": "పూర్వాభాద్ర"
          },
          {
            "title": "రేవతి"
          }
        ]
      },
      {
        "Nakshatraname": "రేవతి",
        "MatchingNakshtra": [
          {
            "title": "అశ్విని"
          },
          {
            "title": "భరణి"
          },
          {
            "title": "మృగశిర"
          },
          {
            "title": "పునర్వసు"
          },
          {
            "title": "పుష్యమి"
          },
          {
            "title": "హస్త"
          },
          {
            "title": "అనూరాధ"
          },
          {
            "title": "జ్యేష్ఠ"
          },
          {
            "title": "మూల"
          },
          {
            "title": "పూర్వాషాఢ"
          },
          {
            "title": "శ్రవణం"
          },
          {
            "title": "ఉత్తరాభాద్ర"
          }
        ]
      }
    ],
    upavasamDates: [
      [
        {
          Amavas: "గురువారము జనవరి 11",
          Chatur: "సోమవారము జనవరి 29",
          Ekadas: "ఆదివారము జనవరి 7, ఆదివారము జనవరి 21",
          Purnim: "గురువారము జనవరి 25",
          Prados: "మంగళవారము జనవరి 09, మంగళవారము జనవరి 23",
          Shast: "మంగళవారము జనవరి 02, మంగళవారము జనవరి 16",
          Chavith: "సోమవారము జనవరి 15, సోమవారము జనవరి 29",
          MasaShivarat: "మంగళవారము జనవరి 10",
          data: {
            Amavasya: "11",
            Chaturthi: "29",
            Ekadasi: "7,21",
            Purni: "25",
            Pradosham: "09,23",
            sasti: "02,16",
            Chavi: "15,29",
            Masa: "10",
          },
        },
        {
          Amavas: "శుక్రవారము ఫిబ్రవరి 09",
          Ekadas: "మంగళవారము ఫిబ్రవరి 06, మంగళవారము ఫిబ్రవరి 20",
          Chatur: "బుధవారము ఫిబ్రవరి 28",
          Purnim: "శనివారము ఫిబ్రవరి 24",
          Prados: "బుధవారము ఫిబ్రవరి 07, బుధవారము ఫిబ్రవరి 21",
          Shast: "గురువారము ఫిబ్రవరి 01, గురువారము ఫిబ్రవరి 15",
          Chavith: "మంగళవారము ఫిబ్రవరి 13, బుధవారము ఫిబ్రవరి 28",
          MasaShivarat: "గురువారము ఫిబ్రవరి 08",
          data: {
            Amavasya: "09",
            Ekadasi: "06,20",
            Chaturthi: "28",
            Purni: "24",
            Pradosham: "07,21",
            sasti: "01,15",
            Chavi: "13,28",
            Masa: "08",
          },
        },
        {
          Amavas: "ఆదివారము మార్చి 10",
          Chatur: "గురువారము మార్చి 28",
          Ekadas: "బుధవారము మార్చి 06, బుధవారము మార్చి 20",
          MasaShivarat: "శుక్రవారము మార్చి 08",
          Purnim: "సోమవారము మార్చి 25",
          Prados: "శుక్రవారము మార్చి 08, శుక్రవారము మార్చి 22",
          Shast: "శుక్రవారము మార్చి 01, శుక్రవారము మార్చి 15",
          Chavith: "బుధవారము మార్చి 13, శుక్రవారము మార్చి 29",
          data: {
            Amavasya: "10",
            Chaturthi: "28",
            Ekadasi: "06,20",
            Masa: "08",
            Purni: "25",
            Pradosham: "08,22",
            sasti: "01,15",
            Chavi: "13,29",
          },
        },
        {
          Amavas: "సోమవారము ఏప్రిల్ 08",
          Ekadas: "శుక్రవారము ఏప్రిల్ 05, శుక్రవారము ఏప్రిల్ 19",
          MasaShivarat: "ఆదివారము ఏప్రిల్ 07",
          Purnim: "మంగళవారము ఏప్రిల్ 23",
          Chatur: "శనివారము ఏప్రిల్ 27",
          Prados: "శనివారము ఏప్రిల్ 06, ఆదివారము ఏప్రిల్ 21",
          Shast: "ఆదివారము ఏప్రిల్ 14, సోమవారము ఏప్రిల్ 29",
          Chavith: "శుక్రవారము ఏప్రిల్ 12, ఆదివారము ఏప్రిల్ 28",
          data: {
            Amavasya: "08",
            Ekadasi: "05,19",
            Masa: "07",
            Purni: "23",
            Chaturthi: "27",
            Pradosham: "06,21",
            sasti: "14,29",
            Chavi: "12,28",
          },
        },
        {
          Amavas: "బుధవారము మే 08",
          Ekadas: "శనివారము మే 04, ఆదివారము మే 19",
          MasaShivarat: "సోమవారము మే 06",
          Purnim: "గురువారము మే 23",
          Chatur: "ఆదివారము మే 26",
          Prados: "ఆదివారము మే 05, సోమవారము మే 20",
          Shast: "సోమవారము మే 13, బుధవారము మే 29",
          Chavith: "శనివారము మే 11, సోమవారము మే 27",
          data: {
            Amavasya: "08",
            Ekadasi: "04,19",
            Masa: "06",
            Purni: "23",
            Chaturthi: "26",
            Pradosham: "05,20",
            sasti: "13,29",
            Chavi: "11,27",
          },
        },
        {
          Amavas: "గురువారము జూన్ 06",
          Ekadas: "ఆదివారము జూన్ 02, సోమవారము జూన్ 17",
          MasaShivarat: "బుధవారము జూన్ 05",
          Purnim: "శనివారము జూన్ 22",
          Chatur: "మంగళవారము జూన్ 25",
          Prados: "మంగళవారము జూన్ 04, బుధవారము జూన్ 19",
          Shast: "బుధవారము జూన్ 12, గురువారము జూన్ 27",
          Chavith: "సోమవారము జూన్ 10, మంగళవారము జూన్ 25",
          data: {
            Amavasya: "06",
            Ekadasi: "02,17",
            Masa: "05",
            Purni: "22",
            Chaturthi: "25",
            Pradosham: "04,19",
            sasti: "12,27",
            Chavi: "10,25",
          },
        },
        {
          Amavas: "శుక్రవారము జూలై 05",
          Ekadas: "మంగళవారము జూలై 02, బుధవారము జూలై 17, బుధవారము జూలై 31",
          MasaShivarat: "గురువారము జూలై 04",
          Purnim: "ఆదివారము జూలై 21",
          Chatur: "బుధవారము జూలై 24",
          Prados: "బుధవారము జూలై 03, శుక్రవారము జూలై 19",
          Shast: "శుక్రవారము జూలై 12, శుక్రవారము జూలై 26",
          Chavith: "మంగళవారము జూలై 09, గురువారము జూలై 25",
          data: {
            Amavasya: "05",
            Ekadasi: "02,17,31",
            Masa: "04",
            Purni: "21",
            Chaturthi: "24",
            Pradosham: "03,19",
            sasti: "12,26",
            Chavi: "09,25",
          },
        },
        {
          Amavas: "ఆదివారము ఆగష్టు 04",
          Ekadas: "గురువారము ఆగష్టు 15, గురువారము ఆగష్టు 29",
          MasaShivarat: "శుక్రవారము ఆగష్టు 02, శనివారము ఆగష్టు 31",
          Purnim: "సోమవారము ఆగష్టు 19",
          Chatur: "గురువారము ఆగష్టు 22",
          Prados: "గురువారము ఆగష్టు 01, శనివారము ఆగష్టు 17, శనివారము ఆగష్టు 31",
          Shast: "శనివారము ఆగష్టు 10, శనివారము ఆగష్టు 24",
          Chavith: "గురువారము ఆగష్టు 08, శుక్రవారము ఆగష్టు 23",
          data: {
            Amavasya: "04",
            Ekadasi: "15,29",
            Masa: "02,31",
            Purni: "19",
            Chaturthi: "22",
            Pradosham: "01,17,31",
            sasti: "10,24",
            Chavi: "08,23",
          },
        },
        {
          Amavas: "సోమవారము సెప్టెంబర్ 02",
          Ekadas: "శనివారము సెప్టెంబర్ 14, శనివారము సెప్టెంబర్ 28",
          MasaShivarat: " - ",
          Purnim: "బుధవారము సెప్టెంబర్ 18",
          Chatur: "శనివారము సెప్టెంబర్ 21",
          Prados: "ఆదివారము సెప్టెంబర్ 15, ఆదివారము సెప్టెంబర్ 29",
          Shast: "సోమవారము సెప్టెంబర్ 09, సోమవారము సెప్టెంబర్ 23",
          Chavith: "శనివారము సెప్టెంబర్ 07, శనివారము సెప్టెంబర్ 21",
          data: {
            Amavasya: "02",
            Ekadasi: "14,28",
            Masa: "",
            Purni: "18",
            Chaturthi: "21",
            Pradosham: "15,29",
            sasti: "09,23",
            Chavi: "07,21",
          },
        },
        {
          Amavas: "బుధవారము అక్టోబర్ 02",
          Ekadas: "ఆదివారము అక్టోబర్ 13, సోమవారము అక్టోబర్ 28",
          MasaShivarat: "మంగళవారము అక్టోబర్ 01, బుధవారము అక్టోబర్ 30",
          Purnim: "గురువారము అక్టోబర్ 17",
          Chatur: "ఆదివారము అక్టోబర్ 20",
          Prados: "మంగళవారము అక్టోబర్ 15, మంగళవారము అక్టోబర్ 29",
          Shast: "బుధవారము అక్టోబర్ 09, బుధవారము అక్టోబర్ 23",
          Chavith: "ఆదివారము అక్టోబర్ 6,సోమవారము అక్టోబర్ 21",
          data: {
            Amavasya: "02",
            Ekadasi: "13,28",
            Masa: "01,30",
            Purni: "17",
            Chaturthi: "20",
            Pradosham: "15,29",
            sasti: "09,23",
            Chavi: "06,21",
          },
        },
        {
          Amavas: "శుక్రవారము నవంబర్ 01",
          Ekadas: "మంగళవారము నవంబర్ 12, మంగళవారము నవంబర్ 26",
          MasaShivarat: "శుక్రవారము నవంబర్ 29",
          Purnim: "శుక్రవారము నవంబర్ 15",
          Chatur: "మంగళవారము నవంబర్ 19",
          Prados: "బుధవారము నవంబర్ 13, గురువారము నవంబర్ 28",
          Shast: "గురువారము నవంబర్ 07, గురువారము నవంబర్ 21",
          Chavith: "మంగళవారము నవంబర్ 05, మంగళవారము నవంబర్ 19",
          data: {
            Amavasya: "01",
            Ekadasi: "12,26",
            Masa: "29",
            Purni: "15",
            Chaturthi: "19",
            Pradosham: "13,28",
            sasti: "07,21",
            Chavi: "05,19",
          },
        },
        {
          Amavas: "ఆదివారము డిసెంబర్ 01, సోమవారము డిసెంబర్ 30",
          Ekadas: "బుధవారము డిసెంబర్ 11, గురువారము డిసెంబర్ 26",
          MasaShivarat: "ఆదివారము డిసెంబర్ 29",
          Purnim: "ఆదివారము, డిసెంబర్ 15",
          Chatur: "బుధవారము డిసెంబర్ 18",
          Prados: "శుక్రవారము డిసెంబర్ 13, శనివారము డిసెంబర్ 28",
          Shast: "శనివారము డిసెంబర్ 07, శనివారము డిసెంబర్ 21",
          Chavith: "గురువారము డిసెంబర్ 05, గురువారము డిసెంబర్ 19",
          data: {
            Amavasya: "01,30",
            Ekadasi: "11,26",
            Masa: "29",
            Purni: "15",
            Chaturthi: "18",
            Pradosham: "13,28",
            sasti: "07,21",
            Chavi: "05,19",
          },
        },
      ],
      [
        {
          Amavas: "బుధవారము జనవరి 29",
          Chatur: "శుక్రవారము జనవరి 17",
          Ekadas: "శుక్రవారము జనవరి 10, శనివారము జనవరి 25",
          Purnim: "సోమవారము, జనవరి 13",
          Prados: "శనివారము జనవరి 11, సోమవారము జనవరి 27",
          Shast: "ఆదివారము జనవరి 05, సోమవారము జనవరి 20",
          Chavith: "శుక్రవారము జనవరి 03, శుక్రవారము జనవరి 17",
          MasaShivarat: "మంగళవారము జనవరి 28",
          data: {
            Amavasya: "29",
            Chaturthi: "17",
            Ekadasi: "10,25",
            Purni: "13",
            Pradosham: "11,27",
            sasti: "05,20",
            Chavi: "03,17",
            Masa: "28",
          },
        },
        {
          Amavas: "గురువారము ఫిబ్రవరి 27",
          Ekadas: "శనివారము ఫిబ్రవరి 08, సోమవారము ఫిబ్రవరి 24",
          Chatur: "ఆదివారము ఫిబ్రవరి 16",
          Purnim: "బుధవారము, ఫిబ్రవరి 12",
          Prados: "సోమవారము ఫిబ్రవరి 10, మంగళవారము ఫిబ్రవరి 25",
          Shast: "సోమవారము ఫిబ్రవరి 03, మంగళవారము ఫిబ్రవరి 18",
          Chavith: "ఆదివారము ఫిబ్రవరి 02, ఆదివారము ఫిబ్రవరి 16",
          MasaShivarat: "బుధవారము ఫిబ్రవరి 26",
          data: {
            Amavasya: "27",
            Ekadasi: "08,24",
            Chaturthi: "16",
            Purni: "12",
            Pradosham: "10,25",
            sasti: "03,18",
            Chavi: "02,16",
            Masa: "26",
          },
        },
        {
          Amavas: "శనివారము మార్చి 29",
          Chatur: "సోమవారము మార్చి 17",
          Ekadas: "సోమవారము మార్చి 10, మంగళవారము మార్చి 25",
          MasaShivarat: "శుక్రవారము మార్చి 28",
          Purnim: "శుక్రవారము, మార్చి 14",
          Prados: "మంగళవారము మార్చి 11, గురువారము మార్చి 27",
          Shast: "బుధవారము మార్చి 05, గురువారము మార్చి 20",
          Chavith: "సోమవారము మార్చి 03, మంగళవారము మార్చి 18",
          data: {
            Amavasya: "29",
            Chaturthi: "17",
            Ekadasi: "10,25",
            Masa: "28",
            Purni: "14",
            Pradosham: "11,27",
            sasti: "05,20",
            Chavi: "03,18",
          },
        },
        {
          Amavas: "ఆదివారము ఏప్రిల్ 27",
          Ekadas: "మంగళవారము ఏప్రిల్ 08, గురువారము ఏప్రిల్ 24",
          MasaShivarat: "శనివారము ఏప్రిల్ 26",
          Purnim: "శనివారము, ఏప్రిల్ 12",
          Chatur: "బుధవారము ఏప్రిల్ 16",
          Prados: "గురువారము ఏప్రిల్ 10, శుక్రవారము ఏప్రిల్ 25",
          Shast: "గురువారము ఏప్రిల్ 03, శనివారము ఏప్రిల్ 19",
          Chavith: "మంగళవారము ఏప్రిల్ 01, గురువారము ఏప్రిల్ 17",
          data: {
            Amavasya: "27",
            Ekadasi: "08,24",
            Masa: "26",
            Purni: "12",
            Chaturthi: "16",
            Pradosham: "10,25",
            sasti: "03,19",
            Chavi: "01,17",
          },
        },
        {
          Amavas: "మంగళవారము మే 27",
          Ekadas: "గురువారము మే 08, శుక్రవారము మే 23",
          MasaShivarat: "ఆదివారము మే 25",
          Purnim: "సోమవారము మే 12",
          Chatur: "శుక్రవారము మే 16",
          Prados: "శనివారము మే 10, శనివారము మే 24",
          Shast: "శనివారము మే 03, ఆదివారము మే 18",
          Chavith: "గురువారము మే 01, శుక్రవారము మే 16, శుక్రవారము మే 30",
          data: {
            Amavasya: "27",
            Ekadasi: "08,23",
            Masa: "25",
            Purni: "12",
            Chaturthi: "16",
            Pradosham: "10,24",
            sasti: "03,18",
            Chavi: "01,16,30",
          },
        },
        {
          Amavas: "బుధవారము జూన్ 25",
          Ekadas: "శుక్రవారము జూన్ 06, శనివారము జూన్ 21",
          MasaShivarat: "మంగళవారము జూన్ 24",
          Purnim: "బుధవారము జూన్ 11",
          Chatur: "శనివారము జూన్ 14",
          Prados: "ఆదివారము జూన్ 08, సోమవారము జూన్ 23",
          Shast: "ఆదివారము జూన్ 01, మంగళవారము జూన్ 17",
          Chavith: "ఆదివారము జూన్ 15, ఆదివారము జూన్ 29",
          data: {
            Amavasya: "25",
            Ekadasi: "06,21",
            Masa: "24",
            Purni: "11",
            Chaturthi: "14",
            Pradosham: "08,23",
            sasti: "01,17",
            Chavi: "15,29",
          },
        },
        {
          Amavas: "గురువారము జూలై 24",
          Ekadas: "ఆదివారము జూలై 06, సోమవారము జూలై 21",
          MasaShivarat: "బుధవారము జూలై 23",
          Purnim: "గురువారము జూలై 10",
          Chatur: "సోమవారము జూలై 14",
          Prados: "మంగళవారము జూలై 08, మంగళవారము జూలై 22",
          Shast: "మంగళవారము జూలై 01, బుధవారము జూలై 16, బుధవారము జూలై 30",
          Chavith: "సోమవారము జూలై 14, సోమవారము జూలై 28",
          data: {
            Amavasya: "24",
            Ekadasi: "06,21",
            Masa: "23",
            Purni: "10",
            Chaturthi: "14",
            Pradosham: "08,22",
            sasti: "01,16,30",
            Chavi: "14,28",
          },
        },
        {
          Amavas: "శనివారము ఆగష్టు 23",
          Ekadas: "మంగళవారము ఆగష్టు 05, మంగళవారము ఆగష్టు 19",
          MasaShivarat: "గురువారము ఆగష్టు 21",
          Purnim: "శనివారము ఆగష్టు 09",
          Chatur: "మంగళవారము ఆగష్టు 12",
          Prados: "బుధవారము ఆగష్టు 06, బుధవారము ఆగష్టు 20",
          Shast: "గురువారము ఆగష్టు 14, శుక్రవారము ఆగష్టు 29",
          Chavith: "బుధవారము ఆగష్టు 13, బుధవారము ఆగష్టు 27",
          data: {
            Amavasya: "23",
            Ekadasi: "05,19",
            Masa: "21",
            Purni: "09",
            Chaturthi: "12",
            Pradosham: "06,20",
            sasti: "14,29",
            Chavi: "13,27",
          },
        },
        {
          Amavas: "ఆదివారము సెప్టెంబర్ 21",
          Ekadas: "బుధవారము సెప్టెంబర్ 03, బుధవారము సెప్టెంబర్ 17",
          MasaShivarat: "శనివారము సెప్టెంబర్ 20",
          Purnim: "ఆదివారము, సెప్టెంబర్ 07",
          Chatur: "బుధవారము, సెప్టెంబర్ 10",
          Prados: "శుక్రవారము సెప్టెంబర్ 05, శుక్రవారము సెప్టెంబర్ 19",
          Shast: "శనివారము సెప్టెంబర్ 13, ఆదివారము సెప్టెంబర్ 28",
          Chavith: "గురువారము సెప్టెంబర్ 11, శుక్రవారము సెప్టెంబర్ 26",
          data: {
            Amavasya: "21",
            Ekadasi: "03,17",
            Masa: "20",
            Purni: "07",
            Chaturthi: "10",
            Pradosham: "05,19",
            sasti: "13,28",
            Chavi: "11,26",
          },
        },
        {
          Amavas: "మంగళవారము అక్టోబర్ 21",
          Ekadas: "శుక్రవారము అక్టోబర్ 03, శుక్రవారము అక్టోబర్ 17",
          MasaShivarat: "ఆదివారము అక్టోబర్ 19",
          Purnim: "మంగళవారము, అక్టోబర్ 07",
          Chatur: "శుక్రవారము అక్టోబర్ 10",
          Prados: "శనివారము అక్టోబర్ 04, శనివారము అక్టోబర్ 18",
          Shast: "ఆదివారము అక్టోబర్ 12, సోమవారము అక్టోబర్ 27",
          Chavith: "శుక్రవారము అక్టోబర్ 10, శనివారము అక్టోబర్ 25",
          data: {
            Amavasya: "21",
            Ekadasi: "03,17",
            Masa: "19",
            Purni: "07",
            Chaturthi: "10",
            Pradosham: "04,18",
            sasti: "12,27",
            Chavi: "10,25",
          },
        },
        {
          Amavas: "బుధవారము నవంబర్ 19",
          Ekadas: "శనివారము నవంబర్ 01, శనివారము నవంబర్ 15",
          MasaShivarat: "మంగళవారము నవంబర్ 18",
          Purnim: "బుధవారము, నవంబర్ 05",
          Chatur: "శనివారము నవంబర్ 08",
          Prados: "సోమవారము నవంబర్ 03, సోమవారము నవంబర్ 17",
          Shast: "సోమవారము నవంబర్ 10, బుధవారము నవంబర్ 26",
          Chavith: "ఆదివారము నవంబర్ 09, సోమవారము నవంబర్ 24",
          data: {
            Amavasya: "19",
            Ekadasi: "01,15",
            Masa: "18",
            Purni: "05",
            Chaturthi: "08",
            Pradosham: "03,17",
            sasti: "10,26",
            Chavi: "09,24",
          },
        },
        {
          Amavas: "శుక్రవారము డిసెంబర్ 19",
          Ekadas:
            "సోమవారము డిసెంబర్ 01, సోమవారము డిసెంబర్ 15, మంగళవారము డిసెంబర్ 30",
          MasaShivarat: "గురువారము డిసెంబర్ 18",
          Purnim: "గురువారము, డిసెంబర్ 04",
          Chatur: "ఆదివారము డిసెంబర్ 07",
          Prados: "మంగళవారము డిసెంబర్ 02, బుధవారము డిసెంబర్ 17",
          Shast: "బుధవారము డిసెంబర్ 10, శుక్రవారము డిసెంబర్ 26",
          Chavith: "సోమవారము డిసెంబర్ 08, బుధవారము డిసెంబర్ 24",
          data: {
            Amavasya: "19",
            Ekadasi: "01,15,30",
            Masa: "18",
            Purni: "04",
            Chaturthi: "07",
            Pradosham: "02,17",
            sasti: "10,26",
            Chavi: "08,24",
          },
        },
      ],
    ],
  "Srustirahasyalu": [
    {
      "CatID": [
        {
          "title": <span class='highlight'>సృష్ఠి ఆవిర్బావము:</span>,
        },
        {
          "title": "ముందు (పరాపరము) దీనియందు శివం పుట్టినది"
        },
        {
          "title": "శివం యందు శక్తి"
        },
        {
          "title": "శక్తి యందు నాదం"
        },
        {
          "title": "నాదం యందు బిందువు"
        },
        {
          "title": "బిందువు యందు సదాశివం"
        },
        {
          "title": "సదాశివం యందు మహేశ్వరం"
        },
        {
          "title": "మహేశ్వరం యందు ఈశ్వరం"
        },
        {
          "title": "ఈశ్వరం యందు రుద్రుడు"
        },
        {
          "title": "రుద్రుని యందు విష్ణువు"
        },
        {
          "title": "విష్ణువు యందు బ్రహ్మ"
        },
        {
          "title": "బ్రహ్మ యందు ఆత్మ"
        },
        {
          "title": "ఆత్మ యందు దహరాకాశం"
        },
        {
          "title": "దహరాకాశం యందు వాయువు"
        },
        {
          "title": "వాయువు యందు అగ్ని"
        },
        {
          "title": "ఆగ్ని యందు జలం"
        },
        {
          "title": "జలం యందు పృద్వీ."
        },
        {
          "title": "పృద్వీ యందు ఓషధులు"
        },
        {
          "title": "ఓషదుల వలన అన్నం"
        },
        {
          "title": "ఈ అన్నము వల్ల నర మృగ పశు పక్షి స్థావర జంగమాదులు పుట్టినవి."
        }
      ],
      "title": "1.సృష్టి ఎలా ఏర్పడ్డది?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>సృష్ఠి కాల చక్రం:</span>,
        },
        {
          "title": "పరాశక్తి ఆదీనంలో నడుస్తుంది."
        },
        {
          "title": "ఇప్పటివరకు ఏంతో మంది శివులు ఏంతోమంది విష్ణువులు ఏంతోమంది బ్రహ్మలు వచ్చారు ఇప్పటివరకు 50 బ్రహ్మలు వచ్చారు.ఇప్పుడు నడుస్తుంది 51 వాడు."
        },
        {
          "title": "1 కృతయుగం"
        },
        {
          "title": "2 త్రేతాయుగం"
        },
        {
          "title": "3 ద్వాపరయుగం"
        },
        {
          "title": "4 కలియుగం"
        },
        {
          "title": "నాలుగు యుగలకు 1 మహయుగం"
        },
        {
          "title": "71 మహ యుగలకు 1మన్వంతరం"
        },
        {
          "title": "14 మన్వంతరాలకు ఒక సృష్ఠి ఒక కల్పం"
        },
        {
          "title": "15 సందులకు ఒక ప్రళయం ఒక కల్పం"
        },
        {
          "title": "1000 యుగలకు బ్రహ్మకు పగలు సృష్ఠి"
        },
        {
          "title": "1000 యుగాలకు ఒక రాత్రి ప్రళయం"
        },
        {
          "title": "2000 యుగాలకు ఒక దినం"
        },
        {
          "title": "బ్రహ్మ వయస్సు 51 సం"
        },
        {
          "title": "ఇప్పటివరకు 27 మహ యుగాలు గడిచాయి"
        },
        {
          "title": "1 కల్పంకు 1 పగలు 432 కోట్ల సంవత్సరములు"
        },
        {
          "title": "7200 కల్పాలు బ్రహ్మకు 100 సంవత్సరములు"
        },
        {
          "title": "14 మంది మనువులు"
        },
        {
          "title": "ఇప్పుడు వైవస్వత మనువులో ఉన్నాం. శ్వేతవారహ యుగంలో ఉన్నాం."
        },
        {
          "title": "5 గురు భాగన కాలంకు 60 సం"
        },
        {
          "title": "1 గురు భాగన కాలంకు 12 సం"
        },
        {
          "title": "1 సంవత్సరంకు 6 ఋతువులు"
        },
        {
          "title": "1 సంవత్సరంకు 3 కాలాలు"
        },
        {
          "title": "1 రోజుకు 2 పూటలు పగలు రాత్రి"
        },
        {
          "title": "1 సం. 12 మాసాలు"
        },
        {
          "title": "1 సం. 2 ఆయనాలు"
        },
        {
          "title": "1సం. 27 కార్తెలు"
        },
        {
          "title": "1 నెలకు 30 తిధులు"
        },
        {
          "title": "27 నక్షత్రాలు - వివరణలు"
        },
        {
          "title": "12 రాశులు"
        },
        {
          "title": "9 గ్రహాలు"
        },
        {
          "title": "8 దిక్కులు"
        },
        {
          "title": "108 పాదాలు"
        },
        {
          "title": "1 వారంకు 7 రోజులు"
        },
        {
          "title": "పంచాంగంలో 1 తిధి. 2 వార. 3 నక్షత్రం. 4 కరణం. 5 యోగం"
        }
      ],
      "title": "2 సృష్టి కాల చక్రం ఎలా నడుస్తుంది?"
    },
    {
      "CatID": [
        {
          "title": "సృష్ఠి యవత్తు త్రిగుణములతోనే ఉంటుంది"
        },
        {
          "title": "1 సత్వ గుణం"
        },
        {
          "title": "2 రజో గుణం"
        },
        {
          "title": "3 తమో గుణం"
        }
      ],
      "title": "3 మనిషిలో ఎన్ని తత్వాలున్నాయి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>పంచ భూతంలు అవిర్బావాం:</span>,
        },
        {
          "title": "ఆత్మ యందు ఆకాశం"
        },
        {
          "title": "ఆకాశం నుండి వాయువు"
        },
        {
          "title": "వాయువు నుండి అగ్ని"
        },
        {
          "title": "అగ్ని నుండి జలం"
        },
        {
          "title": "జలం నుండి భూమి అవిర్బవించాయి"
        },
        {
          "title": "5 ఙ్ఞానింద్రియంలు"
        },
        {
          "title": "5 పంచ ప్రాణంలు"
        },
        {
          "title": "5 పంచ తన్మాత్రలు"
        },
        {
          "title": "5 ఆంతర ఇంద్రియంలు"
        },
        {
          "title": "5 కర్మఇంద్రియంలు = 25 తత్వంలు"
        }
      ],
      "title": "4 పంచ భూతంలు అవిర్బావాం?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>ఆకాశ పంచికరణంలు:</span>,
        },
        {
          "title": "ఆకాశం - ఆకాశంలో కలవడం వల్ల ( జ్ఞానం )"
        },
        {
          "title": "ఆకాశం - వాయువులో కలవడం వల్ల ( మనస్సు )"
        },
        {
          "title": "ఆకాశం - అగ్నిలో కలవడం వల్ల ( బుద్ది )"
        },
        {
          "title": "ఆకాశం - జలంతో కలవడంవల్ల ( చిత్తం )"
        },
        {
          "title": "ఆకాశం - భూమితో కలవడంవల్ల ( ఆహంకారం ) పుడుతుతున్నాయి"
        }
      ],
      "title": "5 ఆకాశ పంచికరణంలు?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>వాయువు పంచికరణంలు:</span>,
        },
        {
          "title": "వాయువు - వాయువుతో కలవడం వల్ల ( వ్యాన)"
        },
        {
          "title": "వాయువు - ఆకాశంతో కలవడంవల్ల ( సమాన )"
        },
        {
          "title": "వాయువు - అగ్నితో కలవడంవల్ల ( ఉదాన )"
        },
        {
          "title": "వాయువు - జలంతో కలవడంవల్ల ( ప్రాణ )"
        },
        {
          "title": "వాయువు - భూమితో కలవడంవల్ల ( అపాన ) వాయువులు పుడుతున్నాయి."
        }
      ],
      "title": "6 వాయువు పంచికరణంలు?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>అగ్ని పంచికరణములు:</span>,
        },
        {
          "title": "అగ్ని - ఆకాశంతో కలవడంవల్ల ( శ్రోత్రం )"
        },
        {
          "title": "అగ్ని - వాయువుతో కలవడంవల్ల ( వాక్కు )"
        },
        {
          "title": "అగ్ని - అగ్నిలో కలవడంతో ( చక్షువు )"
        },
        {
          "title": "అగ్ని - జలంతో కలవడంతో ( జిహ్వ )"
        },
        {
          "title": "అగ్ని - భూమితో కలవడంతో ( ఘ్రాణం ) పుట్టేను."
        }
      ],
      "title": "7 అగ్ని పంచికరణములు?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>జలం పంచికరణంలు:</span>,
        },
        {
          "title": "జలం - ఆకాశంలో కలవడంవల్ల ( శబ్దం )"
        },
        {
          "title": "జలం - వాయువుతో కలవడంవల్ల ( స్పర్ష )"
        },
        {
          "title": "జలం - అగ్నిలో కలవడంవల్ల ( రూపం )"
        },
        {
          "title": "జలం - జలంలో కలవడంవల్ల ( రసం )"
        },
        {
          "title": "జలం - భూమితో కలవడం వల్ల ( గంధం )పుట్టేను."
        }
      ],
      "title": "8 జలం పంచికరణంలు?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>భూమి పంచికరణంలు:</span>,
        },
        {
          "title": "భూమి - ఆకాశంలో కలవడంవల్ల ( వాక్కు )"
        },
        {
          "title": "భూమి - వాయువుతో కలవడం వల్ల ( పాని )"
        },
        {
          "title": "భూమి - అగ్నితో కలవడంవల్ల ( పాదం )"
        },
        {
          "title": "భూమి - జలంతో కలవడంతో ( గూహ్యం )"
        },
        {
          "title": "భూమి - భూమిలో కలవడంవల్ల ( గుదం ) పుట్టేను."
        }
      ],
      "title": "9 భూమి పంచికరణంలు?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>నాడులు:</span>,
        },
        {
          "title": "ఇడా నాడి"
        },
        {
          "title": "పింగళ"
        },
        {
          "title": "సుషుమ్నా"
        },
        {
          "title": "గాందారి"
        },
        {
          "title": "పమశ్వని"
        },
        {
          "title": "పూష"
        },
        {
          "title": "అలంబన"
        },
        {
          "title": "హస్తి"
        },
        {
          "title": "శంఖిని"
        },
        {
          "title": "కూహు"
        },
        {
          "title": "బ్రహ్మనాడీ"
        }
      ],
      "title": "10 నాడులు?"
    }
  ],
  "Jeevanasili": [
    {
      "CatID": [
        {
          "title": <span class='highlight'>కర్మ సిద్ధాంతం ఏం చెబుతుంది?:</span>,
        },
        {
          "title": "అన్ని జన్మలలోను మానవ జన్మ దుర్లభమైనది మరియు ఉత్తమమైనది. మానవుడు తన జీవిత కాలంలో అనేక కర్మలు చేస్తూ ఉంటాడు. చేసిన ప్రతి కర్మకు ఫలితము అనుభవించి తీరాలి. ఈ ఫలితాలనే కర్మ ఫలములు అని కూడా అంటారు. ఈ కర్మ ఫలములు అనేక జన్మలు జీవుడితో కలిసి ప్రయాణం చేస్తూ ఉంటాయి. పుణ్య కర్మలు పక్వానికి వచ్చినప్పుడు దేవలోకంలో జన్మించి ఆ భోగములను అనుభవించి తిరిగి మనుషుడుగా జన్మ ఎత్తుతాడు. దేవలోకంలో కర్మ చేసే వీలు ఉండదు. అది భోగ భూమి.  క్షీనే పుణ్యే మర్త్యలోకం విశంతి. అలానే పాప కర్మలు పక్వానికి వస్తే జీవుడు జంతువులూ, పశువులు, పక్షులు, క్రీములు, కీటకాలుగా నీచ యోనులయందు జన్మిస్తాడు. అనేక బాధలు అనుభవిస్తాడు. ఈ జన్మలలో కూడా శరీరం మనస్సు ఉంటాయి గాని బుద్ది మాత్రం ఉండదు. కాబట్టి జంతు జన్మలో కూడా భగవంతుని సాక్షాత్కారము కలిగే అవకాశమే లేదు."
        },
        {
          "title": "పుణ్య పాప కర్మలు మిశ్రమముగా పక్వానికి వచ్చినప్పుడు జీవుడు మానవ జన్మ ఎత్తుతాడు. కర్మ ఫలముగా సుఖములను, దుఃఖములను అనుభవిస్తాడు. కర్మ ఫలముని అనుభవించటమే కాక కొత్త కర్మలు కూడా చేసే అవకాశం కేవలం మానవ జన్మలోనే కలుగుతుంది. పరమాత్మని అందుకోవడానికి కావలసిన కర్మలు చేసే అధికారం, జ్ఞానం వున్నా ఈ మానవ జన్మ ఉత్తమోత్తమమైనది, దుర్లభమైనది.  జంతూనాం నర జన్మ దుర్లభం. అని శంకరులు వివేక చూడామణి లో తెలియచేసారు. ఇలాంటి ఉత్తమమైన మానవ జన్మని సార్ధకం చేసుకోడానికి ప్రతి ఒక్కరు కృషి చెయ్యాలి."
        },
        {
          "title": "రోజు మనం అనుభవించే సుఖములు అశాశ్వతమైనవి. ఎవడు ఎంత సంపాదించిన ఎదో వెలితి ఉంటుంది. అనిత్యమైన వస్తువులతో వచ్చే సుఖములు కూడా అనిత్యమైనవే. ఏది నిత్యమైనదో, ఏది శాశ్వతమైనదో, ఏది పరిపూర్ణమైనదో అదే మనకి శాశ్వతమైన సుఖమును ఇస్తుంది. నిత్యమైన వస్తువు ఏకమైనా పరమాత్మ మాత్రమే. శాశ్వతమైన సుఖము అంటే -  మోక్షం. సర్వబంధాలనుండి విముక్తి."
        },
        {
          "title": "అనంత కోటి జన్మలనుండి మనం చేస్తున్న కర్మలే మనల్ని ఈ ప్రపంచానికి కట్టివేసి బంధాలై వున్నాయి. ఏవేవో కోరికలతో ఎన్నో కర్మలు చేసే ఆ కర్మలకు ఫలములుగా, ఇల్లు, వాకిళ్లు, తోటలు, పరిశ్రమలు, పదవులు ఎన్నెన్నో సంపాదించుకుంటాము. సంపాదించిన ప్రతిఒక్కటి మనం వదిలి వెళ్ళవలసిందే. కానీ సంపాదించటానికి చేసిన కర్మలు, ఆలోచనలు, సంకల్పాలు జీవునితోనే వాసనలుగా వచ్చి బంధించి వేస్తుంటాయి. ఈ బంధాలు ఉన్నంత కాలం మనిషి చస్తూ బతుకుతూ ఉండవలసిందే. ఈ బంధాలన్నీ వదిలేయాలంటే కర్మ సిద్ధాంతాన్ని అవగాహన చేసుకోవాలి."
        },
        {
          "title": "ఒక ప్రభుత్వాన్ని నడపటానికి రాజ్యాంగం ఎలాగో, ఈ సృష్టినంతటిని నడపటానికి కర్మ సిద్ధాంతం ఒకటి వుంది. కర్మ సిద్ధాంతం భగవన్నిర్మితం. దీనిలో లొసుగులు వుండవు. ఎవరికీ మినహాయింపులు వుండవు. దీనికి అందరు సమానులే. సాక్షాత్తు శ్రీ రామచంద్రుని తండ్రి దశరధునికి పుత్రవియోగం తప్పలేదు. శ్రీ కృషుని తల్లి తండ్రులకి కారాగారవాసం తప్పలేదు. కర్మ సిద్ధాంతం చేసిన కర్మల మీద ఆధారపడి ఉంటుంది."
        },
        {
          "title": "మనం ఉదయం లేచిన దగ్గరనుండి చేసే పనులన్నీ కర్మలే. మనం చేసే ప్రతి కర్మ ఎప్పుడో ఒకప్పుడు ఫలితాన్ని ఇచ్చి తీరుతుంది. ఫలితాన్ని ఇచ్చే సమయాన్ని బట్టి కర్మలను మూడు రకాలుగా విభజించారు."
        },
        {
          "title": "1 ఆగామి కర్మలు"
        },
        {
          "title": "2 సంచిత కర్మలు"
        },
        {
          "title": "3 ప్రారబ్ధ కర్మలు"
        },
        {
          "title": <span class='highlight'>ఆగామి కర్మలు:</span>,
        },
        {
          "title": "మనం భోజనం చేస్తే ఆకలి తీరుతుంది. నీళ్లు తాగితే దాహం తీరుతుంది. ఎవరినైనా తిడితే వాడు బలం కలవాడు అయితే తిరిగికొడతాడు. అది కర్మ ఫలం. ఇలా కొన్ని కర్మలు అప్పటికప్పుడే కర్మఫలమును ఇచ్చి శాంతిస్తాయి. ఆలా శాంతించే కర్మలని ఆగామి కర్మలు అని అంటారు."
        },
        {
          "title": <span class='highlight'>సంచిత కర్మలు:</span>,
        },
        {
          "title": "కొన్ని కర్మలు వెంటనే ఫలితాన్ని ఇవ్వవు. ఉదాహరణకి ఒక చెట్టును నాటడం, ఒక చెరువు త్రవ్వించటం, ఒక పాఠశాల కట్టడం, దాన ధర్మాలు చెయ్యడం, ఒకడిని పరోక్షంగా దూషించడంలాంటివి. ఈ కర్మలు అదే జన్మలో ఫలితమును ఇస్తే అది ఆగామి. అలాకాని పక్షంలో ఆ కర్మలు జీవుడితోనే వాసనలుగా ఉంటాయి. ఒక జన్మ నుండి మరొక జన్మకు మోసుకు వచ్చిన కర్మలను సంచిత కర్మలు అని పిలుస్తారు. ఒక అద్దె ఇంటి నుండి ఇంకొక ఇంటికి మారేటప్పుడు మనం సంపాదించిన డబ్బును, వస్తువులను ఎలా అయితే తీసుకువెళ్తామో అలానే జీవుడు ఒక దేహంతో చేసిన కర్మఫలములని తరువాతి జన్మకి మూట కట్టుకుని వెళ్తాడు. అలంటి కర్మలే సంచిత కర్మలు."
        },
        {
          "title": <span class='highlight'>ప్రారబ్ధ కర్మలు</span>,
        },
        {
          "title": "పక్వానికి వచ్చిన సంచిత కర్మలని ప్రారబ్ధ కర్మలు అంటారు. ప్రారబ్ధ కర్మలను అనుభవించడానికి తగిన శరీరమును వెతుక్కుని జీవుడు జన్మ తీసుకుంటాడు."
        },
        {
          "title": "ప్రారబ్ధ కర్మలు అనుభవించడం పూర్తి అయ్యేదాకా ఆ శరీరములో వుంది పూర్తి అయిన వెంటనే ఆ శరీరమును విడిచి వెళ్ళిపోతాడు. ఈ జీవితం ముగిసేలోగా చేసిన కర్మలు, ఇంతకుముందు చేసిన సంచితములతో కలిసి పోతాయి, మళ్ళి పక్వానికి సిద్ధముగా వున్న సంచితములన్ని ప్రారబ్ధములుగా మారి జీవుడు మళ్ళి జన్మ ఎత్తుతాడు."
        },
        {
          "title": "భగవద్గీతలో కృష్ణుడు చెప్పినట్లు వేల మందిలో కొందరు మాత్రమే దైవాన్ని అన్వేషించి చివరకు మోక్షాన్ని పొందుతారు."
        },
        {
          "title": <span class='highlight'>వేలకొలది జనులలో ఏ ఒక్కడో జ్ఞానసిద్ధి కొరకు ప్రయత్నించును. అట్లు ప్రయత్నించిన వారిలో ఒకానొకడు మాత్రమె నన్ను యదార్థంగా తెలుసుకోన గలుగుచున్నాడు.  భగవద్గీత (7:౩)</span>,
        },
        {
          "title": " మిగిలిన వాళ్ళు జనన మరణ చక్రంలో తిరుగుతూ ఉండవలసిందే."
        },
        {
          "title": <span class='highlight'>పునరపి జననం పునరపి మరణం పునరపి జనని జఠరేశయనం</span>,
        }
      ],
      "title": "1.కర్మ సిద్ధాంతం ఏం చెబుతుంది??"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>ఆచమనం అంటే ఏమిటి</span>,
        },
        {
          "title": "పూజలు, వ్రతాల్లో ''ఆచమనం'' అనే మాట చాలా సార్లు వింటాం. కానీ ఆ పదానికి అర్ధం చాలామందికి సరిగా తెలీదు. అందుకే ''ఆచమనం'' అంటే ఏమిటో, దాని వెనుక ఉన్న శాస్త్రీయత ఏమిటో ఇప్పుడు తెలుసుకుందాం. ఆచమనం అనే ఆచారం అపరిమితమైనది. ఉదయం లేచి స్నానం చేసిన తర్వాత,పూజకు ముందు, సంధ్యావందనం చేసే సమయంలో పలుసార్లు,భోజనానికి ముందు, తర్వాత, బయటకు ఎక్కడికైనా వెళ్ళి వచ్చిన తర్వాత ముఖం, కాళ్ళూ చేతులూ కడుక్కున్న తర్వాత ఆచమనం చేయొచ్చు.ఆచమనం చేసే వ్యక్తి శుచిగా,శుభ్రంగా ఉండాలి. ఒక్కొక్కసారి ఒక్కొక్క ఉద్ధరణి చొప్పున మంత్రయుక్తంగా మూడుసార్లు చేతిలో నీరు పోసుకుని తాగాలి."
        },
        {
          "title": "ఆచమనం గురించి సంస్కృతంలో  గోకర్ణాకృతి హస్తేన మాషమగ్నజలం పిబేత్ అని వర్ణించారు. అంటే, కుడి అరచేతిని ఆవు చెవి ఆకారంలో ఉంచి, ఇందులో మూడు ఉద్ధరణిల నీటిని (ఒక మినపగింజమునిగేంత పరిమాణంలో నీళ్ళు) పోసి, వాటిని తాగాలి. చేతిలో పోసేనీళ్ళు అంతకంటే ఎక్కువ కానీ, తక్కువ కానీ ఉండకూడదు. నీరు కొలత అంతే ఉండాలి."
        },
        {
          "title": "ఆచమనం ఎన్నిసార్లు అయినా చేయొచ్చు అని చెప్తున్నారు.. బాగానే ఉంది. "
        },
        {
          "title": "1.అసలు ఆచమనం ఎందుకు చేయాలి? "
        },
        {
          "title": "2.నీటిని అరచేతిలో పోసుకుని తాగడం వల్ల ప్రయోజనం ఏమిటి? "
        },
        {
          "title": "3.అలా ఎందుకు తాగాలి?"
        },
        {
          "title": "4.ఉద్ధరణితో తిన్నగా నోట్లో పోసుకుని ఎందుకు తాగకూడదు?"
        },
        {
          "title": "5.మూడు ఉద్ధరణిల నీరు మాత్రమే ఎందుకు తీసుకోవాలి?"
        },
        {
          "title": "6. నీరు కొంతఎక్కువో తక్కువో అయితే ఏమవుతుంది?"
        },
        {
          "title": "7.“కేశవాయ స్వాహా,నారాయణాయ స్వాహా, మాధవాయ స్వాహా...” అని మాత్రమేఎందుకు చెప్పాలి? "
        },
        {
          "title": "ఇలాంటి సందేహాలు కలగడం సహజం. దేవుడు,ఆచారాల పట్ల నమ్మకం లేని నాస్తికులు అయితే వీటిని అపహాస్యం చేస్తారు కూడా.అందుకే ఆచమనం చేయడంలో పరమార్థం ఏమిటో విపులంగా తెలుసుకుందాం.మన గొంతు ముందు భాగం లోంచి శబ్దాలు వస్తాయి. దీన్ని స్వరపేటిక అంటాం. దీనిచుట్టూ కార్టిలేజ్ కవచం ఉంటుంది కనుక కొంత వరకూ రక్షణ లభిస్తుంది. అయినప్పటికీ, ఇది ఎంత అద్భుతమైనదో, అంత సున్నితమైనది. ఈ గొంతు స్థానంలో చిన్నదెబ్బ తగిలినా ప్రమాదం. స్వరపేటిక దెబ్బతిని మాట పడిపోవచ్చు,ఒక్కోసారి ప్రాణమే పోవచ్చు. స్వరపేటిక లోపలి భాగంలో ధ్వని ఉత్పాదక పొరలు ఉంటాయి. ఇవి ఇంగ్లీషు అక్షరం 'V' ఆకారంలో పరస్పరం కలిసిపోయి ఉంటాయి. ఈ తంత్రులు సూక్ష్మంగా ఉండి,ఎపెక్స్ ముందుభాగంలో పాతుకుని ఉంటాయి. స్వరపేటిక కవాటాలు పల్చటి మాంసపు పొరతో ముడిపడి ఉంటాయి."
        },
        {
          "title": "ఈ శరీర నిర్మాణం గురించి చెప్పుకోవడం ఎందుకంటే, మన భావవ్యక్తీకరణకు కారకమైన స్వరపేటిక మహా సున్నితమైనది. ముక్కు,నోరు, నాలుక, పెదవులు, పళ్ళు, గొంతు నాళాలు, అంగిలి, కొండనాలుక,గొంతు లోపలి భాగం, శ్వాస నాళం, అన్ననాళం, స్వర తంత్రులు, వాటిచుట్టూ ఉన్న ప్రదేశం ఇవన్నీ ఎంతో నాజూకైనవి. వీటికిబలం కలిగించడమే ఆచమనం పరమోద్దేశం.ఆచమనంలో మూడు ఉద్ధరణిల నీరు మాత్రమే తాగాలి అనిచెప్పుకున్నాం కదా! గొంతులోంచి శబ్దం వెలువడేటప్పుడు అక్కడున్న గాలి బయటికొస్తుంది. ఇలాలోపలి నుండి గాలి బయటకు వస్తున్నప్పుడు అందులోవేగం ఉండకూడదు.శబ్దం సులువుగా, స్పష్టంగా రావాలి. ఇలా కొన్నినీటిని జాగ్రత్తగా చేతిలోకి తీసుకుని, అంతే జాగ్రత్తగా మెల్లగాతాగడం అనే అలవాటు వల్ల మనం చేసే ప్రతి పనిలో శ్రద్ధ,జాగ్రత్త అలవడుతుంది. రోజులో ఆచమనం పేరుతొ అనేకసార్లు మెల్లగా నీరు తాగడంవల్ల గొంతు, ఇతర అవయవాలు వ్యాయామం చేసినట్లు అవుతుంది. కేశవాయ స్వాహా అన్నప్పుడు అది గొంతునుండి వెలువడుతుంది.నారాయణాయ స్వాహా అనే మంత్రం నాలుక సాయంతో బయటకు వస్తుంది. చివరిగా మాధవాయ స్వాహా అనే మంత్రం పెదవుల సాయంతో వెలువడుతుంది. ఆచమనం అనే ఆచారాన్ని పాటించి ఈ మంత్రాలను ఉచ్చరించడం వల్ల గొంతు,నాలుక, పెదాలకు వ్యాయామం లభిస్తుంది. పైగా ఇవి పరమాత్ముని నామాలు కనుక, భక్తిభావంతో ఉచ్చరించడం వల్లమేలు జరుగుతుంది."
        },
        {
          "title": "ఇక ఉద్ధరణితో తిన్నగా ఎందుకు తాగకూడదు, చేతిలో వేసుకునే ఎందుకు తాగాలి అంటే, మన చేతుల్లో కొంతవిద్యుత్తు ప్రవహిస్తూ ఉంటుంది. చేతిలో నీళ్ళు వేసుకుని తాగడం వల్ల ఆ నీరు విద్యుత్తును పీల్చుకుని నోటి ద్వారా శరీరంలోనికి ప్రవేశిస్తుంది. అక్కడ ఉన్న విద్యుత్తుతో కలిసిశరీరం అంతా సమానత్వం ఉండేలా, సమ ధాతువుగా ఉండేలా చేస్తుంది.ఒక ఉద్ధరణి చొప్పున కొద్దికొద్దిగా నీరు సేవించడం వల్ల ఆకొద్దిపాటి విద్యుత్తు పెదాలు మొదలు నాలుక, గొంతు,పెగుల వరకూ ఉన్న సున్నితమైన అవయవాలను ఉత్తేజ పరుస్తాయి.ఈ ప్రయోజనాలే కాకుండా ఒక పవిత్ర ఆచారంగా భావిస్తూ రోజులో అనేకసార్లు పాటించడం వల్ల మనసు దానిమీద కేంద్రీకృతమై,లేనిపోని బాధలు, భయాలు తొలగుతాయి.ఏదో అలవాటుగా పాటించే ఆచారాల వెనుక ఎన్నో ప్రయోజనాలు ఉన్నాయి. శాస్త్రీయత ఉంది."
        }
      ],
      "title": "2. ఆచమనం అంటే ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": "ఈ రోజు నేను ఉపవాసమండీ. అనే మాటని మనం తరచుగా వింటూ ఉంటాం. ముక్కోటి ఏకాదశి శివరాత్రి వంటి పర్వ దినాల్లో చాలా మంది, దరిదాపుల్లో అందరు ఉపవాసాలుంటారు. ప్రతి మాస శివరాత్రికి, ఏకాదశికి  ఉపవాసం ఉండేవారు కూడా చాలా మందే కనపడతారు. ఒక్కొక్క వారం ఒక్కొక్క దేవుడికి ప్రీతికరమని తమ ఇష్ట దైవానికి ప్రీతి కరమైన రోజున ఉపవాసం ఉంటారు ఎంతో మంది. ఇక కార్తీక మాసం వచ్చిందంటే చెప్పనక్కర లేదు. అన్నీ రోజులు ఉపవాసాలే –సోమ వారాలు ఏకాదశులు, పూర్ణిమ, మాస శివరాత్రి. మిగిలిన రోజులు నక్తాలు. ఈ ఉపవాసాలు ఒకొక్కళ్ళు ఒక్కొక్క విధంగా చేస్తూంటారు. రోజంతా ఏమీ తినకుండా ఉండేవారు కొంతమంది. పగలు తిని రాత్రి తినని వారు, రాత్రి తిని పగలు తినని వారు, ఒక పూట అన్నం, మరొక పూట  ఫలహారం ( పిండి వంటలు, పండ్లు, పాలు) తినే వారు, వండినవి తినని వారు, ..... ఇలా ఎన్నో రకాల వారు కనపడతారు. ఉపవాసాన్ని ఒక్క పొద్దు అనటం కూడా వింటాం. అంటే ఒక పూట మాత్రమే తింటారనే అర్థం వస్తుంది. ఇవన్నీ చూస్తే అసలు ఉపవాసం అంటే ఏమిటి? ఎలా చెయ్యాలి? అనే సందేహం రావటం సహజం."
        },
        {
          "title": "ఉప అంటే  సమీపంలో వాసం అంటే ఉండటం. అంటే ఉపవాసం అనే పదానికి దగ్గరగా ఉండటం అని అర్థం. దేనికి దగ్గరగా ఉండటం? ఈ ప్రశ్నకి సమాధానం ఎందుకు ఉపవాసం చేస్తున్నామో తెలిసి ఉంటే తెలుస్తుంది. ఉపవాసం భగవదనుగ్రహం కోసం చేస్తారన్నది జగద్విదితమైన విషయం. కనుక ఉండవలసింది భగవంతుని సమీపంలో. ఇంటిపని వంట పని తగ్గితే సమయమంతా భగవద్ధ్యానంలో గడపటానికి వీలుగా ఉంటుంది. అప్పుడు వంటికి కూడా పని తగ్గుతుంది. బరువైన, అరగటానికి కష్టమైన ఆహారం తీసుకోక పోవటంతో జీర్ణ వ్యవస్థకి వెచ్చించాల్సిన శక్తి కూడా భగవద్ధ్యానానికో, పూజకో  వెచ్చించటానికి వీలవుతుంది. కడుపు నిండా తినగానే కునుకు వస్తుంది చాలమందికి.  ఎందుకంటే శక్తి అంతా జీర్ణాశయం దగ్గరకి వెళ్ళి పోయి ఉంటుంది. మెదడుకి శక్తి సరఫరా తగ్గుతుంది"
        },
        {
          "title": "దానితో మెదడులో చురుకుతనం తగ్గి మాదకత కలుగుతుంది. కళ్ళు మూతలు పడతాయి. అటువంటి సమయంలో పూజకో ధ్యానానికో కూర్చుంటే ఇంకేముంది? హాయిగా నిద్ర ముంచుకు వస్తుంది. అందుకని మితాహారం నియమంగా పెట్టటం జరిగింది. అలాగని ఏమి  తిన కుండ ఉంటే నీరసం వచ్చి అసలు ప్రయోజనం దెబ్బ తింటుంది. అందుకని నీరసం రాకుండా శక్తినిస్తూ, జీర్ణశయానికి బరువు కలిగించ కుండా తేలికగా వంట పట్టే ఆహారం తీసుకోవటం మంచిదని పెద్దల మాట. అటువంటి ఆహారాల్లో (ఆవు) పాలు, పళ్ళు శ్రేష్ఠ మైనవి.  మామూలు పూజకైనా అంతే . పూజా ప్రారంభంలో ఆచమనీయం అని  మూడు పుడిసిళ్ళ నీరు లోపలికి తీసుకుంటారు. అన్నం బదులు మరేదైనా తీసుకుంటారు కొందరు - అన్నం కన్నా తక్కువ తింటారు అనే ఉద్దేశంతో. ఆహారం తగ్గించటం, మార్చటం వల్ల శరీరం అదుపులో ఉటుంది."
        },
        {
          "title": "పూర్తిగా రోజంతా ఏమి తినకుండా ఉండటం కష్టం కనుక ఒకపూట తినటం బాగా వ్యాప్తిలో ఉంది. అది పగలా? రాత్రా? అన్నది వారి వారి సౌకర్యాన్ని బట్టి ఉంటుంది."
        },
        {
          "title": " ఒక నెల పూర్తిగా ఇటువంటి ఉపవాస దీక్ష తీసుకునేది కార్తీక మాసంలో. ఇది శివ కేశవులిద్దరికి ప్రీతి పాత్రమైన మాసం. ఈ నెలలో చాలా మంది నక్తాలుంటారు. అంటే నక్షత్ర దర్శనం అయ్యే దాకా పగలంతా ఉపవసించి  ప్రదోష పూజ అయినాక భోజనం చేస్తారు. కొంత మంది అర్థ నక్తాలు అని పొద్దు వాటారేదాకా ఉండి అప్పుడు భోజనం చేస్తారు. భోజనం ఎప్పుడు చేసినా అప్పటి వరకు రుద్రాభిషేకమో, విష్ణు సహస్ర నామ పారాయణమో చేస్తూ కాలం గడుపుతారు. కార్తీక మాసం చలి కాలం లో వస్తుంది, పగటి సమయం తక్కువ. ఎక్కువ తినాలని చలికి ముడుచుకుని వెచ్చగా కూర్చోవాలనో , పడుకోవాలనో అనిపిస్తుంది. నియంత్రించకపోతే ఆరోగ్యం దెబ్బ తినే ప్రమాదం ఉంది. కనుక ఆహార నియమం పెట్టి ఉంటారు."
        },
        {
          "title": "అసలు ఉపవాసం అంటే అన్నం తిన కుండా ఉండటం అనేదే ఆరోగ్య సూత్రం. ఏ అనారోగ్యమైన ఆహారంతో ముడి పది ఉంటుంది. దానిని సరిచేస్తే ఎన్నో సద్దుకుంటాయి అన్నది ఆయుర్వేద సిద్ధాంతం. వారానికి ఒక రోజు జీర్ణాశయానికి విశ్రాంతి ఆహారం తీసుకోక పోతే మనసు కేంద్రీకరించటం ఎక్కువగా ఉంటుందనటానికి నిరశన వ్రతాలు, సత్యాగ్రహాలే నిదర్శనం. విద్యార్థులకు ఏ విషయమైనా గుర్తుండకపోతే ఆకలిగా ఉన్నపుడు చదివి వెంటనే భోజనం చేస్తే మనసులో గట్టిగా నాటుకు పోతుందని ఈ మధ్య పాశ్చాత్యులు చేసిన ప్రయోగాలు నిరూపించాయి."
        },
        {
          "title": <span class='highlight'>ఉపవాసం లోని రకాలు  - ఉపయోగాలు:</span>,
        },
        {
          "title": "ఉపవాసం అనగా ఏమి తినకుండా కేవలం మంచినీరు తాగి ఉండటమే ఉపవాసం . దీర్ఘ ఉపవాసం చేయువారు రసాహారము తీసికొనవలెను. కొందరు దేవునికి ఒకపొద్దు ఉంటున్నాం అని ఆ తరువాత అరడజను అరటిపళ్ళు, 10 ఇడ్లిలు, అరకిలో ఉప్మా లాగించేస్తారు . అన్నం మాత్రం తినరు.బహుశా వారి దృష్టిలో ఇదో రకం ఉపవాసం కావొచ్చు.కాని అలా చేయడం ఉపవాసం అనిపించుకోదు."
        },
        {
          "title": "ఉపవాసం చేయడం వలన ముఖ్య ఉపయోగం శరీరంలోని మాలిన్యాలను బహిష్కరింపచేసి వ్యాధి నిర్మూలనం అవుతుంది. పొట్ట , కన్ను, వ్రణములు , జ్వరములు, జలుబు మొదలగు వ్యాదులను కనీసం 5 రోజులపాటు ఉపవాసం చేసి వ్యాధి తగ్గించుకోవచ్చు. ఏ వ్యాధిలోనైనా ఉపవాసం చేయుట వలన వ్యాధి తొందరగా తగ్గించుకోవచ్చు . లేనిచో ఒకపూట ఉపవాసం ఉండి తరువాత ఆ వ్యాధికి సంబంధించిన పథ్యకరమైన ఆహారం తీసుకోవచ్చు."
        },
        {
          "title": "ఉపవాసంలో 4 రకాలు ఉన్నాయి అవి: "
        },
        {
          "title": "1. నిర్జలోపవాసం"
        },
        {
          "title": "2. జలోపవాసం"
        },
        {
          "title": "3. రసోపవాసం"
        },
        {
          "title": "4. ఫలోపవాసం"
        },
        {
          "title": <span class='highlight'>నిర్జలోపవాసం:</span>,
        },
        {
          "title": "మంచినీరు కూడా ముట్టకుండా చేయు ఉపవాసమును నిర్జలోపవాసం అంటారు. ఈ ఉపవాసం ముఖ్యంగా శరీరంలో నీరు ఎక్కువ చేరినప్పుడు అనగా శరీరం వాచినప్పుడు రెండు లేదా మూడు దినములు ఈ ఉపవాసం చేయవలెను. మూడురోజులకు మించి ఈ ఉపవాసం చేయరాదు ."
        },
        {
          "title": <span class='highlight'>జలోపవాసం:</span>,
        },
        {
          "title": "కేవలం మంచినీరు మాత్రమే తాగి చేయు ఉపవాసమును జలోపవాసం అందురు. దీనిని మూడురోజుల నుంచి ఏడు రోజుల వరకు మాత్రమే చేయవలెను . అంతకు మించి చేయరాదు . శరీరంలో మాలిన్యాలు అధికంగా చేరి ఏ రసాహారమును కూడా జీర్ణం చేసుకోలేని పరిస్థితులు ఉన్నప్పుడు కేవలం మంచినీరు తాగించి ఉపవాసం చేయించవలెను. అనగా సుమారు రెండులీటర్లు మంచినీరు త్రాగించవలెను."
        },
        {
          "title": <span class='highlight'>రసోపవాసం:</span>,
        },
        {
          "title": "ఈ రసోపవాసమును సాధారణంగా ప్రకృతిచికిత్సాలయాల్లో రసోపవాసం చేయిస్తారు. కేవలం పండ్లరసాలతో చేయు ఉపవాసమును రసోపవాసం అంటారు. ఈ ఉపవాసం వారం రోజులు మొదలుకుని నెలరోజులు వరకు కూడా చేయవచ్చు. రసోపవాసంలో ముఖ్యంగా నిమ్మరసం , పలుచని నారింజరసం , బత్తాయిరసం , కమలారసం , తేనెనీరు, కొబ్బరినీరు , బార్లినీరు మొదలగునవి రోజుకు మూడుసార్లు నుండి అయిదుసార్లు లోపలికి తీసుకోవచ్చు"
        },
        {
          "title": <span class='highlight'>ఫలోపవాసం:</span>,
        },
        {
          "title": "ఉపవాసం చేయలేనివారు ఫలోపవాసం చేయవచ్చు . కేవలం రసము నిండిన ఫలములు మాత్రమే ఆహారంగా తీసికొనవలెను . అరటిపండు తీసుకోకూడదు . ఎక్కువ బత్తాయి, నారింజ, కమలా , ద్రాక్షా, అనాస , దానిమ్మ, మామిడి, పుచ్ఛ మొదలగు పండ్లు తినవచ్చు."
        },
        {
          "title": "ఈ ఉపవాసం రోగిని అనుసరించి పది నుంచి నలుబది రోజుల వరకు అనుసరించవచ్చు."
        },
        {
          "title": <span class='highlight'>ఉపవాసం చేయుట వలన వివిధ అవయవాలలో కలుగు మార్పులు: </span>,
        },
        {
          "title": "జీర్ణక్రియకు మంచి విశ్రాంతి లభించి అజీర్ణం తొలగిపోయి ఆకలివృద్ధి అగును."
        },
        {
          "title": "మలాశయంలో మురికి బహిష్కరింపబడి అజీర్ణం తొలగించబడి క్రిములను, బాక్టీరీయా నాశనం చేయబడును."
        },
        {
          "title": "మూత్రపిండాలలోని విషపదార్ధాలు, రాళ్లు బహిష్కరింపబడును."
        },
        {
          "title": "ఊపిరితిత్తులలోని నంజు, నీరు బహిష్కరించబడి ఆయాసం నివారించబడును. శ్వాసక్రియ చక్కగా జరుగును."
        },
        {
          "title": "గుండెచుట్టు , లోపల చేరిన కొవ్వు, నీరు తగ్గి గుండె చక్కగా కొట్టుకొనును. గుండెజబ్బులలో రసోపవాసం మంచిది."
        },
        {
          "title": "లివర్ మరియు స్ప్లీన్ ఆహారం జీర్ణం అగుటకు ఇవి చక్కగా పనిచేయాలి. ఈ ఉపవాసం చేయుట వలన వీటికి విశ్రాంతి దొరుకును. వాటిలోని మాలిన్యం తొలగించబడి జీర్ణక్రియ వృద్ది అగును."
        },
        {
          "title": "శరీరంలో రక్తప్రసారం చురుకుగా ఉండును. ఉపవాసం చేయుట వలన రక్తదోషములు నివారించబడును. తిమ్మిర్లు, మంటలు , నొప్పులు కూడా తగ్గును."
        },
        {
          "title": "కీళ్లలో పేరుకుపోయిన కొవ్వు, నీరు, మాంసము వంటి మాలిన్యాలు తొలగించబడి వ్యాధి నివారణ అగును."
        },
        {
          "title": "నాడీమండలం శుభ్రపరచబడును."
        },
        {
          "title": "జ్ఞానేంద్రియాలలో మాలిన్యాలు అన్ని పోవును."
        },
        {
          "title": "చర్మం కాంతివంతం అగును. చర్మవ్యాధులు హరించును . శరీరానికి చక్కటిరంగు వచ్చును."
        },
        {
          "title": "మనస్సు ప్రశాంతంగా ఉండి కోపం వంటివి మన అదుపులో ఉండగలవు."
        },
        {
          "title": "ఉపవాసం చేయకూడని వారు:"
        },
        {
          "title": "చాలా బలహీనంగా ఉన్నవారు, గుండెజబ్బులు కలవారు , బాలురకు, వృద్దులకు గర్భిణీస్త్రీలకు , బాలింతలకు , క్షయ మరియు రక్తహీనత కలిగిన రోగులు , మధుమేహంతో ఉన్నవారికి ఎక్కువ రోజులు ఉపవాసం చేయకూడదు "
        },
        {
          "title": "ఉపవాసం చేయదగిన వారు:"
        },
        {
          "title": "స్థూలకాయులు, ఉబ్బసం, సంధివాతం, రక్తపుపోటు,చర్మవ్యాధులు మొదలగు దీర్ఘకాలిక రోగులకు ఉపవాసం చేయుట మంచిది."
        },
        {
          "title": "ఉపవాసం ముగించిన వెంటనే ఘనాహారం తీసుకోకూడదు. ఉపవాసం తరువాత ఎక్కువ ఆహారం తీసుకొకూడదు. క్రమేపి ఆహారాన్ని పెంచుకుంటూ రావలెను. కారం , మసాలా పదార్దాలు , పిండివంటలు పచ్చళ్ళు తినకూడదు. అలా తీసుకున్నచో విరేచనాలు, వాంతులు, కడుపులో మంట, నొప్పి కలుగును."
        }
      ],
      "title": "3. ఉపవాసం అంటే ఏమిటి? ఎలా చెయ్యాలి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>తపస్సు అంటే ఏమిటి:</span>,
        },
        {
          "title": "ఒక మంత్రాన్నో, ఏదో ఒక దైవాన్నో ఉపాసిస్తూ., నిరంతర ధ్యానంలో ఉండడమే తపస్సు అనుకుంటే పొరపాటు. ‘తపనే’ తపస్సు. ఒక కార్యసాధన కోసం అనుక్షణం తపించడమే..., ఆరాటపడడమే ‘తపస్సు. అలా తపించినంత మాత్రాన., ఆరాటపడినంత మాత్రాన ప్రయోజనం ఉంటుందా అనే సందేహం ఎవరికైనా కలుగవచ్చు. తప్పకుండా ప్రయోజనం ఉంటుంది. ఎందుకంటే...మనస్సంకల్పానికి ఉన్న శక్తి, బలము.... ఈ సృష్టిలో దేనికి లేదు. ఆయుధాన్ని వాడకుండా, ఓ మూల పడేస్తే తుప్పుపట్టి పనికిరాకుండా పోతుంది. ఆయుధాన్ని నిరంతరం వాడుతూంటే పదునుదేలి..దాని పనితనాన్ని చూపిస్తుంది."
        },
        {
          "title": "అలాగే మనస్సు కూడా. అయితే., ఇక్కడ మీకో సందేహం రావచ్చు.‘అయ్యా.. మనస్సు నిరంతరం ఏదో ఒక విషయం గురించి ఆలోచిస్తూనే ఉంటుంది కదా అని.’ నిజమే...ఆలోచించడం వేరు. ఆరాటపడడం వేరు. ఏదో ఒక విషయం గురించి ఆలోచించడాన్ని.., ఆరాటపడడం అనరు. చంచలమైన మనస్సును నియంత్రించి, ఒక నిర్దిష్ఠమైన లక్ష్యాన్ని దానికి నిర్దేశించి., ఆ దిశగా మనసును మళ్ళించడానికి పడే ఆరాటాన్నే., తపననే., తపస్సు అంటారు."
        },
        {
          "title": "అది మంచి అయితే మంచి ఫలితాన్ని.., చెడు అయితే చెడు ఫలితాన్ని తప్పకుండా ఇస్తుంది. అందుచేతనే తపస్సు చేసే సాధకుడు మంచినే ఆశించి., విశ్వశాంతిని కాంక్షిస్తూ తపస్సు చేయాలి. అదే నిజమైన తపస్సు. తపస్సు గురించి ఇంత వ్యాఖ్యానం ఇచ్చారు కదా...ఇది నిజం అని నిరూపించడానికి ఏదైనా ఆధారం ఉందా ? అని ప్రశ్నించ వచ్చు. ఆధారం లేకుండా ఏ విషయాన్ని మన ఋషులు ఇంతవరకు ప్రతిపాదించలేదు. దీనికి ప్రకృతి పరమైన ఆధారం ఉంది. సృష్టిలో అందమైన కీటకం ‘సీతాకోకచిలుక’. దీని పుట్టుక చాలా వింతగా ఉంటుంది."
        },
        {
          "title": "సాధారణంగా ఒక ప్రాణి నుంచి అదే విధమైన ప్రాణి పుడుతుంది. ఉదాహరణకు కోడిగ్రుడ్డు నుంచి కోడిపిల్ల పుడుతుంది. సీతాకోకచిలుక పెట్టే గ్రుడ్ల నుంచి సీతాకోకచిలుకలు రావు. గొంగళిపురుగులు వస్తాయి. ఈ గొంగళిపురుగులు చూడడానికి చాలా అసహ్యంగా ఉంటాయి.ఆ దశలో అది రాళ్ళలో., రప్పల్లో.., ముళ్ళలో తిరుగుతూ., ఆకులు తింటూ కాలం గడుపుతుది. అలా కొంత కాలం గడిచాక తన జీవింతం మీద రోత కలిగి.,ఆహార, విహారాలు త్యజించి, ఎవ్వరికీ కనిపించని ప్రదేశనికి పోయి., తన చుట్టూ ఓ గూడు నిర్మించుకుని, తపస్సమాధి స్థితిలోకి వెళ్లిపోతుంది. అలా కొంతకాలం గడిచాక, దాని తపస్సు ఫలించాక అది తన గూడు చీల్చుకుని బయటకు వస్తుంది."
        },
        {
          "title": "అయితే అది గొంగళిపురుగులా రాదు. అందమైన సీతాకోకచిలుకలా వస్తుంది. అప్పుడది ఆకులు, అలములు తినదు. పూవుల్లో ఉండే మకరందాన్నే తాగుతుంది. ప్రకృతి ధర్మానికి కట్టుబడి గ్రుడ్లు పెట్టిన మరుక్షణం ఈ సంసార జగత్తులో చిక్కుకోక మరణిస్తుంది. అదీ తపస్సు ఇచ్చే ప్రతిఫలం. అలాగే తపస్సిద్ధి పొందిన మానవుడు ఈ సంసార లంపటంలో చిక్కుకోక భగవన్నామామృత పానంతో తరిస్తాడు."
        },
        {
          "title": <span class='highlight'>తపస్సు చేయడం వల్ల కలిగే ఫలితమేంటి:</span>,
        },
        {
          "title": "పూర్వకాలంలో ఋషులు ఎక్కువకాలం ధ్యానంలోనే గడిపేవారు. అంటే తపస్సు చేస్తుండేవారు. ప్రపంచంతో ఎటువంటి సంబంధం లేకుండా ప్రశాంత వాతావరణంలో కూర్చొని, దేవుడి నామాన్ని స్మరిస్తూ నిరంతర ధ్యానంలోనే వుండేవారు. ఇంతకీ ఈ తపస్సు వల్ల కలిగే లాభం ఏంటి? అని ప్రతిఒక్కరికి సందేహం రాక తప్పదు. ఏదో ఓ మంత్రాన్ని ఉపాసిస్తూ, నిరంతర ధ్యానంలో వుండడమే తపస్సు అనుకోవడం చాలా పొరపాటు. తపస్సు అంటే ‘తపన’. ఒక కార్యసాధన కోసం అనుక్షణం తపించడమే ‘తపస్సు. అలా తపించడం వల్ల కచ్చితంగా ప్రయోజనం వుంటుంది. ఎందుకంటే.. మనస్సంకల్పానికి ఉన్న శక్తి, బలము ఈ సృష్టిలో దేనికి లేదు."
        },
        {
          "title": "ఇందుకు ఉదాహరణగా.. ఓ ఆయుధాన్ని చాలాకాలం వాడకుండా ఓ మూల పడేస్తే, అది తుప్పుపట్టి పనికిరాకుండా పోతుంది. కానీ దాన్ని నిరంతరం వాడుతూంటే పదునుదేలి.. దాని పనితనాన్ని చూపిస్తుంది. అలాగే మనస్సు కూడా. అయితే., ఇక్కడ అందరికి మరో సందేహం రావచ్చు. ‘మనస్సు నిరంతరం ఏదో ఒక విషయం గురించి ఆలోచిస్తూనే ఉంటుంది కదా! మరి తపస్సు ఎలా అవుతుంది’ అని ప్రశ్న మదిలో కచ్చితంగా పుట్టుకొస్తుంది. అప్పుడు ఓ విషయాన్ని గ్రహించాల్సి వుంటుంది. ఆలోచించడం వేరు, ఆరాటపడడం వేరు. ఏదో ఒక విషయం గురించి ఆలోచించడాన్ని.., ఆరాటపడడం అనరు. చంచలమైన మనస్సును నియంత్రించి, ఒక నిర్దిష్ఠమైన లక్ష్యాన్ని దానికి నిర్దేశించి., ఆ దిశగా మనసును మళ్ళించడానికి పడే ఆరాటాన్నే.. ‘తపస్సు’ అంటారు. అది మంచి అయితే మంచి ఫలితాన్ని.., చెడు అయితే చెడు ఫలితాన్ని తప్పకుండా ఇస్తుంది. అందుచేతనే తపస్సు చేసే సాధకుడు మంచినే ఆశించి., విశ్వశాంతిని కాంక్షిస్తూ తపస్సు చేయాలి. అదే నిజమైన తపస్సు. ఇందుకు ప్రకృతి పరమైన ఆధారం కూడా వుంది. అదే.. సృష్టిలో అందమైన కీటకం ‘సీతాకోకచిలుక’."
        },
        {
          "title": <span class='highlight'>తపస్సుకు ప్రకృతి పరమైన ఆధారం:</span>,
        },
        {
          "title": "సాధారణంగా ఒక ప్రాణి నుంచి అదే విధమైన ప్రాణి పుడుతుంది. కానీ.. సీతాకోకచిలుక పెట్టే గ్రుడ్ల నుంచి సీతాకోకచిలుకలు రాకపోగా గొంగళిపురుగులు వస్తాయి. అవి చూడడానికి చాలా అసహ్యంగా ఉంటాయి. ఆ దశలో అది రాళ్ళలో, రప్పల్లో, తిరుగుతూ… ఆకులు తింటూ కాలం గడుపుతుది. కొంత కాలం గడిచాక తన జీవితం మీద రోత కలిగి… ఆహార, విహారాలు త్యజించి, ఎవ్వరికీ కనిపించని ప్రదేశనికి వెళ్లిపోయి., తన చుట్టూ ఓ గూడు నిర్మించుకుని, తపస్సమాధి స్థితిలోకి వెళ్లిపోతుంది."
        },
        {
          "title": "అలా కొంతకాలం గడిచాక, దాని తపస్సు ఫలించాక అది తన గూడు చీల్చుకుని బయటకు వస్తుంది. అప్పుడది గొంగళిపురుగులా కాకుండా అందమైన సీతాకోకచిలుకలా వస్తుంది. ఆకులు, అలములు తినకుండా. పూవుల్లో ఉండే మకరందాన్నే తాగుతుంది. ప్రకృతి ధర్మానికి కట్టుబడి గ్రుడ్లు పెట్టిన మరుక్షణం ఈ సంసార జగత్తులో చిక్కుకోక మరణిస్తుంది. అదీ తపస్సు ఇచ్చే ప్రతిఫలం. అలాగే తపస్సిద్ధి పొందిన మానవుడు ఈ సంసార లంపటంలో చిక్కుకోకుండా భగవన్నామామృత పానంతో తరిస్తాడు."
        },
        {
          "title": <span class='highlight'>తపస్సు చేస్తే పూర్వ జన్మ విశేషాలు తెలుస్తాయా:</span>,
        },
        {
          "title": "తపస్సు అంటే ఒక కార్యసాధన కోసం తపించడం. అది ఆధ్యాత్మికం కావచ్చు, శారీరక, మానసిక, వాచక తపస్సులు కావచ్చును. యక్ష ప్రశ్నలలో ఒకటైన ఈ ప్రశ్నకు ధర్మరాజు తన వృత్తి, కులధర్మం ఆచరించడం తపస్సు అని అంటాడు. మనసా, వాచా కర్మణా చేస్తున్న పని మీద శ్రద్ధ కనబరచడం తపస్సు. అది చిన్నప్పుడు మనం చదువు గురించి తపించడం కావచ్చు, పెద్దయ్యాక కావలసిన కామ్యం కొరకు తీవ్ర పరివేదన పొంది మన శక్తులన్నీ ఆ పని మీద కేంద్రీకరించి ప్రయత్నించడం. మనోవాక్కాయ కర్మలందు ఆధ్యాత్మిక చింతన చేస్తూ భగవంతుని గురించి తీవ్రంగా తపించడమే తపస్సు అవుతుంది."
        },
        {
          "title": "కొంచెం మనకు అర్ధమయ్యే చిన్న చిన్న పదాలలో ఈ విషయం మరికొంత చర్చిద్దాము. నేడు నీవు పొద్దున్న ఏమి చేసావు అంటే ఠక్కున చెప్పగలము. ఎందుకంటె అది మన మెమరీబ్యాంకు లో పైన దొరికే డేటా లాంటిది. ఒక మూడు రోజుల క్రితం ఈ సమయంలో ఏమి జరిగింది అని అడిగితే వెంటనే స్ఫురించదు. కానీ ఒక్క నిముషం మౌనాన్ని ఆశ్రయించి కొంత అంతర్ముఖులైతే ఆ సమాధానం దొరుకుతుంది. అదే ఒక నెల క్రితం జరిగిన విషయం అడిగితె మరికొంత ప్రయత్నం, మరికొంత అంతర్మధనం ద్వారా ఆ విషయం స్ఫురణకు వస్తుంది. మన మనస్సు ఇలా ఒకొక్క గదిలో ఒకొక్క విషయాన్ని భద్రపరచి మెమరీ లో వెనక్కు తోసేస్తుంది. ఆ విషయం తెలుసుకోవాలంటే పక్క వారిని అడిగితే తెలియకపోవచ్చు. కానీ ఆ సమాధానం మనలోనే ఉంది, కావలసినది కొంత తపస్సు."
        },
        {
          "title": "మన మనస్సు ఎన్నో విషయాలను మన ఇంద్రియాల ద్వారా మనకున్న అవగాహన రీత్యా గ్రహించి జాగ్రత్తగా భద్రపరుస్తుంది. మనకొచ్చిన కోరికలు కొన్ని బయట పెట్టనివి కల రూపంలో వాటిని మనకు నటింప చేసి రంజింపచేస్తుంది. ఇలా ఎన్నో ఎన్నో విషయాలను జాగ్రత్తగా తెరచి చదివి తీసి పారెయ్యడం (access and delete ) ధ్యానం చెయ్యడం వలన మొట్ట మొదటి లాభం. ఇలా మన మనస్సులో ఉన్న చెత్త తుడిచిపెట్టుకుపోగా మరింత ప్రశాంతమవుతుంది. ఇలా చెయ్యగా చెయ్యగా మనలోని ఎప్పటినుండో నిక్షిప్తమైన విషయాలనుండి విముక్తి పొందుతాము."
        },
        {
          "title": "ఒకరాత్రి కళ్ళు మూసుకుని తరువాత పొద్దున్న ఈ దేహంతో లేవడం నిద్ర. ఒక శరీరంలో కన్ను మూసి, మరొక శరీరంతో కన్ను తెరవడం పునర్జన్మ. ఒకే శరీరంతో అనుభవించిన విషయాలు తరువాత రోజుకు గుర్తుంటాయి. ఆ శరీరంతో వచ్చిన వాసనలు మరొక శరీరంలో ఉంటాయి. అంటే ఆ పూర్వ దేహంతో అనుభవించిన విషయాలన్నీ కంప్రేస్స్ (memory compression) చేసి మరొక శరీరంలోకి మోసుకుపోతాయి ఈ వాసనలు. అందుకే కొందరికి పుట్టుకతో తీపి ఇష్టం అవుతుంది, ఒకరికి పుట్టుకతో కోపం మెండుగా ఉంటుంది. ఈ వాసనలు చాలా బలీయమైనవి."
        },
        {
          "title": "వాటిని ప్రయత్నపూర్వకంగా మనం పోగొట్టుకోవాలి. అందుకు మంత్రజపమే సరైన సమాధానం అని పూజ్య గురువులు బోధిస్తుంటారు. ఒకరి తపస్సు తీవ్రతరమైనప్పుడు, ఈ జన్మ వాసనలు పోగొట్టుకుని, పూర్వ జన్మ విషయాల గదిని తెరచి ఆ వాసనలను పోగొట్టుకోగలుగుతారు (uncompress and clean). ఇది సద్గురు కృప ద్వారా సాధ్యమవుతుంది. ఇలా నేనెవరు అనే తీవ్రమైన తపస్సు చేసినవారికి ఈ సిద్ధులు కరతలామలకములు. అలా తమ పూర్వజన్మ విశేషాలన్నీ వారికి దృశ్యమానాలు అవుతాయి. చివరికి తమలో ఉన్న పరమాత్మను దర్శించుకుని, తమ చుట్టూ ఉన్న చైతన్య జగత్తు అంతా పరబ్రహ్మమే గోచరిస్తుంది వారికి. అటువంటి వారికి తమది మాత్రమె కాక అన్ని దేహాలజీవుల విషయాలు పూర్తిగా చూడగలరు. అటువంటి శక్తి తెలుసుకునే మార్గం కేవలం గురు,దైవ కృపవలన మాత్రమె సాధ్యం."
        },
        {
          "title": "సనాతన ధర్మం ఏదీ అసాధ్యం అని చెప్పదు. అంతా నీలో ఉన్న పరబ్రహ్మ లోనే ఉన్నది, అది తెలుసుకో. నిన్ను నువ్వు తక్కువ చేసుకోకు. ఎంతో పుణ్యం చేసుకున్నావు కాబట్టి నీకు మానవ జన్మ, విచక్షణా జ్ఞానం ఉంది అని నువ్వొక పరమాత్మ తురుపుముక్కవు అని ధైర్యం బోధిస్తుంది. తప్ప నువ్వు పాపంతో కుల్లిపోతున్నావు కాబట్టే మానవ జన్మ అని ఎక్కడా చెప్పదు. వివేకానందుల వారు చెప్పినట్టు మనకు ఉపనిషత్తులు బోధిస్తున్నది కేవలం ధైర్యం."
        },
        {
          "title": "ఉత్థిష్ఠ జాగ్రత ప్రాప్య వరాన్ని బోధత క్షురస్య ధార నిశితాదురాత్యయ – కధోపనిషత్ (Arise, Awake and Stop not until the goal is reached). మన మానవ జన్మ మనలోని దైవాన్ని అందుకోవడమే."
        },
        {
          "title": "కొంచెం శ్రద్ధ, మరికొంత సంయమనం, ఇంకొంచెం సంస్కారం, మరికాస్త జ్ఞానం, మరింత పట్టుదల ఉంటే జీవనయానమనే తపస్సు సాధ్యమే. మన సనాతన రథసారథులు సాధకులకోసం మోక్ష ద్వారాన్ని చేరుకోవడానికెన్నో సుగమమైన మార్గాలు చెప్పారు. అవి తెలుసుకోవడానికి మరీ అంత కష్టపడవలసిన పనిలేదు. ఆసక్తి ఉంటే చాలు, 'ఆ'శక్తి దానంతటదే మనల్ని ఆవహిస్తుంది. విజయసుధల్ని ఆహ్వానిస్తుంది. ఆ ఆసక్తిని కూడా చూపక నిరాసక్తులమై, బద్ధక చక్రవర్తులమైతే జీవితంలో ఇంక సాధించేదేంటి? భూమికి భారంగా, చరిత్రహీనంగా జీవించే హక్కు భగవంతుడు మనకివ్వలేదు!"
        },
        {
          "title": "భగవంతుణ్ని మనమేదైనా అడిగే బదులు, అడక్కుండానే మన అవసరాన్ని గ్రహించి ఆయనే తనంతతానుగా మనకు ఇచ్చే విధంగా 'అర్హత'ను మనం ఆర్జించడమే ఉత్తమమైన తపస్సు."
        },
        {
          "title": "నిత్యజీవన విధానంలోని అంశాలన్నింటినీ- అంటే- స్నానం, ధ్యానం, ఆహారం, నిద్ర, కర్తవ్యం మొదలైనవాటిని తపస్సులోని ప్రధానాంశాలుగా, పవిత్రమైన అంశాలుగా, భావించి, ఆచరించిననాడు మోక్షగవాక్షం మనకళ్ల ముందే ప్రత్యక్షమవుతుంది."
        },
      ],
      "title": "4. తపస్సు అంటే ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>జపం ఎలా చెయ్యాలి:</span>,
        },
        {
          "title": "మన ఇష్టదైవం యొక్క నామాన్ని కానీ., మంత్రాన్ని కానీ., ఒక క్రమపద్ధతిలో భక్తిగా జపించే విధానాన్నే జపం అంటారు. రోజుకు ఇన్నిసార్లు జపం చెయ్యాలనే సంఖ్యానియమం కూడా ఉంటుంది. ఒకవేళ అనుకోని ఇబ్బందులవల్ల ఆ రోజు జప సంఖ్య పూర్తి చేయలేని పక్షంలో., మరునాడు ఈరోజు మిగిలిన జపసంఖ్యను చేర్చి చేయవలసి ఉంటుంది. జపాన్ని ఏదో మొక్కుబడిగా చెయ్యకూడదు. సంఖ్య పూర్తిచెయ్యడమే ప్రధాన లక్ష్యంగా జపం చెయ్యకూడదు. భక్తి చాలా ప్రధానం. జపం చెయ్యడానికి ఒక పద్ధతి ఉంది."
        },
        {
          "title": <span class='highlight'>వాచికశ్చ ఉపాంశుశ్చ మానసస్త్రివిధః స్మృతః</span>,
        },
        {
          "title": <span class='highlight'>త్రయాణాం జపయఙ్ఞానాం శ్రేయాన్ స్యాదుత్తరోత్తరమ్</span>,
        },
        {
          "title": "జపం: వాచికము, ఉపాంశువు, మానసికము అని మూడు విధాలుగా ఉంటుంది."
        },
        {
          "title": "వాచికము: బయటకు వినిపించే విధంగా జపం చేసే పద్ధతిని ‘వాచికము’ అంటారు."
        },
        {
          "title": "ఉపాంశువు: బయటకు వినిపించకుండా, కేవలం పెదవులు కదుపుతూ నాలుకతో జపం చేసే విధానాన్ని ‘ఉపాంశువు’ అంటారు."
        },
        {
          "title": "మానసికము: నాలుక, పెదవులు కదలకుండా మౌనంగా మనస్సు లోలోపలే జపం చేసే విధానాన్ని ‘మానసికము’అంటారు."
        },
        {
          "title": "ఈ మూడింటిలో వాచికము కంటే ఉపాంశువు., ఉపాంశువు కంటే మానసికము మరింత శ్రేష్ఠము అని శాస్త్ర ప్రమాణము."
        },
        {
          "title": <span class='highlight'>హస్తౌ నాభిసమౌ కృత్వా ప్రాతస్సంధ్యా జపం చరేత్</span>,
        },
        {
          "title": <span class='highlight'>హృత్సమౌ తు కరౌ మధ్యే సాయం ముఖ సమౌ కరౌ</span>,
        },
        {
          "title": "ప్రాతః కాలమునందు చేతులు నాభి వద్దకు చేర్చి., మధ్యాహ్నమునందు చేతులు హృదయము వద్దకు చేర్చి., సాయంకాలమునందు చేతులను ముఖమునకు సమాంతరముగా ఉంచి జపం చేయవలెను. చందనపూసలతో, అక్షతలతో, పూవులతో, ధాన్యముతో, మట్టిపూసలతో జప సంఖ్యను లెక్కించకూడదు. లక్క, దర్భ, సిందూర పూసలతో కానీ., ఎండిన ఆవుపేడ పూసలతో కానీ రుద్రాక్ష, తులసి, స్ఫటిక పూసలతో కానీ చేసిన జపమాలలతో జప సంఖ్యను లెక్కించుట శ్రేష్ఠము."
        },
        {
          "title": <span class='highlight'>జపమాల:</span>,
        },
        {
          "title": "పమాలలో 108 పూసలు ఉంటాయి. మాల రెండు కొసలు కలిపే పూసను ‘సుమేరుపూస’ అంటారు. జపము చేయునప్పుడు జపమాల కనిపించకుండా వస్త్రాన్ని కప్పి చేయాలి. కానీ, ఆ వస్త్రం తడిగా ఉండకూడదు. జపమాలను అనామిక వ్రేలు (ఉంగరపు వ్రేలు) పైనుంచి బొటనవ్రేలుతో పూసలను లెక్కించవలెను. చూపుడువ్రేలును ఉనయోగించరాదు. సుమేరుపూసను దాటి ముందుకు పోరాదు. సుమేరేపూస దాకా వచ్చిన తర్వాత మాలను వెనుకకు త్రిప్పి  జపము చేయవలెను. ఒకవేళ జపమాల చేతినుంచి జారి క్రిందపడినచో, ఆ జపసంఖ్య లెక్క లోనికి రాదు. మరల జపమాల మెదటి నుంచి జపము చెయ్యాలి. "
        },
        {
          "title": "జపమాల కాలికి తగిలిన ఎడల, దానిని నీటితో కడిగి రెట్టింపు సంఖ్యలో జపం చెయ్యాలి. జపము చేయునప్పుడు మాట్లాడుట కానీ, కదులుట కానీ చేయరాదు. ఒకవేళ తప్పనిసరిగా మాట్లాడవలసిన పరిస్థితి వచ్చినప్పుడు, క్షమాభావనతో భగవంతుని స్మరించి తిరిగి జపం ప్రారంభించాలి. గృహమునందు జపము చేసిన దానికన్న గోశాలయందు వందరెట్లు, వనములందు లేదా తీర్థస్థానములందు వేయిరెట్లు, పర్వతములమీద పదివేలరెట్లు, నదీతీరములందు లక్షరెట్లు, దేవాలయములందు కోటిరెట్టు, శివలింగము దగ్గర అనంతమైన పుణ్యఫలము లభించునని శాస్త్ర ప్రమాణము."
        },
        {
          "title": <span class='highlight'>జపం ఎందుకు చేస్తారు:</span>,
        },
        {
          "title": "కలియుగంలో భక్తులకు మోక్షాన్ని ప్రసాదించే సాధనంగా జపాన్ని పేర్కొంటారు. అందుకు నిదర్శనంగా మన ఆధ్మాత్మిక గ్రంథాలలో జపం యొక్క విశిష్టత అడుగడుగునా ప్రస్తావనకి వస్తూ ఉంటుంది. అలాంటి జపం గురించి కొన్ని విశేషాలు"
        },
        {
          "title": "జపించడం అంటే తనలో తాను స్మరించుకోవడం అన్న అర్థం వస్తుంది. ‘జపం’ అంటే మాటకు - ‘జ’కారో జన్మవిచ్ఛేదః ‘ప’కారః పాపనాశనః అంటూ ప్రతిపదార్థం చెప్పిన సందర్భాలూ ఉన్నాయి. ఒక్క మాటలో చెప్పాలంటే తనకు ఇష్టమైన భగవంతుని నామాన్ని కానీ మంత్రాన్ని కానీ తరచూ స్మరించుకోవడమే జపం."
        },
        {
          "title": "జపం గురించిన ప్రస్తావన అనాదిగా వినిపిస్తూనే ఉంది. వేదాలలో తొలిసారి కనిపించిన ఈ మాట మనుస్మృతి, పతంజలి యోగసూత్రాలలో కూడా కనిపిస్తుంది. ఇక భగవద్గీతలో శ్రీకృష్ణుడు యజ్ఞాలలో తాను జపయజ్ఞాన్నని స్పష్టంగా పేర్కొంటాడు."
        },
        {
          "title": <span class='highlight'>మహర్షీణాం భృగురహం గిరామస్మ్యేకమక్షరమ్|</span>,
        },
        {
          "title": <span class='highlight'>యజ్ఞానాం జపయజ్ఞోఽస్మి స్థావరాణాం హిమాలయః (10.25)</span>,
        },
        {
          "title": "భారతీయ సంస్కృతి ప్రభావంతో సిక్కు, క్రైస్తవ, బౌద్ధ, జైన మతాలలో సైతం వేర్వేరు రూపాలలో ఈ జపం కనిపిస్తూ ఉంటుంది."
        },
        {
          "title": "జపాన్ని మూడు రకాలుగా పేర్కొంటారు. పైకి వినిపించేట్లుగా చేసే జపాన్ని వాచక జపం అంటారు. వినపడీ వినపడనట్లుగా చేసుకునే జపాన్ని ఉపాంశు జపం అంటారు. ఏమాత్రం సద్దు చేయకుండా మనసులోనే సాగిపోయే జపాన్ని మానసిక జపం అంటారు. వీటిలో ఒకదాన్ని మించిన ఫలితం మరో జపం ఇస్తుందని ఉపనిషత్తుల మాట. అంటే మనసులో నిశ్చలంగా సాగిపోయే జపానికే మన పెద్దలు ప్రాముఖ్యతని ఇచ్చారన్నమాట."
        },
        {
          "title": "జపం అంటేనే ప్రార్థనకు క్లుప్తమైన రూపం. కాబట్టి మనకి ఇష్టమైన దేవత గురించిన స్మరణను జపంగా మలచుకోవచ్చు (ఉదా॥ ఓం నమశ్శవాయ). లేదా ఎవరన్నా గురువుగారు దీక్ష ద్వారా ఒసగిన మంత్రాన్ని జపించవచ్చు. అదీ కాదంటే మనసుకి నచ్చిన ఏదన్నా వాక్యాన్ని (ఒం శాంతిః శాంతిః శాంతిః) స్మరించుకోవచ్చు. దీనికి ఫలానా సమయంలో చేయాలన్న కాలనియమం కానీ, ఫలానావారే చేయాలన్న కట్టడి కానీ ఏమీ లేదు. కావల్సిందల్లా నిర్మలమైన మనసు మాత్రమే!"
        },
        {
          "title": "జపంతో నిరంతరం భగవన్నామ స్మరణ చేయడం వల్ల, పరిపరి విధాలా పరుగులుదీసే ఇంద్రియాలు స్థిమితపడతాయి. మనం ఏ మంత్రాన్నైతే జపిస్తున్నామో అది మన మనసులోకి అంతకంతకూ గాఢంగా చొచ్చుకుపోతుంది. తొలుత బలవంతంగా కనిపించే ఈ ప్రక్రియ ఒక సాధనగా మారిపోతుంది. ఇలా కొన్నాళ్లు సాధన చేసిన పిమ్మట సాధకుడు ‘అజపజపం’ అనే స్థితిని చేరుకుంటాడు. అంటే జపం చేయకున్నా కూడా మనసులోని ఒక భాగంలో నామస్మరణ నిర్విరామంగా సాగిపోతూనే ఉంటుంది."
        },
        {
          "title": "మిగతా జీవుల సంగతేమో కానీ మనిషికి శబ్దానికీ మధ్య గాఢమైన సంబంధం ఉంది. మనిషి శబ్దం ద్వారానే తన భావాలను వ్యక్తపరుస్తాడు. శబ్దాన్ని వినడం ద్వారానే ఎదుట ఏం జరుగుతోందో అవగతం చేసుకుంటాడు. మనిషి వినే మాటకి అనుగుణంగా అతనిలోని మనసు ప్రతిస్పందిస్తుంది. అందుకనేనేమో ఈ సృష్టి యావత్తూ ఓంకారం అనే శబ్దం నుంచి ఉత్పన్నం అయిందన్న వాదనలు హిందూ ధర్మంలో వినిపిస్తుంటాయి. అలాంటి శబ్దాన్ని ఉపాసించడం ద్వారా మనసుని లయం చేసుకోవడమే జపంలోని అంతరార్ధం. అది నిర్విరామంగా సాగినా, జపమాల సాయంతో సాగినా.... మన జీవితాన్ని తరింపచేసే ఒక నామాన్ని, వీలైనప్పుడల్లా కాసేపు తలచుకోమని చెప్పడమే జపసాధనలోని పరమార్థం."
        },
        {
          "title": <span class='highlight'>జపం చేసేటప్పుడు మనస్సుని లగ్నం చేసే విధానం:</span>,
        },
        {
          "title": "మనస్సును ఒక చోట నిలపడం అంత సామాన్యమైన విషయం కాదు. మనసు స్వభావమే చంచలత్వం. అది ఎప్పుడు స్థిరత్వానికి లోనవుతుందో ఎప్పుడు సమాధి స్థితికి మీరు వెళ్లినట్లే. కానీ అది కొందరికి తాత్కాలికం. కొద్ది పాటి అనుభవం కలిగి మరల చంచలమౌతుంది. ఎంతో సాధన తరువాత చాలా కొద్దిమంది యోగులకు (యుగపురుషులకు) మాత్రమే నిరంతరం మనసు ఆ భగవంతుని యందులగ్నమై ఉంటుంది."
        },
        {
          "title": "మనసు ఎప్పుడు నిశ్చలమౌతుంది? ఎప్పుడు చంచలమౌతుంది? అనేది ఎంతో సాధన ద్వారా మాత్రమే తెలుసుకోగలిగే విషయం. ఎవరికి వారు మాత్రమే తెలుసుకోవలసిన విషయం. అలా మననాత్ త్రాయతే ఇతి మంత్రః పదే పదే పఠించడం (మననం చేయడం) వలన రక్షణ కలిగించునది  మంత్రము అన్నారు.  గాయత్రీ లేదా మరో దేవతా  జపము అనేది మంత్ర ప్రథానమైనది. అందు మంత్రమును స్పష్టంగా ఉఛ్చరించుట ప్రధానము. ప్రస్తుతానికి జపం చెయ్యడంలోని వివిధ స్థితుల గురించి చూద్దాం."
        },
        {
          "title": "1. పెదాలతో శబ్దం బయటకు వచ్చేటట్టు జపం చెయ్యడం ప్రాథమికం. ఇది మొదటి మెట్టు. ప్రాథమికం అన్నారు కదా అని దీనికి ఏ శక్తీ కలగదు, ఏకోరికా సిద్ధించదు అనుకుంటే పొరపాటు పడినట్లే. కేవలం బ్రాహ్మణుడు వేదాన్ని చదివినంత మాత్రముచేతనే జన్మరాహిత్య స్థితిని పొందుతాడు అని ఆర్యోక్తి. (ఇక కోరిన కోరికలు తీరడంలో ఎటువంటి సందేహమూ లేదు. అయితే ఫలితాలను ఇవ్వడంలో ఒకదానికంటే మరొకటి ఉత్తమం అని తెలుసుకోవడానికే ఈ సూచన చేశారు పెద్దలు) ప్రాధమికం అనే దృష్టితో  ఒకేసారి ఉత్తమ జపం చెయ్యాడానికి ప్రయత్నించి బోర్లా పడిపోతారు చాలామంది సాధకులు."
        },
        {
          "title": "2. పెదాలు కదుపుతూ శబ్దం బయటకు రాకుండా తనకు మాత్రమే వినపడేటట్లు మంత్రం చదవడం ద్వితీయ స్థితి. ఇది సాధనలో రెండవమెట్టు. ఈ స్థితిలో మంత్రం మీకు (జపం చేసేవారికి ) మాత్రమే వినపడాలి. స్వరాలను పదేపదే గుర్తు చేసుకుంటూ సాధన చెయ్యాలి. అలా కొన్ని రోజుల సాధన (మంత్రం బాగా నడుస్తున్నది అన్నది నమ్మకంగా అనిపించిన) తరువాత మూడవమెట్టుకి వెళ్లాలి."
        },
        {
          "title": "3. మనసుతో పదే పదే స్ఫురణకు తెచ్చుకోవడం (మననం చెయ్యడం) మధ్యమం. పైరెండు స్థితులకంటే ఈ మూడవ స్థితి ( మెట్టు ) చాలా కష్టమైనది. దీనిని అధిగమించడానికి కొన్ని నెలలు పట్టవచ్చు. కొన్ని సంవత్సరాలు పట్టవచ్చు. కొన్ని జన్మలు పట్టవచ్చు. ఈ స్థితిలోనే మనసు వేరే విషయాలపైకి వెళ్లడం ఎక్కువగా ఇబ్బందిపెడుతూ ఉంటుంది. మనసులో జపం చేయడం అంటే స్ఫురణకు తెచ్చుకోవడం అనేవిషయం గుర్తుంచుకోవాలి."
        },
        {
          "title": <span class='highlight'>మరో ఆలోచనలో పడడం:</span>,
        },
        {
          "title": "ఒకసారి స్మరించడం తేలిక. వందసార్లు గుర్తుకు తెచ్చుకోవడం పెద్ద కష్టం కాదు. కానీ వేలసార్లు జపించాలి అని సంకల్పించినప్పుడు ఈ సమస్యలు స్పష్టంగా కనిపిస్తాయి. ఒకేసారి వేలసంఖ్యలో జపం చెయ్యాలని సంకల్పించినప్పుడు. సమయం ఎక్కువ పడుతుంది. అంత సమయం మనసు స్థిరంగా ఉండడానికి ఒకేసారి అంగీకరించదు. వ్యతిరెకిస్తుంది. జాగ్రత్తగా ఉండక పోతే విపరీతాలు జరిగే ప్రమాదమూ ఉంది. (కనుక ఈ స్థితిలో ఎప్పటికప్పుడు గురువులను, అనుభవఙ్ఞులను సంప్రదిస్తూ ఉండాలి)  ఎక్కువసేపు మనసు నిలిచి ఉండదు. కానీ మంత్రాన్ని పదే పదే గుర్తుకు తెచ్చుకోవడం."
        },
        {
          "title": "అనే ప్రక్రియని దానికి సాధన ద్వారా అలవాటు చెయ్యాలి. మొదటిలో కష్టం గా ఉన్నా రానురాను సానుకూల పడుతుంది. అందువలన మొదట ఓ వందసార్లు జపం చెయ్యడంతో మొదలుపెట్టి క్రమక్రమంగా జపసంఖ్యను పెంచుకుంటూ పోవాలి."
        },
        {
          "title": "ఒక వందసార్లు జపం సరిగానే చేస్తున్నాము కదా అని సంఖ్య ఒకేసారి పెంచి రోజూ ఓ వెయ్యిసార్లు జపం చేస్తాను అని దీక్షపూనినప్పుడు మరో సమస్యవలన మంత్రం తప్పులు దొర్లడం కనిపిస్తుంది."
        },
        {
          "title": <span class='highlight'>మనసు తొందర పడడం:</span>,
        },
        {
          "title": "నేను రోజుకు వెయ్యిసార్లు నలభైఒక్క రోజులు చేస్తాను అని సంకల్పం చేసుకున్నారు. కానీ ఆ సంఖ్య మీ మనసుకు భారీగా ఉండి ఉండవచ్చు, లేదా ఏదో ఒక రోజు ఆఫీసుకు లేటవుతుండవచ్చు. అందువలన మనసు తొందర పెడుతుంది. త్వరగా పూర్తి చెయ్యాలి అని అనిపిస్తుంది. ఆ తొందరలో మంత్రాన్ని ఏదో ఒకలా పలకడం, పరధ్యానంగా చెయ్యడం మొదలవుతుంది. మనసు పెట్టే తొందరను బట్టి అక్షరాలు, పదాలు  లేదా వాక్యాలే దాటవేయడం జరుగుతుంది. అలా జపిస్తే మంత్రం ఫలితానివ్వడం అటుంచి అపకారం కలిగే ప్రమాదముంది."
        },
        {
          "title": "కనుక మనసు సిద్దపడక పోయినా, సమయం లేక పోయినా నేను వెయ్యిచయ్యాలని సంకల్పించాను అది పూర్తిచెయ్యవలసినదే అని మంకు పట్టు పట్టి కూర్చోకూడదు. చెయ్యగలిగిన జప సంఖ్యమాత్రమే పూర్తి చెయ్యాలి. ముఖ్యమైన విషయం ఏమిటంటే మనసు ఎక్కువ సమయం జపంలో ఉండడానికి సిద్ధపడాలంటే కూడా మన మొండి పట్టుదలే కారణం. అది ఎలాగ అన్నది ఎవరికి వారే తెలుసుకోవాలి. అన్ని విషయాలు మాటలతో చెప్పలేము.  పైరెండు స్థితులలో మంత్రం తప్పులు పోవడానికి  త్వరగా లక్షల జపాన్ని పూర్తిచెయ్యాలి అన్న సంకల్పమే కారణం."
        },
        {
          "title": "4. ఇక మంత్రము ఒక దేవత లేదా గురువు ఉపదేశిస్తున్నట్లుగా కర్ణములకు ( చెవులకు ) వినపడడం ఉత్తమం జపం."
        },
        {
          "title": "ఈ స్థితి కలగడానికి చాలా సాధన కావాలి. కొంతమందికి కలలో కొన్ని మంత్రాలు ఉపదేశం ఇవ్వబడతాయి. వాటిని సాధన చెయ్యడం ద్వారా జన్మరాహిత్యాన్ని పొందగలరు."
        },
        {
          "title": "మంత్రము - ఉపాస్య దేవత - ఉపాసకుడు వేరువేరు అనేస్థితిలో మొదలైన ఈ ప్రయాణం ఆమూడూ ఐక్యమై ఒకటే శక్తి గా రూపొందడంతో పరిపూర్ణమౌతుంది."
        },
        {
          "title": "పైవిషయాలన్నీ గమనించిన మీదట కొన్ని విషయాలు తెలుస్తాయి:"
        },
        {
          "title": "1) మొదట గురువు  మంత్ర దీక్షను పూని వారి సమక్షములో కొంత సాధన చెసిన తరువాత స్వయముగా ప్రయత్నించాలి."
        },
        {
          "title": "2) మూడవస్థితి ప్రారంభకులకు మొదట సంఖ్యానిర్ణయముతో గాక మానసిక నిశ్చలమును బట్టి సమయ నిర్ణయము ఉత్తమము. అంటే మనసు నిలచినంత సమయము జపం చెయ్యాలి అనే సంకల్పముతో మానసిక జపమును ( పునశ్చరణ) చెయ్యాలి.  క్రమముగా నూటఎనిమిదిసార్లు, మూడువందలు, ఐదువందలు వెయ్యి అని సంఖ్యా నిర్ణయముతో సాధన చెయ్యాలి."
        },
        {
          "title": "3) సాధనమాత్రమే ఆసాధ్యాలను సుసాధ్యం చెయ్యగలదు. మనసు పదేపదే వేరే విషయాలమీదకి వెళుతున్నది కదా అని నీరుగారిపోక మళ్లీ మళ్లీ ప్రయత్నించాలి. అలా జపం చేస్తున్నప్పుడు వేరే విషంమీదకి మనసు మళ్లింది అని ఎన్ని సార్లు గుర్తుపట్టగలిగితే మీకు అంత  స్థిరమైన సంకల్పం ఉన్నట్లు. మళ్ళిన మనసుని తీసుకువచ్చి మళ్లీ మంత్రం గుర్తుకు తెచ్చుకోవడం మీద పెట్టాలి. ఆ మంత్రము యొక్క అర్థము మీద దృష్టి నిలపాలి. ఆ మంత్ర అధిష్ఠాన దేవతను దర్శించే ప్రయత్నం చెయ్యాలి. కనుక పట్టువదలని సాధన మాత్రమే మీ జీవితాన్ని తరింపచెయ్యగలదు."
        }
      ],
      "title": "5. జపం ఎలా చెయ్యాలి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>మన ముగ్గులు :</span>,
        },
        {
          "title": "ఇంటి గడప ముందు ముగ్గులో భాగంగాగీసే రెండు అడ్డగీతలు ఇంటి లోనికి దుష్టశక్తులను రాకుండా నిరోధిస్తాయి."
        },
        {
          "title": "ఇంట్లోఉన్న లక్ష్మీదేవి బయటకు వెళ్ళ కుండా చూస్తాయి."
        },
        {
          "title": "ముగ్గువేసి దానికి నాలుగువైపులా రెండేసి అడ్డగీతలు గీస్తే అక్కడ శుభ కార్యాలు, మంగళకరమైన పనులు జరుగుతున్నాయని గుర్తు! పండుగల సమయంలో ఈ విధంగా ఖచ్చితంగా వేయాలి."
        },
        {
          "title": "ఏదేవతపూజచేస్తున్నా దైవాన్నిఉంచే పీట మీద మధ్యలో చిన్న ముగ్గు వేసినా నాలుగు వైపులా రెండేసి గీతలను తప్పక గీయాలి."
        },
        {
          "title": "నక్షత్రం ఆకారం వచ్చేలా గీతలతో వేసిన ముగ్గు భూత, ప్రేత, పిశాచాలను ఆ దరిదాపులకు రాకుండా చూస్తుంది. అంతే కాదు, మనం వేసే పద్మాలు,చుక్కల ముగ్గులలో కూడా మనకుతెలీని అనేక కోణాలు దాగి ఉన్నాయి.అవి కేవలం గీతలే కాదు,  యంత్రాలు కూడా!యంత్ర,తంత్ర శాస్త్ర రహస్యాలతో కూడి ఉండడం వలన మనకు హాని కలిగించే చెడ్డశక్తులను దరిచేరనీయవు. అందుకే ఏ ముగ్గునైనా తొక్కకూడదు."
        },
        {
          "title": "తులసి మొక్క దగ్గర అష్టదళపద్మం వేసి దీపారాధాన చేయాలి!"
        },
        {
          "title": "యజ్ఞయాగాదులలో యజ్ఞగుండం మీద నాలుగు గీతలతో కూడిన ముగ్గులేయాలి. దైవకార్యలలో కూడా నాలుగు గీతలతో కూడిన ముగ్గులు వేయాలి."
        },
        {
          "title": "నూతన వధూవరులు తొలిసారి భోజనం చేసే సమయంలో వారి చుట్టు ప్రక్కల లతలు, పుష్పాలు, తీగలతో కూడిన ముగ్గులు వేయాలి!"
        },
        {
          "title": "దేవతా రూపాలను, ఓం, స్వస్తిక్, శ్రీ గుర్తులను పోలిన ముగ్గులు వేయ కూడదు, ఒకవేళ వేసినా వాటిని తొక్కకూడదు."
        },
        {
          "title": "ఏ స్త్రీ అయితే దేవాలయంలోనూ, అమ్మవారు, శ్రీ మహావిష్ణు వు ముందు నిత్యం ముగ్గులు వేస్తుందో, ఆస్త్రీకి ఏడు జన్మలవరకు వైధవ్యం రాదని, మరియు సుమంగళిగానే మరణిస్తుందని దేవీ భాగవతం, బ్రహ్మాండపురాణం చెబుతున్నాయి."
        },
        {
          "title": "పండుగ వచ్చింది కదా అని, నడవ డానికి చోటు లేకుండా వాకిలంతా ముగ్గులు పెట్టకూడదు!"
        },
        {
          "title": "ముగ్గులు రోజు వేయలేక పెయింట్ పెట్టేస్తాము.దాన్ని ముగ్గుగా శాస్త్రం అంగీ కరించదు. ఏరోజుకారోజు బియ్యపు పిండి తో ముగ్గు పెట్టాలి!"
        },
        {
          "title": "నిత్యం ఇంటి ముందు, వెనుక భాగంలో, తులసి మొక్క దగ్గర దీపా రాధన  చేసే ప్రదేశంలో ముగ్గు వేయాలి."
        },
        {
          "title": "ముగ్గు పాజిటివ్ / దైవ శక్తులను ఇంట్లోకి ఆకర్షిస్తుంది."
        },
        {
          "title": "ముగ్గులు శుభసూచకాలుగా పని చేస్తాయి."
        },
        {
          "title": "పూర్వం రోజూ సాధువులు,సన్యాసులు బ్రహ్మచారులు ఇల్లిల్లూ తిరిగి బిక్ష అడిగే వారు.ఏఇంటిముందైనా ముగ్గులేదంటే ఆ ఇంటికి వేళ్ళేవారు కాదు. వారే కాదు అడ్డుక్కునే వారు కూడా ముగ్గు లేని ఇళ్ళకు వెళ్ళి అడ్డుక్కునే వారు కాదు."
        },
        {
          "title": "ముగ్గు లేదంటే అక్కడ అశుభం జరిగిందని గుర్తు! అందుకే మరణించి న వారికి శ్రాద్ధకర్మలు చేసే రోజున ఉదయం ఇంటిముందు ముగ్గువేయరు. శ్రాద్ధకర్మ పూర్తైన వెంటనే, అది మధ్యా హ్నమైనా ముగ్గు వేస్తారు."
        },
        {
          "title": "ముగ్గులు వెనుక సామాజిక, మానసిక, ఆరోగ్య, ఆధ్యాత్మికమైన అనేక రహస్య కోణాలు దాగి ఉన్నాయి. మనం ఆచరించే ఏఆచారమూ మూఢనమ్మకం కాదు. మన ఆచార, సంప్రదాయాలన్నీ అనేకా నేక అర్ధాలు, పరమార్ధాలతో కూడినవి."
        }
      ],
      "title": "6. మన ముగ్గులు వెనుక అనేక రహస్య కోణాలు ?"
    }
  ],
  "Bhavishyavaani": [
    {
      "CatID": [
        {
          "title": <span class='highlight'>జాతకం అంటే ఏమిటి:</span>,
        },
        {
          "title": "ఏ మనిషికైనా భవిష్యత్తు గురించి కొద్దో గొప్పో బెంగ ఉండే ఉంటుంది. రేపు తనకు జరగబోయే శుభాశుభాలను గురించి తెలుసుకోవటం, ఏవైనా బాధలుంటే వాటికి నివారణోపాయాలను వెతుక్కోవాలనుకోవటం, ప్రతిక్షణం సుఖసంతోషాలతో జీవించాలనుకోవటం మనిషి నైజం. ఆ సుఖవంతమైన జీవితం అన్వేషణలోనే ఎన్నో రకాల శాస్త్రవిషయాలను కనుక్కోవటం జరుగుతున్నది. అయినప్పటికి భవిష్యత్తును తెలుసుకోవాలన్నా, దానిని సుఖవంతముగా మార్చుకోవాలన్నా అది ఒకే ఒక శాస్త్రంతోనే సాధ్యమవుతుంది."
        },
        {
          "title": "అదే జ్యోతిష శాస్త్రం.జ్యోతిష్య శాస్త్రం ద్వారా మనము జన్మించిన సమయానికి ఖగోళములోని గ్రహస్థితులను సూచిస్తూ వేయబడే చక్రాన్నే జాతకము అంటారు. దీనినే జాతకచక్రము, జన్మకుండలి, హోరోస్కోప్‌ ఇలా వివిధ రకాల పేర్లతో ఆయా ప్రాంతాలవారు సంబోధిస్తుంటారు. ఒక వ్యక్తి జన్మించిన సమయము, ప్రదేశము ఆధారముగా జాతకచక్రము గణించబడుతుంది. ఖగోళములోని గ్రహస్థితులను గణితాధారముగా లెక్కించి, ఆయా రాశి, నక్షత్ర, భావాలలో ఉన్న గ్రహాల ఆధారముగా భవిష్యత్తు చెప్పబడుతుంది.దీని గణనలో కాని, జన్మించిన సమయములో కాని తప్పు జరిగినట్లయితే అది ఆ నిర్దేశిత వ్యక్తి జాతకం కాక వేరే వారి జాతకం అవటమే కాకుండా, ఈ వ్యక్తికి చెప్పబడ్డ భవిష్య ఫలాలన్నీ తప్పే అవకాశం ఉంటుంది.కాబట్టి భవిష్యత్తు తెలుసుకోవలనుకుంటే జాతక చక్రము అత్యావశ్యమైనదిగా చెప్పబడింది."
        },
        {
          "title": "జ్యోతిషమనే మహాసముద్రములో జాతకము ఒక నీటి బిందువులాంటిది. అటువంటి జాతకచక్రము వేయటానికి ముందు మన రాశి, నక్షత్రములను తెలుసుకోవటం ఎలాగో నేర్చుకుందాము. ఈ జ్యోతిషపాఠాలు క్రమం తప్పకుండా నేర్చుకునే ప్రయత్నం చేయండి. ఒక పాఠం చదవకపోయినా ఎంతో సమాచారాన్ని కోల్పోయినవారవుతారు.జన్మ రాశి - నక్షత్రం తెలుసుకునే విధానంమన రాశి, నక్షత్రం తెలుసుకోవాలంటే మనం పుట్టిన సంవత్సరానికి గణించబడ్డ దృగ్గణిత పంచాంగం మన వద్ద ఉండాలి. (మీరు జాతక సంబంధ ఏ గణితం చేసినా దృగ్గణిత పంచాగములతోనే చేయండి). ఆ పంచాంగములో ప్రతి రోజు తిథి, వార, నక్షత్ర, యోగ మరియు కరణాల అంత్యసమయాలు ఇవ్వబడతాయి."
        },
        {
          "title": "మీకు ప్రస్తుతం చంద్రస్థితి తెలిస్తే సరిపోతుంది. మీరు పుట్టిన రోజున చంద్రుడు ఏ రాశిలో ఉంటే అదే మీ జన్మరాశి అవుతుంది."
        },
        {
          "title": "ఉదా: తేది 26-03-2004 రోజున మధ్యాహ్నం 2 గంటలకు ఒకరు జన్మించారనుకోండి. ఆ రోజు ఆంధ్రపత్రిక (పిడపర్తి వారి) పంచాంగములో ఉదయం 06:58 వరకు కృత్తికా నక్షత్రం ఉన్నది.అంటే ఉదయం 06:58 నుంచి రోహిణి నక్షత్రం ఆరంభమవుతున్నది. ఇది తెల్లవారి ఉదయం 10:01 ని. వరకు ఉన్నది. అంటే 26-03-2004 ఉదయం 06:58 నుంచి తెల్లవారి(27-03-2004) ఉదయం 10:01 మధ్యలో ఎవరు జన్మించినా వారి నక్షత్రం రోహిణి అవుతుంది. రోహిణి నక్షత్రం వృషభరాశిలో ఉంటుంది. కనుక ఈ రోజు ఎవరు జన్మించినా వారిది రోహిణీనక్షత్రం, వృషభరాశి అవుతుంది.మీరు జన్మించిన సంవత్సర పంచాంగంలో, మీరు పుట్టిన తేదీకి ఏ రాశి, నక్షత్రాలున్నాయో చూడండి"
        }
      ],
      "title": "1.జాతకం అంటే ఏమిటి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>జాతకం లేని వారికి:</span>,
        },
        {
          "title": "జాతకం లేని వారికి శాంతులు అంటే పుట్టిన సమయం లేని వారికి. ఐతే జాతకం ఉన్న వాళ్ళుకూడా చేసుకోవచ్చును."
        },
        {
          "title": <span class='highlight'>ఆదిత్య హృదయం:</span>,
        },
        {
          "title": "ఇది సూర్యునికి సంభందించినది. ఈ ఆదిత్య హృదయం రామ రావణ యుద్ధ సమయంలో అగస్త్య మహర్షి రామునికి ఉపదేసించినాడు. దీనిని రోజూ ప్రాతః సమయమున పటించుట వలన ఆయురారోగ్యాలను, అష్ట ఐ స్వర్యాలను పొందుతారు. మరియూ మనిషిలో దాగిఉన్న కామ,క్రోధాది అంతః శత్రువులను నాశనం చేస్తుంది.పాపాలను నాశనం చేస్తుంది. చింతల నుండి, దుఃఖముల నుండి ఉపశమనం కలిగిస్తుంది. ప్రతి నిత్యం జపిస్తే విజయం తప్పక లభిస్తుంది. ఇది పటించిన పిదపనే రాముడు, రావణుని పై విజయం సాదించాడు.గోధుమలతో చేసిన పదార్ధములు,క్యారెట్,రాగి చెంబులో వాటర్ త్రాగటం వలన కూడ సూర్య గ్రహా దోషాలు తొలుగుతాయి."
        },
        {
          "title": <span class='highlight'>రుణ విమోచక అంగారక(కుజ) స్తోత్రం:</span>,
        },
        {
          "title": "జీవితంలో మనకు ఎదురైనా అనేక ఇబ్బందులకు అప్పులు చేస్తూ ఉంటారు. వాటిని తీర్చలేక ఇబ్బందులు పడుతుంటే రుణ విమోచక అంగారక(కుజ) స్తోత్రం నలుబై ఒక రోజులు పారాయణ చేస్తూ ,నవగ్రహాలకు రోజూ ఇరవై ఏడు ప్రదక్షిణలు చెయ్యాలి. చివరి రోజు కందులు,యెర్ర గుడ్డ,ధనము దక్షిణగా పెట్టి,కుజునకు మీపేరు మీద అష్టోత్తరం చేఇంచండి. మీ అప్పులు తప్పక తీరు తాయి."
        },
        {
          "title": <span class='highlight'>విష్ణు సహస్ర నామ స్తోత్రం:</span>,
        },
        {
          "title": "మీకు వ్యాపారంలో తరచూ నష్టాలు వస్తూ, అప్పులు వసూలుకాకుండా ఉండటం జరుగుతోందా? ఐతే మీరు విష్ణు సహస్ర నామ స్తోత్రం నలుబై ఒక్క రోజులు పారాయణ చెయ్యండి. సాయంత్రం వేళ రోజూ చేస్తే ఇంకా మంచిది. చివరి రోజు విష్ణు ఆలయానికి వెళ్లి గోత్ర నామాలతో స్వామికి అష్టోత్తరం చేఇంచండి. మీ భాదలు తగ్గి వ్యాపారాభివృద్ధి కలుగుతుంది."
        },
        {
          "title": <span class='highlight'>సర్ప దోష నివారణ పూజ:</span>,
        },
        {
          "title": "మీకు వివాహమై ఎంతో కాలమైనా సంతానము లేదా? ఐతే మీరు ఒకసారి కాళహస్తి వెళ్లి రాహు,కేతు,కుజ గ్రహాలకు సర్ప దోష నివారణ పూజ చేయిన్చండి. తర్వాత ఎక్కడైనా నాగ ప్రతిష్ట చేఇంచండి. కర్నాటక రాష్ట్రంలో నున్న విదురాస్వద్ధలో చేఇస్తే ఇంకా మంచిది. "
        },
        {
          "title": <span class='highlight'>సంతాన గోపాలకృష్ణ వ్రతం:</span>,
        },
        {
          "title": "సంతాన గోపాలకృష్ణ వ్రతం నియమ నిబంధనలతో ఒకసారి మీ ఇంటిలో చెయ్యండి. వీలుంటే రెండు శాంతి ప్రక్రియలు చేస్తే ఇంకా మంచిది. తప్పక సంతానం కలుగుతుంది."
        },
        {
          "title": <span class='highlight'>రుక్మిణి కల్యాణం పారాయణ:</span>,
        },
        {
          "title": "వివాహం ఆలస్య మవుతోందా? ఐతే మీరు రుక్మిణి కల్యాణం పారాయణ చెయ్యండి.(లేదా)"
        },
        {
          "title": "నలుభై ఒక్క రోజులు ,రోజుకి నలుభై ఒక్క ప్రదక్షిణలు నవగ్రహాలకు చేసి, చివరి రోజు నవగ్రహాలకు పూజ చెయ్యండి.ఐతే నవగ్రహాలకు తిరిగే మొదటిరోజు మీ కోరిక చెప్పుకొని మొదలు పెట్టండి. తప్పక వివాహము జరుగుతుంది."
        },
        {
          "title": <span class='highlight'>ఏకన్యాస రుద్రాభిషేకం:</span>,
        },
        {
          "title": "డబ్బు ఇబ్బందులకు ఇంకొక శాంతి ప్రక్రియ: ప్రతి నెలలో ఒక మాస శివరాత్రి వస్తుంది. ఆ మాస శివరాత్రి రోజున శివునకు ఏకన్యాస రుద్రాభిషేకం చెయ్యండి. అలాగా ఎనిమిది మాస శివరాత్రులు శివునకు రుద్రాభిషేకాలు చేఇంచండి. మీ ధన ఇబ్బందులు తప్పక తొలిగి పోతాయి.(లేదా)"
        },
        {
          "title": "ధనము బాగా సంపాదించాలి అనుకున్న నిత్యమూ శ్రీ సూక్తము పారాయణ చేయవలెను."
        },
        {
          "title": <span class='highlight'>హనుమాన్ చాలీసా:</span>,
        },
        {
          "title": "హనుమంతుడు కల్పవృక్షం లాంటి వాడు. కల్పవృక్షాన్ని ఆశ్రయించిన అన్ని కోరికలు క్షణంలో నెరవేరుతవి. అటువంటి కల్పవృక్షం దరికి చేర్చగల చక్కని సులభమైన మార్గం హనుమాన్ చాలీసా. ఈ హనుమాన్ చాలీసాను సాక్షాత్తు పరమేశ్వరుని ఆదేశానుసారం శ్రీ గోస్వామి తులసీదాసు గారు రచించిరి. ఈ హనుమాన్ చాలీసాను దినమునకు పదకొండు పర్యాయములు చొప్పున మండలం(నలుభై రోజులు) పారాయణం చేసిన సర్వ కార్యసిద్ధి కలుగును. ఒకే ఆసనమున కూర్చుని నూట ఎనిమిది పర్యాయములు పటించిన విశేష కార్యసిద్ధి కలుగును. నిత్యమూ మూడు వేళలా ఒక పర్యాయము చదివిన వారి యోగక్షేమములు భక్త రక్షకుడగు శ్రీ హనుమంతుడు తాను స్వయంగా చూచుకొనును."
        },
        {
          "title": "స్వస్తి 🙏"
        }
      ],
      "title": "2.జాతకం లేని వారికి?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>కలసిరాని జాతకాన్ని కూడా కలిసొచ్చేలా చేసుకోవడానికి సింపుల్ టిప్స్:</span>,
        },
        {
          "title": "చాలామంది జీవితంలో ముందు ఏం జరుగుతుందోనని ఉత్సుకతతో జాతకాలను చూపించుకుంటారు. జాతకం మంచిగా ఉంటే ఆనందాన్నీ, ఏమైనా తేడాగా ఉంటే బాధను పొందుతారు."
        },
        {
          "title": "ఏ జాతకాలూ తెలియకపోయినా సత్ప్రవర్తనను కలిగిఉండి దైవంపైన భారం వేసి జీవించే వ్యక్తికి దైవమే సరియైన దారిని చూపిస్తారు. అయితే , చాలామంది జీవితంలో ముందు ఏం జరుగుతుందోనని ఉత్సుకతతో జాతకాలను చూపించుకుంటారు. జాతకం మంచిగా ఉంటే ఆనందాన్నీ, ఏమైనా తేడాగా ఉంటే బాధను పొందుతారు."
        },
        {
          "title": "ఆ జాతకమంతా పూర్వం తాను చేసిన మంచిచెడు కర్మల ఫలితమేనని తెలిసినా జీవితంలో చెడు జరగకూడదనే ప్రతివ్యక్తి కోరుకోవటం జరుగుతుంది.రాసిపెట్టిఉన్నది ఎలాగూ తప్పనప్పుడు మనం ఏం మనకు ? అని చాలామంది నిరాశగా అనుకుంటారు. అలా భావించటం పొరపాటు."
        },
        {
          "title": "మన సత్ప్రవర్తన ద్వారా మన తలరాతను మార్చుకోవచ్చని పెద్దలు చెబుతున్నారు."
        },
        {
          "title": "జాతకంలో చెడు సూచనలు కనిపించినప్పుడు బాధపడుతూ కూర్చోకుండా ముందే జాగ్రత్తపడి తమ చెడు ప్రవర్తనను మార్చుకుని దైవప్రార్ధన, పుణ్యకార్యాలు చేయటం, సత్ప్రవర్తనతో మెలగటం, ఇలాంటివి చేయటం ద్వారా రాబోయే కష్టం చాలావరకూ తగ్గే అవకాశం ఉందని పెద్దలు చెబుతున్నారు. పూర్వం ఎందరో ఇలా చేసి తమ జీవితాలను సరిదిద్దుకున్న సంఘటనలు గ్రంధాలలో కనిపిస్తాయి."
        },
        {
          "title": "మరి మీరు కూడా మీ జాతకం మీకు కలసి రాలేదని భావించకుండా జీవితంలో కొన్ని మార్పులు చేసుకుంటే కలసిరాని జాతకం కూడా మంచిగా మారుతుంది."
        },
        {
          "title": <span class='highlight'>లక్ష్మీదేవి ఫోటో:</span>,
        },
        {
          "title": "మీ ఇంటి ముఖ ద్వారానికి, ఒక మంచి రోజు బయట లోపల లక్ష్మీదేవి ఫోటో ఉంచడం, ఆ లక్ష్మీదేవి వెనుక రెండు ఏనుగులు బంగారపు కలశాలతో లక్ష్మీ దేవికి అభిషేకం చేస్తూ ఉండాలి. అలా ఉంచినట్లైతే మీ ఆర్థికపరమైన పనులలో ఆటంకాలు ఉండవు."
        },
        {
          "title": <span class='highlight'>పిలక ఉన్న కొబ్బరి కాయపై:</span>,
        },
        {
          "title": "పిలక ఉన్న కొబ్బరి కాయపై చుట్టూ 7 సార్లు , 7 దారాలు చుట్టి, మీ చుట్టూ 7 సార్లు తిప్పుకోవాలి. పై నుంచి క్రిందికి క్లాక్ వైజ్ డైరెక్షన్ లో తిప్పుకోవాలి. ఒక మంచి రోజు, అలాచేస్తే మీ అద్రుష్ట సమయాలలో కలిగే ఆటంకాలు తొలగిపోతాయి."
        },
        {
          "title": <span class='highlight'>లక్ష్మీ దేవికి 7 శుక్రవారాలు:</span>,
        },
        {
          "title": "లక్ష్మీ దేవికి 7 శుక్రవారాలు, 7 గురు ముత్తైదువులకు, ఇంటి గ్రుహిణి ద్వారా సౌభాగ్య సామగ్రి (కుంకుమ, పసుపు, చందనం, తాంబూలం, వీలు అయితే ఎరుపు రంగు జాకెట్ )దక్షణగా ఇప్పించాలి. అలా చేస్తే మీ ఇంటి గ్రుహినికి మంచిని తప్పక లక్ష్మీదేవి అనుగ్రహిస్తుంది."
        },
        {
          "title": "ప్రతి నెలా వచ్చే అమావాస్య నాడు ఇల్లంతా శుభ్రపరచడం వల్ల మంచి జరగుతుంది."
        },
        {
          "title": <span class='highlight'>గోమతి చక్రం:</span>,
        },
        {
          "title": "ఇంట్లో ఉండే దేవుని మందిరంలో ఒక మంచి రోజు, ఒక కుంకుమ భరిణలో గోమతి చక్రం అనేది కుంకుమ భరిణలో ఉంచి మూత పెట్టి, కదలించకుండా, దేవుని మందిరంలో ఉంచాలి. దానికి పూజాది కార్యక్రమాలు, ఏమి చేయనవసరం లేదు. అలా చేస్తే మీ ఇంట్లో పరిష్కారం కానీ, సమస్యలు ఏమైనా ఉంటె పరిష్కారం అవటానికి అవకాశం ఉన్నది. (గోమతి చక్రం , పూజా సామాగ్రి దొరికే దుకాణంలో దొరుకును)"
        },
        {
          "title": "గోమతి చక్రాలు 3 తీసుకుని, వాటిని పొడి చేసి, ఒక మంచి రోజు , ఇంటి ముందుర చల్లాలి. ఇలా చేయడం వల్ల మీ ఆర్థిక బాధలు తొలగిపోవును."
        },
        {
          "title": "లైట్ వేసిన తర్వాత ఇల్లు చిమ్మరాదు."
        },
        {
          "title": "సాయంత్రం, ఉదయం లైట్ వేసిన తర్వాత ఇల్లు చిమ్మరాదు."
        },
        {
          "title": "పగిలిన అద్దం ఉండకూడదు."
        },
        {
          "title": "ఇంట్లో మూత లేకుండా డస్ట్ బిన్ ఉండకూడదు."
        }
      ],
      "title": "3.కలసిరాని జాతకాన్ని కూడా కలిసొచ్చేలా చేసుకోవడానికి సింపుల్ టిప్స్?"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>జాతకచక్రం ఎప్పుడు వ్రాయించాలి:</span>,
        },
        {
          "title": "ఈ విషయంలో ఒక్కొక్కరిదీ ఒక్కో అభిప్రాయం. కొందరు అనేక అపోహలతో బిడ్డలకి 12 ఏళ్ళదాకా బాలారిష్టాలుంటాయి, అందుకే 12 ఏళ్ళు దాటితేగానీ జాతకం వేయించకూడదంటారు. కొందరు బిడ్డ పుట్టగానేనో, పురిటి స్నానం కాగానేనో, లేదా వీలయినంత తొందరగా వేయిస్తారు."
        },
        {
          "title": "బిడ్డ పుట్టిన తర్వాత 12 సంవత్సరాల వరకూ మాత్రమే బాలారిష్టాలుంటాయంటారు. నిజమే. మరి 12 సంవత్సరాలదాకా జాతకం వేయించకపోతే ఏమైనా గ్రహ దోషాలు, నక్షత్ర దోషాలు వుంటే శాంతులు ఎప్పుడు చేయిస్తారు. అఫ్ కోర్స్ ఇవ్వన్నీ నమ్మకాలున్నవాళ్ళకేననుకోండి. కొన్ని సార్లు జన్మ నక్షత్రం బాగా లేదని శాంతి చేయిస్తారు."
        },
        {
          "title": "అంతేకాదు. బిడ్డకి 12 సంవత్సరాలు వచ్చేదాకా ఏ చెడ్డ పని చేసినా దాని బాధ్యత తల్లిదండ్రులదే. ఎందుకంటే బిడ్డ 12 సంవత్సరాలవరకు తల్లిదండ్రులపై ఆధారపడుతూ సొంత ఆలోచనావిధానం ఉండదు.అందుకే బిడ్డ పుట్టిన తర్వాత వీలయినంత త్వరలో జాతకం వేయిస్తే, ఏవైనా గ్రహ శాంతులు వగైరాలు అవసరమైతే చేయించవచ్చు. అదీగాక జాతకం ప్రకారం బిడ్డ ఎలాంటి మనస్తత్వం కలవాడై వుంటాడో కూడా తెలుస్తుంది. ఆ విషయాలు ముందు తెలుసుకోవటం ద్వారా ఆ బిడ్డని ఉత్తమ వ్యక్తిత్వం కల వ్యక్తిగా తీర్చి దిద్దటానికి తల్లిదండ్రులకి సహాయంగా వుంటాయి."
        },
        {
          "title": "జ్యోతిష్కుని వద్దకు ఇబ్బంది ఏర్పడిన తరువాత వెళ్ళడం కన్నా ముందుగా రాబోయే ఇబ్బందులను తెలుసుకొని అవి రాకుండా చేసుకోవలసిన శాంతిమార్గాలను తనంతట తాను చేసుకోగలిగే సూచనల కోసం జ్యోతిష్కున్ని ఎల్లప్పుడు సంప్రదించటం అలవాటు చేసుకోవాలి."
        },
        {
          "title": "జాతకచక్రం తెలుసుకోవాలంటే ఖచ్చితంగా పుట్టినతేదీ,పుట్టిన సమయం,పుట్టిన ప్రదేశం తెలిసి ఉండాలి.ఇవి తెలియని వారికి జన్మ జాతకంలోని జాతక వివరాలు తెలుసుకోవటం కష్టం."
        }
      ],
      "title": "4.జాతకచక్రం ఎప్పుడు వ్రాయించాలి??"
    },
    {
      "CatID": [
        {
          "title": <span class='highlight'>పాప_పుణ్యాలు అంటే ఏమిటి:</span>,
        },
        {
          "title": "మానవులు ఎలాంటి పుణ్యకార్యాలనూ చేయడానికి ఇష్టపడరు. కాని పుణ్య ఫలాన్ని మాత్రం ఆశిస్తారు., పాప ఫలితాన్ని ఆశించరు."
        },
        {
          "title": "కాని పాప కార్యాలను మాత్రం ప్రయత్న పూర్వకం గానే చేస్తారు. అని ధర్మనీతి శాస్త్ర నిర్వచనం"
        },
        {
          "title": "ఇంతకీ పాపం అంటే ఏమిటి, పుణ్యం అంటే ఏమిటి ?"
        },
        {
          "title": <span class='highlight'>పరోపకారాయ పుణ్యాయ</span>,
        },
        {
          "title": "పాపాయ పరపీడనం అంటే, ఇతరులకు చేసిన మేలు పుణ్యం అనీ, ఇతరులను పీడించడం వలన పాపం సంక్రమిస్తుంది అనీ శాస్త్రవచనం"
        },
        {
          "title": "తెలియక చేయడం, అజ్ఞానంతో చేయడం ఒక విధంగా ప్రారబ్ద ఖర్మలను అనుభవిoచడం అవుతుంది. కానీ తెలిసి చేస్తే అది మహా పాపం అవుతుంది."
        },
        {
          "title": "పూర్వజన్మ ల్లో చేసిన పాప దోషాల వల్లనే ఈ జన్మలో శారీరక, మానసిక వ్యాధులు వచ్చి పీడుస్తున్నాయి అని మనం గ్రహించాలి. చేసుకున్న పాప,పుణ్యాల అనుభవం కోసమే ఈ జన్మ అనునది ఆధ్యాత్మికమైన జవాబు. అయితే ఎంతకాలం ఈ అనుభవం? అనేదీ ప్రశ్నే, దానికీ జవాబు ఉంది. "
        },
        {
          "title": "చేసిన పాప, పుణ్యాల గురించి ఈ లోకంలో తలచుకున్నంత కాలం ఆ పాప, పుణ్య ఫలాన్ని అనుభవించ వలసిందే. ఇదేం తీర్పు దీనికేదైనా నిదర్శనముందా అనే సందేహం కలగచ్చు.ఏ సందేహానికైనా సరైన జవాబు చెప్పే సామర్థ్యం మన రామాయణ, భారత, భాగవతాలకే ఉంది. దీనికి సంబంధించిన కథ ఒకటి మహాబారతంలో ఉంది. ఆ కథ ఏమిటంటే"
        },
        {
          "title": "కృతయుగ కాలంలో, ఇంద్రద్యుమ్నుడు అనే చక్రవర్తి ఈ భూలోకాన్ని ధర్మబధ్ధంగా, ప్రజారంజకంగా పరిపాలిస్తూండేవాడు. ఆయన గొప్ప దాత. దశ మహాదానాలే కాక షోడశ మహాదానాలు విరివిగా చేసాడు. అంతేకాక ఎన్నో పుణ్యకార్యాలు కూడా చేసాడు. ఇంద్రద్యుమ్నుడు చేసిన పుణ్యకార్యాల వల్ల, అతను మరణించాక దేవదూతలు వచ్చి అతన్ని సరాసరి స్వర్గలోకం తీసుకెళ్లారు. ఇంద్రద్యుమ్నుడు స్వర్గంలో సుఖభోగాలు అనుభవిస్తూ ఆనందిస్తున్నాడు. అలా ఎంతకాలం అయిందో అతనికే తెలియదు. "
        },
        {
          "title": "ఒకరోజు ఇంద్రద్యుమ్నుని దగ్గరకు దేవదూతలు వచ్చి, నీవు చేసుకున్న పుణ్యఫలం అయిపోయింది. నీవు స్వర్గంలో ఉండే అర్హత లేదు, భూలోకానికి వెళ్లిపో అన్నారు. అదేమిటి నా పుణ్యఫలం అప్పుడే తీరిపోవడమేమిటి ఇంకా చాలా ఉంది అన్నాడు ఇంద్రద్యుమ్నుడు... ‘నిరూపిస్తావా’ అని అడిగారు దేవదూతలు. ‘నిరూపిస్తాను.. నన్ను భూలోకం తీసుకొని వెళ్లండి’ అన్నాడు ఇంద్రద్యుమ్నుడు. దేవదూతలు అతన్ని భూలోకం తీసుకు వచ్చారు."
        },
        {
          "title": "ఇంద్రద్యుమ్నునకు భూలోకం చాలా కొత్తగా కనిపించింది. అతనికి తెలిసున్న వారెవరూ కనిపించలేదు. ఆ కాలంలో భూలోక వాసులందరిలోకి అతి వృద్ధుడు మార్కండేయుడు ఒక్కడే అని తెలిసి దేవదూతలతో అతని దగ్గరకు వెళ్లి నేనెవరో తెలుసా అని అడిగాడు ఇంద్రద్యుమ్నుడు. మీరెవరో నాకు తెలియదు. అయితే నాకన్న వృద్ధుడు ప్రావారకర్ణుడు అనే గుడ్లగూబ ఉంది. వెళ్లి దాన్ని అడుగుదాం రండి అన్నాడు మార్కండేయుడు."
        },
        {
          "title": "అందరూ కలిసి ఆ గుడ్లగూబ దగ్గరకు వచ్చారు. నేనెవరో తెలుసా అని అడిగాడు ఇంద్రద్యుమ్నుడు. మీరెవరో నాకు తెలియదు. అయితే నాకన్న వృద్ధుడు నాళీజంఘుడు అనే కొంగ ఉంది. వెళ్లి దాన్ని అడుగుదాం రండి అన్నాడు ప్రావారకర్ణుడు. "
        },
        {
          "title": "అందరూ కలిసి ఆ ఆ కొంగ దగ్గరకు వచ్చారు. నేనెవరో తెలుసా అని అడిగాడు ఇంద్రద్యుమ్నుడు. మీరెవరో నాకు తెలియదు. అయితే నాకన్న వృద్ధుడు ఆకూపారుడు అనే తాబేలు ఉంది. వెళ్లి దాన్ని అడుగుదాం రండి  అన్నాడు నాళీజంఘుడు. అందరూ కలిసి  ఆ తాబేలు దగ్గరకు వచ్చారు. నేనెవరో తెలుసా అని అడిగాడు ఇంద్రద్యుమ్నుడు"
        },
        {
          "title": "మీరెవరో నాకు బాగా తెలుసు. మిమ్మల్ని నేనెలా మర్చిపోతాను. మీరు ఇంద్రద్యుమ్న చక్రవర్తి. మీరు ఎన్నో యఙ్ఞాలు చేసారు. నన్ను ఎన్నోసార్లు కాపాడారు. దానాలు చెయ్యడం లోనూ మీరు చక్రవర్తే ఆ కాలంలో మీరు చేసిన గోదానాలు అనంతం దానగ్రహీతలైన బ్రాహ్మణులు ఆ గోవులను తోలుకుంటూ వెడుతూంటే ఆ గోవుల కాలి గిట్టల తొక్కుడు చేతనే కదా ఈ కొలను ఏర్పడింది. అందుకే ఈ కొలనుకు ఇంద్రద్యుమ్నము అని నీ పేరే పెట్టారు ప్రజలు నా సంతతి వారంతా ఈ కొలనులోనే ఇప్పటికీ నివసిస్తున్నారు అన్నాడు ఆకూపారుడు. "
        },
        {
          "title": "దేవదూతలు ఆ సమాధానంతో తృప్తిచెంది. ఇంద్రద్యుమ్నుని తిరిగి స్వర్గానికి తీసుకుని వెళ్లారు. ఇదీ కథ."
        },
        {
          "title": "కనుక కలకాలం అందరూ చెప్పుకునే విదంగా పుణ్యకార్యాలే చెయ్యాలి. అలాకాక పాపకార్యాలు చేస్తే ప్రజలు తలుచుకున్నంత కాలం నరకబాధలు తప్పవు"
        },
        {
          "title": "పాపం వల్లనే దుఃఖాలు వస్తాయి, పాపం లేనప్పుడు ఆనందం కలుగుతుంది. ఏ కొంచెం దుఃఖం కలిగినా అది పాప ఫలమే కాక వేరొకటి కాదు"
        },
        {
          "title": "మనం ఆనందంగా ఉన్నాము కదా అని, పరులను కించపరిచేలా ప్రవర్తిస్తే, అది మహాపాపం.. ఎందుకంటే వారి కర్మలు వారు అనుభవిస్తున్నారు. పాపదోషం అనేది అనుభవించితే తప్ప పోదు."
        },
        {
          "title": "అడవుల్లో ఉన్నప్పుడు, యుద్ధంలో శత్రువుల మధ్య, నీటి మధ్య, అగ్ని మధ్య ఉన్నప్పుడు, సముద్రంలో సాగుతున్నప్పుడు, పర్వత శిఖరాలను ఎక్కుతున్నప్పుడు, నిద్రలో, అజాగ్రత్తలో, సంకట పరిస్థితులలో మనలను పూర్వ జన్మలో చేసిన పుణ్యాలే కాపాడతాయి. అంతే గానీ ఇది నా గొప్ప, నా భక్తి, నా ఒక్కడి పైననే భగవంతుని దయ అనుకోవడం, మన అజ్ఞానం మాత్రమే"
        },
        {
          "title": <span class='highlight'>ఉత్తమమైన_ధర్మం - విదురుడు చెప్పిన ధర్మం:</span>,
        },
        {
          "title": "ఇతరులు తనయందు ఏ విధంగా ప్రవర్తిస్తే, తన మనస్సు కలత చెందుతుందో అదే విధమైన ప్రవర్తనను ఇతరుల యందు నీవు కలిగి ఉండకపోవడమే అన్ని ధర్మాల్లోకి కూడా ఉత్తమమైన ధర్మం అని విదురవాక్కు"
        },
        {
          "title": "పుణ్యం చేయడం చేతకాకున్నప్పుడు ఈ ధర్మాన్ని ఆచరిస్తే చాలు. ఈ లోకంలో పుణ్యం కాని, పాపం కాని, ఇతరుల నుంచి మనం తీసుకోలేం. తాను చేసిన పాపకర్మ వల్లనే దుఃఖం కలుగుతుంది. తాను చేసిన పుణ్యకర్మ వల్లనే సుఖం కలుగుతుంది. "
        },
        {
          "title": "ఈనాడు మనం నవ్వుతూ చేసిన పాపకర్మకి ( ఒకరిని కించపర్చడం, ఒకరి గూర్చి చెడుగా మాట్లాడుకోవడం, ఇలాంటివి ) రేపు ఏడుస్తూ ఆ దుఃఖాన్ని అనుభవించక తప్పదనే సత్యాన్ని మనం గ్రహించాలి."
        },
        {
          "title": "అందుకే అవకాశం ఉన్నప్పుడే సత్కర్మలు ఆచరించాలి. నలుగురి కి సహాయపడాలి, భగవంతుని అనుగ్రహం పొందాలి."
        }
      ],
      "title": "5.పాప_పుణ్యాలు అంటే ఏమిటి?"
    }
  ],
  "therdayatra": [
    {
      "CatID": [
        {
          title: 'ఇహపరమైన జంజాటం నుంచి బయటపడటానికి మనుషులు తీర్థయాత్రలు చేస్తారు. పుణ్యక్షేత్రాలను దర్శిస్తారు. కనీసం ఆ సమయంలోనైనా భగవంతుడి మీద మనసు లగ్నం చేయగలనని, చేయాలని ఓ చిరు ఆశ. చింతలు వీడి ఆ దేవదేవుడి చింతన చేసే ప్రయత్నమే తీర్థయాత్ర.',
        },
        {
          title: 'పుణ్యనదుల్లో స్నానం చేయటం, ఆ ప్రాంతాల్లోని ఆలయాలను సందర్శించటమే తీర్థయాత్రల ముఖ్యోద్దేశం. పుణ్యనదుల్లో స్నానాలు, ఆలయ సందర్శనలు మనిషి మనసు మీద ప్రభావం చూపుతాయి. ప్రశాంతతను, స్థిరచిత్తాన్ని కలిగిస్తాయి. మనసును ఆధ్యాత్మికపథం వైపు పయనింపజేస్తాయి.',
        },
        {
          title: 'తీర్థయాత్రకు అసలైన అర్థం మనిషి తనలోకి తాను పయనించడం, తనలోకి తాను చూడగలగటం. బుద్ధిని, మనసును ఆధ్యాత్మిక చేతన, చింతనలోకి ప్రవేశించేటట్లు చేయగలగటం. ఆ స్థితి ఏర్పడిననాడు భగవంతుణ్ని మనలోనే చూడగలం. అలా చూడగలిగిన ప్రతిసారీ ఓ తీర్థయాత్రను పూర్తిచేసినట్లే.',
        },
        {
          title: 'ఆధ్యాత్మిక చింతన మనిషి మనసు నుంచే ప్రారంభం కావాలి. అందుకే మనసును నిర్మలంగా ఉంచుకోవాలి. నైతిక ప్రవర్తనతో, ధర్మబద్ధమైన జీవితాన్ని సాగించాలి. అప్పుడు ఆ నిర్మలమైన మనసు నుంచి వచ్చే మాట, మనోప్రేరితమై చేసే పనుల్లో ఓ ఏకీభావం ఒనగూడుతుంది.',
        },
        {
          title: 'ఆధ్యాత్మిక_మార్గం లో ప్రయాణం ప్రారంభించిన వ్యక్తికి తాను నమ్ముకున్న మార్గాన్ని మరింత బలపరిచే అనుభవాలు అవసరమవుతాయి.',
        },
        {
          title: 'అటువంటి అనుభవం కోసం కొన్ని ప్రాంతాలను, వ్యక్తులను వెతుక్కుంటూ వెళ్ళాల్సి వస్తుంది. ఇలా వెతుక్కుంటూ వెళ్ళటమే తీర్థయాత్ర.',
        },
        {
          title: 'గతంలో ప్రజలు మునీశ్వరుల దగ్గరకు వెళ్ళి తమ సందేహాలను తీర్చుకునేవారు. ఆ మహానుభావులున్న ప్రదేశాలే #పుణ్యక్షేత్రాలు అయ్యాయి.',
        },
        {
          title: 'అటువంటి శక్తి ప్రతిష్ఠించిన దేవతామూర్తుల ద్వారా లభిస్తుంది. ఆ విశేష స్థల పురాణం కలిగిన పుణ్యక్షేత్రాలను దర్శించటం వల్ల మానవుల మనసులో మార్పు వస్తుంది. మారిన మనసు మనిషికి ప్రశాంతతను చేకూరుస్తుంది.',
        },
        {
          title: 'పుణ్యక్షేత్రాల సందర్శన మనస్సుకు ఆహ్లాదాన్ని ఇవ్వడంతో పాటు వ్యాపారాభివృద్ధి, అనుకున్న కార్యాలు దిగ్విజయంగా పూర్తవుతాయని పండితులు చెబుతున్నారు.',
        }
      ],
      title: 'తీర్థయాత్ర?',
    },
    {
      "CatID": [
        {
          title: '1. కాళ్ళుచేతులు మనసు పూర్తిగా అదుపులో ఉన్నప్పుడే చేయాలి. అవయవాలు అన్నీ యే ఔషధాలు అవసరం లేకుండా, సంపూర్తిగా శరీరం ఆధీనంలో సంపూర్తి ఆరోగ్యంతో పనిచేస్తున్నప్పుడే తీర్థయాత్రలు చేసేయాలి. అంటే  కాళ్ళు చేతులు గుండె కాలేయం జీర్ణాశ్రయం వంటి వివిధ శరీరభాగాలు తమంతట తాముగా పని చేస్తుండాలి. మెడిసిన్ సహాయం వాటికి నిత్యావసరాలు కాకూడదు. ఇటువంటి వారు తీర్థయాత్రలు చేయాలి.',
        },
        {
          title: '2. దీర్ఘకాలిక రోగాలు కూడా అదుపులో ఉండాలి. అవి లేకుండా ఉంటే ఇంకా మంచిది. ',
        },
        {
          title: '3. ఉత్తమప్రదేశాలు వెళ్ళాలనుకునేవారికి, ఉత్తమకార్యములు చేయాలి అనుకునే వారికి, ఉత్తమ సంకల్పాలు ఉన్నవారికి, ఉత్తమ జ్ఞానం సంపాదించాలి అనుకునేవారికి తీర్థయాత్రలు ఫలిస్తాయి.',
        },
        {
          title: '4. విద్యా తపస్సు కోసం కృషి చేసేవారు తీర్థయాత్రలు చేయాలి. యాత్రలు ఎన్నో రకాల విజ్ఞానాన్ని ఇస్తాయి. కనుక విద్యార్జన చేసే దశలోని వారు, ఆధ్యాత్మిక సాధన కోసం తపస్సు చేయాలనుకొనేవారు తీర్థయాత్రలు చేయాలన్నాడు.',
        },
        {
          title: <span class='highlight'>తీర్థయాత్రలు ఎలా చేయాలి?:</span>,
        },
        {
          title: '1. మనసు  అదుపులో పెట్టుకోవడం ఉండాలి. ఎటుపోతే అటుపోయే మనసు ఉండరాదు. ',
        },
        {
          title: '2. మాట అదుపులో ఉండాలి.',
        },
        {
          title: '3. అహంకారం ఉండకూడదు.',
        },
        {
          title: '4. అక్కడకు వెళ్ళి డబ్బుసంపాదిద్దాము అని ఉండకూడదు.',
        },
        {
          title: '5. జీవితంలో అసంతృప్తి ఉండకూడదు. సంతృప్తి కలిగిన వాడై ఉండాలి. అంటే భోగాల కోసం యాత్రలు చేయకూడదు.',
        },
        {
          title: '6. నేను ఏమైనా చేసేయగలను అనే దుడుకు స్వభావం ఉండకూడదు. ఇది ముఖ్యంగా యువకులను ఉద్దేశించి చెప్పింది. యాత్రల్లో ఇచ్చే సూచనలను ముఖ్యంగా యువత గౌరవించాలి. అందరూ ఆరోగ్యాలలో సమానంగా ఉండరు. ముఖ్యంగా ముసలివారు, పిల్లలతల్లులు, పిల్లలు, ఆడవారు. వీరికి తాను సాయం చేసేవాడిగా ఉండాలి.  వారు నెమ్మదిగా నడుస్తుంటే త్వరగా నడవాలని కసురుకోవడం, ఎగతాళి చేయడం వంటివి చేయకూడదు.',
        },
        {
          title: '7. ఎటువంటి పరిస్థితుల్లోనూ అడ్డదార్లలో ప్రయాణించకూడదు. ఎంతరద్దీ ఉన్నా సమయం లేకపోయినా సరే  కేవలం యాత్రీకులకు నిర్దేశించిన మెట్లు లేదా కాలిమార్గాలే ఉపయోగించాలి.',
        },
        {
          title: '8. పరిగెత్తడం వేగంగా నడవడం దూకుడుగా మెట్లు దిగడం వంటివి యువతకు ప్రాణప్రమాదాలు కలిగిస్తాయి',
        },
        {
          title: '9. లఘు ఆహారం స్వీకరిస్తుండాలి.',
        },
        {
          title: '10. ఏకభుక్తం చేస్తుండాలి. ఎందుకంటే ఈ రెండు నియమాలూ ఆధ్యాత్మికంగా శారీరకంగా మంచిది. దర్శనాలలో క్యూలైన్లలో ఆలస్యం కావచ్చు. ప్రయాణంలో ఆలస్యం కావచ్చు. వేళకు సరైన ఆహారం దొరక్కపోవచ్చు. దొరికిన ఆహారం మనం ఎప్పుడూ తినే ఆహారం కాకపోవచ్చు. కొత్తకొత్త ప్రదేశాల్లో నీళ్ళు త్రాగాల్సి రావచ్చు. ప్రయాణంలో వాహనాల కోసం హడావుడిగా తినాల్సి రావచ్చు.',
        },
        {
          title: '11. మామూలు సమయాలకన్నా ముందే భోజనం చేయాల్సి రావచ్చు. ఒక్కోసారి ప్యాక్ చేసుకున్న ఆహారం ఏ దశలో ఉన్నా తినాల్సి రావచ్చు. అలవాటులేని వాతావరణాలు, కొత్తరకమైన రుచికరమైన పదార్థాలు దొరకడం వల్ల జిహ్వాచాపల్యం కొద్దీ ఎక్కువ తినవచ్చు. కనుక దోషాలు పోవాలంటే పై రెండు ఆహార నియమాలూ పాటించాలి.',
        },
        {
          title: '12. దాదాపు 99శాతం రోగాలు తిన్నతిండి, త్రాగిన నీళ్ళ నుంచే వస్తాయి. లఘువుగా తింటే జఠరాగ్ని బాగా మండి ఎటువంటి ఆహారాన్ని అయినా అది జీర్ణం చేస్తుంది.  తిన్నది ఆహారం అధికమైతే వచ్చే రోగలు ఉంటాయి కనుక జాగ్రత్తగా ఉండాలి.',
        },
        {
          title: '13. సాధ్యమైనంత వరకూ తేలిగ్గా అరిగే ఆహారం, నిద్ర లేకపోయినా, అధికశ్రమ కలిగినా శక్తి ఇచ్చేది స్వీకరించాలి. కొన్ని సందర్భాలలో అధికశ్రమ వల్ల కూడా ఆహారం జీర్ణం కాదు.',
        },
        {
          title: '14. క్రింద పడుకోవడం:  సాధారణంగా ఉత్తరాదిలో బొంతల వంటి దుప్పట్లు అద్దెకు ఇస్తారు. పరుపులు మంచాలు కూడా అన్ని చోట్లా అద్దెకు ఇస్తారు. అయితే అవన్నీ నిత్యం ఎన్నోవందల మంది ఉపయోగిస్తారు. వీటిని ఉపయోగించకపోవడమే మంచిది.',
        },
        {
          title: 'మరొక ఆరోగ్యరహస్యం ఏమిటంటే మనిషి నిద్రించేటప్పుడు చెమట పడుతుంది. అది పక్కబట్టలకు బాగా పట్టిపోతుంది. సాధారణంగా చలి ఎక్కువగా ఉండే ప్రాంతాలలో అవి ఎండే అవకాశం లేదు. వాటిని ఉతికే అవకాశాలు అసలే ఉండవు. అందులోనూ రగ్గులువంటి వాటిని అసలు ఉతకరు.',
        },
        {
          title: 'పైగా యాత్రల్లో శుచిగా స్నానాలు చేయడం ఉండదు. ముక్కుమూసుకొని మునగాల్సి వస్తుంది. తీర్థయాత్రల్లో సబ్బులు షాంపూలు వాడకూడదు. అది పర్యావరణాన్ని పాడు చేయడమే కాక కేన్సర్లు కూడా యాత్రీకులకు అంటగడతాయి. కనుక స్నానాలు పూర్తి శుభ్రతను ఇవ్వవు. కనుక అనేక మంది పడుకుంటూ వారి చెమట పక్కబట్టలకు పడుతూ ఉండడం వల్ల చర్మరోగాలు త్వరగా వస్తాయి.',
        },
        {
          title: 'అంతేకాక అందరి చెమటా చేరి కొత్త రకమైన రోగాలు వస్తాయి. ధర్మశాస్త్రాలు అందుకనే  బట్టలు, పక్కబట్టలు, దైవకార్యాలు, భార్య, తీర్థయాత్రలు వ్యక్తిగతమైనవి అని నిర్దేశించాయి. అంటే ఎవరివి వారివే అన్నమాట. ఒకరివి ఇంకొకరు ఉపయోగించరాదు.',
        },
        {
          title: 'సాధారణంగా పరిశుభ్రత విషయంలో కూడా ప్రాంతీయంగా భేదాలు ఉంటాయి.',
        },
        {
          title: 'ముఖ్యంగా ఉత్తరాదిలో కొంత శుభ్రత తక్కువగా ఉంటుంది. దానికి కారణం అక్కడ సూర్యరశ్మి తక్కువగా ఉండడమే. దక్షిణాదిలో మాదిరిగా ఎండబెట్టుకునే అవకాశాలు చాలా తక్కువగా ఉంటాయి. దీనికి ఉత్తరాది ఇళ్ళనిర్మాణాలు (ముఖ్యంగా పర్వత నదీతీర పర్యాటక ప్రాంతాలు), వాతావరణ పరిస్థితులు కూడా కారణాలే.',
        },
        {
          title: '15. బ్రహ్మచర్యం చాలా ముఖ్యం. వెళ్ళిన చోట ముఖ్యంగా తీర్థయాత్రాస్థలాల్లో వేశ్యలు ఉండే అవకాశం లేదా స్వైరణులు ఉండే అవకాశాలు ఉంటాయి. వారు రెచ్చగొడితే రెచ్చిపోతే కొత్తసమస్యలు రావచ్చు. అందులోనూ ఆడవారి విషయాలు కావడం వల్ల అవి ఎంతవరకైనా వెళ్ళే అవకాశాలు కూడా ఉన్నాయి. ధనమానప్రాణాలకు అపాయాలు కలుగవచ్చు. తీర్థయాత్రల్లో మగతనం నిరూపించుకోవడం కన్నా పేడిగా ఉండడం మంచిది.',
        },
        {
          title: '16. మానసికమైన లక్షణాలు కూడా చెప్పాడు. ఎప్పుడూ కోపం తెచ్చుకోకూడదు. అది మనప్రాంతం కాదు. పలికే దిక్కు ఉండదు. కనుక శాంతంగానే ఉండాలి. ఎటువంటి నష్టం ఎదురైనా భరించవలసిందే. కనుకనే యాత్రాదర్శనులు తప్పనిసరిగా అనుసరించాలి.',
        },
        {
          title: '17. సత్యమార్గన్నే పయనించాలి. అంటే రుజుత్వం కలిగి ఉండాలి. కపటత్వం ఉండకూడదు.',
        },
        {
          title: '18. దృఢమైన దీక్షకలిగి ఉండాలి. ఫలానా పర్వతం ఎక్కి తీరాలి అనే పట్టుదల ఉండాలి. శరీరకష్టం, వాతావరణ ఇబ్బందులు ఎన్ని ఎదురైనా అనుకున్న లక్ష్యం అనుకున్న విధంగా సాధించాలి. అంటే కాలినడక అయితే కాలినడకన, గుర్రం మీద అనుకుంటే గుర్రం మీద ప్రయాణం చేయాలి. నిజానికి కొందరు ముందు కాలి నడకన ప్రారంభించి కొంత దూరం వెళ్ళాక గుర్రం ఎక్కి దాని మీద కూర్చోలేక పల్లకీ ఎక్కి సొమ్ము వదిలించుకుంటారు.',
        },
        {
          title: '19. ఆత్మౌపన్యం కలిగి ఉండాలి. అంటే ఎదుటివారికి వచ్చిన కష్టం తనకు వస్తే ఎలా ఉంటుందో ఊహించుకొని వారికి సహాయం చేసే గుణం కలిగి ఉండాలి. తోటి యాత్రీకులలో తనను తాను చూసుకోవాలి. వారు వేరు తాను వేరు అని భావించరాదు. వారికి వచ్చే కష్టనష్టాలు తనశక్తిమేరకు తీర్చడానికి ప్రయత్నించాలి.',
        },
        {
          title: '20. సర్వభూతముల యందు ప్రాణుల యందు దయ కలిగి ఉండాలి.',
        },
        {
          title: <span class='highlight'>ఎందుకు చేయాలి:</span>,
        },
        {
          title: 'మహర్షులు సనాతనధర్మంలో రాజులకు బ్రాహ్మణలకు మహాకఠినమైన అధికవ్యయమైన యజ్ఞాలు చెప్పారు. ఆ యజ్ఞాలు చేయడానికి మహారాజులు మాత్రమే సాధ్యం. లేదా మహాశక్తిసంపన్నులైన వేదపండితులకు మాత్రమే సాధ్యం. కానీ అందరికీ ఆ యజ్ఞాల ఫలాలు లభించాలి,  దరిద్రుడికి కూడా లభించాలని తీర్థయాత్రలు పెట్టారు. అంతేకాదు కొన్ని మహాయజ్ఞములు చేసినా రాని ఫలం కూడా తీర్థయాత్రలు చేస్తేవస్తుంది.',
        },
        {
          title: 'మహాత్ములు చెప్పిన తీర్థాలు క్షేత్రాలు శక్తిపాతం చేసిన ప్రాంతాలు. సాధారణంగా విగ్రహ  ప్రతిష్ఠ చేసేటప్పుడు యంత్ర మంత్ర సహితంగా దివ్యశక్తులు ఉన్న విగ్రహాలు స్థాపిస్తారు. కనుక వారు వేసిన యంత్ర వల్ల శక్తి వస్తుంది. శంకరాచార్యులవారు అటువంటి యంత్రాలు ఎన్నో దేవాలయాల్లో ప్రతిష్ఠించారు. మహనీయులు చదివిన  మంత్రాల వల్ల శక్తి వస్తుంది. కొన్ని స్వయంభూ విగ్రహాదులు లేదా దివ్యవిగ్రహాల వల్ల కూడా శక్తి ఉంటుంది. ప్రతిష్ఠించిన  స్థలాలను  బట్టీ కూడా శక్తి ఉంటుంది.',
        },
        {
          title: 'కాశీ, ప్రయాగ, మధుర అలాంటి క్షేత్రాలే.  అలాగే, పారే తీర్థాలను  బట్టీ కూడా శక్తి ఉంటుంది. ప్రతిష్ఠ  చేసిన శంకరాచార్యులు, వ్యాసుడు వంటి మహనీయుల బట్టీ అపారమైన శక్తి అక్కడ ఉంటుంది. కనుక అటువంటి స్థలాలు దర్శించి ప్రాంతీయాచారాల బట్టీ అర్చించడం వలన ఆ శక్తి తీర్థయాత్రీకులకు వస్తాయి.',
        },
        {
          title: 'మూడు రాత్రులు ఉపవాసం ఉండకపోతే, తీర్థయాత్రలు చేయకపోతే, బంగారందానం, గోదానం చేయకపోతే వచ్చే జన్మలో దరిద్రుడై పుడతారని శాస్త్రాలు చెబుతున్నాయి.',
        }
      ],
      title: 'తీర్థయాత్రలు ఎవరు చేయాలి?',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>శ్రీ అమరారామం – అమరావతి పంచారామక్షేత్రం :</span>,
        },
        {
          title: 'గుంటూరు జిల్లా లో కృష్ణానదీ తీరాన వెలసిన పుణ్యతీర్ధం శ్రీ అమరారామం. దీనినే అమరావతి అని పిలుస్తున్నాం.  అమరలింగేశ్వరుడు కొలువు తీరిన పరమ పవిత్ర పుణ్యక్షేత్రమిది. పంచారామాలలో మొదటిది గా సేవించబడుతోంది.',
        },
        {
          title: 'కలిదోష నివృత్తి కొఱకు శౌనకాది మహామునులకు నారద మహర్షి  భూలోకమునందు గల  పవిత్ర పుణ్య స్థలాలను గూర్చి వివరిస్తూ  ఈ అమరేశ్వరుని  గురించి చెప్పినట్లు  స్కాంద పురాణం లో  కన్పిస్తోంది.',
        },
        {
          title: 'अमरेश समं तीर्थं न भूतो न भविष्यति !',
        },
        {
          title: 'अमरेशं महादेवं सर्वदेवमयं शुभम् !!',
        },
        {
          title: <span class='highlight'>స్థలపురాణం:</span>,
        },
        {
          title: 'ఈ అమరారామాన్ని  గురించిన విశేషాలు, స్కాంద పురాణం లో సహ్యాద్రి ఖండం లోను ,బ్రహ్మపురాణం పూర్వ ఖండం లోను. పద్మపురాణం ఉత్తర భాగం లోను ప్రస్తావించబడినట్లు స్థలపురాణం చెపుతోంది.',
        },
        {
          title: 'తారాకాసుర సంహారం పూర్తి చేశాడు కార్తికేయుడు. యుద్ధ సమయం లో తారకుని కంఠమందలి అమృతలింగం కుమారస్వామి శక్తి ఘాతాలకు ఐదు గా విడి పోయి ఆంధ్ర దేశం లో ఐదు ప్రదేశాల్లో పడ్డాయి.వాటినే మనం పంచారామాలని పిలుస్తున్నాము.',
        },
        {
          title: 'ఆ పంచారామాల్లో ఒకటైన  ఈ అమరారామం లోని అమరేశ్వరుడైన ఇంద్రుని చేత ప్రతిష్ఠించబడటం వలన ఈ స్వామిని  అమరేశ్వరుడని, ఆ స్వామి కొలువైన ఈ నగరాన్ని ఇంద్రుని నగరం పేరున అమరావతి యని పిలుస్తున్నారు. దీనిని” దక్షిణ కాశి” యని కూడ అంటారు.',
        },
        {
          title: 'దేవగురువైన బృహస్పతి ఆదేశానుసారం ఇంద్రుడు ఆశ్వయుజ శుద్ధదశమి నాడు సమస్త దేవతా గణము జయజయధ్వానములు చేయుచూ వెంటరాగా, తారకాసురుని గళమందలి అమృత లింగము నుండి చెదిరిన ఒక శకలమును ఈ క్రౌంచగిరి పై ప్రతిష్ఠించినాడు.',
        },
        {
          title: 'శుద్ధ ధవళ కాంతులతో  ప్రకాశించుచున్న ఆ అమరేశ్వరుడు ప్రతిష్ఠించిన వెంటనే పైపైకి పెరిగి పోవటం ప్రారంభించాడట. అంత దేవేంద్రుడు అభిషేకములు చేసి, వివిధ దేవతాకుసుమములతోను, బిల్వ పత్రములతోను పూజించినను స్వామి పెరుగుదల ఆగక పోవటంచేత లింగాగ్రముపై సీల కొట్టి, కృష్ణవేణీ జలం తో అభిషేకించగా స్వామి పెరుగుదల ఆగిందట.',
        },
        {
          title: 'ఇప్పటికీ లింగాగ్రంలో తలపై నుండి జాలువారిన నెత్తుటి చారలు కన్పిస్తాయని భక్తులు చెప్పుకుంటుంటారు. తారకాసురుని మరణానంతరం ఇంద్రుడు స్వామి ని ప్రతిష్ఠించిన తర్వాతే మహేంద్ర పదవిని మరల పొందాడు. ఆ ఇంద్రుని చే ప్రతిష్ఠించబడిన స్వామి అమరేశ్వరుడిగా ఆరాథించబడుతున్నాడు.',
        },
        {
          title: 'ఈ విషయాన్ని విన్న రాక్షస గురువు శుక్రాచార్యుడు బృహస్పతి చెంతకు వచ్చాడు. “ కృష్ణానదికి వరదలొస్తే అమరేశ్వరుడు మునిగి పోయే ప్రమాదం ఉంది గదా! అటువంటి ప్రదేశం లో స్వామిని ఎలా ప్రతిష్ఠ చేయించారనే సందేహాన్ని” వెలిబుచ్చాడు బృహస్పతి తో శుక్రాచార్యుడు.',
        },
        {
          title: 'అందుకు ”ఆత్మలింగం పడినచోట భూభాగం క్రింద పాతాళం వరకు క్రౌంచ పర్వతం ఉంది. దానిపై నున్న ఆమహాలింగం పెరగటం వల్ల, ఎంత వరదలొచ్చినా ఆ మహాలింగానికి వచ్చిన ముప్పు ఏమీలేదు. కృష్ణా ప్రవాహమే స్వామికి నమస్కరించి ప్రక్కకు తిరిగింది కదా. ఉత్తర దక్షిణాలు గా నది ప్రవహించడాన్ని మీరు గమనించారు కదా!” అన్నారట బృహస్పతి. ఆ యనంతరం దేవ గురువుల సూచనల మేరకు అమరేశ్వరుని చుట్టుఅంబిక మొదలైన శివపరివారమంతా కొలువు తీరింది.',
        },
        {
          title: <span class='highlight'>లింగదర్శనం:</span>,
        },
        {
          title: 'అమరేశ్వరుని రూపం పది అడుగుల ఎత్తు కలిగి, మూడు అడుగులకైవారం తో, శుద్ధ ధవళ వర్ణం తో మెరిసి పోతూ ఉంటుంది. పానమట్టం మీద స్వామి పదిహేను అడుగుల ఎత్తులో కన్పిస్తారు. అభిషేకం చేయడానికి ప్రత్యేకమైన ఏర్పాటు చేయబడింది. స్వామి మాటి మాటికీ పెరుగుతూ ఉంటే ఆలయనిర్మాణం మాటి మాటికీ మార్చవలసి వస్తోందని, స్వామి వారి పెరుగుదలను సీల కొట్టడం ధ్వారా నియంత్రించారనే మాట స్వామి రూపాన్ని చూస్తే వెంటనే స్మరణకు వస్తుంది.',
        },
        {
          title: <span class='highlight'>క్షేత్రమహిమ:</span>,
        },
        {
          title: ' ఈ స్వామి పంచలింగాకారాలతో పంచాక్షరీ మహామంత్రాన్ని బోధిస్తూ ఉంటారని ప్రతీతి. ప్రణవేశ్వరుని గా, అగస్త్యేశ్వరుని గా, కోసలేశ్వరుని గా ,   సోమేశ్వరుని గా, పార్ధివేశ్వరుని గా  దర్శనమిచ్చే ఈ క్షేత్రం లో  అయిదు రోజులు నివసించి,  కృష్ణానది లో స్నానం చేస్తూ, పంచాక్షరిని జపిస్తూ, స్వామిని ఆరాథిస్తే కైవల్య ప్రాప్తి లభిస్తుందని భక్తులు గాఢంగా నమ్ముతున్నారు.',
        },
        {
          title: '“स्नानमात्रेण तत्तोये गो सहस्रफलं लभेत् !',
        },
        {
          title: 'सुरेश्वरं सकृद्दष्ठा पुनर्जन्म नविद्यते !!”',
        },
        {
          title: 'అని శాస్త్రాలు చెపుతున్నాయి. ఈ క్రౌంచ పర్వతం మీద గతం లో దేవతలు, కపిలుడు మొదలైన మహామునులు తపస్సు చేసి కృతార్థులగుట వలన దీన్ని సిద్థి క్షేత్రం గా కూడ పిలుస్తారు. పూర్ణిమ, అమావాస్య, ద్వాదశి, ఆర్ధ్ర నక్షత్రము, ఆది వారము, సంక్రాంతి, సూర్య, చంద్రగ్రహణ కాలాల్లోను, సప్తమీ సోమవారం ,దక్షిణోత్తరాయణములందు ఈ అమరావతీ తీర్ధమందు స్నానం చేసి, అమరేశ్వరుని సేవించిన యెడల వారికి సహస్ర యజ్ఞఫలము లభిస్తుందని చెప్పబడుతోంది.',
        },
        {
          title: <span class='highlight'>ఆలయదర్శనం:</span>,
        },
        {
          title: 'కృష్ణా నదీ తీరాన వెలసిన అతి ప్రాచీన ఆలయం అమరావతి. మహోన్నత గోపురాలతో విరాజిల్లే పౌరాణిక పుణ్యస్థలం అమరావతి. మూడు ప్రాకారాలతో విలసిల్లు తున్న అమరేశ్వరుని మందిరం ఇది. మొదటిప్రాకారం లో ప్రదక్షిణ రీతిలో బయలుదేరితే  వరుసగా ప్రణవేశ్వరుడు, శంకరాచార్యులు, కాశీవిశ్వేశ్వరుడు, ఉమామహేశ్వరుడు, దత్తాత్రేయస్వామి, రుద్రపాదాలు, జ్వాలముఖీ దేవి, అగస్త్యేశ్వర స్వామి, ఫార్థివేశ్వరుడు, సోమేశ్వరుడు, నాగేశ్వరుడు, మహిషాసురమర్థని, కోసలేశ్వరుడు, వీరభద్రుడు  దర్శనమిస్తారు. రెండవ ప్రాకారం లో నైరుతిన కాలభైరవుడు, తూర్పు దిక్కున ధ్వజస్థంభం, దాని సమీపం లోనే సూర్యభగవానుడు ప్రతిష్ఠంచబడటం తో ఇది పంచాయతన క్షేత్రం గా కొనియాడబడుతోంది.',
        },
        {
          title: 'మూడవ ప్రాకారం లో ప్రదక్షిణ మార్గంలో  బయలుదేరితే, ముందుగా నైరుతీ దిశ లో శ్రీశైల మల్లేశ్వరుడు, వాయవ్యం లో కాశీవిశ్వేశ్వరుడు, ఈశాన్యం లో చండీశ్వరుడు, ఆ గ్నేయం లో శ్రీ కాళహస్తీశ్వరుడు దర్శనమిస్తారు. గర్భగుడి లో 10 అడుగుల ఎత్తులో ధగధ్ధగాయమానంగా ధవళ కాంతి తో అమరేశ్వరుడు ప్రత్యక్షమౌతాడు. ముఖమండపం లో స్వామి కి ఎడమవైపు ఉపాలయం లో బాల చాముండేశ్వరీ దేవి దివ్యరూపం దర్శనమిస్తుంది. ఈ ఆలయం లో నాలుగు దిక్కుల నాలుగు ధ్వజస్థంభాలుండటం ప్రత్యేకత.',
        },
        {
          title: 'ముఖమండపం లో నందీశ్వరుని చెంతనే ఈ ఆలయ అభివృద్ధి కి అహరహము కృషిచేసిన వదాన్యులు శ్రీ రాజా వాసిరెడ్డి వేంకటాద్రి నాయుడు ముకుళిత హస్తాలతో స్వామి వారికి నమస్కరిస్తున్న లోహ విగ్రహం మనకు దర్శనమౌతుంది. ముఖమండపం నుండి స్వామి వారికి ఎడమవైపు కు తిరిగితే శ్రీవేణుగోపాలస్వామి ఆలయం లోకి వెళతాము. ఈ స్వామి ఇక్కడ క్షేత్ర పాలకుడు. శివకేశవాభేదానికి ఇది ఒక తార్కాణం గా చెప్పవచ్చు.',
        },
        {
          title: <span class='highlight'>చారిత్రక నేపథ్యం:</span>,
        },
        {
          title: 'అమరావతి, ధరణి కోట అనే వేరు వేరు పేర్ల తో పిలువ బడే ఈ ప్రాంతం చరిత్రలో ధాన్యకటకం గా ఫ్రసిద్ధి కెక్కింది. క్రీ.శ 8 వ శతాబ్దం నాటికే అమరావతీ బౌద్ధస్ధూపం నిర్మించబడింది. శాతవాహనుల కాలం లో దక్షిణాపథం గా పిలువబడిన ఈ ప్రాంతానికి ధాన్యకటకం రాజధానిగా ఉండేది. అశోకుని సార్వభౌమత్వాన్ని అంగీకరించిన శాతవాహనులు బౌద్ధమతాన్ని ప్రచారం చేశారు.కొండవీటి రెడ్డిరాజుల కాలం లో ఈ ఆలయం పునరుద్ధరించబడినట్టలు తెలుస్తోంది.',
        },
        {
          title: 'క్రీ.శ. 1158 లోని కొమ్మనాయని శాసనం,కోటరాజుల శాసనాలు లభిస్తున్నాయి. అనవేమారెడ్డి తమ్ముడు మల్లారెడ్డి అమరేశ్వరాలయం మీద పంచసువర్ణ కలశాలను ఎత్తించిన శాసనం వేంకటాద్రి నాయుడు మండపం లో కన్పిస్తుంది.అలాగే క్రీ.శ 1517 లోని శ్రీకృష్ణ దేవరాయల  దాన శాసనం ఒకటి ఉంది. ముఖమండపం లో కోట కేతరాజు మంత్రి ప్రోలినాయుడు భార్య స్వామి వారికి అఖండదీపారాథనకు చేసిన శాసనం కన్పిస్తుంది.',
        },
        {
          title: 'శ్రీ కృష్ణ దేవరాయలు ఇచ్చటకు వచ్చి. స్వామి కి తులాభారమిచ్చినట్లు తులాభారమండపం సాక్ష్యంగా నిలుస్తోంది. అనంతరం క్రీ.శ 1626 ల పెద్ద అప్పము గారు ఆలయాన్ని పునరుద్ధరించారు. అమరావతీ ఆలయ కుడ్యాల మీద నున్న ఎన్నో శాసనాలు చరిత్ర పరిశోధకులకు ఎంతో విలువైన సమాచారాన్ని అందిస్తున్నాయి.',
        },
        {
          title: 'రాజా వాసిరెడ్డి  వెంకటాద్రి నాయుడు చెంచులను తుదముట్టించిన తరువాత అమరేశ్వరుని ఆజ్ఞ మేరకు తన రాజధానిని చింతపల్లి నుండి అమరావతి కి మార్చారు. అమరేశ్వరుని ఆలయ సమీపం లో క్రీ.శ.1795 ధరణికోట ను నిర్మించి తన రాజధాని గా చేసుకొని, స్వామి వారిని సేవించి తరించాడు. శ్రీ కృష్ణ దేవరాయలు వలెనే స్వామి కి తులాభారాన్ని సమర్పించి, తులాభార మండపాన్ని నిర్మించాడు.',
        },
        {
          title: 'ఆలయ ప్రాకార మండప గోపురాలను నిర్మించి,స్వామిసేవలో తరించాడు. స్వామి పూజాదులకు ఎటువంటి ఇబ్బంది కలగకుండా నవబ్రహ్మల్లాంటి అర్చకులను ఏర్పాటు చేసి, 300 సంవత్సరాలక్రిందటే ఒక్కొక్కరికి 12 ఎకరాల భూమిని దానం  చేసిన వదాన్యుడు రాజా వాసిరెడ్డి వేంకటాద్రి నాయుడు. రాజా వేంకటాద్రి నాయుడు ఈ దేవాలయ పునర్నిర్మాణం చేయించేటప్పుడు బౌద్దారామ శిథిలాలు కొన్నింటిని కూడ ఆలయ నిర్మాణం లో వాడారనే అపప్రథ  నిజమేనేమో అన్నట్లు దేవాలయ స్థంభాలమీద అక్కడక్కడ బుద్ధ ప్రతిమలు దర్శనమిస్తాయి.',
        },
        {
          title: <span class='highlight'>రవాణా వసతి సౌకర్యాలు:</span>,
        },
        {
          title: 'గుంటూరు నుండి 35 కి.మీ, విజయవాడ నుండి 30 కి.మీ  దూరం లోను అమరావతి ఉంది.  ఆర్టీసి సర్వీసులు బహుళంగానే ఉంటాయి. దేవాలయానికి దగ్గరగా వసతి సౌకర్యాలు లభిస్తాయి. కాఫీ ,టిఫిన్ భోజనవసతులు, హోటళ్లు ఉన్నాయి.',
        },
        {
          title: <span class='highlight'>విశేష ఉత్సవాలు:</span>,
        },
        {
          title: 'శ్రీ అమరేశ్వరస్వామి కి మాఘ బహుళ దశమి తో ప్రారంభమయ్యే మహాశివరాత్రి ఉత్సవాలు, అమావాస్య నాడు జరిగే రథోత్సవాన్ని చూడటానికి భక్తులు వేలాది గా తరలి వస్తారు. కార్తీకమాసోత్సవాలు కన్నుల పండువుగా జరుగుతాయి.',
        },
        {
          title: 'ఓం నమః శివాయ.',
        }
      ],
      title: 'శ్రీ అమరారామం – అమరావతి పంచారామక్షేత్రం',
    },
    {
      "CatID": [
        {
          title: 'దేవీపురంలోని శ్రీచక్రాలయంలో *“సహస్రాక్షి”* గా *శ్రీరాజరాజేశ్వరీ దేవి* భక్తులకు దర్శనమిస్తోంది.',
        },
        {
          title: 'ఆంధ్రప్రదేశ్ రాష్ట్రంలోని విశాఖపట్నం అనగానే బీచ్ లు మాత్రమే కాదు.. ఆధ్యాత్మిక పరంగా కూడా అద్భుతమైన ప్రదేశాలున్నాయి. వాటిలో ఒకటి దేవీపురం లోని *సహస్రాక్షి శ్రీ రాజరాజేశ్వరి ఆలయం.',
        },
        {
          title: 'అక్కడ తొమ్మిది కొండలు కళ్ళకు మనోహరంగా కనబడుతాయి. వాటి మధ్యన పచ్చని ప్రకృతి పరవశం కలిగిస్తుంది. ఆకుపచ్చని తోటలు కనువిందు చేస్తాయి. అక్కడే దేవీపురం ఉంది.',
        },
        {
          title: 'ఇది ఆంధ్రప్రదేశ్ లో విశాఖకు అతి దగ్గరలో ఉన్న సబ్బవరం గ్రామానికి అయిదు కిలోమీటర్ల దూరంలో ఉంది. ఇక్కడే సహస్రాక్షి పేరుతో శ్రీ రాజరాజశ్వరీ దేవీ ఆలయం వెలసింది. ఇక్కడ ఆలయం మొత్తం శ్రీచక్రంగానే ఉండటం పరమ విశేషం. ఇంత పెద్ద శ్రీచక్రాలయం ప్రపంచంలో ఇంకెక్కడా లేకపోవటం మరో విశేషం.',
        },
        {
          title: <span class='highlight'>స్థల పురాణం:</span>,
        },
        {
          title: 'శ్రీ దేవీ ఆలయం నిర్మించే సంకల్పంతో నిట్టల ప్రహ్లాద శాస్త్రి గారు 1982 లో 108 మంది రుత్విక్కులతో ,16 రోజులు దేవీ యాగాన్ని పరమనిష్ఠతో చేశారు. వదాన్యులైన దాతలు వీరి అమోఘ సంకల్పానికి స్పందించి ఆలయ నిర్మాణానికి మూడు ఎకరాల స్థలం రాసిచ్చారు. ఈ స్తలమే పైన పేర్కొన్న తొమ్మిది కొండల మధ్యన ఉన్న ప్రదేశం. ఈ ప్రదేశం లో తగిన చోట ఆలయాన్ని నిర్మించాలని శాస్త్రిగారు నడిచి పరిశీలిస్తుంటే, ఒక రోజు అగ్ని గుండంలో మెరుపులతో మెరిసే శరీరంతో పదహారేళ్ళ బాలిక లాగా శ్రీ దేవి దర్శనమిచ్చింది.',
        },
        {
          title: 'పరవశంతో శాస్త్రి గారు అమ్మను అర్చించారు. అక్కడే తనకు ‘ఇల్లు’ కట్టమని దేవి ఆజ్ఞాపించింది. ఆ ప్రదేశం లో త్రవ్వితే అగ్నిలో కాల్చిన గుర్తులున్న పంచలోహ శ్రీ చక్రమేరువు లభించింది. దీన్ని గురించి వాకబు చేయగా ఇక్కడే 250 ఏళ్ళ క్రితం ఒక గొప్ప యజ్ఞం జరిగి నట్లు ,ఆ యజ్ఞం పూర్తి అవగానే ఆ శ్రీచక్ర మేరువు ను భూమిలో నిక్షిప్తం చేసి దానిపై కామాఖ్య పీఠం ప్రతిష్టించి నట్లు తెలిసింది. ఇంకొంచెం ఎత్తుగా ఉన్న కొండ పైన శివాలయం కట్టించారు.',
        },
        {
          title: 'ఈ ఆలయాన్ని శ్రీ చక్ర ఆకారంలోనే నిర్మించడం చాలా అరుదైన విషయం. ఈ ఆలయంలో శ్రీ రాజరాజేశ్వరీ, శివుడు కొలువై ఉన్నారు. శ్రీచక్రయంత్రం ఆకృతిలో నిర్మింపబడిన ఈ ఆలయంలో దేవదేవతలను ప్రతిష్టించారు. *సహస్రాక్షి అంటే వెయ్యి కన్నులు కలదని అర్థం.* శ్రీదేవి సూచించిన పంచలోహ శ్రీచక్రమేరుయంత్రం దొరికిన పర్వత ప్రాంతం ఇదే. సుమారు 250సంవత్సరాల క్రితం ఇక్కడ ఒక గొప్ప యజ్ఝం జరిగిన స్థలం అని ఈ శ్రీ చక్రమేరుయంత్రం ద్వారా తెలిసింది.',
        },
        {
          title: 'నారపాడు శివారులో ఉన్న పుట్రోపు సోదరుల జీడిమామిడి తోట ప్రాంతంలో వీరికి అమ్మ సాక్షాత్కరించి ఇక్కడ మూడు అడుగుల నేల తవ్వితే పంచ శాక్తేయ సంప్రదాయానికి చెందిన ఈ ఆలయ స్థాపనకు ఓ పవిత్ర ఆశయ నేపథ్యం ఉన్నట్లు తెలుస్తుంది. శ్రీచక్రాలయ నిర్మాణానికై తగు ప్రదేశానికై అన్వేషిస్తుండగా నారపాడు శివారులో ఉన్న పుట్రోపు సోదరుల జీడిమామిడి తోట ప్రాంతంలో వీరికి అమ్మ సాక్షాత్కరించి ఇక్కడ మూడు అడుగుల నేల తవ్వితే పంచలోహ శ్రీ చక్రం దొరుకుతందని, యోని స్వరూప శక్తులతో ఓ కామాఖ్యా పీఠాన్ని స్థాపించి తగిన సంప్రదాయంలో పూజలు జరిపించమని చెప్పగా, దేవీ ఆదేశానుసారం సర్వాంగ సుందరంగా, మూడు అంతస్తులతో విలక్షణ అవతార రూపులైన దేవి దేవతల ఆవాసంగా నెలకొల్పబడినది.',
        },
        {
          title: 'కామాఖ్యా పీఠాన్ని శక్తి పూజల కొరకు,  శివపూజల కొరకు కొండమీద శివాలయాన్నీ నిర్మించారు. ఈ మూడు అంతస్థుల గల ఆలయం 108 అడుగుల పొడవు, 108 అడుగుల వెడల్పు, 54 అడుగుల ఎత్తులో నిర్మింపబడినది. ఈ శ్రీచక్రాలయం సుమారు 12సంవత్సరాల క్రితం నిర్మించబడినది. అమ్మ వారి నిలు వెత్తు విగ్రహం ఆది శంకరాచార్యుల వారి సౌందర్య లహరి లో వర్ణించిన రీతిలో శ్రీ లలితా సహస్ర నామ స్త్రోతాలలో వాగ్తేవతలు వర్ణించినట్లుగా ఆలయాన్ని నిర్మించారు.',
        },
        {
          title: '1990 లో మూల విరాట్ అయిన సహస్రాక్షి విగ్రహ ప్రతిష్ట అగమోక్తం గా జరిగింది. శ్రీ చక్రాలయం మూడో అంతస్తులో అంటే బిందు స్తానం లో శయనించిన సదా శివుని మీద కూర్చున్న అమ్మ వారి నిలు వెత్తు విగ్రహం జీవ కళ ఉట్టిపడి కళ్ళను ప్రక్కకు తిప్పలేనంత మనోహరంగా ఉంటుంది. ఆమె చుట్టూ కింది అంతస్తులలో నక్షత్రాల వంటి ఆవరణలు, వాటిల్లో అమ్మవారి పరివార దేవతల విగ్రహాలు చూపరులను ఆకర్షిస్తాయి.',
        },
        {
          title: 'ఈ ఆలయం ప్రపంచంలోనే అతి పెద్ద శ్రీచక్ర నమూనాలలో నిర్మితమైన ఆలయంగా ప్రసిద్ది చెందినది. గర్భాలయంలో ప్రధానదైవంగా శ్రీరాజరాజేశ్వరీ దేవి నల్లని కృష్ణశిలారూపవతిగా వెలుగొందుతోంది.',
        },
        {
          title: 'ఈ ఆలయానికి సాక్షాత్త్ పరమశివుడే క్షేత్ర పాలకుడిగా నెలకొని ఉండటం విశేషం. ఇక్కడ కొండపై  పంచభూలింగేశ్వర స్వామి దేవాలయం దక్షవాటిక ఉన్నాయి. అయితే దక్షిన వాటిక మధ్యభాగంలో పిరమిడ్ ఆకృతిలో ఫలకంపై 360 శివలింగాలను, అగ్రభాగంలో మహాలింగాన్ని ప్రతిష్టించారు. రోజుకి ఒక్క శివలింగార్చన చొప్పున ఏడాది అంత జరిగే అర్చన మహాశివలింగార్చన జరుగుతుంది. ఈ మహాలింగానికి నలువైపులా 1005 శివలింగాలు ప్రతిష్టమై ఉన్నాయి.',
        },
        {
          title: 'నిష్టల ప్రహ్లద శాస్త్రి గారికి అమ్మవారు ధ్యానంలో దర్శనమిచ్చిన విధంగానే దేవీ ఖడ్గమాల దేవతలకు రూపకల్పన చేసి గంధర్వ మాతృమూర్తులుగా 68 విగ్రహాలను భూమి మీద , 10 విగ్రహాలను మొదటి అంతస్తులో 10 విగ్రహాలను రెండో అంతస్తులో సిమెంటుతో నిర్మించి నెలకొల్పారు.',
        },
        {
          title: 'మిగిలిన వాటిని పంచలోహాలతో తయారుచేయించి మూడవ అంతస్తులో అష్టదళ పద్మంలో ఉంచారు. వైష్టవీ, వారాహీ మాహెంద్రీ, చాముండీ, మహాలక్ష్మీ, వీటితో పాటు భూమి మీదే బ్రాహ్మీ, మహేశ్వరీ, కౌమారీ, వైష్టవీ, వారాహీ మాహెంద్రీ, చాముండీ, మహాలక్ష్మీ, బాలాజీ, కాళీయ మర్థనం చేస్తున్న బాల కృష్ణుడు శిలా విగ్రహాలను ప్రతిష్టించారు. వీటికే భక్తులు భక్తీతో అభిషేకం నిర్వహిస్తారు.',
        }
      ],
      title: 'సహస్రాక్షి"  శ్రీ రాజరాజేశ్వరీ దేవి ఆలయం - దేవీపురం',
    },
    {
      "CatID": [
        {
          title: 'ద్రాక్షారామంలో గల శ్రీ మాణిక్యాంబా సమేత శ్రీ భీమేశ్వర స్వామి వార్ల దేవాలయం అతి ప్రాచీన సుప్రసిద్ధ శైవ క్షేత్రం.',
        },
        {
          title: 'ఈ ఆలయాన్ని క్రీ.శ. 7,8 శతాబ్ధాల మధ్య తూర్పు చాళుక్యుల వంశానికి చెందిన చాళుక్య భీముడు నిర్మించినట్టుగా శాసనాల ద్వారా తెలుస్తొంది. ఇక్కడి మూలవిరాట్ శ్రీభీమేశ్వర స్వామి స్వయంభుగా వెలసిన 14 అడుగుల శివలింగం, శుద్ధ స్ఫటికాకార లింగం. ఈయన దేవేరి శ్రీమాణిక్యంబా అమ్మవారు యావత్భారతదేశంలోనే ప్రసిద్ధి చెందిన అష్టాదశ శక్తి పీఠాలలో 12 వ శక్తిపీఠంగా వెలసియున్నది.',
        },
        {
          title: 'తెలుగుకు ఆ పేరు త్రిలింగ అన్న పదం నుంచి ఏర్పడిందని కొందరి భావన.',
        },
        {
          title: 'ఆ త్రిలింగం అనే పదం ఏర్పడేందుకు కారణమైన క్షేత్ర త్రయంలో ద్రాక్షారామం ఒకటి. మిగిలిన రెండు క్షేత్రాలలో ఒకటి కరీంనగర్ జిల్లాలోని కాళేశ్వరము కాగా, మరొకటి శ్రీశైలము',
        },
        {
          title: 'త్రిలింగ క్షేత్రాలలో ఒకటిగా, అష్టాదశ శక్తి పీఠాలలో ద్వాదశ పీఠంగా, దక్షిణ కాశీగా, వ్యాస కాశీగా ద్రాక్షారామానికి ప్రశస్తి ఉంది.',
        },
        {
          title: 'శిల్ప కళాభిరామమై, శాసనాల భాండాగారమై ద్రాక్షారామ భీమేశ్వరస్వామి ఆలయం ఒప్పారుతోంది.',
        },
        {
          title: <span class='highlight'>పుష్కరిణి :</span>,
        },
        {
          title: 'శాతవాహన రాజైన హాలుని కాలానికే ఈ ఆలయం ఉన్నట్లు లీలావతీ గ్రంథం అనే ప్రాకృత భాషా కావ్యంలో పేర్కొన్నారు. ఈ ఆలయాన్ని, సామర్లకోట లోని భీమేశ్వరాలయాన్ని కూడా చాళుక్య రాజయిన భీముడు నిర్మించాడని చెబుతారు. అందుకే ఈ రెండు గుడులు ఒకే రీతిగా ఉండటమేగాక, రెంటి నిర్మాణానికి ఉపయోగించిన రాయికూడ ఒకటేరకంగా ఉంటుంది.',
        },
        {
          title: 'ఈ క్షేత్రాన్ని గురించిన ప్రశంస శ్రీనాథకవి భీమేశ్వర పురాణం లో వివరించాడు. దుష్యంతుడు, భరతుడు, నలుడు, నహషుడు ఈ స్వామిని అర్చించారని వ్రాశాడు.',
        },
        {
          title: 'తిట్టుకవిగా ప్రసద్ధి నందిన వేములవాడ భీమకవి " ఘనుడన్ వేములవాడ వంశజుడ, ద్రాక్షారామ భీమేశునందనుడన్.... " అని చెప్పుకొన్నాడు. అతనికి కవిత్వం అబ్బటం స్వామి ప్రసాదం అయి ఉండవచ్చు.',
        },
        {
          title: 'ఎంతో మంది తెలుగు కవులు శ్రీభీమేశ్వరస్వామిని తమ పద్యాలలో కీర్తించారు. వాటిలో ఈమధ్య వచ్చిన "దక్షారామ భీమేశ్వర శతకం" ఒకటి. దీనిని ప్రొఫెసర్ వి.యల్.యస్. భీమశంకరం రచించాడు.',
        },
        {
          title: <span class='highlight'>గ్రామం పేరు వెనుక చరిత్ర :</span>,
        },
        {
          title: 'పూర్వం దక్ష ప్రజాపతి యజ్ఞం చేసిన ప్రదేశమే నేడు ద్రాక్షారామంగా పిలువబడుతుంది. ఒకప్పుడు ఇది దాక్షారామంగా పిలువబడి కాలక్రమేణా అది ద్రాక్షారామంగా మారింది.తన భర్తకి ఆహ్వానం లేకపోయినప్పటికీ పుట్టింటిపై ప్రేమతో ఆ యజ్ఞానికి వచ్చి అవమానంపాలైన పరమశివుని సతి సతీదేవి ఆత్మాహుతి చేసుకున్న ప్రదేశం ఇదే.',
        },
        {
          title: 'తన భార్యను అవమాన పరిచినందుకు గాను వీరభద్రుడిని సృష్టించిన శివుడు దక్షుడి తల నరికించాడు. సతీదేవి వియోగ వివశత్వం నుంచి శివుడిని బయటపడేయడం కోసం శ్రీమహావిష్ణువు ఆమె శరీరాన్ని 18 ఖండాలుగా చేశాడు. ఆమె శరీర అవయవాలు పడిన ప్రదేశాలు అష్టాదశ శక్తిపీఠాలుగా అవతరించాయి.',
        },
        {
          title: <span class='highlight'>భీమేశ్వరాలయం :</span>,
        },
        {
          title: 'ద్రాక్షారామంలో శివుడు భీమేశ్వరుడిగా స్వయంభువుగా అవతరించాడు. శ్రీలక్ష్మీనారాయణుడు ఈ క్షేత్రానికి క్షేత్ర పాలకుడిగా ఉన్నాడు.',
        },
        {
          title: 'ద్రాక్షారామం త్రిలింగ క్షేత్రాలలో ఒకటిగా పంచారామాల్లో ఒకటిగా దక్షిణ కాశీగా ప్రసిద్ధి చెందింది. ఈ క్షేత్రాన్ని గురించి శ్రీనాథ కవి సార్వభౌముడు తన కావ్యాల్లో పేర్కొన్నాడు. ఇక్కడి స్వామివారిని అభిషేకించడానికి సప్తఋషులు కలిసి గోదావరిని తీసుకు వచ్చారనీ పురాణ కథనాలు వర్ణిస్తున్నాయి.అందువలన అంతర్వాహినిగా ప్రవహించే ఈ గోదావరిని సప్త గోదావరి అని పిలుస్తూ వుంటారు. ఇక్కడి పంచలోహ విగ్రహాలు తామ్ర మూర్తులు 8 వ శతాబ్దం నుంచి ఉన్నవిగా భావిస్తున్నారు.',
        },
        {
          title: <span class='highlight'>అష్ట లింగాలు :</span>,
        },
        {
          title: 'ఈ భీమేశ్వరుడికి ఎనిమిది దిక్కులలోను ఎనిమిది శివలింగాలను చంద్రుడు స్వయంగా ప్రతిష్ఠించాడని విశ్వసించబడుతుంది. తూర్పున కోలంక, పడమర వెంటూరు, దక్షిణాన కోటిపల్లి ఉత్తరాన వెల్ల, ఆగ్నేయంలో దంగేరు. నైరుతిలో కోరుమిల్లి వాయువ్యంలో సోమేశ్వరం, ఈశాన్యాన పెనుమళ్ళ, ప్రాంతాలలో ఈ అష్ట సోమేశ్వర ఆలయాలు ఉన్నాయి.',
        },
        {
          title: 'ఈ భీమేశ్వర ఆలయ ప్రాంగణంలో ఇంద్రేశ్వర, యజ్ఞేశ్వర, సిద్దేశ్వర, యోగీశ్వర, యమేశ్వర, కాళేశ్వర వీరభద్రేశ్వర లింగాలు దర్శనమిస్తాయి. ఇక తూర్పు, పశ్చిమ, ఉత్తర, దక్షిణ దిశగా ఉన్న ఒక్కో గాలి గోపురాన్ని ఒక్కో అమ్మవారు పర్యవేక్షిస్తున్నట్టు స్థలపురాణం వివరిస్తుంది.',
        },
        {
          title: <span class='highlight'>స్థలపురాణం :</span>,
        },
        {
          title: 'పూర్వము తారకాసురుడు అను రాక్షసుడు శివుని గురించి ఘోరమైన తపస్సు చేయగా, శివుడు సాక్షాత్కరించెను. ఆ రాక్షసుడు శివుని యొక్క ఆత్మలింగాన్ని వరంగా కోరగా శివుడు ఆత్మలింగాన్ని ప్రసాదించెను. క్రూర స్వభావం కలిగిన ఆ తారకాసురుడు ఆ లింగ శక్తి వలన దేవతలను, ఋషులను, సత్పురుషులను నానా ఇబ్బందులు పెట్టుచుండగా ఆ బాధలు భరించలేక వీరంతా విష్ణుమూర్తిని ప్రార్థించగా, అపుడు విష్ణువు ఆ లింగం తొలగితేగాని ఆ రాక్షసుని శక్తి నశించదనీ, ఈశ్వరుడి అంశతో జన్మించిన వానితో తప్ప మరెవ్వరి వలనా తనకు మరణం లేకుండా వరం పొంది ఉన్నాడని చెప్పగా, మన్మధ ప్రేరేపణచేత పార్వతీ కళ్యాణం, అనంతరం కుమార సంభవం జరుగగా ఆ కుమారస్వామి రుద్ర గణములకు నాయకత్వం వహించి తారకాసురుడితో యుద్ధం చేయగా, కుమార స్వామి విసిరిన బాణం ఆ ఆత్మలింగానికి తగిలి అయిదు ముక్కలై భూమిమీద అయిదు చోట్ల పడెను. అవే పంచారామ క్షేత్రాలుగా అవతరించెను.',
        },
        {
          title: 'అవి వరుసగా *అమరావతి, భీమవరం, పాలకొల్లు, ద్రాక్షారామం, సామర్లకోట* ఇలా భూమి మీద పడిన ఆత్మలింగాలు కైలాసాన్ని చేరుకోవాలని ఎదగడం ప్రారంభించెను. అలా ఎదిగి పోతూ ఉంటే కలియుగం వచ్చేసరికి మానవులకు అభిషేకాలకు గాని, దర్శనానికి గాని అందకుండా పోతాయని ఒక్కోచోట పడిన ఆత్మలింగానికి ఒక్కొక్క దేముడు అవి ఎదిగిపోకుండా ప్రతిష్ఠ చేసి అభిషేకార్చనలు చేసారు. ఆయా దేవుడు ప్రతిష్ఠ చేసిన లింగం ఆయా దేవుని పేరుతో పిలవబడుతోంది.',
        },
        {
          title: 'అమరావతి:- ఇక్కడ ఇంద్రుడు ప్రతిష్ఠించాడు కాబట్టి అమరేశ్వరస్వామిగా వెలిసెను.',
        },
        {
          title: 'భీమవరం:- ఇక్కడ చంద్రుడు ప్రతిష్ఠించాడు కాబట్టి సోమేశ్వరస్వామిగా వెలిసెను.',
        },
        {
          title: 'పాలకొల్లు:- ఇక్కడ శ్రీరామచంద్రమూర్తి ప్రతిష్ఠించాడు కాబట్టి క్షీరారామలింగేశ్వరస్వామిగా వెలిసెను.',
        },
        {
          title: 'సామర్లకోట:- ఆత్మలింగాన్ని ఛేదించిన దోషం తనకు రాకూడదని కుమారస్వామే స్వయంగా ఇక్కడ లింగాన్ని ప్రతిష్ఠించెను కాబట్టి కుమారారామ భీమేశ్వరస్వామిగా వెలిసెను.',
        }
      ],
      title: 'శ్రీ మాణిక్యాంబా సమేత శ్రీ భీమేశ్వర స్వామి - ద్రాక్షారామం',
    },
    {
      "CatID": [
        {
          title: 'భక్త సంరాక్షణార్ధం శ్రీ మహావిష్ణువు అనేక అవతారాలు ఎత్తాడు, వాటిలో ముఖ్యమైనవి దశావతారాలని మనం కొలుచుకుంటాంకదా. ఇవి భూమి మీద మానవ పరిణామానికి సంకేతాలు అని కూడా చెబుతారు. *దశావతారాలలో మూడవది ఆది వరాహావతారం.',
        },
        {
          title: 'శ్రీ మహావిష్ణువు వరాహావతారాన్ని ఎత్తటానికి సంబంధించిన కధని ఇక్కడ టూకీగా చెప్పుకుందాం.',
        },
        {
          title: 'ఒకసారి శ్రీమహావిష్ణువు దర్శనార్ధం సనక సనందాది మహా ఋషులు వైకుంఠానికి వెళ్ళారు. అక్కడ ద్వారపాలకులైన జయవిజయులు స్వామివారి దర్శనానికి అది సరైన సమయం కాదని అడ్డగిస్తారు. దానితో ఆ మహాఋషులకి కోపం వస్తుంది. జయ విజయులని, ఏ స్వామి సాన్నిధ్యంలో వున్నామనే గర్వంతో తమని అడ్డగించారో, ఆ స్వామి సేవకి దూరమయ్యి భూలోకంలో అసురులుగా జన్మిస్తారని శపిస్తారు.',
        },
        {
          title: 'వారు శ్రీమహావిష్ణువుని ఆయన సేవకి ఎక్కువ కాలం దూరంగా వుండలేమని ప్రార్ధించగా, విష్ణుమూర్తి భక్తులుగా ఏడు జన్మలు లేక శత్రువులుగా మూడు జన్మలలో తనని తిరిగి చేరవచ్చనే వరం ఇస్తాడు. ఏడు జన్మలు ఆయన సేవకి దూరం కాలేమని, శత్రువులుగా మూడు జన్మలలోనే ఆయన సాన్నిధ్యాన్ని ప్రసాదించమని కోరుతారు.',
        },
        {
          title: 'ఆ విధంగా వారు హిరణ్యాక్షుడు, హిరణ్యకశిపుడిగా భూలోకంలో జన్మిస్తారు. మిగతా జన్మలు రావణ - కుంభకర్ణులు, కంస - శిశుపాలురు',
        },
        {
          title: 'హిరణ్యాక్షుడిని చంపటానికి ఆదివరాహావతారంలో, హిరణ్యకశిపునికోసం నరసింహావతారంలో, రావణ, కుంభకర్ణుల కోసం శ్రీరాముడిగా, కంస, శిశుపాలురని అంతం చేయటానికి శ్రీకృష్ణుడిగా అవతరించాడు శ్రీమహావిష్ణువు.',
        },
        {
          title: 'ఈ దశావతారాల్లో ఒక్కరైన భూవరాహస్వామి ఆలయం గురించి తెలుసుకుందాం.',
        },
        {
          title: <span class='highlight'>మైసూర్ సమీపంలోని భువరాహస్వామి ఆలయం:</span>,
        },
        {
          title: 'మైసూర్ సమీపంలోని భువరాహస్వామి ఆలయం విష్ణువు యొక్క మూడవ అవతారం.',
        },
        {
          title: 'కర్నాటక లోని మైసూర్ సమీపంలోని కల్లహల్లి అనే చిన్న గ్రామంలో ఈ ఆలయం ఉంది. ఈ ఆలయం హేమవతి నది ఒడ్డున ఉంది.',
        },
        {
          title: <span class='highlight'>విష్ణువు యొక్క మూడవ అవతారం వరాహ స్వామి:-</span>
        },
        {
          title: 'విష్ణువు యొక్క మూడవ అవతారం వరాహస్వామి అనే అడవిపందిరూపం.',
        },
        {
          title: 'ఈ గుడిలోని విగ్రహం 18 అడుగుల ఎత్తు మరియు బూడిదరాయితో తయారుచేయబడింది. ఈ విగ్రహంలో భూదేవి వరాహస్వామి ఎడమ తొడ మీద కొలువుదీరి దర్శనమిస్తున్నది. దేవత విగ్రహం 3.5 అడుగుల పొడవు ఉంది. హనుమంతుడి విగ్రహం కూడా ప్రధాన విగ్రహం క్రింద చెక్కబడింది.',
        },
        {
          title: 'విగ్రహం యొక్క కుడివైపు, కుడి చేతిలో సుదర్శనచక్రం, ఎడమవైపు తొడమీద భూదేవీ ఆసీనులై కూర్చొని దర్శనమిస్తున్నది.',
        },
        {
          title: 'ఇక్కడ స్థానికులకు భువరాహస్వామి ఆలయం చాలా ప్రసిద్ది చెందింది. ఈ స్వామివారి దర్శనం కోరి వచ్చేవారు ఈ దేవుడు మర్మమైన శక్తులు కలిగి ఉన్నాడని నమ్ముతారు.',
        },
        {
          title: 'భువరాహస్వామి ఆలయంలో పక్కన హేమావతి నది ఉంది. ఈ నదీ ప్రవాహం ఎక్కువగా ఉండటం వల్ల ఈ నదిలో ఈత కొట్టడం, పుణ్యస్నానాలు చేయడానికి అవకాశం ఉండదు. వర్షా కాలంలో ఈ నదిలోని నీరు ఆలయం గోడకు చేరుకుంటుంది. ఏప్రిల్ మరియు మేలో నీరు తగ్గిన తరువాత వార్షిక ఉత్సవాలు జరుగుతాయి. వార్షికోత్సవం ప్రతి సంవత్సరం జరుపుకుంటారు. ఈ ఉత్సవాల్లో పెద్ద సంఖ్యలో భక్తులు సమీప ప్రాంతాల నుండి పండుగలలో పాల్గొంటారు.',
        },
        {
          title: 'భూవరాహస్వామి ఆలయం 2500 సంవత్సరాలకు పైగా ఉంది. ఈ ఆలయంలో గౌతమ మహర్షి తపస్సు చేశాడని చెపుతారు.',
        },
        {
          title: 'ఈ దేవాలయానికి రాజ వీర్ బాలాల గురించి ఒక పురాణ కథ ఉంది. వేట కోసం రాజు అడవికి వెళ్ళిన సమయంలో విశ్రాంతి కొరకు ఒక చెట్టు క్రింద పడుకున్నాడు. అలా విశ్రాంతి తీసుకుంటన్న సమయంలో అక్కడ ఒక వింత ద్రుశ్యాన్ని గమనించాడు. ఒక కుక్క చిన్న కుందేలును తరుముకుని రావడం చూశాడు.',
        },
        {
          title: 'మరి కొద్ది సేపటికి కుందేలు కుక్కను తరుముకునిపోవడం గమనించాడు. అప్పుడు ఆ రాజు ఈ ప్రదేశం కొన్ని మాంత్రిక శక్తులను కలిగి ఉందని విశ్వసించాడు మరియు ఈ ప్రదేశంలో 16 అడుగుల లోతు తవ్వి చూడగా అక్కడ వరాహస్వామి విగ్రహం దాగి ఉండటాన్ని కనుగొన్నాడు. ఈ సంఘటన తరువాత, ఈ రాజు అక్కడ వరహాస్వామి ఆలయాన్ని నిర్మించి ప్రతీ రోజు పూజలు చేయడం ప్రారంభించాడు.',
        },
        {
          title: <span class='highlight'>పూజలు మరియు సేవలు :</span>,
        },
        {
          title: '1.ముక్తి పూజ',
        },
        {
          title: '2.భూ సూక్త పారాయణ',
        },
        {
          title: '3.గోసేవ',
        },
        {
          title: '4.రేవతి అభిషేక సేవ',
        },
        {
          title: <span class='highlight'>ఎలా వెళ్లాలి?</span>,
        },
        {
          title: 'బెంగళూరు -మైసూర్ రహదారిలో కల్లహల్లి అనే చిన్న గ్రామం ఉంది. ఈ గ్రామం మాండ్య జిల్లాలోని పాండవుర్ నుండి 32 కిలోమీటర్ల దూరంలో ఉంది. సమీప బస్సు స్టేషన్ 2 km దూరంలో ఉంది. ఈ ప్రదేశం చేరుకోవడం చాలా సులభం. మాండ్య జిల్లాలోని కల్లహల్లి అనే చిన్న గ్రామం చేరుకోవడానికి బస్సు సౌకర్యం ఉంది. అయితే బస్సులు ఆలయానికి రెండు కిలోమీటర్ల దూరంలో మాత్రమే నిలుస్తాయి. అక్కడి నుండి నడక లేదా మీ సొంత వాహనాల ద్వారా ప్రయాణించవచ్చు.',
        }
      ],
      title: 'మైసూర్ సమీపంలోని కల్లహల్లి భూవరాహస్వామి ఆలయం',
    },
    {
      "CatID": [
        {
          title: 'జగజ్జనని ఆది పరాశక్తి అనేక రూపాల్లో భక్తులకు అభయమిస్తోంది. అమ్మ ఆరాధనకు వేలాది దేవాలయాలు ఉన్నాయి. వీటిల్లో ప్రముఖమైనది రాజస్థాన్‌లోని *జైసల్మేర్‌ జిల్లాలో పాక్‌ సరిహద్దుకు ఆనుకొని ఉన్న శ్రీ తనోట్‌ మాత ఆలయం.',
        },
        {
          title: 'అష్టాదశ శక్తి పీఠాల్లో పాక్‌లోని బలూచిస్థాన్‌లో వెలిసిన *హింగ్లాజ్‌ మాత* అవతారమే తనోట్‌ మాత అని *‘చరన్‌’* సాహిత్యం తెలుపుతోంది. *తనోట్‌ మాత తరువాత కర్ణిమాత గా అవతరించిందని చెబుతారు.',
        },
        {
          title: 'ఒక్క బాంబూ పేలలేదు',
        },
        {
          title: 'అమ్మవారి ఆలయాన్ని భారత రక్షణదళాలు పర్యవేక్షిస్తుంటాయి. 1965, 1971 పాక్‌తో జరిగిన యుద్ధాల్లో అమ్మవారి ప్రభావంతో పాక్‌పై విజయం సాధించినట్టు స్థానికులు చెబుతారు.',
        },
        {
          title: '1965లో జరిగిన యుద్ధంలో పాక్‌ ఈ ప్రాంతాన్ని స్వాధీనం చేసుకునేందుకు భారీ బలగాలతో పెద్ద ప్రణాళిక వేసింది. ఆ సమయంలో ఆలయ సమీపంలో భారత్‌కు చెందిన కొద్దిమంది సైనికులు మాత్రమే విధుల్లో ఉన్నారు. ఆలయ ప్రాంగణంలో ఉన్న భారత సైనికులపై పాక్‌ ఏకంగా 3 వేల బాంబులను ప్రయోగించింది.',
        },
        {
          title: 'అయితే ఒక్క బాంబు కూడా పేలకపోవడం అమ్మవారి అద్భుతశక్తికి  నిదర్శనమని అక్కడి పెద్దలు చెబుతుంటారు. పన్నాగం పారకపోవడంతో పాక్‌ సైన్యం తోకముడిచింది. అప్పటి నుంచి తనోట్‌ మాత ఆలయానికి వేలాదిమంది సందర్శకులు వస్తున్నారు.',
        },
        {
          title: <span class='highlight'>13 శతాబ్ధాల క్రితమే నిర్మాణం</span>,
        },
        {
          title: 'ఈ ఆలయాన్ని 13 శతాబ్ధాల క్రితమే ఈ ఆలయం నిర్మితమైంది. రాజపుత్ర వంశానికి చెందిన తానురావు ఈ ఆలయాన్ని నిర్మించారు. ఇప్పటికీ ఆ వంశస్థులు ఆలయంలో పూజలు నిర్వహిస్తుంటారు. 1971 యుద్ధం అనంతరం ఆలయాన్ని సరిహద్దు భద్రతాదళం నిర్వహణలోకి వెళ్లింది.',
        },
        {
          title: 'ఆలయాన్ని మరింతగా విస్తరించారు. భారత విజయాలకు గుర్తుగా ఆలయ ప్రాంగణంలో ఒక విజయ స్తంభాన్ని నిర్మించారు. పాక్‌పై విజయానికి గుర్తుగా ఏటా వేడుకలు నిర్వహిస్తారు. ఆలయ ప్రాంగణంలో ఒక మ్యూజియం ఉంది. ఇక్కడ పాక్‌ ప్రయోగించి పేలని బాంబులతో పాటు పలు ఆయుధాలను వీక్షించవచ్చు.',
        },
        {
          title: 'ఎలా చేరుకోవాలి ?',
        },
        {
          title: 'రాజస్థాన్‌లోని జైసల్మేర్‌ జిల్లాలో పాక్‌ సరిహద్దుకు ఆనుకొని ఉంటుందీ ఆలయం. జైసల్మేర్‌లో దిగి 120 కి.మీ. ప్రయాణించి ఇక్కడకు చేరుకోవాలి. జైసల్మేర్‌ నుంచి ట్యాక్సీలు దొరుకుతాయి.',
        },
        {
          title: 'నవంబర్ నుంచి జనవరి నెలలో మాత్రమే ఈ ఆలయాన్ని సందర్శించడం వాతావరణ పరిస్థితులకు అనుగుణంగా ఉంటుంది.',
        }
      ],
      title: 'తనోట్‌ మాత ఆలయం (జైసల్మేర్‌)',
    },
    {
      "CatID": [
        {
          title: 'శ్రీరామజయం శ్రీరామజయం శ్రీరామజయం',
        },
        {
          title: 'నెట్టికంటి అంటే ఒకే ఒక కన్ను గలవాడని అర్థం. స్వామికి కుడి కన్ను మాత్రమే ఉంటుంది. భక్తులకు ఈయనే కల్పతరువు మరియు వరప్రదాత కూడానూ',
        },
        {
          title: 'ప్రతిరోజు వేలాది మంది దర్శించుకునే ఈ ఆలయం భూత, ప్రేత, దుష్ట గ్రహపీడ నివారణ క్షేత్రంగా ఖ్యాతికెక్కింది.',
        },
        {
          title: 'ఆంజనేయస్వామి భక్తులకు సుపరిచితమైన ఈ శ్రీ నెట్టి కంటి ఆంజనేయస్వామి* దేవాలయం. అనంతపురం జిల్లాలోని గుంతకల్ పట్టణంలో గల కసాపురం అనే గ్రామంలో ఉన్నది.',
        },
        {
          title: 'ఈ ఆంజనేయస్వామిని దర్శించుకోవడానికి తెలుగు రాష్ట్ర ప్రజలే కాదు, పక్క రాష్ట్రమైన కర్నాటక నుండి కూడా అధిక సంఖ్యలో వస్తుంటారు. అన్నట్టు ఈ ఆలయం మన రాష్ట్రంలో ఉన్న హనుమాన్ ఆలయాలన్నింటిలోకి అతి పెద్దది.',
        },
        {
          title: 'ఆలయ చరిత్ర చదవటానికి పెద్దగా ఉంటుంది కానీ మీకు అర్థమయ్యే రీతిలో విడమర్చి చిన్నగా చెబుతాను.',
        },
        {
          title: <span class='highlight'>ఆలయ చరిత్ర</span>,
        },
        {
          title: 'అనగనగా విజయనగర సామ్రాజ్య కాలం. క్రీ.శ.1521 లో శ్రీవ్యాసరాయల వారు తుంగభద్ర నది ఒడ్డున ధ్యానం చేసేవాడు.  వ్యాసరాయల వారు గొప్ప చిత్రకారుడు. ప్రతిరోజు తాను ధరించే గంధంతో ఎదురుగా ఉన్న ఒక రాయి మీద శ్రీ ఆంజనేయ స్వామి రూపం చిత్రించేవాడు. అలా చిత్రించిన ప్రతిసారి హనుమంతుడు నిజరూపం ధరించి అక్కడి నుంచి వెళ్ళిపోయేవాడట ...!',
        },
        {
          title: 'ఇది గమనించిన వ్యాస రాయలవారు హనుమంతుని శక్తిని వేరోకచోటికి వెళ్ళనీయకుండా, స్వామివారి ద్వాదశ నామాల బీజాక్షరాలతో ఒక యంత్రం తయారు చేసి, దానిలో శ్రీ ఆంజనేయ స్వామివారి నిజరూపాన్ని చిత్రించారట. దాంతో స్వామి ఆ యంత్రంలో బంధింపబడి అందులో ఉండిపోయారట.',
        },
        {
          title: 'ఇప్పటి కర్నూలు జిల్లాలో ఉన్న చిప్పగిరి మండలంలో ఉన్న శ్రీ భోగేశ్వరి స్వామి వారి ఆలయంలో ఒకరోజు వ్యాసరాయల వారు నిద్రిస్తుండగా ఆంజనేయస్వామి కలలో వచ్చి నేను ఫలానా ప్రాంతంలో ఉన్నాను, నాకు గుడి కట్టించు అని చెప్పాడట.'
        },
        {
          title: 'ఆ ప్రాంతం ఎక్కడుందో ఉపదేశించమని వ్యాసరాయలవారు కోరగా స్వామి వారు ఈ విధంగా అనుగ్రహించాడు. ఏమనగా',
        },
        {
          title: 'దక్షిణం వైపున వెళితే ఒక ఎండిన వేపచెట్టు కనిపిస్తుందని, దానికి దగ్గరగా వెళితే ఆది చిగురిస్తుందని, అక్కడ భూమిలో తాను ఉంటాను అని చెప్పారట.',
        },
        {
          title: 'మరునాడు ఉదయాన్నే లేచి దక్షిణం వైపు ప్రయాణం గావించి చివరకు ఆ ఎండిన వేప చెట్టును కనుగొంటాడు వ్యాసరాయలు. రాయల వారు ఆ చెట్టు వద్దకు చేరుకోగానే, ఆ చెట్టు కాస్త ఆకుపచ్చగా చిగురిస్తుంది.',
        },
        {
          title: 'ఆశ్చర్యచకితుడైన వ్యాసరాయలవారు వెంటనే అక్కడ భూమిని తవ్విస్తాడు. తవ్వకాల్లో ఒంటి కన్ను గల ఆంజనేయస్వామి వారి విగ్రహం కనిపిస్తుంది. రాయలవారు ఆ విగ్రహాన్ని అత్యంత భక్తి శ్రద్ధలతో ప్రతిష్టించి, ఆలయాన్ని నిర్మిస్తాడు.',
        },
        {
          title: 'ఏటా నెట్టి కంటి ఆంజనేయస్వామి ఆలయంలో వేలాది మంది భక్తులు కాషాయ వస్త్రాలు ధరించి హనుమదీక్షలు తీసుకుంటారు. హనుమద్ వ్రతానికి, పూజలకు కూడా ఈ ఆలయం ప్రసిద్ధి. ఇందులో బస చేయడానికి తగినన్ని సత్రాలు, కాటేజీలు అందుబాటులో ఉన్నాయి.',
        },
        {
          title: 'ప్రతి ఏడాది ఒక చర్మకారుడు ఏక భుక్తం ఉంటూ, బ్రహ్మచర్యాన్ని పాటిస్తూ ఆంజనేయ స్వామికి చెప్పుల జత తయారు చేసి సమర్పిస్తాడు. మర్నాడు వచ్చి చూస్తే అది అరిగిపోయినట్లు, చిరిగిపోయినట్లు కనిపించటం విశేషం. స్వామి ఆ చెప్పులు ధరించి రాత్రి పూట విహారానికి వెళ్ళి వస్తూంటాడని భక్తుల నమ్మకం.',
        },
        {
          title: 'ప్రతి ఏటా వైశాఖ, శ్రావణ, కార్తీక, మాఘ మాసాలలో శనివారం నాడు అసంఖ్యాకంగా భక్తులు స్వామిని సందర్శించి తమ మనోభీష్టాలను నెరవేర్చుకుంటారు.',
        },
        {
          title: <span class='highlight'>ఎలా చేరుకోవాలి</span>,
        },
        {
          title: 'ముందుగా విమాన మార్గం విషయానికి వస్తే, కసాపురానికి 60 కి. మీ. దూరంలో ఉన్న బళ్లారి లోని విమానాశ్రయం సమీప విమానాశ్రయంగా ఉన్నది. అక్కడ దిగి ప్రభుత్వ బస్సుల్లో లేదా రైలు మార్గంలో ప్రయాణించి చేరుకోవచ్చు.',
        },
        {
          title: 'మీకు వీలైతే, క్యాబ్ లేదా ప్రవేట్ వాహనాలను అద్దెకు తీసుకొని కూడా *కసాపురం* చేరుకోవచ్చు. ఒకవేళ రైలు మార్గంలో వచ్చే వారు కసాపురానికి సమీపంలో ఉన్న గుంతకల్ రైల్వే జంక్షన్ లో దిగి ప్రభుత్వ బస్సుల్లో గానీ, షేర్ ఆటో లో గానీ ఎక్కి చేరుకోవచ్చు. ఈ రైల్వే స్టేషన్ దేశంలోని అన్ని పెద్ద నగరాలతో, పట్టణాలతో అనుసంధానించబడి ఉంది.',
        },
        {
          title: 'కనుక రైలు మార్గం ఉత్తమమైనదిగా నా అభిప్రాయం. చివరగా రోడ్డు మార్గం విషయానికి వస్తే ... గుంతకల్ నుండి ప్రభుత్వ ఆర్డినరీ బస్సుల్లో (పల్లె వెలుగు బస్సులు) ప్రయాణించి చేరుకోవచ్చు.  గుంతకల్ పాత బస్ స్టాండ్ నుండి కూడా ప్రతి 5 నిమిషాలకు ఒక ఆటో ఉంటుంది. కనుక 4 కిలోమీటర్ల దూరలో ఉన్న నెట్టి కంటి ఆంజనేయస్వామి ఆలయాన్ని ప్రశాంతంగా దర్శించుకోవచ్చు.',
        },
        {
          title: <span class='highlight'>శ్రీరామ జయరామ జయజయరామ</span>,
        }
      ],
      title: 'నెట్టికంటి ఆంజనేయస్వామి ఆలయం -  కసాపురం',
    },
    {
      "CatID": [
        {
          title: 'అమ్మవారి నాభిస్థానంలో పంచముఖ శివుడు ఆసీనుడై కనిపించే అద్భుతం',
        },
        {
          title: 'త్రిమూర్తులు సహా ముక్కోటి దేవతలందరినీ నడిపించే తల్లి *జగజ్జనని.* సకల చరాచర జగత్తును సృష్టించిన తల్లి జగజ్జనని. అలాంటి శక్తి స్వరూపిణిని *కాళీ, దుర్గ, లక్ష్మి, సరస్వతి* రూపాల్లో దర్శనం చేసుకుంటాం.',
        },
        {
          title: 'కానీ *జగజ్జనని* రూపంలో ఆ తల్లిని మాత్రం చాలా తక్కువమంది దర్శించుకొని ఉంటారు. ఇలా *జగజ్జనని* రూపంలో ఆ తల్లి వెలసిన ఆలయాలు ప్రపంచంలో రెండు మాత్రమే ఉన్నవి. మరి ఆ ఆలయాలు ఎక్కడ ఉన్నాయి? ఆ అమ్మవారి రూపం ఎలా ఉంటుంది? ఆ ఆలయం విశేషాలు ఏంటనేది మనం ఇప్పుడు తెలుసుకుందాం.',
        },
        {
          title: 'ఆంధ్రప్రదేశ్ రాష్ట్రం, కర్నూలు జిల్లా, నంద్యాలలో *శ్రీ జగజ్జనని* ఆలయం ఉంది. ఈ అమ్మవారి ఆలయాలు ప్రపంచంలో రెండు ఉండగా అందులో ఒకటి హిమాలయ పర్వతాల్లోని మానస సరోవరం లో ఉండగా, మరొక ఆలయం ఈ ప్రాంతంలో ఉందని చెబుతారు.',
        },
        {
          title: 'ఇక మానస సరోవరంలో వెలసిన అమ్మవారు స్వయంభువు అనీ, ఆ విగ్రహం ప్రస్తుతం శిధిలావస్థలో ఉందని చెబుతారు.',
        },
        {
          title: 'ఇక ఈ ఆలయంలో వెలసిన అమ్మవారి విగ్రహాన్ని చూస్తే ప్రతి ఒక్కరికి ఒక కొత్త అనుభూతి వస్తుందని అంటారు.',
        },
        {
          title: 'ఈ ఆలయ స్థల పురాణానికి వస్తే',
        },
        {
          title: 'పూర్వం నంద్యాలకు చెందిన శివనాగపుల్లయ్య అనే వ్యక్తి భవానీమాత భక్తుడు. అతను ప్రతి సంవత్సరం కూడా తప్పకుండ భవానీ మాల ధరించేవాడు.',
        },
        {
          title: 'అయితే 1983 వ సంవత్సరంలో అయన భవానీ దీక్షలో ఉన్నపుడు యాత్రలో భాగంగా అహోబిలానికి వెళ్లగా అక్కడ కొంతమంది యోగులని కలిసాడు. అప్పుడు వారి మధ్య ఆధ్యాత్మిక చర్చ జరుగగా జగజ్జనని ప్రస్తావన వచ్చినది. అందులో ఉన్న ఒక యోగి జగజ్జనని రూపం గురించి తెలియచేసి అతడికి ఆ అమ్మవారి రూపం ఉన్న ఒక చిత్ర పటాన్ని ఇవ్వగా అందులో ఉన్న అమ్మవారి దివ్యమంగళ రూపాన్ని చూసి ముగుడై ఈ అమ్మవారి రూపాన్ని ఇప్పటివరకు చూడలేదే అని చాలా ఆవేదన చెందాడు.',
        },
        {
          title: 'ఆ చిత్రంలో ఉన్న అమ్మవారి ఆలయ కేవలం హిమాలప్రాంతంలో ఉన్న మానస సరోవరంలో మాత్రమే ఉందని తెలుసుకున్న అతడు ఎలాగైనా తన ప్రాంతంలో ఆ అమ్మవారి ఆలయాన్ని నిర్మించాలని భావించాడు.',
        },
        {
          title: 'ఇలా ఆ అమ్మవారి ఆలయాన్ని ఈ ప్రాంతంలో నిర్మించాడు.',
        },
        {
          title: 'ఇక ఈ ఆలయ గర్భాలయంలో జగజ్జనని విగ్రహం నల్లరాతితో చేయబడి తొమ్మిది అడుగుల ఎత్తు ఉండి,  ఎన్నో ప్రత్యేకతలతో దర్శనం ఇస్తుంది.',
        },
        {
          title: 'అమ్మవారి నాభిస్థానంలో పంచముఖ శివుడు ఆసీనుడై కనిపిస్తాడు. పాదపీఠ భాగంలో శ్రీమహావిష్ణువును కొలువు తీర్చిన తీరు అద్భుతం.',
        },
        {
          title: 'ఈ అమ్మవారు అష్టభుజాలతో దర్శనం ఇవ్వగా, కుడివైపున ఉన్న చేతుల్లో చంద్రమండలం, సూర్యమండలం, భూమండలం, అభయహస్తం, లక్ష్మీదేవి, త్రినేత్రం, త్రిశూలం ఉంటాయి.',
        },
        {
          title: 'ఎడమవైపు ఒక చేతిలో శంఖం, రెండో చేతిలో డమరుకం, మూడోచేతిలో ధనుస్సు, నాల్గవ చేతిలో బ్రహదేవుడు ఉంటారు.',
        },
        {
          title: 'ఇంకా 17 తలల ఆదిశేషుడు అమ్మవారికి ఛత్రంగా కనిపిస్తాడు. ఇలా అమ్మావారు సింహవాహనం పై దర్శనం ఇస్తూ భక్తులని మంత్రముగ్దుల్ని చేస్తుంది.',
        }
      ],
      title: 'జగజ్జనని ఆలయం కర్నూలు జిల్లా నంద్యాల',
    },
    {
      "CatID": [
        {
          title: 'ఆదిలాబాదు జిల్లాలోనే కాకుండా రాష్ట్రంలోనే ప్రఖ్యాతిచెందిన ఆలయం జ్ఞానసరస్వతి ఆలయం.',
        },
        {
          title: 'ఇది ఆదిలాబాదు జిల్లా ముధోల్ మండలం బాసరలో ఉంది.',
        },
        {
          title: 'ఈ ఆలయం నిర్మల్ పట్టణానికి 35 కి.మీ దూరంలో గోదావరి నది ఒడ్డున ఉంది. హైదరాబాదుకు సుమారు 200 కి.మీ. దూరం. భారత దేశంలో గల రెండే రెండు సరస్వతీ దేవాలయాల్లో ఒకటి కాశ్మీరులో ఉండగా, రెండవది ఇదే.',
        },
        {
          title: 'బాసరలో జ్ఞాన సరస్వతి అమ్మవారు మహాలక్ష్మి , మహాకాళి సమేతులై కొలువు తీరి ఉన్నారు. ఇక్కడి మందిరం చాళుక్యులకాలంలో నిర్మింపబడింది. ఈ మందిరం సాదా సీదాగా ఎంతో ప్రశాంతమైన వాతావరణంలో ఉంది.',
        },
        {
          title: <span class='highlight'>పురాణగాధ:</span>,
        },
        {
          title: 'బాసర క్షేత్రాన్ని వేదవ్యాసుడు ప్రతిష్ఠించినట్లు స్థలపురాణం చెబుతోంది. కురుక్షేత్ర యుద్ధానంతరం వేదవ్యాసుడు మనశ్శాంతి కోరి తన కుమారుడైన శుకుని(ఈ శకుని వేరు) తో దండకారణ్యానికి వచ్చి ఇక్కడ గోదావరి తీరాన ఉన్న ప్రశాంత వాతావరణానికి ముగ్ధుడై ఇక్కడ కుటీరం నిర్మించి తపస్సు చేయడం ప్రారంభించాడు.',
        },
        {
          title: 'వేదవ్యాస మహర్షికి జగన్మాత దర్శనమిచ్చి ముగ్గురమ్మలకు ఆలయాన్ని నిర్మించమని ఆదేశించింది. వ్యాసుడు నదిలోంచి మూడు గుప్పెళ్ళు ఇసుక తెచ్చి ముగ్గురు దేవతలమూర్తులు ప్రతిష్ఠించాడు. వ్యాసుడు ఇక్కడ కొంత కాలము నివసించాడు కనుక అప్పటినుండి ఈ ఊరు వ్యాసపురి, వ్యాసర అనబడి, తరువాత ఇక్కడ ఉన్న మహారాష్ట్ర ప్రజల ప్రభావం వలన బాసర గా నామాంతరాన్ని సంతరించుకున్నది.',
        },
        {
          title: 'ఇక్కడ వ్యాస నిర్మితమైన ఇసుక విగ్రహాలకు పసుపు పూసి అలంకరించి పూజలు నిర్వహిస్తారు. ఈ పసుపును ఒక్క రవ్వంత తినినా అత్యంత విజ్ఞానం , జ్ఞానము లభిస్తుందని గాఢంగా విశ్వసిస్తారు.',
        },
        {
          title: 'ఆదికవి వాల్మికి ఇక్కడ సరస్వతీ దేవిని ప్రతిష్ఠించి రామాయణం వ్రాసాడని బ్రహ్మాండ పురాణం వివరిస్తుంది. ఈ గుడికి సమీపంలో వాల్మికి మహర్షి సమాధి పాలరాతి శిల ఉన్నాయి. మంజీరా , గోదావరి  తీరాన రాష్ట్రకూటుల చేత నిర్మించబడిన మూడు దేవాలయాలలో ఇది ఒకటని విశ్వసించబడుతున్నది. ఆరవ శతాబ్దంలో నందగిరి ప్రాంతాంలో నందేడుని రాజధానిగా చేసుకుని పరిపాలించిన బిజలుడు అను రాజు బాసరలోని ఈ ఆలయమును నిర్మించాడన్న కథనం ప్రచారంలో ఉంది.',
        },
        {
          title: <span class='highlight'>ఆలయ విశేషాలు</span>,
        },
        {
          title: 'సరస్వతి ఆలయ గోపురము వెనక సరస్వతి విగ్రహము',
        },
        {
          title: 'బాసర సరస్వతీ ఆలయం దేశంలోని ప్రఖ్యాత సరస్వతీ ఆలయాలలో ఒకటి. ఇక్కడ సరస్వతీ ఆలయంలో బాలబాలికలకు అక్షరాభ్యాసం చేయడానికి ప్రజలు అత్యంత ప్రాధాన్యత ఇస్తారు. ఇక్కడ ఉన్న త్రిదేవీ మూర్తులు వ్యాస ప్రతిష్ఠితం కనుక ఈ ప్రత్యేకత. అక్షరాభ్యాసానికి ప్రత్యేక రుసుము ఉంటుంది. ప్రజలు బంధు మిత్రులతో వచ్చి పిల్లలకు అక్షరాభ్యాసము చేస్తారు. ఆలయ ప్రాంగణంలోని ప్రత్యేక మందిరంలో అక్షరాభ్యాసం జరిపిస్తారు. ఆలయ ప్రాంగణంలోని జ్ఞానప్రసూనాంబ చేతిలో ఉన్న అఖండ జ్యోతికి నూనె వంచడానికి భక్తులు ఆసక్తి ప్రదర్శిస్తారు.',
        },
        {
          title: <span class='highlight'>రవాణా సౌకర్యాలు</span>,
        },
        {
          title: 'హైదరాబాదు - మన్మాడ్ మార్గంలో బాసర స్టేషను ఉంది. రాష్ట్ర రాజధాని హైదరాబాదు నుండి , మరికొన్ని సమీప పట్టణాలనుండి (నిర్మల్, నిజామాబాద్ , భైంసా) బస్సు సౌకర్యం ఉంది. నిజామాబాద్ నుండి బాసరకు 40 కి.మీ. దూరం. నిర్మల్ పట్టణానికి 35 కి.మీ. హైదరాబాదుకు సుమారు 205 కి.మీ. దూరం. హైదరాబాద్ - మన్మాడ్ మార్గంలో బాసర స్టేషను ఉంది.',
        },
        {
          title: 'సుమారు 200 సంవత్సరాల క్రితం విధ్వంస కాండకు పాల్పడుతున్న కొందరు దుండగులను తరిమివేసి మక్కాజీ పటేల్ అనే వ్యక్తి మరి కొందరి సహాయంతో ఆలయం పునర్నిర్మాణం చేయించాడు.',
        },
        {
          title: 'ప్రధాన దేవాలయానికి తూర్పు భాగమున ఔదుంబర వృక్షఛాయలో దత్త మందిరం, దత్త పాదుకలు ఉన్నాయి. మహాకాళీ దేవాలయం పశ్చిమ భాగమున నిత్యార్చనలతో చూడ ముచ్చటగా ఉంటుంది. శ్రీ వ్యాస మందిరం దక్షిణ దిశలో ఉంది. ఇందులో వ్యాస భగవానుని విగ్రహము , వ్యాస లింగము ఉన్నాయి.',
        },
        {
          title: 'మందిరానికి దగ్గరలో ఒక గుహ ఉంది. ఇది నరహరి మాలుకుడు తపస్సు చేసిన స్థలమంటారు. అక్కడ "వేదవతి" (ధనపు గుండు) అనే శిలపై తడితే ఒక్కోప్రక్క ఒక్కో శబ్దం వస్తుంది. అందులో సీతమ్మవారి నగలున్నాయంటారు.',
        },
        {
          title: 'ఇక్కడికి దగ్గరలో 8 పుష్కరిణులు ఉన్నాయి. వాటి పేర్లు - *ఇంద్రతీర్థం, సూర్యతీర్థం, వ్యాసతీర్థం, వాల్మీకి తీర్థం, విష్ణుతీర్థం, గణేషతీర్థం, పుత్రతీర్థం, శివతీర్థం.',
        },
        {
          title: <span class='highlight'>పూజా విశేషాలు</span>,
        },
        {
          title: 'ప్రతి నిత్యం ఉదయం 5 గంటలకు సరస్వతీ మూర్తికి వైదిక మంత్రోపేతంగా పూజ జరుపుతారు. సాయంకాలం ఆరు గంటలకు పూజ జరుగుతుంది. ఈ ఆలయానికి ఆంధ్రప్రదేశ్ , మహారాష్ట్ర , ఒడిషా. మధ్య ప్రదేశ్ వంటి రాష్ట్రాలనుండి అధిక సంఖ్యలో భక్తులు తరలి వస్తుంటారు. ముఖ్యముగా విద్యాప్రాప్తికై ఇక్కడ విద్యార్థులతో అక్షరాభ్యాసము చేయించి దేవికి పలక , బలపము , కాగితము , కలము వంటి కానుకలు సమర్పించే ఆచారము ఉంది. కేశఖండనము, ఉపనయనము, వివాహాలు, భజనలు నిరంతరం జరుగుతూనే ఉంటాయి.',
        },
        {
          title: <span class='highlight'>దర్శన వేళలు</span>,
        },
        {
          title: 'ఉదయము 4 గంటలకు ఆలయద్వారాలు తెరచి 4 గంటల నుండి 4.30 గంటల వరకు అభిషేకము టిక్కెట్లను ఇస్తారు. 4 గంటల నుండి 7.30 గంటల వరకు  అభిషేకము, అలంకారము, హారతి, నైవేద్యము చేసి ప్రసాద వితరణ చేస్తారు. 7.30 గంటల నుండి 12.30 గంటల వరకు అర్చన, సర్వదర్శనం ఇతర పూజలు చేస్తారు. 12.30 గంటలకు నివేదన చేసి ఆలయము 2 గంటవరకు మూసి ఉంచుతారు. 2 గంటల నుండి 6.30 గంటల వరకు అర్చన సర్వదర్శనం చేస్తారు. 6.30 గంటల నుండి 7 గంటల వరకు ప్రదోష పూజ నిర్వహిస్తారు. 7 గంటల నుండి 8.3౦ గంటల వరకు మహా హారతి దర్శనం తరువాత ఆలయము మూసి వేస్తారు.',
        },
        {
          title: <span class='highlight'>నవరాత్రులు</span>,
        },
        {
          title: 'ఆశ్వీయజ శుద్ధ పాడ్యమి మొదలు నవమి వరకు జరుగుతాయి. ఉదయము, సాయంకాలము 64 ఉపచారములతో వైదిక విధానంలో అమ్మవారికి వైభవంగా పూజలు జరుగుతాయి. శ్రీదేవీ భాగవతము, దుర్గా సప్తశతి పారాయణాలు జరుగుతాయి. మహార్నవమి రోజున చండీ హోమము చేయబడుతుంది. విజయదశమి నాడు వైదిక మంత్రాలతో మహాభిషేకము, సుందరమైన అలంకారము, సాయంకాలము పల్లకీసేవ , శమీపూజ జరుగుతాయి. ఈ ఉత్సవాలలో భక్తులు , ఉపాసకులు తమ తమ అభిష్టానుసారం పూజలు చేసుకొంటారు. ఇంకా ధార్మిక చర్చలు , ఉపన్యాసములు , హరికథలు , పురాణ పఠనం నిర్వహిస్తారు. యాత్రికులకు నిరతాన్నదానం సమర్పిస్తారు.',
        }
      ],
      title: 'జ్ఞాన సరస్వతి దేవాలయం - బాసర',
    },
    {
      "CatID": [
        {
          title: 'అన్నపూర్ణే సదా పూర్ణే శంకరప్రాణ వల్లభే!',
        },
        {
          title: 'జ్ఞాన వైరాగ్య సిద్ద్యర్థం భిక్షాం దేహిచ పార్వతి!!',
        },
        {
          title: 'అన్నము నుండే సమస్త జీవులు సృష్టింపబడుతున్నవి. సమస్త జీవులకు ప్రాణ శక్తి అన్నము నుండే ఉద్భవిస్తుంది.',
        },
        {
          title: 'ఆకలి ప్రాణ శక్తిని క్షీణింపజేస్తున్నది.  కనుక *అన్నము - ప్రాణ శక్తి - ఆకలి* మూడును ఒకదానికొకటి అనుసంధానము కలిగి ఉన్నవి. సమయానికి అన్నము లభింపకున్న ప్రతి జీవి అలమటించును. కనుకే అన్నము పరబ్రహ్మ స్వరూపమై ఉన్నది.',
        },
        {
          title: 'ఆకలి రెండు రకములు - మొదటిది శరీర పోషణకు సంబందించినది రెండవది పారమార్ధికమునకు సంబంధించినది. ఈ రెండు ఆకళ్ళను తీర్చే తల్లి *శ్రీ అన్నపూర్ణాదేవి.* అందుకే అమ్మను ప్రాణ శక్తిని, జ్ఞానాన్ని ప్రసాదించమని వేడుకుంటాము.',
        },
        {
          title: 'కాశీ క్షేత్రంలో అన్నపూర్ణాదేవి కొలువై ఉన్నట్లే, శ్రీ క్షేత్ర హొరనాడు అనే క్షేత్రంలో శ్రీ ఆదిశంకర ప్రతిష్టిత అన్నపూర్ణా దేవి ఆలయం ఉన్నది',
        },
        {
          title: <span class='highlight'>స్థలపురాణం :</span>,
        },
        {
          title: 'భారత దేశం అంతటా పాదయాత్ర చేసి ఎన్నో పీఠాలను స్థాపించిన ఆదిశంకరులు ఒకసారి మార్గమధ్యంలో ఒక చోట ఆగారు.  శంకరులకు వారి శిష్య బృందానికి ఆకలిగా ఉంది.  అది దట్టమైన అడవి ప్రాంతం.  ఎక్కడా ఆతిథ్యమిచ్చే గృహాలు లేవు. అప్పుడు శంకరులు అన్నపూర్ణా దేవిని స్తోత్రంచేయగా,  ఒక పండు ముత్తైదువ రూపంలో వారిని సమీపించి ఆకలితో ఉన్నట్లు ఉన్నారు. మీరంతా మా గృహానికి వచ్చి మా ఆతిథ్యం స్వీకరించవలసినది అని కోరింది.',
        },
        {
          title: 'శంకరులు వారి శిష్యులు ఆ ముత్తైదువ  గృహానికి వెళ్ళగా అక్కడ పంచభక్ష్యపరమాన్నాలతో షడ్రసోపేతమైన అన్నము పెట్టింది. శంకరులు ఆవిడను *శ్రీ అన్నపూర్ణాదేవి* అని గుర్తించి మరల స్తోత్రం చేసి అమ్మవారిని అక్కడే కొలువై ఉండమని ప్రార్ధించారు.  అప్పుడు అన్నపూర్ణాదేవి బంగారు ప్రతిమయై అక్కడ శాశ్వతంగా నిలిచిపోయారు.  అదే నేడు *హొరనాడు శ్రీ అన్నపూర్ణా ఆలయం* గా భాసిల్లుతోంది.  ఇక్కడ అమ్మవారిని దర్శించుకుని ప్రసాదం స్వీకరించిన వారికి ఈ జన్మలో అన్నపానీయాలకు లోటు ఉండదు అని ప్రతీతి.',
        },
        {
          title: 'హొరనాడు అనే ప్రాంతం బెంగళూరు నుండి 330 కి.మీ. దూరంలో గల అందమైన ప్రాంతం. ఇది శృంగేరిక్షేత్రం నుండి 75 కి.మీ. దూరంలో గలదు. బెంగళూరు నుండి ఈ ప్రాంతానికి ప్రతిరోజూ బస్సులు ఉంటాయి. ఈ క్షేత్రానికి వెళ్ళుటకు అవసరమైన బస్సులను కర్ణాటక రాష్ట్ర రోడ్డు రవాణా సంస్థ నడుపుతోంది. కొన్ని ప్రైవేటు బస్సులు కూడా లభిస్తాయి.',
        }
      ],
      title: 'శ్రీ అన్నపూర్ణనేశ్వరి దేవి ఆలయం - హొరనాడు',
    },
    {
      "CatID": [
        {
          title: 'త్రిమూర్తులలో ఒకడైన బ్రహ్మకు భృగుమహర్షి  శాపము వలన దేవాలయాలు ఉండవు. ఉన్న దేవాలయాలు కూడా శివలింగాకృతిలో ఉంటాయి. అటువంటి దేవాలయాలు బ్రహ్మ, శివుడు పేర్లను కలిపి ఉంటాయి. అందుచేతనే శివుడిని పూజించేటప్పుడు ముందుగా బ్రహ్మను తలచుకుంటాము, అటువంటి దేవాలయాలలో గుంటూరు జిల్లాలోని చేబ్రోలు గ్రామములో వెలసిన *చతుర్ముఖ బ్రహ్మ లింగేశ్వర స్వామి దేవాలయము* చాలా ముఖ్యమైనది.',
        },
        {
          title: 'ఈ దేవాలయాన్ని రాజా వాసిరెడ్డి వెంకటాద్రి నాయుడు గారు 200 ఏళ్ల క్రితము అంటే 1817 ప్రాంతములో నిర్మించిన ఈ దేవాలయములో బ్రహ్మ, శివునితో పాటు పూజలు అందుకుంటాడు.',
        },
        {
          title: 'ఈ దేవాలయ ప్రాంగణములో చోళులకాలం నాటి శిలాశాసనలు కనిపిస్తాయి దీనిని బట్టి చోళ నాయకులైన వెలనాడు చోళులు ఈ దేవాలయాన్ని దర్శించి నట్లు చారిత్రాత్మకాధారాలు ఉన్నాయి.',
        },
        {
          title: 'కాశీలో బ్రహ్మదేవుడి గుడి తరువాత చేబ్రోలులో బ్రహ్మకు గుడి ఉండటం వలన చేబ్రోలును దక్షిణ కాశీగా పిలుస్తారు. పద్మాకారంలోని నల్లరాతి శివలింగము చుట్టూ బ్రహ్మ నాలుగు ముఖాలు ఉంటాయి కాబట్టి ఇక్కడ వెలసిన బ్రహ్మను "చతుర్ముఖ బ్రహ్మలింగేశ్వర స్వామి" అనే పేరుతొ పూజిస్తారు కాబట్టి భక్తులకు ఏకకాలములో శివుడిని, బ్రహ్మను పూజించిన ఫలితము దక్కుతుంది. అందువల్లే లింగాష్టకములో, *“బ్రహ్మ మురారి సురార్చిత లింగం నిర్మల భాసిత శోభిత లింగం”* అని ప్రార్ధిస్తారు.',
        },
        {
          title: 'ఈ దేవాలయము కోనేరు మధ్యలో ఉంటుంది. చుట్టూ రెండు చిన్న శివాలయాలు, తూర్పున చంద్రమౌళీశ్వరుడు, పడమర సహస్రలింగేశ్వరుడి ఆలయము, 999 చిన్న చిన్న శివలింగాలతో ఉన్నపెద్ద శివలింగముతో ఉంటుంది. ఉత్తరంలో వేణుగోపాలస్వామి దక్షిణాన రంగనాథస్వామి కొలువై ఉంటారు. నాలుగు దిక్కుల తరువాత నాలుగు మూలలలో అమ్మవారి నాలుగు శక్తి ఆలయాలు ఉంటాయి. ఆలయానికి దక్షిణాన గాలిగోపురం, ఎర్ర రాయితో నిర్మించిన నందీశ్వరుడి విగ్రహము ఉంటాయి.',
        },
        {
          title: 'పూర్వము ఇక్కడ 101 దేవాలయాలు, 101బావులు ఉండేవిట కాలక్రమేణా చాలా దేవాలయాలు అంతరించిపోయాయి.',
        },
        {
          title: 'ఈ ఆలయం దగ్గరలోనే దక్షిణముగా చోళులచే నిర్మింపబడ్డ పురాతనమైన శ్రీఆదికేశవ స్వామి ఆలయము ఉంది *ఇక్కడ కొలువై ఉన్న విష్ణుమూర్తి కుడిచేతిలో శంఖము, ఎడమ చేతిలో చక్రము అపసవ్యముగా ఉండటం విశేషము.*',
        },
        {
          title: 'ఈ ఆలయానికి వెనుక వైపున తిరుమలలో ఉన్నట్లు *విమాన ఆదికేశవస్వామి* విగ్రహము ఉంటుంది. ఆలయము మూసి ఉన్న సమయములో భక్తులుఈ విమాన స్వామిని దర్శించుకోవచ్చు ఈ దేవాలయముతో పాటు శ్రీ నాగేశ్వరస్వామి, శ్రీ భీమేశ్వర స్వామి ఆలయాలు కూడా దగ్గరలోనే ఉన్నాయి.',
        },
        {
          title: 'ఈ దేవాలయాలయాలు అన్ని 9 –14 శతాబ్దాల కాలములో నిర్మింపబడ్డాయి అని పురావస్తు శాస్త్రజ్ఞుల అంచనా. వేయిస్తంభాల మండపముతో నటరాజస్వామి దేవాలయము ప్రస్తుతము నాగేశ్వరస్వామి ఆలయానికి దగ్గరలో శిధిలావస్థలో ఉన్న నంది విగ్రహానికి ఎదురుగా ఉండేది అని చెపుతారు. పన్నెండు అడుగుల పొడవు ఉన్న నటరాజ విగ్రహము వేల సంవత్సరాల క్రితము ముఖ్య ఆకర్షణగాఉండేది.',
        },
        {
          title: 'భక్తులు శ్రీ బ్రహ్మ లింగేశ్వరస్వామి ఆలయములో చతుర్ముఖుడి దర్శనానికి చెరువు మధ్యగల మండపానికి వంతెన మీదుగా వెళతారు. ఈ దేవాలయములో ముఖ్యముగా నాలుగు పూజనీయం స్థలాలు, *నాగేశ్వర, ఆదికేశ్వర, భీమేశ్వర, బ్రహ్మలింగేశ్వర* కలిగి ఉండటం వలన చాలా ప్రశస్తమైన పుణ్యక్షేత్రముగా విరాజిల్లుతుంది.',
        },
        {
          title: 'భీమేశ్వర స్వామి ఆలయము రూపకల్పన నిర్మాణము చాల భాగము చాళుక్య రాజు, కృష్ణ దేవరాయలు కాలము నాడే జరిగింది. మిగిలిన భాగము పది పద్నాల్గవ శతాబ్దాల మధ్య జరిగింది.ఈ ప్రాంగణములోనే ప్రసన్నంజనేయ స్వామి ఆలయము నుండి ఈ ఆలయ గోపురము పిరమిడ్ ఆకృతిని పోలి ఉంటుంది. ఇన్ని ప్రతేకతలు ఉన్న చతుర్ముఖ బ్రహ్మలింగేశ్వరస్వామి దేవాలయము తప్పనిసరిగా దర్శించవలసిన పుణ్యక్షేత్రము.',
        }
      ],
      title: 'చతుర్ముఖ బ్రహ్మలింగేశ్వర స్వామి దేవాలయము - చేబ్రోలు - గుంటూరు జిల్లా',
    },
    {
      "CatID": [
        {
          title: 'ప్రపంచంలోనే అతి ఎత్తైన అక్షర గాయత్రీ శ్రీచక్ర పీఠం - ఆంధ్రప్రదేశ్ లోని తూర్పుగోదావరి జిల్లా, రాజమహేంద్రవరం లో ఉంది.',
        },
        {
          title: 'ఆ ఆలయ విశేషాలేమిటో ఇపుడు చూద్దామా!!!!',
        },
        {
          title: 'వేద స్వరూపిణిగా త్రిసంధ్యా సమయంలో జపించే మంత్రాధిష్టాన దేవతగా గాయత్రీ దేవిని కొలుస్తారు.',
        },
        {
          title: 'గాయిత్రీ దేవి శ్రీ శక్తి స్వరూపిణిగా పంచముఖాలతో మహా శ్రీచక్ర మేరువుపైన కొలువైన క్షేత్రం రాజమహేంద్రవరంలోని అక్షరకోటి గాయిత్రీ పీఠం.',
        },
        {
          title: 'ఇక్కడ అమ్మవారు గాయిత్రీ మంత్రంలోని బీజాక్షరాలకు ప్రతీకలుగా ఇరవైనాలుగు రూపాల్లో పూజలు అందుకుంటున్నారు. రుగ్వేదంలో మొదటగా లిఖించిన మంత్రంగా గాయత్రీ మంత్రాన్నీ చెబుతారు.',
        },
        {
          title: 'న గాయత్య్రా: పరంమంత్రం నమాతు: పరదేవతామ్* అనేది పురాణవచనం. తల్లిని మించిన దైవం లేదు, గాయిత్రి మాతను మించిన మంత్రం లేదని దీని అర్థం.',
        },
        {
          title: 'గాయత్రి అన్న పదమునకు,  *గయాన్ త్రాయతే ఇతి గాయత్రీ* అని ఆదిశంకరాచుర్యలు భాష్యం చెప్పారు. అంటే...ప్రాణాలను రక్షించే మంత్రం గాయత్రీ మంత్రమని భావన. అలాగే వాల్మీకి రామాయణానికి మూలాధారం గాయత్రీ మంత్రమేనని పేర్కొంటారు. ఈ మహా మంత్రానికి వ్యాఖ్యాన రూపంమే రామాయణ మహాకావ్య రచన జరిగిందని చెబుతారు.',
        },
        {
          title: 'అటువంటి వేద స్వరూపిణికి నెలవైన ఆలయం *రాజమండ్రిలోని అక్షరకోటి గాయత్రీ పీఠం.* ఈ క్షేత్ర విశేషాలేంటో మనం ఇప్పుడు తెలుసుకుందాం.',
        },
        {
          title: 'ఎత్తైన గాయత్రీ శక్తిపీఠాల్లో ఒకటి:',
        },
        {
          title: 'ఈ క్షేత్రం ఎత్తైన గాయత్రీ శక్తిపీఠాల్లో ఒకటిగా విరాజిల్లుతోంది. ఈ క్షేత్రం గోదావరీ తీరంలో కొలువుదీరి ఉంది. ఈ శక్తిపీఠం యొక్క ఆలయ గోపురం నిర్మాణం ఆకాశాన్ని తాకుతోందా అన్నట్లుగా ఆద్యాంతం ఎన్నో ప్రత్యేకతలను కలిగి ఉంది.',
        },
        {
          title: 'షట్చక్ర ఆకారంలో మొదటి ఆరు అంతస్తులూ, వాల్మీకి రామాయణంలోని ఆరు కాండలకు ప్రతీకలుగా నిర్మించారు.',
        },
        {
          title: 'ఆలయం క్రింద భాగంలో సుమారు వెయ్యి శ్రీచక్రాలతో మహాశ్రీచక్ర మేరువును ఏర్పాటు చేశారు. ఈ ఆలయ ఆవరణలోనే సహస్రలింగేశ్వరుడి విగ్రహాలు, నవగ్రహాలు ఉన్నాయి.',
        },
        {
          title: 'ఈ ఆలయానికి క్షేత్రపాలకులుగా ఉన్న ఇరవై నాలుగు అడుగుల కార్తికేయుడు, పంచముఖ ఆంజనేయస్వామి విగ్రహాలు పర్యటకులను విశేషంగా ఆకట్టుకుంటున్నాయి.',
        },
        {
          title: 'మొదటి అంతస్తుని మూలాధార చక్రంగా, రెండవ అంతస్తులో అయిదు శిరస్సులతో బ్రాహ్మి అవతారంలో గాయిత్రీ దేవి కొలువుదీరి దర్శనమిస్తుంది.',
        },
        {
          title: 'మూడవ అంతస్తును మణిపురగా పిలుస్తారు. ఇందులో గాయిత్రీ మంత్రంలోని మొదటి పాదంలోని ఎనిమిది అక్షరాలకు ప్రతీకలుగా అష్టలక్ష్ముల రూపాలను ప్రతిష్టించారు.',
        },
        {
          title: 'ఆ పై అంతుస్తులో గాయిత్రీ దేవి మంత్రంలోని రెండో పాదంలో ఉండే ఎనిమిది అక్షరాలకు ప్రతీకలుగా మరో ఎనిమిది శక్తిస్వరూపాలను ఏర్పాటు చేశారు.',
        },
        {
          title: 'ఆరో అంతస్తులో తుర్య గాయత్రీ మంత్రం ప్రకారంగా ఆజ్ఝాచక్రంలో చతుర్వేద మాతలను ప్రతిష్టించారు.  వాల్మీకి రామాయణంలోని ఆరుకాండలకు సంకేతంగా ఆలయంలోని మొదటి ఆరు అంతస్తులను తీర్చిదిద్దారు.',
        },
        {
          title: 'ఏడు, ఎనిమిది అంతస్తుల్లో అష్టాదశ శక్తిపీఠాలను ప్రతిష్టించగా',
        },
        {
          title: 'తొమ్మిదో అంతస్తులో నవదుర్గలు, పదిలో దశ మహావిద్యలు',
        },
        {
          title: '11వ అంతస్తులో శ్రీరామ పట్టాభిషేకానికి సంబంధించిన దృశ్యాలు',
        },
        {
          title: '12వ అంతస్తులో ధ్యానమందిరంను నిర్మించారు. 144 అడుగుల ఎత్తులో నిర్మించిన ఆలయ శిఖరం అత్యంత రమణీయంగా తీర్చిదిద్దారు.',
        },
        {
          title: <span class='highlight'>ఎలా వెళ్లాలి:</span>,
        },
        {
          title: 'గోదావరి తీరంలో ఉన్న గాయత్రీ క్షేత్రాన్ని చేరుకోవడానికి రైలు, రోడ్డు, విమాన మార్గాలున్నాయి. రోడ్డు మార్గంలో వచ్చేవారు రాజమండ్రి బస్ స్టేషన్ కి చేరుకుని అక్కడ నుండి లోకల్ బస్సులు, లోకల్ వెహికల్స్ లో వెళ్లొచ్చు. దేశంలో వివిధ ప్రదేశాల నుండి కూడా రాజమండ్రికి రైలు సదుపాయం కలదు. రైల్వే స్టేషన్ కు సమీపంలో ఉన్న ఈ క్షేత్రానికి నడిచి వెళ్ళవచ్చు. ఈ క్షేత్రం రాజమండ్రి విమానాశ్రయానికి సుమారు ఎనిమిది కిలోమీటర్ల దూరంలో ఉంది. అక్కడి నుండి రైలు మార్గం గుండా ప్రయాణించి గాయత్రీ శక్తిపీఠంను దర్శనం చేసుకోవచ్చు.',
        }
      ],
      title: 'అక్షర గాయత్రీ శ్రీచక్ర పీఠము - రాజమహేంద్రవరం',
    },
    {
      "CatID": [
        {
          title: 'జునాఘడ్ లో అతిముఖ్య మైనవి 5 పర్వత శిఖరాలు',
        },
        {
          title: 'మొదటి శిఖరమైన *అంబాశిఖరం* లో నేమినాథ మరియు అంబామాత (పార్వతి దేవి) దేవాలయాలు గలవు.',
        },
        {
          title: 'రెండవ శిఖరమైన *గురుగోరఖ్ నాథ్ శిఖరం* లో గురుగోరఖ్ నాథ్ దేవాలయం మరియు అఖండ ధుని గలవు.',
        },
        {
          title: 'మూడవ శిఖరమైన *ఒఘాద్ శిఖరం* లో అనేక గుహాలయాలు గలవు.',
        },
        {
          title: 'నాలుగవ శిఖరమైన *గురుదత్తాత్రేయ శిఖరం* లో దత్తాత్రేయుని కమండలకుండం, అఖండ దత్త ధుని మరియు గురు దత్తాత్రేయుని పాదుకలు గలవు.',
        },
        {
          title: 'ఐదవ శిఖరమైన *కాళికాశిఖరం* లో మహాకాళీమాత దేవాలయం కలదు. దీనినే పావఘర్ శిఖరం అంటారు. దీనిని చేరుకోవడానికి కమండలకుండం నుండి వేరొక దారి తీసుకొని వెళ్ళాలి. ఇక్కడ సహజంగా ఏర్పడిన మహాకాళీమాత యొక్క ప్రసాదపాత్రను చూడవచ్చు.',
        },
        {
          title: 'ఆలయానికి చేరటానికి మొత్తం 10,000 మెట్లు ఎక్కాలి. ఎవరైనా వెళ్ళితే తెల్లవారుజామున నుండే నడక ప్రారంభిస్తే చేస్తే చాలా మంచింది.',
        },
        {
          title: 'అలాగే భావనాథ్ దేవాలయం గిర్నార్ పర్వత శ్రేణుల పాదాల దగ్గర గల అతి గొప్ప పురాతన శివాలయం. శివరాత్రికి శివుడే స్వయంగా ఇక్కడకు వస్తాడని భావించే యోగులు, అఘోరాలు, దిగంబర సాధువులు ఆ రోజు ఇక్కడ పెద్ద సంఖ్యలో హాజరౌతారు.',
        },
        {
          title: 'ఈ దేవాలయంలో అత్యంత మహిమగల స్వయంభూ శివలింగం గలదు. శివ పార్వతుల విహారంలో వారి దుస్తులు ఇక్కడ పడిపోయాయని పురాణేతిహాసాలు చెబుతున్నాయి. అందువల్లనే ఇక్కడ సాధువులు దానికి ప్రతీకగా దిగంబరంగా తురుగుతారు. ఈ దేవాలయంలో మృగికుండ్ అనే కుండం కలదు. భక్తులు ఇందులో పవిత్ర స్నానాలు ఆచరిస్తారు. శివరాత్రికి ఇక్కడ అతి పెద్ద జాతర జరుగుతుంది *. గిర్నార్ లిలి పరిక్రమ మరియు ఇతర పోటీలు ఇక్కడ నుండే ప్రారంభం అవుతాయి.',
        },
        {
          title: 'మనం ఏకార్యక్రమమైనా ప్రారంభించబోయేముందు విఘ్ననాయకుడైన విఘ్నేశ్వరుడిని ముందుగా పూజించి పనిని ప్రారంభించడం ఆనవాయితి . ఈ సంప్రదాయానికి భిన్నంగా గిరిరాజ్ గిర్నార్ క్షేత్ర యాత్రలో పర్వత అధిరోహణకు ముందు అందరూ ఖచ్చితంగా *ఛడవొవ్ హనుమాన్* కు ప్రార్ధన లేదా పూజ చేయాలి. దీనికి గల కారణం ఛడవొవ్ హనుమాన్ ‘ప్రాణవాయువుకు’ అధిష్టాన దేవుడు.',
        },
        {
          title: 'సాధారణంగా ఈ యాత్రలో భక్తులు గిర్నార్ పర్వతం పైకి వెళ్ళే కొలది ప్రాణవాయువు అందక ఇబ్బంది పడతారు , అలాంటివేవీ జరగకుండా ఛడవొవ్ హనుమాన్ భక్తులను రక్షిస్తుంటారు. ఈయన మూలాధార చక్రం లోనే అతి శక్తివంతమైన గణపతి కుడా ఉంటారు. అందువల్లనే ఛడవొవ్ హనుమాన్ దేవాలయం మొదటి మెట్టు దాటగానే మొట్టమొదటగా ఉంటుంది. ఈయన ఆశీస్సులుంటేనే ముందుకు…లేదంటే వెనక్కే! ',
        },
        {
          title: 'మొదటి మెట్టు ఎక్కే ముందు ఈయనను మర్చిపోయి కొద్దిదూరం వెళ్ళాక గుర్తుతెచ్చుకొని తిరిగి వెనకకు వచ్చి ప్రార్ధించే వారంటే ఈయనకు పిచ్చి కోపమట. కాబట్టి భక్తులు ముందుగానే మొదటిమెట్టు ఎక్కుతూనే ఈయన సహాయాన్ని, అనుమతిని కోరాలి.',
        },
        {
          title: <span class='highlight'>అంబా జీ మాత దేవాలయం:</span>,
        },
        {
          title: 'అంబా జీ మాత (పార్వతి దేవి) దేవాలయాన్ని 12వ శతాబ్దంలో పునర్నిర్మించారు. అంతకు ముందు ఇక్కడ చిన్నదైన గుడి ఉండేది. ఈ చిన్న గుడి చుట్టూ పెద్ద ప్రాకారాలను కట్టి పెద్ద దేవాలయంగా మార్చారు. ఈ దేవాలయం అతి పురాతనమైదని. ఈ దేవాలయ పునర్నిర్మాణంలో మాత యొక్క రధం మరియు ఆమె కాలి ముద్రలు కనుగొన్నారు. ఈ ప్రదేశంలో కృష్ణుడుకి తలకేశాలు [పుట్టు వెంట్రుకలు] తీసారని చరిత్ర చెబుతోంది.',
        },
        {
          title: 'అంబా జీ మాత యొక్క కళ్ళు అతిశక్తి వంతమైనవి. అమ్మ మొత్తం గిర్నార్ పర్వత శ్రేణులను రక్షిస్తూ పహారా కాస్తూ ఉంటారని ఇక్కడి పూజారులు చెబుతుంటారు. అంబా జీ మాత దేవాలయం దాటిన తరువాత వచ్చే మైదానంలో అనేక దుకాణాలు ఉంటాయి.ఇది దాటితే ఇక ఎలాంటి దుకాణాలు ఉండవు. కాబట్టి నీళ్ళు మొదలైనవి తీసుకొన్ని వెళ్ళితే చాలా మంచిది.',
        },
        {
          title: 'సాధారణంగా భక్తులు ముందుగా కమండల కుండం వెళ్లి, మళ్లీ మెట్లుఎక్కి పైకి వచ్చి దత్తాత్రేయశిఖరం( అవలోకన శిఖరం), దత్త పాదుకల దర్శనానికి వెళతారు. కమండల్ కుండ్ లో భోజనం చెయ్యాలనుకునే భక్తులు ముందుగా గురు దత్తాత్రేయశిఖరం( అవలోకన శిఖరం) వెళతారు.',
        },
        {
          title: <span class='highlight'>కమండల కుండం:</span>,
        },
        {
          title: 'గురు దత్తాత్రేయుడు ఆయన కమండలాన్ని విసిరేసిన ప్రదేశంలో రాళ్ల మధ్యలో నుండి ఉద్భవించిన కుండమే ‘కమండల కుండం’. ఇక్కడ గురు దత్తాత్రేయుల వారి అఖండ ధుని, వారు వాడిన త్రిశూలం, కమండలం మరియు ఇతర వస్తువులు ఇప్పటికీ ఉన్నాయి. కమండల కుండం లోని నీరు తియ్యగా, చల్లగా ఉంటాయి.',
        },
        {
          title: 'ఇక్కడ గల ఆశ్రమంలో భక్తులకు ఉచిత భోజనం (ఉదయం 11:00 గంటల నుండి) మరియు ఉచిత తేనీరు  ఇస్తారు. ఇక్కడ గల గురు దత్తాత్రేయుల వారి అఖండ ధుని దత్తాత్రేయుల వారే 12000 సంవత్సరాల క్రితం వెలిగించారు. ఇప్పటికీ ఆ ధుని నిరంతరాయంగా వెలుగుతూ ఉండడం ఇక్కడి విశేషం.',
        },
        {
          title: 'ప్రతీ సోమవారం ఉదయం ఇక్కడ గల అతి పవిత్రమైన దత్తాత్రేయుల వారి అఖండ ధునిని Open చేస్తారు. ప్రతీ భక్తుడు ఈ దృశ్యాన్ని చూసి తిరవలసినదే! దత్తాత్రేయశిఖరం కమాన్ దగ్గర నుండి నిట్ట నిలువుగా వుండే కొన్ని వందల మెట్లు ఎక్కిన తరువాత ఆఖరుగా మనమెంతగానో ఎదురుచూసే, మన జన్మని చరితార్ధం చేసే గురు దత్తాత్రేయ పాదుకలు వస్తాయి.',
        },
        {
          title: 'ఆ పాదుకల మహిమను ఏమానవ మాత్రుడు వర్ణింప సాహసం చేయగలడు? గురు పాదుకా దర్శనం అనంతరం అక్కడ ఉండే పెద్ద ‘ఘంట’ ను కొట్టడం అక్కడి ఆనవాయితి. 10,000 మెట్లు ఎక్కిన అలసటంతా ఒక్కసారిగా ఆ పాదుకా దర్శనంతో పటాపంచలైపోతాయి. భక్తులు ఎంతో ఆనందంతో , గురు దత్తుడికి కృతజ్ఞతలు తెలుపుతూ తృప్తితో క్రిందకి దిగుతారు.',
        }
      ],
      title: 'శ్రీ దత్త క్షేత్రం, జునాగడ్, గుజరాత్',
    },
    {
      "CatID": [
        {
          title: 'ఆధ్యాత్మికంగా పంచారామాల్లో ఒకటైన సామర్లకోట భీమేశ్వరస్వామి ఆలయం దేశవ్యాప్తంగా ప్రముఖ ఆలయాల్లో ఒకటి.',
        },
        {
          title: 'తూర్పు గోదావరి జిల్లా రాజమండ్రికి 50 కిలోమీటర్ల దూరంలో ఉంది. ఇక్కడి భీమేశ్వరుడిని కుమారస్వామి ప్రతిష్టించడం వల్ల కుమారారామ భీమేశ్వరం అనే పేరు వచ్చిందని చెబుతారు.',
        },
        {
          title: 'క్రీ.శ. 892 నుండి 921 వరకు మొదటి చాళుక్య భీమనపాలుడు కుమారరామాన్ని రాజధానిగా చేసుకుని రాజ్యపాలన చేశాడు. ఇతడికి భీమేశ్వరుడి మీద అమితమైన భక్తి, ఆలయానికి ప్రాకార మండపాలను నిర్మించారు. సామర్లకోటలోని భీమేవ్వరాలయం నిర్మాణశైలిలో ద్రాక్షారామంలోని భీమేశ్వరాలయాన్ని పోలి ఉంటుంది. మరి ఈ ఆలయ విశేషాలను మరి కాస్త వివరంగా తెలుసుకుందాం.',
        },
        {
          title: 'ఇక్కడ స్వామి వారు లింగరూపంలో దర్శనం ఇస్తారు. ఇక్కడి అమ్మవారు *బాల త్రిపురసుందరి* గా పూజలందుకుంటుంది. అపురూప సౌందర్యవతి అయిన ఈ మాతను చూడడానికి రెండు కళ్లూ చాలవు. ఆలయంలో ఊయల స్తంభం నేటికి ఊపితే ఉగుతుంది.',
        },
        {
          title: 'గుడిలో స్వామి వారికి ఎదురుగా మండపంలో వున్న నంది విగ్రహం ఏక శిలచే చెక్కబడివున్నది. ఆలయంలోని మండపం నూరు రాతి స్తంభాలను కలిగి ఉన్నప్పటికీ శిల్పి తన శిల్ప కళా వైవిధ్యంతో నిర్మించడంతో ఏ రెండు స్తంభాలూ ఒకేలా ఉండకపోవడం గమనార్హం. ఇక్కడ శివలింగం సున్నపు రాయిచే నిర్మితమై తెల్లని రంగులో చూడముచ్ఛటగా ఉండి భక్తులను ఆకర్షిస్తుంది.',
        },
        {
          title: <span class='highlight'>ప్రాకార ముఖద్వారం సమీపంలో ప్రాచీన సరోవరం</span>,
        },
        {
          title: '1340-1466 ప్రాంతంలో రాజ్యపాలన చేసిన కాకతీయ రాజు ఈ ఆలయంలో కొంతభాగాన్ని పునర్నిర్మించినట్టు తెలుస్తోంది. కోటగోడలాంటి ప్రాకారం లోపల అంతే ఎత్తుగల రెండవ ప్రాకారం ఉంది. ప్రాకార ముఖద్వారం సమీపంలో ప్రాచీన సరోవరం, వెనుక భాగాన పెద్ద రాతిస్థంభము ఉన్నాయి. ఈ ఆలయం గర్భాలయం, అంతరాలయం, ముఖమండపం అనే మూడు భాగాలుగా ఉంటుంది. విశాలమైన ప్రాకారాలతో నాలుగు ద్వారాలతో కోనేటి జలాలతో చాళుక్యుల శిల్పకళా నైపుణ్యంతో అలరారుతోన్న ఈ క్షేత్రాన్ని దర్శించగానే మనసుకి ఎంతో ఆహ్లాదం, ఆనందం కలుగుతాయి.',
        },
        {
          title: 'దేవాలయం లోపలి ప్రాకారంలో వినాయకుడు, కాలభైరవుడు, వీరభద్రుడు, మహాకాళీ, శనేశ్వరుడు నవగ్రహాలు కొలువై ఉండటం చూస్తారు. ప్రధాన ద్వారానికి ఎడమవైపు బాలాత్రిపురసుందరి అమ్మవారు, కుడివైపున ఊయల మంటపం కనిపిస్తాయి. గర్భగుడిలో రెండో అంతస్తు వరకూ పెరిగిన 14 అడుగుల భీమేశ్వరుడి శివలింగం నయనానందాన్ని కలిగిస్తుంది. ఈ దేవాలయం చుట్టూ రెండు ఎత్తైన రెండు ప్రాకారాలను కలిగి ఉంది. ప్రాకారపు గోడలు ఇసుకరాయిచే కట్టబడినవి. వెలుపలి ప్రాకారపు గోడకు నాలుగుదిక్కులలో నాలుగు ప్రవేశ మార్గాలున్నాయి.',
        },
        {
          title: 'ప్రధాన ప్రవేశ ద్వారాన్ని సూర్యద్వారం అంటారు. గుడిలోని స్థంబాల మీద అప్సర బొమ్మలు చెక్కబడివున్నవి. చాళుక్య వంశానికి చెందిన విక్రమాదిత్యుని పుత్రుడు చాళుక్య భీమేశ్వర కుమారరామం పేరు మీదుగా ఇక్కడి శివుడికి కుమరరామ అని వ్యవహారంలోకి వచ్చినట్లు తెలుస్తున్నది.',
        },
        {
          title: 'నిర్మాణ సమయంలోనే ఈ శివలింగం అంతకంతకు పెరిగిపోతుండటం గమనించి శిల్పులు శివలింగంపైభాగాన చీల కొట్టారనే కథ స్థానికంగా వినిపిస్తూ ఉంటుంది. ఈ మందిరం నిర్మాణం క్రీ.శ 892లో ప్రారంభమై సుమారు క్రీ.శ 922వరకు సాగింది. ఆలయం నిర్మాణం చాలా చక్కని శిల్పకళ కలిగి ఇప్పటికీ పగుళ్ళు లేకుండా ఉంది.',
        },
        {
          title: '1340-1466మధ్యకాలంలో రాజ్యం చేసిన కాకతీయులు ఈ మందిరాన్ని కొంత పునర్మించారు.',
        },
        {
          title: 'ఈ ఆలయంలో కాకతీయుల నాటి శిల్పకళను, అంతకు పూర్వపు తూర్పు చాళుక్యులనాటి శిల్పకళను తేలికగా గుర్తించవచ్చును. 1147-1494 మధ్యకాలంలో ఆలయానికి సమర్పించిన విరాళాలు గురించిన శాసనాలున్నాయి. దేవాలయం స్తంభాలపై ఉన్న శిల్పాలు భక్తులను విశేషంగా ఆకట్టుకుంటాయి. హయగ్రీవస్వామి, శేషసాయి, యోగమండపంలో వటపత్రసాయి, ప్రహారీ చుట్టుగోడలపైన గరుత్మంతుని అధిరోహించిన అష్టబాహువులు గల నారాయణస్వామి,క్షేత్రపాలకునిగా రుద్రరూపంలో మహాశివుడు, యోగనారసింహుడు, అనంత పద్మనాభుడు, ఇలా పలు శిల్పాలతో ఈ క్షేత్రం భక్తులకి కనువిందు చేస్తుంది.',
        },
        {
          title: 'ఆలయంలోని మండటపం నూరు రాతిస్తంభాలను కలిగి ఉంది.',
        },
        {
          title: 'గుడిలోపల స్వామి వారికి ఎదురుగా ఉన్న మంటపంలో ఆరు అడుగుల ఎత్తులో నంది విగ్రహం ఏక శిలచే చెక్కబడినది. ఆలయంలోని మండటపం నూరు రాతిస్తంభాలను కలిగి ఉంది. రెండో అంతస్తువరకు దాదాపు 14 అడుగులున్న శివలింగం ఉంది. శివలింగం ఆధారం క్రింది గదిలో ఉండగా, లింగ అగ్రభాగంపై కప్పును చీల్చుకుని మొదటి అంతస్తు వరకు ఉంటుంది. భక్తులు, పూజలు, అర్చనలు ఇక్కడే స్వామి వారికీ పూజ కార్యక్రమాలు నిర్వహిస్తుంటారు.',
        },
        {
          title: 'మొదటి అంతస్తులో ఉన్న లింగ దర్శనం తర్వాత క్రింద ఉన్న లింగపాద భాగాన్ని దర్శించుకుంటారు. ఈ దేవాలయ నిర్మాణం పంచారామలలో ఒకటైన ద్రాక్షారామంలోని భీమేశ్వరాలయాన్ని పోలిఉండును. చాళుక్య రాజయిన భీముడు నిర్మించాడని క్షేత్ర కథనంలో వివరించడం జరిగింది. ఈయనే ద్రాక్షరామ దేవాలయాన్ని నిర్మించింది. అందుకే ఈ రెండు గుళ్ళు ఒకే రీతిగా వుండటమే కాదు, రెండిటి నిర్మాణానికి ఉపయోగించిన రాయి కూడా ఒకే రకంగా మరియు నిర్మాణ శైలి కూడా ఒకే విధంగా ఉంటుంది.',
        },
        {
          title: 'ఆలయం పడమటి గోడలో అమర్చిన గణపతి విగ్రహం ఉంది. ఈ గణపతి నాభిలో వజ్రం ఉండేదట. ఆరోజుల్లో ఈ వజ్రం నుండి వచ్చే కాంతులే రాత్రిపూట భక్తులకు మార్గదర్శకంగా ఉండేవట. అందుకే ఈ గణపతి వజ్రగణపతి అయ్యాడు.',
        },
        {
          title: 'ఇక్కడ భీమ గుండంలో స్నానం చేస్తే సర్వపాపాలు పోతాయని భక్తుల నమ్మకం.',
        },
        {
          title: 'ఈ ఆలయ నిర్మాణంలో మరో విశేషం ఏమిటంటే చైత్ర, వైశాఖ మాసాలలో సూర్యదేవుని కిరణాలు ఉదయం పూట స్వామి వారి పాదాలను సాంయంత్రం పూట అమ్మవారి పాదాలను తాకుతాయి. ఇక్కడ భీమ గుండంలో స్నానం చేస్తే సర్వపాపాలు పోతాయని భక్తుల నమ్మకం. మహాశివరాత్రికి గొప్ప ఉత్సవం నిర్వహిస్తారు. ఇక్కడ స్వామి వారికి బాలా త్రిపురసుందరికీ వైభవంగా వివాహం మహోత్సవం జరిపిస్తారు.',
        },
        {
          title: <span class='highlight'>కళ్యాణోత్సం:</span>,
        },
        {
          title: 'అయిదు రోజుల పాటు జరిగే ఈ వేడుకల్లో స్వామివారిని నందివాహనంపై అమ్మవారిని సింహవాహనంపై ఊరేగిస్తారు. ఈ కళ్యాణోత్సవాన్ని తిలకించడానికి ఆ చుట్టుపక్కల ప్రాంతాల్లోని ప్రజలు అధిక సంఖ్యలో వస్తుంటారు. ఇక కార్తీక మాసంలో కూడా ఇక్కడ పూజలు, అభిషేకాలు, ఉత్సవాలు విరివిగా జరుగుతాయి. ఈ కార్యక్రమాల్లో పాల్గొంటూ భక్తులు పునీతులవుతుంటారు.',
        },
        {
          title: <span class='highlight'>ఎలా వెళ్లాలి:</span>,
        },
        {
          title: 'సామర్లకోట కు 60 కిలోమీటర్ల దూరంలో రాజమండ్రి విమానాశ్రయం కలదు. అక్కడి నుండి క్యాబ్ లేదా టాక్సీ లలో ప్రయాణించి సామర్లకోట చేరుకోవచ్చు. సామర్లకోట సొంతంగా రైల్వే స్టేషన్ కలిగి ఉన్నది. ఇక్కడికి వైజాగ్, కాకినాడ తదితర ప్రాంతాల నుండి వచ్చే రైళ్లన్నీ ఆగుతాయి. రైల్వే స్టేషన్ లో దిగి, అక్కడి నుండి ఆటోలో కిలోమీటర్ దూరంలో ఉన్న కుమారారామము క్షేత్రం చేరుకోవచ్చు.',
        },
        {
          title: 'సామర్లకోట కు రాజమండ్రి, కాకినాడ మరియు దాని సమీప ప్రాంతాల నుండి చక్కటి బస్సు సౌకర్యం కలదు. అంతేనా, ఆంధ్ర ప్రదేశ్ రాష్ట్ర రోడ్ రవాణా సంస్థ వారు పంచారామాలను బస్సులో ఒక్కరోజులో దర్శించే యాత్రా సౌకర్యాన్ని కలిగిస్తున్నారు.',
        }
      ],
      title: 'సామర్లకోట భీమేశ్వర స్వామి ఆలయం',
    },
    {
      "CatID": [
        {
          title: 'అన్నపూర్ణే సదా పూర్ణే శంకరప్రాణ వల్లభే!',
        },
        {
          title: 'జ్ఞాన వైరాగ్య సిద్ద్యర్థం భిక్షాం దేహిచ పార్వతి!!',
        },
        {
          title: 'అన్నము నుండే సమస్త జీవులు సృష్టింపబడుతున్నవి.  సమస్త జీవులకు ప్రాణ శక్తి అన్నము నుండే ఉద్భవిస్తుంది.',
        },
        {
          title: 'ఆకలి రెండు రకములు - మొదటిది శరీర పోషణకు సంబందించినది రెండవది పారమార్ధికమునకు సంబంధించినది.*  ఈ రెండు ఆకళ్ళను తీర్చే తల్లి *శ్రీ అన్నపూర్ణాదేవి.* అందుకే అమ్మను ప్రాణ శక్తిని,  జ్ఞానాన్ని ప్రసాదించమని వేడుకుంటాము.',
        },
        {
          title: 'కాశీ క్షేత్రంలో అన్నపూర్ణాదేవి కొలువై ఉన్నట్లే, శ్రీ క్షేత్ర హొరనాడు అనే క్షేత్రంలో శ్రీ ఆదిశంకర ప్రతిష్టిత అన్నపూర్ణా దేవి ఆలయం ఉన్నది.',
        },
        {
          title: <span class='highlight'>స్థలపురాణం :</span>,
        },
        {
          title: 'భారత దేశం అంతటా పాదయాత్ర చేసి ఎన్నో పీఠాలను స్థాపించిన ఆదిశంకరులు ఒకసారి మార్గమధ్యంలో ఒక చోట ఆగారు.  శంకరులకు వారి శిష్య బృందానికి ఆకలిగా ఉంది.  అది దట్టమైన అడవి ప్రాంతం.  ఎక్కడా ఆతిథ్యమిచ్చే గృహాలు లేవు. అప్పుడు శంకరులు అన్నపూర్ణా దేవిని స్తోత్రంచేయగా,  ఒక పండు ముత్తైదువ రూపంలో వారిని సమీపించి ఆకలితో ఉన్నట్లు ఉన్నారు. మీరంతా మా గృహానికి వచ్చి మా ఆతిథ్యం స్వీకరించవలసినది అని కోరింది.',
        },
        {
          title: 'శంకరులు వారి శిష్యులు ఆ ముత్తైదువ  గృహానికి వెళ్ళగా అక్కడ పంచభక్ష్యపరమాన్నాలతో షడ్రసోపేతమైన అన్నము పెట్టింది. శంకరులు ఆవిడను *శ్రీ అన్నపూర్ణాదేవి* అని గుర్తించి మరల స్తోత్రం చేసి అమ్మవారిని అక్కడే కొలువై ఉండమని ప్రార్ధించారు.  అప్పుడు అన్నపూర్ణాదేవి బంగారు ప్రతిమయై అక్కడ శాశ్వతంగా నిలిచిపోయారు.  అదే నేడు *హొరనాడు శ్రీ అన్నపూర్ణా ఆలయం* గా భాసిల్లుతోంది.  ఇక్కడ అమ్మవారిని దర్శించుకుని ప్రసాదం స్వీకరించిన వారికి ఈ జన్మలో అన్నపానీయాలకు లోటు ఉండదు అని ప్రతీతి.',
        },
        {
          title: 'హొరనాడు అనే ప్రాంతం బెంగళూరు నుండి 330 కి.మీ. దూరంలో గల అందమైన ప్రాంతం. ఇది శృంగేరిక్షేత్రం నుండి 75 కి.మీ. దూరంలో గలదు. బెంగళూరు నుండి ఈ ప్రాంతానికి ప్రతిరోజూ బస్సులు ఉంటాయి. ఈ క్షేత్రానికి వెళ్ళుటకు అవసరమైన బస్సులను కర్ణాటక రాష్ట్ర రోడ్డు రవాణా సంస్థ నడుపుతోంది. కొన్ని ప్రైవేటు బస్సులు కూడా లభిస్తాయి.',
        }
      ],
      title: 'శ్రీ అన్నపూర్ణనేశ్వరి దేవి ఆలయం - హొరనాడు',
    },
    {
      "CatID": [
        {
          title: 'శ్రీ దత్తాత్రేయ దేవాలయం ఎత్తిపోతల. అతి ప్రాచీన, కార్త్యవీర్యార్జున పునః ప్రతిష్టిత దత్తక్షేత్రం ఎత్తిపోతల.',
        },
        {
          title: 'బాహ్య ప్రపంచానికి అంతగా తెలియని అతి గొప్ప విశేషమైన మహిమగల దత్త క్షేత్రమిది.',
        },
        {
          title: 'సహజసిద్ధ ఎత్తిపోతల జలపాతంతో పాటు దిగువ భాగంలో ఉన్ష్న వందల సంవత్సరాల నాటి దేవాలయం దత్తాత్రేయ దేవాలయం.',
        },
        {
          title: 'నాగార్జునసాగర్ నుంచి 15 కి.మీ దూరం లొ మాచర్ల జిల్లాలో ఉంది.',
        },
        {
          title: <span class='highlight'>ఎత్తిపోతల దత్తక్షేత్ర ప్రత్యేకత:</span>,
        },
        {
          title: 'యతి – తపః – తలం (ఎత్తిపోతల)* త్రివేణి సంగమ దత్తక్షేత్ర ప్రదేశం.',
        },
        {
          title: 'ఇక్కడ ఎత్తిపోతల కృష్ణానది ఉప-ఉప నదులైన మూడు ఉప-ఉప (వంకలు) నదులు *చంద్రవంక* , అగ్నివంక మరియు *సూర్యవంక* నదులు ఒకదానికొకటి సంగమిస్తాయి.',
        },
        {
          title: 'ఈ మూడు నదులు ఎత్తిపోతల జలపాతం వద్ద కలిసి ఒకటిగా ఏర్పడి ఆ మొత్తం మధువంక గా మారి అది కృష్ణానదిలో కలవడం జరుగుతుంది.',
        },
        {
          title: 'అందువల్లనే ఎత్తిపోతల జలపాతం వద్ద సంగమేశ్వర దేవాలయాన్ని ప్రస్తుతం జీర్ణ స్థితిలో కలదు మనం చూడవచ్చు, మరియు ఈ మూడు వంకలు కలిసి పైనుండి క్రిందకు పడేచోట గల ప్రదేశం చూచుటకు గోవు యొక్క కర్ణం ఆవుచెవి మాదిరిగా ఉండడమూ మరియు మూడు వంకలు కలిసి చంద్రవంక, అగ్నివంక మరియు సూర్యవంక మధువంక గా దత్తాత్రేయుని శక్తి స్వరూపిణి అయిన మధుమతీదేవి యొక్క నేత్రముల ఎదురుగా జరుగుతుండడం వల్ల ఈ క్షేత్రాన్ని త్రివేణి మధు గోకర్ణ గా ఒకప్పుడు పిలిచేవారు.',
        },
        {
          title: 'ఇక్కడగల పరిసర ప్రదేశాల్లో మధుమతీ సమేత దత్తాత్రేయుని ఆవాసం వల్ల ఇక్కడ యతులు తపస్సు చేసుకోవడానికి అధిక ప్రాముఖ్యత ఇచ్చేవారు. ఫలితంగా, త్రివేణి మధు గోకర్ణ కాస్తా యతి – తపః – తలం గా తదుపరి ఎత్తిపోతల గా మారింది.',
        },
        {
          title: 'ఎత్తిపోతల - దత్తాత్రేయుడు స్వయంభూ దత్తాత్రేయుడు.* కొండగుహలో ఉన్న స్వయంభూ దత్తాత్రేయమూర్తిని పునః ప్రతిష్టించాడు ‘హైహయ’ వంశరాజైన కార్త్యవీర్యార్జునుడు.',
        },
        {
          title: 'హైహయ వంశరాజైన కార్త్యవీర్యార్జునుడు ఈ క్షేత్రానికి దగ్గర లోగల మహీష్పతి నగరాన్ని (నేటి మాచర్ల) రాజధానిగా పరిపాలన సాగించేవాడు. అందువల్ల ఇక్కడే కార్త్యవీర్యార్జునుడు ముఖ్య పర్వదినములలో తప్పని సరిగా అనఘాస్టమీ వ్రతాలను ఆచరించేవాడు.',
        },
        {
          title: 'ఈ క్షేత్ర మహిమ తెలుసుకున్న. పరుశురాముడు (కార్త్యవీర్యార్జునుడి సంహరించిన వాడు మరియు రేణుకామాత – జమదగ్నిల కుమారుడు) కార్త్యవీర్యార్జునుడి తదుపరి ఈ ఆలయాన్ని ఎంతగానో అభివృద్ధి చేసాడు.',
        },
        {
          title: 'ప్రపంచంలోని ఏకైక *సింధూరలేపన దత్తాత్రేయుడు ఇక్కడ కనిపిస్తాడు, అలాగే ప్రపంచంలోని ఏకైక *‘నాగకిరిటాభారణ’ (నాగుపామును కిరిటంగా ధరించిన) దత్తాత్రేయుడు ఏకముఖ, చతుర్భుజుడుగా కనిపిస్తాడు. విష్ణురూప, అలంకారప్రియ, చిద్విలాస మరియు నామధారి (నామమును ధరించిన) దత్తాత్రేయుడు.',
        },
        {
          title: 'భక్తులు ఇక్కడి దత్తాత్రేయుడుని దర్శించుకోవడానికి వచ్చినప్పుడు, కార్త్యవీర్యార్జున విరచిత దత్తస్తోత్రాలను చదివితే మిక్కిలి ప్రీతి చెందుతాడట.* అలాగే కష్టాలలో ఉన్నవారు వారి కష్టాలు తీరిన తరువాత ఇక్కడి ఝెండా ప్రాంగణం లో ఝెండాలను కడతారు.',
        },
        {
          title: 'మధుమతీ దేవి దత్తాత్రేయుని శక్తి స్వరూపిణి. మధుమతి అనగా ‘తేనెవంటి హృదయం గలది అని అర్ధం. మధుమతీ దేవి కుడా స్వయంభూ గానే ఉద్భవించారు.',
        },
        {
          title: <span class='highlight'>దత్త శిల :</span>,
        },
        {
          title: 'దత్త శిల ఎత్తిపోతల ప్రధాన ద్వారం నుండి దత్తాత్రేయ దేవాలయానికి వెళ్ళే మెట్ల మార్గంలో పెద్ద పుట్టకు సమీపంలో కుడివైపున ఉంటుంది. దత్తాత్రేయుడు ఈ రాయి మీద కుర్చుని విశ్రాంతి తీసుకునేవాడని అనేక మంది మహర్షులు చెప్పేవారు.',
        },
        {
          title: 'ఒక్కోసారి ఈ శిల మీదే దత్తాత్రేయుడు కల్లు త్రాగువాని వలె కుర్చుని కల్లు తాగుతూ కనిపిస్తాడట. నడి రాత్రిలో ఈ దత్త శిలకు శిరస్సును ఆనించి దత్తాత్రేయుడిని ధ్యానించి ఈ శిలకు దరిదాపుల్లోనే నిద్రిస్తే వారికి తప్పని సరిగా దత్తదర్శనం కలుగుతుంది.',
        }
      ],
      title: 'శ్రీ దత్తాత్రేయ దేవాలయం - ఎత్తిపోతల',
    },
    {
      "CatID": [
        {
          title: 'భక్త సంరాక్షణార్ధం శ్రీ మహావిష్ణువు అనేక అవతారాలు ఎత్తాడు, వాటిలో ముఖ్యమైనవి దశావతారాలని మనం కొలుచుకుంటాంకదా. ఇవి భూమి మీద మానవ పరిణామానికి సంకేతాలు అని కూడా చెబుతారు. *దశావతారాలలో మూడవది ఆది వరాహావతారం.',
        },
        {
          title: 'శ్రీ మహావిష్ణువు వరాహావతారాన్ని ఎత్తటానికి సంబంధించిన కధని ఇక్కడ టూకీగా చెప్పుకుందాం.',
        },
        {
          title: 'ఒకసారి శ్రీమహావిష్ణువు దర్శనార్ధం సనక సనందాది మహా ఋషులు వైకుంఠానికి వెళ్ళారు. అక్కడ ద్వారపాలకులైన జయవిజయులు స్వామివారి దర్శనానికి అది సరైన సమయం కాదని అడ్డగిస్తారు. దానితో ఆ మహాఋషులకి కోపం వస్తుంది. జయ విజయులని, ఏ స్వామి సాన్నిధ్యంలో వున్నామనే గర్వంతో తమని అడ్డగించారో, ఆ స్వామి సేవకి దూరమయ్యి భూలోకంలో అసురులుగా జన్మిస్తారని శపిస్తారు.',
        },
        {
          title: 'వారు శ్రీమహావిష్ణువుని ఆయన సేవకి ఎక్కువ కాలం దూరంగా వుండలేమని ప్రార్ధించగా, విష్ణుమూర్తి భక్తులుగా ఏడు జన్మలు లేక శత్రువులుగా మూడు జన్మలలో తనని తిరిగి చేరవచ్చనే వరం ఇస్తాడు. ఏడు జన్మలు ఆయన సేవకి దూరం కాలేమని, శత్రువులుగా మూడు జన్మలలోనే ఆయన సాన్నిధ్యాన్ని ప్రసాదించమని కోరుతారు.',
        },
        {
          title: 'ఆ విధంగా వారు హిరణ్యాక్షుడు, హిరణ్యకశిపుడిగా భూలోకంలో జన్మిస్తారు. మిగతా జన్మలు రావణ - కుంభకర్ణులు, కంస - శిశుపాలురు.',
        },
        {
          title: 'హిరణ్యాక్షుడిని చంపటానికి ఆదివరాహావతారంలో, హిరణ్యకశిపునికోసం నరసింహావతారంలో, రావణ, కుంభకర్ణుల కోసం శ్రీరాముడిగా, కంస, శిశుపాలురని అంతం చేయటానికి శ్రీకృష్ణుడిగా అవతరించాడు శ్రీమహావిష్ణువు.',
        },
        {
          title: 'ఈ దశావతారాల్లో ఒక్కరైన భూవరాహస్వామి ఆలయం గురించి తెలుసుకుందాం.',
        },
        {
          title: 'విష్ణువు యొక్క మూడవ అవతారం వరాహ స్వామి:-',
        },
        {
          title: 'విష్ణువు యొక్క మూడవ అవతారం వరాహస్వామి అనే అడవిపందిరూపం.',
        },
        {
          title: 'ఈ గుడిలోని విగ్రహం 18 అడుగుల ఎత్తు మరియు బూడిదరాయితో తయారుచేయబడింది. ఈ విగ్రహంలో భూదేవి వరాహస్వామి ఎడమ తొడ మీద కొలువుదీరి దర్శనమిస్తున్నది. దేవత విగ్రహం 3.5 అడుగుల పొడవు ఉంది. హనుమంతుడి విగ్రహం కూడా ప్రధాన విగ్రహం క్రింద చెక్కబడింది.',
        },
        {
          title: 'విగ్రహం యొక్క కుడివైపు, కుడి చేతిలో సుదర్శనచక్రం, ఎడమవైపు తొడమీద భూదేవీ ఆసీనులై కూర్చొని దర్శనమిస్తున్నది.',
        },
        {
          title: 'ఇక్కడ స్థానికులకు భువరాహస్వామి ఆలయం చాలా ప్రసిద్ది చెందింది. ఈ స్వామివారి దర్శనం కోరి వచ్చేవారు ఈ దేవుడు మర్మమైన శక్తులు కలిగి ఉన్నాడని నమ్ముతారు.',
        },
        {
          title: 'భువరాహస్వామి ఆలయంలో పక్కన హేమావతి నది ఉంది. ఈ నదీ ప్రవాహం ఎక్కువగా ఉండటం వల్ల ఈ నదిలో ఈత కొట్టడం, పుణ్యస్నానాలు చేయడానికి అవకాశం ఉండదు. వర్షా కాలంలో ఈ నదిలోని నీరు ఆలయం గోడకు చేరుకుంటుంది.',
        },
        {
          title: 'భువరాహస్వామి ఆలయంలో పక్కన హేమావతి నది ఉంది. ఈ నదీ ప్రవాహం ఎక్కువగా ఉండటం వల్ల ఈ నదిలో ఈత కొట్టడం, పుణ్యస్నానాలు చేయడానికి అవకాశం ఉండదు. వర్షా కాలంలో ఈ నదిలోని నీరు ఆలయం గోడకు చేరుకుంటుంది.',
        },
        {
          title: 'భూవరాహస్వామి ఆలయం 2500 సంవత్సరాలకు పైగా ఉంది. ఈ ఆలయంలో గౌతమ మహర్షి తపస్సు చేశాడని చెపుతారు.',
        },
        {
          title: 'ఈ దేవాలయానికి రాజ వీర్ బాలాల గురించి ఒక పురాణ కథ ఉంది. వేట కోసం రాజు అడవికి వెళ్ళిన సమయంలో విశ్రాంతి కొరకు ఒక చెట్టు క్రింద పడుకున్నాడు. అలా విశ్రాంతి తీసుకుంటన్న సమయంలో అక్కడ ఒక వింత ద్రుశ్యాన్ని గమనించాడు. ఒక కుక్క చిన్న కుందేలును తరుముకుని రావడం చూశాడు. మరి కొద్ది సేపటికి కుందేలు కుక్కను తరుముకునిపోవడం గమనించాడు.',
        },
        {
          title: 'అప్పుడు ఆ రాజు ఈ ప్రదేశం కొన్ని మాంత్రిక శక్తులను కలిగి ఉందని విశ్వసించాడు మరియు ఈ ప్రదేశంలో 16 అడుగుల లోతు తవ్వి చూడగా అక్కడ వరాహస్వామి విగ్రహం దాగి ఉండటాన్ని కనుగొన్నాడు. ఈ సంఘటన తరువాత, ఈ రాజు అక్కడ వరహాస్వామి ఆలయాన్ని నిర్మించి ప్రతీ రోజు పూజలు చేయడం ప్రారంభించాడు.',
        },
        {
          title: 'పూజలు మరియు సేవలు',
        },
        {
          title: '1. ముక్తి పూజ',
        },
        {
          title: '2. భూ సూక్త పారాయణ',
        },
        {
          title: '3. గోసేవ',
        },
        {
          title: '4. రేవతి అభిషేక సేవ',
        },
        {
          title: <span class='highlight'>ఎలా వెళ్లాలి?</span>,
        },
        {
          title: 'బెంగళూరు - మైసూర్ రహదారిలో కల్లహల్లి అనే చిన్న గ్రామం ఉంది. ఈ గ్రామం మాండ్య జిల్లాలోని పాండవుర్ నుండి 32 కిలోమీటర్ల దూరంలో ఉంది. సమీప బస్సు స్టేషన్ 2 km దూరంలో ఉంది. ఈ ప్రదేశం చేరుకోవడం చాలా సులభం. మాండ్య జిల్లాలోని కల్లహల్లి అనే చిన్న గ్రామం చేరుకోవడానికి బస్సు సౌకర్యం ఉంది. అయితే బస్సులు ఆలయానికి రెండు కిలోమీటర్ల దూరంలో మాత్రమే నిలుస్తాయి. అక్కడి నుండి నడక లేదా మీ సొంత వాహనాల ద్వారా ప్రయాణించవచ్చు.',
        }
      ],
      title: 'మైసూర్ సమీపంలోని కల్లహల్లి భూవరాహస్వామి ఆలయం',
    },
    {
      "CatID": [
        {
          title: 'భుజంగేశాయ విద్మహే ఉరగేశాయ ధీమహీ తన్నో నాగ ప్రచోదయాత్',
        },
        {
          title: 'కర్నాటక రాష్ట్రము నందు, మూడు ప్రఖ్యాత సుబ్రహ్మణ్య క్షేత్రాలు కలవు. అవి -',
        },
        {
          title: 'ఆది సుబ్రహ్మణ్య (కుక్కే సుబ్రహ్మణ్య),',
        },
        {
          title: 'మధ్య సుబ్రహ్మణ్య (ఘాటి సుబ్రహ్మణ్య)* మరియు',
        },
        {
          title: 'అంత్య సుబ్రహ్మణ్య (నాగలమడక)',
        },
        {
          title: '(పావగడ నగలమడికే సుబ్రహ్మణ్య)) అనే మూడు అద్భుతమైన క్షేత్రాలు',
        },
        {
          title: 'ఈ మూడూ కలిపితే ఒక సర్పాకారం ఏర్పడుతుంది...',
        },
        {
          title: 'ఈ మూడు క్షేత్రాలను ఎవరు దర్శించి స్వామిని ఆరాధిస్తారో, వారికి ఉన్న సకల కుజ, రాహు, కేతు దోషములు, సకల నవగ్రహ దోషములు పరిహరింపబడి, స్వామి అనుగ్రహమును పొంది, సకల అభీష్టములు పొందుతారు.',
        },
        {
          title: 'ఈ ప్రదేశం ఆనాడు విజయనగర రాజుల ఆస్థానానికి చెందినదని అంటారు.',
        },
        {
          title: 'శ్రీరామచంద్రుడు వనవాస కాలంలో నాగలమడకలో నివాసం ఉన్నట్లు చారిత్రక ఆధారాల ద్వారా తెలుస్తోంది.',
        },
        {
          title: 'శ్రీరాముడు ఈ ప్రదేశం వదలి కామనదుర్గ (నీళ్లమ్మనహళ్ళి) కాకాద్రికొండకు ప్రయాణమైనట్లు చెబుతారు. ఈ కొండనే కామిలకొండ అని పిలుస్తారు. ఈ కొండపై శ్రీ రామచంద్ర స్వామి వారి గుడి ఉన్నది.',
        },
        {
          title: 'నాగలమడకలో అన్నంభట్టు అనే బ్రాహ్మణుడు ఉండేవారని ఆయన సుబ్రహ్మణ్యేశ్వరస్వామి భక్తుడి గా వుంటూ దక్షిణ కర్ణాటక ప్రాంతంలోని కుక్కే సుబ్రహ్మణ్యేశ్వర స్వామి దర్శనానికి ప్రతి సంవత్సరం కాలి నడకన హాజరయ్యేవారని అంటారు.',
        },
        {
          title: 'ఒకసారి వృద్ధాప్యంలో అన్నంభట్టు గారు కుక్కేలో రథం లాగే సమయానికి చేరుకోలేక పోయారని, అయితే భక్తులు ఎంతమంది లాగినా కూడా రథం ముందుకు కదలక అలాగే నిలిచి పోయిందని అన్నంభట్టు గారు అక్కడకు చేరుకొని రథం పగ్గాలపై చేయి వేసిన వెంటనే రథం కదిలిందని పూర్వీకులు చెబుతారు.',
        },
        {
          title: <span class='highlight'>నాగాభరణం :</span>,
        },
        {
          title: 'వృద్ధాప్యంలో ఇక్కడకు రాలేవని అందువల్ల నాగలమడకలోనే ఉంటూ సేవ చేయమని చెప్పి నాగాభరణంను అన్నంభట్టు కు  కుక్కే సుబ్రహ్మణ్య స్వామి ఇచ్చినట్లు పెద్దలు పేర్కొంటున్నారు.',
        },
        {
          title: 'ఆ నాగాభరణంను తీసుకువచ్చి ఇక్కడ ప్రతిష్ఠించడం వల్లనే నాగలమడక అని పేరు వచ్చిందంటారు.',
        },
        {
          title: 'అది కూడా స్వామి కలలో కన్పించి పెన్నానది పరివాహకం వద్దనే ప్రతిష్ఠించమని చెప్పడంతో నాగుల కోసం వెతుకుతున్న సందర్భంలో ఒక రైతు పొలంలో నాగలితో దున్నుతుండగా ఆ సమయంలో నాగులను పోలిన రాళ్ళు లభ్యం కావడంతో ఆ రాళ్ళనే ప్రతిష్ఠించినట్లు చెబుతారు.',
        },
        {
          title: 'ప్రారంభంలో కేవలం నాలుగు స్తంభాలు నిలబెట్టి రాతిబండపరచి మంటపాన్ని నిర్మించారని రొద్దంకు చెందిన  బాలసుబ్బయ్య అనే వ్యక్తి ఈ మంటపంలో వ్యాపారంకు సంబంధించిన సరుకులు పెట్టుకుని నిద్రిస్తుండగా స్వామి కలలో కనిపించి ఆలయం నిర్మించాలని చెప్పడం తో ఆయన ఆలయ నిర్మాణానికి కృషి చేసి సఫలీకృతుడైనట్లు తెలిసింది.',
        },
        {
          title: 'కావున ఆ వంశానికి చెందిన వ్యక్తులు ఇప్పటికీ ప్రతి సంవత్సరం ఇక్కడ జరిగే రథోత్సవంలో అన్నదాన కార్యక్రమం నిర్వహిస్తున్నారు.',
        },
        {
          title: 'నాగలమడకలోని సుబ్రహ్మణ్యేశ్వర స్వామి ఆలయంలో ఉండే శిల్పం సుందరంగా మూడుచుట్లు చుట్టుకుని ఏడు శిరస్సులు కల్గిన మూడు అడుగుల నాగప్పస్వామి శిల్పం చూసిన భక్తులకు తక్షణం భక్తి భావన కలుగుతుంది.',
        },
        {
          title: <span class='highlight'>పుల్లివిస్తర్ల విశిష్టత:</span>,
        },
        {
          title: 'ప్రతి ఏడాదికి ఒకసారి నిర్వహించే బ్రహ్మ రథోత్సవంలో లక్షలాది మంది తమ మొక్కుబడులు తీర్చడానికి ఈ ప్రాంతానికి వస్తువుంటారు. అందులో విశిష్టమైనది *పుల్లివిస్తర్లు* (బ్రాహ్మణులు భోజనం చేసి వదిలిన ఆకులు) తలపై పెట్టుకుని పినాకిని నదిలో స్నానం చేయడం.',
        },
        {
          title: 'స్వామి రథోత్సవం తర్వాత బ్రాహ్మణులు భోజనం పిదప విడిచిన పుల్లివిస్తర్లు ఏరుకుని వాటిని తలపై పెట్టుకుని నీరున్న చోట తలంటుస్నానాలు చేస్తే చేసిన పాపాలు పోయి మంచి జరుగుతుందని భక్తులు భావించడం విశేషం. అప్పటి వరకు వున్న ఉపవాస దీక్షను విరమించడం భక్తులు అనవాయితీ.',
        },
        {
          title: <span class='highlight'>ఎద్దుల పరుష:</span>,
        },
        {
          title: 'ఈ జాతరలో రైతులకు ఈ ఎద్దుల పరుష ప్రత్యేక ఆకర్షణ. కర్ణాటకలోని తుముకూరు జిల్లాలో అతి పెద్ద ఎద్దుల పరుష ఇక్కడ జరుగుతుంది. ఇక్కడకు తుముకూరు జిల్లా మరియు ఆంధ్ర రాష్ట్రంలోని అనంతపురం జిల్లాల నుంచి అధిక సంఖ్యలో ఎద్దులు చేరుకుని దాదాపు 10 రోజులపాటు ఎద్దుల అమ్మకాలు, కొనుగోలు జరుగుతాయి.',
        },
        {
          title: 'అంత్య సుబ్రహ్మణ్యం పేరుతో వెలసిన ఈ స్వామి ఆలయానికి విశిష్ట ఖ్యాతి నెలకొనివుంది.',
        },
        {
          title: <span class='highlight'>నాగలమడక శ్రీ సుబ్రహ్మణ్యేశ్వర స్వామి గుడి పూజలు :</span>,
        },
        {
          title: '1. సర్ప దోష శాంతి( కాలసర్ప దోష నివారణ ,సర్పదోష నివారణ ,రాహు కేతు శాంతి)',
        },
        {
          title: '2. నాగ ప్రతిష్ట పూజ',
        },
        {
          title: '3. ఆశ్లేష బలి పూజ',
        },
        {
          title: '4. సర్ప సంస్కార పూజ',
        },
        {
          title: '5. శాంతి బాగగలు పూజ',
        }
      ],
      title: 'నాగలమడక సుబ్రహ్మణ్య స్వామి',
    },
    {
      "CatID": [
        {
          title: 'మన దేశంలో ఇతర రాష్ట్రాలతో పోల్చితే తమిళనాడులో పుణ్యక్షేత్రాలు లెక్కలేనన్ని ఉన్నాయి. ఈ రాష్ట్రంలో ఉన్న అద్భుత ఆలయాలు మరెక్కడా కనిపించవు. వాటిల్లో దేని ప్రత్యేకత దానిదే.',
        },
        {
          title: 'ప్రపంచ వారసత్వ ప్రదేశంగా యునెస్కో గుర్తింపు పొందిన *దారశుర ఆలయం* పురావస్తుశాఖ నిర్వహణలో ఉంది.',
        },
        {
          title: 'శిల్పకళాశోభితమైన ఈ ఆలయాన్ని తంజావూరు బృహదీశ్వరాలయం నమూనాలో రెండో రాజరాజచోళుడు నిర్మించాడు. ఇక్కడి శివుని పేరు ఐరావతేశ్వరుడు',
        },
        {
          title: 'ఈ ఆలయాన్ని పన్నెండవ శతాబ్దిలో నిర్మించారు. చోళులు నిర్మించిన దేవాలయాల్లో ఇప్పటికీ నిత్యం ధూప-దీప నైవేద్యాలు జరుగుతున్న దేవాలయాల్లో దారశురం లోని ఐరావతేశ్వరాలయం కూడా ఒకటి.',
        },
        {
          title: 'కుంభ కోణానికి నాలుగు కిలోమీటర్ల దూరంలో తంజావూర్ వెళ్ళే మార్గంలో దారాసురం ఉంది.',
        },
        {
          title: 'ఇంద్రుని వాహనం ఐరావతం',
        },
        {
          title: 'ఇంద్రుని వాహనం అయిన ఐరావతం అనే తెల్ల ఏనుగు, యముడు ఈ స్వామిని ఆరాధించినట్లు ఐతిహ్యం.',
        },
        {
          title: 'పురాణాల ప్రకారం ఏడు తొండాలు మరియు నాలుగు దంతాలు కలిగిన ఇంద్రుని వాహనం ఐరావతం భక్తితో శివునికి పూజలు చేస్తూ వుంటాడు.',
        },
        {
          title: 'ఐరావతం దుర్వాసమహర్షిని పూజించలేదని తలచి కోపంతో శాపం ఇస్తాడు. వెంటనే ఆ ఏనుగు యొక్క రంగులో మార్పు వస్తుంది.  ఈ దేవాలయము యొక్క పవిత్ర జలాల్లో మునిగితే ఏనుగుకు శాపవిముక్తి కలుగుతుందని చెప్తాడు.',
        },
        {
          title: <span class='highlight'>యమతీర్థం :</span>,
        },
        {
          title: 'యమధర్మ రాజు కూడా శివున్ని భక్తిగా పూజిస్తాడు. ఒక యోగి ద్వారా శాపం పొందిన యమధర్మ రాజుకు తన శరీరం అంతా మండే అనుభూతికి లోనైనప్పుడు యముడు కూడా ఈ ఆలయ పవిత్ర జలంలో మునిగి శాప విముక్తిని పొందుతాడు. అందువల్ల ఈ ఆలయంనకు యమతీర్థం అని పేరు వచ్చింది.',
        },
        {
          title: <span class='highlight'>ద్రవిడ నిర్మాణ శైలి :</span>,
        },
        {
          title: 'ఆలయం ద్రావిడ నిర్మాణ శైలి ఉపయోగించి నిర్మించబడింది. ఈ ఆలయం శిల్పాలకు చాలా ప్రసిద్ధి. యలిస్ అనే పౌరాణిక జీవులు ఆలయ స్తంభాలు పైన చెక్కబడి ఉంటాయి.',
        },
        {
          title: 'యలిస్ యొక్క రూపం ఈ విధంగా వుంటుంది. దీనికి ఏనుగు యొక్క తొండం, ఎద్దు యొక్క శరీరం, సింహం తల, పొట్టేలు కొమ్ములు మరియు పంది యొక్క చెవులతో వున్న రూపాన్ని కలిగివుంటుంది.',
        },
        {
          title: <span class='highlight'>రథం ఆకారంలో ఉండే ఆలయానికి రాతి చక్రాలు :</span>
        },
        {
          title: 'అత్యంత ప్రతిభావంతులైన శిల్పులు తమ ప్రతిభను ప్రతిబింబించేలా శిల్పాలను చెక్కారు. రధం ఆకారంలో ఉండే ఆలయానికి రాతి చక్రాలు, వాటిని లాగుతున్నట్లుగా ఏనుగులను, అశ్వాలను మలచారు. ఆలయ గోపురం ఎనభై అడుగుల ఎత్తుతో ఠీవీగా కనపడుతుంది.',
        },
        {
          title: <span class='highlight'>మండప స్థంభాలపైన శివకళ్యాణ దృశ్యాలు :</span>
        },
        {
          title: 'మండప స్థంభాల పైన చెక్కిన శివకళ్యాణ దృశ్యాలు, శివ పురాణ ఘట్టాలు ఎంతో రమణీయంగా ఉంటాయి. మహేశ్వరుని పెళ్లికుమారుని చేయడం, ఆ సుందరమూర్తిని మహిళలు మైమరచిపోయి చూస్తుండటం, సకల సరంజామా, మేళతాళాలతో, రథాలు, గుర్రాలు, ఏనుగుల ఊరేగింపు గొప్పగా ఉంటాయి.',
        },
        {
          title: 'అదే విధంగా త్రిపురాంతక సంహార దృశ్యాలు, త్రినేత్రుడు మన్మధుని దహించే దృశ్యం, యోగ ముద్రలో ఉన్న పరమేశ్వరుని గణాలంతా ప్రార్ధించడం ఇవన్నీ బహు చక్కగా మలచారు.',
        },
        {
          title: 'సూక్ష్మ శిల్పాలలో చాలా భాగం భరతనాట్య అంశాలతో చెక్కినవి కావడం విశేషం. నాట్యకళకు చెందిన భంగిమలను మనోహరంగా చెక్కారు.',
        },
        {
          title: <span class='highlight'>గర్భాలయంలో లింగ రూపంలో శ్రీ ఐరావతేశ్వర స్వామి :</span>
        },
        {
          title: 'గర్భాలయంలో పెద్ద లింగ రూపంలో శ్రీఐరావతేశ్వర స్వామి పూజలందుకొంటుంటారు. దక్షిణదిశగా అమ్మవారు *శ్రీ పెరియ (దేవ) నాయకి* నిలువెత్తు రూపంలో కొలువై ఉంటారు. గర్భాలయ ప్రవేశ ద్వారానికి రెండుపక్కలా ద్వారపాలకులు శంఖనిధి, పద్మనిధి శిల్పాలు నల్ల రాతి మీద చెక్కబడినాయి.  వెరసి పేరుకు తగినట్లుగా శ్రీ ఐరావతేశ్వర స్వామి వారి ఆలయంలో అన్నీ భారీగా ఉంటాయి.',
        },
        {
          title: <span class='highlight'>అమ్మవారి ముక్కుపుడక రంధ్రం :</span>
        },
        {
          title: 'ఇక్కడి ఐరావతేశ్వరుని దర్శించి, ఆలయ ప్రాంగణంలోని మ్యూజియంలో భద్రపరిచిన అపురూప శిల్పాలనూ కుడ్య చిత్రాలనూ ఆసాంతం తిలకించవచ్చు. అమ్మవారి ప్రతిమలో ముక్కుపుడక రంధ్రం నుంచి ఓ పుల్ల దూరేటంత సందు ఉండే విధంగా చెక్కిన శిల్పి నైపుణ్యానికి ఆశ్చర్యపోకతప్పదు.',
        },
        {
          title: <span class='highlight'>రహస్యం :</span>
        },
        {
          title: 'అక్కడే వివిధ స్వరాలు పలికే శిల్పాలను చూడవచ్చు. ఈ దేవాలయంలో సంగీతాన్ని ప్రతిధ్వనింపజేసే రాతి మెట్లు ఉన్నాయి. ఇందుకు గల కారణాలు మాత్రం ఇప్పటికీ నిగూఢ రహస్యం.',
        },
        {
          title: <span class='highlight'>సంతాన ప్రాప్తి :</span>
        },
        {
          title: 'అంతేకాకుండా ఈ దేవాలయంలో ఉన్న కొలను పేరు *‘’యమతీర్ధం‘’* అంటారు. ఈ సరస్సులో స్నానం చేస్తే చర్మరోగాలన్నీ సమిసిపోతాయని కూడా చెబుతారు. ముందున్న మండపం గుర్రాలతో లాగుతున్న పెద్ద రాతిరథం ఉండటం విశేషం. ఇక్కడ స్వామిని అర్చించి వేడుకొంటే సంతాన ప్రాప్తి కలిగిస్తాడని ఇక్కడికి వచ్చే భక్తులు ఎక్కువగా విశ్వసిస్తారు.',
        },
        {
          title: <span class='highlight'>పట్టుచీరలకూ ప్రసిద్ధి :</span>
        },
        {
          title: 'దారాశురం పట్టుచీరలకూ ప్రసిద్ధి. సౌరాష్ట్ర నుంచి వలస వచ్చిన పలు చేనేత కుటుంబాలు ఇక్కడి మగ్గాలపై చీరలు నేయడం చూసి కొనకుండా ఉండలేరు.',
        },
        {
          title: <span class='highlight'>ఎలా చేరుకోవాలి :</span>
        },
        {
          title: <span class='highlight'>రైలు మార్గం :</span>
        },
        {
          title: 'దారాశురం వద్ద రైల్వే స్టేషన్ ఉంది. కానీ అన్ని వైపుల నుండి రైళ్లు లేవు. కానీ కుంభకోణం మరియు తంజావూరు నుండి రెగ్యులర్ రైలు సర్వీసులు ఉన్నాయి. కుంభకోణం మరియు తంజావూర్ నుండి చెన్నై, బెంగళూరు, తిరుచి మరియు మదురై వరకు రైళ్లు దరాశురం గుండా వెళతాయి. రైలు ద్వారా ఇక్కడికి చేరుకోవచ్చు.',
        },
        {
          title: <span class='highlight'>విమాన మార్గం :</span>
        },
        {
          title: 'దారాశురానికి సమీప విమానాశ్రయం తిరుచిరాపల్లి . ఇక్కడ నుండి దారాశురం వరకు టాక్సీలు అందుబాటులో ఉన్నాయి. ఇక్కడి నుండి దారాశురం చేరుకోవడానికి గంటన్నర సమయం పడుతుంది. చెన్నై నుండి ఇక్కడికి చేరుకోవడానికి ఐదున్నర గంటలు పడుతుంది.',
        }
      ],
      title: 'శ్రీ ఐరావతేశ్వర స్వామి ఆలయం - దారశురం - తమిళనాడు',
    },
    {
      "CatID": [
        {
          title: 'సముద్రపు ఒడ్డున ఉండే శివాలయాలను చూసి ఉంటారు. కానీ సముద్రం మధ్యలో ఉండే శివాలయాన్ని మాత్రం ఎక్కడా చూసి ఉండరు. ఈ ఆలయాన్ని భక్తులు దర్శించేందుకు వీలుగా సముద్రం ప్రతి రోజూ కొన్ని గంటలు వెనక్కి వెళ్తుంది. ఈ అద్భుతం కేవలం మన భారతదేశంలో మాత్రమే ఉండడం విశేషం.',
        },
        {
          title: 'గుజరాత్ లోని భావనగర్ కు తూర్పున 23 కిలోమీటర్ల దూరంలో కొలియాక్ సముద్ర తీర ప్రాంతం ఉంటుంది.',
        },
        {
          title: 'భారతీయ క్యాలెండర్ ప్రకారం భదర్వ అమావాస్య రాత్రి పాండవులు ఇక్కడ *నిష్కలంక్ మహదేవ్* ను స్థాపించారని చెబుతారు. కొలియాక్ కు తూర్పున సముద్ర తీరానికి 3 కిలోమీటర్ల దూరంలో *నిష్కలంక్ మహదేవ్* ఆలయం ఉంది.',
        },
        {
          title: 'సాధారణంగా హిందూ దేవాలయాలు కొండల్లో, పర్వత ప్రాంతాల్లో, గుహల్లో, సముద్రతీర తీర ప్రాంతాల్లో, జలపాతాలు, నదులకు సమీపంలో అందమైన ప్రకృతి మధ్య ఎంతో గొప్పగా కనిపిస్తాయి. కానీ నిష్కలంక మహదేవ్ ఆలయం వీటన్నింటికీ ఎంతో భిన్నం.',
        },
        {
          title: 'భీకరమైన అలల ప్రవాహం మధ్య తీరానికి సముద్రం మధ్యలో ఈ ఆలయం ఉంటుంది. నిష్కలంక్ అంటే పాపాలు దూరం చేసేది అని అర్ధం.',
        },
        {
          title: 'మహాభారత యుద్ధం తరువాత పాండవులు తమ దోషాలను, కళంకాలను ఇక్కడే రూపుమాపుకున్నారని పురాణ కధనం. అందుకే ఇక్కడి శివుణ్ణి నిష్కలంక్ మహదేవ్ గా పూజిస్తారు.',
        },
        {
          title: <span class='highlight'>వెనక్కి వెళ్లే సముద్రం:</span>
        },
        {
          title: 'కొలియాక్ సముద్ర తీరానికి ఉదయం పూట వచ్చే టూరిస్టులకు ఇక్కడ ఎటువంటి ఆలయం ఉన్నట్లు కనిపించదు. ఎందుకంటే ఆ సమయంలో ఆలయం పూర్తిగా నీటమునిగి ఉంటుంది. సముద్రం మధ్యలో ఆలయం ఉందనడానికి సూచికగా ఆలయ ధ్వజస్తంభంపై ఉండే జెండా మాత్రమే రెపరెపలాడుతూ కనిపిస్తుంది.',
        },
        {
          title: 'మధ్యాహ్నం 11 గంటలు దాటిన తరువాత నుంచి సముద్రం మెల్లగా వెనక్కి వెళ్లడం ప్రారంభిస్తుంది. దీంతో భక్తులు ఆలయానికి చేరుకునేందుకు మార్గం సుగమం అవుతుంది. ముఖ్యంగా పౌర్ణమి, అమావాస్య రోజుల్లో భక్తులు ఇక్కడికి అధిక సంఖ్యలో దర్శనానికి వచ్చి అలలు ఎప్పుడు మాయమౌతాయా అని ఎదురుచూస్తుంటారు.',
        },
        {
          title: 'ప్రతి ఏటా మహాశివరాత్రి పర్వదినం రోజున ఇక్కడ అత్యంత వైభవంగా ఉత్సవాలు జరుగుతాయి.',
        },
        {
          title: 'సముద్రం మధ్యలో ఈ ఆలయం నిర్మాణం ఎలా చేశారనేది నేటి తరం ఇంజినీర్లకు, సాంకేతిక నిపుణులకు అంతుచిక్కని పెద్ద ప్రశ్నగా మిగిలింది. ఈ ఆలయాన్ని వీక్షించిన వారు ప్రాచీన భారతీయుల పనితనాన్ని, నైపుణ్యాన్ని కొనియాడకుండా ఉండలేరు.',
        },
        {
          title: 'ప్రతిరోజూ మధ్యాహ్నం 1 గంట సమయానికి సముద్రం పూర్తిగా వెనక్కి వెళ్లడంతో పూలు, పండ్లు, పూజా సామగ్రి అమ్మే వర్తకులు తమ సామాగ్రిని తోపుడు బండ్లపై వేసుకుని సముద్రంలో నడుచుకుంటూ ఆలయానికి చేరుకుంటారు. ఆ తరువాత ఆలయానికి వెళ్లే భక్తుల తాకిడి కూడా పెరుగుతుంది.',
        },
        {
          title: 'రాత్రి 7 గంటల వరకూ భక్తులు ఈ ఆలయం వద్ద సమయం గడపవచ్చు. ఆ సమయం దాటిన తరువాత సముద్రం మళ్లీ ముందుకు రావడం ప్రారంభిస్తుంది. అర్ధరాత్రి దాటే సమయానికి ఆలయం పూర్తిగా సముద్రగర్భంలో మునిగిపోతుంది.',
        },
        {
          title: <span class='highlight'>ఆలయం వెనుక ఆసక్తికరమైన కధ :</span>
        },
        {
          title: 'మహాభారతం యుద్ధం సమయంలో పాండవులు కౌరవులపై యుద్ధాన్ని గెలిచిన విషయం అందరికీ తెలిసిందే. అయితే ఆ యుద్ధంలో సొంత బంధువులను చంపిన పాపాలను వారు మూటగట్టుకుంటారు. ఆ పాపాల నుంచి విముక్తి పొందడానికి పాండవులు శ్రీకృష్ణున్ని ఆశ్రయిస్తారు. అప్పుడు శ్రీకృష్ణుడు ఒక నల్లని ఆవుకు నల్లని జెండాను కట్టి అవి ఎంత దూరం వెళితే అంత దూరం వాటి వెంట వెళ్లమంటాడు. ఎప్పుడైతే ఆ ఆవు, జెండా తెల్లగా మారతాయో అప్పుడు ఆ పాపాల నుంచి విముక్తి దొరుకుతుందని సెలవిస్తాడు.',
        },
        {
          title: 'కృష్ణుడి సూచన మేరకు పాండవులు రోజుల తరబడి వాటి వెంటే నడిచేవారు. ఎంత దూరం నడిచినా వాటి రంగులో మార్పు రాలేదు. ఎప్పుడైతే చివరిగా ఆవు, జెండా కొలియాక్ సముద్ర తీరానికి చేరుకున్నాయో అప్పుడు ఉన్నట్టుండి అవి తెల్లగా మారతాయి. అప్పుడు అయిదురుగు అన్నదమ్ములు ఆ ప్రదేశంలోనే కూర్చుని పరమశివుని కోసం ఘోర తపస్సు చేస్తారు.',
        },
        {
          title: 'వారి భక్తికి మెచ్చిన శివుడు ఒక్కొక్కరి ఎదుట ఒక్కో స్వయంభువు శివలింగంగా అవతరిస్తాడు. దీంతో పాండవులు అమితానందపడి ఆ ఐదు శివలింగాలకు పూజలు నిర్వహించినట్లు పురాణ కధనం. పాండవుల పాపాలను కడిగిన ఈ పరమ పవిత్ర ప్రదేశం అప్పటి నుంచి నిష్కలంక్ / నిష్కలంక్ మహదేవ్ గా ప్రసిద్ధి పొందింది.',
        },
        {
          title: 'భదర్వి మాసంలో అమావాస్య రోజున పాండవులు ఈ దేవాలయాన్ని ఇక్కడ స్థాపించడంతో ప్రతి ఏటా శర్వణ్ మాసం (ఆగస్టు)లో అమావాస్య రోజున భైదర్వి అనే పండుగను ఘనంగా నిర్వహిస్తారు.',
        },
        {
          title: 'ఆలయాన్ని సందర్శించే భక్తులకు ప్రతి శివలింగం ఎదుట ఒక్కో నంది కనిపిస్తుంది. భక్తులు ముందుగా *పాండవ కొలను* అని పిలవబడే నీటి గుంట వద్ద తమ కాళ్లను శుభ్రపరచుకుని పూలు, పాలు, పండ్లతో శివలింగాలకు స్వయంగా అభిషేకిస్తుంటారు.',
        },
        {
          title: 'ఇక్కడ ప్రతి అమావాస్య, పౌర్ణమి రోజుల్లో కెరటాలు చాలా ఉధృతంగా వస్తుంటాయి. భక్తులు తెల్లవారుజామునే ఇక్కడికి చేరుకుని కెరటాలు శాంతించే వరకూ ఎదురుచూస్తుంటారు. మనకు బాగా కావాల్సిన వారు ఎవరైనా మరణిస్తే వారి ఆస్తికలను ఇక్కడి నీటిలో కలపడం ద్వారా వారి ఆత్మకు శాంతి చేకూరి ముక్తి లభిస్తుందని బలంగా నమ్ముతారు. ఆలయం గోపురంపై సూచికగా ఎగిరే జెండాను సంవత్సరానికి ఒక్క సారి మాత్రమే మారుస్తారు. ఇప్పటి వరకూ తుఫాన్ల వలన కానీ, అలల వలన కానీ ఈ జెండా దెబ్బతిన్న దాఖలాలు లేవు.',
        },
        {
          title: <span class='highlight'>ఎలా వెళ్లాలి :</span>
        },
        {
          title: 'దేవుడిపై భక్తి, పర్యటనల పట్ల ఆసక్తి ఉన్న వారికి ఈ ప్రదేశం తప్పకుండా ఓ మరపురాని అనుభూతిని ఇస్తుందనడంలో ఎంతమాత్రం సందేహం లేదు. భగవంతుడి అద్భుత సృష్టికి ఇంతకంటే వేరే నిదర్శనం మరొకటి లేదని ఈ ప్రాంతాన్ని సందర్శించే పర్యాటకులు చెబుతుంటారు. ఈ ఆలయ విశేషాలు తెలుసుకున్న ఎవరైనా జీవితంలో ఒక్కసారైనా ఈ సాహసభరిత యాత్ర చేయాలని కోరుకుంటారు. మార్చి నుంచి జూలై మాసాల మధ్య ఈ ఆలయాన్ని సందర్శించేందుకు మంచి సమయం.',
        },
        {
          title: 'విమాన మార్గం ద్వారా వచ్చే వారు అహ్మదాబాద్ విమానాశ్రయంలో దిగి 196 కిలోమీటర్ల దూరంలో ఉండే ఈ ప్రదేశానికి చేరుకోవాల్సి ఉంటుంది.',
        },
        {
          title: 'అహ్మదాబాద్ రైల్వే స్టేషన్ నుంచి భావనగర్ కు రైలు మార్గం ద్వారా చేరుకోవచ్చు. భావనగర్ ఎక్స్ ప్రెస్, మహువ ఎక్స్ ప్రెస్ రైళ్లు ఈ మార్గంలో నడుస్తాయి. సుమారు 5 గంటల ప్రయాణం ఉంటుంది. భావనగర్ నుంచి కొలియాక్ గ్రామానికి 22 కిలోమీటర్ల దూరం. రైల్వే స్టేషన్ నుంచి ట్యాక్సీ, ఆటో రిక్షా లేదా బస్సుల ద్వారా అక్కడికి చేరుకోవచ్చు.',
        }
      ],
      title: 'నిష్కలంక్ మహాదేవ్ శివాలయాన్ని దాచి ఉంచే సముద్రం',
    },
    {
      "CatID": [
        {
          title: 'శ్రీ వాసుదేవ పెరుమాళ్ దేవాలయం శ్రీకాకుళం జిల్లా మందస గ్రామంలోని ప్రాచీన దేవాలయం. సుమారు 700 సంవత్సరాల క్రితం నిర్మితమయినదిగా భావిస్తున్న ఈ ఆలయం నిర్మాణానికి సంబంధించిన పూర్తి ఆధారాలు లభ్యం కానప్పటికీ సుమారు 266 సంవత్సరాలక్రితం ఇది పునర్నిర్మితమయినట్టు ఇక్కడ లభించిన ఆధారాలబట్టి తెలియవచ్చింది. ఎర్రని ఇసుక రాయితో కళింగ శైలిలో తీర్చిదిద్దిన ఈ ఆలయ అపూర్వ శిల్పసంపద వర్ణనాతీతం.',
        },
        {
          title: 'ఆలయంలో నెలకొని ఉన్న నిలువెత్తు సాలగ్రామ మూలమూర్తి తిరుపతి వెంకటేశ్వరుని విగ్రహాన్ని పోలివుండి చూపరులను కట్టిపడేస్తుంది. గత శతాబ్దము చివర వరకు ఇది మంచి వేదాధ్యయన కేంద్రముగా విలసిల్లినట్లు కూడా తగిన ఆధారాలు లభించినాయి. వైజాగ్, విజయనగరం, ఒడిశా - ఆంధ్రా సరిహద్దు ప్రాంతాలతో ఈ ప్రదేశం చక్కటి రోడ్డు మార్గాన్ని కలిగియున్నది.',
        },
        {
          title: 'ఆ కాలంలో మందసా రామానుజులను ప్రసిద్ధ వేదవిద్వాంసులు ఈ ఆలయ ప్రాంగణంలోనే వేదవిద్యను నేర్పుతూ కాశీ వరకు కూడా పర్యటించి పలువురు వేద విధ్వాంసులను వేదాంత చర్చలలో ఓడించి పలు సన్మాన పత్రములను పొంది ఉన్నారట. మందసా రామానుజుల కీర్తిని గురించి తెలుసుకున్నచిన్నజీయరు స్వామివారి గురువు పెద్ద జీయరు స్వామి వారు, వారి మిత్రులు గోపాలాచార్యస్వామివారితో కలసి నేటి రాజమండ్రి నుంచి శ్రీభాష్యం అధ్యయనం చేయడానికి కాలినడకన మందసకు వేంచేయడం జరిగింది.',
        },
        {
          title: 'నాటి రాత్రి ఆలయప్రాంగణంలో నిద్రించిన శిష్యులిద్దరికీ వారు రాజమండ్రి వద్ద దాటి వచ్చిన గోదావరి వంతెన విరిగి వరదలో కొట్టుకుపోయినట్లు కల వచ్చింది. అది అపశకునంగా భావించిన శిష్యులిద్దరు తమ విద్యాభ్యాసానికి ఆటంకము కలుగుతుందేమోనని భయపడుతూ గురువు గారివద్దకు వెళ్ళి కల సంగతి చెప్పారు.',
        },
        {
          title: 'గురువుగారు వారిని ఊరడించి ఆలయంలో వేంచేసియున్నశ్రీ వాసుదేవ పెరుమాళ్ వద్దకు వారిని తీసుకుని వెళ్ళి స్వామికి సాష్టాంగ నమస్కారము చేయించి, వారు కూడా చేసినారట. ఆ సమయంలో వాసుదేవుని విగ్రహం నుండి ఓ దివ్యమయిన కాంతి ప్రసరించినదట. వాసుదేవుని అనుగ్రహం వల్ల శిష్యులిద్దరు సుమారు 2 సంవత్సరాలలో పూర్తికావలసిన శ్రీభాష్యం అధ్యయనాన్ని కేవలం 6 నెలలలోనే పూర్తి చేసుకుని తిరుగుప్రయాణం అయ్యారట. అందుకని ఇక్కడి దేవుని జ్ఞానప్రదాతగా, అభయప్రదాతగా భక్తులు కొలుస్తారు.',
        },
        {
          title: <span class='highlight'>వాసుదేవుని దివ్య సన్నిధి</span>
        },
        {
          title: 'కాలాంతరంలో దివ్యమైన ఈ ఆలయం పాలకుల నిరాదరణకు గురి అయ్యి పూర్తిగా శిథిలావస్థకు చేరుకుంది. ఆలయానికి చెందిన అపూర్వ శిల్పసంపద చాలావరకు ఆకతాయి చేష్టలకు నాశనం కాబడింది.సుమారు 1683 ఎకరాలు మాన్యం ఉన్నప్పటికీ ఈ ఆలయం మనిషి స్వార్థానికి ప్రతీకగా శిథిలమయ్యింది. ప్రస్తుతం కేవలం 3 ఎకరాల భూమి మాత్రమే రెవెన్యూ రికార్డుల ప్రకారం అందుబాటులో ఉంది. ఆలయ గోడలమీద పిచ్చిమొక్కలు పెరిగి విషజంతువుల సంచారంతో సుమారు 50 సంవత్సరాల కాలం ఈ అపురూప ఆలయం జనబాహుళ్యానికి దూరంగా ఉండిపోయింది.',
        },
        {
          title: 'చినజీయరు ఆగమనం-పునర్వైభవం',
        },
        {
          title: '1988 లో ఈ ఆలయ చరిత్ర తెలుసుకున్న చిన్నజీయరు స్వామి వారు ఆలయసందర్శనార్ధం మందసకు వేంచేసి, ఖర్చుకు వెరవకుండా ఆలయ ప్రాచీనతకు భంగం కలుగకుండా పునర్నిర్మించాలని సంకల్పించారు. అన్ని ప్రభుత్వ లాంచనాలు పూర్తి చేసి ఆంధ్రప్రదేశ్ దేవాదాయ శాఖ వారినుండి ఆలయాన్ని స్వాధీనం చేసుకుని, ఒడిషా నుంచి శిల్పులను రప్పించి యదాతధంగా ఆలయాన్నిపునర్నిర్మింపచేసారు.',
        },
        {
          title: 'గురువు పెద్దజీయరు స్వామివారి విద్యాభ్యాసానికి గుర్తుగా వారి శతాబ్ది ఉత్సవాల్లో భాగంగా శ్రీశ్రీశ్రీ త్రిదండి చిన్నజీయరు స్వామివారు 2009 ఫిబ్రవరి నెలలో పూర్తిగా శిథిలమయిన ఈ ఆలయాన్ని పునఃప్రతిష్ఠ చేయడం జరిగింది. జిల్లాలో వివిధ ప్రాంతాలనుంచే కాకుండా ఇతర జిల్లాలు మరియు ఒడిషా నుండి కూడా అనేకమంది భక్తులు వస్తుంటారు.',
        }
      ],
      title: 'మందస వాసుదేవ పెరుమాళ్ ఆలయం',
    }
  ],
  "Vastu": [
    {
      "CatID": [
        {
          title: 'వీధిశూల అని వీధి పోటు అని పిలువబడే వీటి విషయంలో చాలా చాలా అప్రమత్తంగా ఉండాలి.',
        },
        {
          title: 'స్థలం తీసుకునే తరుణంలోనే ఈ వీధిపోట్లును గుర్తించాలి.',
        },
        {
          title: 'వీధి ఫలితాలు తెల్సుకుని స్థలాన్ని కొనడం చేయాలి.',
        },
        {
          title: 'మన స్థలానికి ఎదురుగా వీధి ఉంటే దానిని వీధిపోటు అంటాము.',
        },
        {
          title: 'ఏ వీధిపోటు ఎలాంటి ఫలితాలనిస్తుందో సవివరంగా తెల్సుకుందాం.',
        },
        {
          title: <span class='highlight'>తూర్పు ఈశాన్య వీధిపోటు :</span>
        },
        {
          title: 'తూర్పు ఈశాన్య వీధిపోటు ఆ గృహంలో నివశించే పురుషులపై ప్రభావం చూపుతుంది.',
        },
        {
          title: 'ఇంటా బయటా వీరిదే పైచేయి అన్నట్లుంటుంది వీరి పరిస్థితి.',
        },
        {
          title: 'ఎక్కడ ఉన్నా ఏ పని చేస్తున్నా మంచి గుర్తింపు, మన్నన వీరికి లభిస్తాయి.',
        },
        {
          title: 'సమాజంలో మంచి గౌరవ ప్రతిష్ఠలు పొందగల్గుతారు.',
        },
        {
          title: 'ఇది శుభప్రదమైన వీధిశూలే.',
        },
        {
          title: 'ఇలాంటి వీధిపోటు ఉన్న స్థలంలో గృహ నిర్మాణం ఆమోద యోగ్యమే.',
        },
        {
          title: <span class='highlight'>ఉత్తర ఈశాన్యం వీధిపోటు :</span>
        },
        {
          title: 'ఉత్తర ఈశాన్యం వీధిపోటు... ఎంతో శుభప్రదం, లాభదాయకం, ఇంట సిరులు కురిపించే వీధిపోటు ఇది.',
        },
        {
          title: 'ఈ ఇంట ధనమే కాదు, ఆరోగ్యం కూడా దండిగా ఉంటుంది.',
        },
        {
          title: 'ఈ ఇంటో నివశించే దంపతులు ఎంతో అన్యోన్యంగా దాంపత్యాన్ని సాగిస్తారు.',
        },
        {
          title: 'కుటుంబంలో సభ్యుల నడుమ మమతానురాగాలు పెనవేసుకుంటాయి.',
        },
        {
          title: 'ఇంటా బయటా స్త్రీ పురుష బేధం లేకుండా ఈ ఇంట నివసించే వారికి మంచి పేరు ప్రతిష్ఠలు లభిస్తాయి.',
        },
        {
          title: 'ఇలా ఉత్తర ఈశాన్యం వీధిపోటు ఉన్న స్థలం లభిస్తే... వెయ్యి రూపాయలు అదనంగా చెల్లించి అయినా తక్షణం కొనేసుకోండి.',
        },
        {
          title: <span class='highlight'>ఉత్తర వాయువ్యం వీధిపోటు :</span>
        },
        {
          title: 'ఈ వీధిపోటు శుభదాయకం కాదు. ముఖ్యంగా ఈ వీధిపోటు ఆ ఇంట నివశించే మహిళలపై ప్రభావం చూపుతుంది. మనశ్శాంతిగా ఉండలేరు. సంసారంలో సుఖ సౌఖ్యాలు కరువవుతాయి. ఆడపిల్లలకు చదువు అబ్బదు. వివాహాల సమయంలో కూడా ఎన్నోచిక్కులు ఎదురవుతాయి. ఇలాంటి స్థలాన్ని కానీ, ఇంటిని కానీ కొనకూడదు.',
        },
        {
          title: <span class='highlight'>పశ్చిమ వాయువ్యం వీధిపోటు :</span>
        },
        {
          title: 'పశ్చిమ వాయువ్య దిశలో ఇంటికి ఎదురుగా వీధి ఉన్నట్లయితే దాన్ని పశ్చిమ వాయువ్య వీధిపోటుగా పరిగణించాలి.ఈ వీధిపోటు ఉన్న స్థలం కొనదగినది. గృహ నిర్మాణం చేయదగినది.',
        },
        {
          title: 'ఈ వీధిపోటు పురుషులపై సత్ప్రభావం చూపుతుంది. రాజపూజ్యం, గౌరవ ప్రతిష్ఠలు, ఎల్లెడలా ఆధిపత్యం, రాజకీయాలలో నాయకులుగాను త్వరగా ఎదుగుతారు.',
        },
        {
          title: 'మట్టి ముట్లుకున్నా బంగారం అన్నట్లుంటుంది ఈ ఇంటి నివశించే పురుషుల పరిస్థితి.ఇలాంటి స్థలాన్ని రెండో ఆలోచన లేకుండా కొనేయాలి.',
        },
        {
          title: <span class='highlight'>పశ్చిమ నైఋతి వీధిపోటు :</span>
        },
        {
          title: 'ఈ వీధిపోటు ఆ ఇంట నివశించే పురుషులపై ప్రధానంగా ప్రభావం చూపుతుంది. జీవితం గొర్రెకు తోక బెత్తెడే అన్నట్లుంటుంది. కష్టానికి తగ్గ ఫలితం లభించదు.',
        },
        {
          title: 'నిరాశా నిస్పృహలకు గురిచేస్తుంది. మనశ్శాంతిని హరిస్తుంది. జీవితం ఆపజయాల జాతర అన్నట్లు మారుతుంది. ఆపవాదులు, నిందలు, ఈ ఇంట మగవారిని బాధించి వేధిస్తాయి.',
        },
        {
          title: 'విజయం చేతికందినట్లే అంది పరాజయాన్ని మిగులుస్తుంది. మగవారి పరిస్థితి ఇలా ఉంటే ఇక ఆ కుటుంబం ఎలా ఉంటుందో మీరే అలోచించండి.',
        },
        {
          title: <span class='highlight'>దక్షిణ నైఋతి వీధిపోటు :</span>
        },
        {
          title: 'దక్షిణ నైఋతికి ఎదురుగా వీధి ఉంటే.. దాన్ని దక్షిణ నైఋతి వీధిపోటుగా భావించాలి. ఇలాంటి వీధిపోటు ఉన్న స్థలాన్ని, ఇంటిని కొనకూడదు.',
        },
        {
          title: 'ప్రత్యేకించి ఈ వీధిపోటు ప్రభావవం ఆ ఇంట గృహిణిపైన ఉంటుంది. కాపురం కలతల కల్లోలంగా ఉంటుంది. దాంపత్యంలో అనురాగం కొరవడుతుంది.',
        },
        {
          title: 'ఇంటి యజమానురాలి ఆరోగ్యం బాగుండదు. ఏ కార్యం తలపెట్టినా ఎదురుతిరుగుతుంది. మనసు ఎప్పుడూ కల్లోల సాగరంలా ఉంటుంది.',
        },
        {
          title: 'ఊరకే కృంగిపోతుంటారు. ఇంటా బయటా అవమానాలే.',
        },
        {
          title: <span class='highlight'>దక్షిణ ఆగ్నేయ వీధిపోటు :</span>
        },
        {
          title: 'ఇలాంటి వీధిపోటు ఉన్న స్థలాన్ని, ఇంటినీ నిశ్చింతగా కొనవచ్చు. ఈ ఇంట నివసించేవారు.',
        },
        {
          title: 'ఆనందప్రదమైన జీవితాన్ని అనుభవిస్తారు. డబ్బుకు కొదవే ఉండదు. అలానే ఈ ఇంట నివసించే వారికి ఆరోగ్యానికీ కొదవ ఉండదు. ఎప్పుడూ ఈ ఇల్లు ధన ధాన్యాలతో తులతూగుతుంటుంది.',
        },
        {
          title: 'బంధుమిత్రులతో కళకళలాడుతుంటుంది. ఈ ఇంట నివశించే ఆడవారు, ఆడపిల్లల చదువుల్లో సరస్వతుల్లా రాణిస్తారు. మంచి ఉద్యోగాలను పొందగల్గుతారు. మంచి ఖ్యాతి విఖ్యాతులు సొంతం చేసుకుంటారు.',
        },
        {
          title: <span class='highlight'>తూర్పు ఆగ్నేయ వీధిపోటు :</span>
        },
        {
          title: 'తూర్పు ఆగ్నేయ దిశలో వీధిపోటు ఉందంటే... ఆ ఇంట నివశించే వారి జీవితం... నిత్యం అల్లకల్లోలం అన్నట్లుంటుంది.',
        },
        {
          title: 'జయాలు శూన్యం. అపజయాలు అపారం. జీవితంలో కష్టాలు కోకొల్లలు. సుఖాలు కోటి దివిటీలతో వెతికినా కన్పించవు. మనసు సునామీ నాటి సంద్రంటా ఉంటుంది.',
        },
        {
          title: 'వేయి ప్రయత్నాలు చేస్తే 999 విఫలం అన్నట్లుంటుంది జీవితం. అటు వృత్తిలో అయినా, ఇటు వ్యాపారంలో అయినా విజయం ఎండమావే అవుతుంటుంది.',
        },
        {
          title: 'తూర్పు ఆగ్నేయ వీధిపోటున్న ఇంటిని, స్థలాన్ని కొనకూడదు.',
        },
        {
          title: <span class='highlight'>వీధిపోట్లు పట్ల నిర్లక్ష్యం :</span>
        },
        {
          title: 'వాస్తుశాస్త్రం రీత్యా వీధిపోట్లు విషయంలో చాలాచాలా అప్రమత్తంగా ఉండాలి.',
        },
        {
          title: 'సుఖశాంతుల్ని, జీవితంలో సెక్సెస్‌లను మింగేసి, అశాంతిని మిగిలించే వీధిపోట్లు ఉన్నా ఇళ్ళు, స్థలాలు, వ్యాపార దుకాణాలు వీటికి ఎంత దూరంగా ఉంటే అంత మంచిది.',
        },
        {
          title: 'శాస్త్రాన్ని, శాస్త్ర సూచనలను నిర్లక్ష్యం చేసి... కోరి కలతల్ని కొని తెచ్చుకోవడం మంచిది కాదు.',
        }
      ],
      title: 'వీదిశూల విషయంలో విధిగా అప్రమత్తం ?',
    },
    {
      "CatID": [
        {
          title: '1. ఈశాన్యం లొ పూజలు , పవిత్ర కార్యాలును నిర్వర్తించే విధంగా పూజగది ఉండాలి.',
        },
        {
          title: '2. ఆగ్నేయం లొ అగ్నికి సంబందించిన వంటావార్పు చేసుకొనే విధంగా వంటగది ఉండాలి.',
        },
        {
          title: '3. నైరుతిలో ఆయుధ సామగ్రి మొదలయిన వాటిని పెట్టుకోవడానికి ఒక గది ఉండాలి.',
        },
        {
          title: '4. వాయువ్యం లొ స్వతంత్రబిలాష చిహ్నములు .',
        },
        {
          title: '5. తూర్పు దిక్కున సూర్యునికి ప్రీతికరమైన పనులు.',
        },
        {
          title: '6. యమస్థానం అయిన దక్షిణం వైపు తలపెట్టి నిద్రించుట.',
        },
        {
          title: '7. కుభేర స్థానం అయిన ఉత్తరం వైపు చూస్తూ నిద్రలేచుట.',
        },
        {
          title: '8. వరుణ స్థానం అయిన పశ్చిమాన పాడిపశువులు పెంచుటకు తగిన స్థలం ఉండవలెను.',
        },
        {
          title: 'ఈ విధంగా చేయుటవలన ఆయా దిక్కులలోని ఉన్న దేవతలు సంతృప్తి చెంది ఆ గృహములో నివసించేవారికి సర్వసుఖాలు, సర్వ సంపదలు ఇస్తారు.',
        }
      ],
      title: 'గృహ నిర్మాణం ఏ విధంగా చేపడితే సర్వ సుఖాలు పొందుతారు ?',
    },
    {
      "CatID": [
        {
          title: ' 1. గోవుల మందలు ఉండే ప్రదేశాలలోనూ',
        },
        {
          title: '2. స్మశాన భూమికి సమీపం లొను',
        },
        {
          title: '3. మలమూత్రాలు విసర్జించు ప్రదేశాలలోను',
        },
        {
          title: '4. ఉప్పు నేలలోను, చవుడు నేలలయందు',
        },
        {
          title: '5. ఎల్లప్పుడు నీటి వుటలు గల ప్రదేశాలలోను',
        },
        {
          title: '6. రాతి భూముల యందు , మిక్కిలి రక్త వర్ణం గల భూమి యందు',
        },
        {
          title: '7. చెరువులను పూడ్చి గృహ నిర్మాణం చేయరాదు అలా చేయడం వలన అనేకములు అయిన పంది జన్మలు ఎత్తి రౌరవాది నరకములు అనుభవించి కష్టాల పాలవుతారు.',
        }
      ],
      title: 'ఎటువంటి స్థలం లొ గృహ నిర్మాణం చేయరాదు ?',
    },
    {
      "CatID": [
        {
          title: 'రాతితో కట్టే గృహానికి ఆ రాతితోనే శంఖువు తయారు చేసి శంఖుస్థాపన చేయవలెను. ఇటుకలతో కట్టిన గృహమునకు ఇటుకలతోనే శంఖువు చేసి ప్రతిష్ట చేయవలెను. గోడలు పెట్టక కర్రలతో, నిట్రాట లతో వేయు పాకలకు కర్రతో శంఖువు తయారు చేసి ప్రతిష్ట చేయవలెను.',
        },
        {
          title: 'శంఖువును నవరత్న, సువర్ణ, తామ్ర , రజిత నాణేలతో , నవధన్యములతో పూజించి , స్థాపించవలెను . అన్ని రకాల గృహములకు కర్ర శంఖువు ప్రతిష్టించరాదు . కాష్ట శంఖువు భుమిలొ ఎంతకాలం ఉండునో అంతకాలం ఆ గృహం శుబప్రధంగా ఉండును. ఆ తరువాత ఆ గృహములలో నివసించువారికి కష్టాలు కలుగును.కావున కర్రతో చేసిన శంఖువు కంటే రాతితో చేసిన శంఖువు ఉత్తమం అని తెలుస్తుంది.',
        }
      ],
      title: 'ఏయే గృహాలకి ఎటువంటి శంఖువు ప్రతిష్ట చేయాలి ?',
    },
    {
      "CatID": [
        {
          title: 'గృహంలో కిటికీలు, ద్వారములు సమసంఖ్యలో ఉండాలి. వేటికవే విడివిడిగా సమసంఖ్యలొ ఉండాలి. కిటికీలు సరిసంఖ్యలోను , ద్వారాలు సరిసంఖ్యలొను ఉండాలి. అలమారాల గురించి శాస్త్రం లొ ఏమీ చెప్పలేదు. వాటి ఉపయోగాన్ని అనుసరించి సరిసంఖ్యో, బేసి సంఖ్యలొ నో పెట్టుకొవాలి.',
        },
        {
          title: 'వాటికి స్థల నిర్ణయం కూడా చెప్పలేదు కిటికీలు , ద్వారాలు సరిసంఖ్యలో ఉన్నా చివరన సున్నా లేకుండా ఉండాలి. అనగా 10,20,30 ఇలా చివరన సున్నా రాకూడదు. అలాగే మొత్తం గృహం లొ ఉన్న ద్వారాలు, కిటికీలు అన్ని లెక్కపెట్టాలి.',
        }
      ],
      title: 'గృహ నిర్మాణం లొ ఇంటి కిటికీలు, ద్వారాలు ఏ విధంగా అమర్చాలి ?',
    },
    {
      "CatID": [
        {
          title: 'పూర్వ‌కాలంలో అంధ‌తాసుర‌డ‌నే రాక్ష‌సుడు ముల్లోకాల వాసుల‌ను ముప్ప‌తిప్పులు పెట్టుచుండెను. అప్పుడు లోక సంర‌క్ష‌ణార్థం ప‌ర‌మేశ్వ‌రుడు ఆ రాక్ష‌సునితో యుద్ధం చేశాడు. ఆ స‌మ‌యంలో శివుని ల‌లాటం నుండి రాలిన ఒక చెమ‌ట బిందువు భూమిపై ప‌డి దాని నుండి భ‌యంక‌ర‌మైన క‌రాళ వ‌ద‌నంతో ఒక గొప్ప భూతం ఉద్భ‌వించి క్ర‌మ‌క్ర‌మంగా భూమి, ఆకాశాల‌ను ఆవ‌రించి సాగింది. ఆ మ‌హాభూతాన్ని చూసిన ఇంద్రాది దేవ‌త‌లు భయ‌భ్రాంతుల‌య్యారు. బ్ర‌హ్మ‌దేవుని శ‌ర‌ణువేడారు. స‌మ‌స్త భూత‌ముల‌ను సంభ‌వించువాడు, స‌ర్వ‌లోక పితామ‌హుడు అయిన బ్ర‌హ్మ దేవ‌త‌ల‌ను ఊర‌డించి ఆ భూత‌మును ఆధోముఖంగా భూమి యందు ప‌డ‌వేసి విధానం చెప్పాడు.',
        },
        {
          title: 'బ్ర‌హ్మ‌దేవుని ఆన‌తి ప్ర‌కారం దేవ‌త‌లంద‌రూ ఏక‌మై ఆ భూత‌మును ప‌ట్టి అధోముఖంగా క్రింద‌కు ప‌డ‌వేశారు. ఆ భూతం భూమిపై ఈశ‌న్య కోణ‌మున శిర‌స్సు, నైరుతి కోణ‌మున పాద‌ములు, వాయువ్య‌, ఆగ్నేయ కోణాలందు బాహువులు వుండున‌ట్లు ఆధోముఖంగా భూమిపై ప‌డింది. అది తిరిగి లేవ‌కుండా దేవ‌త‌లు దానిపై కూర్చున్నారు. ఇంత‌మంది దేవ‌త‌ల తేజస్ర్స‌ముదాయంతో దేదీప్య‌మానంగా వెలుగొందుతున్న ఆ భూతాకార అద్భుతాన్ని తిల‌కించిన బ్ర‌హ్మ దేవుడు దాన్నే వాస్తు పురుషుడుగా సృష్టిగావించాడు. వాస్తు పురుషుడు భాద్ర‌ప‌ద బ‌హుళ త‌దియ‌, శ‌నివారం, కృత్రికా న‌క్ష‌త్ర‌ము, వ్య‌తీపాత యోగ‌ము, భ‌ద్ర‌నా క‌ర‌ణ‌ము గుళిక‌తో కూడిన కాలంలో ఆ వాస్తు పురుషుడు జ‌న్మించాడు.',
        },
        {
          title: 'బ్ర‌హ్మ‌దేవుని ఆన‌తి ప్ర‌కారం దేవ‌త‌లంద‌రూ ఏక‌మై ఆ భూత‌మును ప‌ట్టి అధోముఖంగా క్రింద‌కు ప‌డ‌వేశారు. ఆ భూతం భూమిపై ఈశ‌న్య కోణ‌మున శిర‌స్సు, నైరుతి కోణ‌మున పాద‌ములు, వాయువ్య‌, ఆగ్నేయ కోణాలందు బాహువులు వుండున‌ట్లు ఆధోముఖంగా భూమిపై ప‌డింది. అది తిరిగి లేవ‌కుండా దేవ‌త‌లు దానిపై కూర్చున్నారు. ఇంత‌మంది దేవ‌త‌ల తేజస్ర్స‌ముదాయంతో దేదీప్య‌మానంగా వెలుగొందుతున్న ఆ భూతాకార అద్భుతాన్ని తిల‌కించిన బ్ర‌హ్మ దేవుడు దాన్నే వాస్తు పురుషుడుగా సృష్టిగావించాడు. వాస్తు పురుషుడు భాద్ర‌ప‌ద బ‌హుళ త‌దియ‌, శ‌నివారం, కృత్రికా న‌క్ష‌త్ర‌ము, వ్య‌తీపాత యోగ‌ము, భ‌ద్ర‌నా క‌ర‌ణ‌ము గుళిక‌తో కూడిన కాలంలో ఆ వాస్తు పురుషుడు జ‌న్మించాడు.',
        },
        {
          title: 'అంతేకాక వాస్తు ప‌రుషునిపై అష్ట‌దిక్కుల‌లో వున్న దేవ‌త‌లు తృప్తి పొందు విధంగా ఆయా స్థ‌లాల‌లో నివ‌సించే దేవ‌త‌లు వారివారి విధులు నిర్వ‌హించుట వ‌ల‌న గృహ‌స్థుల‌కు స‌ర్వ‌సుఖ‌ములు, స‌త్ఫ‌లితులు క‌లుగున‌ట్లు ఆశీర్వ‌దించారు. బ్ర‌హ్మ‌దేవుని ఆశీస్సులు ప్ర‌కారము ఈశాన్య‌మున – ఈశ్వ‌రుడు (ఈశ‌), ఆగ్నేయ‌మున – అగ్ని, నైరుతిన ఆదిత్య‌డు, వాయువ్య‌మైన – వాయువు, తూర్పున – వ‌రుణుడు, ఉత్త‌ర‌మున – కుబేరుడు (సోమ‌), అష్ట‌దిక్కుల‌లో అధిష్టించిన ఈ దేవ‌త‌లు తృప్తి చెందే విధంగా నిర్మాణ క్ర‌మం వుంటే ఆ గృహంలో నివ‌సించే వాళ్లు స‌ర్వ‌సుఖ సంప‌ద‌ల‌ను పొందుతారు. ఇదీ వాస్తు – పురాణం. ఈశాన్య‌ములో పూజ‌లు, ప‌విత్ర కార్య‌ములు అగ్నేయ‌మున అగ్నిదేవునికిసంబంధించిన వంటావార్పు నైరుతిన ఆయుధ సామాగ్రి, వాయువ్య‌మున స్వ‌తంత్రాభిలాష చిహ్న‌ములు, తూర్పున ఆధిత్యునికి ప్రీతిక‌ర‌మైన ప‌నులు,య‌మ‌స్థాన‌మైన ద‌క్షిణ‌ము శిర‌స్సు ఉంచి నిద్రించుట‌, కుబేర స్థాన‌మైన ఉత్త‌రాన్ని ద‌ర్శిస్తూ మేలు కొనుట‌, వ‌రుణ స్థాన‌మైన ప‌శ్చిమాన పాడి ప‌శువుల‌ను పెంచుట మొద‌లైన విధులు ఆయా దిక్కుల్లో ఉన్న దేవ‌త‌ల‌కు తృప్తిని క‌లిగిస్తాయి. ఈ సారాంశాన్ని వాస్తు శాస్త్రం నియ‌మాలు మ‌న‌కు వెళ్ల‌డిస్తున్నాయి.',
        },
        {
          title: 'గృహ నిర్మాణాలు చాలా ర‌కాలు వీటిలో మ‌న‌ష్యోప‌యుక్త‌ములు, ప‌శ‌వుల‌కు సంబంధించిన నిర్మాణాలు, ప‌క్షుల‌కు సంబంధించిన నిర్మాణాలు దేవ‌త‌ల‌కు సంబంధించిన నిర్మాణాలు ఇలాగ అనేక విధాలుగా వున్నాయి. వాస్తుశాస్త్రక‌ర్త‌లు నిర్మాణాల‌ను ముఖ్యంగా 4 భాగాలుగా విభ‌జించారు. (1) సాధార‌ణ మ‌నుష్య నివాస‌ములు (2) ప్ర‌భు నిర్మాణ‌ములు (3) దేవ‌తా నిర్మాణ‌ములు (4) స‌ర్వ‌సాధార‌ణ ప్ర‌జోప‌యోగ నిర్మాణాలు. సామాన్యంగా ప్ర‌తి గృహ‌స్తుల‌కు అవ‌స‌ర‌మైన స‌దుపాయ‌ముల‌ను గురించి మార్పుల‌తో నిర్మాణాలు చెప్ప‌బ‌డియున్న‌వి.',
        },
        {
          title: <span class='highlight'>ఏనాటిదీ వాస్తుశాస్త్రం?</span>
        },
        {
          title: 'వాస్తు ఈనాటిదికాదు.. రాజుల కాలం నుంచే ఉంది. ప్రతి రోజు కొలువులో ఒక జ్యోతిషునితో పాటు ఒక వాస్తు పండితుడు కూడా ఉండేవాడు. మహారాజు ఏ నిర్మాణం చేయాలన్నా వాస్తు పండుతుల సూచనలు పాటించినట్లు చారిత్రక ఆధారాలు లభిస్తున్నాయి. అంతేకాదు.... వాస్తు వేదకాలం నాటిది అని చెప్పేందుకు ఆధారంగా పలు తాళపత్ర గ్రంథాలు సాక్ష్యంగా నిలుస్తున్నాయి. క్రైస్తవ, ముస్లిం మత గ్రంథాలలో కూడా ఇల్లు, దాని నిర్మాణ బాగోగులు గురించిన సమాచారం ఉండడం గమనించదగిన విషయం.',
        },
        {
          title: <span class='highlight'>స్థలంలో దిక్కుల గురించి :</span>
        },
        {
          title: 'స్థలంలో దిక్సూచినుపయోగించి ఉత్తర దక్షిణాలకు నిర్ధారించాకే తూర్పు, పడమరలను తదనుగుణంగా నిర్ణయించడం సులవవుతుంది. స్థలానికి నాలుగు దిక్కులే కాదు. నాలుగు మూలలు కూడా ఉంటాయి. వాటిని నిర్ణయించడంపై భిన్నాభిప్రాయాలు ఉన్నా, గ్రంథస్తంగా అందుతున్న పరిజ్ఞానాను సారంగా అయితే ఒక దిక్కును తొమ్మిది భాగాలుగా విభజించి, అటుపై మూలల నిర్ణయం చేయాలి. ఆ వివరాలు వివరంగా తెల్సుకుందాం. తూర్పు దిక్కును 9 భాగాలు చేయండి. మీరు తూర్పుకు తిరిగి నిలబడినపుడు తూర్పు దిక్కులో మీ కుడిచేతి వైపు ఉన్న రెండు భాగాలు తూర్పు ఆగ్నేయంగా భావించాలి.',
        },
        {
          title: 'అలాగే మీ ఎడమ చేతివైపు ఉన్న చివరి రెండు భాగాలు తూర్పు ఈశాన్యంగా ఈ రెంటి నడుమ ఉన్న అయిదు భాగాలను తూర్పు దిక్కుగా భావించాలి. ఒక ఉత్తరం విషయానికొస్తే... మీరు ఉత్తరదిశగా తిరిగితే... మీ కుడిచేతి వైపున ఉండే చివరి రెండు భాగాలు ఉత్తర ఈశాన్యం, ఎడమచేతి చివరగా ఉండే రెండు భాగాలు ఉత్తర వాయువ్యం, వీటి నడుమ ఉన్న అయిదు భాగాలు ఉత్తర దిక్కుగా భావించాలి. ఇక పడమర వియానికొస్తే... మీరు పడమర దిక్కుగా నిలబడినపుడు పడమర దిక్కులోని 9 భాగాలలో మీ కుడిచేతివైపు చివరగా ఉండే రెండు భాగాలు పశ్చిమ వాయువ్యంగాను, మీ ఎడమ చేతివైపు చివరగా ఉండే రెండు భాగాలు పశ్చిమ నైఋతిగాను వీటి నడుమ ఉండే అయిదు భాగాలు పశ్చిమ దిశగా గ్రహించాలి.',
        },
        {
          title: 'దక్షిణాన్ని కూడా ఇలానే గమనిస్తే మీరు దక్షిణ దిశగా తిరిగి నిలబడినపుడు.. మీకుడి చేతి చివరన ఉన్న రెండు భాగాలు... దక్షిణ నైఋతి. అలానే ఎడమచేతి వైపు చివరగా ఉండే రెండు భాగాలు దక్షిణ ఆగ్నేయం అని గ్రహించాలి. స్థలం ఏదయినా సరే దిక్కులు, మూలల్ని ఇలా నిర్ణయించుకోవాలి.',
        },
        {
          title: <span class='highlight'>గృహ నిర్మాణ స్థల వైశిష్ట్యం :</span>
        },
        {
          title: 'గృహ నిర్మాణ సమయంలోనే వాస్తు నియమాలు పాటిస్తే సరిపోదు. గృహ నిర్మాణ నిమిత్తం స్తలాన్ని చేసుకునే తరుణంలో కూడా హండ్రెడ్‌ పర్సెంట్‌ ఆ స్థలం విషయంలో వాస్తు నియమాలు పాటించాలి. ఏ మాత్రం వాస్తుకు వ్యతిరేకంగా లేని స్థలాన్ని మాత్రమే సెలక్టు చేసుకుని... ఆ స్థలంలోనే పూజాది కార్యక్రమాలు నిర్వహించి వాస్తు పూజ విధిగా చేసి అప్పుడు గృహ నిర్మాణం ప్రారంభించాలన్నది శాస్త్రం చేస్తున్న సూచన.',
        },
        {
          title: '1. మీరు తీసుకునే స్థలం బల్లపరుపుగా చదునుగా ఉండాలి.',
        },
        {
          title: '2. మీ స్థలానికి పడమర దిశలో కానీ, దక్షిణ దిశలో కానీ తటాకాలు, కాలువలు, జలాశయాలు, పెద్ద పెద్ద గోతులు ఏ మాత్రం ఉండకూడదు.',
        },
        {
          title: '3. పడమర, దక్షిణ దిశలలో స్థలం ఎత్తుగా ఉండవచ్చు. ఆనుకుని ఉన్నస్థలం మెరకగా ఉండవచ్చు. ఎత్తయిన కొండలు, గుట్టలు ఏవయినా ఉండవచ్చు. ఇది గృహ నిర్మాణానికి అనువైన స్థలంగా వాస్తు చెబుతుంది.',
        },
        {
          title: '4. మీరు సెలక్టు చేసుకున్న స్థలం ఉత్తరం పల్లంగా ఉండవచ్చు ఉత్తర భాగాన జలాశయాలు, కాలువలు ఉండవచ్చు.',
        },
        {
          title: '5. అలాగే తూర్పు దిశలో కూడా ఎలాంటి మెరలు, గుట్టలు లేకుండా మీ తూర్పుదిక్కున స్థలం పల్లంగా ఉండాలి. స్థలానికి తూర్పున తటాకం, జలాశయం, బావి, గొయ్యి, కాలువ ఇలాంటివి ఏవి ఉన్నా దాన్ని శుభప్రదమైన స్థలంగా పరిగణించాలి.',
        },
        {
          title: '6. మీరు నిర్ణయించుకున్న స్థలానికి నైఋతి దిశలో ఎంత ఎత్తయిన కట్టడాలువ ఉంటేవ మీకు అంత శుభప్రదం, నైఋతిలో మెరక, కొండలు, గుట్టలు ఉన్నా అది శుభాదయకమే.',
        },
        {
          title: '7. నైఋతి, ఆగ్నేయం, వాయువ్య దిక్కులతో పోల్చినపుడు... ఈశాన్య దిక్కు పల్లంగా ఉంటే అది ఎంతో మంచిది.',
        },
        {
          title: '8. ఒకవేళ ఇలా లేకున్నా ఈశాన్యాన్ని పల్లంగా చేసుకుంటే ఉత్తమం. పొరపాటున కూడా ఈశాన్యం కన్నా ఇతర మూడు మూలలు పల్లంగా ఉండరాదు.',
        },
        {
          title: '9. స్థలాన్ని సెలక్టు చేసుకునే సమయంలో మీ స్థలానికి అతి చేరువలో స్మశానం, కర్మాగారాలు, అధిక ధ్వనిని కల్గించే రైల్వే మార్గాలు, స్టేషన్‌లు, విమానాశ్రయాలు లేకుండా తగు జాగ్రత్త పాటించాలి. ధ్వని కాలుష్యం మీరు నివశించే చోటుకు అతి చేరువగా ఉంటే మీ ఆరోగ్యం పై ఈ ధ్వని కాలుష్యం ప్రభావం చూపుతుంది.',
        },
        {
          title: '10. స్థలానికి అతి చేరువలో మురుగు ప్రవహించే కాలువలు లేకుండా చూసుకోవాలి. అలానే నీరు నిలిచిపోయే గోతులు లేకుండా జాగ్రత్త వహించాలి.',
        },
        {
          title: '11. స్థలాన్ని త్రవ్వినపుడు ఎముకలు, దంతాలు బయటపడినా, పాము పుట్టలు, దిబ్బలు బయటపడినా అది నివాసయోగ్యం కాని స్థలంగా భావించి దాన్ని వదిలివేయాలి.',
        },
        {
          title: '12. ఉత్తరం కన్నా దక్షిణం మెరకగా అంటే ఎత్తుగా ఉన్న స్థలంలో గృహ నిర్మాణం చేసినట్లయితే... ఆ గృహంలో నివశించే వారి ఆర్ధిక పరిస్థితి ఉన్నతంగా ఉంటుంది.',
        },
        {
          title: '13. ఇలా కాకుండా దక్షిణం పల్లం ఉత్తరం మెరకగా ఉన్న స్థలంలో గృహ నిర్మాణం చేసినట్లయితే ఆర్ధికంగా, ఆరోగ్య పరంగా పలురకాల సమస్యలు ఈ గృహంలో నివశించే వార్ని వేధిస్తాయి.',
        },
        {
          title: '14. తూర్పు కన్నా, పడమర ఎత్తుగా ఉన్న స్థలంలో గృహ నిర్మాణం చేశారంటే... ఈ గృహంలో నివసించే వారికి చక్కని మనశ్శాంతి, సమాజంలో గౌరవ ప్రతిష్టలు లభిస్తాయి. ప్రశాంతంగా జీవించ గల్గుతారు.',
        },
        {
          title: '15. తూర్పు ఎత్తుగాను, పడమర పల్లంగాను ఉన్న స్థలంలో గృహ నిర్మాణం చేసినట్లయితే.. మానసిక ప్రశాంతత ఉండదు. ఆరోగ్య సమస్యలు, మానసిక సమస్యలు, పలురకాల ఇబ్బందులు వీర్ని వెన్నాడుతూనే ఉంటాయి.',
        },
        {
          title: '16. నైఋతి దిక్కుకన్నా ఈశాన్య దిక్కులో స్థలం పల్లంగా ఉన్నట్లయితే.. ఈ స్థలం గృహ నిర్మాణానికి ఎంతో శుభప్రదమైనదిగా వాస్తుశాస్త్రం చెబుతుంది. మంచి ఆరోగ్యం, మంచి గౌరవ ప్రతిష్ఠలు, పదుగురు అభినందించే సంతతి ఇలాంటి గృహంలో నివశించే వారికి లభ్యమవుతాయి.',
        },
        {
          title: '17. ఆగ్నేయం కన్నా వాయువ్యం పల్లంగా ఉండాలి. ఇలాంటి స్థలంలో గృహనిర్మాణం వాస్తు నియమానుసారం చేస్తే అష్ట ఐశ్వర్యాలు సిద్ధిస్తాయి. సమాజంలో మాంచి గౌరవ ప్రతిష్ఠలు పొందగల్గుతారు.',
        },
        {
          title: '18. వాయువ్యం ఎత్తుగా ఉండి... వాయువ్య కన్నా ఆగ్నేయం తక్కువ ఎత్తులో ఉండే స్థలంలో గృహ నిర్మాణం చేయరాదు.',
        },
        {
          title: '19. నైఋతి మూలకన్నా ఈశాన్యం మూల ఎత్తుగా ఉన్న స్థలంలో కూడా గృహనిర్మాణం చేయరాదు.',
        }
      ],
      title: 'వాస్తు శాస్త్రము (వాస్తు పురాణం)',
    },
    {
      "CatID": [
        {
          title: 'ఎక్కడికెళ్లినా సమస్యలే ఇంట్లో, బయటా ఎక్కడైనా కష్టాలే ఎదురువుతున్నాయ్ నిత్యం ఇబ్బందులే. ఆర్థికంగా, మానసికంగా అన్నీ ఒకేసారి వచ్చి పడుతున్నాయ్ వాటి నుంచి ఎంత బయట పడదామన్నా వీలవడం లేదు, మరింత లోతుకు వెళ్లాల్సి వస్తోంది. అని వాపోతున్నారా..? అయితే అది మీ తప్పు కాకపోవచ్చు.',
        },
        {
          title: 'మీ ఇంట్లో ఉన్న నెగెటివ్ ఎనర్జీ, వాస్తు దోషం అయి ఉండవచ్చు. ఎందుకంటే మీ ఇంట్లో నిత్యం మీరే ఉన్నా అప్పుడప్పుడు వచ్చే అతిథులు, స్నేహితులు, ఇంకా ఇతర తెలిసిన వారి వల్ల ఇంట్లో నెగెటివ్ ఎనర్జీ వస్తుందట అంతేకాదు దీనికి వాస్తు దోషం తోడైతే అప్పుడు ఆ ఇంట్లో ఉన్న వారికి అన్నీ సమస్యలే ఎదురవుతాయట.',
        },
        {
          title: 'ఈ క్రమంలో అలాంటి సమస్యలు తప్పించేందుకు, వాస్తు దోషం పోగొట్టేందుకు పలు రకాల నివారణా మార్గాలు అందుబాటులో ఉన్నాయి. వీటి గురించి పలువురు పండితులు విశ్లేషించి మరీ చెబుతున్నారు కూడా. ఈ క్రమంలో సదరు నివారణా మార్గాలు ఏమిటో ఇప్పుడు తెలుసుకుందాం.',
        },
        {
          title: <span class='highlight'>వేప ఆకులు :</span>
        },
        {
          title: 'వేప ఆకుల్లో సహజ సిద్ధమైన యాంటీ బయోటిక్ యాంటీ బాక్టీరియల్ యాంటీ వైరల్ యాంటీ ఫంగల్ గుణాలు ఉన్నాయి. సూక్ష్మ క్రిముల పట్ల వేప అద్భుతంగా పని చేస్తుంది. ఈ క్రమంలో వేప ఆకును ఇంట్లో కాల్చి పొగ వేస్తే దాంతో ఇంట్లో ఉండే బాక్టీరియా, వైరస్లు నాశనమవుతాయి. అంతే కాదు వేప ఆకును ఇంట్లో మండించడం వల్ల వాస్తు దోషం కూడా పోతుంది',
        },
        {
          title: <span class='highlight'>అగర్బత్తీలు :</span>},
        {
          title: 'హిందువులు ఎవరైనా దేవుడికి పూజ చేసినప్పుడు మాత్రమే అగర్ బత్తీలను వెలిగిస్తారు. లేదంటే ఎవరైనా చనిపోయినప్పుడు వారిని ఖననం చేసేందుకు తీసుకెళ్లినప్పుడు కూడా వీటిని వెలిగిస్తారు. అయితే అగర్ బత్తీలను మామూలు సమయంలో కూడా వెలిగించవచ్చ. దాంతో ఇంట్లో ఉన్న నెగెటివ్ ఎనర్జీ మాయమవుతుంది.',
        },
        {
          title: 'అయితే అగర్బత్తీలను ఎప్పుడు వెలిగించినా బేసి సంఖ్యలో స్టిక్స్ను వెలిగించాలి.కుర్చీలు, టేబుల్స్ సోఫాలు, మంచాలు ఇలా ఇంట్లో ఉన్న ఫర్నిచర్ను అప్పుడప్పుడు తీసి వేరే దిశలో పెట్టి మళ్లీ యథావిధిగా అమర్చుకోవాలట. దీంతో నెగెటివ్ ఎనర్జీ పోయి పాజిటివ్ ఎనర్జీ వస్తుందట. దీన్ని గురించి ఫెంగ్ షుయ్ వాస్తులో వివరించారు.',
        },
        {
          title: <span class='highlight'>ఉప్పు :</span>
        },
        {
          title: 'రెండు చిన్నపాటి గిన్నెలను తీసుకుని వాటిలో కొంత ఉప్పు వేయాలి. అనంతరం ఆ రెండు గిన్నెలను ఇంట్లో ఈశాన్య నైరుతి దిశల్లో ఉంచాలి. ఇలా చేస్తే నెగెటివ్ ఎనర్జీ మాయమవుతుంది. పాజిటివ్ ఎనర్జీ వస్తుంది.కిటికీలుకిటికీలను ఎల్లప్పుడూ తెరచి ఉంచాలి. వాటి వద్ద కుండీల్లో ఏవైనా మొక్కలను ఉంచాలి. ఇలా చేయడం వల్ల నెగెటివ్ ఎనర్జీ బయటికి వెళ్లి పాజిటివ్ ఎనర్జీ వస్తుంది. దాంతో ఇంట్లోని అందరికీ మంచే జరుగుతుంది.',
        },
        {
          title: <span class='highlight'>కర్పూరం, లవంగాలు :</span>
        },
        {
          title: 'ఉదయం, సాయంత్రం వేళ్లలో కొద్దిగా కర్పూరం తీసుకుని వెలిగించి దాంట్లో కొన్ని లవంగాలను కూడా వేయాలి. ఇలా రెండింటినీ మండించడం వల్ల ఇంట్లో ఉన్న వాస్తుదోషం పోతుంది. అందరికీ అదృష్టం క;లసివస్తుంది. ఆర్థిక సమ;స్యలు ఉంటే పోతాయి.',
        }
      ],
      title: 'ఇంట్లో వాస్తు దోషాలు మరియు ఇతర దోషాలు పోయి ప్రశాంతంగా ఉండాలంటే ?',
    },
    {
      "CatID": [
        {
          title: 'ప్రతి ఒక్కరికి ఇల్లు కట్టుకోవాలని ఉంటుంది, దానికి సంబంధించి వాస్తు తది తర అంశాల దగ్గర నుంచి, గృహప్రవేశం అయ్యే వరకు అన్నీ సలహాలు తీసుకుని ఇల్లు కట్టుకుంటారు. ఇంటి వాస్తు, వారి గ్రహ బలం, శాంతులు ఇత్యది అన్ని విషయాల్లో జాగ్రత్త పడతారు.',
        },
        {
          title: 'ఇప్పుడు అపార్ట్మెంట్ సంస్కృతి వచ్చిన తరువాత గృహ ప్రవేశం అప్పుడు వెండి గోవు ప్రతిమ ను తీసుకువెళుతున్నారు కాని, నిజానికి పూర్వం, గోవును దూడను తీసుకుని నూతన గృహం లో కి పురోహితుడు ప్రవేశించి, శాంతి చేసి పిదప దేవుని చిత్ర పటాల తో భార్యా భర్తలు గృహ ప్రవేశం అవుతారు. అసలు గృహ ప్రవేశం లో గోవునే ఎందుకు తీసుకెళతారో చూద్దాం.',
        },
        {
          title: 'మనం ఈ రోజు క్రయం చేసిన స్థలం/ఇల్లు ఇంతకు ముందు మరెవరిదో. మనం ఎంతో కష్టపడి రూపాయి రూపాయి కూడబెట్టి ఇల్లు కట్టుకుని కొంతకాలానికి మరణిస్తారు. మరణించిన తరువాత కొంత మంది ప్రేతాత్మ లు గా మారి ఆ ఇంటిని, ఆ ఇంటిలో తన వారి గుర్తులను మరువలేక ప్రేత అయి ఇంటి చుట్టూ తిరుగుతుంటారు.',
        },
        {
          title: 'సహజంగా కుక్కకు వాసన పసిగట్టే శక్తిని భగవంతుడు ఇచ్చాడు. అలాగే పాముకు భూకంపాలను గుర్తించే శక్తి ని ఇచ్చాడు, అలాగే ఆవులకు ప్రేతాలను పశిగట్టే శక్తి ని ఇచ్చాడు. అందుకే నూతన గృహం లో ప్రవేశించేటప్పుడు గత వారి తాలూకు ప్రేతాలు శాంతించడానికి, కొన్నవారికి కీడు చేయకుండా ఉండటానికి గోవును పంపిస్తారు.',
        },
        {
          title: 'ఒక వేళ ప్రేత లు కనక ఉన్నట్లైతే గోవులు గుర్తుపట్టి లోపలకి వెళ్లటానికి మొరపెడతాయి. అప్పుడు పురో హితుడు శాస్త్రోక్తంగా, వేద పఠనం తో ఆ ప్రేతలను తరిమి తరువాత గృహప్రవేశం చేయిస్తాడు. ఇది ఇందులో ఉన్న పరమార్ధం.',
        }
      ],
      title: 'గృహ ప్రవేశంలో గోమాత ఎందుకు తీసుకెళతారో ?',
    },
    {
      "CatID": [
        {
          title: 'ఏదైనా సాధించినప్పుడు మాత్రమే మనం సంతోషంగా ఉంటామని చాలా మంది భావిస్తూ ఉంటారు. వాస్తవానికి అఛీవ్‌మెంట్ అనేది తాత్కాలికమైన సంతోషాన్ని మాత్రమే ఇస్తుంది. దాని ద్వారా లభించే సంతోషం మాయమైన తర్వాత మళ్లీ ఏదో సాధించడం కోసం పరుగు పెట్టాలి. ఇక్కడ గుర్తుపెట్టుకోవాల్సిన విషయం, “ఏదైనా సాధించడం” అనేది మనకు మనం ఎదగడం కోసం ఉపయోగపడుతుంది తప్పించి అది సంతోషానికి కేరాఫ్ అడ్రస్ కాదు. మరి అలాంటప్పుడు సంతోషం ఎలా లభిస్తుంది?',
        },
        {
          title: <span class='highlight'>చిన్న శ్వాస!</span>
        },
        {
          title: 'ఒకే ఒక బలమైన శ్వాస.. మెదడులోకి ఆక్సిజన్ సరఫరా ఒక్కసారిగా పంప్ చెయ్యబడి, అప్పటివరకు మనసులో ఉన్న గందరగోళం మొత్తం మాయమయ్యేలా ఒక్క బలమైన శ్వాస చాలు, మీలో ఉన్న ఒత్తిడి మాయం కావటానికి, పరోక్షంగా ఆ వత్తిడి మాటున దాగి ఉన్న సంతోషం తిరిగి రావడానికి! చాలామందికి అర్థం కాని విషయం మన శ్వాస మన సంతోషానికి చాలా సందర్భాల్లో కారణమవుతుంది.',
        },
        {
          title: 'గుండె నిండా ఊపిరి తీసుకుంటే వచ్చే కాన్ఫిడెన్స్‌లో మన సంతోషం దాగి ఉంటుంది. నిరంతరం ఒత్తిడి, ఆందోళన వంటి అనేక రకాల నెగిటివ్ అంశాల క్రింద మన సంతోషం కప్పేయబడి ఉంటుంది. దాన్ని రిలీవ్ చెయ్యడానికి అప్పుడప్పుడు బలంగా శ్వాస తీసుకుని హోల్డ్ చేసి, వదిలిపెట్టడం సహాయపడుతుంది. అందుకే ప్రాణాయామం గురించి అంత గొప్పగా చెబుతారు.',
        },
        {
          title: 'ఈ క్షణం మిమ్మల్ని ఏదైనా వేరే ఆలోచన డామినేట్ చేస్తుంటే, బలంగా ఒక శ్వాస తీసుకోండి. దాన్ని నిట్టూర్పు అనుకోండి ఇంకోటి అనుకోండి.. నిజంగా ఆ ఆలోచన అవసరమా లేదా, ఆ విషయంలో మీరు చేయగలిగింది ఏమిటి వంటి పలు అంశాల మీద క్లారిటీ వస్తుంది. అది చాలు, ఒత్తిడి తగ్గి పోయి సంతోషం తిరిగి రావడానికి!',
        },
        {
          title: <span class='highlight'>బాగా వినండి!</span>
        },
        {
          title: 'వినడం ఎవరైతే తగ్గిస్తారో వారు ఎప్పుడూ అశాంతిగా ఉంటారు. ఈ మధ్య కాలంలో చాలా మంది ఎదుటి వ్యక్తి మాటలు వినే ఓపిక కోల్పోతున్నారు. ఎదుటి వ్యక్తి ఏదైనా చెబుతుంటే, దాన్ని మెదడులోకి స్వీకరించడం పక్కన పెట్టి, తలాడిస్తూ, తరువాత మనం ఏం మాట్లాడదామా అని సెంటెన్స్‌లు ఫ్రేమ్ చేసుకుంటున్నారు.',
        },
        {
          title: 'మరికొంతమంది అవతలి వ్యక్తి మాట్లాడుతుంటే, వేరే విషయాల గురించి పరధ్యానంగా ఆలోచించడం, అవతలి వారు తమ గురించి ఏమనుకుంటున్నారు అన్నది ఊహించుకోవటం చేస్తూ ఉంటారు. మనసుపెట్టి వినడం అనేది యోగాతో సమానం. మన ఆలోచనలు ఈ క్షణంలో ఉండేలా అలవాటు చేస్తుంది. దీంతో ఫోకస్ లెవల్స్ పెరుగుతాయి. క్రమేపీ అనవసరమైన ఆలోచనలు తగ్గిపోతాయి. ఇది పరోక్షంగా సంతోషానికి దారితీస్తుంది.',
        },
        {
          title: <span class='highlight'>దృష్టి ఇలా</span>
        },
        {
          title: 'మీరు గమనించారో లేదో గంటల తరబడి మీరు ఫోకస్డ్‌గా ఒక పని చేస్తున్నప్పుడు, కొద్దిసేపటికి దాంట్లో పూర్తిగా లీనమై పోతారు. బయట ప్రపంచం గురించి అసలు ఆలోచించరు. అది అద్భుతమైన స్థితి. దాంట్లో లభించే సంతోషం మాటల్లో వర్ణించలేనిది. సరిగ్గా ఇదే నియమాన్ని అన్నిచోట్లా అప్లై చేయండి. మీ కళ్లు ఏం చూస్తున్నాయో దాన్ని తప్పించి మిగతా ప్రపంచాన్ని అప్పటికప్పుడు మర్చిపోండి.',
        },
        {
          title: 'అలాగే మీరు ఏమి చదువుతున్నారో మనసులో అది మాత్రమే ఉండాలి. కళ్లతో చూసే ఏ విషయమూ మరీ ఎక్కువగా విశ్లేషించవద్దు, జడ్జ్ చేయొద్దు, కేవలం కళ్ళ ఎదుట జరిగే విషయాలకు సాక్ష్యంగా చూస్తూ ఉండండి. దాంతో మీ విశ్లేషణ, దాని ద్వారా వచ్చే మీ కంక్లూజన్ మీ మనసును చెడగొట్టకుండా ఉంటుంది. అలాగే ఆహారం తీసుకునేటప్పుడు, ఏదో హడావిడిగా కడుపు నింపుకోవడం కాకుండా, దాని టేస్ట్‌ని పూర్తిస్థాయిలో ఆస్వాదిస్తూ పూర్తి ఫోకస్డ్‌గా తినండి. చాలామందికి కడుపునిండా తినడం వలన సంతృప్తి వస్తుంది. కానీ ఆహారాన్ని ఆస్వాదిస్తూ తింటే నాలుగు ముద్దలు తిన్నా చాలా సంతృప్తి గా అనిపిస్తుంది.',
        },
        {
          title: <span class='highlight'>ప్రకృతికి దగ్గరగా</span>
        },
        {
          title: 'రోజూ రాత్రి 12, 1, 2 గంటలకు పడుకుని ఉదయం 8, 9 గంటలకు లేచి హడావిడిగా ఆఫీస్‌కి పరిగెత్తడం కాకుండా, కొద్దిగా ప్రకృతికి దగ్గరగా జీవించండి. కనీసం ఉదయాన్నే సూర్యకాంతిలో కొద్దిసేపు గడపడం, పార్కులు వంటివి ఉంటే వాటిలో వాకింగ్ చేయడం, అప్పుడప్పుడు వర్షంలో తడవడం, చలికాలం చలిని కొద్దిసేపైనా మనస్ఫూర్తిగా ఆస్వాదించడం.',
        },
        {
          title: 'ఇవన్నీ పరోక్షంగా మనల్ని ప్రకృతికి దగ్గర చేస్తాయి. ఇప్పుడు మనం చాలా మంది భావిస్తున్నట్లు ప్రకృతి మన శత్రువు కాదు. ప్రకృతి నుండి మనల్ని మనం కాపాడుకోవాల్సినంత భయమేమీ లేదు. మనం ప్రకృతికి దూరంగా ఉండటం వల్లే దాన్ని చూసి భయపడాల్సి వస్తోంది.',
        },
        {
          title: <span class='highlight'>లక్ష్యాలు</span>
        },
        {
          title: 'చాలామంది జీవితం నిర్జీవంగా ఉండటానికి ప్రధాన కారణం వారికి తగినంత లక్ష్యాలు లేకపోవడం! ఉదాహరణకు ఈ ఆర్టికల్ రాసేటప్పుడు, ఇది ఎంతమంది ఉపయోగించుకుంటారు అనేదానికన్నా “ఇది నా భావవ్యక్తీకరణను మెరుగుపరుస్తుంది, ఇలాంటివి ఇక వీలున్నప్పుడల్లా రాయాలి” అన్న భావన నన్ను డామినేట్ చేసింది. అందుకే దీన్ని చాలా సంతోషం గా రాస్తున్నాను. ',
        },
        {
          title: 'ఇలా చిన్నవో పెద్దవో, కొన్ని పర్పస్‌లు, లక్ష్యాలు నిర్దేశించుకొని వాటి కోసం పని చేస్తూ పోతే కచ్చితంగా ఆనందం సొంతమవుతుంది. అలా కాకుండా ఆ పని చేస్తే మనకేం వస్తుంది అన్న లెక్కలు వేసుకుంటూ కూర్చుంటే మన ఆనందాన్ని మనం చేజేతులా దూరం చేసుకున్నట్లే! కొన్ని ఆనందాలు నిస్వార్ధంగా పనిచేయడం వలన వస్తాయి.. ఆనందం కోసం స్వార్ధంగా పనిచేసి, డబ్బులు కూడపెట్టుకొని, వాటిని ఖర్చు పెట్టడం ద్వారా తాత్కాలిక ఆనందం పొందాల్సిన ఖర్మ మనకు అవసరం లేదు!',
        }
      ],
      title: 'ఎల్లప్పుడూ సంతోషంగా ఉండడానికి 5 టిప్స్',
    },
    {
      "CatID": [
        {
          title: 'పడమటి కన్నా తూర్పున ఎక్కువ ఖాళీ స్థలం వుండటం - పురుషుని కీర్తి కిరీటం.',
        },
        {
          title: 'దక్షిణం కన్నా ఉత్తరాన ఎక్కువ ఖాళీ స్థలం - సిరులకు, స్త్రీల సుఖాలకు ఆలవాలం.',
        },
        {
          title: 'తూర్పు కన్నా పడమట ఎక్కువ ఖాళీ స్థలం - పురుషుల యోగ్యత విఫలం.',
        },
        {
          title: 'ఉత్తరం కన్నా దక్షిణంలో ఎక్కువ ఖాళీ స్థలం - అన్ని అనర్ధాలకు మూలం.',
        },
        {
          title: 'ఈశాన్యంలో ఖాళీ లేని గేహం - శ్వాస నిలిచిపోయే దేహం (గేహం = ఇల్లు).',
        },
        {
          title: 'విదిక్కుల స్థలం ఇంటికి ఆగ్నేయ వాయవ్యాలలో సమాన ఖాళీ వుంచు - అది నీ ప్రతిష్ఠను పెంచు.',
        },
        {
          title: 'విదిక్కుల స్థలం ఇంటికి అన్నింటికన్నా ఈశాన్యంలో ఖాళీ ఎక్కువ - ఉంటే ధన, కనక వస్తు వాహనాలకు ఉండదు తక్కువ.',
        },
        {
          title: 'తూర్పు స్థలాన్ని కలుపుకో - కీర్తి సంపదలను గెలుచుకో.',
        },
        {
          title: 'ఆగ్నేయ స్థలాన్ని కలపుకోవద్దు - ఆపదలను దాపునకు పిలుచుకోవద్దు.',
        },
        {
          title: 'దక్షిణ స్థలాన్ని కలుపుకోకు - రక్షణ కవచాన్ని కోల్పోకు.',
        },
        {
          title: 'నైఋతి స్థలం వూరకవచ్చినా కలుపుకోకు - కష్టాలను కొని తెచ్చుకోకు.',
        },
        {
          title: 'పశ్చిమ స్థలాన్న కలుపుకోవడం - పచ్చని ఆరోగ్యానికి చిచ్చు పెట్టుకోవడం.',
        },
        {
          title: 'వాయవ్య స్థలాన్ని కలుపుకున్నవారు - మనశ్వాతిని కోల్పోతారు.',
        },
        {
          title: 'ఉత్తర స్థలాన్ని కలుపుకో - ఉత్తమ ఫలాన్ని అందుకో.',
        },
        {
          title: 'ఈశాన్యంలోని స్థలాన్ని కొనడం - విశేష ఐశ్వర్యాలతో వృద్ధిచెందడం.',
        },
        {
          title: 'ఈశాన్యంలో స్థలంపోతే - ఇంట్లో ఇనుపగజ్జెల మోతే (ఇనుపగజ్జెలు దరిద్రానికి గుర్తులు)',
        }
      ],
      title: 'ఖాళీ స్థలాలు వాటి వాస్తు శాస్త్రం',
    },
    {
      "CatID": [
        {
          title: '"అకవాట మానాచ్చన్న మభుక్త బలి భోజనం',
        },
        {
          title: 'గృహం న ప్రవిశేద్ధిమానా పదమా కరంహి తత్"',
        },
        {
          title: 'వాస్తురాజవల్లభం',
        },
        {
          title: 'ద్వారాలులేకుండా, ,పైకప్పులేకుండా,వాస్తుశాంతి,వాస్తుహోమములేకుండా,8 దిక్కులలో బలిలేకుండా,భదువులకు భోజనాలు పెట్టకుండా గృహప్రవేశము చేయరాదు సత్యనారాయణ వ్రతం రోజుయినా భోజనాలు పెట్టాలి.',
        },
        {
          title: 'శాంతికమళాకారము,బృహద్వా స్తుమాలా,ధర్మ సింధు,నిర్ణయసింధూ,కాలామృతము, మొదలైన గ్రంధాలలో గృహప్రవేశము ముందు వాస్తుశాంతులు చేయకుండా యజమాని గృహప్రవేశము చేయరాదని గ్రంధాలు చెబుతున్నాయి.',
        },
        {
          title: 'ఎందుకంటే ఇల్లునిర్మాణము చేసేటప్పుడు క్రిమికీటకాలహింస,చెట్లు నరికినదోషము,అంతర్గత శల్యదోషాలు,ఆయాది దోషము, ముహూర్తదోషము,కాకిప్రవేశ దోషము, భూతప్రేతపిశాచ ప్రవేశము పోవాలంటే వాస్తుదోషాలకు ,తగిన శాంతి హోమాలుచేసి తరువాత శుభమూహర్తంలో గృహప్రవేశము చేయాలి ఇదిశాస్త్రము ఈవిధంగా తెలంగాణ,రాయలసీమ ప్రాంతాలలో కొన్నిప్రాంతాలలో చేస్తారు ఈనాడు గృహప్రవేశాలు మరిదారుణంగా చేస్తున్నారు.',
        },
        {
          title: 'శుభముహూర్త సమయంలో ముందుగా గోవు, దంపతులు గృహంలో కుడికాలుపెట్టి లోపలికి వెళ్ళాలి కానీ ముందు ఫోటోగ్రాఫర్ వెళ్తున్నాడు ఆదిిచెప్పులతో ఇలా అందరుకాదు కొంతమంది గుమ్మందగ్గరే చెప్పులు,బియ్యము గ్లాసు కాలితోతన్ని లోపలికి పోవటం ఇవిిదోషము, సాంప్రదాయవస్త్రాలు ధరించకుండా,ఆడవారు కాలికి పసుపురాయకుండా గృహప్రవేశం చేసేస్తున్నారు,ఆగ్నేయంలో వంటగదిలో పొంగించవలసిన పాలు నట్టింట్లోపొంగించడం చేస్తున్నారు ,సింహద్వారానికి పసుపురాసి బొట్లుపెట్టకుండా,మామిడిఆకులు కట్టకుండా ప్రవేశం చేస్తున్నారు',
        },
        {
          title: 'కొంతమందిపుణ్యాహవాచనము,ఏకాశీతి పదవాస్తుమండపారాధన చేయకుండా పూజముగిస్తున్నారు',
        },
        {
          title: 'గృహప్రధానద్వారాము తలుపులు ముహూర్త సమయానికి తెరిచి ప్రవేశము చేయాలి అంతవరకు మూసిఉంచాలి ప్రవేశం ముందు దుష్టశక్తులు ప్రవేశించకుండా ఉండటానికి రాత్రి గృహప్రవేశము ఐతే ఉదయమునూతన గృహంలో వాస్తుశాంతి చేయవలెను వాస్తుశాంతి రాత్రి,సాయంత్రము చేయరాదు',
        },
        {
          title: 'గృహప్రవేశము,రాత్రి పూట,పగటిపూట చేయవచ్చు ఎక్కువగా పగలు చేయకపోవడానికి కారణము మంచి శకునంకాజాలదని,రాత్రి ఎవ్వరు తిరగరని ఎక్కువగా రాత్రి గృహప్రవేశం చేస్తున్నారు గృహప్రవేశము చేసినవారు రాత్రిఅంతా జాగరణ చేయాలి సూర్యోదయం వరకు నిద్రపోరాదు ఎందుకంటే ఆగృహము కూడా నిద్రావస్థను పొదుతుందని పెద్దలు చేెప్పినారు.',
        },
        {
          title: 'మూడురోజులు తప్పకుండా ఉదయము సాయంత్రము నూతన గృహంలో దీపారాధన చేయవలెను ఒకవేళ మైలసోకిన 5 రోజులు ఆపివేసి మరల చేయవలెను.',
        },
        {
          title: 'పాలు పొంగించడానికి తొడబుట్టిన చెల్లెలులేదా అక్కచేత పాలుపొంగించవలెను వారులేకపోతే పెళ్లయిన కూతురు చేత పాలుపొంగించవలెను వారులేకపోతే సోదరివరస ఐనవారు ఎవరైనా పాలుపొంగించాలి పాలుపొంగించినవారికి పసుపు కుంకుమతో వస్త్రాలు పెట్టవలెను.',
        },
        {
          title: <span class='highlight'>వాస్తుశాంతి పూజ విధానము</span>,
        },
        {
          title: 'గణపతిపూజ,పుణ్యాహవాచనము, పంచగవ్యసంస్కారము,ఏకాశీతి పదమండల వాస్తుపూజ,నవగ్రహ మండపారాధన,లక్ష్మీ గణపతి,రుద్ర,నవగ్రహ,వాస్తు,హోమాలు,వాస్తుపర్యగ్నికరణ, బ్రాహ్మణులకు నవగ్రహ దానాలు మొదలైన పూజలు చేయవలెను.',
        }
      ],
      title: 'గృహప్రవేశము ఎలాచేయాలి ?',
    },
    {
      "CatID": [
        {
          title: 'తక్కువ సమయంలో ధనవంతులు కావాలంటే..* ఇంట్లో ఈ  పనులు చేయండి. నిజంగా ధనవంతులు కావాలంటే లక్ష్మీదేవి కాటాక్షం కావాలి. ధనలక్ష్మి ప్రసన్నం కోసం వాస్తు శాస్త్రం ప్రకారం..ప్రతిరోజూ కొన్ని ప్రత్యేకమైన పనులు చేయాలి  దాంతో ఆ లక్ష్మిదేవి ప్రసన్నమవుతుంది.',
        },
        {
          title: 'ధనవంతులు అవ్వాలనే కోరిక చాలా మందిలో ఉంటుంది. కానీ…. అది అంత సులువేమీ కాదు.. జీవితంలో ప్రతి వ్యక్తి ధనవంతుడిలా బతకాలని కోరుకుంటాడు. అతని ఆరోగ్యం బాగుండాలని, వారికి ఇంట్లో ఎలాంటి లోటు ఉండకూడదని ఆశిస్తాడు. సమాజంలో వారికి సరైన గౌరవం లభించాలని అనుకుంటాడు.',
        },
        {
          title: 'కానీ, అందరూ ఈ కోరికలను తీర్చుకోలేరు. నిజంగా ధనవంతులు కావాలంటే లక్ష్మీదేవి కటాక్షం కావాలి. ధనలక్ష్మి ప్రసన్నం కోసం వాస్తు శాస్త్రం ప్రకారం..ప్రతిరోజూ కొన్ని ప్రత్యేకమైన పనులు చేయాలి దాంతో ఆ లక్ష్మిదేవి ప్రసన్నమవుతుంది. ఆమె అనుగ్రహాన్ని ప్రసాదిస్తుంది. అందులో భాగంగా',
        },
        {
          title: <span class='highlight'>తులసి పూజ:</span>,
        },
        {
          title: 'మీ ఇంట్లో తులసి మొక్క ఉండాలి. ప్రతిరోజు ఉదయం, సాయంత్రం తులసి మొక్కకు నెయ్యి దీపం వెలిగించి నీళ్లు పోసి పూజిస్తే లక్ష్మీదేవి ప్రసన్నమై ఆ కుటుంబంలోని కోరికలన్నీ తీరుస్తుందని  శాస్త్రం చెబుతోంది.',
        },
        {
          title: <span class='highlight'>తూర్పు ముఖంగా తినండి:</span>,
        },
        {
          title: 'మీరు ఆహారం తీసుకునేటప్పుడు.. తూర్పు దిశగా చూస్తూ భోజనం చేసేలా ప్రయత్నించండి. ఈ దిశ సూర్య భగవానుడికి అంకితం చేయబడింది. పవిత్రమైనదిగా పరిగణించబడుతుంది. భోజనం చేసేటప్పుడు చెప్పులు వేసుకోవద్దు, లేకుంటే అన్నపూర్ణ ఆగ్రహం వస్తుంది.',
        },
        {
          title: <span class='highlight'>ఈశాన్యంలో గంగాజలం:</span>,
        },
        {
          title: 'ఇంటి ఈశాన్య కోణం అత్యంత శుభప్రదంగా పరిగణించబడుతుంది. మీరు క్రమం తప్పకుండా గంగా జలాన్ని ఈశాన్యంలో చల్లుకోవాలి. లేదా బోరింగ్ సంపు, నుయ్యి, వంటి వాటిని ఏర్పాటు చేసుకోవాలి.',
        }
      ],
      title: 'ముఖ్యమైన వాస్తు విషయములు',
    },

  ],
  "MasamVisistatha": [
    {
      "CatID": [
        {
          title: <span class='highlight'>తెలుగు నెలలు (తెలుగు మాసములు) విశిష్టత :</span>,
        },
        {
          title: 'తెలుగు నెలలు పన్నెండు. ప్రతి నెల శుక్ల పక్ష పాడ్యమి (అమావాస్య తర్వాత వచ్చే తిథి) తో మొదలై అమావాస్యతో ముగుస్తుంది.',
        },
        {
          title: 'ప్రతి నెలలో రెండు పక్షాలు ఉంటాయి.',
        },
        {
          title: '1. శుక్ల పక్షం లేదా శుద్ధ పక్షం (ప్రతి నెల మొదటి తిథి పాడ్యమి నుంచి పున్నమి వరకు): రోజు రోజుకూ చంద్రుడి తో పాటు వెన్నెల పెరిగి రాత్రుళ్ళు తెల్లగా, కాంతివంతంగా అవుతాయి. (శుక్ల అంటే తెల్లని అని అర్థం ).',
        },
        {
          title: '2. కృష్ణ పక్షం లేదా బహుళ పక్షం (ప్రతి నెల పున్నమి తరువాత వచ్చే పాడ్యమి తిథి నుంచి అమావాస్య వరకు): రోజు రోజుకూ చంద్రుడి తో పాటు వెన్నెల తరిగి రాత్రుళ్ళు నల్లగా చీకటితో నిండుతాయి. (కృష్ణ అంటే నల్లని అని అర్థం).',
        },
        {
          title: 'తెలుగు నెలలు',
        },
        {
          title: '1. చైత్రము',
        },
        {
          title: '2. వైశాఖము',
        },
        {
          title: '3. జ్యేష్ఠము',
        },
        {
          title: '4. ఆషాఢము',
        },
        {
          title: '5. శ్రావణము',
        },
        {
          title: '6. భాద్రపదము',
        },
        {
          title: '7. ఆశ్వయుజము',
        },
        {
          title: '8. కార్తీకము',
        },
        {
          title: '9. మార్గశిరము',
        },
        {
          title: '10. పుష్యము',
        },
        {
          title: '11. మాఘము',
        },
        {
          title: '12. ఫాల్గుణము',
        },
        {
          title: 'ఈ నెలల పేర్లు ఒక్కో నక్షత్రం పేరు మీద ఒక్కొక్క నెల ఏర్పడినట్లు సులభంగా గుర్తించవచ్చు.',
        },
        {
          title: 'పౌర్ణమి రోజున చిత్తా నక్షత్రం (అనగా చంద్రుడు చిత్తా * నక్షత్రం తో కలిసిన రోజు) అయితే ఆ నెల చైత్రము.',
        },
        {
          title: 'పౌర్ణమి రోజున విశాఖ నక్షత్రం (అనగా చంద్రుడు విశాఖ నక్షత్రం తో కలిసిన రోజు) అయితే ఆ నెల వైశాఖము.',
        },
        {
          title: ' పౌర్ణమి రోజున జ్యేష్ఠ నక్షత్రం (అనగా చంద్రుడు జ్యేష్ఠా నక్షత్రం తో కలిసిన రోజు) అయితే ఆ నెల జ్యేష్ఠము.',
        },
        {
          title: 'పౌర్ణమి రోజున పూర్వాషాఢ నక్షత్రం (అనగా చంద్రుడు పూర్వాషాఢా నక్షత్రం తో కలిసిన రోజు)అయితే ఆ నెల ఆషాఢము.',
        },
        {
          title: 'పౌర్ణమి రోజున శ్రవణం నక్షత్రం (అనగా చంద్రుడు శ్రవణం నక్షత్రం తో కలిసిన రోజు) అయితే ఆ నెల శ్రావణము.',
        },
        {
          title: 'పౌర్ణమి రోజున పూర్వాభాద్ర నక్షత్రం (అనగా * చంద్రుడు పూర్వాభాద్రా నక్షత్రం తో కలిసిన రోజు)అయితే ఆ నెల భాద్రపదము.',
        },
        {
          title: 'పౌర్ణమి రోజున అశ్వని నక్షత్రం (అనగా చంద్రుడు * అశ్వనీ నక్షత్రం తో కలిసిన రోజు) అయితే ఆ నెల ఆశ్వయుజము.',
        },
        {
          title: 'పౌర్ణమి రోజున కృత్తిక నక్షత్రం (అనగా చంద్రుడు కృత్తికా నక్షత్రం తో కలిసిన రోజు) అయితే ఆ నెల కార్తీకము.',
        },
        {
          title: 'పౌర్ణమి రోజున మృగశిర నక్షత్రం (అనగా చంద్రుడు మృగశిరా నక్షత్రం తో కలిసిన రోజు) అయితే ఆ నెల మార్గశిరము.',
        },
        {
          title: 'పౌర్ణమి రోజున పుష్యమి నక్షత్రం (అనగా చంద్రుడు పుష్యమీ నక్షత్రం తో కలిసిన రోజు) అయితే ఆ నెల పుష్యము.',
        },
        {
          title: 'పౌర్ణమి రోజున మఖ నక్షత్రం (అనగా చంద్రుడు మఖా నక్షత్రం తో కలిసిన రోజు) అయితే ఆ నెల మాఘము.',
        },
        {
          title: 'పౌర్ణమి రోజున ఉత్తరఫల్గుణి (ఉత్తర) నక్షత్రం (అనగా చంద్రుడు ఉత్తరఫల్గుణీ నక్షత్రం తో కలిసిన రోజు)అయితే ఆ నెల ఫాల్గుణము.',
        }
      ],
      "title": 'తెలుగు నెలలు (తెలుగు మాసములు) విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>చైత్ర మాసం విశిష్టత :</span>,
        },
        {
          title: 'ఋతూనాం కుసుమాకరాం అని భగవానుడు స్వయంగా తానే వసంత ఋతువునని భగవద్గీతలో చెప్పుకున్న వసంత ఋతువులో తొలి మాసం చైత్రమాసం.',
        },
        {
          title: 'సంవత్సరానికి తొలి మాసం కూడా. చైత్రమాసం అనగానే మనకి ఉగాది, శ్రీరామనవమి గుర్తుకొస్తాయి.',
        },
        {
          title: 'అవే కాదు, దశావతారాలలో మొదటిది అయిన మత్స్యావతారం, యజ్ఞ వరాహమూర్తి జయంతి, సౌభాగ్యగౌరీ వ్రతం వంటి విశిష్టమైన రోజులెన్నో ఈ మాసంలోనే ఉన్నాయి.',
        },
        {
          title: 'అలా చైత్ర మాసం సంవత్సరానికి మొదటి నెలగా మాత్రమే కాక, అనేక ఆధ్యాత్మిక, పౌరాణిక విశిష్టతలు కలిగిన మాసం కూడా.',
        },
        {
          title: 'ఈ మాసంలో చంద్రుడు పౌర్ణమినాడు చిత్త నక్షత్రంతో కూడి ఉంటాడు. సూర్యుడు కూడా మొదటిరాశియైన మేషరాశిలో సంచరిస్తున్నాడు.',
        },
        {
          title: 'ప్రభవ నామ సంవత్సరంతో ప్రారంభమైన తెలుగు సంవత్సరాలు అక్షయతో ముగుస్తాయి.',
        },
        {
          title: 'అంటే మనిషి పుట్టిన సంవత్సరం నుంచి తిరిగి అరవై ఏళ్ల తర్వాత అదే సంవత్సరం మొదలువుతుంది.',
        },
        {
          title: 'అప్పటి నుంచి మళ్లీ బాల్యావస్థ మొదలవుతుంది.',
        },
        {
          title: 'అంటే చిన్న పిల్లల్లా ప్రవర్తిస్తుంటారు. అకారణంగా అలగడం, అవీ.. ఇవీ తినాలని అడగటం, చిన్న చిన్న దొంగతనాలు చేయటం, ఎక్కువసేపు నిద్రపోవటం, చిన్న విషయాలకే ఆనంద పడటం, కోపం తెచ్చుకోవటం, కన్నీళ్లు పెట్టుకోవడం ఇలాంటి బాల్య చేష్టలన్నీ అరవైఏళ్ల నుంచి నెమ్మదిగా ప్రారంభమవుతాయి.',
        },
        {
          title: 'ప్రతి కొడుకూ అరవై సంవత్సరాలు వచ్చిన నాటి నుంచి తన తండ్రిని తన బిడ్డలతో సమానంగా చూసుకోవాలని ధర్మశాస్త్రం చెబుతోంది.',
        },
        {
          title: 'ఆరుపదుల జీవితాన్ని ఎవరైతే ఆనందంగా జీవిస్తారో వారి జీవితం ధన్యం. ఆ ధన్యజీవితపు జ్ఞాపకార్థమే బిడ్డలు, మనవళ్లు బంధువులు మిత్రులు కలిసి షష్టిపూర్తి చేస్తారు.',
        },
        {
          title: 'ఇక ధర్మశాస్త్రం ప్రకారం చూసుకుంటే కృత, త్రేతా, ద్వాపర యుగాల్లో మానవ ఆయుర్దాయం 180 సంవత్సరాలు.',
        },
        {
          title: 'కలియుగానికి వచ్చే సరికి కలి ప్రభావంతో 120 సంవత్సరాలకు పడిపోయింది.',
        },
        {
          title: 'అందుకే 60ఏళ్లు పూర్తవగానే షష్టి పూర్తి చేస్తారు. అంటే దీనర్థం. మొదటి 60ఏళ్లు పూర్తవగానే లోక సంబంధ విషయాలు పూర్తయినట్లు భావించాలి.',
        },
        {
          title: 'మిగిలిన 60ఏళ్లు ఆధ్యాత్మిక చింతనతో బతకాలని ధర్మశాస్త్రం చెబుతోంది.',
        },
        {
          title: 'పురాణ గాథ! :',
        },
        {
          title: 'ఒకానొక సమయంలో నారద మునీంద్రుడు తానంత గొప్ప భక్తుడు లేడని, ఆ గర్వంతో విర్ర వీగుతున్నాడట. అప్పుడు శ్రీమహా విష్ణుడు అతడికి జ్ఞాన బోధ చేయాలని తలంచాడు.',
        },
        {
          title: 'దీంతో నారదుడిని మాయ ఆవరించేలా చేసి ఒక సరస్సు తీసుకెళ్లి అందులో దిగి స్నానం చేయమన్నాడు. నారదుడు అందులో దిగి స్నానం చేయగానే, ఒక్కసారి పూర్వ స్మృతిని మర్చిపోయి, స్త్రీ రూపం ఎత్తాడు.',
        },
        {
          title: 'అదే సమయంలో దారితప్పి అక్కడకు వచ్చిన ఓ మహారాజును చూసి మోహించి, వివాహం చేసుకుని 60మంది పిల్లలను కన్నాడు.',
        },
        {
          title: 'వారే.. ప్రభవ.. విభవ.. శుక్ల.. చివరిగా అక్షయ. వారంతా ఒకరి తర్వాత ఒకరు యుద్ధంలో మరణిస్తుండటంతో పుత్రశోకంతో ఉండిపోయాడు.',
        },
        {
          title: 'సంసార సాగరంలో మునిగిపోయి అసలు తానెవరో మర్చిపోయాడు. అప్పుడు నారదుడిని ఆవరించిన మాయను శ్రీహరి తొలగించి, ఇదీ సంసారం అంటే నీవు ఏదో గొప్ప భక్తుడవని భావిస్తున్నావు. అని జ్ఞానబోధ చేశాడట.',
        },
        {
          title: 'నీ పిల్లలు 60 సంవత్సరాలుగా కాలచక్రంలో తిరుగుతుంటారు అని విష్ణుమూర్తి వరమిస్తాడు. అవే మన తెలుగు సంవత్సరాలుగా ప్రస్తుతం వాడుకలో ఉన్నాయి.',
        }
      ],
      "title": 'చైత్ర మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>వైశాఖ మాసం విశిష్టత :</span>,
        },
        {
          title: 'వైశాఖ మాసానికి మరో పేరు మాధవ మాసం. మాసాలన్నింట్లో వైశాఖమాసం ఉత్తమమైనది. విశేషదానాలకి ఎంతో పుణ్య ప్రదమైన మాసంగా పురాణాలలో చెప్పబడింది. శ్రీ మహా విష్ణువు కు ప్రీతి కరమైన ఈ వైశాఖ మాసం లో తులసి దళాలతో శ్రీ మహావిష్ణువును లక్ష్మీదేవితో కలిపి పూజించిన వారికి ముక్తి దాయకం.',
        },
        {
          title: 'ఈ మాసం లో ఏక భుక్తం , నక్తం అయాచితం గా భుజించడం ఉత్తమం గా చెప్పబడింది. వైశాఖ మాసం దేవతలతో సహా అందరికీ పూజనీయమైనది. యజ్ఞాలకు , తపస్సులకు పూజాదికాలకు , దాన ధర్మాలకు ఎంతో ఎక్కువ ఫలమిచ్చి శాంతినిచ్చి కోరికలను తీరుస్తుంది.',
        },
        {
          title: 'ఎవరైతే ఈ మాసం లో సూర్యోదయానికి ముందే లేచి స్నానం చేస్తారో, వారికి ఉత్తమగతులు కలుగుతాయి. ఉదయాన్నే స్నానం చేసి ఎక్కువ నీటి తో రావి చెట్టు మొదళ్ళను తడిపి ప్రదక్షిణాలు చేస్తే పూర్వీకులంతా తరిస్తారు. ఈ మాసం లో శివునికి ధారపాత్ర ద్వారా అభిషేకం జరిగేలా ఏర్పాటు చేయడం శుభ ఫలితాలనిస్తుంది.',
        },
        {
          title: 'మన సంస్కృతి ఉత్కృష్టమైనది. మనకు ఈ ప్రకృతి అందులోని చరాచరాలన్ని పూజనీయాలే ! అంతేకాకుండా మనం కాలగణనకు ఉపయోగించే తిథులు , నక్షత్రాలు , వారాలు , మాసాలు అన్నీ ఎంతో గొప్పదనాన్ని , ప్రత్యేకతను సంతరించుకున్నటువంటివే.',
        },
        {
          title: 'చాంద్రమానం పాటించే మనకు చైత్రం మొదలుకుని ఫాల్గుణం వరకు పన్నెండు నెలలు ఉన్నాయి. ఒక్కో మాసానికి ఒక్కో ప్రత్యేకత, విశిష్టత ఉన్నాయి.',
        },
        {
          title: 'కార్తీక, మాఘ మాసాల తర్వాత అంతటి మహత్యాన్ని స్వంతం చేసుకున్న పుణ్యప్రదమైన మాసం వైశాఖం. ఈ నెలలోనే పూర్ణిమ తిథినాడు విశాఖ నక్షత్రం ఉండడం వల్ల ఈ మాసానికి వైశాఖమాసం అనే పేరు ఏర్పడింది.',
        },
        {
          title: 'ఆద్యాత్మికత , పవిత్రత , దైవశక్తి ఉన్న నెలల్లో వైశాఖమాసానికి ప్రత్యేక స్థానం ఉంది.',
        },
        {
          title: 'ఇది శ్రీ మహావిష్ణువుకు అత్యంత ప్రీతిపాకరమైన నెల. అందువల్లనే వైశాఖమాసానికి మాధవమాసం అని పేరు. అత్యంత పవిత్రమైన మాసంగా పేరుపొందిన వైశాఖమాస మాహత్మ్యంను పూర్వం శ్రీమహావిష్ణువు స్వయంగా శ్రీమహాలక్ష్మికి వివరించినట్టు పురాణాలు పేర్కొంటున్నాయి. అత్యంత పవిత్రమైన మాసంగా చెప్పబడుతూ ఉన్న వైశాఖమాసంలో ప్రతి దినమూ పుణ్యదినమే',
        },
        {
          title: 'అటువంటి ముప్పై పుణ్యదినాలు కలిగిన ఈ మాసంలో ఆచరించాల్సిన విధులు పురాణ గ్రంధాల్లో వివరించబడ్డాయి. ముఖ్యంగా స్నాన , పూజ , దానధర్మాల వంటి వాటిని ఈ నెలలో ఆచరించడం వల్ల మానవుడికి ఇహలోకంలో సౌఖ్యం , పరలోకంలో మోక్షం సిద్ధిస్తాయని పురాణ కథనం.',
        },
        {
          title: 'వైశాఖమాసంలో నదీ స్నానం ఉత్తమమైనదిగా చెప్పబడింది. అందుకు అవకాశం లేని స్థితిలో గంగ , గోదావరి వంటి పుణ్యనదులను స్మరించుకుంటూ కాలువల్లోగానీ , చెరువులోగాని , బావుల వద్దగానీ అదీ కుదరకపోతే ఇంట్లోనే స్నానం చేయాలి. నీటియందు సకల దేవతలు కొలువుతీరి ఉంటారని పురాణాలు చెబుతున్నాయి.',
        },
        {
          title: 'వైశాఖమాసంలో సూర్యుడు మేషరాశిలో సంచరిస్తూ ఉంటాడు. కనుక ఎండలు అధికంగా ఉండి మానవులను ఇబ్బందులను గురిచేస్తూ ఉంటాయి. కనుక వేడిమినుంచి ఉపసమనం కలిగించేవాటిని దానం ఇవ్వాలనేది శాస్త్రవచనం.  నీరు , గొడుగు , విసనకర్ర , పాదరక్షలు వంటివి దానం చేయడం శ్రేష్టం. అట్లే దాహంతో ఉన్నవారికి మంచినీటిని ఇవ్వడం , చలివేంద్రాలను ఏర్పాటు చేయడం వల్ల దేవతానుగ్రహం కలుగుతుంది.',
        },
        {
          title: 'సంధ్యావందనాలు ఆచరించడంతో పాటు శ్రీమహావిష్ణువును తులసీదళాలతో పూజించవలెను. శ్రీమహావిష్ణువు వైశాఖమాసం మొదలుకొని మూడునెలలపాటు  ఈ భూమి మీద విహరిస్తూ ఉంటాడు. అతనికి అత్యంత ప్రీతికరమైన తులసీదళములతో అర్చించడం వల్ల సంతుష్టుడై సకల సౌభాగ్యాలను, సౌఖ్యాన్ని ప్రసాదిస్తాడని చెప్పబడుతున్నది.',
        }
      ],
      "title": 'వైశాఖ మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>జ్యేష్ఠ మాసం విశిష్టత :</span>,
        },
        {
          title: 'తెలుగువారు చంద్రమానం అనుసరిస్తారు కాబట్టి కొత్త ఏడాది ఛైత్రంతో ప్రారంభమై పాల్గుణంతో ముగుస్తుంది. తెలుగు నెలల్లో మూడోది జ్యేష్ఠం.',
        },
        {
          title: 'ఛైత్ర , వైశాఖం తర్వాత వచ్చే జ్యేష్ఠ మాస పుణ్య కాలంలో చేసే పూజలు , జపాలు , పారాయణాదులకు విశేష ఫలముంటుందని శాస్త్రాలు పేర్కొంటున్నాయి. జ్యేష్ఠంలో విష్ణుసహస్రనామ పారాయణం అనంత ఫలాన్నిస్తుంది.',
        },
        {
          title: 'అలాగే ఈ మాసంలో జలదానం చేయడం చాలా ఉత్తమం. జ్యేష్ఠశుద్ద తదియనాడు రంభా తృతీయగా జరుపుకుంటారు. ఈ రోజున ప్రత్యేకంగా పార్వతి దేవిని పూజించడమే కాదు, దానాలకు శుభకాలం. ముఖ్యంగా అన్న దానం చేయడం ఉత్తమం.',
        },
        {
          title: 'జ్యేష్ఠశుద్ద దశమిని *దశపాపహర దశమి* అంటారు. అంటే పది రకాల పాపాలను పోగొట్టే దశమి అని అర్ధం. పాపాలను హరించే శక్తి కలిగిన దశమి రోజున గంగా స్నానం , లేదా ఏదైనా నది లో పదిసార్లు మునకేస్తే మంచి ఫలితాన్నిస్తుంది.',
        },
        {
          title: 'నల్ల నువ్వులు , నెయ్యి , పేలపిండి , బెల్లం నదిలో వేయాలి. అలాగే చేపలు , కప్పలు , తాబేలు లాంటి జలచరాల రజత ప్రతిమలను నీటిలో వదలడం విశేష పుణ్యదాయకం. ఈ రోజున ఇష్ట దైవాన్ని పూజించే , ఆలయాల సందర్శిస్తే శుభం జరుగుతుంది.',
        },
        {
          title: 'జ్యేష్ఠ శుద్ద ఏకాదశినే *నిర్జల ఏకాదశి* అనే పేరుతోనూ పిలుస్తారు. ఏకాదశి వ్రతాన్ని ఆచరించి పెసరపప్పు , పాయసం , పానకం , నెయ్యి , గొడుగు దానం చేయాలని శాస్త్రాలు తెలియజేస్తున్నాయి. నిర్జల ఏకాదశి వ్రతాన్ని ఆచరిస్తే 12 ఏకాదశులను ఆచరించిన ఫలితం దక్కుతుంది.',
        },
        {
          title: 'జ్యేష్ఠ శుద్ద ద్వాదశిని దశహరా అంటారు. ఇది దుర్దశలను పోగొట్టగలిగే శక్తి కలిగిన తిథి. ఈరోజు నది స్నానాలు చేయాలి. అలాంటి అవకాశంలేనప్పుడు ఇంట్లో స్నానమాచరించే సమయంలో గంగా దేవిని స్మరించడం ఉత్తమం. *జ్యేష్ఠ పూర్ణిమను మహాజ్యేష్టి* అంటారు. ఈ రోజున తిలలు దానం చేసిన వారికి ఆశ్వమేథయాగం చేసిన ఫలితం లభిస్తుంది.',
        },
        {
          title: 'జ్యేష్ఠ నక్షత్రంతో కూడిన జ్యేష్ఠ మాసంలో గొడుగు, చెప్పులు దానం చేసిన వారికి ఉత్తమగతులతో పాటు ఐశ్వర్యం ప్రాప్తిస్తాయని విష్ణు పురాణం తెలిపింది. వామన ప్రీతికి విసనకర్ర , జల కలశం , మంచి గంధం దానం చేయాలి. ఈ పౌర్ణమినే ఏరువాక పున్నమి పేరుతో జరుపుకుంటారు. ఇది రైతుల పండుగ.. ఎద్దులను అలంకరించి పొంగలి పెట్టి , ఉరేగింపుగా పొలాల వద్దకు తీసుకెళ్లి దుక్కి దున్నిస్తారు.',
        },
        {
          title: 'జ్యేష్ఠ పౌర్ణమి తర్వాత పదమూడో రోజున మహిళలు *వటసావిత్రి* వ్రతం చేసుకుంటారు. భర్తలు పది కాలాల పాటు సంపూర్ణ ఆరోగ్యంతో దీర్ఘాయుష్మంతులు కావాలని మనసార కోరుకుంటూ ఈ పూజ చేస్తారు.',
        },
        {
          title: 'జ్యేష్ఠ బహుళ ఏకాదశిని *అపర ఏకాదశి, సిద్ద ఏకాదశి అని కూడా అంటారు. ఈ రోజున ఏకాదశి వ్రతం ఆచరించడం వల్ల అనుకున్న పనులు నేరవేరుతాయి. జ్యేష్ఠ బహుళ చతుర్దశి మాస శివరాత్రి ప్రదోష కాలంలో శివునికి అభిషేకం , బిల్వదళాలతో పూజిస్తే అకాల మృత‌్యుహరణం , యశస్సు కీర్తి , ఆరోగ్యం లభిస్తాయి.',
        }
      ],
      "title": 'జ్యేష్ఠ మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>ఆషాఢ మాసం విశిష్టత :</span>,
        },
        {
          title: 'ఆషాఢ మాసము తెలుగు సంవత్సరంలో నాలుగవ నెల. ఈ నెలలో పౌర్ణమినాడు చంద్రుడు ఉత్తరాషాఢ/పూర్వాషాఢ నక్షత్రాల సమీపంలోనికి వచ్చే నెల. ఉత్తరాయణ పుణ్యకాలం పూర్తయి సూర్యుడు మిథునరాశి నుంచి కర్కాటకరాశి లోనికి ప్రవేశిస్తాడు.',
        },
        {
          title: 'దాంతో దక్షిణాయనం మొదలవుతుంది. ఆషాఢ శుద్ధ ఏకాదశి నాడు విష్ణువు పాలకడలిపై యోగనిద్రలోకి వెళ్ళే సందర్భాన్ని తొలిఏకాదశిగా పరిగణిస్తారు. ఆషాఢ శుద్ధ పౌర్ణమి రోజును గురుపౌర్ణమిగా వ్యవహరిస్తారు. మహాభాగవతాన్ని రచించిన వేద వ్యాసుడు జన్మించిన రోజును వ్యాసపౌర్ణమి అని కూడా అంటారు. వ్యాసుడు వేదాల్ని నాలుగు భాగాలుగా విభజించిన రోజు కూడా ఇదేనంటారు.',
        },
        {
          title: 'అధిక ఆషాఢ మాసము వచ్చిన సంవత్సరం పూరీ జగన్నాధ ఆలయంలోని మూలవిరాట్టుల్ని ఖననం చేసి కొత్త దారు విగ్రహాలు చేయిస్తారు. దీన్ని నవకళేబర ఉత్సవం అంటారు.',
        },
        {
          title: <span class='highlight'>విశేషాలు :</span>,
        },
        {
          title: 'ఆడవారు ఒక్కసారైనా ఈ మాసంలో గోరింటాకు పెట్టుకుంటారు.',
        },
        {
          title: 'ఆహారంలో మునగకాయను విరివిగా వాడాలంటారు.',
        },
        {
          title: 'శుద్ధ ఏకాదశినే మహా ఏకాదశి అని కూడా అంటారు. దీన్నే ప్రథమైకాదశి అని కూడా అంటుంటారు. తెలుగునాట ఇది తొలి ఏకాదశి. పేలపిండి తింటారు.',
        },
        {
          title: 'ఈ మాసంలో ఇంద్రియ నిగ్రహంతో ఆహార విహారాలలో తగిన జాగ్రత్తను తీసుకుంటూ జీవితాన్ని గడపటం కోసం పూజలు, వ్రతాలుతో, నవ దంపతులకు ఆషాఢ నియమం పాటించమని చెబుతారు.ఆషాఢమాసంలో నవదంపతులు కలవకూడదనే ఆచారాన్ని మనదేశంలోని హైందవేతర మతస్తులు కూడా కొన్నిచోట్ల పాటిస్తుంటారు.',
        },
        {
          title: 'హైదరాబాదు, సికింద్రాబాదు, తెలంగాణ, రాయలసీమలోని కొన్ని ప్రాంతాలలో ఆషాఢ మాసంలో బోనాలు పండుగ జరుపుకోబడుతుంది.',
        },
        {
          title: 'దీనిని అమ్మవారికి నివేదన చేసే పర్వదినాన్నే బోనాలు అంటారు. ముఖ్యంగా గ్రామీణ ప్రాంతంలో ఈ పండుగ అత్యంత వైభవం గా జరుపుకొంటారు. సమస్త జగత్తుకు కారణమైనటువంటి అమ్మవారిని భక్తి శ్రద్దలతో పూజిస్తారు. అన్నం, బెల్లం, పెరుగు, పసుపు నీళ్ళు, వేపాకులు ఈ బోనం లో ఉంటాయి. ఇవన్నీ కూడా ఆరోగ్యానికి హానికలిగించే వ్యాదుల నుండి ఉపకరించేవి. ఈ సమయం లో ప్రకృతి లో జరిగే మార్పుల వలన అనారోగ్యాలపాలు కాకుండా ఇవి ఎంతో మేలు చేస్తాయి.',
        },
        {
          title: 'ఆషాఢ మాసంలో యువతులు గోరింటాకు తప్పక పెట్టుకోవాలని పెద్దలు పేర్కొంటారు. గోరింటాకుకు మన సంప్రదాయంలో ప్రత్యేక స్థానం ఉంది.',
        }
      ],
      "title": 'ఆషాఢ మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>శ్రావణ మాసం విశిష్టత :</span>,
        },
        {
          title: 'లక్ష్మీ ప్రదమైన మాసం "శ్రావణ మాసం"',
        },
        {
          title: ' స్థితికారుడు అయిన శ్రీమహావిష్ణువుకు, ఆయన దేవేరి అయిన శ్రీమహాలక్ష్మికి అత్యంత ప్రీతికరమైనది ఈ శ్రావణ మాసం. అనేక రకములైన వ్రతములు, నోములు పూజలు ఆచరించడం వలన విశేష ఫలితాలను, సకల సౌభాగ్యాలను ప్రసాదించే దివ్యమైన మాసమే “శ్రావణ మాసం“.',
        },
        {
          title: 'చాంద్రమానం ప్రకారం తెలుగు మాసాలలో చైత్రం లగాయత్తు చూస్తే, శ్రావణ మాసం ఐదవ మాసం. పౌర్ణమి నాడు చంద్రుడు శ్రవణ నక్షత్రంలో ఉంటాడు కనుక దీనికి శ్రావణ మాసం అని పేరు. శ్రీ మహావిష్ణువు జన్మ నక్షత్రం అయిన శ్రావణ నక్షత్రం పేరుతో ఏర్పడిన శ్రావణమాసంలో శ్రీమహావిష్ణువుకు చేసే పూజలు అనంత పుణ్యములను ఇస్తాయి.',
        },
        {
          title: 'శ్రావణమాసం మహిళలకు ఏంతో పవిత్రమైన మాసం. మహిళలు పాటించే వ్రతాలలన్నింటిలో ఎక్కువ వ్రతాలు ఈ మాసంలో ఉండడంవల్ల దీనిని వ్రతాలమాసమని, సౌభాగ్యాన్ని ప్రసాదించే మాసమని కూడా పేర్కొనబడింది.',
        },
        {
          title: <span class='highlight'>శ్రావణ మాసంలో విశేష పర్వదినములు :</span>,
        },
        {
          title: 'మంగళగౌరీ వ్రతం',
        },
        {
          title: 'వరలక్ష్మీ వ్రతం',
        },
        {
          title: 'నాగచతుర్థి',
        },
        {
          title: 'పుత్రదా ఏకాదశి',
        },
        {
          title: 'రాఖీ పూర్ణిమ',
        },
        {
          title: 'హయగ్రీవ జయంతి',
        },
        {
          title: 'రాఘవేంద్ర జయంతి',
        },
        {
          title: 'శ్రీ కృష్ణాష్టమి',
        },
        {
          title: 'కామిక ఏకాదశి',
        },
        {
          title: 'పోలాల అమావాస్య',
        },
        {
          title: <span class='highlight'>మంగళగౌరీ వ్రతం :</span>,
        },
        {
          title: 'శ్రావణ మాసం మందు ఆచరించ వలసిన వ్రతములలో మొదటిది ఈ మంగళగౌరీ వ్రతం. ఈ నెలలో వచ్చే నాలుగు మంగళవరాలు మంగళ గౌరీని పూజించాలి. పార్వతి దేవికి మరొక పేరు (గౌరీ ) మంగళ గౌరీ. సాధారణంగా కొత్తగా పెళ్ళయిన ముత్తైదువలు ఈ వ్రతాన్ని చేస్తారు. ఈ వ్రతాన్ని ఆచరించడం వల్ల మహిళలకు సౌభాగ్యకరమైన ఐదవతనం కలకాలం నిలుస్తుందని ప్రతీతి. ఈ వ్రతాన్నిగురించి స్వయంగా శ్రీ కృష్ణుడు ద్రౌపదికి వివరించినట్లు పురాణాలు పేర్కొన్నాయి.',
        },
        {
          title: <span class='highlight'>వరలక్ష్మీ వ్రతం :</span>,
        },
        {
          title: 'శ్రావణ మాసం లో మహిళలకు అతి ముఖ్యమైన ప్రధానమైన వ్రతం శ్రీ వరలక్ష్మీ వ్రతం. దీనిని పూర్ణిమ ముందు వచ్చే శుక్రవారం ఆచరింపవలెను. ఈ రోజున వరలక్ష్మీ దేవతను పూజిస్తే అష్టలక్ష్మీ పూజలకు సమానం అనే నమ్మకంతో కుటుంబ సభ్యులు కూడా పాలుపంచుకుంటారు. ఈ దేవతను పూజిస్తే అష్టైశ్వర్యాలు అయిన సంపద, భూమి, శిక్షణ, ప్రేమ, కీర్తి, శాంతి, సంతోషం మరియు శక్తి వంటివి లభిస్తాయని ప్రగాఢ విశ్వాసం.',
        },
        {
          title: <span class='highlight'>శుక్లచవితి-నాగచతుర్థి :</span>,
        },
        {
          title: 'దీపావళి తర్వాత జరుపుకొనే నాగులచవితి లాగ, మన రాష్ట్రంలోని కొన్ని ప్రాంతాలందు ఈరోజుని నాగులచవితి పండుగలా నాగాపుజలను చేస్తారు. రోజంతా ఉపవాసం ఉండి పుట్ట వద్దకు వెళ్ళి పాలు పోసి, నాగ దేవతను పూజిస్తారు. దుర్వాయుగ్మ వ్రతం చేయడానికి కుడా విశేషమైన రోజు ఈ శుక్ల చవితి.',
        },
        {
          title: <span class='highlight'>శుక్ల ఏకాదశి-పుత్రదా ఏకాదశి :</span>,
        },
        {
          title: 'శ్రావణశుద్ధ ఏకాదశిని పుత్రదా ఏకాదశి లేదా లలిత ఏకాదశి అంటారు. ఆరోజున గొడుగు దానమిస్తే విశేష ఫలితాన్ని పొందవచ్చు. పుత్ర సంతానాన్ని కోరుకొనేవారు ఈనాడు ఏకాదశీ వ్రతాన్ని ఆచరించడం మంచిది.',
        },
        {
          title: <span class='highlight'>శ్రావణ పూర్ణిమ – రాఖీపూర్ణిమ :</span>,
        },
        {
          title: 'అన్న/తమ్ముని శ్రేయస్సుని కోరుతూ అక్కాచెల్లెళ్ళు సోదరుని చేతికి రాఖీ కట్టే పండుగే ఈ రాఖీ పూర్ణిమ. సోదరునికి రాఖీ కట్టి, నుదుట బొట్టు పెట్టి అనంతరం మిఠాయిలను తినిపిస్తారు. సోదరుడు సోదరిని ఆశీర్వదించి కానుకలివ్వడం ఆనవాయితీ. ఈ రోజునే బ్రాహ్మణ, క్షత్రియ & వైశ్యులు తమ పాత యజ్ఞోపవీతాన్ని విసర్జించి కొత్తది ధరించడం ఆచారం. అందుచేత ఈ రోజుని జంధ్యాల పూర్ణిమ అనికూడా అంటారు.',
        },
        {
          title: <span class='highlight'>పూర్ణిమ – హయగ్రీవ జయంతి :</span>,
        },
        {
          title: 'ఈరోజునే శ్రీమహావిష్ణువు వేదాలను రక్షించేందుకు హయగ్రీవ రూపం ధరించినట్లు పురాణాలు చెబుతున్నాయి. హయగ్రీవుడు జన్మించిన ఈ రోజుని హయగ్రీవ జయంతిగా జరుపుకొని, హయగ్రీవుడిని పూజించి శనగలు, ఉలవలతో గుగ్గిళ్ళు చేసి నైవేద్యం సమర్పించడం సర్వ శ్రేష్టం.',
        },
        {
          title: <span class='highlight'>కృష్ణవిదియ - శ్రీ రాఘవేంద్రస్వామి జయంతి :</span>,
        },
        {
          title: 'మంత్రాలయంలో శ్రీ గురు రాఘవేంద్రస్వామి జయంతిని పురస్కరించుకొని విశేష పూజలను చేస్తారు. అంతే కాదు. క్రీ.శ.1671 వ సంవత్సరంలో విరోధికృత్ నామ సంవత్సర, శ్రావణ బహుళ విదియనాడు శ్రీ రాఘవేంద్రస్వామి వారు సజీవంగా సమాధిలో ప్రవేశించారని ప్రాచీన గ్రంధాలలో పేర్కొనబడినది.',
        },
        {
          title: <span class='highlight'>కృష్ణపక్ష అష్టమి – శ్రీకృష్ణాష్టమి :</span>,
        },
        {
          title: 'శ్రీమహావిష్ణువు యోక్క ఎనిమిదో అవతారమే శ్రీకృష్ణ అవతారం. శ్రీకృష్ణ పరమాత్మ జన్మించిన శుదినమే ఈ శ్రీకృష్ణాష్టమి. దీనినే జన్మాష్టమి అని కూడా పిలుస్తారు. ఈరోజు ఉదయం ఉపవాసం ఉండి సాయంత్రం కృష్ణుడిని పూజించి నైవేద్యంగా పాలు, పెరుగు, వెన్నలను సమర్పించడం అనంతరం ఉట్టిని కొట్టడం అనేది ఆచారంగా వస్తోంది.',
        },
        {
          title: <span class='highlight'>కృష్ణపక్ష ఏకాదశి – కామిక ఏకాదశి :</span>,
        },
        {
          title: 'ఇక బహుళ పక్షంలో వచ్చే ఏకాదశే కామిక ఏకాదశి. ఈరోజున నవనీతమును(వెన్న) దానం చేయాలని పెద్దలు అంటారు. తద్వారా ఈతి బాధలు పోయి, కోరికలన్నీ నెరవేరుతాయని శాస్త్ర వచనం.',
        },
        {
          title: <span class='highlight'>కృష్ణపక్ష అమావాస్య – పోలాల అమావాస్య :</span>,
        },
        {
          title: 'పోలాల అమావాస్యను మహిళలు శ్రావణ మాసములో కృష్ణపక్ష అమావాస్య రోజున జరుపుకుంటారు. సంతానాన్ని కోరుకునే ఇల్లాళ్లు దీనిని చేసుకోవాలని పెద్దలు చెబుతుంటారు. కాలక్రమేణా పోలాల అమావాస్య అన్న పేరు కాస్తా, పోలేరు అమావాస్య గా మారి,  పోలేరమ్మ అనే గ్రామ దేవతలను ఆరాధించే పర్వదినంగా మార్పు చెందింది. ఇది ఆచరించడం వల్ల పిల్లలకు అకాల మృత్యు భయం తొలగిపోతుంది అని శాస్త్రాలు చెబుతున్నాయి.',
        }
      ],
      "title": 'శ్రావణ మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>భాద్రపద మాసం విశిష్టత :</span>,
        },
        {
          title: 'శ్రావణం తర్వాత వచ్చే భాద్రపదమూ ప్రత్యేకమే! భాద్రపదంలో ఒకో రోజు గడిచేకొద్దీ ఊరంతా హోరెత్తిపోతుంది. మరి వినాయక చవితి వచ్చేది ఈ నెలలోనే కదా!',
        },
        {
          title: 'ఆ చవితి రోజున స్వామి రూపాన్ని మట్టితో రూపొందించి, ఆ రూపాన్ని పత్రితో పూజిస్తాం. సర్వ శుభాలనూ కలిగించే ఆ విఘ్నాధిపతిని పూర్తిగా ప్రకృతితోనే పూజించి, ప్రకృతిలోనే నిమజ్జనం చేయడం ఈ పండుగకే ప్రత్యేకం.',
        },
        {
          title: 'ఒక్క చవితే కాదు, భాద్రపదంలో ప్రతి తిథీ ప్రత్యేకమే! వినాయక చవితి తర్వాత వచ్చే పంచమిని రుషిపంచమి అని పిలుస్తారు. ఆ రోజున స్త్రీలంతా సప్తర్షులని పూజిస్తూ ఉపవాసం ఉంటారు. అలా చేస్తే రుషుల అనుగ్రహంతో వారిలో ఉన్న దోషాలన్నీ తొలగిపోతాయని నమ్ముతారు.',
        },
        {
          title: 'ఆ తర్వాత వచ్చే *సూర్యషష్టి, లలితా సప్తమి, రాధాష్టమి తిథులలో ఆయా దేవతలని పూజిస్తారు. ఇలా ఒకో తిథినీ దాటుతూ *పరివర్తన ఏకాదశి* వస్తుంది.',
        },
        {
          title: 'తొలిఏకాదశి రోజున శేషతల్పం మీద శయనించే విష్ణుమూర్తి, పరివర్తన ఏకాదశి రోజున మరోపక్కకి ఒత్తిగిలుతాడని అంటారు. అందుకే ఈ రోజుకి ‘పరివర్తన ఏకాదశి’ అన్న పేరు వచ్చింది.',
        },
        {
          title: 'కానీ ఈ పేరు వెనక చాలా నిగూఢ అర్థాలే కనిపిస్తాయి. ఆనాటికి రుతువులలో వచ్చే మార్పునీ, మనుషులలో పరివర్తన రావల్సిన అవసరాన్నీ అది సూచిస్తుంది.',
        },
        {
          title: 'ఈ ఏకాదశి రోజున ఉపవాసం ఉండి జాగరణ చేస్తే గృహస్థు జీవితంలో చేసిన పాపాలన్నీ నశించిపోతాయని చెబుతారు.',
        },
        {
          title: 'పరివర్తన ఏకాదశి మర్నాడే *వామన జయంతి* వస్తుంది. విష్ణుమూర్తి అవతారమైన వామనుడు ఉద్భవించింది ఈ రోజునే! వామనుడే కాదు, బలరాముడు, వరాహస్వామి కూడా ఈ మాసంలోనే అవతరించారని చెబుతారు.',
        },
        {
          title: 'భాద్రపదమాసంలో మరో ప్రత్యేకత మహాలయ పక్షం. భాద్రపద పౌర్ణమి మర్నాడు నుంచి పదిహేను రోజుల పాటు ఈ మహాలయ పక్షం వస్తుంది. పితృదేవతలందరినీ ఈ కాలంలో తల్చుకోవడం ఆనవాయితీ.',
        },
        {
          title: 'భాద్రపదంలో పండుగలే కాదు నోములు, వ్రతాలకి కూడా కొదవ లేదు.',
        },
        {
          title: 'భాద్రపద శుద్ధ చతుర్దశి రోజున వచ్చే *అనంతపద్మనాభస్వామి వ్రతం* ఇందులో ముఖ్యమైనది. ఈ రోజున ఆ పద్మనాభస్వామిని కొలిచినవారి కష్టాలన్నీ తీరిపోతాయని అంటారు. ఇదే కాకుండా ఉండ్రాళ్ల తద్ది నోము, ఉమామహేశ్వర వ్రతం కూడా గుర్తుంచుకోదగ్గవే!',
        },
        {
          title: 'ఇదీ భాద్రపదంలోని కొన్ని ప్రత్యేకతలు.',
        },
        {
          title: 'ఇంత విశేషమైన మాసం కాబట్టే కొందరు అసలు కలియుగమే భాద్రపదంలో మొదలైందని నమ్ముతారు.',
        },
        {
          title: 'భాద్రపదం అన్న పేరు కేవలం నక్షత్రాన్ని మాత్రమే సూచించదు. ఆ మాసంలో ప్రజలంతా *‘భద్రంగా’* ఉండాలన్న ఆలోచనతో ఆ పేరు పెట్టినట్లు తోస్తుంది.',
        }
      ],
      "title": 'భాద్రపద మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>ఆశ్వీయుజ మాసం యొక్క విశిష్టత :</span>,
        },
        {
          title: 'త్రిముర్తులైన బ్రహ్మ, విష్ణు, మహేశ్వరుల దేవేరులైన సరస్వతి, మహాలక్ష్మీ, పార్వతిదేవిలకు అత్యంత ప్రీతికరమైన…వారి పూజలకు ఉత్కృష్టమైన మాసం ఆశ్వయుజం!',
        },
        {
          title: 'జగన్మాత అయిన పార్వతిదేవి దుష్ట శిక్షణ, శిష్ట రక్షణార్ధం, తొమ్మిది అవతారాలను ధరించిన మాసం..!',
        },
        {
          title: 'ఆయుర్వేద దేవుడైన ధన్వంతరీ, త్రిమతాచార్యులలో ద్వైత సిద్ధాంత ప్రవక్త శ్రీ మధ్వాచార్యులు జన్మించిన మాసం..!',
        },
        {
          title: 'దుష్ట దానవుడైన నరకాసురుడు అంతమొందింపబడి ప్రజలందరికి ఆనందాల వెలుగులను పంచిన దివ్య మాసము ఇది !',
        },
        {
          title: 'ఈ మాసంలోని తొలి తొమ్మిది రోజులు "దేవి నవరాత్రులు',
        },
        {
          title: 'సంప్రదాయబద్ధంగా పూజలు చెయ్యాలి అనుకున్న భక్తులు కలశాన్ని స్థాపించి , ముగ్గురు అమ్మల మూలపుటమ్మను. ఈ నాటి నుండి తొమ్మిది రోజుల పాటు నియమముగా ఆరాధించాలి.',
        },
        {
          title: 'దేవి పూజను ఆశ్వయుజ మాసం అష్టమి, నవమిలలో పూజించిన భక్తులకు ఎటువంటి శోకాలు దరిచేరవు.',
        },
        {
          title: 'దేవి పూజకు ఉత్కృష్టమైన ఈ రోజులలో అమ్మవారిని పూజించి రోజుకొక నైవేద్యం చొప్పున సమర్పించడం మంచిది.',
        },
        {
          title: 'కలశ స్థాపనాదులతో పూజించలేని వారు, అమ్మవారి పటానికి గాని, విగ్రహానికి గాని , పుస్తకాలను గాని పూజిస్తూ స్తోత్ర , నామ పారాయణలను చేయవచ్చు..!',
        },
        {
          title: 'ఈ విధముగ దేవి నవరాత్రులలో ఆ తల్లిని ఆరాధించడం వల్ల ఆ దేవి సంతృప్తురాలు అవుతుంది. అంతే కాకుండా దుష్ట , గ్రహ పీడలు నశించి అమ్మవారి కృప కటాక్షలు కలుగుతాయని చెప్పబడుతోంది.',
        },
        {
          title: 'అలాగే, ఈ మాసం లో సప్తమి రోజున గోపూజ చెయ్యవలెను. కపిల గోవును పూజించాలని, కేవలం పంచగవ్యములను మాత్రం స్వీకరించి ఉపవాసము ఉండవలెను..!',
        },
        {
          title: 'పూర్ణిమ నాడు నారదీయ పురాణమును పండితులకు తాంబూలములో వుంచి దానము ఇవ్వవలెను.',
        },
        {
          title: 'పూర్ణిమ నాడు స్త్రీలు జాగరణ చెయ్యటం వలన లక్ష్మి దేవి సంతోషించి, అష్టైశ్వర్యాలు ప్రసాదిస్తుంది అని శాస్త్ర వచనం.',
        },
        {
          title: 'ఈ నెలలోని బహుళ పక్షములో చతుర్దశి , అమావాస్య తిధులలో దీపాలను దేవాలయం , మఠము ప్రాకారాల్లోను, వీధులు, ఇంటి ముందు సాయంత్రము సమయములో వెలిగించుకోవడంవల్ల పితృదేవతలు సంతృప్తి చెందుతారని చెప్పబడుతోంది.',
        },
        {
          title: 'ఈ విధముగ ఎన్నో విశిష్టతలను సొ౦తం చేసుకున్న మాసం -- ఆశ్వయుజ మాసం !',
        },
        {
          title: 'ఈ మాసంలో చేసే పూజలు, విధుల ఆచరణ వల్ల అనంతమైన పుణ్య ఫలాలు కలుగుతాయని పురాణ వచనం..!',
        },
        {
          title: 'అనంత రూపాలలో విలసిల్లే శక్తిస్వరూపిణి అయిన ఆ తల్లిని  ఏ రూపములోనైనా, ఏ నామంతోనైనా ఆరాధించవచ్చు. ఆ తల్లి అమ్మలగన్న అమ్మ !',
        },
        {
          title: 'తనను నమ్మిన భక్తులను ఎట్టి పరిస్థితులలో విడవకుండా కాపాడే కల్పవల్లి కరుణామయి. ఆ తల్లి !!!.',
        }
      ],
      "title": 'ఆశ్వీయుజ మాసం యొక్క విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>కార్తీక మాసం విశిష్టత :</span>,
        },
        {
          title: 'స్నాన, దాన, జపాలు, పూజలు, ఉపవాస వ్రతాలు, దీపాలు వెలిగించడం, వనభోజనాలు వంటి వాటిని చేయడం వల్ల జన్మజన్మల పాపాలను ప్రక్షాళన చేసి అనంతమైన పుణ్యఫలాలను ప్రసాదించే మహిమాన్వితమైన మాసం “కార్తీకమాసం’. చాంద్రమానం ప్రకారం కార్తీకమాసం ఎనిమిదవది. శరదృతువులో రెండవ మాసం. ఈ మాసంలోని పూర్ణిమనాడు చంద్రుడు కృత్తికా నక్షత్ర సమీపంలో సంచరిస్తూ ఉండడం వల్ల ఈ మాసానికి “కార్తీకమాసం” అని పేరు వచ్చింది.',
        },
        {
          title: '"న కార్తీక నమో మాసః',
        },
        {
          title: 'న దేవం కేశవాత్పరం!',
        },
        {
          title: 'నచవేద సమం శాస్త్రం',
        },
        {
          title: 'న తీర్థం గంగాయాస్థమమ్"',
        },
        {
          title: 'అని స్కంద పురాణంలో పేర్కొనబడింది. అంటే “కార్తీకమాసానికి సమానమైన మాసము లేదు. శ్రీమహావిష్ణువుకు సమానమైన దేవుడు లేడు. వేదముతో సమానమైన శాస్త్రము లేదు గంగతో సమానమైన తీర్థము లేదు.” అని అర్ధం.',
        },
        {
          title: 'శివునికి ప్రీతిపాత్రమైన మాసం కార్తీక మాసం. ప్రతి ఏటా దీపావళి వెళ్ళిన మరుసటి రోజు నుంచి అతి పవిత్రమైన కార్తీక మాసం ప్రారంభమవుతుంది. ఈ మాసంలో భక్తులంతా నిత్యం భోళాశంకరుని నామాన్ని స్మరిస్తూ ఉంటారు. పురాణ కాలంనుంచీ ఈ మాసం ఓ ప్రత్యేకతను సంతరించుకుంది. హరిహరాదులకు ప్రీతిపాత్రమైన ఈ మాసంలో భక్తకోటి యావత్తూ కఠిన నిష్ఠతో చేపట్టే నోములకు ఎంతో ప్రాధాన్యం ఉంది. ఈ మాసంలో పాఢ్యమి, చవితి, పౌర్ణమి, చతుర్దశి, ఏకాదశి, ద్వాదశి తిధుల్లో శివపార్వతుల అనుగ్రహం కోసం మహిళలు పూజలు చేస్తుంటారు.',
        },
        {
          title: 'హరిహరాదులకు ప్రీతికరం… కార్తీక మాసం',
        },
        {
          title: 'మన భారతీయ సంస్కృతిలో కార్తీకమాసం వచ్చింది అంటే ఆ నెల రోజులు పండుగదినాలే! అందులోను కార్తీకమాసం ఈశ్వరారాధనకు చాలా ముఖ్యమైనది. దేశం నలుమూలలా ఉన్న వివిధ ఆలయాలలో రుద్రాభిషేకాలు, రుద్రపూజ, లక్ష బిల్వదళాలతో పూజలు, అమ్మవారికి లక్షకుంకుమార్చనలు, విశేషంగా జరుపుతూ ఉంటారు. అలా విశేషార్చనలు జరిపే భక్తులకు సదాశివుడు ప్రసన్నుడై కొంగుబంగారంలా సంతోషం కలిగిస్తాడు. కాబట్టి ఆ స్వామికి ‘‘ఆశుతోషుడు’’ అనే బిరుదు వచ్చింది.',
        },
        {
          title: '‘‘హరిః ఓం నమస్తే అస్తు భగవన్విశ్వేశ్వరాయ మహాదేవాయ త్య్రంబకాయ',
        },
        {
          title: 'త్రిపురాంతకాయ త్రికాలాగ్నికాలాయ కాలాగ్ని రుద్రాయ నీలకంఠాయ',
        },
        {
          title: 'మృత్యుంజయాయ సర్వేశ్వరాయ సదాశివాయ శ్రీమన్మహాదేవాయ నమః”',
        },
        {
          title: 'ప్రతి ఈశ్వరాలయంలో ఆ రుద్ర నమకం మంత్రభాగం మారుమోగిపోతూ, ప్రతిధ్వనిస్తూ ఉంటుంది. హిందువుల గృహాలలో ‘‘ఆదిత్యమంబికా విష్ణూగణనాథం మహేశ్వరం’’ అనే పంచాయతన దేవతలను విశేషంగా ఆరాధిస్తారు. ఈ కార్తీకమాస మహత్యం గురించి పూర్వం నైమిశారణ్య ఆశ్రమములో శౌనకాది మహామునులు అందరికీ సూతమహాముని ఎన్నో విష్ణు భక్తుల చరిత్రలు, విష్ణు మహిమలను వినిపించే సమయంలో, “ఓ సూతముని శ్రేష్ఠా!',
        },
        {
          title: 'కలియుగంలో ప్రజలు సంసార సాగరమునుండి తరింపలేక, అరిషడ్వర్గాలకు దాసులై, సుఖంగా మోక్షమార్గం తెలియక ఎన్నో ఈతిబాధలు అనుభవిస్తున్న ఈ మానవులకు ధర్మాలన్నింటిలో ఉత్తమ ధర్మమేది? దేవతలు అందరిలోనూ ముక్తి నొసంగు ఉత్తమ దైవమెవరు? మానవునికి ఆవరించియున్న ఈ అజ్ఞానాన్ని రూపుమాపి పుణ్యఫలం యిచ్చే కార్యమేది? ప్రతిక్షణం మృత్యువు వల్ల వెంబడించబడే ఈ మానవులకు మోక్షము కలిగించు చక్కని ఉపాయము చెప్ప”మని కోరారు.',
        },
        {
          title: 'ఆ ప్రశ్నలను విన్న సూతముని, “ఓ ముని పుంగవులారా! క్షణికమైన సుఖభోగాల కోసం పరితపించుతూ, మందబుద్ధులు అవుతున్న మానవులకు ‘‘ఈ కార్తీకమాస వ్రతము’’ హరిహరాదులకు అత్యంత ప్రీతికరమైంది. దీనిని ఆచరించటం వల్ల సకల పాపాలు హరింపబడి మరు జన్మలేక పరంధామము పొందగలరు. పుణ్యాత్ములకు మాత్రమే ఈ కార్తీకమాస వ్రతమాచరించాలని కోరికను కలుగచేస్తాడు ఆ పరమాత్మ! దుష్టులకు, దుర్మార్గులకు వారి కర్మలు పరిపక్వమయ్యేవరకు ఏవగింపు కలిగిస్తాడు.',
        },
        {
          title: 'ఈ మాసంలో వచ్చే సోమవారాలు చవితి, ఏకాదశి, ద్వాదశి, పౌర్ణమి, అత్యంత పుణ్యప్రదమైనవి. నెల అంతా సాధ్యపడని భక్తులు కనీసం ఆయా రోజులలో పవిత్రపుణ్య నదీ స్నానం ఆచరించి, ఉపవాస దీక్షలు చేస్తూ మహాన్యాస పూర్వక మహా రుద్రాభిషేకాలు, లక్ష బిల్వార్చనలు, లక్ష కుంకుమార్చనలు, లలిత, విష్ణు సహస్రనామ పారాయణాలు, ప్రతి నిత్యం ఉభయ సంధ్యలలో దీపారాధన చేసేవారికి విశేష పుణ్య ఫలం లభిస్తుంది. ఈ కార్తీకమాసం ముప్పై రోజులు ఆచరించిన వారికి అనంతకోటి పుణ్యఫలం లభిస్తుందని చెప్పబడింది.',
        },
        {
          title: 'ఇందులో అత్యంత మహిమాన్వితమైన కాలం ప్రదోషకాలం. సూర్యాస్తమయం అయ్యాక మూడు గడియలు (ఒక గంట) ప్రదోషోరజనీముఖమ్‌. రాత్రికి ఆరంభకాలమే ఈ ప్రదోష సమయం. ఇలా ప్రతి నిత్ర్యం వచ్చే ప్రదోషాన్ని నిత్య ప్రదోషంగా చెప్తారు. ఈ ప్రదోషం నాలుగు విధాలుగా మహాత్ములు వివరిస్తూ ఉంటారు. 1. నిత్య ప్రదోషం. 2. పక్ష ప్రదోషం 3. మాస ప్రదోషం 4. మహాప్రదోషం అని చెప్తారు.',
        },
        {
          title: 'కొందరు నిష్టాపరులు ఈ కార్తీకమాసమంతా పుణ్యనదీస్నానం ఆచరిస్తూ ప్రతి నిత్యం హరిహరాదులను పూజిస్తూ పగలు అపక్వాహారం అంటే వండని ఆహారం. పాలు, పండ్లు స్వీకరించి సాయంత్రం భక్తితో కార్తీక దీపారాధనలు, పూజలు చేసి, నివేదించిన అన్నాన్ని రాత్రి భుజిస్తూ ఉంటారు. ఇలా ఈ కార్తీక వ్రతాన్ని నిత్యం ఆచరిస్తారు.ఇక ప్రదోషకాలంలో పరమేశ్వరుడు ఏక కాలంలో రెండు రూపాల్ని ప్రదర్శిస్తూ ఎడమ భాగాన పార్వతి, రెండవ భాగంలో పరమేశ్వరరూపంగా ‘‘అర్థనారీశ్వ రుడుగా’’ దర్శనమిచ్చే కాలం ఈ ప్రదోషకాలం అని చెప్పబడినది. ఆ ప్రదోష సమయాల్లో ఆ తల్లి ‘‘అధ్యక్షురాలు’’గా అధిరోహించియుండగా! పరమేశ్వరుడు పరవశించి తాండవం చేస్తూ ఉంటాడు.',
        },
        {
          title: 'ఆ నృత్యాన్ని దర్శించటానికి దేవతలందరూ అక్కడ కొలువుతీరి ఉంటారుట! ఆ సమయంలో ఆ తాండవ నృత్యానికి అనుగుణంగా సరస్వతి దేవి వీణవాయిస్తూ ఉంటే బ్రహ్మ తాళం వేస్తాడట. శ్రీ మహాలక్ష్మీ గానం చేస్తూ ఉంటే! శ్రీ హరి మృదంగం వాయిస్తాడుట. ఇంద్రుడు వేణునాదంతో పులకింపచేస్తూ ఉంటాడు! అలాంటి ప్రదోష సమయాల్లో దేవగంధర్వ మహర్షి సిద్ధులందరూ పరమాత్మ స్వరూపాన్ని కొలుస్తూ ఉంటారుట.',
        },
        {
          title: 'కాబట్టి ప్రదోష సమయాల్లో శివుని ఆరాధిస్తే! శివుని ఆశీస్సులతోపాటు మిగతా దేవతల ఆశీస్సులు కూడా ఏకకాలంలో మనం పొందగలుగుతామని చెప్పబడింది. ఇంకా మనకు ఆ అర్థనారీశ్వర స్వరూపాన్ని ధ్యానిస్తే! రెండు ప్రయోజనాలు లభిస్తాయట. కామం! అంటే కోర్కెలను నియంత్రించే శక్తి మరియు కాలాన్ని అంటే మరణాన్ని జయించే శక్తిని ప్రసా దిస్తాడుట! ఇంకా ఈ ప్రదోష దర్శనం సర్వశుభాలను కలుగచేసి, సర్వదారిద్య్ర బాధలను తొలగించి సర్వసంపత్తులు అనుగ్రిహస్తుంది అని చెప్పబడింది.',
        },
        {
          title: 'ఈ కార్తీకమాసంలో అత్యంత విశేషమైనది. ఉత్థానైకాదశి అంటే శ్రీ మహావిష్ణువు పాలకడలిలో ఆదిశేషుని పాన్పుపైన ఆషాడ శుద్ధ ఏకాదశినాడు తనయోగనిద్రను ప్రారంభించి తిరిగి కార్తీక శుద్ధ ఏకాదశినాడు కనులు విప్పి యోగ నిద్ర నుండి మేల్కొన్న రోజుకే ఉత్థాన ఏకాదశి అనే పేరు. ఆ మరుసటి రోజు ద్వాదశినాడు ముప్పై ముగ్గురు దేవతలలో శ్రీ మహాలక్ష్మీ సమేతుడై తులసీ ధాత్రివనంలో ఉంటాడని చెప్తారు.',
        },
        {
          title: 'ఈ ద్వాదశిని క్షీరాబ్ధి ద్వాదశి అంటారు అంటే, పూర్వం కృతయుగంలో దేవదానవులు పాలసముద్ర మధనం చేసిన రోజు. కనుక దీనికి క్షీరాబ్ధి ద్వాదశి అను పేరు వచ్చింది. పాల సముద్రాన్ని చిలికారు కనుక చిల్కు ద్వాదశి అని కూడా అంటారు. కనుక స్త్రీలు ఈ రోజు వారి సౌభాగ్య సంపదల కోసం తులసీ ధాత్రి (తులసికోట) దగ్గర విశేష దీపారాధనలు చేసి షోడశోపచారాలతో తులసీధాత్రి లక్ష్మీనారాయణులను పూజిస్తారు. ఆ రోజు దేశం నలుమూలలా ఉన్న ఆలయాలలోని లక్ష్మీనారాయణ మూర్తులను మిరుమిట్లు గొలిపే విద్యుత్‌ దీపకాంతితో, బాణసంచాలతో సమీప నదీజాలలో తెప్సోత్సవం నిర్వహిస్తూ ఉంటారు.',
        },
        {
          title: 'కార్తీక పూర్ణిమనాడు వరిగడ్డిని వెంటిగా చుట్టి దానిని రెండు స్తంభాలకు కట్టి ఆ వెంటిని మూడుమార్లు కాగడాలతో వెలిగిస్తూ వాటి క్రింది పార్వతీపరమేశ్వరుల ప్రతిమలను పల్లకిలో ఉంచి మూడుసార్లు త్రిప్పి జ్వాలాతోరణ వేడుకను నిర్వహిస్తారు. అలా హరిహరాదులకు ప్రత్యేక ఉత్సవ వేడుకలు నిర్వహిస్తారు. ఇలా ఈ కార్తీకమాస విశేషాలను కొనియాడి చెప్పడానికి సహస్రముఖాలు కలిగిన ఆదిశేషుడు, చతుర్ముఖుడైన బ్రహ్మకే సాధ్యం కాదని చెప్పగా, ఇక మానవ మాత్రులమైన మనమెంత?” అని సూతమహాముని చెప్పారు.',
        },
        {
          title: 'మన సంస్కృతిలో ఈ దీపారాధన అనేది ప్రధానాంశం. ఈ దీపదానంలో ఆవునెయ్యి ఉత్తమోత్తమమైనది. మంచినూనె మధ్యమము, ఇప్పనూనె అధమము, ఇతర నూనెలు అడవిలో పుట్టిన నూనెలు అధమాతి అధమములు. గేదె నేతితో దీపము, వెలిగిస్తే పూర్వ పుణ్యము కూడా నశించి పోతుంది. అదే స్వల్పంగా ఆవునేయి కలిపి వెలిగింస్తే దోషములేదని, అలా ఒకటి మొదలు వేయి వరకు దీపాలు వెలిగించుటం ఎంతో శుభప్రదమని వాటి సంఖ్యనుబట్టి వివిధ ఫలితాలు అందిస్తుందని, దీపదాన మహాత్యంలో చెప్పివున్నారు. అలాంటి దీపారాధన పూజామందిరంలో, దేవాలయాలలో గృహప్రాంగణాలలో, తులసీ బృందావనంలో, మారేడు, రావి వంటి దేవతా వృక్షాల దగ్గర, పుణ్య నదీతీరాలలో వెలిగించుటం అత్యంత పుణ్యప్రదమని పురాణాలు వర్ణించి చెబుతున్నాయి.',
        },
        {
          title: 'ఈ మాసంలో సోదరి చేతివంట భగనీ హస్తభోజనము చేసి యధాశక్తి వారికి కానుకలు సమర్పించుటంతో పాటు, సమీప వనంలో బంధువులు, స్నేహితులతో కలిసి ఉసి రిచెట్టును పూజించి, సాత్విక ఆహారంతో వనభోజనాలు చేస్తూ వుండటం మంచిది. అందువల్ల మన జీవన గమనంలో మంచి ఆహ్లాదంతో పాటు అన్నదాన ఫలితం కూడా లభిస్తుంది.',
        },
        {
          title: 'అలాంటి మహిమాన్వితమైన ఈ కార్తీకమాసంలో నియమనిష్టలతో హరిహరాదులను అనునిత్యం ఆరాధిస్తూ ‘‘కార్తీకపురాణ’’ పఠనం చేస్తే అనంతకోటి పుణ్యఫలం లభిస్తుందని, ఈ పవిత్ర పుణ్యదినాలలో అలసత్వం వహించకుండా యథాశక్తి దీపదానము, వస్త్ర, ఫల, పుష్ప, సువర్ణ దానాలు మొదలైనవి చేయుటం వల్ల ఇహంలో సర్వసుఖాలు అనుభవించుటమే కాకుండా, జన్మాంతరంలో జన్మరాహిత్యాన్ని పొందగలరని ఈ కార్తీకమాస వ్రతమహాత్యాన్ని గురించిసూతమహాముని శౌనకాది మునులకు వివరించాడు.',
        },
        {
          title: <span class='highlight'>విశిష్టత :</span>
        },
        {
          title: 'ఆయా మాసాలలో చంద్రుడు పూర్ణుడై ఏ నక్షత్రంలో ఉంటాడో ఆ నక్షత్రం పేరే ఆ మాసానికి వస్తుంది. కృత్తికా నక్షత్రంపై చంద్రుడు పూర్ణుడై ఉండటంవల్ల ఈ మాసానికి కార్తీకమాసమని పేరు. ఈ మాసంలో కృత్తిక నక్షత్రానికి, దీపారాధనకు, సోమవారాలకు ప్రాధాన్యత ఉంది. ఈ విషయాలను గురించి ఇప్పుడు తెలుసుకుందాం.',
        },
        {
          title: 'కృత్తికా నక్షత్రం: కృత్తికానక్షత్రానికి నక్షత్రాలలో మంచి ప్రాముఖ్యత ఉంది. దేవతలలో ప్రథముడైన అగ్నిదేవుడు ఈ నక్షత్రానికి అధిపతి. అగ్ని నక్షత్రాలైన కృత్తిక, ఉత్తర, ఉత్తరాషాడలలో మొదటిది కృత్తికయే. వేదకాలంలో సంవత్సరం కృత్తికా నక్షత్రంతోనే ఆరంభమయ్యేది. ఈ నక్షత్రాన్ని అగ్ని నక్షత్రమని అంటారు. అగ్ని ఆరు ముఖాలు కలవాడు.',
        },
        {
          title: 'కృత్తికలు కూడా ఆరు నక్షత్రాలు. ఈ కృత్తికలు ఒక విశిష్టత ఉంది. అదేమిటంటే కుమారస్వామిని షణ్ముఖుడు అంటారు. అంటే ఆరు ముఖాలు కలవాడని అర్థం. ఆకాశంలోని ఆరు కృత్తికా నక్షత్రాలు మాతృమూర్తులై పాలు యివ్వగా కుమారస్వామి ఆరు ముఖాలతో పాలు త్రాగాడు. ఈ విధంగా కృత్తికలచే పెంచబడటంతో కుమరస్వామికి కార్తీకేయుడని పేరు వచ్చినది. ఈ కారణాల వల్ల కృత్తికలకు ప్రాముఖ్యం కలిగింది.',
        },
        {
          title: <span class='highlight'>కార్తీక దీపాలు :</span>
        },
        {
          title: 'ఈ మాసంలో చెప్పుకోదగ్గ మరో అంశం దీపారాధన. ఈ మాస ప్రారంభం నుండి సూర్యోదయానికి పూర్వమే లేచి నదీస్నానం చేసి శుచిగా, పొడిబట్టలు ధరించి దీపారాధన చేయాలి. ఈ మాసంలోనే జ్వాలా తోరణాన్ని కొన్ని చోట్ల వెలిగిస్తారు. ఈ కాలమంతా దేవాలయాలన్నీ దీపాలచే అలంకరించబడి ప్రజలను ఉత్తేజపరుస్తూ శోభాయమానంగా ఉంటాయి. ప్రతి ఇంటిముంగిట ఈ మాసాంతం వరకు దీపం వెలుగుతూ ఉంటుంది.',
        },
        {
          title: 'కార్తీకమాసంలో స్త్రీలు నదులలో, కోనేటిలలో దీపాలు వదలుతారు. ఈ దీపాలు ఆకాశంలోని చుక్కల్లాగా ప్రకాశవంతంగా వెలుగుతూ కన్నులపండుగను కలుగచేస్తాయి. ఈ మాసంలో స్త్రీలు దీపాన్ని దానంగా ఇస్తారు. దీని వల్ల వారికి ఎనలేని కీర్తిసౌ భాగ్యాలు కలుగుతాయని భావిస్తారు. ఈ దీపాలు మనిషిలోని అజ్ఞానమునే చీకటిని తొలగించి జ్ఞానమనే వెలుగును నింపుతాయి.',
        },
        {
          title: <span class='highlight'>కార్తీక సోమవారాలు :</span>
        },
        {
          title: 'ఈ మాసవారాలలో సోమవారానికి ప్రత్యేకత ఉంది. సోమవారానికి చంద్రుడు అధిపతి. దేవతలలో ప్రథముడైన అగ్ని నక్షత్రాలలో మొదటిదైన కృత్తికను అధిపతిగా ఉండటం, చంద్రుడు పూర్ణుడై ఈ నక్షత్రం మీద ఉండటం వల్ల మాసంలోని సోమవారాలకు విశిష్టత కలిగింది. చంద్రుని వారమైన ఈ సోమవారం శివునికి ఎంతో ప్రీతికరమైనది. శైవభక్తులు ఈ మాసంలో ముఖ్యంగా సోమవారాలలో భక్తిశ్రద్ధలతో నియమనిష్టలతో శివుణ్ణి ఆరాధిస్తారు. ఈ మాసకాలంలో సూర్యోదయ పూర్వమే బ్రహ్మ ముహూర్తంలో నదీ స్నానం చేసి ‘హరహరశంభో’ అంటూ శివుణ్ణి స్తుతిస్తూ భక్తి ప్రపంచంలో మునిగిపోతారు. ముఖ్యంగా శైవభక్తులు ఈ మాసమంతా ఉపవాసముండి శివుడిని పూజిస్తారు. శివ ప్రీతికరమైన సోమవారం రోజు భానోదయం ముందు లేచి స్నానాదికార్యాక్రమాలు ముగించుకుని, పొడి బట్టలు ధరించి మొదటగా దీపారాధన చేయాలి.',
        },
        {
          title: 'అనంతరం శివుడికి రుద్రాభిషేకం చేయించి శివవ్రత నియమాలను పాటించాలి. ఈ విధంగా చేయడం వల్ల నిత్యమూ సిరిసంపదలతో, సుఖసౌఖ్యాలతో వర్థిల్లుతారని ప్రజల నమ్మకం. సూర్యుడు తులారాశిలో ప్రవేశించిన నాటి నుండిగాని, కార్తీక మాసారంభదినమైన శుద్ధపాడ్యమి మొదలుకొని గాని వ్రతారంభం చేయాలి. అలా ప్రారంభించే సమయంలో “ఓ కార్తీక దామోదార! నీకు వందనములు. నాచే ఆరంభింపబడే కార్తీక వ్రతాన్ని విఘ్నం లేకుండా చేయు”ము అని తరువాత స్నానం చేయాలి.',
        },
        {
          title: 'ఆ విధంగా జీవనదికి వెళ్ళి గంగకు, శ్రీ మన్నారాయణునను, భైరవున్ని నమస్కరించి భైరవాజ్ఞను తలదాల్చి మొలలోతు నీటిలో నిలువబడి మొదట సంకల్పము చెప్పుకొని సూక్తాలను చదివి, మార్జన మంత్రముతోను, అఘమర్షణ మంత్రముతోను, గంగోదకమును శిరస్సున జల్లుకొని అఘమర్ష స్నానమా ఆచరించాలి. తరువాత సూర్యుడికి కర్ఘ్య ప్రదానం చేసి దేవతలకు, ఋషూలకు, పితృదేవతలకు క్రమ ప్రకారంగ తర్పణం వదలాలి. అప్పుడది సుస్నానం అవుతుంది. స్నానం చేసిన తరువాత నదీతీరము చేరి మూడుదోసిళ్ళ నీరు గట్టుపైన పోయాలి.',
        },
        {
          title: 'కార్తీకమాసంలో గంగా, గోదావరి, కావేరీ, తుంగభద్రాది నదులలో స్నానం చేస్తే ఆత్యుత్తమం, గంగానది కార్తీకమాసంలో నదులన్నిటిలో ద్రవరూప సన్నిహితయై వుంటుంది. శ్రీ ఆదినారాయణుడు గోష్పాద మాత్ర ప్రదేశంలో జలములో సన్నిహితుడై ఉంటాడని వేదాలు చెప్పుతున్నాయి కాబట్టి సముద్రకామి అయిన నదీ స్నానం అత్యంత పవిత్రమైనది. నదీ స్నానానికి ఆవకాశము లభించకపోతే కులువలోగాని, చెరువులోగాని, కూపము దగ్గరగాని సూర్యోదయము స్నానం చేయాలి.',
        },
        {
          title: 'తరువాత మడిబట్టలను ధరించి ముందుగా భగవంతుని స్మరించు కోవాలి. తరువాత భస్మాన్ని త్రిపుండ్రముగా నుదుట ధరించాలి. లేక గోపీచందనముపైన నుదుట నూర్ద్వ పుండ్రముగా వుంచుకోవాలి. తరువాత సంధ్యావందనము, బ్రహ్మ యజ్ఞాన్ని ముగించి, నిత్యాగ్నిహోత్రాన్ని చేసుకొని దేవతార్చన చేసుకోవాలి. స్నానతీర్థములోనే కార్తీక పురాణ శ్రవణమును చేయాలి.',
        },
        {
          title: 'సూర్యుడు ఆస్తమించే కాలంలో సాయంసంధ్యను పూర్తి చేసికొని శివాలయముగాని, విష్ణు ఆలయంలోగాని దీపారాధన చేయాలి. షోడశోపచార పూజావిధానంలో హరిహరులను పూజించి షడ్రసోపేతమై, భక్ష్యభోజ్యాదులతో కూడిన నైవేద్యము పెట్టాలి. ఈ విధంగా కార్తీకశుద్ధ ప్రతిపత్తు మొదలు అమావాశ్య తుదివరకు నక్తవ్రతం చేస్తే కార్తీకమాస వ్రతము పూర్తవుతుంది. మరునాడు శక్తిననుసరించి మృష్టాన్నముతో భూత తృప్తి కావించాలి. కార్తీక మాసంలో సోమవారం శివప్రీతికై సోమవారవ్రతము చేసినవారికి కైలాసంలో శివుని సన్నిధానమున నుండుట ప్రాప్తిస్తుంది. సోమవారవ్రత విధానం ఎలాంటిది అంటే – సోమవారం నదీ స్నానం చేసి సంపూర్ణంగా ఉపవాసం ఉండి, శివునికి అభిషేకం చేసి రాత్రి మొదటి ఝామున భుజించాలి.',
        },
        {
          title: 'ఆ రోజున యితరులలాగా పదార్ధం గ్రహింపరాదు. తిలదాన మొనర్చినందువలన పాపములన్నియు నశించును. ఇంకా ఆత్యంత నిష్ఠతోను, భక్తితోను ఆచరింప అవకాశం ఉన్నవారు ఆ దినం రాత్రి కూడా నిద్రింపోక పురాణాది పఠనంతో జాగరణ చేసి, మరునాడు శక్తి కొలదిగా బ్రాహ్మణులకు సంతర్పణను చేసి తరువాత భుజించాలి. ఈ పై రెండూ చేయలేనివారు సోమవారం రోజు నపరాహ్ణము వరకు వుండి భుజించాలి. యిందులో ఏది చేయుడానికి శక్తిలేకపోతే నదీస్నానం చేసుకొని భగవంతుని ధ్యానించాలి. ',
        },
        {
          title: 'సోమవారం రోజు స్త్రీగాని, పురుషుడుగాని నక్షత్ర దర్శనం అయ్యేవరకు ఉపవాసం చేసి తరువాత భుజించినవారి పాపాలు అగ్నిలో పడిన దూదివలే నాశనం అవుతుంది. ఆ రోజునశివుడికి అభిషేకం చేసి, బిల్వదళంబులతో సహస్రనామార్చన చేసి, ఇతరులచే చేయించిమా, శివపంచాక్షరీ మంత్రాన్ని జపించినా, వారిని శివుడు ఆనుగ్రహించి సర్వసంపదలను, సమస్త శుభాలను చేకూరుస్తాడు. కార్తీక సోమవారాలు లేదా పౌర్ణమినాడుగాని లేక ఇతర దినాల్లో అయినా సాయంసమయాలలో శివాలయంలో ఉసిరికాయపైన వత్తులను వుంచి దీపం వెలిగించడం శ్రేష్టం.',
        },
        {
          title: 'ఆవునెయ్యితో దీపం వెలిగించడం శ్రేష్టం. లేదంటే నువ్వులనూనెతో గానీ, కొబ్బరినూనెతో గానీ, నెయ్యితోగాని, అవిశనూనెతో గానీ, ఇప్పనూనెతో గానీ, లేదంటే కనీసం ఆముదంతోనైనా దీపాన్ని వెలిగించాలి. అంతే కాకుండా కార్తీకమాసంలో దీపదానం చేయాలని శాస్త్రవచనం. కార్తీకమాసంలో ముప్పై రోజులలో దీపం పెట్టలేనివారు శుద్ధద్వాదశి, చతుర్దశి, పూర్ణిమ దినాల్లో తప్పక దీపం పెట్టాలని శాస్త్ర వచనం. ఈ విధంగా కార్తీకమాసంలో దీపాలను వెలిగించడం, దీపదానం చేయడం వల్ల సకల జీవరాశులే కాకుండా రాళ్ళూ, రప్పలు, వృక్షాలు వంటివి కూడా ముక్తి పొందుతాయని పురాణ కథనం.',
        }
      ],
      "title": 'కార్తీక మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>మార్గశిర మాసం విశిష్టత :</span>
        },
        {
          title: 'శ్రీమహావిష్ణువుకు ఇష్టమైన మాసం.!',
        },
        {
          title: 'మాసానాం మార్గశీర్షం..!',
        },
        {
          title: 'హేమంత ఋతువులో వచ్చే మొదటి నెల.',
        },
        {
          title: 'దీనినే జ్యోతిష్యాన్ని అనుసరించి..',
        },
        {
          title: 'సౌరమాన ప్రకారం ధనుర్మాసమని',
        },
        {
          title: 'చంద్రమానం ప్రకారం మార్గశిర మాసమని అంటారు.',
        },
        {
          title: 'చాంద్రమాన సంప్రదాయాన్ని అనుసరించి చంద్రుడు మృగశిర నక్షత్రంలో ఉండే నెల "మార్గశీర్షం".చంద్రుడు మనః కారకుడు, ఆ చంద్రుడు అనుకూలంగా లేకపొతే మంచి ఆలోచనలు కలగవు, మానసిక స్థితి సరైన మార్గంలో ఉండదు. అందుకని చంద్రుడు అనుకూలించే కాలంలో మన దైవపూజలని ప్రారంభిస్తే వాటి మీద శ్రద్ద బాగా పెరిగి తద్వారా మనోధైర్యం వృద్ది చెందుతుంది. ',
        },
        {
          title: <span class='highlight'>జ్యోతిష్య శాస్త్ర ప్రకారం :</span>
        },
        {
          title: 'చంద్రునికి ఉచ్ఛ స్థానం వృషభ రాశి, మృగశిర నక్షత్రం వృషభరాశికి చెందినది కావున, చంద్రుని సంపూర్ణ అనుగ్రహం ఉండి దైవ కార్యాలని చేసే కొద్దీ చేయలనిపించే మంచి ఆలోచనలు కలుగుతాయి.',
        },
        {
          title: 'ఈ మాసంలో..!',
        },
        {
          title: 'ఇది ప్రకృతి కాంతకు సీమంతం.',
        },
        {
          title: 'తుషార బిందువుల హేమంతం..!!',
        },
        {
          title: 'మార్గశీర్ష మాసము ఒక విలక్షణమైన మాసము. మార్గశీర్షము అంటేనే మార్గములందు శ్రేష్ఠమైనది. ఉపయోగకరమైనదని అర్థం.',
        },
        {
          title: 'ఇది ఏ మార్గము అంటే భగవంతుని పొందు భక్తిమార్గము. శీర్షప్రాయమైన ఈ మార్గము మిగిలిన మార్గము లన్నింటికన్నా ప్రధానమైనది, ప్రాముఖ్యతతోపాటు పవిత్రత కూడా ఏర్పడటంచే ఇది శ్రేష్టమైనది. శ్రీ మహావిష్ణువుకి ప్రీతికరమైన మాసం మార్గశిరం.',
        },
        {
          title: 'బృహత్సామ తథాసామ్నాం- గాయత్రీ ఛందసా మహం- మాసానాం మార్గశీర్షోహ- ఋతూనాంకుసుమాకరం” ',
        },
        {
          title: 'అనే శ్లోకంలో మార్గశీర్గాన్నీ నేనే,',
        },
        {
          title: 'ఆరు ఋతువులలోనూ పుష్పసౌరభం నేనే,',
        },
        {
          title: 'సామవేదానికి చెందిన గానాలలో బృహత్సామాన్ని నేనే, ఛందస్సులలో గాయత్రీ ఛందాన్ని',
        },
        {
          title: 'శోభ అధికంగా ఉండే వసంత కాలాన్ని నేను',
        },
        {
          title: 'అని భగవద్గీతలోని విభూతి యోగంలో సాక్షాత్తు శ్రీకృష్ణపరమాత్ముడే పేర్కొన్నాడు.',
        },
        {
          title: 'శ్రీకృష్ణుడు మార్గశిరం అంటే నేనేనని చెప్పుకున్న మాసమిది.',
        },
        {
          title: 'మాసాల్లో తాను మార్గశిరమాసాన్ని అంటాడు.',
        },
        {
          title: 'శ్రీకృష్ణ పరమాత్మ.!',
        },
        {
          title: 'ఈ మాసంలో చేసే ఏ పూజైన, హోమమైన,',
        },
        {
          title: 'ఎటువంటి దైవకార్యం చేసినా దానిని స్వయంగా',
        },
        {
          title: 'తనే స్వీకరిస్తానని తెలియజేశాడు.',
        },
        {
          title: 'భగవద్గీత లోని విభూతియోగంలో......',
        },
        {
          title: 'ఈకాలంలో పొలాలనుంచి ధాన్యం ఇళ్లకు చేరి ప్రజలు సంతోషంగా ఉంటారని  ఉత్తమ మాసంగా పరిగణిస్తారు.!!',
        },
        {
          title: 'కృష్ణుడు విష్ణ్వంశ సంభూతుడు......!',
        },
        {
          title: 'విష్ణువు సూర్యనారాయణుడై....',
        },
        {
          title: 'ధనూరాశి నుంచి మకర రాశికి ప్రయాణించే సమయమిది.',
        },
        {
          title: 'సౌరమానం ప్రకారం ఈనెలలో ధనుర్మాసం ప్రారంభమవుతుంది.',
        },
        {
          title: 'ధనుర్మాస విశిష్టతను బ్రహ్మాండ పురాణం.... భాగవతం..వైఖానసం మొదలైన గ్రంథాలు వివరిస్తున్నాయి..!',
        },
        {
          title: 'సూర్య భగవానుడు పన్నెండు నెలల్లో నెలకి ఒక మాసము చొప్పున మారుతూ ఉండేదాన్ని ‘సంక్రమణము’ అంటారు. మనకు సంవత్సరానికి పన్నెండు సంక్రమణములు వస్తాయి. ',
        },
        {
          title: 'సూర్యుడు తులారాశి నుండి వృశ్చిక రాశిలోనికి ప్రవేశించడం వృశ్చిక సంక్రమణము అంటారు.',
        },
        {
          title: 'ఈ మార్గశిర మాసము శ్రీ మహావిష్ణువుకు,',
        },
        {
          title: 'శ్రీ మహాలక్ష్మీదేవికి, సూర్యభగవానుడికి కూడా ప్రీతికరమైన మాసము.',
        },
        {
          title: 'పవిత్రమైన ‘భగవద్గీత’ జన్మించిన మాసం.',
        },
        {
          title: 'సూర్యుడు ధనూరాశిలో ఉండగా..విష్ణువును మేల్కొలిపే ధనుర్మాసవ్రతం చేయాలని పురాణాలు చెబుతున్నాయి. ఈ మాసంలోనే ధనుర్మాసం ప్రారంభమవుతుంది. ధనుర్మాసంలో ధనుర్మాస వ్రతాన్ని ఆచరించి ‘మదుసూధనుడు’ అనే నామముతో శ్రీ మహావిష్ణువును పూజించవలెను. ',
        },
        {
          title: 'ధనుర్మాసంలో ప్రతిరోజు విష్ణ్వాలయాలలో ప్రత్యేక అర్చనాదులు జరుగుతాయి.',
        },
        {
          title: '‘మార్గళివ్రతం’ అనే పేరుతో గోదాదేవి ఈ ధనుర్మాసమంతా విష్ణు వ్రతాన్ని చేపట్టి రోజుకొక్క పాశురంతో స్వామిని కీర్తించింది.',
        },
        {
          title: 'మార్గశీర్షంలో మృగశిరతో కూడిన పూర్ణిమ శ్రేష్ఠం. ఈ మాసంలో లవణం దానం చేయటం వల్ల ఈ మార్గశిర మాస విధులను పాటించడంవల్ల అనంతమైన పుణ్యఫలాలు ప్రాప్తిస్తాయి.',
        },
        {
          title: 'ఈ మాసమంతా శ్రీ విష్ణువును తులసీ దళముతో పూజించడం, పుణ్యప్రదం.',
        },
        {
          title: 'ద్వాదశినాడు పంచామృతాలతో అభిషేకం చేయవలెను. శ్రీ విష్ణుతోపాటు సూర్యున్ని కూడా పూజించి శుభాలను పొందాలని, ఏ పనిచేస్తున్నా ఈ మాసంలో ‘ఓం దామోదరాయనమః, ఓ నమో నారాయణయనమః’ అనే మంత్రాన్ని పఠించాలని శాస్త్ర వచనం.',
        },
        {
          title: 'ప్రతిరోజు బ్రాహ్మీముహూర్తంలో తులసి వృక్ష సన్నిధిలోని మృత్తికతో, తులసి ఆకులను తీసికొని ‘ఓం నమో నారాయణాయ’ అనే మంత్రాన్ని పఠిస్తూ శరీరానికి పూసుకుని స్నానమాచరించాలి.',
        },
        {
          title: 'ఈ మాసంలో పసుపు, ఆవాలు, మెంతులు , మిరియాలు, చింతపండు పెరుగు మొదలైనవి క్షార గుణాన్ని హరించి ఆరోగ్యాన్ని కాపాడతాయి కాబట్టి, వీటితో తయారైన పొంగలి..పులిహోర..దద్యోజనం మొదలగు మధురపదార్ధములు విష్ణువుకు నివేదించి ప్రసాదంగా స్వీకరించిన మంచిది.',
        },
        {
          title: 'మార్గశిర మాసంలోని గురువారాల్లో శ్రీ మహాలక్ష్మీని పూజిస్తూ ‘‘మార్గశిర లక్ష్మీవార వ్రతం” చేయడం, ద్వాదశి అభిషేకంవల్ల ఆయురారోగ్యాలు వృద్ధి చెందుతాయి.',
        },
        {
          title: 'ఆధ్యాత్మికపరంగా మానసిక శక్తిని ఇచ్చే ఈమార్గమాసంలో భగవంతునియందు లయించవలెనన్న తపనగలవారు అందరూ ఈ మార్గశిర మాసములో వైష్ణవప్రధానమైన లక్ష్మీ వ్రతాన్ని ఆచరించుటకు అర్హులే.',
        },
        {
          title: 'మార్గశిర శుద్ద పాడ్యమి నుండి ఈ మాసమంతా శ్రీ మహా విష్ణువు ని పూజిస్తారు. శ్రీ మహా విష్ణువుకి ప్రీతికరమైన ఈ మాసంలో ప్రాతః కాలంలో స్నానం చేసి విష్ణువుని ఆరాధించడం లేదా  శ్రీ విష్ణుసహస్రనామం స్తోత్రం పఠనం అనంతకోటి పుణ్య ఫలితాలనందిస్తుంది. ఈ మాసంలో చేసే నదీ స్నానాన్ని మార్గశీర్ష స్నానాలు అంటారు.',
        },
        {
          title: 'మార్గశిర శుద్ద పంచమి రోజున నాగ పూజ చేయడం విశేష ఫలితాన్నిస్తుంది. శుభకార్యాలు ప్రారంభించడానికి అనుకూలమైన రోజుగా చెప్పబడింది.',
        },
        {
          title: 'మార్గశిర శుద్ద షష్ఠి ని స్కంద షష్ఠి అని వ్యవహరిస్తారు. ఈ రోజు సుబ్రహ్మణ్య స్వామి ని శక్తికొలది పూజిస్తే సంతాన అనుకూలత కలుగుతుందని ప్రతీతి.',
        },
        {
          title: 'మార్గశిర శుద్ద సప్తమి ని భానుసప్తమి, జయసప్తమి, మిత్ర సప్తమి అని అంటారు. ఈ రోజు సూర్యారాధన చేసి పాయసం నివేదన చేస్తే అనేకమైన మంచి ఫలితాలు కలుగుతాయి.',
        },
        {
          title: 'మార్గశిర అష్టమిని కాలభైరవాష్టమి గా పిలుస్తారు, శివుని మరో రూపమే భైరవుడు. భైరవుడంటే పోషకుడని, భయంకరుడనే అర్ధాలు వస్తాయి. భైరవుని దగ్గర కాలుడు (కాలం) కూడా అణిగి ఉంటాడు కనుకనే కాలభైరవుడయ్యాడు. భైరవుణ్ణి శరణు కోరితే మృత్యు భయం తొలగిపోతుంది. ఈరోజు గంగా స్నానం, పితృ తర్పణం, శ్రాద్ధ కర్మలు ఆచరిస్తే ఏడాది మొత్తం లౌకిక, పార లౌకిక బాధల నుండి విముక్తి కలుగుతుంది. అలాగే భైరవుని వాహనమైన శునకానికి పాలు, పెరుగు, వంటివి ఆహారం గా ఇవ్వడం మంచిది.',
        },
        {
          title: 'మార్గశిర ఏకాదశి ని మోక్షద ఏకాదశి గా చెప్తారు. ఈరోజు శ్రీ మహా విష్ణువు కి అత్యంత ప్రీతికరమైన రోజుగా చెప్పబడింది. విష్ణు సహస్రనామ పారాయణం సర్వ పాపాలను తొలగిస్తుంది. ఈ రోజున చేసుకొనే ఉత్తర ద్వారా దర్శనం వలన మోక్షం లభిస్తుందని చెప్తారు. మార్గశిర శుద్ద ఏకాదశి గీతా జయంతి. భగవద్గీత  పారాయణం, పార్ధసారధిని (కృష్ణుని) ఆరాధన చేయడం మంచిది.',
        },
        {
          title: 'ఈ మాసంలో వచ్చే ద్వాదశి ని అఖండ ద్వాదశి అంటారు. మార్గశిర శుద్ద త్రయోదశి నాడు హనుమత్భక్తులు హన్మద్వ్రతం ఆచరిస్తారు. సంతానం లేని దంపతులు ఆచరిస్తే సంతానం కలుగుతుంది.',
        },
        {
          title: 'మార్గశిర శుద్ద పౌర్ణమి నాడు దత్తాత్రేయ జయంతి. దత్తాత్రేయుడంటే సాక్ష్యాత్తు త్రిమూర్తి స్వరూపం. అనఘావ్రతం ఆచరించి స్వామీని పూజిస్తే సకల పాపాలు తొలగుతాయి.',
        },
        {
          title: 'కార్తీక పౌర్ణమి నుండి మార్గశిర పౌర్ణమి వరకు యమధర్మ రాజు కోరలు తెరుచుకొని ఉంటాడు, ఈ రోజుల్ని యమదంష్ట్రులుగా చెబుతారు.',
        },
        {
          title: 'మార్గశిర పౌర్ణమి తో అనేక రకమైన వ్యాదులు, అనారోగ్య సమస్యలు తొలగుతాయి, కనుక కృతజ్ఞత పూర్వకంగా ఈ దినం. యమధర్మ రాజుని ఆరాదిస్తారు. ఈ పౌర్ణమి ని కోరల పున్నమి, నరక పౌర్ణమి అని కూడా పిలుస్తారు.',
        },
        {
          title: 'మార్గశిరం..ఆధ్యాత్మిక భావ వికాసానికి ప్రతీక. కార్తీకంలో పుణ్యనదీ స్నానాలతో తరించిన భక్తుల హృదయాలు. మార్గశిర మాసంలో మరింత భగవచ్చింతనలో తన్మయమవుతాయి..!! ',
        },
        {
          title: 'నిర్మలమైన ఆకాశం మాదిరిగా మనస్సులు కూడా ఈ మాసంలో నిర్మలంగా ఉంటాయి.!!',
        },
        {
          title: 'తూర్పు తెలతెలవారుతుండగా పొగమంచు ఇంకా విచ్చిపోకముందే ముంగిట రకరకాల ముగ్గులు, వరిపిండితోనూ సున్నపుపిండితోనూ వేసి వాటి మధ్య బంతిపూలు తురిమిన గొబ్బిళ్లు పెట్టే ఆడపిల్లలు. తెలుగు పల్లెటూళ్ల ధనుర్మాస శోభకు వన్నెలు చేకూరుస్తారు.',
        }
      ],
      "title": 'మార్గశిర మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>పుష్య మాసం విశిష్టత :</span>
        },
        {
          title: 'చంద్రుడు పుష్యమి నక్షత్రంలో ఉండగా వచ్చే మాసం పుష్య మాసం. *“పుష్య”* అనే మాటకు పోషణ శక్తి కలిగినది అని అర్ధం. పుష్య మాసం శీతాకాలం.',
        },
        {
          title: 'ఆధ్యాత్మికంగా జపతపాదులు , ధ్యాన పారాయణలకు శ్రేష్ఠమైన మాసమిది. పితృదేవతలను పూజించి అందరు దోషరహితులయ్యే పుణ్య మాసం పుష్యం. పుష్య పౌర్ణమి వేదాధ్యయానికి చాలా విశిష్టమైనదిగా చెప్పబడింది. శ్రావణ పౌర్ణమి మొదలు పుష్య పౌర్ణమి వరకు వేదాలు , మంత్రాలు నేర్చుకోవడానికి అనువైన సమయం గా చెప్పబడింది.',
        },
        {
          title: 'విష్ణువుకు ఇష్టమైన మాసం ఆశ్వీయుజం. శివునకు కార్తీకం. అలాగే పుష్యమాసం శనీశ్వరుడికి పరమ ప్రీతికరం. ఎందుకంటే ఆయన జన్మనక్షత్రం పుష్యమి. ఈ నెలంతా శనైశ్చరుణ్ని పూజించే వారిపట్ల శని ప్రసన్నుడై శుభాలు కలిగిస్తాడని పురాణాలు తెలుపుతున్నాయి.',
        },
        {
          title: 'ఏలినాటి శనితో బాధపడేవారు ఈ మాసంలో రోజూ ఉదయానే శుచిగా స్నానం చేసి శనీశ్వరుణ్ణి భక్తితో ప్రార్థిస్తారు. పౌర్ణమి నాడు శనికి తైలాభిషేకం జరిపించి నవ్వులు దానమిస్తారు. ఆయనకు ఇష్టమైన నువ్వులు , బెల్లం ఆహారంలో భాగం చేసుకుంటారు. దీనివెనుక శాస్త్రీయ కోణం చుస్తే  ఈ రెండూ పదార్ధాలు మనిషి ఓంట్లో వేడిని పెంచి చలి నుంచి రక్షిస్తాయి.',
        },
        {
          title: 'శని ధర్మదర్శి న్యాయం , సత్యం , ధర్మాలను ఎత్తి చూపించేవాడు. సర్వప్రాణుల సమస్త విశ్వ ప్రేమను , పవిత్రతను ఉద్ధరిచేవాడు అతడే . మానవుడు ఈ నెలలో నువ్వులు సేవించి , నియమ నిష్ఠులు పాటించినట్లు అయితే శని అనుగ్రహం పొందవచ్చు.',
        },
        {
          title: 'అంతే గాక గరుడ పురాణంలో నాభిస్థానం శని స్థానం అని చెప్పబడింది. ఎప్పుడు శరీరంలోని నాభి ప్రదేశాన్ని శని ప్రదేశంగా చెప్పారో అప్పుడే ఈ ప్రదేశానికి ఉన్న ప్రాముఖ్యమంతటికి శని ప్రభావమే కారణం అని మనం గ్రహించాలి.',
        },
        {
          title: 'పుష్యమాసం తొలి అర్ధభాగంలో విష్ణుమూర్తిని పూజించడం అనాదిగా వస్తున్న ఆచారం. పుష్య శుక్ల విదియ నుంచి పంచమి వరకు శ్రీ హరిని తులసీదళాలతో పూజిస్తే సౌందర్యం లభిస్తుందని ఒక నమ్మకం.',
        },
        {
          title: 'అలాగే సోమవారాల్లో శివుడిని మారేడు దళాలతోనూ ఆదివారాల్లో సూర్యుణ్ణి జిల్లేడు పూలతోనూ అర్చిస్తారు. శుక్ల పక్ష షష్ఠినాడు తమిళులు కుమారస్వామిని పూజిస్తారు. మనకు మార్గశిర శుద్ధ షష్ఠి ( సుబ్రహ్మణ్య షష్ఠి ) ఎలాగో వారికి ఈ రోజు అంత పవిత్రమైనది.',
        },
        {
          title: 'ఇక శుక్ల పక్షంలో వచ్చే అష్టమిరోజు  పితృదేవతలను ఆరాధిస్తారు. ఈ మాసంలో శుద్ధ ఏకాదశిని పుత్రదా ఏకాదశి అంటారు. ఈ రోజున ఏకాదశి వ్రతం ఆచరిస్తే పుత్ర సంతానం కలుగుతుందని విశ్వాసం. పుష్యమాసంలో వస్త్రదానం విశేష ఫలితాలనిస్తుందని ప్రతీతి. చలితో బాధపడేవారిని ఆదుకోవడమే ఈ నియమం వెనుక సదుద్దేశం.',
        },
        {
          title: 'పుష్యమాసంలో వచ్చే పెద్ద పండుగ సంక్రాంతి. సంక్రాంతి ముందు జరుపుకునే పండుగ భోగి. చీకటితోనే లేచి చలి మంటలతో చీకట్లను పారద్రోలుతారు. దక్షిణాయనానికీ , ధనుర్మాసానికీ ఆఖరు రోజు ఇది. భోగినాడు వైష్ణవాలయాల్లో గోదారంగనాథుల కల్యాణాన్ని కన్నుల పండువగా జరుపుతారు. మర్నాడు సూర్యుడు మకర రాశిలోకి ప్రవేశించే దినమే మకర సంక్రాంతి.',
        },
        {
          title: 'ఆ రోజు నుండి భక్తులంతా పరమ పవిత్రంగా భావించే ఉత్తరాయణం ప్రారంభమవుతుంది. సంక్రమణం నాడు రాత్రిపూట భోజనం చేయకూడదని పురాణాలు చెబుతున్నాయి. సంక్రాంతి నాడు శివుడ్ని ఆవునేతితోనూ , నువ్వులతోనూ అభిషేకిస్తే దరిద్రం తొలగిపోయి సకల భోగభాగ్యాలూ కలుగుతాయని ప్రతీతి.',
        },
        {
          title: 'సంక్రాంతి మరుసటి రోజు కనుమ పండుగ చేస్తారు. ఈ రోజు ధాన్యరాశులనూ వ్యవసాయంలో సహకరించే పశువులనూ లక్ష్మీ స్వరూపంగా భావించి పూజిస్తారు. పుష్య బహుళ ఏకాదశిని విమలైకాదశి , సఫలైకాదశి, షట్తిలైకాదశి , కల్యాణైకాదశి అని పిలుస్తారు.',
        },
        {
          title: 'సున్నిపిండితో ఒంటిని రుద్దుకుని నువ్వులు కలిపిన నీటిలో స్నానం చేయడం , నువ్వుల్ని ఆహారంలో భాగం చేసుకోవడం , మంచినీటిలోనూ నువ్వులు కలుపుకొని తాగడం , తిలదానం చేయడం ఈ ఏకాదశి రోజు చేస్తారు.',
        },
        {
          title: 'ఈ మాసంలో ఆఖరు రోజైన అమావాస్యను చొల్లంగి అమావాస్య అంటారు. ఈ రోజు నది స్నానాదులు చేసుకుని దైవదర్శనం చేసుకుంటే శుభాలు కలుగుతాయి , పితృ తర్పణాలు , ఆబ్దికాదులు ఉంటే వారి పేరుతో అన్న దానాలు పేదవారికి చేస్తే విశేషించి పుణ్యఫలంతో పాటు పితృదేవతల అనుగ్రహం కలుగుతుంది.',
        },
        {
          title: 'పుష్యమాసములో సూర్యోదయ సమయమున ప్రసరించు సూర్య కాంతి అద్భుతమగు యోగచైతన్యమును ప్రసాదింపగలదు. పుష్యమి చాలా అద్భుతమైన నక్షత్రము. చెప్పలేనంత కాంతిని దర్శనము చేయించే మాసము పుష్యమాసము. ఉత్తరాయణ పుణ్యకాలములో  సూర్యుడు దక్షిణము నుండి ఉత్తరదిశగా పయనము సాగిస్తాడు. అనగా ఊర్ద్వముఖముగా ప్రయాణము.',
        },
        {
          title: 'మనలోని ప్రాణశక్తి బలమును కూర్చుకొను సమయము. సూర్యకిరణముల యందు ఒక ప్రత్యేకమైన హిరణ్మయమైన కాంతి ఉండును. ఇది మన బుద్ధిని ప్రచోదనము గావించును. మనస్సును అంటిపెట్టుకున్న స్వభావము నందలి అశుభములను ఆ కాంతి హరింపగలదు. బుద్ధిబలము , ప్రాణబలము పుష్టిగా లభించు మాసము పుష్యమాసము.',
        }
      ],
      "title": 'పుష్య మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>మాఘ మాసం విశిష్టత :</span>
        },
        {
          title: 'మాఘ మాసం ఎంతో విశిష్టమైనది. ఈ మాసంలో వచ్చే ముఖ్యమైన తిథి శుక్ల పక్ష చవితి దీనిని తిల చతుర్థి అం టారు. దీన్నే కుంద చతుర్థి అని కూడా అంటారు. నువ్వులను తింటారు. నువ్వులతో లడ్లు చేసి పంచి పెడతారు. ఈ రోజున డుంఢిరాజును ఉద్దేశించి, నక్త వ్రతము పూజ చేస్తారు! డుంఢిని ఈ విధంగా పూజించడం వలన దేవతల చేత సైతం పూజలందుకుంటారని కాశీ ఖండములో తెలియజేశారు. మాఘమాసం తెలుగు సంవత్సరంలో పదకొండవ నెల. చంద్రుడు మఖ నక్షత్రంతో కూడుకున్న మాసం కాబట్టి ఇది మాఘమాసం అయింది. ఉత్తరాయణ పుణ్యకాలంలో వచ్చే ఈ మాసం విష్ణుమూర్తికి ప్రీతిపాత్రమైనది.',
        },
        {
          title: 'కుంద చతుర్థి నాడు కుంద పుష్పాలతో పరమేశ్వరుని అర్పించి రాత్రి జాగారణ చేసినవారు, సకలైశ్వర్యాలను పొందుతారని కాలదర్శనంలో చెప్పబడింది. అయితే సాయంకాలం చతుర్థి ఉంటే ఉత్తమం అని ఈ సందర్భంలో తెలుసుకోవాలి. మాఘమాసంలో ప్రాత:కాలంలో చేసే స్నాన,జప,తపములు చాలా ఉత్తమమైనవి. ఈ మాసంలో స్నానం చేసేటప్పుడు దు:ఖ దారిద్ర్య నాశాయ, శ్రీ విష్ణోతోషణాయచ! ప్రాత:స్నానం కరోమ్య, మాఘ పాప వినాశనం! అని చేసిన తరువాత',
        },
        {
          title: 'సవిత్రేప్రసవిత్రేచ! పరంధామజలేమమ! త్వత్తేజసా పరిబ్రష్టం,పాపం యాతు సస్రదా! అని చదవాలి.',
        },
        {
          title: 'సూర్య భగవానునికి ఆర్గ్యమివ్వాలి',
        },
        {
          title: 'ఈ మాసాన్ని కుంభమాసం అని కూడా అంటారు.కొంతమంది ఈ నెల్లాళ్ళు ముల్లంగి దుంపను తినరు.',
        },
        {
          title: 'ఈ మాసంలో నవ్వులను, పంచదారను కలిపి కలిపి తినాలట. నువ్వులను దానమివ్వాలట. రాగి పాత్రలో గోధుమ రంగుగా ఉన్న నువ్వులను పాత్రతో సహా దానమిస్తే మంచిది.ఈ నెలలో మరణించిన వారికి అమృతత్వం సిద్దిస్తుందట.',
        },
        {
          title: 'మాఘశుద్ద పంచమిని శ్రీ పంచమి అంటారు. ఈ పంచమి నాడే సరస్వతీదేవి జన్మించిందట.',
        },
        {
          title: 'ఈనాడు రతీ మన్మధులను మల్లెపూలతో పూజిస్తారు.ఉత్తర భారతంలో విష్ణుమూర్తిని, సరస్వతీదేవిని కూడా పూజిస్తారు. బ్రహ్మదేవుడు సృష్టి చేయగా చరాచర ప్రపంచం శ్మశాన నిశ్శబ్ధతతో ఉందట. అవేదనతో తన కమండలంలోని నీటిని ప్రపంచంపై చిలకరించగా చెట్లపై ఆ నీటి బిందువులు పడి ఒక శక్తి ఉద్భవించిందట. రెండు చేతులతో వీణను వాయిస్తూ మరో రెండు చేతులతో పుస్తకాన్ని మాలను ధరించి సమగ్ర రూపిణిగా దర్శనమిచ్చిందట. ఆ వగీశ్వరి వీణావాదనం ద్వారా ప్రపంచంలోని స్తబ్థతను ఉదాసీనతను తొలగించి విద్యాబుద్దులకు అదిష్టాత్రి అయింది ఆ దేవి.',
        },
        {
          title: 'అప్పటి నుండి శ్రీ పంచమి రోజును సరస్వతిని పూజించడం జరుగుతుంది. ఇక ',
        },
        {
          title: 'మాఘశుద్ద సప్తమి ఇదే సూర్య సప్తమి అని కూడా పిలువబడుతుంది.ఇదే రథసప్తమి సుర్య గ్రహణదినం వలె ఇది పరమపవిత్రమైనది.ఈ రోజున అరుణోదయకాలంలో ఏడు జిల్లేడు ఆకులను అందులో రేగికాయలను ఉంచుకొని తలాపై పెట్టుకొని స్నానం చేస్తే ఏడు విధాలైన శాపాలు నశిస్తాయట_*. స్నానికి ముందు చెరకుగడతో నీటిని కదిలిస్తారు. *_నమస్కారం ప్రియ:సూర్య:_* అన్న ఆర్య వాక్య ప్రకారం కేవలం నమస్కారం చేతనే సూర్యుడు సంతృపి చెందుతాడని తెలుస్తుంది.ఈ రోజున *_చిక్కుడుకాయలతో రథం చేసి కొత్త బియ్యంతో పాయసాన్ని వండి చిక్కుడు అకులలో పెట్టి సూర్యునికి నివేదన చేయడం ఆచారం.',
        },
        {
          title: 'సూర్యుడు తనను పూజించిన సత్రాజిత్తుకి ఈ రోజునే "శమంతకమణి" ప్రసాదించాడు. హనుమంతునికి వ్యాకరణ శాస్త్రాన్ని యజవాల్క్యునికి యజుర్వేదాన్ని బోధించాడు. ఆరోగ్యం భాస్కరాదిచ్చేత్ అన్న వాక్యం ప్రకారం ఆరోగ్యం కొరకు ఆదిత్య హృదయం పారాయణ చెయ్యాలి. రథసప్తమి నాటి స్నానం *_సప్త సప్త మహాసప్త ద్వీపా వసుంధరా! కోటి జన్మార్జితంపాపిం వినశ్యతితత్‌క్షణాత్_* అన్నట్లుగా పాప విముక్తి కలిగిస్తుందట. భీష్మాష్టమి "మాఘమానస్యచాష్టమ్యాం శుక్ల పక్షేచ పార్థివ!ప్రాజాపత్యేచ నక్షత్రే మధ్య:ప్రాప్తే దివాకరే!" శోభకృత నామ సంవత్సరంలో *_మాఘమాసంలో శుక్లపక్షంలో రోహిణి నక్షత్రం ఉన్న అష్టమి తిథినాడు మధ్యాహ్నం సూర్యుడు నడినెత్తిన ప్రకాశిస్తూ ఉండగా అభిజిత్ లగ్నంలో భీష్మ పితామహుడు ధ్యాన స్థితుడై ప్రాణాలను విడిచిపెట్టాడట.',
        },
        {
          title: 'స్వచ్చంద మరణం ఆయనకి వరం. ఆయనకు తర్పణలు విడిచి పెట్టడం నెలగంటు పెట్టినప్పటినుంచీ పెట్టిన గొబ్బెమ్మలను ఎండబెట్టి దాచి ఆ పిడకలతో పాయసాన్ని వండి నివేదన చేయడం ముఖ్యం. అష్టమినాడే దైవ సాయుజ్యం పొందినా శ్రీ కృష్ణుని సమక్షంలోనే విష్ణుసహస్రనామాలతో ఆయనను కీర్తిస్తూ మోక్షం పొందాడు. కాబట్టి ఏకాదశిని ఆయన పేరుతో ఏర్పాటు చేశారు. *_భీష్మ ఏకాదశి_* నాడు విశేష పూజలు చేయడం ఆనవాయితీ. ఇక మాఘమాసంలో వచ్చే *_ప్రతి ఆదివారాలు మహిమాన్వితాలే._* ఈ విధంగా *_మాఘమాసమంతా "శివరాత్రి"వరకూ అన్నీ పర్వదినాలే.',
        }
      ],
      "title": 'మాఘ మాసం విశిష్టత',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>ఫాల్గునమాసం విశిష్టత :</span>
        },
        {
          title: 'పౌర్ణమినాడు ఫల్గునీ నక్షత్రం ఉన్న చాంద్రమాన మాసం ఫాల్గునమాసం. ఫాల్గుణము అని వ్రాయకూడదు. ఫాల్గునము అన్న అక్షర క్రమమే సరైన శబ్ద స్వరూపము. ఉత్తర ఫల్గునీ నక్షత్రం నాడు పుట్టిన పాండవ మధ్యముడు ఫల్గునుడయ్యాడు. ఈ మాసం శిశిర ఋతువుకు పరాకాష్ఠ. వసంత ఋతువుకు ద్వారం వంటిది.',
        },
        {
          title: 'శ్రీమహావిష్ణువుకు అత్యంత ప్రీతికరమైన మాసం - ఫాల్గుణ మాసం. ఫాల్గుణమాసంలో మొదటి పెన్నెండు రోజులు, అంటే శుక్లపక్షపాడ్యమి మొదలు ద్వాదశి వరకూ శ్రీమహావిష్ణువు పూజకు ఉత్కృష్టమైన రోజులు. ప్రతి రోజూ తెల్లవారు ఘామునే నిద్రలేచి కాలకృత్యాలు తీర్చుకుని, శిరస్నానం చేసి సూర్యభగవానుడికి అర్ఘ్యం ఇచ్చిన అనంతరం, శ్రీమహావిష్ణువును షోడశోపచారాలు, అష్టోత్తరాలతో పూజించి, పాలను నైవేద్యంగా సమర్పించాలి.',
        },
        {
          title: 'ఈ పన్నెండురోజుల్లో ఒకరోజుగానీ లేదంటే ద్వాదశి నాడుగానీ వస్త్రాలు, వివిధదాన్యాలను పండితులకు దానముగా ఇవ్వడం మంచిది. శక్తివున్నవారు ఏదైనా వైష్ణవాలయానికి ఆవును దానమివ్వడం విశేష ఫలితాలనిస్తుంది. పూర్ణిమనాడు పరమశివుడిని, శ్రీకృష్ణపరమాత్మను, మహాలక్ష్మినీ పూజించడంతో పాటూ "లింగపురాణం" ను దానముగా ఇవ్వడం మంచిది. అట్లే ఈనాటి సాయంత్రం శ్రీకృష్ణుడిని ఉయ్యాలలో వేసి ఊపవలెను. దీనిని డోలోత్సవం అని అంటారు. దీనినే కొన్ని ప్రాంతాలలో డోలాపూర్ణిమ అని అంటారు. నరాడోలాగతం దృష్ట్యా గోవిందం పురుషోత్తమం ఫాల్గున్యాం ప్రయతోభూత్వా గోవిందస్య పురంప్రజేత్‌ ఉయ్యాలలో అర్చింపబడిన పురుషోత్తముడైన గోవిందుని ఈ రోజున దర్శించిన భక్తులకు వైకుంఠప్రాప్తి కలుగుతుందని ధర్మశాస్త్రాలు ఘోషిస్తున్నాయి.',
        },
        {
          title: 'ఈ రోజున రంగుపొడులను, రంగునీళ్ళను చల్లుకోవాలని చెప్పబడింది. ఈ రోజున ఉదయాన్నే నూనెతో తలంటిస్నానం చేసి చూత కుసుమ భక్షణం తప్పక చేయాలని శాస్త్రాలు చెబుతున్నాయి. ఈ పూజ ప్రకారం, ఇంటిని శుభ్రం చేసి, ఇంటి ప్రాంగణంలో తెల్లనిగుడ్డను ఆసనంగా తూర్పుముఖంగా కూర్చుని, ఒక ముత్తైదువుచే వందన తిలకం, నీరాజనాన్ని పొంది చందనంతో కూడిన మామిడి పువ్వులను తినాలి. చూతమగ్ర్యం వసంతస్య మాకందకుసుమం తద సచందనం పిచామ్యద్య సర్వకామ్యార్థ సిద్దయే అనే శ్లోకంతో మామిడిపూతను స్వీకరించాలి. అనంతరం రంగులను నృత్యగానాదులతో చల్లుకోవాలని చెప్పబడింది.',
        },
        {
          title: 'అట్లే, హరిహరసుతుడు అయిన అయ్యప్పస్వామి వారు జన్మించిన దినం కూడా ఈనాడే కనుక వారిని పూజించడం విశేష ఫలితాలనిస్తుంది. ఫాల్గుణమాసంలో పూర్ణిమరోజున హోళీపండుగను నిర్వహిస్తుంటారు. ఈ పూర్ణిమ శక్తితో కూడినది. ఏ సంవత్సరమైనా పూర్ణిమ, ఉత్తరఫల్గుణి కలిసి వస్తే, ఆ రోజున మహాలక్ష్మిని షోడశోపచారాలతో ఆరాధించి, లక్ష్మీ అష్టోత్తర శతనామాలు, కనకధారా స్తోత్రాలను పారాయణం చేయడం మంచిది. హోళిరోజూన లక్ష్మీదేవిని ఆరాధిస్తే సమస్త శుభములు కలుగుతాయని పెద్దలవాక్కు. కొన్ని దక్షిణాది ఆలయాలలో ఫాల్గుణపూర్ణిమను చాలా గొప్పగా చేస్తారు.',
        },
        {
          title: 'ఈ ఉత్సవం వెనుక ఒక కథ ఉంది. ఒకసారి పార్వతి తన ప్రభావం చేత శివుని కళ్ళు మూతపడేటట్లు చేసింది. శివుని కళ్ళు మూతపడినందు వల్ల జగమంతా అంధకారబంధురమైంది. శివుడు కోపగించు కోవడంతో, అలిగిన పార్వతీదేవి కాంచీపురానికి వచ్చి, తిరిగి శివుని అభిమానాన్ని పొందేందుకు ఒక మామిడి చెట్టు కింద కూర్చుని తపస్సు చేయడం ప్రారంభించింది. ఒకానొక పాల్గుణపూర్ణిమనాడు మామిడి చెట్టు కింద పార్వతీదేవి ప్రాయశ్చిత్త కర్మకాండను పూర్తిచేసింది.',
        },
        {
          title: 'అప్పుడు సంతసించిన శివుడు పార్వతిని అనుగ్రహించాడు. అప్పటినుంచి కాంచీపురంలో ఫాల్గుణ పూర్ణిమ ఉత్సవం జరుగుతుంది. ఈ ఉత్సవాన్ని చూసేందుకు దేశం నలుమూలల నుంచి భక్తులు వస్తుంటారు. ఫాల్గుణ మాసములో ఈ విధమైన పూజలను, దానాలను చేయడం వల్ల అనంతమైన పుణ్యఫలాలు లభిస్తాయని శాస్త్రవచనం.',
        }
      ],
      "title": 'ఫాల్గునమాసం విశిష్టత',
    }
  ],
  "Kartheekapuranam": [
   
    {
      "CatID": [
        {
          title: <span class='highlight'>చైత్ర మాసం విశిష్టత :</span>
        },
        {
          title: 'ఋతూనాం కుసుమాకరాం అని భగవానుడు స్వయంగా తానే వసంత ఋతువునని భగవద్గీతలో చెప్పుకున్న వసంత ఋతువులో తొలి మాసం చైత్రమాసం.',
        },
        {
          title: 'సంవత్సరానికి తొలి మాసం కూడా. చైత్రమాసం అనగానే మనకి ఉగాది, శ్రీరామనవమి గుర్తుకొస్తాయి.',
        },
        {
          title: 'అవే కాదు, దశావతారాలలో మొదటిది అయిన మత్స్యావతారం, యజ్ఞ వరాహమూర్తి జయంతి, సౌభాగ్యగౌరీ వ్రతం వంటి విశిష్టమైన రోజులెన్నో ఈ మాసంలోనే ఉన్నాయి.',
        },
        {
          title: 'అలా చైత్ర మాసం సంవత్సరానికి మొదటి నెలగా మాత్రమే కాక, అనేక ఆధ్యాత్మిక, పౌరాణిక విశిష్టతలు కలిగిన మాసం కూడా.',
        },
        {
          title: 'ఈ మాసంలో చంద్రుడు పౌర్ణమినాడు చిత్త నక్షత్రంతో కూడి ఉంటాడు. సూర్యుడు కూడా మొదటిరాశియైన మేషరాశిలో సంచరిస్తున్నాడు.',
        },
        {
          title: 'ప్రభవ నామ సంవత్సరంతో ప్రారంభమైన తెలుగు సంవత్సరాలు అక్షయతో ముగుస్తాయి.',
        },
        {
          title: 'అంటే మనిషి పుట్టిన సంవత్సరం నుంచి తిరిగి అరవై ఏళ్ల తర్వాత అదే సంవత్సరం మొదలువుతుంది.',
        },
        {
          title: 'అప్పటి నుంచి మళ్లీ బాల్యావస్థ మొదలవుతుంది.',
        },
        {
          title: 'అంటే చిన్న పిల్లల్లా ప్రవర్తిస్తుంటారు. అకారణంగా అలగడం, అవీ.. ఇవీ తినాలని అడగటం, చిన్న చిన్న దొంగతనాలు చేయటం, ఎక్కువసేపు నిద్రపోవటం, చిన్న విషయాలకే ఆనంద పడటం, కోపం తెచ్చుకోవటం, కన్నీళ్లు పెట్టుకోవడం ఇలాంటి బాల్య చేష్టలన్నీ అరవైఏళ్ల నుంచి నెమ్మదిగా ప్రారంభమవుతాయి.',
        },
        {
          title: 'ప్రతి కొడుకూ అరవై సంవత్సరాలు వచ్చిన నాటి నుంచి తన తండ్రిని తన బిడ్డలతో సమానంగా చూసుకోవాలని ధర్మశాస్త్రం చెబుతోంది.',
        },
        {
          title: 'ఆరుపదుల జీవితాన్ని ఎవరైతే ఆనందంగా జీవిస్తారో వారి జీవితం ధన్యం. ఆ ధన్యజీవితపు జ్ఞాపకార్థమే బిడ్డలు, మనవళ్లు బంధువులు మిత్రులు కలిసి షష్టిపూర్తి చేస్తారు.',
        },
        {
          title: 'ఇక ధర్మశాస్త్రం ప్రకారం చూసుకుంటే కృత, త్రేతా, ద్వాపర యుగాల్లో మానవ ఆయుర్దాయం 180 సంవత్సరాలు.',
        },
        {
          title: 'కలియుగానికి వచ్చే సరికి కలి ప్రభావంతో 120 సంవత్సరాలకు పడిపోయింది.',
        },
        {
          title: 'అందుకే 60ఏళ్లు పూర్తవగానే షష్టి పూర్తి చేస్తారు. అంటే దీనర్థం. మొదటి 60ఏళ్లు పూర్తవగానే లోక సంబంధ విషయాలు పూర్తయినట్లు భావించాలి.',
        },
        {
          title: 'మిగిలిన 60ఏళ్లు ఆధ్యాత్మిక చింతనతో బతకాలని ధర్మశాస్త్రం చెబుతోంది.',
        },
        {
          title: 'పురాణ గాథ! :',
        },
        {
          title: 'ఒకానొక సమయంలో నారద మునీంద్రుడు తానంత గొప్ప భక్తుడు లేడని, ఆ గర్వంతో విర్ర వీగుతున్నాడట. అప్పుడు శ్రీమహా విష్ణుడు అతడికి జ్ఞాన బోధ చేయాలని తలంచాడు.',
        },
        {
          title: 'దీంతో నారదుడిని మాయ ఆవరించేలా చేసి ఒక సరస్సు తీసుకెళ్లి అందులో దిగి స్నానం చేయమన్నాడు. నారదుడు అందులో దిగి స్నానం చేయగానే, ఒక్కసారి పూర్వ స్మృతిని మర్చిపోయి, స్త్రీ రూపం ఎత్తాడు.',
        },
        {
          title: 'అదే సమయంలో దారితప్పి అక్కడకు వచ్చిన ఓ మహారాజును చూసి మోహించి, వివాహం చేసుకుని 60మంది పిల్లలను కన్నాడు.',
        },
        {
          title: 'వారే.. ప్రభవ.. విభవ.. శుక్ల.. చివరిగా అక్షయ. వారంతా ఒకరి తర్వాత ఒకరు యుద్ధంలో మరణిస్తుండటంతో పుత్రశోకంతో ఉండిపోయాడు.',
        },
        {
          title: 'సంసార సాగరంలో మునిగిపోయి అసలు తానెవరో మర్చిపోయాడు. అప్పుడు నారదుడిని ఆవరించిన మాయను శ్రీహరి తొలగించి, ఇదీ సంసారం అంటే నీవు ఏదో గొప్ప భక్తుడవని భావిస్తున్నావు. అని జ్ఞానబోధ చేశాడట.',
        },
        {
          title: 'నీ పిల్లలు 60 సంవత్సరాలుగా కాలచక్రంలో తిరుగుతుంటారు అని విష్ణుమూర్తి వరమిస్తాడు. అవే మన తెలుగు సంవత్సరాలుగా ప్రస్తుతం వాడుకలో ఉన్నాయి.',
        }
      ],
      "title": 'కార్తీక పురాణం part-1',
      // "img": require('../imgs/Astotaram/VenkateswaraSwami.png')
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>వైశాఖ మాసం విశిష్టత :</span>
        },
        {
          title: 'వైశాఖ మాసానికి మరో పేరు మాధవ మాసం. మాసాలన్నింట్లో వైశాఖమాసం ఉత్తమమైనది. విశేషదానాలకి ఎంతో పుణ్య ప్రదమైన మాసంగా పురాణాలలో చెప్పబడింది. శ్రీ మహా విష్ణువు కు ప్రీతి కరమైన ఈ వైశాఖ మాసం లో తులసి దళాలతో శ్రీ మహావిష్ణువును లక్ష్మీదేవితో కలిపి పూజించిన వారికి ముక్తి దాయకం.',
        },
        {
          title: 'ఈ మాసం లో ఏక భుక్తం , నక్తం అయాచితం గా భుజించడం ఉత్తమం గా చెప్పబడింది. వైశాఖ మాసం దేవతలతో సహా అందరికీ పూజనీయమైనది. యజ్ఞాలకు , తపస్సులకు పూజాదికాలకు , దాన ధర్మాలకు ఎంతో ఎక్కువ ఫలమిచ్చి శాంతినిచ్చి కోరికలను తీరుస్తుంది.',
        },
        {
          title: 'ఎవరైతే ఈ మాసం లో సూర్యోదయానికి ముందే లేచి స్నానం చేస్తారో, వారికి ఉత్తమగతులు కలుగుతాయి. ఉదయాన్నే స్నానం చేసి ఎక్కువ నీటి తో రావి చెట్టు మొదళ్ళను తడిపి ప్రదక్షిణాలు చేస్తే పూర్వీకులంతా తరిస్తారు. ఈ మాసం లో శివునికి ధారపాత్ర ద్వారా అభిషేకం జరిగేలా ఏర్పాటు చేయడం శుభ ఫలితాలనిస్తుంది.',
        },
        {
          title: 'మన సంస్కృతి ఉత్కృష్టమైనది. మనకు ఈ ప్రకృతి అందులోని చరాచరాలన్ని పూజనీయాలే ! అంతేకాకుండా మనం కాలగణనకు ఉపయోగించే తిథులు , నక్షత్రాలు , వారాలు , మాసాలు అన్నీ ఎంతో గొప్పదనాన్ని , ప్రత్యేకతను సంతరించుకున్నటువంటివే.',
        },
        {
          title: 'చాంద్రమానం పాటించే మనకు చైత్రం మొదలుకుని ఫాల్గుణం వరకు పన్నెండు నెలలు ఉన్నాయి. ఒక్కో మాసానికి ఒక్కో ప్రత్యేకత, విశిష్టత ఉన్నాయి.',
        },
        {
          title: 'కార్తీక, మాఘ మాసాల తర్వాత అంతటి మహత్యాన్ని స్వంతం చేసుకున్న పుణ్యప్రదమైన మాసం వైశాఖం. ఈ నెలలోనే పూర్ణిమ తిథినాడు విశాఖ నక్షత్రం ఉండడం వల్ల ఈ మాసానికి వైశాఖమాసం అనే పేరు ఏర్పడింది.',
        },
        {
          title: 'ఆద్యాత్మికత , పవిత్రత , దైవశక్తి ఉన్న నెలల్లో వైశాఖమాసానికి ప్రత్యేక స్థానం ఉంది.',
        },
        {
          title: 'ఇది శ్రీ మహావిష్ణువుకు అత్యంత ప్రీతిపాకరమైన నెల. అందువల్లనే వైశాఖమాసానికి మాధవమాసం అని పేరు. అత్యంత పవిత్రమైన మాసంగా పేరుపొందిన వైశాఖమాస మాహత్మ్యంను పూర్వం శ్రీమహావిష్ణువు స్వయంగా శ్రీమహాలక్ష్మికి వివరించినట్టు పురాణాలు పేర్కొంటున్నాయి. అత్యంత పవిత్రమైన మాసంగా చెప్పబడుతూ ఉన్న వైశాఖమాసంలో ప్రతి దినమూ పుణ్యదినమే',
        },
        {
          title: 'అటువంటి ముప్పై పుణ్యదినాలు కలిగిన ఈ మాసంలో ఆచరించాల్సిన విధులు పురాణ గ్రంధాల్లో వివరించబడ్డాయి. ముఖ్యంగా స్నాన , పూజ , దానధర్మాల వంటి వాటిని ఈ నెలలో ఆచరించడం వల్ల మానవుడికి ఇహలోకంలో సౌఖ్యం , పరలోకంలో మోక్షం సిద్ధిస్తాయని పురాణ కథనం.',
        },
        {
          title: 'వైశాఖమాసంలో నదీ స్నానం ఉత్తమమైనదిగా చెప్పబడింది. అందుకు అవకాశం లేని స్థితిలో గంగ , గోదావరి వంటి పుణ్యనదులను స్మరించుకుంటూ కాలువల్లోగానీ , చెరువులోగాని , బావుల వద్దగానీ అదీ కుదరకపోతే ఇంట్లోనే స్నానం చేయాలి. నీటియందు సకల దేవతలు కొలువుతీరి ఉంటారని పురాణాలు చెబుతున్నాయి.',
        },
        {
          title: 'వైశాఖమాసంలో సూర్యుడు మేషరాశిలో సంచరిస్తూ ఉంటాడు. కనుక ఎండలు అధికంగా ఉండి మానవులను ఇబ్బందులను గురిచేస్తూ ఉంటాయి. కనుక వేడిమినుంచి ఉపసమనం కలిగించేవాటిని దానం ఇవ్వాలనేది శాస్త్రవచనం.  నీరు , గొడుగు , విసనకర్ర , పాదరక్షలు వంటివి దానం చేయడం శ్రేష్టం. అట్లే దాహంతో ఉన్నవారికి మంచినీటిని ఇవ్వడం , చలివేంద్రాలను ఏర్పాటు చేయడం వల్ల దేవతానుగ్రహం కలుగుతుంది.',
        },
        {
          title: 'సంధ్యావందనాలు ఆచరించడంతో పాటు శ్రీమహావిష్ణువును తులసీదళాలతో పూజించవలెను. శ్రీమహావిష్ణువు వైశాఖమాసం మొదలుకొని మూడునెలలపాటు  ఈ భూమి మీద విహరిస్తూ ఉంటాడు. అతనికి అత్యంత ప్రీతికరమైన తులసీదళములతో అర్చించడం వల్ల సంతుష్టుడై సకల సౌభాగ్యాలను, సౌఖ్యాన్ని ప్రసాదిస్తాడని చెప్పబడుతున్నది.',
        }
      ],
      "title": 'కార్తీక పురాణం part-2',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>జ్యేష్ఠ మాసం విశిష్టత :</span>},
        {
          title: 'తెలుగువారు చంద్రమానం అనుసరిస్తారు కాబట్టి కొత్త ఏడాది ఛైత్రంతో ప్రారంభమై పాల్గుణంతో ముగుస్తుంది. తెలుగు నెలల్లో మూడోది జ్యేష్ఠం.',
        },
        {
          title: 'ఛైత్ర , వైశాఖం తర్వాత వచ్చే జ్యేష్ఠ మాస పుణ్య కాలంలో చేసే పూజలు , జపాలు , పారాయణాదులకు విశేష ఫలముంటుందని శాస్త్రాలు పేర్కొంటున్నాయి. జ్యేష్ఠంలో విష్ణుసహస్రనామ పారాయణం అనంత ఫలాన్నిస్తుంది.',
        },
        {
          title: 'అలాగే ఈ మాసంలో జలదానం చేయడం చాలా ఉత్తమం. జ్యేష్ఠశుద్ద తదియనాడు రంభా తృతీయగా జరుపుకుంటారు. ఈ రోజున ప్రత్యేకంగా పార్వతి దేవిని పూజించడమే కాదు, దానాలకు శుభకాలం. ముఖ్యంగా అన్న దానం చేయడం ఉత్తమం.',
        },
        {
          title: 'జ్యేష్ఠశుద్ద దశమిని *దశపాపహర దశమి* అంటారు. అంటే పది రకాల పాపాలను పోగొట్టే దశమి అని అర్ధం. పాపాలను హరించే శక్తి కలిగిన దశమి రోజున గంగా స్నానం , లేదా ఏదైనా నది లో పదిసార్లు మునకేస్తే మంచి ఫలితాన్నిస్తుంది.',
        },
        {
          title: 'నల్ల నువ్వులు , నెయ్యి , పేలపిండి , బెల్లం నదిలో వేయాలి. అలాగే చేపలు , కప్పలు , తాబేలు లాంటి జలచరాల రజత ప్రతిమలను నీటిలో వదలడం విశేష పుణ్యదాయకం. ఈ రోజున ఇష్ట దైవాన్ని పూజించే , ఆలయాల సందర్శిస్తే శుభం జరుగుతుంది.',
        },
        {
          title: 'జ్యేష్ఠ శుద్ద ఏకాదశినే *నిర్జల ఏకాదశి* అనే పేరుతోనూ పిలుస్తారు. ఏకాదశి వ్రతాన్ని ఆచరించి పెసరపప్పు , పాయసం , పానకం , నెయ్యి , గొడుగు దానం చేయాలని శాస్త్రాలు తెలియజేస్తున్నాయి. నిర్జల ఏకాదశి వ్రతాన్ని ఆచరిస్తే 12 ఏకాదశులను ఆచరించిన ఫలితం దక్కుతుంది.',
        },
        {
          title: 'జ్యేష్ఠ శుద్ద ద్వాదశిని దశహరా అంటారు. ఇది దుర్దశలను పోగొట్టగలిగే శక్తి కలిగిన తిథి. ఈరోజు నది స్నానాలు చేయాలి. అలాంటి అవకాశంలేనప్పుడు ఇంట్లో స్నానమాచరించే సమయంలో గంగా దేవిని స్మరించడం ఉత్తమం. *జ్యేష్ఠ పూర్ణిమను మహాజ్యేష్టి* అంటారు. ఈ రోజున తిలలు దానం చేసిన వారికి ఆశ్వమేథయాగం చేసిన ఫలితం లభిస్తుంది.',
        },
        {
          title: 'జ్యేష్ఠ నక్షత్రంతో కూడిన జ్యేష్ఠ మాసంలో గొడుగు, చెప్పులు దానం చేసిన వారికి ఉత్తమగతులతో పాటు ఐశ్వర్యం ప్రాప్తిస్తాయని విష్ణు పురాణం తెలిపింది. వామన ప్రీతికి విసనకర్ర , జల కలశం , మంచి గంధం దానం చేయాలి. ఈ పౌర్ణమినే ఏరువాక పున్నమి పేరుతో జరుపుకుంటారు. ఇది రైతుల పండుగ.. ఎద్దులను అలంకరించి పొంగలి పెట్టి , ఉరేగింపుగా పొలాల వద్దకు తీసుకెళ్లి దుక్కి దున్నిస్తారు.',
        },
        {
          title: 'జ్యేష్ఠ పౌర్ణమి తర్వాత పదమూడో రోజున మహిళలు *వటసావిత్రి* వ్రతం చేసుకుంటారు. భర్తలు పది కాలాల పాటు సంపూర్ణ ఆరోగ్యంతో దీర్ఘాయుష్మంతులు కావాలని మనసార కోరుకుంటూ ఈ పూజ చేస్తారు.',
        },
        {
          title: 'జ్యేష్ఠ బహుళ ఏకాదశిని *అపర ఏకాదశి, సిద్ద ఏకాదశి అని కూడా అంటారు. ఈ రోజున ఏకాదశి వ్రతం ఆచరించడం వల్ల అనుకున్న పనులు నేరవేరుతాయి. జ్యేష్ఠ బహుళ చతుర్దశి మాస శివరాత్రి ప్రదోష కాలంలో శివునికి అభిషేకం , బిల్వదళాలతో పూజిస్తే అకాల మృత‌్యుహరణం , యశస్సు కీర్తి , ఆరోగ్యం లభిస్తాయి.',
        }
      ],
      "title": 'కార్తీక పురాణం part-3',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>ఆషాఢ మాసం విశిష్టత :</span>
        },
        {
          title: 'ఆషాఢ మాసము తెలుగు సంవత్సరంలో నాలుగవ నెల. ఈ నెలలో పౌర్ణమినాడు చంద్రుడు ఉత్తరాషాఢ/పూర్వాషాఢ నక్షత్రాల సమీపంలోనికి వచ్చే నెల. ఉత్తరాయణ పుణ్యకాలం పూర్తయి సూర్యుడు మిథునరాశి నుంచి కర్కాటకరాశి లోనికి ప్రవేశిస్తాడు.',
        },
        {
          title: 'దాంతో దక్షిణాయనం మొదలవుతుంది. ఆషాఢ శుద్ధ ఏకాదశి నాడు విష్ణువు పాలకడలిపై యోగనిద్రలోకి వెళ్ళే సందర్భాన్ని తొలిఏకాదశిగా పరిగణిస్తారు. ఆషాఢ శుద్ధ పౌర్ణమి రోజును గురుపౌర్ణమిగా వ్యవహరిస్తారు. మహాభాగవతాన్ని రచించిన వేద వ్యాసుడు జన్మించిన రోజును వ్యాసపౌర్ణమి అని కూడా అంటారు. వ్యాసుడు వేదాల్ని నాలుగు భాగాలుగా విభజించిన రోజు కూడా ఇదేనంటారు.',
        },
        {
          title: 'అధిక ఆషాఢ మాసము వచ్చిన సంవత్సరం పూరీ జగన్నాధ ఆలయంలోని మూలవిరాట్టుల్ని ఖననం చేసి కొత్త దారు విగ్రహాలు చేయిస్తారు. దీన్ని నవకళేబర ఉత్సవం అంటారు.',
        },
        {
          title: <span class='highlight'>విశేషాలు :</span>
        },
        {
          title: 'ఆడవారు ఒక్కసారైనా ఈ మాసంలో గోరింటాకు పెట్టుకుంటారు.',
        },
        {
          title: 'ఆహారంలో మునగకాయను విరివిగా వాడాలంటారు.',
        },
        {
          title: 'శుద్ధ ఏకాదశినే మహా ఏకాదశి అని కూడా అంటారు. దీన్నే ప్రథమైకాదశి అని కూడా అంటుంటారు. తెలుగునాట ఇది తొలి ఏకాదశి. పేలపిండి తింటారు.',
        },
        {
          title: 'ఈ మాసంలో ఇంద్రియ నిగ్రహంతో ఆహార విహారాలలో తగిన జాగ్రత్తను తీసుకుంటూ జీవితాన్ని గడపటం కోసం పూజలు, వ్రతాలుతో, నవ దంపతులకు ఆషాఢ నియమం పాటించమని చెబుతారు.ఆషాఢమాసంలో నవదంపతులు కలవకూడదనే ఆచారాన్ని మనదేశంలోని హైందవేతర మతస్తులు కూడా కొన్నిచోట్ల పాటిస్తుంటారు.',
        },
        {
          title: 'హైదరాబాదు, సికింద్రాబాదు, తెలంగాణ, రాయలసీమలోని కొన్ని ప్రాంతాలలో ఆషాఢ మాసంలో బోనాలు పండుగ జరుపుకోబడుతుంది.',
        },
        {
          title: 'దీనిని అమ్మవారికి నివేదన చేసే పర్వదినాన్నే బోనాలు అంటారు. ముఖ్యంగా గ్రామీణ ప్రాంతంలో ఈ పండుగ అత్యంత వైభవం గా జరుపుకొంటారు. సమస్త జగత్తుకు కారణమైనటువంటి అమ్మవారిని భక్తి శ్రద్దలతో పూజిస్తారు. అన్నం, బెల్లం, పెరుగు, పసుపు నీళ్ళు, వేపాకులు ఈ బోనం లో ఉంటాయి. ఇవన్నీ కూడా ఆరోగ్యానికి హానికలిగించే వ్యాదుల నుండి ఉపకరించేవి. ఈ సమయం లో ప్రకృతి లో జరిగే మార్పుల వలన అనారోగ్యాలపాలు కాకుండా ఇవి ఎంతో మేలు చేస్తాయి.',
        },
        {
          title: 'ఆషాఢ మాసంలో యువతులు గోరింటాకు తప్పక పెట్టుకోవాలని పెద్దలు పేర్కొంటారు. గోరింటాకుకు మన సంప్రదాయంలో ప్రత్యేక స్థానం ఉంది.',
        }
      ],
      "title": 'కార్తీక పురాణం part-4',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>శ్రావణ మాసం విశిష్టత :</span>
        },
        {
          title: 'లక్ష్మీ ప్రదమైన మాసం "శ్రావణ మాసం"',
        },
        {
          title: ' స్థితికారుడు అయిన శ్రీమహావిష్ణువుకు, ఆయన దేవేరి అయిన శ్రీమహాలక్ష్మికి అత్యంత ప్రీతికరమైనది ఈ శ్రావణ మాసం. అనేక రకములైన వ్రతములు, నోములు పూజలు ఆచరించడం వలన విశేష ఫలితాలను, సకల సౌభాగ్యాలను ప్రసాదించే దివ్యమైన మాసమే “శ్రావణ మాసం“.',
        },
        {
          title: 'చాంద్రమానం ప్రకారం తెలుగు మాసాలలో చైత్రం లగాయత్తు చూస్తే, శ్రావణ మాసం ఐదవ మాసం. పౌర్ణమి నాడు చంద్రుడు శ్రవణ నక్షత్రంలో ఉంటాడు కనుక దీనికి శ్రావణ మాసం అని పేరు. శ్రీ మహావిష్ణువు జన్మ నక్షత్రం అయిన శ్రావణ నక్షత్రం పేరుతో ఏర్పడిన శ్రావణమాసంలో శ్రీమహావిష్ణువుకు చేసే పూజలు అనంత పుణ్యములను ఇస్తాయి.',
        },
        {
          title: 'శ్రావణమాసం మహిళలకు ఏంతో పవిత్రమైన మాసం. మహిళలు పాటించే వ్రతాలలన్నింటిలో ఎక్కువ వ్రతాలు ఈ మాసంలో ఉండడంవల్ల దీనిని వ్రతాలమాసమని, సౌభాగ్యాన్ని ప్రసాదించే మాసమని కూడా పేర్కొనబడింది.',
        },
        {
          title: <span class='highlight'>శ్రావణ మాసంలో విశేష పర్వదినములు :</span>
        },
        {
          title: 'మంగళగౌరీ వ్రతం',
        },
        {
          title: 'వరలక్ష్మీ వ్రతం',
        },
        {
          title: 'నాగచతుర్థి',
        },
        {
          title: 'పుత్రదా ఏకాదశి',
        },
        {
          title: 'రాఖీ పూర్ణిమ',
        },
        {
          title: 'హయగ్రీవ జయంతి',
        },
        {
          title: 'రాఘవేంద్ర జయంతి',
        },
        {
          title: 'శ్రీ కృష్ణాష్టమి',
        },
        {
          title: 'కామిక ఏకాదశి',
        },
        {
          title: 'పోలాల అమావాస్య',
        },
        {
          title: <span class='highlight'>మంగళగౌరీ వ్రతం :</span>,
        },
        {
          title: 'శ్రావణ మాసం మందు ఆచరించ వలసిన వ్రతములలో మొదటిది ఈ మంగళగౌరీ వ్రతం. ఈ నెలలో వచ్చే నాలుగు మంగళవరాలు మంగళ గౌరీని పూజించాలి. పార్వతి దేవికి మరొక పేరు (గౌరీ ) మంగళ గౌరీ. సాధారణంగా కొత్తగా పెళ్ళయిన ముత్తైదువలు ఈ వ్రతాన్ని చేస్తారు. ఈ వ్రతాన్ని ఆచరించడం వల్ల మహిళలకు సౌభాగ్యకరమైన ఐదవతనం కలకాలం నిలుస్తుందని ప్రతీతి. ఈ వ్రతాన్నిగురించి స్వయంగా శ్రీ కృష్ణుడు ద్రౌపదికి వివరించినట్లు పురాణాలు పేర్కొన్నాయి.',
        },
        {
          title: <span class='highlight'>వరలక్ష్మీ వ్రతం :</span>,
        },
        {
          title: 'శ్రావణ మాసం లో మహిళలకు అతి ముఖ్యమైన ప్రధానమైన వ్రతం శ్రీ వరలక్ష్మీ వ్రతం. దీనిని పూర్ణిమ ముందు వచ్చే శుక్రవారం ఆచరింపవలెను. ఈ రోజున వరలక్ష్మీ దేవతను పూజిస్తే అష్టలక్ష్మీ పూజలకు సమానం అనే నమ్మకంతో కుటుంబ సభ్యులు కూడా పాలుపంచుకుంటారు. ఈ దేవతను పూజిస్తే అష్టైశ్వర్యాలు అయిన సంపద, భూమి, శిక్షణ, ప్రేమ, కీర్తి, శాంతి, సంతోషం మరియు శక్తి వంటివి లభిస్తాయని ప్రగాఢ విశ్వాసం.',
        },
        {
          title: <span class='highlight'>శుక్లచవితి-నాగచతుర్థి :</span>,
        },
        {
          title: 'దీపావళి తర్వాత జరుపుకొనే నాగులచవితి లాగ, మన రాష్ట్రంలోని కొన్ని ప్రాంతాలందు ఈరోజుని నాగులచవితి పండుగలా నాగాపుజలను చేస్తారు. రోజంతా ఉపవాసం ఉండి పుట్ట వద్దకు వెళ్ళి పాలు పోసి, నాగ దేవతను పూజిస్తారు. దుర్వాయుగ్మ వ్రతం చేయడానికి కుడా విశేషమైన రోజు ఈ శుక్ల చవితి.',
        },
        {
          title: <span class='highlight'>శుక్ల ఏకాదశి-పుత్రదా ఏకాదశి :</span>,
        },
        {
          title: 'శ్రావణశుద్ధ ఏకాదశిని పుత్రదా ఏకాదశి లేదా లలిత ఏకాదశి అంటారు. ఆరోజున గొడుగు దానమిస్తే విశేష ఫలితాన్ని పొందవచ్చు. పుత్ర సంతానాన్ని కోరుకొనేవారు ఈనాడు ఏకాదశీ వ్రతాన్ని ఆచరించడం మంచిది.',
        },
        {
          title: <span class='highlight'>శ్రావణ పూర్ణిమ – రాఖీపూర్ణిమ :</span>,
        },
        {
          title: 'అన్న/తమ్ముని శ్రేయస్సుని కోరుతూ అక్కాచెల్లెళ్ళు సోదరుని చేతికి రాఖీ కట్టే పండుగే ఈ రాఖీ పూర్ణిమ. సోదరునికి రాఖీ కట్టి, నుదుట బొట్టు పెట్టి అనంతరం మిఠాయిలను తినిపిస్తారు. సోదరుడు సోదరిని ఆశీర్వదించి కానుకలివ్వడం ఆనవాయితీ. ఈ రోజునే బ్రాహ్మణ, క్షత్రియ & వైశ్యులు తమ పాత యజ్ఞోపవీతాన్ని విసర్జించి కొత్తది ధరించడం ఆచారం. అందుచేత ఈ రోజుని జంధ్యాల పూర్ణిమ అనికూడా అంటారు.',
        },
        {
          title: <span class='highlight'>పూర్ణిమ – హయగ్రీవ జయంతి :</span>,
        },
        {
          title: 'ఈరోజునే శ్రీమహావిష్ణువు వేదాలను రక్షించేందుకు హయగ్రీవ రూపం ధరించినట్లు పురాణాలు చెబుతున్నాయి. హయగ్రీవుడు జన్మించిన ఈ రోజుని హయగ్రీవ జయంతిగా జరుపుకొని, హయగ్రీవుడిని పూజించి శనగలు, ఉలవలతో గుగ్గిళ్ళు చేసి నైవేద్యం సమర్పించడం సర్వ శ్రేష్టం.',
        },
        {
          title: <span class='highlight'>కృష్ణవిదియ - శ్రీ రాఘవేంద్రస్వామి జయంతి :</span>,
        },
        {
          title: 'మంత్రాలయంలో శ్రీ గురు రాఘవేంద్రస్వామి జయంతిని పురస్కరించుకొని విశేష పూజలను చేస్తారు. అంతే కాదు. క్రీ.శ.1671 వ సంవత్సరంలో విరోధికృత్ నామ సంవత్సర, శ్రావణ బహుళ విదియనాడు శ్రీ రాఘవేంద్రస్వామి వారు సజీవంగా సమాధిలో ప్రవేశించారని ప్రాచీన గ్రంధాలలో పేర్కొనబడినది.',
        },
        {
          title: <span class='highlight'>కృష్ణపక్ష అష్టమి – శ్రీకృష్ణాష్టమి :</span>,
        },
        {
          title: 'శ్రీమహావిష్ణువు యోక్క ఎనిమిదో అవతారమే శ్రీకృష్ణ అవతారం. శ్రీకృష్ణ పరమాత్మ జన్మించిన శుదినమే ఈ శ్రీకృష్ణాష్టమి. దీనినే జన్మాష్టమి అని కూడా పిలుస్తారు. ఈరోజు ఉదయం ఉపవాసం ఉండి సాయంత్రం కృష్ణుడిని పూజించి నైవేద్యంగా పాలు, పెరుగు, వెన్నలను సమర్పించడం అనంతరం ఉట్టిని కొట్టడం అనేది ఆచారంగా వస్తోంది.',
        },
        {
          title: <span class='highlight'>కృష్ణపక్ష ఏకాదశి – కామిక ఏకాదశి :</span>
        },
        {
          title: 'ఇక బహుళ పక్షంలో వచ్చే ఏకాదశే కామిక ఏకాదశి. ఈరోజున నవనీతమును(వెన్న) దానం చేయాలని పెద్దలు అంటారు. తద్వారా ఈతి బాధలు పోయి, కోరికలన్నీ నెరవేరుతాయని శాస్త్ర వచనం.',
        },
        {
          title: <span class='highlight'>కృష్ణపక్ష అమావాస్య – పోలాల అమావాస్య :</span>},
        {
          title: 'పోలాల అమావాస్యను మహిళలు శ్రావణ మాసములో కృష్ణపక్ష అమావాస్య రోజున జరుపుకుంటారు. సంతానాన్ని కోరుకునే ఇల్లాళ్లు దీనిని చేసుకోవాలని పెద్దలు చెబుతుంటారు. కాలక్రమేణా పోలాల అమావాస్య అన్న పేరు కాస్తా, పోలేరు అమావాస్య గా మారి,  పోలేరమ్మ అనే గ్రామ దేవతలను ఆరాధించే పర్వదినంగా మార్పు చెందింది. ఇది ఆచరించడం వల్ల పిల్లలకు అకాల మృత్యు భయం తొలగిపోతుంది అని శాస్త్రాలు చెబుతున్నాయి.',
        }
      ],
      "title": 'కార్తీక పురాణం part-5',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>భాద్రపద మాసం విశిష్టత :</span>,
        },
        {
          title: 'శ్రావణం తర్వాత వచ్చే భాద్రపదమూ ప్రత్యేకమే! భాద్రపదంలో ఒకో రోజు గడిచేకొద్దీ ఊరంతా హోరెత్తిపోతుంది. మరి వినాయక చవితి వచ్చేది ఈ నెలలోనే కదా!',
        },
        {
          title: 'ఆ చవితి రోజున స్వామి రూపాన్ని మట్టితో రూపొందించి, ఆ రూపాన్ని పత్రితో పూజిస్తాం. సర్వ శుభాలనూ కలిగించే ఆ విఘ్నాధిపతిని పూర్తిగా ప్రకృతితోనే పూజించి, ప్రకృతిలోనే నిమజ్జనం చేయడం ఈ పండుగకే ప్రత్యేకం.',
        },
        {
          title: 'ఒక్క చవితే కాదు, భాద్రపదంలో ప్రతి తిథీ ప్రత్యేకమే! వినాయక చవితి తర్వాత వచ్చే పంచమిని రుషిపంచమి అని పిలుస్తారు. ఆ రోజున స్త్రీలంతా సప్తర్షులని పూజిస్తూ ఉపవాసం ఉంటారు. అలా చేస్తే రుషుల అనుగ్రహంతో వారిలో ఉన్న దోషాలన్నీ తొలగిపోతాయని నమ్ముతారు.',
        },
        {
          title: 'ఆ తర్వాత వచ్చే *సూర్యషష్టి, లలితా సప్తమి, రాధాష్టమి తిథులలో ఆయా దేవతలని పూజిస్తారు. ఇలా ఒకో తిథినీ దాటుతూ *పరివర్తన ఏకాదశి* వస్తుంది.',
        },
        {
          title: 'తొలిఏకాదశి రోజున శేషతల్పం మీద శయనించే విష్ణుమూర్తి, పరివర్తన ఏకాదశి రోజున మరోపక్కకి ఒత్తిగిలుతాడని అంటారు. అందుకే ఈ రోజుకి ‘పరివర్తన ఏకాదశి’ అన్న పేరు వచ్చింది.',
        },
        {
          title: 'కానీ ఈ పేరు వెనక చాలా నిగూఢ అర్థాలే కనిపిస్తాయి. ఆనాటికి రుతువులలో వచ్చే మార్పునీ, మనుషులలో పరివర్తన రావల్సిన అవసరాన్నీ అది సూచిస్తుంది.',
        },
        {
          title: 'ఈ ఏకాదశి రోజున ఉపవాసం ఉండి జాగరణ చేస్తే గృహస్థు జీవితంలో చేసిన పాపాలన్నీ నశించిపోతాయని చెబుతారు.',
        },
        {
          title: 'పరివర్తన ఏకాదశి మర్నాడే *వామన జయంతి* వస్తుంది. విష్ణుమూర్తి అవతారమైన వామనుడు ఉద్భవించింది ఈ రోజునే! వామనుడే కాదు, బలరాముడు, వరాహస్వామి కూడా ఈ మాసంలోనే అవతరించారని చెబుతారు.',
        },
        {
          title: 'భాద్రపదమాసంలో మరో ప్రత్యేకత మహాలయ పక్షం. భాద్రపద పౌర్ణమి మర్నాడు నుంచి పదిహేను రోజుల పాటు ఈ మహాలయ పక్షం వస్తుంది. పితృదేవతలందరినీ ఈ కాలంలో తల్చుకోవడం ఆనవాయితీ.',
        },
        {
          title: 'భాద్రపదంలో పండుగలే కాదు నోములు, వ్రతాలకి కూడా కొదవ లేదు.',
        },
        {
          title: 'భాద్రపద శుద్ధ చతుర్దశి రోజున వచ్చే *అనంతపద్మనాభస్వామి వ్రతం* ఇందులో ముఖ్యమైనది. ఈ రోజున ఆ పద్మనాభస్వామిని కొలిచినవారి కష్టాలన్నీ తీరిపోతాయని అంటారు. ఇదే కాకుండా ఉండ్రాళ్ల తద్ది నోము, ఉమామహేశ్వర వ్రతం కూడా గుర్తుంచుకోదగ్గవే!',
        },
        {
          title: 'ఇదీ భాద్రపదంలోని కొన్ని ప్రత్యేకతలు.',
        },
        {
          title: 'ఇంత విశేషమైన మాసం కాబట్టే కొందరు అసలు కలియుగమే భాద్రపదంలో మొదలైందని నమ్ముతారు.',
        },
        {
          title: 'భాద్రపదం అన్న పేరు కేవలం నక్షత్రాన్ని మాత్రమే సూచించదు. ఆ మాసంలో ప్రజలంతా *‘భద్రంగా’* ఉండాలన్న ఆలోచనతో ఆ పేరు పెట్టినట్లు తోస్తుంది.',
        }
      ],
      "title": 'కార్తీక పురాణం part-6',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>ఆశ్వీయుజ మాసం యొక్క విశిష్టత :</span>,
        },
        {
          title: 'త్రిముర్తులైన బ్రహ్మ, విష్ణు, మహేశ్వరుల దేవేరులైన సరస్వతి, మహాలక్ష్మీ, పార్వతిదేవిలకు అత్యంత ప్రీతికరమైన…వారి పూజలకు ఉత్కృష్టమైన మాసం ఆశ్వయుజం!',
        },
        {
          title: 'జగన్మాత అయిన పార్వతిదేవి దుష్ట శిక్షణ, శిష్ట రక్షణార్ధం, తొమ్మిది అవతారాలను ధరించిన మాసం..!',
        },
        {
          title: 'ఆయుర్వేద దేవుడైన ధన్వంతరీ, త్రిమతాచార్యులలో ద్వైత సిద్ధాంత ప్రవక్త శ్రీ మధ్వాచార్యులు జన్మించిన మాసం..!',
        },
        {
          title: 'దుష్ట దానవుడైన నరకాసురుడు అంతమొందింపబడి ప్రజలందరికి ఆనందాల వెలుగులను పంచిన దివ్య మాసము ఇది !',
        },
        {
          title: 'ఈ మాసంలోని తొలి తొమ్మిది రోజులు "దేవి నవరాత్రులు',
        },
        {
          title: 'సంప్రదాయబద్ధంగా పూజలు చెయ్యాలి అనుకున్న భక్తులు కలశాన్ని స్థాపించి , ముగ్గురు అమ్మల మూలపుటమ్మను. ఈ నాటి నుండి తొమ్మిది రోజుల పాటు నియమముగా ఆరాధించాలి.',
        },
        {
          title: 'దేవి పూజను ఆశ్వయుజ మాసం అష్టమి, నవమిలలో పూజించిన భక్తులకు ఎటువంటి శోకాలు దరిచేరవు.',
        },
        {
          title: 'దేవి పూజకు ఉత్కృష్టమైన ఈ రోజులలో అమ్మవారిని పూజించి రోజుకొక నైవేద్యం చొప్పున సమర్పించడం మంచిది.',
        },
        {
          title: 'కలశ స్థాపనాదులతో పూజించలేని వారు, అమ్మవారి పటానికి గాని, విగ్రహానికి గాని , పుస్తకాలను గాని పూజిస్తూ స్తోత్ర , నామ పారాయణలను చేయవచ్చు..!',
        },
        {
          title: 'ఈ విధముగ దేవి నవరాత్రులలో ఆ తల్లిని ఆరాధించడం వల్ల ఆ దేవి సంతృప్తురాలు అవుతుంది. అంతే కాకుండా దుష్ట , గ్రహ పీడలు నశించి అమ్మవారి కృప కటాక్షలు కలుగుతాయని చెప్పబడుతోంది.',
        },
        {
          title: 'అలాగే, ఈ మాసం లో సప్తమి రోజున గోపూజ చెయ్యవలెను. కపిల గోవును పూజించాలని, కేవలం పంచగవ్యములను మాత్రం స్వీకరించి ఉపవాసము ఉండవలెను..!',
        },
        {
          title: 'పూర్ణిమ నాడు నారదీయ పురాణమును పండితులకు తాంబూలములో వుంచి దానము ఇవ్వవలెను.',
        },
        {
          title: 'పూర్ణిమ నాడు స్త్రీలు జాగరణ చెయ్యటం వలన లక్ష్మి దేవి సంతోషించి, అష్టైశ్వర్యాలు ప్రసాదిస్తుంది అని శాస్త్ర వచనం.',
        },
        {
          title: 'ఈ నెలలోని బహుళ పక్షములో చతుర్దశి , అమావాస్య తిధులలో దీపాలను దేవాలయం , మఠము ప్రాకారాల్లోను, వీధులు, ఇంటి ముందు సాయంత్రము సమయములో వెలిగించుకోవడంవల్ల పితృదేవతలు సంతృప్తి చెందుతారని చెప్పబడుతోంది.',
        },
        {
          title: 'ఈ విధముగ ఎన్నో విశిష్టతలను సొ౦తం చేసుకున్న మాసం -- ఆశ్వయుజ మాసం !',
        },
        {
          title: 'ఈ మాసంలో చేసే పూజలు, విధుల ఆచరణ వల్ల అనంతమైన పుణ్య ఫలాలు కలుగుతాయని పురాణ వచనం..!',
        },
        {
          title: 'అనంత రూపాలలో విలసిల్లే శక్తిస్వరూపిణి అయిన ఆ తల్లిని  ఏ రూపములోనైనా, ఏ నామంతోనైనా ఆరాధించవచ్చు. ఆ తల్లి అమ్మలగన్న అమ్మ !',
        },
        {
          title: 'తనను నమ్మిన భక్తులను ఎట్టి పరిస్థితులలో విడవకుండా కాపాడే కల్పవల్లి కరుణామయి. ఆ తల్లి !!!.',
        }
      ],
      "title": 'కార్తీక పురాణం part-7',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>కార్తీక మాసం విశిష్టత :</span>,
        },
        {
          title: 'స్నాన, దాన, జపాలు, పూజలు, ఉపవాస వ్రతాలు, దీపాలు వెలిగించడం, వనభోజనాలు వంటి వాటిని చేయడం వల్ల జన్మజన్మల పాపాలను ప్రక్షాళన చేసి అనంతమైన పుణ్యఫలాలను ప్రసాదించే మహిమాన్వితమైన మాసం “కార్తీకమాసం’. చాంద్రమానం ప్రకారం కార్తీకమాసం ఎనిమిదవది. శరదృతువులో రెండవ మాసం. ఈ మాసంలోని పూర్ణిమనాడు చంద్రుడు కృత్తికా నక్షత్ర సమీపంలో సంచరిస్తూ ఉండడం వల్ల ఈ మాసానికి “కార్తీకమాసం” అని పేరు వచ్చింది.',
        },
        {
          title: '"న కార్తీక నమో మాసః',
        },
        {
          title: 'న దేవం కేశవాత్పరం!',
        },
        {
          title: 'నచవేద సమం శాస్త్రం',
        },
        {
          title: 'న తీర్థం గంగాయాస్థమమ్"',
        },
        {
          title: 'అని స్కంద పురాణంలో పేర్కొనబడింది. అంటే “కార్తీకమాసానికి సమానమైన మాసము లేదు. శ్రీమహావిష్ణువుకు సమానమైన దేవుడు లేడు. వేదముతో సమానమైన శాస్త్రము లేదు గంగతో సమానమైన తీర్థము లేదు.” అని అర్ధం.',
        },
        {
          title: 'శివునికి ప్రీతిపాత్రమైన మాసం కార్తీక మాసం. ప్రతి ఏటా దీపావళి వెళ్ళిన మరుసటి రోజు నుంచి అతి పవిత్రమైన కార్తీక మాసం ప్రారంభమవుతుంది. ఈ మాసంలో భక్తులంతా నిత్యం భోళాశంకరుని నామాన్ని స్మరిస్తూ ఉంటారు. పురాణ కాలంనుంచీ ఈ మాసం ఓ ప్రత్యేకతను సంతరించుకుంది. హరిహరాదులకు ప్రీతిపాత్రమైన ఈ మాసంలో భక్తకోటి యావత్తూ కఠిన నిష్ఠతో చేపట్టే నోములకు ఎంతో ప్రాధాన్యం ఉంది. ఈ మాసంలో పాఢ్యమి, చవితి, పౌర్ణమి, చతుర్దశి, ఏకాదశి, ద్వాదశి తిధుల్లో శివపార్వతుల అనుగ్రహం కోసం మహిళలు పూజలు చేస్తుంటారు.',
        },
        {
          title: 'హరిహరాదులకు ప్రీతికరం… కార్తీక మాసం',
        },
        {
          title: 'మన భారతీయ సంస్కృతిలో కార్తీకమాసం వచ్చింది అంటే ఆ నెల రోజులు పండుగదినాలే! అందులోను కార్తీకమాసం ఈశ్వరారాధనకు చాలా ముఖ్యమైనది. దేశం నలుమూలలా ఉన్న వివిధ ఆలయాలలో రుద్రాభిషేకాలు, రుద్రపూజ, లక్ష బిల్వదళాలతో పూజలు, అమ్మవారికి లక్షకుంకుమార్చనలు, విశేషంగా జరుపుతూ ఉంటారు. అలా విశేషార్చనలు జరిపే భక్తులకు సదాశివుడు ప్రసన్నుడై కొంగుబంగారంలా సంతోషం కలిగిస్తాడు. కాబట్టి ఆ స్వామికి ‘‘ఆశుతోషుడు’’ అనే బిరుదు వచ్చింది.',
        },
        {
          title: '‘‘హరిః ఓం నమస్తే అస్తు భగవన్విశ్వేశ్వరాయ మహాదేవాయ త్య్రంబకాయ',
        },
        {
          title: 'త్రిపురాంతకాయ త్రికాలాగ్నికాలాయ కాలాగ్ని రుద్రాయ నీలకంఠాయ',
        },
        {
          title: 'మృత్యుంజయాయ సర్వేశ్వరాయ సదాశివాయ శ్రీమన్మహాదేవాయ నమః”',
        },
        {
          title: 'ప్రతి ఈశ్వరాలయంలో ఆ రుద్ర నమకం మంత్రభాగం మారుమోగిపోతూ, ప్రతిధ్వనిస్తూ ఉంటుంది. హిందువుల గృహాలలో ‘‘ఆదిత్యమంబికా విష్ణూగణనాథం మహేశ్వరం’’ అనే పంచాయతన దేవతలను విశేషంగా ఆరాధిస్తారు. ఈ కార్తీకమాస మహత్యం గురించి పూర్వం నైమిశారణ్య ఆశ్రమములో శౌనకాది మహామునులు అందరికీ సూతమహాముని ఎన్నో విష్ణు భక్తుల చరిత్రలు, విష్ణు మహిమలను వినిపించే సమయంలో, “ఓ సూతముని శ్రేష్ఠా!',
        },
        {
          title: 'కలియుగంలో ప్రజలు సంసార సాగరమునుండి తరింపలేక, అరిషడ్వర్గాలకు దాసులై, సుఖంగా మోక్షమార్గం తెలియక ఎన్నో ఈతిబాధలు అనుభవిస్తున్న ఈ మానవులకు ధర్మాలన్నింటిలో ఉత్తమ ధర్మమేది? దేవతలు అందరిలోనూ ముక్తి నొసంగు ఉత్తమ దైవమెవరు? మానవునికి ఆవరించియున్న ఈ అజ్ఞానాన్ని రూపుమాపి పుణ్యఫలం యిచ్చే కార్యమేది? ప్రతిక్షణం మృత్యువు వల్ల వెంబడించబడే ఈ మానవులకు మోక్షము కలిగించు చక్కని ఉపాయము చెప్ప”మని కోరారు.',
        },
        {
          title: 'ఆ ప్రశ్నలను విన్న సూతముని, “ఓ ముని పుంగవులారా! క్షణికమైన సుఖభోగాల కోసం పరితపించుతూ, మందబుద్ధులు అవుతున్న మానవులకు ‘‘ఈ కార్తీకమాస వ్రతము’’ హరిహరాదులకు అత్యంత ప్రీతికరమైంది. దీనిని ఆచరించటం వల్ల సకల పాపాలు హరింపబడి మరు జన్మలేక పరంధామము పొందగలరు. పుణ్యాత్ములకు మాత్రమే ఈ కార్తీకమాస వ్రతమాచరించాలని కోరికను కలుగచేస్తాడు ఆ పరమాత్మ! దుష్టులకు, దుర్మార్గులకు వారి కర్మలు పరిపక్వమయ్యేవరకు ఏవగింపు కలిగిస్తాడు.',
        },
        {
          title: 'ఈ మాసంలో వచ్చే సోమవారాలు చవితి, ఏకాదశి, ద్వాదశి, పౌర్ణమి, అత్యంత పుణ్యప్రదమైనవి. నెల అంతా సాధ్యపడని భక్తులు కనీసం ఆయా రోజులలో పవిత్రపుణ్య నదీ స్నానం ఆచరించి, ఉపవాస దీక్షలు చేస్తూ మహాన్యాస పూర్వక మహా రుద్రాభిషేకాలు, లక్ష బిల్వార్చనలు, లక్ష కుంకుమార్చనలు, లలిత, విష్ణు సహస్రనామ పారాయణాలు, ప్రతి నిత్యం ఉభయ సంధ్యలలో దీపారాధన చేసేవారికి విశేష పుణ్య ఫలం లభిస్తుంది. ఈ కార్తీకమాసం ముప్పై రోజులు ఆచరించిన వారికి అనంతకోటి పుణ్యఫలం లభిస్తుందని చెప్పబడింది.',
        },
        {
          title: 'ఇందులో అత్యంత మహిమాన్వితమైన కాలం ప్రదోషకాలం. సూర్యాస్తమయం అయ్యాక మూడు గడియలు (ఒక గంట) ప్రదోషోరజనీముఖమ్‌. రాత్రికి ఆరంభకాలమే ఈ ప్రదోష సమయం. ఇలా ప్రతి నిత్ర్యం వచ్చే ప్రదోషాన్ని నిత్య ప్రదోషంగా చెప్తారు. ఈ ప్రదోషం నాలుగు విధాలుగా మహాత్ములు వివరిస్తూ ఉంటారు. 1. నిత్య ప్రదోషం. 2. పక్ష ప్రదోషం 3. మాస ప్రదోషం 4. మహాప్రదోషం అని చెప్తారు.',
        },
        {
          title: 'కొందరు నిష్టాపరులు ఈ కార్తీకమాసమంతా పుణ్యనదీస్నానం ఆచరిస్తూ ప్రతి నిత్యం హరిహరాదులను పూజిస్తూ పగలు అపక్వాహారం అంటే వండని ఆహారం. పాలు, పండ్లు స్వీకరించి సాయంత్రం భక్తితో కార్తీక దీపారాధనలు, పూజలు చేసి, నివేదించిన అన్నాన్ని రాత్రి భుజిస్తూ ఉంటారు. ఇలా ఈ కార్తీక వ్రతాన్ని నిత్యం ఆచరిస్తారు.ఇక ప్రదోషకాలంలో పరమేశ్వరుడు ఏక కాలంలో రెండు రూపాల్ని ప్రదర్శిస్తూ ఎడమ భాగాన పార్వతి, రెండవ భాగంలో పరమేశ్వరరూపంగా ‘‘అర్థనారీశ్వ రుడుగా’’ దర్శనమిచ్చే కాలం ఈ ప్రదోషకాలం అని చెప్పబడినది. ఆ ప్రదోష సమయాల్లో ఆ తల్లి ‘‘అధ్యక్షురాలు’’గా అధిరోహించియుండగా! పరమేశ్వరుడు పరవశించి తాండవం చేస్తూ ఉంటాడు.',
        },
        {
          title: 'ఆ నృత్యాన్ని దర్శించటానికి దేవతలందరూ అక్కడ కొలువుతీరి ఉంటారుట! ఆ సమయంలో ఆ తాండవ నృత్యానికి అనుగుణంగా సరస్వతి దేవి వీణవాయిస్తూ ఉంటే బ్రహ్మ తాళం వేస్తాడట. శ్రీ మహాలక్ష్మీ గానం చేస్తూ ఉంటే! శ్రీ హరి మృదంగం వాయిస్తాడుట. ఇంద్రుడు వేణునాదంతో పులకింపచేస్తూ ఉంటాడు! అలాంటి ప్రదోష సమయాల్లో దేవగంధర్వ మహర్షి సిద్ధులందరూ పరమాత్మ స్వరూపాన్ని కొలుస్తూ ఉంటారుట.',
        },
        {
          title: 'కాబట్టి ప్రదోష సమయాల్లో శివుని ఆరాధిస్తే! శివుని ఆశీస్సులతోపాటు మిగతా దేవతల ఆశీస్సులు కూడా ఏకకాలంలో మనం పొందగలుగుతామని చెప్పబడింది. ఇంకా మనకు ఆ అర్థనారీశ్వర స్వరూపాన్ని ధ్యానిస్తే! రెండు ప్రయోజనాలు లభిస్తాయట. కామం! అంటే కోర్కెలను నియంత్రించే శక్తి మరియు కాలాన్ని అంటే మరణాన్ని జయించే శక్తిని ప్రసా దిస్తాడుట! ఇంకా ఈ ప్రదోష దర్శనం సర్వశుభాలను కలుగచేసి, సర్వదారిద్య్ర బాధలను తొలగించి సర్వసంపత్తులు అనుగ్రిహస్తుంది అని చెప్పబడింది.',
        },
        {
          title: 'ఈ కార్తీకమాసంలో అత్యంత విశేషమైనది. ఉత్థానైకాదశి అంటే శ్రీ మహావిష్ణువు పాలకడలిలో ఆదిశేషుని పాన్పుపైన ఆషాడ శుద్ధ ఏకాదశినాడు తనయోగనిద్రను ప్రారంభించి తిరిగి కార్తీక శుద్ధ ఏకాదశినాడు కనులు విప్పి యోగ నిద్ర నుండి మేల్కొన్న రోజుకే ఉత్థాన ఏకాదశి అనే పేరు. ఆ మరుసటి రోజు ద్వాదశినాడు ముప్పై ముగ్గురు దేవతలలో శ్రీ మహాలక్ష్మీ సమేతుడై తులసీ ధాత్రివనంలో ఉంటాడని చెప్తారు.',
        },
        {
          title: 'ఈ ద్వాదశిని క్షీరాబ్ధి ద్వాదశి అంటారు అంటే, పూర్వం కృతయుగంలో దేవదానవులు పాలసముద్ర మధనం చేసిన రోజు. కనుక దీనికి క్షీరాబ్ధి ద్వాదశి అను పేరు వచ్చింది. పాల సముద్రాన్ని చిలికారు కనుక చిల్కు ద్వాదశి అని కూడా అంటారు. కనుక స్త్రీలు ఈ రోజు వారి సౌభాగ్య సంపదల కోసం తులసీ ధాత్రి (తులసికోట) దగ్గర విశేష దీపారాధనలు చేసి షోడశోపచారాలతో తులసీధాత్రి లక్ష్మీనారాయణులను పూజిస్తారు. ఆ రోజు దేశం నలుమూలలా ఉన్న ఆలయాలలోని లక్ష్మీనారాయణ మూర్తులను మిరుమిట్లు గొలిపే విద్యుత్‌ దీపకాంతితో, బాణసంచాలతో సమీప నదీజాలలో తెప్సోత్సవం నిర్వహిస్తూ ఉంటారు.',
        },
        {
          title: 'కార్తీక పూర్ణిమనాడు వరిగడ్డిని వెంటిగా చుట్టి దానిని రెండు స్తంభాలకు కట్టి ఆ వెంటిని మూడుమార్లు కాగడాలతో వెలిగిస్తూ వాటి క్రింది పార్వతీపరమేశ్వరుల ప్రతిమలను పల్లకిలో ఉంచి మూడుసార్లు త్రిప్పి జ్వాలాతోరణ వేడుకను నిర్వహిస్తారు. అలా హరిహరాదులకు ప్రత్యేక ఉత్సవ వేడుకలు నిర్వహిస్తారు. ఇలా ఈ కార్తీకమాస విశేషాలను కొనియాడి చెప్పడానికి సహస్రముఖాలు కలిగిన ఆదిశేషుడు, చతుర్ముఖుడైన బ్రహ్మకే సాధ్యం కాదని చెప్పగా, ఇక మానవ మాత్రులమైన మనమెంత?” అని సూతమహాముని చెప్పారు.',
        },
        {
          title: 'మన సంస్కృతిలో ఈ దీపారాధన అనేది ప్రధానాంశం. ఈ దీపదానంలో ఆవునెయ్యి ఉత్తమోత్తమమైనది. మంచినూనె మధ్యమము, ఇప్పనూనె అధమము, ఇతర నూనెలు అడవిలో పుట్టిన నూనెలు అధమాతి అధమములు. గేదె నేతితో దీపము, వెలిగిస్తే పూర్వ పుణ్యము కూడా నశించి పోతుంది. అదే స్వల్పంగా ఆవునేయి కలిపి వెలిగింస్తే దోషములేదని, అలా ఒకటి మొదలు వేయి వరకు దీపాలు వెలిగించుటం ఎంతో శుభప్రదమని వాటి సంఖ్యనుబట్టి వివిధ ఫలితాలు అందిస్తుందని, దీపదాన మహాత్యంలో చెప్పివున్నారు. అలాంటి దీపారాధన పూజామందిరంలో, దేవాలయాలలో గృహప్రాంగణాలలో, తులసీ బృందావనంలో, మారేడు, రావి వంటి దేవతా వృక్షాల దగ్గర, పుణ్య నదీతీరాలలో వెలిగించుటం అత్యంత పుణ్యప్రదమని పురాణాలు వర్ణించి చెబుతున్నాయి.',
        },
        {
          title: 'ఈ మాసంలో సోదరి చేతివంట భగనీ హస్తభోజనము చేసి యధాశక్తి వారికి కానుకలు సమర్పించుటంతో పాటు, సమీప వనంలో బంధువులు, స్నేహితులతో కలిసి ఉసి రిచెట్టును పూజించి, సాత్విక ఆహారంతో వనభోజనాలు చేస్తూ వుండటం మంచిది. అందువల్ల మన జీవన గమనంలో మంచి ఆహ్లాదంతో పాటు అన్నదాన ఫలితం కూడా లభిస్తుంది.',
        },
        {
          title: 'అలాంటి మహిమాన్వితమైన ఈ కార్తీకమాసంలో నియమనిష్టలతో హరిహరాదులను అనునిత్యం ఆరాధిస్తూ ‘‘కార్తీకపురాణ’’ పఠనం చేస్తే అనంతకోటి పుణ్యఫలం లభిస్తుందని, ఈ పవిత్ర పుణ్యదినాలలో అలసత్వం వహించకుండా యథాశక్తి దీపదానము, వస్త్ర, ఫల, పుష్ప, సువర్ణ దానాలు మొదలైనవి చేయుటం వల్ల ఇహంలో సర్వసుఖాలు అనుభవించుటమే కాకుండా, జన్మాంతరంలో జన్మరాహిత్యాన్ని పొందగలరని ఈ కార్తీకమాస వ్రతమహాత్యాన్ని గురించిసూతమహాముని శౌనకాది మునులకు వివరించాడు.',
        },
        {
          title: <span class='highlight'>విశిష్టత :</span>,
        },
        {
          title: 'ఆయా మాసాలలో చంద్రుడు పూర్ణుడై ఏ నక్షత్రంలో ఉంటాడో ఆ నక్షత్రం పేరే ఆ మాసానికి వస్తుంది. కృత్తికా నక్షత్రంపై చంద్రుడు పూర్ణుడై ఉండటంవల్ల ఈ మాసానికి కార్తీకమాసమని పేరు. ఈ మాసంలో కృత్తిక నక్షత్రానికి, దీపారాధనకు, సోమవారాలకు ప్రాధాన్యత ఉంది. ఈ విషయాలను గురించి ఇప్పుడు తెలుసుకుందాం.',
        },
        {
          title: 'కృత్తికా నక్షత్రం: కృత్తికానక్షత్రానికి నక్షత్రాలలో మంచి ప్రాముఖ్యత ఉంది. దేవతలలో ప్రథముడైన అగ్నిదేవుడు ఈ నక్షత్రానికి అధిపతి. అగ్ని నక్షత్రాలైన కృత్తిక, ఉత్తర, ఉత్తరాషాడలలో మొదటిది కృత్తికయే. వేదకాలంలో సంవత్సరం కృత్తికా నక్షత్రంతోనే ఆరంభమయ్యేది. ఈ నక్షత్రాన్ని అగ్ని నక్షత్రమని అంటారు. అగ్ని ఆరు ముఖాలు కలవాడు.',
        },
        {
          title: 'కృత్తికలు కూడా ఆరు నక్షత్రాలు. ఈ కృత్తికలు ఒక విశిష్టత ఉంది. అదేమిటంటే కుమారస్వామిని షణ్ముఖుడు అంటారు. అంటే ఆరు ముఖాలు కలవాడని అర్థం. ఆకాశంలోని ఆరు కృత్తికా నక్షత్రాలు మాతృమూర్తులై పాలు యివ్వగా కుమారస్వామి ఆరు ముఖాలతో పాలు త్రాగాడు. ఈ విధంగా కృత్తికలచే పెంచబడటంతో కుమరస్వామికి కార్తీకేయుడని పేరు వచ్చినది. ఈ కారణాల వల్ల కృత్తికలకు ప్రాముఖ్యం కలిగింది.',
        },
        {
          title: <span class='highlight'>కార్తీక దీపాలు :</span>,
        },
        {
          title: 'ఈ మాసంలో చెప్పుకోదగ్గ మరో అంశం దీపారాధన. ఈ మాస ప్రారంభం నుండి సూర్యోదయానికి పూర్వమే లేచి నదీస్నానం చేసి శుచిగా, పొడిబట్టలు ధరించి దీపారాధన చేయాలి. ఈ మాసంలోనే జ్వాలా తోరణాన్ని కొన్ని చోట్ల వెలిగిస్తారు. ఈ కాలమంతా దేవాలయాలన్నీ దీపాలచే అలంకరించబడి ప్రజలను ఉత్తేజపరుస్తూ శోభాయమానంగా ఉంటాయి. ప్రతి ఇంటిముంగిట ఈ మాసాంతం వరకు దీపం వెలుగుతూ ఉంటుంది.',
        },
        {
          title: 'కార్తీకమాసంలో స్త్రీలు నదులలో, కోనేటిలలో దీపాలు వదలుతారు. ఈ దీపాలు ఆకాశంలోని చుక్కల్లాగా ప్రకాశవంతంగా వెలుగుతూ కన్నులపండుగను కలుగచేస్తాయి. ఈ మాసంలో స్త్రీలు దీపాన్ని దానంగా ఇస్తారు. దీని వల్ల వారికి ఎనలేని కీర్తిసౌ భాగ్యాలు కలుగుతాయని భావిస్తారు. ఈ దీపాలు మనిషిలోని అజ్ఞానమునే చీకటిని తొలగించి జ్ఞానమనే వెలుగును నింపుతాయి.',
        },
        {
          title: <span class='highlight'>కార్తీక సోమవారాలు :</span>,
        },
        {
          title: 'ఈ మాసవారాలలో సోమవారానికి ప్రత్యేకత ఉంది. సోమవారానికి చంద్రుడు అధిపతి. దేవతలలో ప్రథముడైన అగ్ని నక్షత్రాలలో మొదటిదైన కృత్తికను అధిపతిగా ఉండటం, చంద్రుడు పూర్ణుడై ఈ నక్షత్రం మీద ఉండటం వల్ల మాసంలోని సోమవారాలకు విశిష్టత కలిగింది. చంద్రుని వారమైన ఈ సోమవారం శివునికి ఎంతో ప్రీతికరమైనది. శైవభక్తులు ఈ మాసంలో ముఖ్యంగా సోమవారాలలో భక్తిశ్రద్ధలతో నియమనిష్టలతో శివుణ్ణి ఆరాధిస్తారు. ఈ మాసకాలంలో సూర్యోదయ పూర్వమే బ్రహ్మ ముహూర్తంలో నదీ స్నానం చేసి ‘హరహరశంభో’ అంటూ శివుణ్ణి స్తుతిస్తూ భక్తి ప్రపంచంలో మునిగిపోతారు. ముఖ్యంగా శైవభక్తులు ఈ మాసమంతా ఉపవాసముండి శివుడిని పూజిస్తారు. శివ ప్రీతికరమైన సోమవారం రోజు భానోదయం ముందు లేచి స్నానాదికార్యాక్రమాలు ముగించుకుని, పొడి బట్టలు ధరించి మొదటగా దీపారాధన చేయాలి.',
        },
        {
          title: 'అనంతరం శివుడికి రుద్రాభిషేకం చేయించి శివవ్రత నియమాలను పాటించాలి. ఈ విధంగా చేయడం వల్ల నిత్యమూ సిరిసంపదలతో, సుఖసౌఖ్యాలతో వర్థిల్లుతారని ప్రజల నమ్మకం. సూర్యుడు తులారాశిలో ప్రవేశించిన నాటి నుండిగాని, కార్తీక మాసారంభదినమైన శుద్ధపాడ్యమి మొదలుకొని గాని వ్రతారంభం చేయాలి. అలా ప్రారంభించే సమయంలో “ఓ కార్తీక దామోదార! నీకు వందనములు. నాచే ఆరంభింపబడే కార్తీక వ్రతాన్ని విఘ్నం లేకుండా చేయు”ము అని తరువాత స్నానం చేయాలి.',
        },
        {
          title: 'ఆ విధంగా జీవనదికి వెళ్ళి గంగకు, శ్రీ మన్నారాయణునను, భైరవున్ని నమస్కరించి భైరవాజ్ఞను తలదాల్చి మొలలోతు నీటిలో నిలువబడి మొదట సంకల్పము చెప్పుకొని సూక్తాలను చదివి, మార్జన మంత్రముతోను, అఘమర్షణ మంత్రముతోను, గంగోదకమును శిరస్సున జల్లుకొని అఘమర్ష స్నానమా ఆచరించాలి. తరువాత సూర్యుడికి కర్ఘ్య ప్రదానం చేసి దేవతలకు, ఋషూలకు, పితృదేవతలకు క్రమ ప్రకారంగ తర్పణం వదలాలి. అప్పుడది సుస్నానం అవుతుంది. స్నానం చేసిన తరువాత నదీతీరము చేరి మూడుదోసిళ్ళ నీరు గట్టుపైన పోయాలి.',
        },
        {
          title: 'కార్తీకమాసంలో గంగా, గోదావరి, కావేరీ, తుంగభద్రాది నదులలో స్నానం చేస్తే ఆత్యుత్తమం, గంగానది కార్తీకమాసంలో నదులన్నిటిలో ద్రవరూప సన్నిహితయై వుంటుంది. శ్రీ ఆదినారాయణుడు గోష్పాద మాత్ర ప్రదేశంలో జలములో సన్నిహితుడై ఉంటాడని వేదాలు చెప్పుతున్నాయి కాబట్టి సముద్రకామి అయిన నదీ స్నానం అత్యంత పవిత్రమైనది. నదీ స్నానానికి ఆవకాశము లభించకపోతే కులువలోగాని, చెరువులోగాని, కూపము దగ్గరగాని సూర్యోదయము స్నానం చేయాలి.',
        },
        {
          title: 'తరువాత మడిబట్టలను ధరించి ముందుగా భగవంతుని స్మరించు కోవాలి. తరువాత భస్మాన్ని త్రిపుండ్రముగా నుదుట ధరించాలి. లేక గోపీచందనముపైన నుదుట నూర్ద్వ పుండ్రముగా వుంచుకోవాలి. తరువాత సంధ్యావందనము, బ్రహ్మ యజ్ఞాన్ని ముగించి, నిత్యాగ్నిహోత్రాన్ని చేసుకొని దేవతార్చన చేసుకోవాలి. స్నానతీర్థములోనే కార్తీక పురాణ శ్రవణమును చేయాలి.',
        },
        {
          title: 'సూర్యుడు ఆస్తమించే కాలంలో సాయంసంధ్యను పూర్తి చేసికొని శివాలయముగాని, విష్ణు ఆలయంలోగాని దీపారాధన చేయాలి. షోడశోపచార పూజావిధానంలో హరిహరులను పూజించి షడ్రసోపేతమై, భక్ష్యభోజ్యాదులతో కూడిన నైవేద్యము పెట్టాలి. ఈ విధంగా కార్తీకశుద్ధ ప్రతిపత్తు మొదలు అమావాశ్య తుదివరకు నక్తవ్రతం చేస్తే కార్తీకమాస వ్రతము పూర్తవుతుంది. మరునాడు శక్తిననుసరించి మృష్టాన్నముతో భూత తృప్తి కావించాలి. కార్తీక మాసంలో సోమవారం శివప్రీతికై సోమవారవ్రతము చేసినవారికి కైలాసంలో శివుని సన్నిధానమున నుండుట ప్రాప్తిస్తుంది. సోమవారవ్రత విధానం ఎలాంటిది అంటే – సోమవారం నదీ స్నానం చేసి సంపూర్ణంగా ఉపవాసం ఉండి, శివునికి అభిషేకం చేసి రాత్రి మొదటి ఝామున భుజించాలి.',
        },
        {
          title: 'ఆ రోజున యితరులలాగా పదార్ధం గ్రహింపరాదు. తిలదాన మొనర్చినందువలన పాపములన్నియు నశించును. ఇంకా ఆత్యంత నిష్ఠతోను, భక్తితోను ఆచరింప అవకాశం ఉన్నవారు ఆ దినం రాత్రి కూడా నిద్రింపోక పురాణాది పఠనంతో జాగరణ చేసి, మరునాడు శక్తి కొలదిగా బ్రాహ్మణులకు సంతర్పణను చేసి తరువాత భుజించాలి. ఈ పై రెండూ చేయలేనివారు సోమవారం రోజు నపరాహ్ణము వరకు వుండి భుజించాలి. యిందులో ఏది చేయుడానికి శక్తిలేకపోతే నదీస్నానం చేసుకొని భగవంతుని ధ్యానించాలి. ',
        },
        {
          title: 'సోమవారం రోజు స్త్రీగాని, పురుషుడుగాని నక్షత్ర దర్శనం అయ్యేవరకు ఉపవాసం చేసి తరువాత భుజించినవారి పాపాలు అగ్నిలో పడిన దూదివలే నాశనం అవుతుంది. ఆ రోజునశివుడికి అభిషేకం చేసి, బిల్వదళంబులతో సహస్రనామార్చన చేసి, ఇతరులచే చేయించిమా, శివపంచాక్షరీ మంత్రాన్ని జపించినా, వారిని శివుడు ఆనుగ్రహించి సర్వసంపదలను, సమస్త శుభాలను చేకూరుస్తాడు. కార్తీక సోమవారాలు లేదా పౌర్ణమినాడుగాని లేక ఇతర దినాల్లో అయినా సాయంసమయాలలో శివాలయంలో ఉసిరికాయపైన వత్తులను వుంచి దీపం వెలిగించడం శ్రేష్టం.',
        },
        {
          title: 'ఆవునెయ్యితో దీపం వెలిగించడం శ్రేష్టం. లేదంటే నువ్వులనూనెతో గానీ, కొబ్బరినూనెతో గానీ, నెయ్యితోగాని, అవిశనూనెతో గానీ, ఇప్పనూనెతో గానీ, లేదంటే కనీసం ఆముదంతోనైనా దీపాన్ని వెలిగించాలి. అంతే కాకుండా కార్తీకమాసంలో దీపదానం చేయాలని శాస్త్రవచనం. కార్తీకమాసంలో ముప్పై రోజులలో దీపం పెట్టలేనివారు శుద్ధద్వాదశి, చతుర్దశి, పూర్ణిమ దినాల్లో తప్పక దీపం పెట్టాలని శాస్త్ర వచనం. ఈ విధంగా కార్తీకమాసంలో దీపాలను వెలిగించడం, దీపదానం చేయడం వల్ల సకల జీవరాశులే కాకుండా రాళ్ళూ, రప్పలు, వృక్షాలు వంటివి కూడా ముక్తి పొందుతాయని పురాణ కథనం.',
        }
      ],
      "title": 'కార్తీక పురాణం part-8',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>మార్గశిర మాసం విశిష్టత :</span>,
        },
        {
          title: 'శ్రీమహావిష్ణువుకు ఇష్టమైన మాసం.!',
        },
        {
          title: 'మాసానాం మార్గశీర్షం..!',
        },
        {
          title: 'హేమంత ఋతువులో వచ్చే మొదటి నెల.',
        },
        {
          title: 'దీనినే జ్యోతిష్యాన్ని అనుసరించి..',
        },
        {
          title: 'సౌరమాన ప్రకారం ధనుర్మాసమని',
        },
        {
          title: 'చంద్రమానం ప్రకారం మార్గశిర మాసమని అంటారు.',
        },
        {
          title: 'చాంద్రమాన సంప్రదాయాన్ని అనుసరించి చంద్రుడు మృగశిర నక్షత్రంలో ఉండే నెల "మార్గశీర్షం".చంద్రుడు మనః కారకుడు, ఆ చంద్రుడు అనుకూలంగా లేకపొతే మంచి ఆలోచనలు కలగవు, మానసిక స్థితి సరైన మార్గంలో ఉండదు. అందుకని చంద్రుడు అనుకూలించే కాలంలో మన దైవపూజలని ప్రారంభిస్తే వాటి మీద శ్రద్ద బాగా పెరిగి తద్వారా మనోధైర్యం వృద్ది చెందుతుంది. ',
        },
        {
          title: <span class='highlight'>జ్యోతిష్య శాస్త్ర ప్రకారం :</span>,
        },
        {
          title: 'చంద్రునికి ఉచ్ఛ స్థానం వృషభ రాశి, మృగశిర నక్షత్రం వృషభరాశికి చెందినది కావున, చంద్రుని సంపూర్ణ అనుగ్రహం ఉండి దైవ కార్యాలని చేసే కొద్దీ చేయలనిపించే మంచి ఆలోచనలు కలుగుతాయి.',
        },
        {
          title: 'ఈ మాసంలో..!',
        },
        {
          title: 'ఇది ప్రకృతి కాంతకు సీమంతం.',
        },
        {
          title: 'తుషార బిందువుల హేమంతం..!!',
        },
        {
          title: 'మార్గశీర్ష మాసము ఒక విలక్షణమైన మాసము. మార్గశీర్షము అంటేనే మార్గములందు శ్రేష్ఠమైనది. ఉపయోగకరమైనదని అర్థం.',
        },
        {
          title: 'ఇది ఏ మార్గము అంటే భగవంతుని పొందు భక్తిమార్గము. శీర్షప్రాయమైన ఈ మార్గము మిగిలిన మార్గము లన్నింటికన్నా ప్రధానమైనది, ప్రాముఖ్యతతోపాటు పవిత్రత కూడా ఏర్పడటంచే ఇది శ్రేష్టమైనది. శ్రీ మహావిష్ణువుకి ప్రీతికరమైన మాసం మార్గశిరం.',
        },
        {
          title: 'బృహత్సామ తథాసామ్నాం- గాయత్రీ ఛందసా మహం- మాసానాం మార్గశీర్షోహ- ఋతూనాంకుసుమాకరం” ',
        },
        {
          title: 'అనే శ్లోకంలో మార్గశీర్గాన్నీ నేనే,',
        },
        {
          title: 'ఆరు ఋతువులలోనూ పుష్పసౌరభం నేనే,',
        },
        {
          title: 'సామవేదానికి చెందిన గానాలలో బృహత్సామాన్ని నేనే, ఛందస్సులలో గాయత్రీ ఛందాన్ని',
        },
        {
          title: 'శోభ అధికంగా ఉండే వసంత కాలాన్ని నేను',
        },
        {
          title: 'అని భగవద్గీతలోని విభూతి యోగంలో సాక్షాత్తు శ్రీకృష్ణపరమాత్ముడే పేర్కొన్నాడు.',
        },
        {
          title: 'శ్రీకృష్ణుడు మార్గశిరం అంటే నేనేనని చెప్పుకున్న మాసమిది.',
        },
        {
          title: 'మాసాల్లో తాను మార్గశిరమాసాన్ని అంటాడు.',
        },
        {
          title: 'శ్రీకృష్ణ పరమాత్మ.!',
        },
        {
          title: 'ఈ మాసంలో చేసే ఏ పూజైన, హోమమైన,',
        },
        {
          title: 'ఎటువంటి దైవకార్యం చేసినా దానిని స్వయంగా',
        },
        {
          title: 'తనే స్వీకరిస్తానని తెలియజేశాడు.',
        },
        {
          title: 'భగవద్గీత లోని విభూతియోగంలో......',
        },
        {
          title: 'ఈకాలంలో పొలాలనుంచి ధాన్యం ఇళ్లకు చేరి ప్రజలు సంతోషంగా ఉంటారని  ఉత్తమ మాసంగా పరిగణిస్తారు.!!',
        },
        {
          title: 'కృష్ణుడు విష్ణ్వంశ సంభూతుడు......!',
        },
        {
          title: 'విష్ణువు సూర్యనారాయణుడై....',
        },
        {
          title: 'ధనూరాశి నుంచి మకర రాశికి ప్రయాణించే సమయమిది.',
        },
        {
          title: 'సౌరమానం ప్రకారం ఈనెలలో ధనుర్మాసం ప్రారంభమవుతుంది.',
        },
        {
          title: 'ధనుర్మాస విశిష్టతను బ్రహ్మాండ పురాణం.... భాగవతం..వైఖానసం మొదలైన గ్రంథాలు వివరిస్తున్నాయి..!',
        },
        {
          title: 'సూర్య భగవానుడు పన్నెండు నెలల్లో నెలకి ఒక మాసము చొప్పున మారుతూ ఉండేదాన్ని ‘సంక్రమణము’ అంటారు. మనకు సంవత్సరానికి పన్నెండు సంక్రమణములు వస్తాయి. ',
        },
        {
          title: 'సూర్యుడు తులారాశి నుండి వృశ్చిక రాశిలోనికి ప్రవేశించడం వృశ్చిక సంక్రమణము అంటారు.',
        },
        {
          title: 'ఈ మార్గశిర మాసము శ్రీ మహావిష్ణువుకు,',
        },
        {
          title: 'శ్రీ మహాలక్ష్మీదేవికి, సూర్యభగవానుడికి కూడా ప్రీతికరమైన మాసము.',
        },
        {
          title: 'పవిత్రమైన ‘భగవద్గీత’ జన్మించిన మాసం.',
        },
        {
          title: 'సూర్యుడు ధనూరాశిలో ఉండగా..విష్ణువును మేల్కొలిపే ధనుర్మాసవ్రతం చేయాలని పురాణాలు చెబుతున్నాయి. ఈ మాసంలోనే ధనుర్మాసం ప్రారంభమవుతుంది. ధనుర్మాసంలో ధనుర్మాస వ్రతాన్ని ఆచరించి ‘మదుసూధనుడు’ అనే నామముతో శ్రీ మహావిష్ణువును పూజించవలెను. ',
        },
        {
          title: 'ధనుర్మాసంలో ప్రతిరోజు విష్ణ్వాలయాలలో ప్రత్యేక అర్చనాదులు జరుగుతాయి.',
        },
        {
          title: '‘మార్గళివ్రతం’ అనే పేరుతో గోదాదేవి ఈ ధనుర్మాసమంతా విష్ణు వ్రతాన్ని చేపట్టి రోజుకొక్క పాశురంతో స్వామిని కీర్తించింది.',
        },
        {
          title: 'మార్గశీర్షంలో మృగశిరతో కూడిన పూర్ణిమ శ్రేష్ఠం. ఈ మాసంలో లవణం దానం చేయటం వల్ల ఈ మార్గశిర మాస విధులను పాటించడంవల్ల అనంతమైన పుణ్యఫలాలు ప్రాప్తిస్తాయి.',
        },
        {
          title: 'ఈ మాసమంతా శ్రీ విష్ణువును తులసీ దళముతో పూజించడం, పుణ్యప్రదం.',
        },
        {
          title: 'ద్వాదశినాడు పంచామృతాలతో అభిషేకం చేయవలెను. శ్రీ విష్ణుతోపాటు సూర్యున్ని కూడా పూజించి శుభాలను పొందాలని, ఏ పనిచేస్తున్నా ఈ మాసంలో ‘ఓం దామోదరాయనమః, ఓ నమో నారాయణయనమః’ అనే మంత్రాన్ని పఠించాలని శాస్త్ర వచనం.',
        },
        {
          title: 'ప్రతిరోజు బ్రాహ్మీముహూర్తంలో తులసి వృక్ష సన్నిధిలోని మృత్తికతో, తులసి ఆకులను తీసికొని ‘ఓం నమో నారాయణాయ’ అనే మంత్రాన్ని పఠిస్తూ శరీరానికి పూసుకుని స్నానమాచరించాలి.',
        },
        {
          title: 'ఈ మాసంలో పసుపు, ఆవాలు, మెంతులు , మిరియాలు, చింతపండు పెరుగు మొదలైనవి క్షార గుణాన్ని హరించి ఆరోగ్యాన్ని కాపాడతాయి కాబట్టి, వీటితో తయారైన పొంగలి..పులిహోర..దద్యోజనం మొదలగు మధురపదార్ధములు విష్ణువుకు నివేదించి ప్రసాదంగా స్వీకరించిన మంచిది.',
        },
        {
          title: 'మార్గశిర మాసంలోని గురువారాల్లో శ్రీ మహాలక్ష్మీని పూజిస్తూ ‘‘మార్గశిర లక్ష్మీవార వ్రతం” చేయడం, ద్వాదశి అభిషేకంవల్ల ఆయురారోగ్యాలు వృద్ధి చెందుతాయి.',
        },
        {
          title: 'ఆధ్యాత్మికపరంగా మానసిక శక్తిని ఇచ్చే ఈమార్గమాసంలో భగవంతునియందు లయించవలెనన్న తపనగలవారు అందరూ ఈ మార్గశిర మాసములో వైష్ణవప్రధానమైన లక్ష్మీ వ్రతాన్ని ఆచరించుటకు అర్హులే.',
        },
        {
          title: 'మార్గశిర శుద్ద పాడ్యమి నుండి ఈ మాసమంతా శ్రీ మహా విష్ణువు ని పూజిస్తారు. శ్రీ మహా విష్ణువుకి ప్రీతికరమైన ఈ మాసంలో ప్రాతః కాలంలో స్నానం చేసి విష్ణువుని ఆరాధించడం లేదా  శ్రీ విష్ణుసహస్రనామం స్తోత్రం పఠనం అనంతకోటి పుణ్య ఫలితాలనందిస్తుంది. ఈ మాసంలో చేసే నదీ స్నానాన్ని మార్గశీర్ష స్నానాలు అంటారు.',
        },
        {
          title: 'మార్గశిర శుద్ద పంచమి రోజున నాగ పూజ చేయడం విశేష ఫలితాన్నిస్తుంది. శుభకార్యాలు ప్రారంభించడానికి అనుకూలమైన రోజుగా చెప్పబడింది.',
        },
        {
          title: 'మార్గశిర శుద్ద షష్ఠి ని స్కంద షష్ఠి అని వ్యవహరిస్తారు. ఈ రోజు సుబ్రహ్మణ్య స్వామి ని శక్తికొలది పూజిస్తే సంతాన అనుకూలత కలుగుతుందని ప్రతీతి.',
        },
        {
          title: 'మార్గశిర శుద్ద సప్తమి ని భానుసప్తమి, జయసప్తమి, మిత్ర సప్తమి అని అంటారు. ఈ రోజు సూర్యారాధన చేసి పాయసం నివేదన చేస్తే అనేకమైన మంచి ఫలితాలు కలుగుతాయి.',
        },
        {
          title: 'మార్గశిర అష్టమిని కాలభైరవాష్టమి గా పిలుస్తారు, శివుని మరో రూపమే భైరవుడు. భైరవుడంటే పోషకుడని, భయంకరుడనే అర్ధాలు వస్తాయి. భైరవుని దగ్గర కాలుడు (కాలం) కూడా అణిగి ఉంటాడు కనుకనే కాలభైరవుడయ్యాడు. భైరవుణ్ణి శరణు కోరితే మృత్యు భయం తొలగిపోతుంది. ఈరోజు గంగా స్నానం, పితృ తర్పణం, శ్రాద్ధ కర్మలు ఆచరిస్తే ఏడాది మొత్తం లౌకిక, పార లౌకిక బాధల నుండి విముక్తి కలుగుతుంది. అలాగే భైరవుని వాహనమైన శునకానికి పాలు, పెరుగు, వంటివి ఆహారం గా ఇవ్వడం మంచిది.',
        },
        {
          title: 'మార్గశిర ఏకాదశి ని మోక్షద ఏకాదశి గా చెప్తారు. ఈరోజు శ్రీ మహా విష్ణువు కి అత్యంత ప్రీతికరమైన రోజుగా చెప్పబడింది. విష్ణు సహస్రనామ పారాయణం సర్వ పాపాలను తొలగిస్తుంది. ఈ రోజున చేసుకొనే ఉత్తర ద్వారా దర్శనం వలన మోక్షం లభిస్తుందని చెప్తారు. మార్గశిర శుద్ద ఏకాదశి గీతా జయంతి. భగవద్గీత  పారాయణం, పార్ధసారధిని (కృష్ణుని) ఆరాధన చేయడం మంచిది.',
        },
        {
          title: 'ఈ మాసంలో వచ్చే ద్వాదశి ని అఖండ ద్వాదశి అంటారు. మార్గశిర శుద్ద త్రయోదశి నాడు హనుమత్భక్తులు హన్మద్వ్రతం ఆచరిస్తారు. సంతానం లేని దంపతులు ఆచరిస్తే సంతానం కలుగుతుంది.',
        },
        {
          title: 'మార్గశిర శుద్ద పౌర్ణమి నాడు దత్తాత్రేయ జయంతి. దత్తాత్రేయుడంటే సాక్ష్యాత్తు త్రిమూర్తి స్వరూపం. అనఘావ్రతం ఆచరించి స్వామీని పూజిస్తే సకల పాపాలు తొలగుతాయి.',
        },
        {
          title: 'కార్తీక పౌర్ణమి నుండి మార్గశిర పౌర్ణమి వరకు యమధర్మ రాజు కోరలు తెరుచుకొని ఉంటాడు, ఈ రోజుల్ని యమదంష్ట్రులుగా చెబుతారు.',
        },
        {
          title: 'మార్గశిర పౌర్ణమి తో అనేక రకమైన వ్యాదులు, అనారోగ్య సమస్యలు తొలగుతాయి, కనుక కృతజ్ఞత పూర్వకంగా ఈ దినం. యమధర్మ రాజుని ఆరాదిస్తారు. ఈ పౌర్ణమి ని కోరల పున్నమి, నరక పౌర్ణమి అని కూడా పిలుస్తారు.',
        },
        {
          title: 'మార్గశిరం..ఆధ్యాత్మిక భావ వికాసానికి ప్రతీక. కార్తీకంలో పుణ్యనదీ స్నానాలతో తరించిన భక్తుల హృదయాలు. మార్గశిర మాసంలో మరింత భగవచ్చింతనలో తన్మయమవుతాయి..!! ',
        },
        {
          title: 'నిర్మలమైన ఆకాశం మాదిరిగా మనస్సులు కూడా ఈ మాసంలో నిర్మలంగా ఉంటాయి.!!',
        },
        {
          title: 'తూర్పు తెలతెలవారుతుండగా పొగమంచు ఇంకా విచ్చిపోకముందే ముంగిట రకరకాల ముగ్గులు, వరిపిండితోనూ సున్నపుపిండితోనూ వేసి వాటి మధ్య బంతిపూలు తురిమిన గొబ్బిళ్లు పెట్టే ఆడపిల్లలు. తెలుగు పల్లెటూళ్ల ధనుర్మాస శోభకు వన్నెలు చేకూరుస్తారు.',
        }
      ],
      "title": 'కార్తీక పురాణం part-9',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>పుష్య మాసం విశిష్టత :</span>,
        },
        {
          title: 'చంద్రుడు పుష్యమి నక్షత్రంలో ఉండగా వచ్చే మాసం పుష్య మాసం. *“పుష్య”* అనే మాటకు పోషణ శక్తి కలిగినది అని అర్ధం. పుష్య మాసం శీతాకాలం.',
        },
        {
          title: 'ఆధ్యాత్మికంగా జపతపాదులు , ధ్యాన పారాయణలకు శ్రేష్ఠమైన మాసమిది. పితృదేవతలను పూజించి అందరు దోషరహితులయ్యే పుణ్య మాసం పుష్యం. పుష్య పౌర్ణమి వేదాధ్యయానికి చాలా విశిష్టమైనదిగా చెప్పబడింది. శ్రావణ పౌర్ణమి మొదలు పుష్య పౌర్ణమి వరకు వేదాలు , మంత్రాలు నేర్చుకోవడానికి అనువైన సమయం గా చెప్పబడింది.',
        },
        {
          title: 'విష్ణువుకు ఇష్టమైన మాసం ఆశ్వీయుజం. శివునకు కార్తీకం. అలాగే పుష్యమాసం శనీశ్వరుడికి పరమ ప్రీతికరం. ఎందుకంటే ఆయన జన్మనక్షత్రం పుష్యమి. ఈ నెలంతా శనైశ్చరుణ్ని పూజించే వారిపట్ల శని ప్రసన్నుడై శుభాలు కలిగిస్తాడని పురాణాలు తెలుపుతున్నాయి.',
        },
        {
          title: 'ఏలినాటి శనితో బాధపడేవారు ఈ మాసంలో రోజూ ఉదయానే శుచిగా స్నానం చేసి శనీశ్వరుణ్ణి భక్తితో ప్రార్థిస్తారు. పౌర్ణమి నాడు శనికి తైలాభిషేకం జరిపించి నవ్వులు దానమిస్తారు. ఆయనకు ఇష్టమైన నువ్వులు , బెల్లం ఆహారంలో భాగం చేసుకుంటారు. దీనివెనుక శాస్త్రీయ కోణం చుస్తే  ఈ రెండూ పదార్ధాలు మనిషి ఓంట్లో వేడిని పెంచి చలి నుంచి రక్షిస్తాయి.',
        },
        {
          title: 'శని ధర్మదర్శి న్యాయం , సత్యం , ధర్మాలను ఎత్తి చూపించేవాడు. సర్వప్రాణుల సమస్త విశ్వ ప్రేమను , పవిత్రతను ఉద్ధరిచేవాడు అతడే . మానవుడు ఈ నెలలో నువ్వులు సేవించి , నియమ నిష్ఠులు పాటించినట్లు అయితే శని అనుగ్రహం పొందవచ్చు.',
        },
        {
          title: 'అంతే గాక గరుడ పురాణంలో నాభిస్థానం శని స్థానం అని చెప్పబడింది. ఎప్పుడు శరీరంలోని నాభి ప్రదేశాన్ని శని ప్రదేశంగా చెప్పారో అప్పుడే ఈ ప్రదేశానికి ఉన్న ప్రాముఖ్యమంతటికి శని ప్రభావమే కారణం అని మనం గ్రహించాలి.',
        },
        {
          title: 'పుష్యమాసం తొలి అర్ధభాగంలో విష్ణుమూర్తిని పూజించడం అనాదిగా వస్తున్న ఆచారం. పుష్య శుక్ల విదియ నుంచి పంచమి వరకు శ్రీ హరిని తులసీదళాలతో పూజిస్తే సౌందర్యం లభిస్తుందని ఒక నమ్మకం.',
        },
        {
          title: 'అలాగే సోమవారాల్లో శివుడిని మారేడు దళాలతోనూ ఆదివారాల్లో సూర్యుణ్ణి జిల్లేడు పూలతోనూ అర్చిస్తారు. శుక్ల పక్ష షష్ఠినాడు తమిళులు కుమారస్వామిని పూజిస్తారు. మనకు మార్గశిర శుద్ధ షష్ఠి ( సుబ్రహ్మణ్య షష్ఠి ) ఎలాగో వారికి ఈ రోజు అంత పవిత్రమైనది.',
        },
        {
          title: 'ఇక శుక్ల పక్షంలో వచ్చే అష్టమిరోజు  పితృదేవతలను ఆరాధిస్తారు. ఈ మాసంలో శుద్ధ ఏకాదశిని పుత్రదా ఏకాదశి అంటారు. ఈ రోజున ఏకాదశి వ్రతం ఆచరిస్తే పుత్ర సంతానం కలుగుతుందని విశ్వాసం. పుష్యమాసంలో వస్త్రదానం విశేష ఫలితాలనిస్తుందని ప్రతీతి. చలితో బాధపడేవారిని ఆదుకోవడమే ఈ నియమం వెనుక సదుద్దేశం.',
        },
        {
          title: 'పుష్యమాసంలో వచ్చే పెద్ద పండుగ సంక్రాంతి. సంక్రాంతి ముందు జరుపుకునే పండుగ భోగి. చీకటితోనే లేచి చలి మంటలతో చీకట్లను పారద్రోలుతారు. దక్షిణాయనానికీ , ధనుర్మాసానికీ ఆఖరు రోజు ఇది. భోగినాడు వైష్ణవాలయాల్లో గోదారంగనాథుల కల్యాణాన్ని కన్నుల పండువగా జరుపుతారు. మర్నాడు సూర్యుడు మకర రాశిలోకి ప్రవేశించే దినమే మకర సంక్రాంతి.',
        },
        {
          title: 'ఆ రోజు నుండి భక్తులంతా పరమ పవిత్రంగా భావించే ఉత్తరాయణం ప్రారంభమవుతుంది. సంక్రమణం నాడు రాత్రిపూట భోజనం చేయకూడదని పురాణాలు చెబుతున్నాయి. సంక్రాంతి నాడు శివుడ్ని ఆవునేతితోనూ , నువ్వులతోనూ అభిషేకిస్తే దరిద్రం తొలగిపోయి సకల భోగభాగ్యాలూ కలుగుతాయని ప్రతీతి.',
        },
        {
          title: 'సంక్రాంతి మరుసటి రోజు కనుమ పండుగ చేస్తారు. ఈ రోజు ధాన్యరాశులనూ వ్యవసాయంలో సహకరించే పశువులనూ లక్ష్మీ స్వరూపంగా భావించి పూజిస్తారు. పుష్య బహుళ ఏకాదశిని విమలైకాదశి , సఫలైకాదశి, షట్తిలైకాదశి , కల్యాణైకాదశి అని పిలుస్తారు.',
        },
        {
          title: 'సున్నిపిండితో ఒంటిని రుద్దుకుని నువ్వులు కలిపిన నీటిలో స్నానం చేయడం , నువ్వుల్ని ఆహారంలో భాగం చేసుకోవడం , మంచినీటిలోనూ నువ్వులు కలుపుకొని తాగడం , తిలదానం చేయడం ఈ ఏకాదశి రోజు చేస్తారు.',
        },
        {
          title: 'ఈ మాసంలో ఆఖరు రోజైన అమావాస్యను చొల్లంగి అమావాస్య అంటారు. ఈ రోజు నది స్నానాదులు చేసుకుని దైవదర్శనం చేసుకుంటే శుభాలు కలుగుతాయి , పితృ తర్పణాలు , ఆబ్దికాదులు ఉంటే వారి పేరుతో అన్న దానాలు పేదవారికి చేస్తే విశేషించి పుణ్యఫలంతో పాటు పితృదేవతల అనుగ్రహం కలుగుతుంది.',
        },
        {
          title: 'పుష్యమాసములో సూర్యోదయ సమయమున ప్రసరించు సూర్య కాంతి అద్భుతమగు యోగచైతన్యమును ప్రసాదింపగలదు. పుష్యమి చాలా అద్భుతమైన నక్షత్రము. చెప్పలేనంత కాంతిని దర్శనము చేయించే మాసము పుష్యమాసము. ఉత్తరాయణ పుణ్యకాలములో  సూర్యుడు దక్షిణము నుండి ఉత్తరదిశగా పయనము సాగిస్తాడు. అనగా ఊర్ద్వముఖముగా ప్రయాణము.',
        },
        {
          title: 'మనలోని ప్రాణశక్తి బలమును కూర్చుకొను సమయము. సూర్యకిరణముల యందు ఒక ప్రత్యేకమైన హిరణ్మయమైన కాంతి ఉండును. ఇది మన బుద్ధిని ప్రచోదనము గావించును. మనస్సును అంటిపెట్టుకున్న స్వభావము నందలి అశుభములను ఆ కాంతి హరింపగలదు. బుద్ధిబలము , ప్రాణబలము పుష్టిగా లభించు మాసము పుష్యమాసము.',
        }
      ],
      "title": 'కార్తీక పురాణం part-10',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>మాఘ మాసం విశిష్టత :</span>,
        },
        {
          title: 'మాఘ మాసం ఎంతో విశిష్టమైనది. ఈ మాసంలో వచ్చే ముఖ్యమైన తిథి శుక్ల పక్ష చవితి దీనిని తిల చతుర్థి అం టారు. దీన్నే కుంద చతుర్థి అని కూడా అంటారు. నువ్వులను తింటారు. నువ్వులతో లడ్లు చేసి పంచి పెడతారు. ఈ రోజున డుంఢిరాజును ఉద్దేశించి, నక్త వ్రతము పూజ చేస్తారు! డుంఢిని ఈ విధంగా పూజించడం వలన దేవతల చేత సైతం పూజలందుకుంటారని కాశీ ఖండములో తెలియజేశారు. మాఘమాసం తెలుగు సంవత్సరంలో పదకొండవ నెల. చంద్రుడు మఖ నక్షత్రంతో కూడుకున్న మాసం కాబట్టి ఇది మాఘమాసం అయింది. ఉత్తరాయణ పుణ్యకాలంలో వచ్చే ఈ మాసం విష్ణుమూర్తికి ప్రీతిపాత్రమైనది.',
        },
        {
          title: 'కుంద చతుర్థి నాడు కుంద పుష్పాలతో పరమేశ్వరుని అర్పించి రాత్రి జాగారణ చేసినవారు, సకలైశ్వర్యాలను పొందుతారని కాలదర్శనంలో చెప్పబడింది. అయితే సాయంకాలం చతుర్థి ఉంటే ఉత్తమం అని ఈ సందర్భంలో తెలుసుకోవాలి. మాఘమాసంలో ప్రాత:కాలంలో చేసే స్నాన,జప,తపములు చాలా ఉత్తమమైనవి. ఈ మాసంలో స్నానం చేసేటప్పుడు దు:ఖ దారిద్ర్య నాశాయ, శ్రీ విష్ణోతోషణాయచ! ప్రాత:స్నానం కరోమ్య, మాఘ పాప వినాశనం! అని చేసిన తరువాత',
        },
        {
          title: 'సవిత్రేప్రసవిత్రేచ! పరంధామజలేమమ! త్వత్తేజసా పరిబ్రష్టం,పాపం యాతు సస్రదా! అని చదవాలి.',
        },
        {
          title: 'సూర్య భగవానునికి ఆర్గ్యమివ్వాలి',
        },
        {
          title: 'ఈ మాసాన్ని కుంభమాసం అని కూడా అంటారు.కొంతమంది ఈ నెల్లాళ్ళు ముల్లంగి దుంపను తినరు.',
        },
        {
          title: 'ఈ మాసంలో నవ్వులను, పంచదారను కలిపి కలిపి తినాలట. నువ్వులను దానమివ్వాలట. రాగి పాత్రలో గోధుమ రంగుగా ఉన్న నువ్వులను పాత్రతో సహా దానమిస్తే మంచిది.ఈ నెలలో మరణించిన వారికి అమృతత్వం సిద్దిస్తుందట.',
        },
        {
          title: 'మాఘశుద్ద పంచమిని శ్రీ పంచమి అంటారు. ఈ పంచమి నాడే సరస్వతీదేవి జన్మించిందట.',
        },
        {
          title: 'ఈనాడు రతీ మన్మధులను మల్లెపూలతో పూజిస్తారు.ఉత్తర భారతంలో విష్ణుమూర్తిని, సరస్వతీదేవిని కూడా పూజిస్తారు. బ్రహ్మదేవుడు సృష్టి చేయగా చరాచర ప్రపంచం శ్మశాన నిశ్శబ్ధతతో ఉందట. అవేదనతో తన కమండలంలోని నీటిని ప్రపంచంపై చిలకరించగా చెట్లపై ఆ నీటి బిందువులు పడి ఒక శక్తి ఉద్భవించిందట. రెండు చేతులతో వీణను వాయిస్తూ మరో రెండు చేతులతో పుస్తకాన్ని మాలను ధరించి సమగ్ర రూపిణిగా దర్శనమిచ్చిందట. ఆ వగీశ్వరి వీణావాదనం ద్వారా ప్రపంచంలోని స్తబ్థతను ఉదాసీనతను తొలగించి విద్యాబుద్దులకు అదిష్టాత్రి అయింది ఆ దేవి.',
        },
        {
          title: 'అప్పటి నుండి శ్రీ పంచమి రోజును సరస్వతిని పూజించడం జరుగుతుంది. ఇక ',
        },
        {
          title: 'మాఘశుద్ద సప్తమి ఇదే సూర్య సప్తమి అని కూడా పిలువబడుతుంది.ఇదే రథసప్తమి సుర్య గ్రహణదినం వలె ఇది పరమపవిత్రమైనది.ఈ రోజున అరుణోదయకాలంలో ఏడు జిల్లేడు ఆకులను అందులో రేగికాయలను ఉంచుకొని తలాపై పెట్టుకొని స్నానం చేస్తే ఏడు విధాలైన శాపాలు నశిస్తాయట_*. స్నానికి ముందు చెరకుగడతో నీటిని కదిలిస్తారు. *_నమస్కారం ప్రియ:సూర్య:_* అన్న ఆర్య వాక్య ప్రకారం కేవలం నమస్కారం చేతనే సూర్యుడు సంతృపి చెందుతాడని తెలుస్తుంది.ఈ రోజున *_చిక్కుడుకాయలతో రథం చేసి కొత్త బియ్యంతో పాయసాన్ని వండి చిక్కుడు అకులలో పెట్టి సూర్యునికి నివేదన చేయడం ఆచారం.',
        },
        {
          title: 'సూర్యుడు తనను పూజించిన సత్రాజిత్తుకి ఈ రోజునే "శమంతకమణి" ప్రసాదించాడు. హనుమంతునికి వ్యాకరణ శాస్త్రాన్ని యజవాల్క్యునికి యజుర్వేదాన్ని బోధించాడు. ఆరోగ్యం భాస్కరాదిచ్చేత్ అన్న వాక్యం ప్రకారం ఆరోగ్యం కొరకు ఆదిత్య హృదయం పారాయణ చెయ్యాలి. రథసప్తమి నాటి స్నానం *_సప్త సప్త మహాసప్త ద్వీపా వసుంధరా! కోటి జన్మార్జితంపాపిం వినశ్యతితత్‌క్షణాత్_* అన్నట్లుగా పాప విముక్తి కలిగిస్తుందట. భీష్మాష్టమి "మాఘమానస్యచాష్టమ్యాం శుక్ల పక్షేచ పార్థివ!ప్రాజాపత్యేచ నక్షత్రే మధ్య:ప్రాప్తే దివాకరే!" శోభకృత నామ సంవత్సరంలో *_మాఘమాసంలో శుక్లపక్షంలో రోహిణి నక్షత్రం ఉన్న అష్టమి తిథినాడు మధ్యాహ్నం సూర్యుడు నడినెత్తిన ప్రకాశిస్తూ ఉండగా అభిజిత్ లగ్నంలో భీష్మ పితామహుడు ధ్యాన స్థితుడై ప్రాణాలను విడిచిపెట్టాడట.',
        },
        {
          title: 'స్వచ్చంద మరణం ఆయనకి వరం. ఆయనకు తర్పణలు విడిచి పెట్టడం నెలగంటు పెట్టినప్పటినుంచీ పెట్టిన గొబ్బెమ్మలను ఎండబెట్టి దాచి ఆ పిడకలతో పాయసాన్ని వండి నివేదన చేయడం ముఖ్యం. అష్టమినాడే దైవ సాయుజ్యం పొందినా శ్రీ కృష్ణుని సమక్షంలోనే విష్ణుసహస్రనామాలతో ఆయనను కీర్తిస్తూ మోక్షం పొందాడు. కాబట్టి ఏకాదశిని ఆయన పేరుతో ఏర్పాటు చేశారు. *_భీష్మ ఏకాదశి_* నాడు విశేష పూజలు చేయడం ఆనవాయితీ. ఇక మాఘమాసంలో వచ్చే *_ప్రతి ఆదివారాలు మహిమాన్వితాలే._* ఈ విధంగా *_మాఘమాసమంతా "శివరాత్రి"వరకూ అన్నీ పర్వదినాలే.',
        }
      ],
      "title": 'కార్తీక పురాణం part-11',
    },
    {
      "CatID": [
        {
          title: <span class='highlight'>ఫాల్గునమాసం విశిష్టత :</span>,
        },
        {
          title: 'పౌర్ణమినాడు ఫల్గునీ నక్షత్రం ఉన్న చాంద్రమాన మాసం ఫాల్గునమాసం. ఫాల్గుణము అని వ్రాయకూడదు. ఫాల్గునము అన్న అక్షర క్రమమే సరైన శబ్ద స్వరూపము. ఉత్తర ఫల్గునీ నక్షత్రం నాడు పుట్టిన పాండవ మధ్యముడు ఫల్గునుడయ్యాడు. ఈ మాసం శిశిర ఋతువుకు పరాకాష్ఠ. వసంత ఋతువుకు ద్వారం వంటిది.',
        },
        {
          title: 'శ్రీమహావిష్ణువుకు అత్యంత ప్రీతికరమైన మాసం - ఫాల్గుణ మాసం. ఫాల్గుణమాసంలో మొదటి పెన్నెండు రోజులు, అంటే శుక్లపక్షపాడ్యమి మొదలు ద్వాదశి వరకూ శ్రీమహావిష్ణువు పూజకు ఉత్కృష్టమైన రోజులు. ప్రతి రోజూ తెల్లవారు ఘామునే నిద్రలేచి కాలకృత్యాలు తీర్చుకుని, శిరస్నానం చేసి సూర్యభగవానుడికి అర్ఘ్యం ఇచ్చిన అనంతరం, శ్రీమహావిష్ణువును షోడశోపచారాలు, అష్టోత్తరాలతో పూజించి, పాలను నైవేద్యంగా సమర్పించాలి.',
        },
        {
          title: 'ఈ పన్నెండురోజుల్లో ఒకరోజుగానీ లేదంటే ద్వాదశి నాడుగానీ వస్త్రాలు, వివిధదాన్యాలను పండితులకు దానముగా ఇవ్వడం మంచిది. శక్తివున్నవారు ఏదైనా వైష్ణవాలయానికి ఆవును దానమివ్వడం విశేష ఫలితాలనిస్తుంది. పూర్ణిమనాడు పరమశివుడిని, శ్రీకృష్ణపరమాత్మను, మహాలక్ష్మినీ పూజించడంతో పాటూ "లింగపురాణం" ను దానముగా ఇవ్వడం మంచిది. అట్లే ఈనాటి సాయంత్రం శ్రీకృష్ణుడిని ఉయ్యాలలో వేసి ఊపవలెను. దీనిని డోలోత్సవం అని అంటారు. దీనినే కొన్ని ప్రాంతాలలో డోలాపూర్ణిమ అని అంటారు. నరాడోలాగతం దృష్ట్యా గోవిందం పురుషోత్తమం ఫాల్గున్యాం ప్రయతోభూత్వా గోవిందస్య పురంప్రజేత్‌ ఉయ్యాలలో అర్చింపబడిన పురుషోత్తముడైన గోవిందుని ఈ రోజున దర్శించిన భక్తులకు వైకుంఠప్రాప్తి కలుగుతుందని ధర్మశాస్త్రాలు ఘోషిస్తున్నాయి.',
        },
        {
          title: 'ఈ రోజున రంగుపొడులను, రంగునీళ్ళను చల్లుకోవాలని చెప్పబడింది. ఈ రోజున ఉదయాన్నే నూనెతో తలంటిస్నానం చేసి చూత కుసుమ భక్షణం తప్పక చేయాలని శాస్త్రాలు చెబుతున్నాయి. ఈ పూజ ప్రకారం, ఇంటిని శుభ్రం చేసి, ఇంటి ప్రాంగణంలో తెల్లనిగుడ్డను ఆసనంగా తూర్పుముఖంగా కూర్చుని, ఒక ముత్తైదువుచే వందన తిలకం, నీరాజనాన్ని పొంది చందనంతో కూడిన మామిడి పువ్వులను తినాలి. చూతమగ్ర్యం వసంతస్య మాకందకుసుమం తద సచందనం పిచామ్యద్య సర్వకామ్యార్థ సిద్దయే అనే శ్లోకంతో మామిడిపూతను స్వీకరించాలి. అనంతరం రంగులను నృత్యగానాదులతో చల్లుకోవాలని చెప్పబడింది.',
        },
        {
          title: 'అట్లే, హరిహరసుతుడు అయిన అయ్యప్పస్వామి వారు జన్మించిన దినం కూడా ఈనాడే కనుక వారిని పూజించడం విశేష ఫలితాలనిస్తుంది. ఫాల్గుణమాసంలో పూర్ణిమరోజున హోళీపండుగను నిర్వహిస్తుంటారు. ఈ పూర్ణిమ శక్తితో కూడినది. ఏ సంవత్సరమైనా పూర్ణిమ, ఉత్తరఫల్గుణి కలిసి వస్తే, ఆ రోజున మహాలక్ష్మిని షోడశోపచారాలతో ఆరాధించి, లక్ష్మీ అష్టోత్తర శతనామాలు, కనకధారా స్తోత్రాలను పారాయణం చేయడం మంచిది. హోళిరోజూన లక్ష్మీదేవిని ఆరాధిస్తే సమస్త శుభములు కలుగుతాయని పెద్దలవాక్కు. కొన్ని దక్షిణాది ఆలయాలలో ఫాల్గుణపూర్ణిమను చాలా గొప్పగా చేస్తారు.',
        },
        {
          title: 'ఈ ఉత్సవం వెనుక ఒక కథ ఉంది. ఒకసారి పార్వతి తన ప్రభావం చేత శివుని కళ్ళు మూతపడేటట్లు చేసింది. శివుని కళ్ళు మూతపడినందు వల్ల జగమంతా అంధకారబంధురమైంది. శివుడు కోపగించు కోవడంతో, అలిగిన పార్వతీదేవి కాంచీపురానికి వచ్చి, తిరిగి శివుని అభిమానాన్ని పొందేందుకు ఒక మామిడి చెట్టు కింద కూర్చుని తపస్సు చేయడం ప్రారంభించింది. ఒకానొక పాల్గుణపూర్ణిమనాడు మామిడి చెట్టు కింద పార్వతీదేవి ప్రాయశ్చిత్త కర్మకాండను పూర్తిచేసింది.',
        },
        {
          title: 'అప్పుడు సంతసించిన శివుడు పార్వతిని అనుగ్రహించాడు. అప్పటినుంచి కాంచీపురంలో ఫాల్గుణ పూర్ణిమ ఉత్సవం జరుగుతుంది. ఈ ఉత్సవాన్ని చూసేందుకు దేశం నలుమూలల నుంచి భక్తులు వస్తుంటారు. ఫాల్గుణ మాసములో ఈ విధమైన పూజలను, దానాలను చేయడం వల్ల అనంతమైన పుణ్యఫలాలు లభిస్తాయని శాస్త్రవచనం.',
        }
      ],
      "title": 'కార్తీక పురాణం part-12',
    }
  ]
}
export default ItaramuluData;